import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  bpchar: { input: string; output: string; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: string; output: string; }
  timetz: { input: any; output: any; }
  uuid: { input: string; output: string; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ad.campaign_metrics" */
export type Ad_Campaign_Metrics = {
  __typename?: 'ad_campaign_metrics';
  /** An object relationship */
  campaign?: Maybe<Campaign>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  clicks: Scalars['Int']['output'];
  conversions?: Maybe<Scalars['Int']['output']>;
  cpc?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  impressions: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  platform: Ad_Platform_Enum;
  /** ID given to the campaign by its respective ad platform */
  platform_specific_id: Scalars['String']['output'];
  reach?: Maybe<Scalars['Int']['output']>;
  spend: Scalars['float8']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Aggregate = {
  __typename?: 'ad_campaign_metrics_aggregate';
  aggregate?: Maybe<Ad_Campaign_Metrics_Aggregate_Fields>;
  nodes: Array<Ad_Campaign_Metrics>;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp_Var_Samp>;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Avg = {
  arguments: Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Corr = {
  arguments: Ad_Campaign_Metrics_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ad_Campaign_Metrics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Ad_Campaign_Metrics_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Max = {
  arguments: Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Min = {
  arguments: Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Sum = {
  arguments: Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Campaign_Metrics_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Aggregate_Fields = {
  __typename?: 'ad_campaign_metrics_aggregate_fields';
  avg?: Maybe<Ad_Campaign_Metrics_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Campaign_Metrics_Max_Fields>;
  min?: Maybe<Ad_Campaign_Metrics_Min_Fields>;
  stddev?: Maybe<Ad_Campaign_Metrics_Stddev_Fields>;
  stddev_pop?: Maybe<Ad_Campaign_Metrics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ad_Campaign_Metrics_Stddev_Samp_Fields>;
  sum?: Maybe<Ad_Campaign_Metrics_Sum_Fields>;
  var_pop?: Maybe<Ad_Campaign_Metrics_Var_Pop_Fields>;
  var_samp?: Maybe<Ad_Campaign_Metrics_Var_Samp_Fields>;
  variance?: Maybe<Ad_Campaign_Metrics_Variance_Fields>;
};


/** aggregate fields of "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Campaign_Metrics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Aggregate_Order_By = {
  avg?: InputMaybe<Ad_Campaign_Metrics_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ad_Campaign_Metrics_Max_Order_By>;
  min?: InputMaybe<Ad_Campaign_Metrics_Min_Order_By>;
  stddev?: InputMaybe<Ad_Campaign_Metrics_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ad_Campaign_Metrics_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ad_Campaign_Metrics_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ad_Campaign_Metrics_Sum_Order_By>;
  var_pop?: InputMaybe<Ad_Campaign_Metrics_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ad_Campaign_Metrics_Var_Samp_Order_By>;
  variance?: InputMaybe<Ad_Campaign_Metrics_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Arr_Rel_Insert_Input = {
  data: Array<Ad_Campaign_Metrics_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Campaign_Metrics_On_Conflict>;
};

/** aggregate avg on columns */
export type Ad_Campaign_Metrics_Avg_Fields = {
  __typename?: 'ad_campaign_metrics_avg_fields';
  clicks?: Maybe<Scalars['Float']['output']>;
  conversions?: Maybe<Scalars['Float']['output']>;
  impressions?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Avg_Order_By = {
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ad.campaign_metrics". All fields are combined with a logical 'AND'. */
export type Ad_Campaign_Metrics_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Campaign_Metrics_Bool_Exp>>;
  _not?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Campaign_Metrics_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  clicks?: InputMaybe<Int_Comparison_Exp>;
  conversions?: InputMaybe<Int_Comparison_Exp>;
  cpc?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  impressions?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<Ad_Platform_Enum_Comparison_Exp>;
  platform_specific_id?: InputMaybe<String_Comparison_Exp>;
  reach?: InputMaybe<Int_Comparison_Exp>;
  spend?: InputMaybe<Float8_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Constraint {
  /** unique or primary key constraint on columns "platform", "platform_specific_id" */
  CampaignMetricsPlatformSpecificIdPlatformKey = 'campaign_metrics_platform_specific_id_platform_key',
  /** unique or primary key constraint on columns "id" */
  FacebookCampaignPkey = 'facebook_campaign_pkey'
}

/** input type for incrementing numeric columns in table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Inc_Input = {
  clicks?: InputMaybe<Scalars['Int']['input']>;
  conversions?: InputMaybe<Scalars['Int']['input']>;
  impressions?: InputMaybe<Scalars['Int']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  spend?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  clicks?: InputMaybe<Scalars['Int']['input']>;
  conversions?: InputMaybe<Scalars['Int']['input']>;
  cpc?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impressions?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Ad_Platform_Enum>;
  /** ID given to the campaign by its respective ad platform */
  platform_specific_id?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  spend?: InputMaybe<Scalars['float8']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Ad_Campaign_Metrics_Max_Fields = {
  __typename?: 'ad_campaign_metrics_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  conversions?: Maybe<Scalars['Int']['output']>;
  cpc?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** ID given to the campaign by its respective ad platform */
  platform_specific_id?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  spend?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  cpc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** ID given to the campaign by its respective ad platform */
  platform_specific_id?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ad_Campaign_Metrics_Min_Fields = {
  __typename?: 'ad_campaign_metrics_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  conversions?: Maybe<Scalars['Int']['output']>;
  cpc?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** ID given to the campaign by its respective ad platform */
  platform_specific_id?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  spend?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  cpc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** ID given to the campaign by its respective ad platform */
  platform_specific_id?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Mutation_Response = {
  __typename?: 'ad_campaign_metrics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Campaign_Metrics>;
};

/** on_conflict condition type for table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_On_Conflict = {
  constraint: Ad_Campaign_Metrics_Constraint;
  update_columns?: Array<Ad_Campaign_Metrics_Update_Column>;
  where?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
};

/** Ordering options when selecting data from "ad.campaign_metrics". */
export type Ad_Campaign_Metrics_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  cpc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  platform_specific_id?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad.campaign_metrics */
export type Ad_Campaign_Metrics_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Conversions = 'conversions',
  /** column name */
  Cpc = 'cpc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Impressions = 'impressions',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  PlatformSpecificId = 'platform_specific_id',
  /** column name */
  Reach = 'reach',
  /** column name */
  Spend = 'spend',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "ad_campaign_metrics_aggregate_bool_exp_avg_arguments_columns" columns of table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Spend = 'spend'
}

/** select "ad_campaign_metrics_aggregate_bool_exp_corr_arguments_columns" columns of table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Spend = 'spend'
}

/** select "ad_campaign_metrics_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Spend = 'spend'
}

/** select "ad_campaign_metrics_aggregate_bool_exp_max_arguments_columns" columns of table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Spend = 'spend'
}

/** select "ad_campaign_metrics_aggregate_bool_exp_min_arguments_columns" columns of table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Spend = 'spend'
}

/** select "ad_campaign_metrics_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Spend = 'spend'
}

/** select "ad_campaign_metrics_aggregate_bool_exp_sum_arguments_columns" columns of table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Spend = 'spend'
}

/** select "ad_campaign_metrics_aggregate_bool_exp_var_samp_arguments_columns" columns of table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Select_Column_Ad_Campaign_Metrics_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Spend = 'spend'
}

/** input type for updating data in table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  clicks?: InputMaybe<Scalars['Int']['input']>;
  conversions?: InputMaybe<Scalars['Int']['input']>;
  cpc?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impressions?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Ad_Platform_Enum>;
  /** ID given to the campaign by its respective ad platform */
  platform_specific_id?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  spend?: InputMaybe<Scalars['float8']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Ad_Campaign_Metrics_Stddev_Fields = {
  __typename?: 'ad_campaign_metrics_stddev_fields';
  clicks?: Maybe<Scalars['Float']['output']>;
  conversions?: Maybe<Scalars['Float']['output']>;
  impressions?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Stddev_Order_By = {
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ad_Campaign_Metrics_Stddev_Pop_Fields = {
  __typename?: 'ad_campaign_metrics_stddev_pop_fields';
  clicks?: Maybe<Scalars['Float']['output']>;
  conversions?: Maybe<Scalars['Float']['output']>;
  impressions?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Stddev_Pop_Order_By = {
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ad_Campaign_Metrics_Stddev_Samp_Fields = {
  __typename?: 'ad_campaign_metrics_stddev_samp_fields';
  clicks?: Maybe<Scalars['Float']['output']>;
  conversions?: Maybe<Scalars['Float']['output']>;
  impressions?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Stddev_Samp_Order_By = {
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ad_campaign_metrics" */
export type Ad_Campaign_Metrics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Campaign_Metrics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Campaign_Metrics_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  clicks?: InputMaybe<Scalars['Int']['input']>;
  conversions?: InputMaybe<Scalars['Int']['input']>;
  cpc?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impressions?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Ad_Platform_Enum>;
  /** ID given to the campaign by its respective ad platform */
  platform_specific_id?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  spend?: InputMaybe<Scalars['float8']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Ad_Campaign_Metrics_Sum_Fields = {
  __typename?: 'ad_campaign_metrics_sum_fields';
  clicks?: Maybe<Scalars['Int']['output']>;
  conversions?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  spend?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Sum_Order_By = {
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
};

/** update columns of table "ad.campaign_metrics" */
export enum Ad_Campaign_Metrics_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Conversions = 'conversions',
  /** column name */
  Cpc = 'cpc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Impressions = 'impressions',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  PlatformSpecificId = 'platform_specific_id',
  /** column name */
  Reach = 'reach',
  /** column name */
  Spend = 'spend',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ad_Campaign_Metrics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ad_Campaign_Metrics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Campaign_Metrics_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Campaign_Metrics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ad_Campaign_Metrics_Var_Pop_Fields = {
  __typename?: 'ad_campaign_metrics_var_pop_fields';
  clicks?: Maybe<Scalars['Float']['output']>;
  conversions?: Maybe<Scalars['Float']['output']>;
  impressions?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Var_Pop_Order_By = {
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ad_Campaign_Metrics_Var_Samp_Fields = {
  __typename?: 'ad_campaign_metrics_var_samp_fields';
  clicks?: Maybe<Scalars['Float']['output']>;
  conversions?: Maybe<Scalars['Float']['output']>;
  impressions?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Var_Samp_Order_By = {
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ad_Campaign_Metrics_Variance_Fields = {
  __typename?: 'ad_campaign_metrics_variance_fields';
  clicks?: Maybe<Scalars['Float']['output']>;
  conversions?: Maybe<Scalars['Float']['output']>;
  impressions?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ad.campaign_metrics" */
export type Ad_Campaign_Metrics_Variance_Order_By = {
  clicks?: InputMaybe<Order_By>;
  conversions?: InputMaybe<Order_By>;
  impressions?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
};

/** columns and relationships of "ad.comment" */
export type Ad_Comment = {
  __typename?: 'ad_comment';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creative_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  setting_reference?: Maybe<Ad_Setting_Enum>;
  text: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "ad.comment" */
export type Ad_Comment_Aggregate = {
  __typename?: 'ad_comment_aggregate';
  aggregate?: Maybe<Ad_Comment_Aggregate_Fields>;
  nodes: Array<Ad_Comment>;
};

export type Ad_Comment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ad_Comment_Aggregate_Bool_Exp_Count>;
};

export type Ad_Comment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ad_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Comment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ad.comment" */
export type Ad_Comment_Aggregate_Fields = {
  __typename?: 'ad_comment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Comment_Max_Fields>;
  min?: Maybe<Ad_Comment_Min_Fields>;
};


/** aggregate fields of "ad.comment" */
export type Ad_Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ad.comment" */
export type Ad_Comment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ad_Comment_Max_Order_By>;
  min?: InputMaybe<Ad_Comment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ad.comment" */
export type Ad_Comment_Arr_Rel_Insert_Input = {
  data: Array<Ad_Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Comment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ad.comment". All fields are combined with a logical 'AND'. */
export type Ad_Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Comment_Bool_Exp>>;
  _not?: InputMaybe<Ad_Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Comment_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creative_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  setting_reference?: InputMaybe<Ad_Setting_Enum_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad.comment" */
export enum Ad_Comment_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommentPkey = 'comment_pkey'
}

/** input type for inserting data into table "ad.comment" */
export type Ad_Comment_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  setting_reference?: InputMaybe<Ad_Setting_Enum>;
  text?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ad_Comment_Max_Fields = {
  __typename?: 'ad_comment_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creative_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "ad.comment" */
export type Ad_Comment_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creative_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ad_Comment_Min_Fields = {
  __typename?: 'ad_comment_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creative_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "ad.comment" */
export type Ad_Comment_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creative_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ad.comment" */
export type Ad_Comment_Mutation_Response = {
  __typename?: 'ad_comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Comment>;
};

/** on_conflict condition type for table "ad.comment" */
export type Ad_Comment_On_Conflict = {
  constraint: Ad_Comment_Constraint;
  update_columns?: Array<Ad_Comment_Update_Column>;
  where?: InputMaybe<Ad_Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "ad.comment". */
export type Ad_Comment_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creative_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  setting_reference?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad.comment */
export type Ad_Comment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ad.comment" */
export enum Ad_Comment_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreativeId = 'creative_id',
  /** column name */
  Id = 'id',
  /** column name */
  SettingReference = 'setting_reference',
  /** column name */
  Text = 'text',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "ad.comment" */
export type Ad_Comment_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  setting_reference?: InputMaybe<Ad_Setting_Enum>;
  text?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ad_comment" */
export type Ad_Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Comment_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  setting_reference?: InputMaybe<Ad_Setting_Enum>;
  text?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ad.comment" */
export enum Ad_Comment_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreativeId = 'creative_id',
  /** column name */
  Id = 'id',
  /** column name */
  SettingReference = 'setting_reference',
  /** column name */
  Text = 'text',
  /** column name */
  UserId = 'user_id'
}

export type Ad_Comment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Comment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Comment_Bool_Exp;
};

/** columns and relationships of "ad.creative" */
export type Ad_Creative = {
  __typename?: 'ad_creative';
  /** An object relationship */
  ad?: Maybe<Campaign_Ad>;
  ad_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  background_upload?: Maybe<File_Upload>;
  background_upload_id?: Maybe<Scalars['uuid']['output']>;
  benefits: Scalars['String']['output'];
  call_to_action?: Maybe<Scalars['String']['output']>;
  call_to_action_background_color_hex?: Maybe<Scalars['String']['output']>;
  call_to_action_text_color_hex?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  comments: Array<Ad_Comment>;
  /** An aggregate relationship */
  comments_aggregate: Ad_Comment_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creative_upload: File_Upload;
  creative_upload_id: Scalars['uuid']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  feedback: Array<Ad_Creative_Feedback>;
  /** An aggregate relationship */
  feedback_aggregate: Ad_Creative_Feedback_Aggregate;
  funnel_url?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  headline_background_color_hex?: Maybe<Scalars['String']['output']>;
  headline_text_color_hex?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  logo_upload?: Maybe<File_Upload>;
  logo_upload_id?: Maybe<Scalars['uuid']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "ad.creative" */
export type Ad_CreativeCommentsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Comment_Order_By>>;
  where?: InputMaybe<Ad_Comment_Bool_Exp>;
};


/** columns and relationships of "ad.creative" */
export type Ad_CreativeComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Comment_Order_By>>;
  where?: InputMaybe<Ad_Comment_Bool_Exp>;
};


/** columns and relationships of "ad.creative" */
export type Ad_CreativeFeedbackArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Feedback_Order_By>>;
  where?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
};


/** columns and relationships of "ad.creative" */
export type Ad_CreativeFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Feedback_Order_By>>;
  where?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
};

/** aggregated selection of "ad.creative" */
export type Ad_Creative_Aggregate = {
  __typename?: 'ad_creative_aggregate';
  aggregate?: Maybe<Ad_Creative_Aggregate_Fields>;
  nodes: Array<Ad_Creative>;
};

export type Ad_Creative_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ad_Creative_Aggregate_Bool_Exp_Count>;
};

export type Ad_Creative_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ad_Creative_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Creative_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ad.creative" */
export type Ad_Creative_Aggregate_Fields = {
  __typename?: 'ad_creative_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Creative_Max_Fields>;
  min?: Maybe<Ad_Creative_Min_Fields>;
};


/** aggregate fields of "ad.creative" */
export type Ad_Creative_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Creative_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ad.creative" */
export type Ad_Creative_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ad_Creative_Max_Order_By>;
  min?: InputMaybe<Ad_Creative_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ad.creative" */
export type Ad_Creative_Arr_Rel_Insert_Input = {
  data: Array<Ad_Creative_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Creative_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ad.creative". All fields are combined with a logical 'AND'. */
export type Ad_Creative_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Creative_Bool_Exp>>;
  _not?: InputMaybe<Ad_Creative_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Creative_Bool_Exp>>;
  ad?: InputMaybe<Campaign_Ad_Bool_Exp>;
  ad_id?: InputMaybe<Uuid_Comparison_Exp>;
  background_upload?: InputMaybe<File_Upload_Bool_Exp>;
  background_upload_id?: InputMaybe<Uuid_Comparison_Exp>;
  benefits?: InputMaybe<String_Comparison_Exp>;
  call_to_action?: InputMaybe<String_Comparison_Exp>;
  call_to_action_background_color_hex?: InputMaybe<String_Comparison_Exp>;
  call_to_action_text_color_hex?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Ad_Comment_Bool_Exp>;
  comments_aggregate?: InputMaybe<Ad_Comment_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creative_upload?: InputMaybe<File_Upload_Bool_Exp>;
  creative_upload_id?: InputMaybe<Uuid_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  feedback?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
  feedback_aggregate?: InputMaybe<Ad_Creative_Feedback_Aggregate_Bool_Exp>;
  funnel_url?: InputMaybe<String_Comparison_Exp>;
  headline?: InputMaybe<String_Comparison_Exp>;
  headline_background_color_hex?: InputMaybe<String_Comparison_Exp>;
  headline_text_color_hex?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logo_upload?: InputMaybe<File_Upload_Bool_Exp>;
  logo_upload_id?: InputMaybe<Uuid_Comparison_Exp>;
  mime_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad.creative" */
export enum Ad_Creative_Constraint {
  /** unique or primary key constraint on columns "external_id" */
  CreativeExternalIdKey = 'creative_external_id_key',
  /** unique or primary key constraint on columns "id" */
  CreativePkey = 'creative_pkey'
}

/** columns and relationships of "ad.creative_feedback" */
export type Ad_Creative_Feedback = {
  __typename?: 'ad_creative_feedback';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creative: Ad_Creative;
  creative_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  text: Scalars['String']['output'];
};

/** aggregated selection of "ad.creative_feedback" */
export type Ad_Creative_Feedback_Aggregate = {
  __typename?: 'ad_creative_feedback_aggregate';
  aggregate?: Maybe<Ad_Creative_Feedback_Aggregate_Fields>;
  nodes: Array<Ad_Creative_Feedback>;
};

export type Ad_Creative_Feedback_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ad_Creative_Feedback_Aggregate_Bool_Exp_Count>;
};

export type Ad_Creative_Feedback_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ad_Creative_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ad.creative_feedback" */
export type Ad_Creative_Feedback_Aggregate_Fields = {
  __typename?: 'ad_creative_feedback_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Creative_Feedback_Max_Fields>;
  min?: Maybe<Ad_Creative_Feedback_Min_Fields>;
};


/** aggregate fields of "ad.creative_feedback" */
export type Ad_Creative_Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Creative_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ad.creative_feedback" */
export type Ad_Creative_Feedback_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ad_Creative_Feedback_Max_Order_By>;
  min?: InputMaybe<Ad_Creative_Feedback_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ad.creative_feedback" */
export type Ad_Creative_Feedback_Arr_Rel_Insert_Input = {
  data: Array<Ad_Creative_Feedback_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Creative_Feedback_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ad.creative_feedback". All fields are combined with a logical 'AND'. */
export type Ad_Creative_Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Creative_Feedback_Bool_Exp>>;
  _not?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Creative_Feedback_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creative?: InputMaybe<Ad_Creative_Bool_Exp>;
  creative_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad.creative_feedback" */
export enum Ad_Creative_Feedback_Constraint {
  /** unique or primary key constraint on columns "id" */
  CreativeFeedbackPkey = 'creative_feedback_pkey'
}

/** input type for inserting data into table "ad.creative_feedback" */
export type Ad_Creative_Feedback_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative?: InputMaybe<Ad_Creative_Obj_Rel_Insert_Input>;
  creative_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ad_Creative_Feedback_Max_Fields = {
  __typename?: 'ad_creative_feedback_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creative_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "ad.creative_feedback" */
export type Ad_Creative_Feedback_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creative_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ad_Creative_Feedback_Min_Fields = {
  __typename?: 'ad_creative_feedback_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creative_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "ad.creative_feedback" */
export type Ad_Creative_Feedback_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creative_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ad.creative_feedback" */
export type Ad_Creative_Feedback_Mutation_Response = {
  __typename?: 'ad_creative_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Creative_Feedback>;
};

/** on_conflict condition type for table "ad.creative_feedback" */
export type Ad_Creative_Feedback_On_Conflict = {
  constraint: Ad_Creative_Feedback_Constraint;
  update_columns?: Array<Ad_Creative_Feedback_Update_Column>;
  where?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "ad.creative_feedback". */
export type Ad_Creative_Feedback_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creative?: InputMaybe<Ad_Creative_Order_By>;
  creative_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad.creative_feedback */
export type Ad_Creative_Feedback_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ad.creative_feedback" */
export enum Ad_Creative_Feedback_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreativeId = 'creative_id',
  /** column name */
  Id = 'id',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "ad.creative_feedback" */
export type Ad_Creative_Feedback_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ad_creative_feedback" */
export type Ad_Creative_Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Creative_Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Creative_Feedback_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ad.creative_feedback" */
export enum Ad_Creative_Feedback_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreativeId = 'creative_id',
  /** column name */
  Id = 'id',
  /** column name */
  Text = 'text'
}

export type Ad_Creative_Feedback_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Creative_Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Creative_Feedback_Bool_Exp;
};

/** input type for inserting data into table "ad.creative" */
export type Ad_Creative_Insert_Input = {
  ad?: InputMaybe<Campaign_Ad_Obj_Rel_Insert_Input>;
  ad_id?: InputMaybe<Scalars['uuid']['input']>;
  background_upload?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  background_upload_id?: InputMaybe<Scalars['uuid']['input']>;
  benefits?: InputMaybe<Scalars['String']['input']>;
  call_to_action?: InputMaybe<Scalars['String']['input']>;
  call_to_action_background_color_hex?: InputMaybe<Scalars['String']['input']>;
  call_to_action_text_color_hex?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Ad_Comment_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative_upload?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  creative_upload_id?: InputMaybe<Scalars['uuid']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Ad_Creative_Feedback_Arr_Rel_Insert_Input>;
  funnel_url?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_background_color_hex?: InputMaybe<Scalars['String']['input']>;
  headline_text_color_hex?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logo_upload?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  logo_upload_id?: InputMaybe<Scalars['uuid']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ad_Creative_Max_Fields = {
  __typename?: 'ad_creative_max_fields';
  ad_id?: Maybe<Scalars['uuid']['output']>;
  background_upload_id?: Maybe<Scalars['uuid']['output']>;
  benefits?: Maybe<Scalars['String']['output']>;
  call_to_action?: Maybe<Scalars['String']['output']>;
  call_to_action_background_color_hex?: Maybe<Scalars['String']['output']>;
  call_to_action_text_color_hex?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creative_upload_id?: Maybe<Scalars['uuid']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  funnel_url?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  headline_background_color_hex?: Maybe<Scalars['String']['output']>;
  headline_text_color_hex?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logo_upload_id?: Maybe<Scalars['uuid']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "ad.creative" */
export type Ad_Creative_Max_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  background_upload_id?: InputMaybe<Order_By>;
  benefits?: InputMaybe<Order_By>;
  call_to_action?: InputMaybe<Order_By>;
  call_to_action_background_color_hex?: InputMaybe<Order_By>;
  call_to_action_text_color_hex?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creative_upload_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  funnel_url?: InputMaybe<Order_By>;
  headline?: InputMaybe<Order_By>;
  headline_background_color_hex?: InputMaybe<Order_By>;
  headline_text_color_hex?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_upload_id?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ad_Creative_Min_Fields = {
  __typename?: 'ad_creative_min_fields';
  ad_id?: Maybe<Scalars['uuid']['output']>;
  background_upload_id?: Maybe<Scalars['uuid']['output']>;
  benefits?: Maybe<Scalars['String']['output']>;
  call_to_action?: Maybe<Scalars['String']['output']>;
  call_to_action_background_color_hex?: Maybe<Scalars['String']['output']>;
  call_to_action_text_color_hex?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creative_upload_id?: Maybe<Scalars['uuid']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  funnel_url?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  headline_background_color_hex?: Maybe<Scalars['String']['output']>;
  headline_text_color_hex?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logo_upload_id?: Maybe<Scalars['uuid']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "ad.creative" */
export type Ad_Creative_Min_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  background_upload_id?: InputMaybe<Order_By>;
  benefits?: InputMaybe<Order_By>;
  call_to_action?: InputMaybe<Order_By>;
  call_to_action_background_color_hex?: InputMaybe<Order_By>;
  call_to_action_text_color_hex?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creative_upload_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  funnel_url?: InputMaybe<Order_By>;
  headline?: InputMaybe<Order_By>;
  headline_background_color_hex?: InputMaybe<Order_By>;
  headline_text_color_hex?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_upload_id?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ad.creative" */
export type Ad_Creative_Mutation_Response = {
  __typename?: 'ad_creative_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Creative>;
};

/** input type for inserting object relation for remote table "ad.creative" */
export type Ad_Creative_Obj_Rel_Insert_Input = {
  data: Ad_Creative_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Creative_On_Conflict>;
};

/** on_conflict condition type for table "ad.creative" */
export type Ad_Creative_On_Conflict = {
  constraint: Ad_Creative_Constraint;
  update_columns?: Array<Ad_Creative_Update_Column>;
  where?: InputMaybe<Ad_Creative_Bool_Exp>;
};

/** Ordering options when selecting data from "ad.creative". */
export type Ad_Creative_Order_By = {
  ad?: InputMaybe<Campaign_Ad_Order_By>;
  ad_id?: InputMaybe<Order_By>;
  background_upload?: InputMaybe<File_Upload_Order_By>;
  background_upload_id?: InputMaybe<Order_By>;
  benefits?: InputMaybe<Order_By>;
  call_to_action?: InputMaybe<Order_By>;
  call_to_action_background_color_hex?: InputMaybe<Order_By>;
  call_to_action_text_color_hex?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Ad_Comment_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  creative_upload?: InputMaybe<File_Upload_Order_By>;
  creative_upload_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  feedback_aggregate?: InputMaybe<Ad_Creative_Feedback_Aggregate_Order_By>;
  funnel_url?: InputMaybe<Order_By>;
  headline?: InputMaybe<Order_By>;
  headline_background_color_hex?: InputMaybe<Order_By>;
  headline_text_color_hex?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_upload?: InputMaybe<File_Upload_Order_By>;
  logo_upload_id?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad.creative */
export type Ad_Creative_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ad.creative" */
export enum Ad_Creative_Select_Column {
  /** column name */
  AdId = 'ad_id',
  /** column name */
  BackgroundUploadId = 'background_upload_id',
  /** column name */
  Benefits = 'benefits',
  /** column name */
  CallToAction = 'call_to_action',
  /** column name */
  CallToActionBackgroundColorHex = 'call_to_action_background_color_hex',
  /** column name */
  CallToActionTextColorHex = 'call_to_action_text_color_hex',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreativeUploadId = 'creative_upload_id',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FunnelUrl = 'funnel_url',
  /** column name */
  Headline = 'headline',
  /** column name */
  HeadlineBackgroundColorHex = 'headline_background_color_hex',
  /** column name */
  HeadlineTextColorHex = 'headline_text_color_hex',
  /** column name */
  Id = 'id',
  /** column name */
  LogoUploadId = 'logo_upload_id',
  /** column name */
  MimeType = 'mime_type'
}

/** input type for updating data in table "ad.creative" */
export type Ad_Creative_Set_Input = {
  ad_id?: InputMaybe<Scalars['uuid']['input']>;
  background_upload_id?: InputMaybe<Scalars['uuid']['input']>;
  benefits?: InputMaybe<Scalars['String']['input']>;
  call_to_action?: InputMaybe<Scalars['String']['input']>;
  call_to_action_background_color_hex?: InputMaybe<Scalars['String']['input']>;
  call_to_action_text_color_hex?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative_upload_id?: InputMaybe<Scalars['uuid']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  funnel_url?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_background_color_hex?: InputMaybe<Scalars['String']['input']>;
  headline_text_color_hex?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logo_upload_id?: InputMaybe<Scalars['uuid']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ad_creative" */
export type Ad_Creative_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Creative_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Creative_Stream_Cursor_Value_Input = {
  ad_id?: InputMaybe<Scalars['uuid']['input']>;
  background_upload_id?: InputMaybe<Scalars['uuid']['input']>;
  benefits?: InputMaybe<Scalars['String']['input']>;
  call_to_action?: InputMaybe<Scalars['String']['input']>;
  call_to_action_background_color_hex?: InputMaybe<Scalars['String']['input']>;
  call_to_action_text_color_hex?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative_upload_id?: InputMaybe<Scalars['uuid']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  funnel_url?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_background_color_hex?: InputMaybe<Scalars['String']['input']>;
  headline_text_color_hex?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logo_upload_id?: InputMaybe<Scalars['uuid']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ad.creative" */
export enum Ad_Creative_Update_Column {
  /** column name */
  AdId = 'ad_id',
  /** column name */
  BackgroundUploadId = 'background_upload_id',
  /** column name */
  Benefits = 'benefits',
  /** column name */
  CallToAction = 'call_to_action',
  /** column name */
  CallToActionBackgroundColorHex = 'call_to_action_background_color_hex',
  /** column name */
  CallToActionTextColorHex = 'call_to_action_text_color_hex',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreativeUploadId = 'creative_upload_id',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FunnelUrl = 'funnel_url',
  /** column name */
  Headline = 'headline',
  /** column name */
  HeadlineBackgroundColorHex = 'headline_background_color_hex',
  /** column name */
  HeadlineTextColorHex = 'headline_text_color_hex',
  /** column name */
  Id = 'id',
  /** column name */
  LogoUploadId = 'logo_upload_id',
  /** column name */
  MimeType = 'mime_type'
}

export type Ad_Creative_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Creative_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Creative_Bool_Exp;
};

/** columns and relationships of "ad.platform" */
export type Ad_Platform = {
  __typename?: 'ad_platform';
  /** An array relationship */
  campaign_metrics: Array<Ad_Campaign_Metrics>;
  /** An aggregate relationship */
  campaign_metrics_aggregate: Ad_Campaign_Metrics_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "ad.platform" */
export type Ad_PlatformCampaign_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Metrics_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
};


/** columns and relationships of "ad.platform" */
export type Ad_PlatformCampaign_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Metrics_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
};

/** aggregated selection of "ad.platform" */
export type Ad_Platform_Aggregate = {
  __typename?: 'ad_platform_aggregate';
  aggregate?: Maybe<Ad_Platform_Aggregate_Fields>;
  nodes: Array<Ad_Platform>;
};

/** aggregate fields of "ad.platform" */
export type Ad_Platform_Aggregate_Fields = {
  __typename?: 'ad_platform_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Platform_Max_Fields>;
  min?: Maybe<Ad_Platform_Min_Fields>;
};


/** aggregate fields of "ad.platform" */
export type Ad_Platform_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Platform_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ad.platform". All fields are combined with a logical 'AND'. */
export type Ad_Platform_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Platform_Bool_Exp>>;
  _not?: InputMaybe<Ad_Platform_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Platform_Bool_Exp>>;
  campaign_metrics?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  campaign_metrics_aggregate?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad.platform" */
export enum Ad_Platform_Constraint {
  /** unique or primary key constraint on columns "value" */
  PlatformPkey = 'platform_pkey'
}

export enum Ad_Platform_Enum {
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  GoogleCollection = 'GOOGLE_COLLECTION',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Meta = 'META',
  Pinterest = 'PINTEREST',
  Reddit = 'REDDIT',
  Snapchat = 'SNAPCHAT',
  Spotify = 'SPOTIFY',
  Tiktok = 'TIKTOK',
  Youtube = 'YOUTUBE'
}

/** Boolean expression to compare columns of type "ad_platform_enum". All fields are combined with logical 'AND'. */
export type Ad_Platform_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ad_Platform_Enum>;
  _in?: InputMaybe<Array<Ad_Platform_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ad_Platform_Enum>;
  _nin?: InputMaybe<Array<Ad_Platform_Enum>>;
};

/** input type for inserting data into table "ad.platform" */
export type Ad_Platform_Insert_Input = {
  campaign_metrics?: InputMaybe<Ad_Campaign_Metrics_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ad_Platform_Max_Fields = {
  __typename?: 'ad_platform_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Ad_Platform_Min_Fields = {
  __typename?: 'ad_platform_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "ad.platform" */
export type Ad_Platform_Mutation_Response = {
  __typename?: 'ad_platform_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Platform>;
};

/** on_conflict condition type for table "ad.platform" */
export type Ad_Platform_On_Conflict = {
  constraint: Ad_Platform_Constraint;
  update_columns?: Array<Ad_Platform_Update_Column>;
  where?: InputMaybe<Ad_Platform_Bool_Exp>;
};

/** Ordering options when selecting data from "ad.platform". */
export type Ad_Platform_Order_By = {
  campaign_metrics_aggregate?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad.platform */
export type Ad_Platform_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "ad.platform" */
export enum Ad_Platform_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ad.platform" */
export type Ad_Platform_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ad_platform" */
export type Ad_Platform_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Platform_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Platform_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ad.platform" */
export enum Ad_Platform_Update_Column {
  /** column name */
  Value = 'value'
}

export type Ad_Platform_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Platform_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Platform_Bool_Exp;
};

/** columns and relationships of "ad.providers" */
export type Ad_Providers = {
  __typename?: 'ad_providers';
  access_token?: Maybe<Scalars['String']['output']>;
  account_id: Scalars['String']['output'];
  account_secret?: Maybe<Scalars['String']['output']>;
  api_key?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  last_error_at?: Maybe<Scalars['timestamptz']['output']>;
  last_sync_at?: Maybe<Scalars['timestamptz']['output']>;
  name: Scalars['String']['output'];
  platform: Ad_Platform_Enum;
  refresh_token?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "ad.providers" */
export type Ad_Providers_Aggregate = {
  __typename?: 'ad_providers_aggregate';
  aggregate?: Maybe<Ad_Providers_Aggregate_Fields>;
  nodes: Array<Ad_Providers>;
};

/** aggregate fields of "ad.providers" */
export type Ad_Providers_Aggregate_Fields = {
  __typename?: 'ad_providers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Providers_Max_Fields>;
  min?: Maybe<Ad_Providers_Min_Fields>;
};


/** aggregate fields of "ad.providers" */
export type Ad_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ad.providers". All fields are combined with a logical 'AND'. */
export type Ad_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Providers_Bool_Exp>>;
  _not?: InputMaybe<Ad_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Providers_Bool_Exp>>;
  access_token?: InputMaybe<String_Comparison_Exp>;
  account_id?: InputMaybe<String_Comparison_Exp>;
  account_secret?: InputMaybe<String_Comparison_Exp>;
  api_key?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_error_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_sync_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<Ad_Platform_Enum_Comparison_Exp>;
  refresh_token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad.providers" */
export enum Ad_Providers_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey = 'providers_pkey'
}

/** input type for inserting data into table "ad.providers" */
export type Ad_Providers_Insert_Input = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_id?: InputMaybe<Scalars['String']['input']>;
  account_secret?: InputMaybe<Scalars['String']['input']>;
  api_key?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_sync_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Ad_Platform_Enum>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Ad_Providers_Max_Fields = {
  __typename?: 'ad_providers_max_fields';
  access_token?: Maybe<Scalars['String']['output']>;
  account_id?: Maybe<Scalars['String']['output']>;
  account_secret?: Maybe<Scalars['String']['output']>;
  api_key?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_error_at?: Maybe<Scalars['timestamptz']['output']>;
  last_sync_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Ad_Providers_Min_Fields = {
  __typename?: 'ad_providers_min_fields';
  access_token?: Maybe<Scalars['String']['output']>;
  account_id?: Maybe<Scalars['String']['output']>;
  account_secret?: Maybe<Scalars['String']['output']>;
  api_key?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_error_at?: Maybe<Scalars['timestamptz']['output']>;
  last_sync_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "ad.providers" */
export type Ad_Providers_Mutation_Response = {
  __typename?: 'ad_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Providers>;
};

/** on_conflict condition type for table "ad.providers" */
export type Ad_Providers_On_Conflict = {
  constraint: Ad_Providers_Constraint;
  update_columns?: Array<Ad_Providers_Update_Column>;
  where?: InputMaybe<Ad_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "ad.providers". */
export type Ad_Providers_Order_By = {
  access_token?: InputMaybe<Order_By>;
  account_id?: InputMaybe<Order_By>;
  account_secret?: InputMaybe<Order_By>;
  api_key?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_error_at?: InputMaybe<Order_By>;
  last_sync_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad.providers */
export type Ad_Providers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ad.providers" */
export enum Ad_Providers_Select_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AccountSecret = 'account_secret',
  /** column name */
  ApiKey = 'api_key',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastErrorAt = 'last_error_at',
  /** column name */
  LastSyncAt = 'last_sync_at',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ad.providers" */
export type Ad_Providers_Set_Input = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_id?: InputMaybe<Scalars['String']['input']>;
  account_secret?: InputMaybe<Scalars['String']['input']>;
  api_key?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_sync_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Ad_Platform_Enum>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "ad_providers" */
export type Ad_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Providers_Stream_Cursor_Value_Input = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_id?: InputMaybe<Scalars['String']['input']>;
  account_secret?: InputMaybe<Scalars['String']['input']>;
  api_key?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_sync_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Ad_Platform_Enum>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "ad.providers" */
export enum Ad_Providers_Update_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AccountSecret = 'account_secret',
  /** column name */
  ApiKey = 'api_key',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastErrorAt = 'last_error_at',
  /** column name */
  LastSyncAt = 'last_sync_at',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ad_Providers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Providers_Bool_Exp;
};

/** columns and relationships of "ad.setting" */
export type Ad_Setting = {
  __typename?: 'ad_setting';
  value: Scalars['String']['output'];
};

/** aggregated selection of "ad.setting" */
export type Ad_Setting_Aggregate = {
  __typename?: 'ad_setting_aggregate';
  aggregate?: Maybe<Ad_Setting_Aggregate_Fields>;
  nodes: Array<Ad_Setting>;
};

/** aggregate fields of "ad.setting" */
export type Ad_Setting_Aggregate_Fields = {
  __typename?: 'ad_setting_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Setting_Max_Fields>;
  min?: Maybe<Ad_Setting_Min_Fields>;
};


/** aggregate fields of "ad.setting" */
export type Ad_Setting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Setting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ad.setting". All fields are combined with a logical 'AND'. */
export type Ad_Setting_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Setting_Bool_Exp>>;
  _not?: InputMaybe<Ad_Setting_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Setting_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad.setting" */
export enum Ad_Setting_Constraint {
  /** unique or primary key constraint on columns "value" */
  SettingPkey = 'setting_pkey'
}

export enum Ad_Setting_Enum {
  BackgroundPicture = 'BACKGROUND_PICTURE',
  Benefits = 'BENEFITS',
  BrandColor = 'BRAND_COLOR',
  CallToAction = 'CALL_TO_ACTION',
  Headline = 'HEADLINE',
  Link = 'LINK',
  Logo = 'LOGO'
}

/** Boolean expression to compare columns of type "ad_setting_enum". All fields are combined with logical 'AND'. */
export type Ad_Setting_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ad_Setting_Enum>;
  _in?: InputMaybe<Array<Ad_Setting_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ad_Setting_Enum>;
  _nin?: InputMaybe<Array<Ad_Setting_Enum>>;
};

/** input type for inserting data into table "ad.setting" */
export type Ad_Setting_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ad_Setting_Max_Fields = {
  __typename?: 'ad_setting_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Ad_Setting_Min_Fields = {
  __typename?: 'ad_setting_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "ad.setting" */
export type Ad_Setting_Mutation_Response = {
  __typename?: 'ad_setting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Setting>;
};

/** on_conflict condition type for table "ad.setting" */
export type Ad_Setting_On_Conflict = {
  constraint: Ad_Setting_Constraint;
  update_columns?: Array<Ad_Setting_Update_Column>;
  where?: InputMaybe<Ad_Setting_Bool_Exp>;
};

/** Ordering options when selecting data from "ad.setting". */
export type Ad_Setting_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad.setting */
export type Ad_Setting_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "ad.setting" */
export enum Ad_Setting_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ad.setting" */
export type Ad_Setting_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ad_setting" */
export type Ad_Setting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Setting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Setting_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ad.setting" */
export enum Ad_Setting_Update_Column {
  /** column name */
  Value = 'value'
}

export type Ad_Setting_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Setting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Setting_Bool_Exp;
};

/** columns and relationships of "ad.status" */
export type Ad_Status = {
  __typename?: 'ad_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "ad.status" */
export type Ad_Status_Aggregate = {
  __typename?: 'ad_status_aggregate';
  aggregate?: Maybe<Ad_Status_Aggregate_Fields>;
  nodes: Array<Ad_Status>;
};

/** aggregate fields of "ad.status" */
export type Ad_Status_Aggregate_Fields = {
  __typename?: 'ad_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Status_Max_Fields>;
  min?: Maybe<Ad_Status_Min_Fields>;
};


/** aggregate fields of "ad.status" */
export type Ad_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ad.status". All fields are combined with a logical 'AND'. */
export type Ad_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Status_Bool_Exp>>;
  _not?: InputMaybe<Ad_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad.status" */
export enum Ad_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  StatusPkey = 'status_pkey'
}

export enum Ad_Status_Enum {
  Approved = 'APPROVED',
  WaitingForApproval = 'WAITING_FOR_APPROVAL',
  WaitingForRevision = 'WAITING_FOR_REVISION'
}

/** Boolean expression to compare columns of type "ad_status_enum". All fields are combined with logical 'AND'. */
export type Ad_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ad_Status_Enum>;
  _in?: InputMaybe<Array<Ad_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ad_Status_Enum>;
  _nin?: InputMaybe<Array<Ad_Status_Enum>>;
};

/** input type for inserting data into table "ad.status" */
export type Ad_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ad_Status_Max_Fields = {
  __typename?: 'ad_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Ad_Status_Min_Fields = {
  __typename?: 'ad_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "ad.status" */
export type Ad_Status_Mutation_Response = {
  __typename?: 'ad_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Status>;
};

/** on_conflict condition type for table "ad.status" */
export type Ad_Status_On_Conflict = {
  constraint: Ad_Status_Constraint;
  update_columns?: Array<Ad_Status_Update_Column>;
  where?: InputMaybe<Ad_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "ad.status". */
export type Ad_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad.status */
export type Ad_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "ad.status" */
export enum Ad_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ad.status" */
export type Ad_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ad_status" */
export type Ad_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ad.status" */
export enum Ad_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Ad_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Status_Bool_Exp;
};

/** columns and relationships of "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns = {
  __typename?: 'anna_ai_call_campaigns';
  call_from: Scalars['timetz']['output'];
  call_till: Scalars['timetz']['output'];
  call_wait_time: Scalars['Int']['output'];
  /** An object relationship */
  campaign?: Maybe<Campaign>;
  campaign_data: Scalars['jsonb']['output'];
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  enabled: Scalars['Boolean']['output'];
  from: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  inbound: Scalars['Boolean']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
  max_calls: Scalars['Int']['output'];
  /** An array relationship */
  outbound_calls: Array<Anna_Ai_Outbound_Calls>;
  /** An aggregate relationship */
  outbound_calls_aggregate: Anna_Ai_Outbound_Calls_Aggregate;
  pathway_id: Scalars['uuid']['output'];
  tier: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  webhook?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "anna_ai.call_campaigns" */
export type Anna_Ai_Call_CampaignsCampaign_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "anna_ai.call_campaigns" */
export type Anna_Ai_Call_CampaignsOutbound_CallsArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Order_By>>;
  where?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
};


/** columns and relationships of "anna_ai.call_campaigns" */
export type Anna_Ai_Call_CampaignsOutbound_Calls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Order_By>>;
  where?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
};

/** aggregated selection of "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Aggregate = {
  __typename?: 'anna_ai_call_campaigns_aggregate';
  aggregate?: Maybe<Anna_Ai_Call_Campaigns_Aggregate_Fields>;
  nodes: Array<Anna_Ai_Call_Campaigns>;
};

export type Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp_Count>;
};

export type Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp_Bool_And = {
  arguments: Anna_Ai_Call_Campaigns_Select_Column_Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Anna_Ai_Call_Campaigns_Select_Column_Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Aggregate_Fields = {
  __typename?: 'anna_ai_call_campaigns_aggregate_fields';
  avg?: Maybe<Anna_Ai_Call_Campaigns_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Anna_Ai_Call_Campaigns_Max_Fields>;
  min?: Maybe<Anna_Ai_Call_Campaigns_Min_Fields>;
  stddev?: Maybe<Anna_Ai_Call_Campaigns_Stddev_Fields>;
  stddev_pop?: Maybe<Anna_Ai_Call_Campaigns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Anna_Ai_Call_Campaigns_Stddev_Samp_Fields>;
  sum?: Maybe<Anna_Ai_Call_Campaigns_Sum_Fields>;
  var_pop?: Maybe<Anna_Ai_Call_Campaigns_Var_Pop_Fields>;
  var_samp?: Maybe<Anna_Ai_Call_Campaigns_Var_Samp_Fields>;
  variance?: Maybe<Anna_Ai_Call_Campaigns_Variance_Fields>;
};


/** aggregate fields of "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Aggregate_Order_By = {
  avg?: InputMaybe<Anna_Ai_Call_Campaigns_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Anna_Ai_Call_Campaigns_Max_Order_By>;
  min?: InputMaybe<Anna_Ai_Call_Campaigns_Min_Order_By>;
  stddev?: InputMaybe<Anna_Ai_Call_Campaigns_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Anna_Ai_Call_Campaigns_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Anna_Ai_Call_Campaigns_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Anna_Ai_Call_Campaigns_Sum_Order_By>;
  var_pop?: InputMaybe<Anna_Ai_Call_Campaigns_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Anna_Ai_Call_Campaigns_Var_Samp_Order_By>;
  variance?: InputMaybe<Anna_Ai_Call_Campaigns_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Anna_Ai_Call_Campaigns_Append_Input = {
  campaign_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Arr_Rel_Insert_Input = {
  data: Array<Anna_Ai_Call_Campaigns_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Anna_Ai_Call_Campaigns_On_Conflict>;
};

/** aggregate avg on columns */
export type Anna_Ai_Call_Campaigns_Avg_Fields = {
  __typename?: 'anna_ai_call_campaigns_avg_fields';
  call_wait_time?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
  max_calls?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Avg_Order_By = {
  call_wait_time?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "anna_ai.call_campaigns". All fields are combined with a logical 'AND'. */
export type Anna_Ai_Call_Campaigns_Bool_Exp = {
  _and?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Bool_Exp>>;
  _not?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
  _or?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Bool_Exp>>;
  call_from?: InputMaybe<Timetz_Comparison_Exp>;
  call_till?: InputMaybe<Timetz_Comparison_Exp>;
  call_wait_time?: InputMaybe<Int_Comparison_Exp>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_data?: InputMaybe<Jsonb_Comparison_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  from?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inbound?: InputMaybe<Boolean_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  make_id?: InputMaybe<Int_Comparison_Exp>;
  max_calls?: InputMaybe<Int_Comparison_Exp>;
  outbound_calls?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
  outbound_calls_aggregate?: InputMaybe<Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp>;
  pathway_id?: InputMaybe<Uuid_Comparison_Exp>;
  tier?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  webhook?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "anna_ai.call_campaigns" */
export enum Anna_Ai_Call_Campaigns_Constraint {
  /** unique or primary key constraint on columns "campaign_id" */
  CallCampaignsCampaignIdKey = 'call_campaigns_campaign_id_key',
  /** unique or primary key constraint on columns "id" */
  CallCampaignsPkey = 'call_campaigns_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Anna_Ai_Call_Campaigns_Delete_At_Path_Input = {
  campaign_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Anna_Ai_Call_Campaigns_Delete_Elem_Input = {
  campaign_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Anna_Ai_Call_Campaigns_Delete_Key_Input = {
  campaign_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Inc_Input = {
  call_wait_time?: InputMaybe<Scalars['Int']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
  max_calls?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Insert_Input = {
  call_from?: InputMaybe<Scalars['timetz']['input']>;
  call_till?: InputMaybe<Scalars['timetz']['input']>;
  call_wait_time?: InputMaybe<Scalars['Int']['input']>;
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_data?: InputMaybe<Scalars['jsonb']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inbound?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
  max_calls?: InputMaybe<Scalars['Int']['input']>;
  outbound_calls?: InputMaybe<Anna_Ai_Outbound_Calls_Arr_Rel_Insert_Input>;
  pathway_id?: InputMaybe<Scalars['uuid']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  webhook?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Anna_Ai_Call_Campaigns_Max_Fields = {
  __typename?: 'anna_ai_call_campaigns_max_fields';
  call_from?: Maybe<Scalars['timetz']['output']>;
  call_till?: Maybe<Scalars['timetz']['output']>;
  call_wait_time?: Maybe<Scalars['Int']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
  max_calls?: Maybe<Scalars['Int']['output']>;
  pathway_id?: Maybe<Scalars['uuid']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  webhook?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Max_Order_By = {
  call_from?: InputMaybe<Order_By>;
  call_till?: InputMaybe<Order_By>;
  call_wait_time?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
  pathway_id?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  webhook?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Anna_Ai_Call_Campaigns_Min_Fields = {
  __typename?: 'anna_ai_call_campaigns_min_fields';
  call_from?: Maybe<Scalars['timetz']['output']>;
  call_till?: Maybe<Scalars['timetz']['output']>;
  call_wait_time?: Maybe<Scalars['Int']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
  max_calls?: Maybe<Scalars['Int']['output']>;
  pathway_id?: Maybe<Scalars['uuid']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  webhook?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Min_Order_By = {
  call_from?: InputMaybe<Order_By>;
  call_till?: InputMaybe<Order_By>;
  call_wait_time?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
  pathway_id?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  webhook?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Mutation_Response = {
  __typename?: 'anna_ai_call_campaigns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anna_Ai_Call_Campaigns>;
};

/** input type for inserting object relation for remote table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Obj_Rel_Insert_Input = {
  data: Anna_Ai_Call_Campaigns_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Anna_Ai_Call_Campaigns_On_Conflict>;
};

/** on_conflict condition type for table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_On_Conflict = {
  constraint: Anna_Ai_Call_Campaigns_Constraint;
  update_columns?: Array<Anna_Ai_Call_Campaigns_Update_Column>;
  where?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
};

/** Ordering options when selecting data from "anna_ai.call_campaigns". */
export type Anna_Ai_Call_Campaigns_Order_By = {
  call_from?: InputMaybe<Order_By>;
  call_till?: InputMaybe<Order_By>;
  call_wait_time?: InputMaybe<Order_By>;
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_data?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inbound?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
  outbound_calls_aggregate?: InputMaybe<Anna_Ai_Outbound_Calls_Aggregate_Order_By>;
  pathway_id?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  webhook?: InputMaybe<Order_By>;
};

/** primary key columns input for table: anna_ai.call_campaigns */
export type Anna_Ai_Call_Campaigns_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Anna_Ai_Call_Campaigns_Prepend_Input = {
  campaign_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "anna_ai.call_campaigns" */
export enum Anna_Ai_Call_Campaigns_Select_Column {
  /** column name */
  CallFrom = 'call_from',
  /** column name */
  CallTill = 'call_till',
  /** column name */
  CallWaitTime = 'call_wait_time',
  /** column name */
  CampaignData = 'campaign_data',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  Inbound = 'inbound',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MakeId = 'make_id',
  /** column name */
  MaxCalls = 'max_calls',
  /** column name */
  PathwayId = 'pathway_id',
  /** column name */
  Tier = 'tier',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Webhook = 'webhook'
}

/** select "anna_ai_call_campaigns_aggregate_bool_exp_bool_and_arguments_columns" columns of table "anna_ai.call_campaigns" */
export enum Anna_Ai_Call_Campaigns_Select_Column_Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Inbound = 'inbound',
  /** column name */
  IsActive = 'is_active'
}

/** select "anna_ai_call_campaigns_aggregate_bool_exp_bool_or_arguments_columns" columns of table "anna_ai.call_campaigns" */
export enum Anna_Ai_Call_Campaigns_Select_Column_Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Inbound = 'inbound',
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Set_Input = {
  call_from?: InputMaybe<Scalars['timetz']['input']>;
  call_till?: InputMaybe<Scalars['timetz']['input']>;
  call_wait_time?: InputMaybe<Scalars['Int']['input']>;
  campaign_data?: InputMaybe<Scalars['jsonb']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inbound?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
  max_calls?: InputMaybe<Scalars['Int']['input']>;
  pathway_id?: InputMaybe<Scalars['uuid']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  webhook?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Anna_Ai_Call_Campaigns_Stddev_Fields = {
  __typename?: 'anna_ai_call_campaigns_stddev_fields';
  call_wait_time?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
  max_calls?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Stddev_Order_By = {
  call_wait_time?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Anna_Ai_Call_Campaigns_Stddev_Pop_Fields = {
  __typename?: 'anna_ai_call_campaigns_stddev_pop_fields';
  call_wait_time?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
  max_calls?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Stddev_Pop_Order_By = {
  call_wait_time?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Anna_Ai_Call_Campaigns_Stddev_Samp_Fields = {
  __typename?: 'anna_ai_call_campaigns_stddev_samp_fields';
  call_wait_time?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
  max_calls?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Stddev_Samp_Order_By = {
  call_wait_time?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "anna_ai_call_campaigns" */
export type Anna_Ai_Call_Campaigns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anna_Ai_Call_Campaigns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anna_Ai_Call_Campaigns_Stream_Cursor_Value_Input = {
  call_from?: InputMaybe<Scalars['timetz']['input']>;
  call_till?: InputMaybe<Scalars['timetz']['input']>;
  call_wait_time?: InputMaybe<Scalars['Int']['input']>;
  campaign_data?: InputMaybe<Scalars['jsonb']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inbound?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
  max_calls?: InputMaybe<Scalars['Int']['input']>;
  pathway_id?: InputMaybe<Scalars['uuid']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  webhook?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Anna_Ai_Call_Campaigns_Sum_Fields = {
  __typename?: 'anna_ai_call_campaigns_sum_fields';
  call_wait_time?: Maybe<Scalars['Int']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
  max_calls?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Sum_Order_By = {
  call_wait_time?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
};

/** update columns of table "anna_ai.call_campaigns" */
export enum Anna_Ai_Call_Campaigns_Update_Column {
  /** column name */
  CallFrom = 'call_from',
  /** column name */
  CallTill = 'call_till',
  /** column name */
  CallWaitTime = 'call_wait_time',
  /** column name */
  CampaignData = 'campaign_data',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  Inbound = 'inbound',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MakeId = 'make_id',
  /** column name */
  MaxCalls = 'max_calls',
  /** column name */
  PathwayId = 'pathway_id',
  /** column name */
  Tier = 'tier',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Webhook = 'webhook'
}

export type Anna_Ai_Call_Campaigns_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Anna_Ai_Call_Campaigns_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Anna_Ai_Call_Campaigns_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Anna_Ai_Call_Campaigns_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Anna_Ai_Call_Campaigns_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Anna_Ai_Call_Campaigns_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Anna_Ai_Call_Campaigns_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anna_Ai_Call_Campaigns_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anna_Ai_Call_Campaigns_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Anna_Ai_Call_Campaigns_Var_Pop_Fields = {
  __typename?: 'anna_ai_call_campaigns_var_pop_fields';
  call_wait_time?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
  max_calls?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Var_Pop_Order_By = {
  call_wait_time?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Anna_Ai_Call_Campaigns_Var_Samp_Fields = {
  __typename?: 'anna_ai_call_campaigns_var_samp_fields';
  call_wait_time?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
  max_calls?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Var_Samp_Order_By = {
  call_wait_time?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Anna_Ai_Call_Campaigns_Variance_Fields = {
  __typename?: 'anna_ai_call_campaigns_variance_fields';
  call_wait_time?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
  max_calls?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "anna_ai.call_campaigns" */
export type Anna_Ai_Call_Campaigns_Variance_Order_By = {
  call_wait_time?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  max_calls?: InputMaybe<Order_By>;
};

/** columns and relationships of "anna_ai.call_states" */
export type Anna_Ai_Call_States = {
  __typename?: 'anna_ai_call_states';
  /** An array relationship */
  outbound_calls: Array<Anna_Ai_Outbound_Calls>;
  /** An aggregate relationship */
  outbound_calls_aggregate: Anna_Ai_Outbound_Calls_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "anna_ai.call_states" */
export type Anna_Ai_Call_StatesOutbound_CallsArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Order_By>>;
  where?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
};


/** columns and relationships of "anna_ai.call_states" */
export type Anna_Ai_Call_StatesOutbound_Calls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Order_By>>;
  where?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
};

/** aggregated selection of "anna_ai.call_states" */
export type Anna_Ai_Call_States_Aggregate = {
  __typename?: 'anna_ai_call_states_aggregate';
  aggregate?: Maybe<Anna_Ai_Call_States_Aggregate_Fields>;
  nodes: Array<Anna_Ai_Call_States>;
};

/** aggregate fields of "anna_ai.call_states" */
export type Anna_Ai_Call_States_Aggregate_Fields = {
  __typename?: 'anna_ai_call_states_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Anna_Ai_Call_States_Max_Fields>;
  min?: Maybe<Anna_Ai_Call_States_Min_Fields>;
};


/** aggregate fields of "anna_ai.call_states" */
export type Anna_Ai_Call_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anna_Ai_Call_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "anna_ai.call_states". All fields are combined with a logical 'AND'. */
export type Anna_Ai_Call_States_Bool_Exp = {
  _and?: InputMaybe<Array<Anna_Ai_Call_States_Bool_Exp>>;
  _not?: InputMaybe<Anna_Ai_Call_States_Bool_Exp>;
  _or?: InputMaybe<Array<Anna_Ai_Call_States_Bool_Exp>>;
  outbound_calls?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
  outbound_calls_aggregate?: InputMaybe<Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "anna_ai.call_states" */
export enum Anna_Ai_Call_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  CallStatesPkey = 'call_states_pkey'
}

/** input type for inserting data into table "anna_ai.call_states" */
export type Anna_Ai_Call_States_Insert_Input = {
  outbound_calls?: InputMaybe<Anna_Ai_Outbound_Calls_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Anna_Ai_Call_States_Max_Fields = {
  __typename?: 'anna_ai_call_states_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Anna_Ai_Call_States_Min_Fields = {
  __typename?: 'anna_ai_call_states_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "anna_ai.call_states" */
export type Anna_Ai_Call_States_Mutation_Response = {
  __typename?: 'anna_ai_call_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anna_Ai_Call_States>;
};

/** input type for inserting object relation for remote table "anna_ai.call_states" */
export type Anna_Ai_Call_States_Obj_Rel_Insert_Input = {
  data: Anna_Ai_Call_States_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Anna_Ai_Call_States_On_Conflict>;
};

/** on_conflict condition type for table "anna_ai.call_states" */
export type Anna_Ai_Call_States_On_Conflict = {
  constraint: Anna_Ai_Call_States_Constraint;
  update_columns?: Array<Anna_Ai_Call_States_Update_Column>;
  where?: InputMaybe<Anna_Ai_Call_States_Bool_Exp>;
};

/** Ordering options when selecting data from "anna_ai.call_states". */
export type Anna_Ai_Call_States_Order_By = {
  outbound_calls_aggregate?: InputMaybe<Anna_Ai_Outbound_Calls_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: anna_ai.call_states */
export type Anna_Ai_Call_States_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "anna_ai.call_states" */
export enum Anna_Ai_Call_States_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "anna_ai.call_states" */
export type Anna_Ai_Call_States_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "anna_ai_call_states" */
export type Anna_Ai_Call_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anna_Ai_Call_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anna_Ai_Call_States_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "anna_ai.call_states" */
export enum Anna_Ai_Call_States_Update_Column {
  /** column name */
  Value = 'value'
}

export type Anna_Ai_Call_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anna_Ai_Call_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anna_Ai_Call_States_Bool_Exp;
};

/** columns and relationships of "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls = {
  __typename?: 'anna_ai_outbound_calls';
  /** An object relationship */
  call_campaign: Anna_Ai_Call_Campaigns;
  call_campaign_id: Scalars['uuid']['output'];
  call_ended_by?: Maybe<Scalars['String']['output']>;
  call_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  call_state: Anna_Ai_Call_States;
  consent_given?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  contact?: Maybe<Contact>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  end_call_result?: Maybe<Scalars['String']['output']>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  has_recording: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  lang_skill: Scalars['String']['output'];
  overall_impression: Scalars['String']['output'];
  pathway_tags?: Maybe<Scalars['jsonb']['output']>;
  planned_at: Scalars['timestamptz']['output'];
  q_and_a?: Maybe<Scalars['jsonb']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  state: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  telli_contact_id?: Maybe<Scalars['uuid']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  transcripts?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  upload?: Maybe<File_Upload>;
  variables?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_CallsPathway_TagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_CallsQ_And_AArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_CallsTranscriptsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_CallsVariablesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_Aggregate = {
  __typename?: 'anna_ai_outbound_calls_aggregate';
  aggregate?: Maybe<Anna_Ai_Outbound_Calls_Aggregate_Fields>;
  nodes: Array<Anna_Ai_Outbound_Calls>;
};

export type Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp_Count>;
};

export type Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp_Bool_And = {
  arguments: Anna_Ai_Outbound_Calls_Select_Column_Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Anna_Ai_Outbound_Calls_Select_Column_Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_Aggregate_Fields = {
  __typename?: 'anna_ai_outbound_calls_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Anna_Ai_Outbound_Calls_Max_Fields>;
  min?: Maybe<Anna_Ai_Outbound_Calls_Min_Fields>;
};


/** aggregate fields of "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Anna_Ai_Outbound_Calls_Max_Order_By>;
  min?: InputMaybe<Anna_Ai_Outbound_Calls_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Anna_Ai_Outbound_Calls_Append_Input = {
  pathway_tags?: InputMaybe<Scalars['jsonb']['input']>;
  q_and_a?: InputMaybe<Scalars['jsonb']['input']>;
  transcripts?: InputMaybe<Scalars['jsonb']['input']>;
  variables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_Arr_Rel_Insert_Input = {
  data: Array<Anna_Ai_Outbound_Calls_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Anna_Ai_Outbound_Calls_On_Conflict>;
};

/** Boolean expression to filter rows from the table "anna_ai.outbound_calls". All fields are combined with a logical 'AND'. */
export type Anna_Ai_Outbound_Calls_Bool_Exp = {
  _and?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Bool_Exp>>;
  _not?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
  _or?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Bool_Exp>>;
  call_campaign?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
  call_campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  call_ended_by?: InputMaybe<String_Comparison_Exp>;
  call_id?: InputMaybe<Uuid_Comparison_Exp>;
  call_state?: InputMaybe<Anna_Ai_Call_States_Bool_Exp>;
  consent_given?: InputMaybe<Boolean_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  duration?: InputMaybe<String_Comparison_Exp>;
  end_call_result?: InputMaybe<String_Comparison_Exp>;
  ended_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_recording?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lang_skill?: InputMaybe<String_Comparison_Exp>;
  overall_impression?: InputMaybe<String_Comparison_Exp>;
  pathway_tags?: InputMaybe<Jsonb_Comparison_Exp>;
  planned_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  q_and_a?: InputMaybe<Jsonb_Comparison_Exp>;
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  summary?: InputMaybe<String_Comparison_Exp>;
  telli_contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  to?: InputMaybe<String_Comparison_Exp>;
  transcripts?: InputMaybe<Jsonb_Comparison_Exp>;
  upload?: InputMaybe<File_Upload_Bool_Exp>;
  variables?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "anna_ai.outbound_calls" */
export enum Anna_Ai_Outbound_Calls_Constraint {
  /** unique or primary key constraint on columns "id", "contact_id" */
  OutboundCallIdContactIdIdx = 'outbound_call_id_contact_id_idx',
  /** unique or primary key constraint on columns "id" */
  OutboundCallsPkey = 'outbound_calls_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Anna_Ai_Outbound_Calls_Delete_At_Path_Input = {
  pathway_tags?: InputMaybe<Array<Scalars['String']['input']>>;
  q_and_a?: InputMaybe<Array<Scalars['String']['input']>>;
  transcripts?: InputMaybe<Array<Scalars['String']['input']>>;
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Anna_Ai_Outbound_Calls_Delete_Elem_Input = {
  pathway_tags?: InputMaybe<Scalars['Int']['input']>;
  q_and_a?: InputMaybe<Scalars['Int']['input']>;
  transcripts?: InputMaybe<Scalars['Int']['input']>;
  variables?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Anna_Ai_Outbound_Calls_Delete_Key_Input = {
  pathway_tags?: InputMaybe<Scalars['String']['input']>;
  q_and_a?: InputMaybe<Scalars['String']['input']>;
  transcripts?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_Insert_Input = {
  call_campaign?: InputMaybe<Anna_Ai_Call_Campaigns_Obj_Rel_Insert_Input>;
  call_campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  call_ended_by?: InputMaybe<Scalars['String']['input']>;
  call_id?: InputMaybe<Scalars['uuid']['input']>;
  call_state?: InputMaybe<Anna_Ai_Call_States_Obj_Rel_Insert_Input>;
  consent_given?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  end_call_result?: InputMaybe<Scalars['String']['input']>;
  ended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  has_recording?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lang_skill?: InputMaybe<Scalars['String']['input']>;
  overall_impression?: InputMaybe<Scalars['String']['input']>;
  pathway_tags?: InputMaybe<Scalars['jsonb']['input']>;
  planned_at?: InputMaybe<Scalars['timestamptz']['input']>;
  q_and_a?: InputMaybe<Scalars['jsonb']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  telli_contact_id?: InputMaybe<Scalars['uuid']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  transcripts?: InputMaybe<Scalars['jsonb']['input']>;
  upload?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  variables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Anna_Ai_Outbound_Calls_Max_Fields = {
  __typename?: 'anna_ai_outbound_calls_max_fields';
  call_campaign_id?: Maybe<Scalars['uuid']['output']>;
  call_ended_by?: Maybe<Scalars['String']['output']>;
  call_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  end_call_result?: Maybe<Scalars['String']['output']>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lang_skill?: Maybe<Scalars['String']['output']>;
  overall_impression?: Maybe<Scalars['String']['output']>;
  planned_at?: Maybe<Scalars['timestamptz']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  telli_contact_id?: Maybe<Scalars['uuid']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_Max_Order_By = {
  call_campaign_id?: InputMaybe<Order_By>;
  call_ended_by?: InputMaybe<Order_By>;
  call_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  end_call_result?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lang_skill?: InputMaybe<Order_By>;
  overall_impression?: InputMaybe<Order_By>;
  planned_at?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  telli_contact_id?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Anna_Ai_Outbound_Calls_Min_Fields = {
  __typename?: 'anna_ai_outbound_calls_min_fields';
  call_campaign_id?: Maybe<Scalars['uuid']['output']>;
  call_ended_by?: Maybe<Scalars['String']['output']>;
  call_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  end_call_result?: Maybe<Scalars['String']['output']>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lang_skill?: Maybe<Scalars['String']['output']>;
  overall_impression?: Maybe<Scalars['String']['output']>;
  planned_at?: Maybe<Scalars['timestamptz']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  telli_contact_id?: Maybe<Scalars['uuid']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_Min_Order_By = {
  call_campaign_id?: InputMaybe<Order_By>;
  call_ended_by?: InputMaybe<Order_By>;
  call_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  end_call_result?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lang_skill?: InputMaybe<Order_By>;
  overall_impression?: InputMaybe<Order_By>;
  planned_at?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  telli_contact_id?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_Mutation_Response = {
  __typename?: 'anna_ai_outbound_calls_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anna_Ai_Outbound_Calls>;
};

/** on_conflict condition type for table "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_On_Conflict = {
  constraint: Anna_Ai_Outbound_Calls_Constraint;
  update_columns?: Array<Anna_Ai_Outbound_Calls_Update_Column>;
  where?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
};

/** Ordering options when selecting data from "anna_ai.outbound_calls". */
export type Anna_Ai_Outbound_Calls_Order_By = {
  call_campaign?: InputMaybe<Anna_Ai_Call_Campaigns_Order_By>;
  call_campaign_id?: InputMaybe<Order_By>;
  call_ended_by?: InputMaybe<Order_By>;
  call_id?: InputMaybe<Order_By>;
  call_state?: InputMaybe<Anna_Ai_Call_States_Order_By>;
  consent_given?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  end_call_result?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  has_recording?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lang_skill?: InputMaybe<Order_By>;
  overall_impression?: InputMaybe<Order_By>;
  pathway_tags?: InputMaybe<Order_By>;
  planned_at?: InputMaybe<Order_By>;
  q_and_a?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  telli_contact_id?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  transcripts?: InputMaybe<Order_By>;
  upload?: InputMaybe<File_Upload_Order_By>;
  variables?: InputMaybe<Order_By>;
};

/** primary key columns input for table: anna_ai.outbound_calls */
export type Anna_Ai_Outbound_Calls_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Anna_Ai_Outbound_Calls_Prepend_Input = {
  pathway_tags?: InputMaybe<Scalars['jsonb']['input']>;
  q_and_a?: InputMaybe<Scalars['jsonb']['input']>;
  transcripts?: InputMaybe<Scalars['jsonb']['input']>;
  variables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "anna_ai.outbound_calls" */
export enum Anna_Ai_Outbound_Calls_Select_Column {
  /** column name */
  CallCampaignId = 'call_campaign_id',
  /** column name */
  CallEndedBy = 'call_ended_by',
  /** column name */
  CallId = 'call_id',
  /** column name */
  ConsentGiven = 'consent_given',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  EndCallResult = 'end_call_result',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  HasRecording = 'has_recording',
  /** column name */
  Id = 'id',
  /** column name */
  LangSkill = 'lang_skill',
  /** column name */
  OverallImpression = 'overall_impression',
  /** column name */
  PathwayTags = 'pathway_tags',
  /** column name */
  PlannedAt = 'planned_at',
  /** column name */
  QAndA = 'q_and_a',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  State = 'state',
  /** column name */
  Summary = 'summary',
  /** column name */
  TelliContactId = 'telli_contact_id',
  /** column name */
  To = 'to',
  /** column name */
  Transcripts = 'transcripts',
  /** column name */
  Variables = 'variables'
}

/** select "anna_ai_outbound_calls_aggregate_bool_exp_bool_and_arguments_columns" columns of table "anna_ai.outbound_calls" */
export enum Anna_Ai_Outbound_Calls_Select_Column_Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ConsentGiven = 'consent_given',
  /** column name */
  HasRecording = 'has_recording'
}

/** select "anna_ai_outbound_calls_aggregate_bool_exp_bool_or_arguments_columns" columns of table "anna_ai.outbound_calls" */
export enum Anna_Ai_Outbound_Calls_Select_Column_Anna_Ai_Outbound_Calls_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ConsentGiven = 'consent_given',
  /** column name */
  HasRecording = 'has_recording'
}

/** input type for updating data in table "anna_ai.outbound_calls" */
export type Anna_Ai_Outbound_Calls_Set_Input = {
  call_campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  call_ended_by?: InputMaybe<Scalars['String']['input']>;
  call_id?: InputMaybe<Scalars['uuid']['input']>;
  consent_given?: InputMaybe<Scalars['Boolean']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  end_call_result?: InputMaybe<Scalars['String']['input']>;
  ended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  has_recording?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lang_skill?: InputMaybe<Scalars['String']['input']>;
  overall_impression?: InputMaybe<Scalars['String']['input']>;
  pathway_tags?: InputMaybe<Scalars['jsonb']['input']>;
  planned_at?: InputMaybe<Scalars['timestamptz']['input']>;
  q_and_a?: InputMaybe<Scalars['jsonb']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  telli_contact_id?: InputMaybe<Scalars['uuid']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  transcripts?: InputMaybe<Scalars['jsonb']['input']>;
  variables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "anna_ai_outbound_calls" */
export type Anna_Ai_Outbound_Calls_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anna_Ai_Outbound_Calls_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anna_Ai_Outbound_Calls_Stream_Cursor_Value_Input = {
  call_campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  call_ended_by?: InputMaybe<Scalars['String']['input']>;
  call_id?: InputMaybe<Scalars['uuid']['input']>;
  consent_given?: InputMaybe<Scalars['Boolean']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  end_call_result?: InputMaybe<Scalars['String']['input']>;
  ended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  has_recording?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lang_skill?: InputMaybe<Scalars['String']['input']>;
  overall_impression?: InputMaybe<Scalars['String']['input']>;
  pathway_tags?: InputMaybe<Scalars['jsonb']['input']>;
  planned_at?: InputMaybe<Scalars['timestamptz']['input']>;
  q_and_a?: InputMaybe<Scalars['jsonb']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  telli_contact_id?: InputMaybe<Scalars['uuid']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  transcripts?: InputMaybe<Scalars['jsonb']['input']>;
  variables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "anna_ai.outbound_calls" */
export enum Anna_Ai_Outbound_Calls_Update_Column {
  /** column name */
  CallCampaignId = 'call_campaign_id',
  /** column name */
  CallEndedBy = 'call_ended_by',
  /** column name */
  CallId = 'call_id',
  /** column name */
  ConsentGiven = 'consent_given',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  EndCallResult = 'end_call_result',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  HasRecording = 'has_recording',
  /** column name */
  Id = 'id',
  /** column name */
  LangSkill = 'lang_skill',
  /** column name */
  OverallImpression = 'overall_impression',
  /** column name */
  PathwayTags = 'pathway_tags',
  /** column name */
  PlannedAt = 'planned_at',
  /** column name */
  QAndA = 'q_and_a',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  State = 'state',
  /** column name */
  Summary = 'summary',
  /** column name */
  TelliContactId = 'telli_contact_id',
  /** column name */
  To = 'to',
  /** column name */
  Transcripts = 'transcripts',
  /** column name */
  Variables = 'variables'
}

export type Anna_Ai_Outbound_Calls_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Anna_Ai_Outbound_Calls_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Anna_Ai_Outbound_Calls_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Anna_Ai_Outbound_Calls_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Anna_Ai_Outbound_Calls_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Anna_Ai_Outbound_Calls_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anna_Ai_Outbound_Calls_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anna_Ai_Outbound_Calls_Bool_Exp;
};

/** columns and relationships of "answer" */
export type Answer = {
  __typename?: 'answer';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  /** An object relationship */
  contact: Contact;
  contact_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  question: Funnel_Question;
  question_id: Scalars['uuid']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "answer" */
export type Answer_Aggregate = {
  __typename?: 'answer_aggregate';
  aggregate?: Maybe<Answer_Aggregate_Fields>;
  nodes: Array<Answer>;
};

export type Answer_Aggregate_Bool_Exp = {
  count?: InputMaybe<Answer_Aggregate_Bool_Exp_Count>;
};

export type Answer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Answer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Answer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "answer" */
export type Answer_Aggregate_Fields = {
  __typename?: 'answer_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Answer_Max_Fields>;
  min?: Maybe<Answer_Min_Fields>;
};


/** aggregate fields of "answer" */
export type Answer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Answer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "answer" */
export type Answer_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Answer_Max_Order_By>;
  min?: InputMaybe<Answer_Min_Order_By>;
};

/** input type for inserting array relation for remote table "answer" */
export type Answer_Arr_Rel_Insert_Input = {
  data: Array<Answer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Answer_On_Conflict>;
};

/** Boolean expression to filter rows from the table "answer". All fields are combined with a logical 'AND'. */
export type Answer_Bool_Exp = {
  _and?: InputMaybe<Array<Answer_Bool_Exp>>;
  _not?: InputMaybe<Answer_Bool_Exp>;
  _or?: InputMaybe<Array<Answer_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<Funnel_Question_Bool_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "answer" */
export enum Answer_Constraint {
  /** unique or primary key constraint on columns "id" */
  AnswerPkey = 'answer_pkey',
  /** unique or primary key constraint on columns "question_id", "contact_id" */
  AnswerQuestionIdContactIdKey = 'answer_question_id_contact_id_key'
}

/** input type for inserting data into table "answer" */
export type Answer_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question?: InputMaybe<Funnel_Question_Obj_Rel_Insert_Input>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Answer_Max_Fields = {
  __typename?: 'answer_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "answer" */
export type Answer_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Answer_Min_Fields = {
  __typename?: 'answer_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "answer" */
export type Answer_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "answer" */
export type Answer_Mutation_Response = {
  __typename?: 'answer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Answer>;
};

/** on_conflict condition type for table "answer" */
export type Answer_On_Conflict = {
  constraint: Answer_Constraint;
  update_columns?: Array<Answer_Update_Column>;
  where?: InputMaybe<Answer_Bool_Exp>;
};

/** Ordering options when selecting data from "answer". */
export type Answer_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Funnel_Question_Order_By>;
  question_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: answer */
export type Answer_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "answer" */
export enum Answer_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "answer" */
export type Answer_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "answer" */
export type Answer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Answer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Answer_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "answer" */
export enum Answer_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  Value = 'value'
}

export type Answer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Answer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Answer_Bool_Exp;
};

/** columns and relationships of "applicant.event" */
export type Applicant_Event = {
  __typename?: 'applicant_event';
  applicant_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  extra: Scalars['jsonb']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


/** columns and relationships of "applicant.event" */
export type Applicant_EventExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "applicant.event" */
export type Applicant_Event_Aggregate = {
  __typename?: 'applicant_event_aggregate';
  aggregate?: Maybe<Applicant_Event_Aggregate_Fields>;
  nodes: Array<Applicant_Event>;
};

/** aggregate fields of "applicant.event" */
export type Applicant_Event_Aggregate_Fields = {
  __typename?: 'applicant_event_aggregate_fields';
  avg?: Maybe<Applicant_Event_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Applicant_Event_Max_Fields>;
  min?: Maybe<Applicant_Event_Min_Fields>;
  stddev?: Maybe<Applicant_Event_Stddev_Fields>;
  stddev_pop?: Maybe<Applicant_Event_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Applicant_Event_Stddev_Samp_Fields>;
  sum?: Maybe<Applicant_Event_Sum_Fields>;
  var_pop?: Maybe<Applicant_Event_Var_Pop_Fields>;
  var_samp?: Maybe<Applicant_Event_Var_Samp_Fields>;
  variance?: Maybe<Applicant_Event_Variance_Fields>;
};


/** aggregate fields of "applicant.event" */
export type Applicant_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Applicant_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Applicant_Event_Append_Input = {
  extra?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Applicant_Event_Avg_Fields = {
  __typename?: 'applicant_event_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "applicant.event". All fields are combined with a logical 'AND'. */
export type Applicant_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Event_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Event_Bool_Exp>>;
  applicant_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "applicant.event" */
export enum Applicant_Event_Constraint {
  /** unique or primary key constraint on columns "id", "applicant_id" */
  EventIdApplicantIdIdx = 'event_id_applicant_id_idx',
  /** unique or primary key constraint on columns "id" */
  EventPkey = 'event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Applicant_Event_Delete_At_Path_Input = {
  extra?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Applicant_Event_Delete_Elem_Input = {
  extra?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Applicant_Event_Delete_Key_Input = {
  extra?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "applicant.event" */
export type Applicant_Event_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "applicant.event" */
export type Applicant_Event_Insert_Input = {
  applicant_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  extra?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Applicant_Event_Max_Fields = {
  __typename?: 'applicant_event_max_fields';
  applicant_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Applicant_Event_Min_Fields = {
  __typename?: 'applicant_event_min_fields';
  applicant_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "applicant.event" */
export type Applicant_Event_Mutation_Response = {
  __typename?: 'applicant_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Applicant_Event>;
};

/** on_conflict condition type for table "applicant.event" */
export type Applicant_Event_On_Conflict = {
  constraint: Applicant_Event_Constraint;
  update_columns?: Array<Applicant_Event_Update_Column>;
  where?: InputMaybe<Applicant_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "applicant.event". */
export type Applicant_Event_Order_By = {
  applicant_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: applicant.event */
export type Applicant_Event_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Applicant_Event_Prepend_Input = {
  extra?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "applicant.event" */
export enum Applicant_Event_Select_Column {
  /** column name */
  ApplicantId = 'applicant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Extra = 'extra',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "applicant.event" */
export type Applicant_Event_Set_Input = {
  applicant_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  extra?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Applicant_Event_Stddev_Fields = {
  __typename?: 'applicant_event_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Applicant_Event_Stddev_Pop_Fields = {
  __typename?: 'applicant_event_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Applicant_Event_Stddev_Samp_Fields = {
  __typename?: 'applicant_event_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "applicant_event" */
export type Applicant_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Event_Stream_Cursor_Value_Input = {
  applicant_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  extra?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Applicant_Event_Sum_Fields = {
  __typename?: 'applicant_event_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "applicant.event" */
export enum Applicant_Event_Update_Column {
  /** column name */
  ApplicantId = 'applicant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Extra = 'extra',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Applicant_Event_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Applicant_Event_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Applicant_Event_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Applicant_Event_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Applicant_Event_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Applicant_Event_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Applicant_Event_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Applicant_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Applicant_Event_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Applicant_Event_Var_Pop_Fields = {
  __typename?: 'applicant_event_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Applicant_Event_Var_Samp_Fields = {
  __typename?: 'applicant_event_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Applicant_Event_Variance_Fields = {
  __typename?: 'applicant_event_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "board.column_type" */
export type Board_Column_Type = {
  __typename?: 'board_column_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "board.column_type" */
export type Board_Column_Type_Aggregate = {
  __typename?: 'board_column_type_aggregate';
  aggregate?: Maybe<Board_Column_Type_Aggregate_Fields>;
  nodes: Array<Board_Column_Type>;
};

/** aggregate fields of "board.column_type" */
export type Board_Column_Type_Aggregate_Fields = {
  __typename?: 'board_column_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Board_Column_Type_Max_Fields>;
  min?: Maybe<Board_Column_Type_Min_Fields>;
};


/** aggregate fields of "board.column_type" */
export type Board_Column_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Board_Column_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "board.column_type". All fields are combined with a logical 'AND'. */
export type Board_Column_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Board_Column_Type_Bool_Exp>>;
  _not?: InputMaybe<Board_Column_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Board_Column_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "board.column_type" */
export enum Board_Column_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ColumnTypePkey = 'column_type_pkey'
}

export enum Board_Column_Type_Enum {
  Custom = 'CUSTOM',
  Declined = 'DECLINED',
  ImChatbot = 'IM_CHATBOT',
  NewApplicant = 'NEW_APPLICANT'
}

/** Boolean expression to compare columns of type "board_column_type_enum". All fields are combined with logical 'AND'. */
export type Board_Column_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Board_Column_Type_Enum>;
  _in?: InputMaybe<Array<Board_Column_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Board_Column_Type_Enum>;
  _nin?: InputMaybe<Array<Board_Column_Type_Enum>>;
};

/** input type for inserting data into table "board.column_type" */
export type Board_Column_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Board_Column_Type_Max_Fields = {
  __typename?: 'board_column_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Board_Column_Type_Min_Fields = {
  __typename?: 'board_column_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "board.column_type" */
export type Board_Column_Type_Mutation_Response = {
  __typename?: 'board_column_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Board_Column_Type>;
};

/** input type for inserting object relation for remote table "board.column_type" */
export type Board_Column_Type_Obj_Rel_Insert_Input = {
  data: Board_Column_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Board_Column_Type_On_Conflict>;
};

/** on_conflict condition type for table "board.column_type" */
export type Board_Column_Type_On_Conflict = {
  constraint: Board_Column_Type_Constraint;
  update_columns?: Array<Board_Column_Type_Update_Column>;
  where?: InputMaybe<Board_Column_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "board.column_type". */
export type Board_Column_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: board.column_type */
export type Board_Column_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "board.column_type" */
export enum Board_Column_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "board.column_type" */
export type Board_Column_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "board_column_type" */
export type Board_Column_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Board_Column_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Board_Column_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "board.column_type" */
export enum Board_Column_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Board_Column_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Board_Column_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Board_Column_Type_Bool_Exp;
};

/** columns and relationships of "board.contact_board" */
export type Board_Contact_Board = {
  __typename?: 'board_contact_board';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  /** An array relationship */
  columns: Array<Board_Contact_Board_Column>;
  /** An aggregate relationship */
  columns_aggregate: Board_Contact_Board_Column_Aggregate;
  id: Scalars['uuid']['output'];
};


/** columns and relationships of "board.contact_board" */
export type Board_Contact_BoardColumnsArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Column_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
};


/** columns and relationships of "board.contact_board" */
export type Board_Contact_BoardColumns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Column_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
};

/** aggregated selection of "board.contact_board" */
export type Board_Contact_Board_Aggregate = {
  __typename?: 'board_contact_board_aggregate';
  aggregate?: Maybe<Board_Contact_Board_Aggregate_Fields>;
  nodes: Array<Board_Contact_Board>;
};

/** aggregate fields of "board.contact_board" */
export type Board_Contact_Board_Aggregate_Fields = {
  __typename?: 'board_contact_board_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Board_Contact_Board_Max_Fields>;
  min?: Maybe<Board_Contact_Board_Min_Fields>;
};


/** aggregate fields of "board.contact_board" */
export type Board_Contact_Board_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Board_Contact_Board_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "board.contact_board". All fields are combined with a logical 'AND'. */
export type Board_Contact_Board_Bool_Exp = {
  _and?: InputMaybe<Array<Board_Contact_Board_Bool_Exp>>;
  _not?: InputMaybe<Board_Contact_Board_Bool_Exp>;
  _or?: InputMaybe<Array<Board_Contact_Board_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  columns?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
  columns_aggregate?: InputMaybe<Board_Contact_Board_Column_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "board.contact_board_column" */
export type Board_Contact_Board_Column = {
  __typename?: 'board_contact_board_column';
  board_id: Scalars['uuid']['output'];
  /** An object relationship */
  column_type?: Maybe<Board_Column_Type>;
  /** An object relationship */
  contact_board: Board_Contact_Board;
  /** An array relationship */
  contact_board_entries: Array<Board_Contact_Board_Entry>;
  /** An aggregate relationship */
  contact_board_entries_aggregate: Board_Contact_Board_Entry_Aggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  type?: Maybe<Board_Column_Type_Enum>;
};


/** columns and relationships of "board.contact_board_column" */
export type Board_Contact_Board_ColumnContact_Board_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Entry_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
};


/** columns and relationships of "board.contact_board_column" */
export type Board_Contact_Board_ColumnContact_Board_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Entry_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
};

/** aggregated selection of "board.contact_board_column" */
export type Board_Contact_Board_Column_Aggregate = {
  __typename?: 'board_contact_board_column_aggregate';
  aggregate?: Maybe<Board_Contact_Board_Column_Aggregate_Fields>;
  nodes: Array<Board_Contact_Board_Column>;
};

export type Board_Contact_Board_Column_Aggregate_Bool_Exp = {
  count?: InputMaybe<Board_Contact_Board_Column_Aggregate_Bool_Exp_Count>;
};

export type Board_Contact_Board_Column_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Board_Contact_Board_Column_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "board.contact_board_column" */
export type Board_Contact_Board_Column_Aggregate_Fields = {
  __typename?: 'board_contact_board_column_aggregate_fields';
  avg?: Maybe<Board_Contact_Board_Column_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Board_Contact_Board_Column_Max_Fields>;
  min?: Maybe<Board_Contact_Board_Column_Min_Fields>;
  stddev?: Maybe<Board_Contact_Board_Column_Stddev_Fields>;
  stddev_pop?: Maybe<Board_Contact_Board_Column_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Board_Contact_Board_Column_Stddev_Samp_Fields>;
  sum?: Maybe<Board_Contact_Board_Column_Sum_Fields>;
  var_pop?: Maybe<Board_Contact_Board_Column_Var_Pop_Fields>;
  var_samp?: Maybe<Board_Contact_Board_Column_Var_Samp_Fields>;
  variance?: Maybe<Board_Contact_Board_Column_Variance_Fields>;
};


/** aggregate fields of "board.contact_board_column" */
export type Board_Contact_Board_Column_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Board_Contact_Board_Column_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Aggregate_Order_By = {
  avg?: InputMaybe<Board_Contact_Board_Column_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Board_Contact_Board_Column_Max_Order_By>;
  min?: InputMaybe<Board_Contact_Board_Column_Min_Order_By>;
  stddev?: InputMaybe<Board_Contact_Board_Column_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Board_Contact_Board_Column_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Board_Contact_Board_Column_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Board_Contact_Board_Column_Sum_Order_By>;
  var_pop?: InputMaybe<Board_Contact_Board_Column_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Board_Contact_Board_Column_Var_Samp_Order_By>;
  variance?: InputMaybe<Board_Contact_Board_Column_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "board.contact_board_column" */
export type Board_Contact_Board_Column_Arr_Rel_Insert_Input = {
  data: Array<Board_Contact_Board_Column_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Board_Contact_Board_Column_On_Conflict>;
};

/** aggregate avg on columns */
export type Board_Contact_Board_Column_Avg_Fields = {
  __typename?: 'board_contact_board_column_avg_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Avg_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "board.contact_board_column". All fields are combined with a logical 'AND'. */
export type Board_Contact_Board_Column_Bool_Exp = {
  _and?: InputMaybe<Array<Board_Contact_Board_Column_Bool_Exp>>;
  _not?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
  _or?: InputMaybe<Array<Board_Contact_Board_Column_Bool_Exp>>;
  board_id?: InputMaybe<Uuid_Comparison_Exp>;
  column_type?: InputMaybe<Board_Column_Type_Bool_Exp>;
  contact_board?: InputMaybe<Board_Contact_Board_Bool_Exp>;
  contact_board_entries?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
  contact_board_entries_aggregate?: InputMaybe<Board_Contact_Board_Entry_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  position?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Board_Column_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "board.contact_board_column" */
export enum Board_Contact_Board_Column_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContactBoardColumnPkey = 'contact_board_column_pkey'
}

/** input type for incrementing numeric columns in table "board.contact_board_column" */
export type Board_Contact_Board_Column_Inc_Input = {
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "board.contact_board_column" */
export type Board_Contact_Board_Column_Insert_Input = {
  board_id?: InputMaybe<Scalars['uuid']['input']>;
  column_type?: InputMaybe<Board_Column_Type_Obj_Rel_Insert_Input>;
  contact_board?: InputMaybe<Board_Contact_Board_Obj_Rel_Insert_Input>;
  contact_board_entries?: InputMaybe<Board_Contact_Board_Entry_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Board_Column_Type_Enum>;
};

/** aggregate max on columns */
export type Board_Contact_Board_Column_Max_Fields = {
  __typename?: 'board_contact_board_column_max_fields';
  board_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Max_Order_By = {
  board_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Board_Contact_Board_Column_Min_Fields = {
  __typename?: 'board_contact_board_column_min_fields';
  board_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Min_Order_By = {
  board_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "board.contact_board_column" */
export type Board_Contact_Board_Column_Mutation_Response = {
  __typename?: 'board_contact_board_column_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Board_Contact_Board_Column>;
};

/** on_conflict condition type for table "board.contact_board_column" */
export type Board_Contact_Board_Column_On_Conflict = {
  constraint: Board_Contact_Board_Column_Constraint;
  update_columns?: Array<Board_Contact_Board_Column_Update_Column>;
  where?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
};

/** Ordering options when selecting data from "board.contact_board_column". */
export type Board_Contact_Board_Column_Order_By = {
  board_id?: InputMaybe<Order_By>;
  column_type?: InputMaybe<Board_Column_Type_Order_By>;
  contact_board?: InputMaybe<Board_Contact_Board_Order_By>;
  contact_board_entries_aggregate?: InputMaybe<Board_Contact_Board_Entry_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: board.contact_board_column */
export type Board_Contact_Board_Column_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "board.contact_board_column" */
export enum Board_Contact_Board_Column_Select_Column {
  /** column name */
  BoardId = 'board_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Position = 'position',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "board.contact_board_column" */
export type Board_Contact_Board_Column_Set_Input = {
  board_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Board_Column_Type_Enum>;
};

/** aggregate stddev on columns */
export type Board_Contact_Board_Column_Stddev_Fields = {
  __typename?: 'board_contact_board_column_stddev_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Stddev_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Board_Contact_Board_Column_Stddev_Pop_Fields = {
  __typename?: 'board_contact_board_column_stddev_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Stddev_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Board_Contact_Board_Column_Stddev_Samp_Fields = {
  __typename?: 'board_contact_board_column_stddev_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Stddev_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "board_contact_board_column" */
export type Board_Contact_Board_Column_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Board_Contact_Board_Column_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Board_Contact_Board_Column_Stream_Cursor_Value_Input = {
  board_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Board_Column_Type_Enum>;
};

/** aggregate sum on columns */
export type Board_Contact_Board_Column_Sum_Fields = {
  __typename?: 'board_contact_board_column_sum_fields';
  position?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Sum_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** update columns of table "board.contact_board_column" */
export enum Board_Contact_Board_Column_Update_Column {
  /** column name */
  BoardId = 'board_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Position = 'position',
  /** column name */
  Type = 'type'
}

export type Board_Contact_Board_Column_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Board_Contact_Board_Column_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Board_Contact_Board_Column_Set_Input>;
  /** filter the rows which have to be updated */
  where: Board_Contact_Board_Column_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Board_Contact_Board_Column_Var_Pop_Fields = {
  __typename?: 'board_contact_board_column_var_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Var_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Board_Contact_Board_Column_Var_Samp_Fields = {
  __typename?: 'board_contact_board_column_var_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Var_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Board_Contact_Board_Column_Variance_Fields = {
  __typename?: 'board_contact_board_column_variance_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "board.contact_board_column" */
export type Board_Contact_Board_Column_Variance_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "board.contact_board" */
export enum Board_Contact_Board_Constraint {
  /** unique or primary key constraint on columns "campaign_id" */
  ContactBoardCampaignIdKey = 'contact_board_campaign_id_key',
  /** unique or primary key constraint on columns "id" */
  ContactBoardPkey = 'contact_board_pkey'
}

/** columns and relationships of "board.contact_board_entry" */
export type Board_Contact_Board_Entry = {
  __typename?: 'board_contact_board_entry';
  board_id: Scalars['uuid']['output'];
  column_id: Scalars['uuid']['output'];
  /** An object relationship */
  contact?: Maybe<Contact>;
  /** An object relationship */
  contact_board: Board_Contact_Board;
  contact_id: Scalars['uuid']['output'];
  /** An object relationship */
  forward_log?: Maybe<Rms_Forwarded_Logs>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Board_Note>;
  /** An aggregate relationship */
  notes_aggregate: Board_Note_Aggregate;
  position?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "board.contact_board_entry" */
export type Board_Contact_Board_EntryNotesArgs = {
  distinct_on?: InputMaybe<Array<Board_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Note_Order_By>>;
  where?: InputMaybe<Board_Note_Bool_Exp>;
};


/** columns and relationships of "board.contact_board_entry" */
export type Board_Contact_Board_EntryNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Note_Order_By>>;
  where?: InputMaybe<Board_Note_Bool_Exp>;
};

/** aggregated selection of "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Aggregate = {
  __typename?: 'board_contact_board_entry_aggregate';
  aggregate?: Maybe<Board_Contact_Board_Entry_Aggregate_Fields>;
  nodes: Array<Board_Contact_Board_Entry>;
};

export type Board_Contact_Board_Entry_Aggregate_Bool_Exp = {
  count?: InputMaybe<Board_Contact_Board_Entry_Aggregate_Bool_Exp_Count>;
};

export type Board_Contact_Board_Entry_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Board_Contact_Board_Entry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Aggregate_Fields = {
  __typename?: 'board_contact_board_entry_aggregate_fields';
  avg?: Maybe<Board_Contact_Board_Entry_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Board_Contact_Board_Entry_Max_Fields>;
  min?: Maybe<Board_Contact_Board_Entry_Min_Fields>;
  stddev?: Maybe<Board_Contact_Board_Entry_Stddev_Fields>;
  stddev_pop?: Maybe<Board_Contact_Board_Entry_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Board_Contact_Board_Entry_Stddev_Samp_Fields>;
  sum?: Maybe<Board_Contact_Board_Entry_Sum_Fields>;
  var_pop?: Maybe<Board_Contact_Board_Entry_Var_Pop_Fields>;
  var_samp?: Maybe<Board_Contact_Board_Entry_Var_Samp_Fields>;
  variance?: Maybe<Board_Contact_Board_Entry_Variance_Fields>;
};


/** aggregate fields of "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Board_Contact_Board_Entry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Aggregate_Order_By = {
  avg?: InputMaybe<Board_Contact_Board_Entry_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Board_Contact_Board_Entry_Max_Order_By>;
  min?: InputMaybe<Board_Contact_Board_Entry_Min_Order_By>;
  stddev?: InputMaybe<Board_Contact_Board_Entry_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Board_Contact_Board_Entry_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Board_Contact_Board_Entry_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Board_Contact_Board_Entry_Sum_Order_By>;
  var_pop?: InputMaybe<Board_Contact_Board_Entry_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Board_Contact_Board_Entry_Var_Samp_Order_By>;
  variance?: InputMaybe<Board_Contact_Board_Entry_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Arr_Rel_Insert_Input = {
  data: Array<Board_Contact_Board_Entry_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Board_Contact_Board_Entry_On_Conflict>;
};

/** aggregate avg on columns */
export type Board_Contact_Board_Entry_Avg_Fields = {
  __typename?: 'board_contact_board_entry_avg_fields';
  position?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Avg_Order_By = {
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "board.contact_board_entry". All fields are combined with a logical 'AND'. */
export type Board_Contact_Board_Entry_Bool_Exp = {
  _and?: InputMaybe<Array<Board_Contact_Board_Entry_Bool_Exp>>;
  _not?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
  _or?: InputMaybe<Array<Board_Contact_Board_Entry_Bool_Exp>>;
  board_id?: InputMaybe<Uuid_Comparison_Exp>;
  column_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_board?: InputMaybe<Board_Contact_Board_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  forward_log?: InputMaybe<Rms_Forwarded_Logs_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Board_Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Board_Note_Aggregate_Bool_Exp>;
  position?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "board.contact_board_entry" */
export enum Board_Contact_Board_Entry_Constraint {
  /** unique or primary key constraint on columns "id", "contact_id" */
  ContactBoardEntryIdContactIdIdx = 'contact_board_entry_id_contact_id_idx',
  /** unique or primary key constraint on columns "id" */
  ContactBoardEntryPkey = 'contact_board_entry_pkey'
}

/** input type for incrementing numeric columns in table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Inc_Input = {
  position?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Insert_Input = {
  board_id?: InputMaybe<Scalars['uuid']['input']>;
  column_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_board?: InputMaybe<Board_Contact_Board_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  forward_log?: InputMaybe<Rms_Forwarded_Logs_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Board_Note_Arr_Rel_Insert_Input>;
  position?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Board_Contact_Board_Entry_Max_Fields = {
  __typename?: 'board_contact_board_entry_max_fields';
  board_id?: Maybe<Scalars['uuid']['output']>;
  column_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Max_Order_By = {
  board_id?: InputMaybe<Order_By>;
  column_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Board_Contact_Board_Entry_Min_Fields = {
  __typename?: 'board_contact_board_entry_min_fields';
  board_id?: Maybe<Scalars['uuid']['output']>;
  column_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Min_Order_By = {
  board_id?: InputMaybe<Order_By>;
  column_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Mutation_Response = {
  __typename?: 'board_contact_board_entry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Board_Contact_Board_Entry>;
};

/** input type for inserting object relation for remote table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Obj_Rel_Insert_Input = {
  data: Board_Contact_Board_Entry_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Board_Contact_Board_Entry_On_Conflict>;
};

/** on_conflict condition type for table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_On_Conflict = {
  constraint: Board_Contact_Board_Entry_Constraint;
  update_columns?: Array<Board_Contact_Board_Entry_Update_Column>;
  where?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
};

/** Ordering options when selecting data from "board.contact_board_entry". */
export type Board_Contact_Board_Entry_Order_By = {
  board_id?: InputMaybe<Order_By>;
  column_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_board?: InputMaybe<Board_Contact_Board_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  forward_log?: InputMaybe<Rms_Forwarded_Logs_Order_By>;
  id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Board_Note_Aggregate_Order_By>;
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: board.contact_board_entry */
export type Board_Contact_Board_Entry_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "board.contact_board_entry" */
export enum Board_Contact_Board_Entry_Select_Column {
  /** column name */
  BoardId = 'board_id',
  /** column name */
  ColumnId = 'column_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  Score = 'score',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Set_Input = {
  board_id?: InputMaybe<Scalars['uuid']['input']>;
  column_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Board_Contact_Board_Entry_Stddev_Fields = {
  __typename?: 'board_contact_board_entry_stddev_fields';
  position?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Stddev_Order_By = {
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Board_Contact_Board_Entry_Stddev_Pop_Fields = {
  __typename?: 'board_contact_board_entry_stddev_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Stddev_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Board_Contact_Board_Entry_Stddev_Samp_Fields = {
  __typename?: 'board_contact_board_entry_stddev_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Stddev_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "board_contact_board_entry" */
export type Board_Contact_Board_Entry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Board_Contact_Board_Entry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Board_Contact_Board_Entry_Stream_Cursor_Value_Input = {
  board_id?: InputMaybe<Scalars['uuid']['input']>;
  column_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Board_Contact_Board_Entry_Sum_Fields = {
  __typename?: 'board_contact_board_entry_sum_fields';
  position?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Sum_Order_By = {
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** update columns of table "board.contact_board_entry" */
export enum Board_Contact_Board_Entry_Update_Column {
  /** column name */
  BoardId = 'board_id',
  /** column name */
  ColumnId = 'column_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  Score = 'score',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Board_Contact_Board_Entry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Board_Contact_Board_Entry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Board_Contact_Board_Entry_Set_Input>;
  /** filter the rows which have to be updated */
  where: Board_Contact_Board_Entry_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Board_Contact_Board_Entry_Var_Pop_Fields = {
  __typename?: 'board_contact_board_entry_var_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Var_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Board_Contact_Board_Entry_Var_Samp_Fields = {
  __typename?: 'board_contact_board_entry_var_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Var_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Board_Contact_Board_Entry_Variance_Fields = {
  __typename?: 'board_contact_board_entry_variance_fields';
  position?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "board.contact_board_entry" */
export type Board_Contact_Board_Entry_Variance_Order_By = {
  position?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "board.contact_board" */
export type Board_Contact_Board_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  columns?: InputMaybe<Board_Contact_Board_Column_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Board_Contact_Board_Max_Fields = {
  __typename?: 'board_contact_board_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Board_Contact_Board_Min_Fields = {
  __typename?: 'board_contact_board_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "board.contact_board" */
export type Board_Contact_Board_Mutation_Response = {
  __typename?: 'board_contact_board_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Board_Contact_Board>;
};

/** input type for inserting object relation for remote table "board.contact_board" */
export type Board_Contact_Board_Obj_Rel_Insert_Input = {
  data: Board_Contact_Board_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Board_Contact_Board_On_Conflict>;
};

/** on_conflict condition type for table "board.contact_board" */
export type Board_Contact_Board_On_Conflict = {
  constraint: Board_Contact_Board_Constraint;
  update_columns?: Array<Board_Contact_Board_Update_Column>;
  where?: InputMaybe<Board_Contact_Board_Bool_Exp>;
};

/** Ordering options when selecting data from "board.contact_board". */
export type Board_Contact_Board_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  columns_aggregate?: InputMaybe<Board_Contact_Board_Column_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: board.contact_board */
export type Board_Contact_Board_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "board.contact_board" */
export enum Board_Contact_Board_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "board.contact_board" */
export type Board_Contact_Board_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "board_contact_board" */
export type Board_Contact_Board_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Board_Contact_Board_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Board_Contact_Board_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "board.contact_board" */
export enum Board_Contact_Board_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Id = 'id'
}

export type Board_Contact_Board_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Board_Contact_Board_Set_Input>;
  /** filter the rows which have to be updated */
  where: Board_Contact_Board_Bool_Exp;
};

/** columns and relationships of "board.note" */
export type Board_Note = {
  __typename?: 'board_note';
  author_id: Scalars['String']['output'];
  /** An object relationship */
  contact: Contact;
  /** An object relationship */
  contact_board_entry?: Maybe<Board_Contact_Board_Entry>;
  contact_board_entry_id?: Maybe<Scalars['uuid']['output']>;
  contact_id: Scalars['uuid']['output'];
  content: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "board.note" */
export type Board_Note_Aggregate = {
  __typename?: 'board_note_aggregate';
  aggregate?: Maybe<Board_Note_Aggregate_Fields>;
  nodes: Array<Board_Note>;
};

export type Board_Note_Aggregate_Bool_Exp = {
  count?: InputMaybe<Board_Note_Aggregate_Bool_Exp_Count>;
};

export type Board_Note_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Board_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Board_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "board.note" */
export type Board_Note_Aggregate_Fields = {
  __typename?: 'board_note_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Board_Note_Max_Fields>;
  min?: Maybe<Board_Note_Min_Fields>;
};


/** aggregate fields of "board.note" */
export type Board_Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Board_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "board.note" */
export type Board_Note_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Board_Note_Max_Order_By>;
  min?: InputMaybe<Board_Note_Min_Order_By>;
};

/** input type for inserting array relation for remote table "board.note" */
export type Board_Note_Arr_Rel_Insert_Input = {
  data: Array<Board_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Board_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "board.note". All fields are combined with a logical 'AND'. */
export type Board_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Board_Note_Bool_Exp>>;
  _not?: InputMaybe<Board_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Board_Note_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_board_entry?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
  contact_board_entry_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "board.note" */
export enum Board_Note_Constraint {
  /** unique or primary key constraint on columns "id", "contact_id", "contact_board_entry_id" */
  IdContactIdIdx = 'id_contact_id_idx',
  /** unique or primary key constraint on columns "id" */
  NotePkey = 'note_pkey'
}

/** input type for inserting data into table "board.note" */
export type Board_Note_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_board_entry?: InputMaybe<Board_Contact_Board_Entry_Obj_Rel_Insert_Input>;
  contact_board_entry_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Board_Note_Max_Fields = {
  __typename?: 'board_note_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  contact_board_entry_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "board.note" */
export type Board_Note_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  contact_board_entry_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Board_Note_Min_Fields = {
  __typename?: 'board_note_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  contact_board_entry_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "board.note" */
export type Board_Note_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  contact_board_entry_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "board.note" */
export type Board_Note_Mutation_Response = {
  __typename?: 'board_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Board_Note>;
};

/** on_conflict condition type for table "board.note" */
export type Board_Note_On_Conflict = {
  constraint: Board_Note_Constraint;
  update_columns?: Array<Board_Note_Update_Column>;
  where?: InputMaybe<Board_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "board.note". */
export type Board_Note_Order_By = {
  author_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_board_entry?: InputMaybe<Board_Contact_Board_Entry_Order_By>;
  contact_board_entry_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: board.note */
export type Board_Note_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "board.note" */
export enum Board_Note_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ContactBoardEntryId = 'contact_board_entry_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "board.note" */
export type Board_Note_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  contact_board_entry_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "board_note" */
export type Board_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Board_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Board_Note_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  contact_board_entry_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "board.note" */
export enum Board_Note_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ContactBoardEntryId = 'contact_board_entry_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Board_Note_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Board_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Board_Note_Bool_Exp;
};

/** Someone who can be assigned to a conversation */
export type Bot_Assignee = {
  __typename?: 'bot_assignee';
  value: Scalars['String']['output'];
};

/** aggregated selection of "bot.assignee" */
export type Bot_Assignee_Aggregate = {
  __typename?: 'bot_assignee_aggregate';
  aggregate?: Maybe<Bot_Assignee_Aggregate_Fields>;
  nodes: Array<Bot_Assignee>;
};

/** aggregate fields of "bot.assignee" */
export type Bot_Assignee_Aggregate_Fields = {
  __typename?: 'bot_assignee_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Bot_Assignee_Max_Fields>;
  min?: Maybe<Bot_Assignee_Min_Fields>;
};


/** aggregate fields of "bot.assignee" */
export type Bot_Assignee_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bot_Assignee_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "bot.assignee". All fields are combined with a logical 'AND'. */
export type Bot_Assignee_Bool_Exp = {
  _and?: InputMaybe<Array<Bot_Assignee_Bool_Exp>>;
  _not?: InputMaybe<Bot_Assignee_Bool_Exp>;
  _or?: InputMaybe<Array<Bot_Assignee_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bot.assignee" */
export enum Bot_Assignee_Constraint {
  /** unique or primary key constraint on columns "value" */
  AssigneePkey = 'assignee_pkey'
}

export enum Bot_Assignee_Enum {
  Bot = 'BOT',
  Recruiter = 'RECRUITER'
}

/** Boolean expression to compare columns of type "bot_assignee_enum". All fields are combined with logical 'AND'. */
export type Bot_Assignee_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Bot_Assignee_Enum>;
  _in?: InputMaybe<Array<Bot_Assignee_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Bot_Assignee_Enum>;
  _nin?: InputMaybe<Array<Bot_Assignee_Enum>>;
};

/** input type for inserting data into table "bot.assignee" */
export type Bot_Assignee_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Bot_Assignee_Max_Fields = {
  __typename?: 'bot_assignee_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Bot_Assignee_Min_Fields = {
  __typename?: 'bot_assignee_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "bot.assignee" */
export type Bot_Assignee_Mutation_Response = {
  __typename?: 'bot_assignee_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bot_Assignee>;
};

/** input type for inserting object relation for remote table "bot.assignee" */
export type Bot_Assignee_Obj_Rel_Insert_Input = {
  data: Bot_Assignee_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Bot_Assignee_On_Conflict>;
};

/** on_conflict condition type for table "bot.assignee" */
export type Bot_Assignee_On_Conflict = {
  constraint: Bot_Assignee_Constraint;
  update_columns?: Array<Bot_Assignee_Update_Column>;
  where?: InputMaybe<Bot_Assignee_Bool_Exp>;
};

/** Ordering options when selecting data from "bot.assignee". */
export type Bot_Assignee_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bot.assignee */
export type Bot_Assignee_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "bot.assignee" */
export enum Bot_Assignee_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "bot.assignee" */
export type Bot_Assignee_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "bot_assignee" */
export type Bot_Assignee_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bot_Assignee_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bot_Assignee_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "bot.assignee" */
export enum Bot_Assignee_Update_Column {
  /** column name */
  Value = 'value'
}

export type Bot_Assignee_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bot_Assignee_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bot_Assignee_Bool_Exp;
};

/** columns and relationships of "bot.channel" */
export type Bot_Channel = {
  __typename?: 'bot_channel';
  value: Scalars['String']['output'];
};

/** aggregated selection of "bot.channel" */
export type Bot_Channel_Aggregate = {
  __typename?: 'bot_channel_aggregate';
  aggregate?: Maybe<Bot_Channel_Aggregate_Fields>;
  nodes: Array<Bot_Channel>;
};

/** aggregate fields of "bot.channel" */
export type Bot_Channel_Aggregate_Fields = {
  __typename?: 'bot_channel_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Bot_Channel_Max_Fields>;
  min?: Maybe<Bot_Channel_Min_Fields>;
};


/** aggregate fields of "bot.channel" */
export type Bot_Channel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bot_Channel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "bot.channel". All fields are combined with a logical 'AND'. */
export type Bot_Channel_Bool_Exp = {
  _and?: InputMaybe<Array<Bot_Channel_Bool_Exp>>;
  _not?: InputMaybe<Bot_Channel_Bool_Exp>;
  _or?: InputMaybe<Array<Bot_Channel_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bot.channel" */
export enum Bot_Channel_Constraint {
  /** unique or primary key constraint on columns "value" */
  ChannelPkey = 'channel_pkey'
}

export enum Bot_Channel_Enum {
  Whatsapp = 'WHATSAPP'
}

/** Boolean expression to compare columns of type "bot_channel_enum". All fields are combined with logical 'AND'. */
export type Bot_Channel_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Bot_Channel_Enum>;
  _in?: InputMaybe<Array<Bot_Channel_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Bot_Channel_Enum>;
  _nin?: InputMaybe<Array<Bot_Channel_Enum>>;
};

/** input type for inserting data into table "bot.channel" */
export type Bot_Channel_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Bot_Channel_Max_Fields = {
  __typename?: 'bot_channel_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Bot_Channel_Min_Fields = {
  __typename?: 'bot_channel_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "bot.channel" */
export type Bot_Channel_Mutation_Response = {
  __typename?: 'bot_channel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bot_Channel>;
};

/** on_conflict condition type for table "bot.channel" */
export type Bot_Channel_On_Conflict = {
  constraint: Bot_Channel_Constraint;
  update_columns?: Array<Bot_Channel_Update_Column>;
  where?: InputMaybe<Bot_Channel_Bool_Exp>;
};

/** Ordering options when selecting data from "bot.channel". */
export type Bot_Channel_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bot.channel */
export type Bot_Channel_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "bot.channel" */
export enum Bot_Channel_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "bot.channel" */
export type Bot_Channel_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "bot_channel" */
export type Bot_Channel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bot_Channel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bot_Channel_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "bot.channel" */
export enum Bot_Channel_Update_Column {
  /** column name */
  Value = 'value'
}

export type Bot_Channel_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bot_Channel_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bot_Channel_Bool_Exp;
};

/** columns and relationships of "bot.conversation" */
export type Bot_Conversation = {
  __typename?: 'bot_conversation';
  assigned: Bot_Assignee_Enum;
  /** An object relationship */
  assignee: Bot_Assignee;
  channel: Bot_Channel_Enum;
  channel_specific_id: Scalars['String']['output'];
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  contact: Contact;
  contact_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  invalid_reason?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  messages: Array<Bot_Message>;
  /** An aggregate relationship */
  messages_aggregate: Bot_Message_Aggregate;
  start_attempts: Scalars['Int']['output'];
  started_at: Scalars['timestamp']['output'];
  state: Bot_Conversation_State_Enum;
};


/** columns and relationships of "bot.conversation" */
export type Bot_ConversationMessagesArgs = {
  distinct_on?: InputMaybe<Array<Bot_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Message_Order_By>>;
  where?: InputMaybe<Bot_Message_Bool_Exp>;
};


/** columns and relationships of "bot.conversation" */
export type Bot_ConversationMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Message_Order_By>>;
  where?: InputMaybe<Bot_Message_Bool_Exp>;
};

/** aggregated selection of "bot.conversation" */
export type Bot_Conversation_Aggregate = {
  __typename?: 'bot_conversation_aggregate';
  aggregate?: Maybe<Bot_Conversation_Aggregate_Fields>;
  nodes: Array<Bot_Conversation>;
};

/** aggregate fields of "bot.conversation" */
export type Bot_Conversation_Aggregate_Fields = {
  __typename?: 'bot_conversation_aggregate_fields';
  avg?: Maybe<Bot_Conversation_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Bot_Conversation_Max_Fields>;
  min?: Maybe<Bot_Conversation_Min_Fields>;
  stddev?: Maybe<Bot_Conversation_Stddev_Fields>;
  stddev_pop?: Maybe<Bot_Conversation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bot_Conversation_Stddev_Samp_Fields>;
  sum?: Maybe<Bot_Conversation_Sum_Fields>;
  var_pop?: Maybe<Bot_Conversation_Var_Pop_Fields>;
  var_samp?: Maybe<Bot_Conversation_Var_Samp_Fields>;
  variance?: Maybe<Bot_Conversation_Variance_Fields>;
};


/** aggregate fields of "bot.conversation" */
export type Bot_Conversation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bot_Conversation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Bot_Conversation_Avg_Fields = {
  __typename?: 'bot_conversation_avg_fields';
  start_attempts?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "bot.conversation". All fields are combined with a logical 'AND'. */
export type Bot_Conversation_Bool_Exp = {
  _and?: InputMaybe<Array<Bot_Conversation_Bool_Exp>>;
  _not?: InputMaybe<Bot_Conversation_Bool_Exp>;
  _or?: InputMaybe<Array<Bot_Conversation_Bool_Exp>>;
  assigned?: InputMaybe<Bot_Assignee_Enum_Comparison_Exp>;
  assignee?: InputMaybe<Bot_Assignee_Bool_Exp>;
  channel?: InputMaybe<Bot_Channel_Enum_Comparison_Exp>;
  channel_specific_id?: InputMaybe<String_Comparison_Exp>;
  closed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invalid_reason?: InputMaybe<String_Comparison_Exp>;
  messages?: InputMaybe<Bot_Message_Bool_Exp>;
  messages_aggregate?: InputMaybe<Bot_Message_Aggregate_Bool_Exp>;
  start_attempts?: InputMaybe<Int_Comparison_Exp>;
  started_at?: InputMaybe<Timestamp_Comparison_Exp>;
  state?: InputMaybe<Bot_Conversation_State_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "bot.conversation" */
export enum Bot_Conversation_Constraint {
  /** unique or primary key constraint on columns "contact_id", "channel_specific_id", "channel" */
  ConversationChannelSpecificIdChannelContactIdKey = 'conversation_channel_specific_id_channel_contact_id_key',
  /** unique or primary key constraint on columns "id" */
  ConversationPkey = 'conversation_pkey',
  /** unique or primary key constraint on columns "id", "contact_id" */
  IdContactIdIdx = 'id_contact_id_idx'
}

/** input type for incrementing numeric columns in table "bot.conversation" */
export type Bot_Conversation_Inc_Input = {
  start_attempts?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "bot.conversation" */
export type Bot_Conversation_Insert_Input = {
  assigned?: InputMaybe<Bot_Assignee_Enum>;
  assignee?: InputMaybe<Bot_Assignee_Obj_Rel_Insert_Input>;
  channel?: InputMaybe<Bot_Channel_Enum>;
  channel_specific_id?: InputMaybe<Scalars['String']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid_reason?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Bot_Message_Arr_Rel_Insert_Input>;
  start_attempts?: InputMaybe<Scalars['Int']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  state?: InputMaybe<Bot_Conversation_State_Enum>;
};

/** aggregate max on columns */
export type Bot_Conversation_Max_Fields = {
  __typename?: 'bot_conversation_max_fields';
  channel_specific_id?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invalid_reason?: Maybe<Scalars['String']['output']>;
  start_attempts?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Bot_Conversation_Min_Fields = {
  __typename?: 'bot_conversation_min_fields';
  channel_specific_id?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invalid_reason?: Maybe<Scalars['String']['output']>;
  start_attempts?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "bot.conversation" */
export type Bot_Conversation_Mutation_Response = {
  __typename?: 'bot_conversation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bot_Conversation>;
};

/** input type for inserting object relation for remote table "bot.conversation" */
export type Bot_Conversation_Obj_Rel_Insert_Input = {
  data: Bot_Conversation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Bot_Conversation_On_Conflict>;
};

/** on_conflict condition type for table "bot.conversation" */
export type Bot_Conversation_On_Conflict = {
  constraint: Bot_Conversation_Constraint;
  update_columns?: Array<Bot_Conversation_Update_Column>;
  where?: InputMaybe<Bot_Conversation_Bool_Exp>;
};

/** Ordering options when selecting data from "bot.conversation". */
export type Bot_Conversation_Order_By = {
  assigned?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Bot_Assignee_Order_By>;
  channel?: InputMaybe<Order_By>;
  channel_specific_id?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalid_reason?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Bot_Message_Aggregate_Order_By>;
  start_attempts?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bot.conversation */
export type Bot_Conversation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "bot.conversation" */
export enum Bot_Conversation_Select_Column {
  /** column name */
  Assigned = 'assigned',
  /** column name */
  Channel = 'channel',
  /** column name */
  ChannelSpecificId = 'channel_specific_id',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidReason = 'invalid_reason',
  /** column name */
  StartAttempts = 'start_attempts',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "bot.conversation" */
export type Bot_Conversation_Set_Input = {
  assigned?: InputMaybe<Bot_Assignee_Enum>;
  channel?: InputMaybe<Bot_Channel_Enum>;
  channel_specific_id?: InputMaybe<Scalars['String']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid_reason?: InputMaybe<Scalars['String']['input']>;
  start_attempts?: InputMaybe<Scalars['Int']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  state?: InputMaybe<Bot_Conversation_State_Enum>;
};

/** The state of a conversation */
export type Bot_Conversation_State = {
  __typename?: 'bot_conversation_state';
  value: Scalars['String']['output'];
};

/** aggregated selection of "bot.conversation_state" */
export type Bot_Conversation_State_Aggregate = {
  __typename?: 'bot_conversation_state_aggregate';
  aggregate?: Maybe<Bot_Conversation_State_Aggregate_Fields>;
  nodes: Array<Bot_Conversation_State>;
};

/** aggregate fields of "bot.conversation_state" */
export type Bot_Conversation_State_Aggregate_Fields = {
  __typename?: 'bot_conversation_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Bot_Conversation_State_Max_Fields>;
  min?: Maybe<Bot_Conversation_State_Min_Fields>;
};


/** aggregate fields of "bot.conversation_state" */
export type Bot_Conversation_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bot_Conversation_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "bot.conversation_state". All fields are combined with a logical 'AND'. */
export type Bot_Conversation_State_Bool_Exp = {
  _and?: InputMaybe<Array<Bot_Conversation_State_Bool_Exp>>;
  _not?: InputMaybe<Bot_Conversation_State_Bool_Exp>;
  _or?: InputMaybe<Array<Bot_Conversation_State_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bot.conversation_state" */
export enum Bot_Conversation_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  ConversationStatePkey = 'conversation_state_pkey'
}

export enum Bot_Conversation_State_Enum {
  Closed = 'CLOSED',
  Invalid = 'INVALID',
  Open = 'OPEN',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "bot_conversation_state_enum". All fields are combined with logical 'AND'. */
export type Bot_Conversation_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Bot_Conversation_State_Enum>;
  _in?: InputMaybe<Array<Bot_Conversation_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Bot_Conversation_State_Enum>;
  _nin?: InputMaybe<Array<Bot_Conversation_State_Enum>>;
};

/** input type for inserting data into table "bot.conversation_state" */
export type Bot_Conversation_State_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Bot_Conversation_State_Max_Fields = {
  __typename?: 'bot_conversation_state_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Bot_Conversation_State_Min_Fields = {
  __typename?: 'bot_conversation_state_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "bot.conversation_state" */
export type Bot_Conversation_State_Mutation_Response = {
  __typename?: 'bot_conversation_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bot_Conversation_State>;
};

/** on_conflict condition type for table "bot.conversation_state" */
export type Bot_Conversation_State_On_Conflict = {
  constraint: Bot_Conversation_State_Constraint;
  update_columns?: Array<Bot_Conversation_State_Update_Column>;
  where?: InputMaybe<Bot_Conversation_State_Bool_Exp>;
};

/** Ordering options when selecting data from "bot.conversation_state". */
export type Bot_Conversation_State_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bot.conversation_state */
export type Bot_Conversation_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "bot.conversation_state" */
export enum Bot_Conversation_State_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "bot.conversation_state" */
export type Bot_Conversation_State_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "bot_conversation_state" */
export type Bot_Conversation_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bot_Conversation_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bot_Conversation_State_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "bot.conversation_state" */
export enum Bot_Conversation_State_Update_Column {
  /** column name */
  Value = 'value'
}

export type Bot_Conversation_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bot_Conversation_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bot_Conversation_State_Bool_Exp;
};

/** aggregate stddev on columns */
export type Bot_Conversation_Stddev_Fields = {
  __typename?: 'bot_conversation_stddev_fields';
  start_attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Bot_Conversation_Stddev_Pop_Fields = {
  __typename?: 'bot_conversation_stddev_pop_fields';
  start_attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Bot_Conversation_Stddev_Samp_Fields = {
  __typename?: 'bot_conversation_stddev_samp_fields';
  start_attempts?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "bot_conversation" */
export type Bot_Conversation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bot_Conversation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bot_Conversation_Stream_Cursor_Value_Input = {
  assigned?: InputMaybe<Bot_Assignee_Enum>;
  channel?: InputMaybe<Bot_Channel_Enum>;
  channel_specific_id?: InputMaybe<Scalars['String']['input']>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid_reason?: InputMaybe<Scalars['String']['input']>;
  start_attempts?: InputMaybe<Scalars['Int']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  state?: InputMaybe<Bot_Conversation_State_Enum>;
};

/** aggregate sum on columns */
export type Bot_Conversation_Sum_Fields = {
  __typename?: 'bot_conversation_sum_fields';
  start_attempts?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "bot.conversation" */
export enum Bot_Conversation_Update_Column {
  /** column name */
  Assigned = 'assigned',
  /** column name */
  Channel = 'channel',
  /** column name */
  ChannelSpecificId = 'channel_specific_id',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidReason = 'invalid_reason',
  /** column name */
  StartAttempts = 'start_attempts',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  State = 'state'
}

export type Bot_Conversation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bot_Conversation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bot_Conversation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bot_Conversation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bot_Conversation_Var_Pop_Fields = {
  __typename?: 'bot_conversation_var_pop_fields';
  start_attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Bot_Conversation_Var_Samp_Fields = {
  __typename?: 'bot_conversation_var_samp_fields';
  start_attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Bot_Conversation_Variance_Fields = {
  __typename?: 'bot_conversation_variance_fields';
  start_attempts?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "bot.message" */
export type Bot_Message = {
  __typename?: 'bot_message';
  /** An object relationship */
  conversation: Bot_Conversation;
  conversation_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  sent_at: Scalars['timestamptz']['output'];
  sent_by: Bot_Sender_Enum;
  status: Bot_Message_Status_Enum;
  text: Scalars['String']['output'];
};

/** aggregated selection of "bot.message" */
export type Bot_Message_Aggregate = {
  __typename?: 'bot_message_aggregate';
  aggregate?: Maybe<Bot_Message_Aggregate_Fields>;
  nodes: Array<Bot_Message>;
};

export type Bot_Message_Aggregate_Bool_Exp = {
  count?: InputMaybe<Bot_Message_Aggregate_Bool_Exp_Count>;
};

export type Bot_Message_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Bot_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Bot_Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "bot.message" */
export type Bot_Message_Aggregate_Fields = {
  __typename?: 'bot_message_aggregate_fields';
  avg?: Maybe<Bot_Message_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Bot_Message_Max_Fields>;
  min?: Maybe<Bot_Message_Min_Fields>;
  stddev?: Maybe<Bot_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Bot_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bot_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Bot_Message_Sum_Fields>;
  var_pop?: Maybe<Bot_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Bot_Message_Var_Samp_Fields>;
  variance?: Maybe<Bot_Message_Variance_Fields>;
};


/** aggregate fields of "bot.message" */
export type Bot_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bot_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "bot.message" */
export type Bot_Message_Aggregate_Order_By = {
  avg?: InputMaybe<Bot_Message_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bot_Message_Max_Order_By>;
  min?: InputMaybe<Bot_Message_Min_Order_By>;
  stddev?: InputMaybe<Bot_Message_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bot_Message_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bot_Message_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bot_Message_Sum_Order_By>;
  var_pop?: InputMaybe<Bot_Message_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bot_Message_Var_Samp_Order_By>;
  variance?: InputMaybe<Bot_Message_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bot.message" */
export type Bot_Message_Arr_Rel_Insert_Input = {
  data: Array<Bot_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Bot_Message_On_Conflict>;
};

/** aggregate avg on columns */
export type Bot_Message_Avg_Fields = {
  __typename?: 'bot_message_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "bot.message" */
export type Bot_Message_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bot.message". All fields are combined with a logical 'AND'. */
export type Bot_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Bot_Message_Bool_Exp>>;
  _not?: InputMaybe<Bot_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Bot_Message_Bool_Exp>>;
  conversation?: InputMaybe<Bot_Conversation_Bool_Exp>;
  conversation_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sent_by?: InputMaybe<Bot_Sender_Enum_Comparison_Exp>;
  status?: InputMaybe<Bot_Message_Status_Enum_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bot.message" */
export enum Bot_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagePkey = 'message_pkey'
}

/** input type for incrementing numeric columns in table "bot.message" */
export type Bot_Message_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "bot.message" */
export type Bot_Message_Insert_Input = {
  conversation?: InputMaybe<Bot_Conversation_Obj_Rel_Insert_Input>;
  conversation_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_by?: InputMaybe<Bot_Sender_Enum>;
  status?: InputMaybe<Bot_Message_Status_Enum>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Bot_Message_Max_Fields = {
  __typename?: 'bot_message_max_fields';
  conversation_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "bot.message" */
export type Bot_Message_Max_Order_By = {
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Bot_Message_Min_Fields = {
  __typename?: 'bot_message_min_fields';
  conversation_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "bot.message" */
export type Bot_Message_Min_Order_By = {
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "bot.message" */
export type Bot_Message_Mutation_Response = {
  __typename?: 'bot_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bot_Message>;
};

/** on_conflict condition type for table "bot.message" */
export type Bot_Message_On_Conflict = {
  constraint: Bot_Message_Constraint;
  update_columns?: Array<Bot_Message_Update_Column>;
  where?: InputMaybe<Bot_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "bot.message". */
export type Bot_Message_Order_By = {
  conversation?: InputMaybe<Bot_Conversation_Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  sent_by?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bot.message */
export type Bot_Message_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "bot.message" */
export enum Bot_Message_Select_Column {
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  SentBy = 'sent_by',
  /** column name */
  Status = 'status',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "bot.message" */
export type Bot_Message_Set_Input = {
  conversation_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_by?: InputMaybe<Bot_Sender_Enum>;
  status?: InputMaybe<Bot_Message_Status_Enum>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "bot.message_status" */
export type Bot_Message_Status = {
  __typename?: 'bot_message_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "bot.message_status" */
export type Bot_Message_Status_Aggregate = {
  __typename?: 'bot_message_status_aggregate';
  aggregate?: Maybe<Bot_Message_Status_Aggregate_Fields>;
  nodes: Array<Bot_Message_Status>;
};

/** aggregate fields of "bot.message_status" */
export type Bot_Message_Status_Aggregate_Fields = {
  __typename?: 'bot_message_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Bot_Message_Status_Max_Fields>;
  min?: Maybe<Bot_Message_Status_Min_Fields>;
};


/** aggregate fields of "bot.message_status" */
export type Bot_Message_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bot_Message_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "bot.message_status". All fields are combined with a logical 'AND'. */
export type Bot_Message_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Bot_Message_Status_Bool_Exp>>;
  _not?: InputMaybe<Bot_Message_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Bot_Message_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bot.message_status" */
export enum Bot_Message_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  MessageStatusPkey = 'message_status_pkey'
}

export enum Bot_Message_Status_Enum {
  Deleted = 'DELETED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Read = 'READ',
  Sent = 'SENT'
}

/** Boolean expression to compare columns of type "bot_message_status_enum". All fields are combined with logical 'AND'. */
export type Bot_Message_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Bot_Message_Status_Enum>;
  _in?: InputMaybe<Array<Bot_Message_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Bot_Message_Status_Enum>;
  _nin?: InputMaybe<Array<Bot_Message_Status_Enum>>;
};

/** input type for inserting data into table "bot.message_status" */
export type Bot_Message_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Bot_Message_Status_Max_Fields = {
  __typename?: 'bot_message_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Bot_Message_Status_Min_Fields = {
  __typename?: 'bot_message_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "bot.message_status" */
export type Bot_Message_Status_Mutation_Response = {
  __typename?: 'bot_message_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bot_Message_Status>;
};

/** on_conflict condition type for table "bot.message_status" */
export type Bot_Message_Status_On_Conflict = {
  constraint: Bot_Message_Status_Constraint;
  update_columns?: Array<Bot_Message_Status_Update_Column>;
  where?: InputMaybe<Bot_Message_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "bot.message_status". */
export type Bot_Message_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bot.message_status */
export type Bot_Message_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "bot.message_status" */
export enum Bot_Message_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "bot.message_status" */
export type Bot_Message_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "bot_message_status" */
export type Bot_Message_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bot_Message_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bot_Message_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "bot.message_status" */
export enum Bot_Message_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Bot_Message_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bot_Message_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bot_Message_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Bot_Message_Stddev_Fields = {
  __typename?: 'bot_message_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "bot.message" */
export type Bot_Message_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bot_Message_Stddev_Pop_Fields = {
  __typename?: 'bot_message_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "bot.message" */
export type Bot_Message_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bot_Message_Stddev_Samp_Fields = {
  __typename?: 'bot_message_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "bot.message" */
export type Bot_Message_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "bot_message" */
export type Bot_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bot_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bot_Message_Stream_Cursor_Value_Input = {
  conversation_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_by?: InputMaybe<Bot_Sender_Enum>;
  status?: InputMaybe<Bot_Message_Status_Enum>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Bot_Message_Sum_Fields = {
  __typename?: 'bot_message_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "bot.message" */
export type Bot_Message_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "bot.message" */
export enum Bot_Message_Update_Column {
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  SentBy = 'sent_by',
  /** column name */
  Status = 'status',
  /** column name */
  Text = 'text'
}

export type Bot_Message_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bot_Message_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bot_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bot_Message_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bot_Message_Var_Pop_Fields = {
  __typename?: 'bot_message_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "bot.message" */
export type Bot_Message_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bot_Message_Var_Samp_Fields = {
  __typename?: 'bot_message_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "bot.message" */
export type Bot_Message_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Bot_Message_Variance_Fields = {
  __typename?: 'bot_message_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "bot.message" */
export type Bot_Message_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "bot.sender" */
export type Bot_Sender = {
  __typename?: 'bot_sender';
  value: Scalars['String']['output'];
};

/** aggregated selection of "bot.sender" */
export type Bot_Sender_Aggregate = {
  __typename?: 'bot_sender_aggregate';
  aggregate?: Maybe<Bot_Sender_Aggregate_Fields>;
  nodes: Array<Bot_Sender>;
};

/** aggregate fields of "bot.sender" */
export type Bot_Sender_Aggregate_Fields = {
  __typename?: 'bot_sender_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Bot_Sender_Max_Fields>;
  min?: Maybe<Bot_Sender_Min_Fields>;
};


/** aggregate fields of "bot.sender" */
export type Bot_Sender_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bot_Sender_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "bot.sender". All fields are combined with a logical 'AND'. */
export type Bot_Sender_Bool_Exp = {
  _and?: InputMaybe<Array<Bot_Sender_Bool_Exp>>;
  _not?: InputMaybe<Bot_Sender_Bool_Exp>;
  _or?: InputMaybe<Array<Bot_Sender_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bot.sender" */
export enum Bot_Sender_Constraint {
  /** unique or primary key constraint on columns "value" */
  SenderPkey = 'sender_pkey'
}

export enum Bot_Sender_Enum {
  Applicant = 'APPLICANT',
  Bot = 'BOT',
  Recruiter = 'RECRUITER'
}

/** Boolean expression to compare columns of type "bot_sender_enum". All fields are combined with logical 'AND'. */
export type Bot_Sender_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Bot_Sender_Enum>;
  _in?: InputMaybe<Array<Bot_Sender_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Bot_Sender_Enum>;
  _nin?: InputMaybe<Array<Bot_Sender_Enum>>;
};

/** input type for inserting data into table "bot.sender" */
export type Bot_Sender_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Bot_Sender_Max_Fields = {
  __typename?: 'bot_sender_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Bot_Sender_Min_Fields = {
  __typename?: 'bot_sender_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "bot.sender" */
export type Bot_Sender_Mutation_Response = {
  __typename?: 'bot_sender_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bot_Sender>;
};

/** on_conflict condition type for table "bot.sender" */
export type Bot_Sender_On_Conflict = {
  constraint: Bot_Sender_Constraint;
  update_columns?: Array<Bot_Sender_Update_Column>;
  where?: InputMaybe<Bot_Sender_Bool_Exp>;
};

/** Ordering options when selecting data from "bot.sender". */
export type Bot_Sender_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bot.sender */
export type Bot_Sender_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "bot.sender" */
export enum Bot_Sender_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "bot.sender" */
export type Bot_Sender_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "bot_sender" */
export type Bot_Sender_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bot_Sender_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bot_Sender_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "bot.sender" */
export enum Bot_Sender_Update_Column {
  /** column name */
  Value = 'value'
}

export type Bot_Sender_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bot_Sender_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bot_Sender_Bool_Exp;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']['input']>;
  _gt?: InputMaybe<Scalars['bpchar']['input']>;
  _gte?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']['input']>;
  _in?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']['input']>;
  _lt?: InputMaybe<Scalars['bpchar']['input']>;
  _lte?: InputMaybe<Scalars['bpchar']['input']>;
  _neq?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']['input']>;
};

/** columns and relationships of "campaign" */
export type Campaign = {
  __typename?: 'campaign';
  /** An array relationship */
  ad_campaign_metrics: Array<Ad_Campaign_Metrics>;
  /** An aggregate relationship */
  ad_campaign_metrics_aggregate: Ad_Campaign_Metrics_Aggregate;
  /** An array relationship */
  ads: Array<Campaign_Ad>;
  /** An aggregate relationship */
  ads_aggregate: Campaign_Ad_Aggregate;
  ads_email_list: Array<Scalars['String']['output']>;
  applicant_board_enabled: Scalars['Boolean']['output'];
  applicants_email_list: Array<Scalars['String']['output']>;
  bot_consent?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  c_location?: Maybe<Organization_Location>;
  /** An array relationship */
  call_campaign: Array<Anna_Ai_Call_Campaigns>;
  /** An aggregate relationship */
  call_campaign_aggregate: Anna_Ai_Call_Campaigns_Aggregate;
  /** An array relationship */
  campaign_events: Array<Campaign_Event_Log>;
  /** An aggregate relationship */
  campaign_events_aggregate: Campaign_Event_Log_Aggregate;
  /** An object relationship */
  campaign_status?: Maybe<Campaign_Status>;
  /** An object relationship */
  campaign_work_location?: Maybe<Campaign_Work_Location>;
  category?: Maybe<Scalars['String']['output']>;
  chat_bot_enabled: Scalars['Boolean']['output'];
  chat_bot_is_ko: Scalars['Boolean']['output'];
  chat_bot_v2_enabled: Scalars['Boolean']['output'];
  /** An array relationship */
  contacts: Array<Contact>;
  /** An aggregate relationship */
  contacts_aggregate: Contact_Aggregate;
  /** An array relationship */
  contacts_per_day: Array<New_Contacts_Per_Day>;
  /** An aggregate relationship */
  contacts_per_day_aggregate: New_Contacts_Per_Day_Aggregate;
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget: Scalars['numeric']['output'];
  daily_media_budget?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  email_template_overwrite?: Maybe<Campaign_Email_Template_Overwrite>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  forwarding?: Maybe<Chat_Bot_Forwarding>;
  /** An object relationship */
  funnel?: Maybe<Funnel_Funnels>;
  /** An object relationship */
  funnel_insights?: Maybe<Funnel_Insights>;
  /** An array relationship */
  funnel_page_insights: Array<Funnel_Page_Insights>;
  /** An aggregate relationship */
  funnel_page_insights_aggregate: Funnel_Page_Insights_Aggregate;
  /** An array relationship */
  funnel_whatsapp_share_clicks: Array<Funnel_Whatsapp_Share_Clicks>;
  /** An aggregate relationship */
  funnel_whatsapp_share_clicks_aggregate: Funnel_Whatsapp_Share_Clicks_Aggregate;
  id: Scalars['uuid']['output'];
  is_hidden: Scalars['Boolean']['output'];
  is_test: Scalars['Boolean']['output'];
  job_posting_text?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  location_slug?: Maybe<Scalars['String']['output']>;
  margin_in_percent: Scalars['float8']['output'];
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  meistertask_url?: Maybe<Scalars['String']['output']>;
  monday_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  org_settings_override?: Maybe<Campaign_Settings_Override>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['String']['output'];
  /** An array relationship */
  origin_contacts: Array<Contact>;
  /** An aggregate relationship */
  origin_contacts_aggregate: Contact_Aggregate;
  pdf_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  perspective_campaign?: Maybe<Perspective_Campaign>;
  perspective_campaign_id?: Maybe<Scalars['String']['output']>;
  phone_number_default_region: Campaign_Iso_2_Country_Codes_Enum;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  questions: Array<Funnel_Question>;
  /** An aggregate relationship */
  questions_aggregate: Funnel_Question_Aggregate;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
  responsible_person?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  rms_connector?: Maybe<Rms_Connectors>;
  /** An object relationship */
  routing_info?: Maybe<Campaign_Routing_Info>;
  short_id: Scalars['bpchar']['output'];
  start?: Maybe<Scalars['timestamptz']['output']>;
  /** Stored campaign status (DRAFT, ACTIVE, PAUSED, FINISHED). Maintained from dates, status_override, and linked ad status. */
  status?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  status_log: Array<Campaign_Status_Log>;
  /** An aggregate relationship */
  status_log_aggregate: Campaign_Status_Log_Aggregate;
  /** Can be used to manually override the campaign status to set the campaign to paused/finished */
  status_override?: Maybe<Campaign_Status_Enum>;
  support_email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  transactions: Array<Campaign_Budget_Transaction>;
  /** An aggregate relationship */
  transactions_aggregate: Campaign_Budget_Transaction_Aggregate;
  /** An array relationship */
  unqualified_contacts_per_day: Array<New_Unqualified_Contacts_Per_Day>;
  /** An aggregate relationship */
  unqualified_contacts_per_day_aggregate: New_Unqualified_Contacts_Per_Day_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  work_location?: Maybe<Campaign_Work_Location_Enum>;
};


/** columns and relationships of "campaign" */
export type CampaignAd_Campaign_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Metrics_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignAd_Campaign_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Metrics_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignAdsArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Ad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Ad_Order_By>>;
  where?: InputMaybe<Campaign_Ad_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignAds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Ad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Ad_Order_By>>;
  where?: InputMaybe<Campaign_Ad_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignCall_CampaignArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Order_By>>;
  where?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignCall_Campaign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Order_By>>;
  where?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignCampaign_EventsArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Event_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Event_Log_Order_By>>;
  where?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignCampaign_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Event_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Event_Log_Order_By>>;
  where?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignContactsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignContacts_Per_DayArgs = {
  distinct_on?: InputMaybe<Array<New_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Contacts_Per_Day_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignContacts_Per_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<New_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Contacts_Per_Day_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignFunnel_Page_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Page_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignFunnel_Page_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Page_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignFunnel_Whatsapp_Share_ClicksArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Order_By>>;
  where?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignFunnel_Whatsapp_Share_Clicks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Order_By>>;
  where?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignOrigin_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignOrigin_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Order_By>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Order_By>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignStatus_LogArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Log_Order_By>>;
  where?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignStatus_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Log_Order_By>>;
  where?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Transaction_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Transaction_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignUnqualified_Contacts_Per_DayArgs = {
  distinct_on?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Unqualified_Contacts_Per_Day_Bool_Exp>;
};


/** columns and relationships of "campaign" */
export type CampaignUnqualified_Contacts_Per_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Unqualified_Contacts_Per_Day_Bool_Exp>;
};

/** columns and relationships of "campaign.ad" */
export type Campaign_Ad = {
  __typename?: 'campaign_ad';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creative: Ad_Creative;
  creative_id: Scalars['uuid']['output'];
  /** An array relationship */
  creatives_history: Array<Ad_Creative>;
  /** An aggregate relationship */
  creatives_history_aggregate: Ad_Creative_Aggregate;
  id: Scalars['uuid']['output'];
  platform: Ad_Platform_Enum;
  status: Ad_Status_Enum;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "campaign.ad" */
export type Campaign_AdCreatives_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Order_By>>;
  where?: InputMaybe<Ad_Creative_Bool_Exp>;
};


/** columns and relationships of "campaign.ad" */
export type Campaign_AdCreatives_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Order_By>>;
  where?: InputMaybe<Ad_Creative_Bool_Exp>;
};

/** aggregated selection of "campaign.ad" */
export type Campaign_Ad_Aggregate = {
  __typename?: 'campaign_ad_aggregate';
  aggregate?: Maybe<Campaign_Ad_Aggregate_Fields>;
  nodes: Array<Campaign_Ad>;
};

export type Campaign_Ad_Aggregate_Bool_Exp = {
  count?: InputMaybe<Campaign_Ad_Aggregate_Bool_Exp_Count>;
};

export type Campaign_Ad_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Campaign_Ad_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Ad_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "campaign.ad" */
export type Campaign_Ad_Aggregate_Fields = {
  __typename?: 'campaign_ad_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Ad_Max_Fields>;
  min?: Maybe<Campaign_Ad_Min_Fields>;
};


/** aggregate fields of "campaign.ad" */
export type Campaign_Ad_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Ad_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "campaign.ad" */
export type Campaign_Ad_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Campaign_Ad_Max_Order_By>;
  min?: InputMaybe<Campaign_Ad_Min_Order_By>;
};

/** input type for inserting array relation for remote table "campaign.ad" */
export type Campaign_Ad_Arr_Rel_Insert_Input = {
  data: Array<Campaign_Ad_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Ad_On_Conflict>;
};

/** Boolean expression to filter rows from the table "campaign.ad". All fields are combined with a logical 'AND'. */
export type Campaign_Ad_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Ad_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Ad_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Ad_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creative?: InputMaybe<Ad_Creative_Bool_Exp>;
  creative_id?: InputMaybe<Uuid_Comparison_Exp>;
  creatives_history?: InputMaybe<Ad_Creative_Bool_Exp>;
  creatives_history_aggregate?: InputMaybe<Ad_Creative_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  platform?: InputMaybe<Ad_Platform_Enum_Comparison_Exp>;
  status?: InputMaybe<Ad_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.ad" */
export enum Campaign_Ad_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdPkey = 'ad_pkey'
}

/** input type for inserting data into table "campaign.ad" */
export type Campaign_Ad_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative?: InputMaybe<Ad_Creative_Obj_Rel_Insert_Input>;
  creative_id?: InputMaybe<Scalars['uuid']['input']>;
  creatives_history?: InputMaybe<Ad_Creative_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  platform?: InputMaybe<Ad_Platform_Enum>;
  status?: InputMaybe<Ad_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Campaign_Ad_Max_Fields = {
  __typename?: 'campaign_ad_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creative_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "campaign.ad" */
export type Campaign_Ad_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creative_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Campaign_Ad_Min_Fields = {
  __typename?: 'campaign_ad_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creative_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "campaign.ad" */
export type Campaign_Ad_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creative_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "campaign.ad" */
export type Campaign_Ad_Mutation_Response = {
  __typename?: 'campaign_ad_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Ad>;
};

/** input type for inserting object relation for remote table "campaign.ad" */
export type Campaign_Ad_Obj_Rel_Insert_Input = {
  data: Campaign_Ad_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Ad_On_Conflict>;
};

/** on_conflict condition type for table "campaign.ad" */
export type Campaign_Ad_On_Conflict = {
  constraint: Campaign_Ad_Constraint;
  update_columns?: Array<Campaign_Ad_Update_Column>;
  where?: InputMaybe<Campaign_Ad_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.ad". */
export type Campaign_Ad_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creative?: InputMaybe<Ad_Creative_Order_By>;
  creative_id?: InputMaybe<Order_By>;
  creatives_history_aggregate?: InputMaybe<Ad_Creative_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.ad */
export type Campaign_Ad_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "campaign.ad" */
export enum Campaign_Ad_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreativeId = 'creative_id',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "campaign.ad" */
export type Campaign_Ad_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  platform?: InputMaybe<Ad_Platform_Enum>;
  status?: InputMaybe<Ad_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "campaign_ad" */
export type Campaign_Ad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Ad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Ad_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creative_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  platform?: InputMaybe<Ad_Platform_Enum>;
  status?: InputMaybe<Ad_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "campaign.ad" */
export enum Campaign_Ad_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreativeId = 'creative_id',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Campaign_Ad_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Ad_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Ad_Bool_Exp;
};

/** aggregated selection of "campaign" */
export type Campaign_Aggregate = {
  __typename?: 'campaign_aggregate';
  aggregate?: Maybe<Campaign_Aggregate_Fields>;
  nodes: Array<Campaign>;
};

export type Campaign_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Campaign_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Campaign_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Campaign_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Campaign_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Campaign_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Campaign_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Campaign_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Campaign_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Campaign_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Campaign_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Campaign_Aggregate_Bool_Exp_Var_Samp>;
};

export type Campaign_Aggregate_Bool_Exp_Avg = {
  arguments: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Aggregate_Bool_Exp_Bool_And = {
  arguments: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Campaign_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Campaign_Aggregate_Bool_Exp_Corr = {
  arguments: Campaign_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Campaign_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Campaign_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Campaign_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Campaign_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Campaign_Aggregate_Bool_Exp_Max = {
  arguments: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Aggregate_Bool_Exp_Min = {
  arguments: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Aggregate_Bool_Exp_Sum = {
  arguments: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "campaign" */
export type Campaign_Aggregate_Fields = {
  __typename?: 'campaign_aggregate_fields';
  avg?: Maybe<Campaign_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Max_Fields>;
  min?: Maybe<Campaign_Min_Fields>;
  stddev?: Maybe<Campaign_Stddev_Fields>;
  stddev_pop?: Maybe<Campaign_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campaign_Stddev_Samp_Fields>;
  sum?: Maybe<Campaign_Sum_Fields>;
  var_pop?: Maybe<Campaign_Var_Pop_Fields>;
  var_samp?: Maybe<Campaign_Var_Samp_Fields>;
  variance?: Maybe<Campaign_Variance_Fields>;
};


/** aggregate fields of "campaign" */
export type Campaign_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "campaign" */
export type Campaign_Aggregate_Order_By = {
  avg?: InputMaybe<Campaign_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Campaign_Max_Order_By>;
  min?: InputMaybe<Campaign_Min_Order_By>;
  stddev?: InputMaybe<Campaign_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Campaign_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Campaign_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Campaign_Sum_Order_By>;
  var_pop?: InputMaybe<Campaign_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Campaign_Var_Samp_Order_By>;
  variance?: InputMaybe<Campaign_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "campaign" */
export type Campaign_Arr_Rel_Insert_Input = {
  data: Array<Campaign_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_On_Conflict>;
};

/** aggregate avg on columns */
export type Campaign_Avg_Fields = {
  __typename?: 'campaign_avg_fields';
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget?: Maybe<Scalars['Float']['output']>;
  daily_media_budget?: Maybe<Scalars['Float']['output']>;
  margin_in_percent?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
};

/** order by avg() on columns of table "campaign" */
export type Campaign_Avg_Order_By = {
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "campaign". All fields are combined with a logical 'AND'. */
export type Campaign_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Bool_Exp>>;
  ad_campaign_metrics?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
  ad_campaign_metrics_aggregate?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Bool_Exp>;
  ads?: InputMaybe<Campaign_Ad_Bool_Exp>;
  ads_aggregate?: InputMaybe<Campaign_Ad_Aggregate_Bool_Exp>;
  ads_email_list?: InputMaybe<String_Array_Comparison_Exp>;
  applicant_board_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  applicants_email_list?: InputMaybe<String_Array_Comparison_Exp>;
  bot_consent?: InputMaybe<Boolean_Comparison_Exp>;
  c_location?: InputMaybe<Organization_Location_Bool_Exp>;
  call_campaign?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
  call_campaign_aggregate?: InputMaybe<Anna_Ai_Call_Campaigns_Aggregate_Bool_Exp>;
  campaign_events?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
  campaign_events_aggregate?: InputMaybe<Campaign_Event_Log_Aggregate_Bool_Exp>;
  campaign_status?: InputMaybe<Campaign_Status_Bool_Exp>;
  campaign_work_location?: InputMaybe<Campaign_Work_Location_Bool_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  chat_bot_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  chat_bot_is_ko?: InputMaybe<Boolean_Comparison_Exp>;
  chat_bot_v2_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  contacts?: InputMaybe<Contact_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Bool_Exp>;
  contacts_per_day?: InputMaybe<New_Contacts_Per_Day_Bool_Exp>;
  contacts_per_day_aggregate?: InputMaybe<New_Contacts_Per_Day_Aggregate_Bool_Exp>;
  cost_per_lead?: InputMaybe<Numeric_Comparison_Exp>;
  cost_per_lead_customer?: InputMaybe<Numeric_Comparison_Exp>;
  customer_budget_bonus?: InputMaybe<Numeric_Comparison_Exp>;
  customer_budget_initial?: InputMaybe<Float8_Comparison_Exp>;
  customer_budget_total?: InputMaybe<Float8_Comparison_Exp>;
  daily_budget?: InputMaybe<Numeric_Comparison_Exp>;
  daily_media_budget?: InputMaybe<Numeric_Comparison_Exp>;
  email_template_overwrite?: InputMaybe<Campaign_Email_Template_Overwrite_Bool_Exp>;
  end?: InputMaybe<Timestamptz_Comparison_Exp>;
  forwarding?: InputMaybe<Chat_Bot_Forwarding_Bool_Exp>;
  funnel?: InputMaybe<Funnel_Funnels_Bool_Exp>;
  funnel_insights?: InputMaybe<Funnel_Insights_Bool_Exp>;
  funnel_page_insights?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
  funnel_page_insights_aggregate?: InputMaybe<Funnel_Page_Insights_Aggregate_Bool_Exp>;
  funnel_whatsapp_share_clicks?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
  funnel_whatsapp_share_clicks_aggregate?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_hidden?: InputMaybe<Boolean_Comparison_Exp>;
  is_test?: InputMaybe<Boolean_Comparison_Exp>;
  job_posting_text?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  location_slug?: InputMaybe<String_Comparison_Exp>;
  margin_in_percent?: InputMaybe<Float8_Comparison_Exp>;
  media_budget?: InputMaybe<Float8_Comparison_Exp>;
  meistertask_url?: InputMaybe<String_Comparison_Exp>;
  monday_url?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_settings_override?: InputMaybe<Campaign_Settings_Override_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
  origin_contacts?: InputMaybe<Contact_Bool_Exp>;
  origin_contacts_aggregate?: InputMaybe<Contact_Aggregate_Bool_Exp>;
  pdf_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  perspective_campaign?: InputMaybe<Perspective_Campaign_Bool_Exp>;
  perspective_campaign_id?: InputMaybe<String_Comparison_Exp>;
  phone_number_default_region?: InputMaybe<Campaign_Iso_2_Country_Codes_Enum_Comparison_Exp>;
  profit?: InputMaybe<Numeric_Comparison_Exp>;
  questions?: InputMaybe<Funnel_Question_Bool_Exp>;
  questions_aggregate?: InputMaybe<Funnel_Question_Aggregate_Bool_Exp>;
  remaining_customer_budget?: InputMaybe<Float8_Comparison_Exp>;
  responsible_person?: InputMaybe<String_Comparison_Exp>;
  rms_connector?: InputMaybe<Rms_Connectors_Bool_Exp>;
  routing_info?: InputMaybe<Campaign_Routing_Info_Bool_Exp>;
  short_id?: InputMaybe<Bpchar_Comparison_Exp>;
  start?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_log?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
  status_log_aggregate?: InputMaybe<Campaign_Status_Log_Aggregate_Bool_Exp>;
  status_override?: InputMaybe<Campaign_Status_Enum_Comparison_Exp>;
  support_email?: InputMaybe<String_Comparison_Exp>;
  transactions?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  transactions_aggregate?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Bool_Exp>;
  unqualified_contacts_per_day?: InputMaybe<New_Unqualified_Contacts_Per_Day_Bool_Exp>;
  unqualified_contacts_per_day_aggregate?: InputMaybe<New_Unqualified_Contacts_Per_Day_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  work_location?: InputMaybe<Campaign_Work_Location_Enum_Comparison_Exp>;
};

/** columns and relationships of "campaign.budget" */
export type Campaign_Budget = {
  __typename?: 'campaign_budget';
  amount?: Maybe<Scalars['float8']['output']>;
  bonus?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  campaign?: Maybe<Campaign>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  without_bonus?: Maybe<Scalars['float8']['output']>;
};

/** aggregated selection of "campaign.budget" */
export type Campaign_Budget_Aggregate = {
  __typename?: 'campaign_budget_aggregate';
  aggregate?: Maybe<Campaign_Budget_Aggregate_Fields>;
  nodes: Array<Campaign_Budget>;
};

/** aggregate fields of "campaign.budget" */
export type Campaign_Budget_Aggregate_Fields = {
  __typename?: 'campaign_budget_aggregate_fields';
  avg?: Maybe<Campaign_Budget_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Budget_Max_Fields>;
  min?: Maybe<Campaign_Budget_Min_Fields>;
  stddev?: Maybe<Campaign_Budget_Stddev_Fields>;
  stddev_pop?: Maybe<Campaign_Budget_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campaign_Budget_Stddev_Samp_Fields>;
  sum?: Maybe<Campaign_Budget_Sum_Fields>;
  var_pop?: Maybe<Campaign_Budget_Var_Pop_Fields>;
  var_samp?: Maybe<Campaign_Budget_Var_Samp_Fields>;
  variance?: Maybe<Campaign_Budget_Variance_Fields>;
};


/** aggregate fields of "campaign.budget" */
export type Campaign_Budget_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Budget_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Campaign_Budget_Avg_Fields = {
  __typename?: 'campaign_budget_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  without_bonus?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "campaign.budget". All fields are combined with a logical 'AND'. */
export type Campaign_Budget_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Budget_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Budget_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Budget_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bonus?: InputMaybe<Float8_Comparison_Exp>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
  without_bonus?: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "campaign.budget" */
export type Campaign_Budget_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bonus?: InputMaybe<Scalars['float8']['input']>;
  without_bonus?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "campaign.budget" */
export type Campaign_Budget_Insert_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bonus?: InputMaybe<Scalars['float8']['input']>;
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  without_bonus?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type Campaign_Budget_Max_Fields = {
  __typename?: 'campaign_budget_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bonus?: Maybe<Scalars['float8']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  without_bonus?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Campaign_Budget_Min_Fields = {
  __typename?: 'campaign_budget_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bonus?: Maybe<Scalars['float8']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  without_bonus?: Maybe<Scalars['float8']['output']>;
};

/** response of any mutation on the table "campaign.budget" */
export type Campaign_Budget_Mutation_Response = {
  __typename?: 'campaign_budget_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Budget>;
};

/** Ordering options when selecting data from "campaign.budget". */
export type Campaign_Budget_Order_By = {
  amount?: InputMaybe<Order_By>;
  bonus?: InputMaybe<Order_By>;
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  without_bonus?: InputMaybe<Order_By>;
};

/** select columns of table "campaign.budget" */
export enum Campaign_Budget_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Bonus = 'bonus',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  WithoutBonus = 'without_bonus'
}

/** input type for updating data in table "campaign.budget" */
export type Campaign_Budget_Set_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bonus?: InputMaybe<Scalars['float8']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  without_bonus?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type Campaign_Budget_Stddev_Fields = {
  __typename?: 'campaign_budget_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  without_bonus?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Campaign_Budget_Stddev_Pop_Fields = {
  __typename?: 'campaign_budget_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  without_bonus?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Campaign_Budget_Stddev_Samp_Fields = {
  __typename?: 'campaign_budget_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  without_bonus?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "campaign_budget" */
export type Campaign_Budget_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Budget_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Budget_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bonus?: InputMaybe<Scalars['float8']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  without_bonus?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Campaign_Budget_Sum_Fields = {
  __typename?: 'campaign_budget_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bonus?: Maybe<Scalars['float8']['output']>;
  without_bonus?: Maybe<Scalars['float8']['output']>;
};

/** columns and relationships of "campaign.budget_transaction" */
export type Campaign_Budget_Transaction = {
  __typename?: 'campaign_budget_transaction';
  amount: Scalars['float8']['output'];
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  type: Campaign_Transaction_Type_Enum;
};

/** aggregated selection of "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Aggregate = {
  __typename?: 'campaign_budget_transaction_aggregate';
  aggregate?: Maybe<Campaign_Budget_Transaction_Aggregate_Fields>;
  nodes: Array<Campaign_Budget_Transaction>;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Bool_Exp_Var_Samp>;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Avg = {
  arguments: Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Corr = {
  arguments: Campaign_Budget_Transaction_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Campaign_Budget_Transaction_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Max = {
  arguments: Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Min = {
  arguments: Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Sum = {
  arguments: Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Campaign_Budget_Transaction_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Aggregate_Fields = {
  __typename?: 'campaign_budget_transaction_aggregate_fields';
  avg?: Maybe<Campaign_Budget_Transaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Budget_Transaction_Max_Fields>;
  min?: Maybe<Campaign_Budget_Transaction_Min_Fields>;
  stddev?: Maybe<Campaign_Budget_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Campaign_Budget_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campaign_Budget_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Campaign_Budget_Transaction_Sum_Fields>;
  var_pop?: Maybe<Campaign_Budget_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Campaign_Budget_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Campaign_Budget_Transaction_Variance_Fields>;
};


/** aggregate fields of "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Campaign_Budget_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Campaign_Budget_Transaction_Max_Order_By>;
  min?: InputMaybe<Campaign_Budget_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Campaign_Budget_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Campaign_Budget_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Campaign_Budget_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Campaign_Budget_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Campaign_Budget_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Campaign_Budget_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Campaign_Budget_Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Campaign_Budget_Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Budget_Transaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Campaign_Budget_Transaction_Avg_Fields = {
  __typename?: 'campaign_budget_transaction_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "campaign.budget_transaction". All fields are combined with a logical 'AND'. */
export type Campaign_Budget_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Budget_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Budget_Transaction_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  full_amount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Campaign_Transaction_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Constraint {
  /** unique or primary key constraint on columns "id" */
  BudgetTransactionPkey = 'budget_transaction_pkey'
}

/** input type for incrementing numeric columns in table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Insert_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Campaign_Transaction_Type_Enum>;
};

/** aggregate max on columns */
export type Campaign_Budget_Transaction_Max_Fields = {
  __typename?: 'campaign_budget_transaction_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Campaign_Budget_Transaction_Min_Fields = {
  __typename?: 'campaign_budget_transaction_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Mutation_Response = {
  __typename?: 'campaign_budget_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Budget_Transaction>;
};

/** on_conflict condition type for table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_On_Conflict = {
  constraint: Campaign_Budget_Transaction_Constraint;
  update_columns?: Array<Campaign_Budget_Transaction_Update_Column>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.budget_transaction". */
export type Campaign_Budget_Transaction_Order_By = {
  amount?: InputMaybe<Order_By>;
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  full_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.budget_transaction */
export type Campaign_Budget_Transaction_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullAmount = 'full_amount',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** select "campaign_budget_transaction_aggregate_bool_exp_avg_arguments_columns" columns of table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "campaign_budget_transaction_aggregate_bool_exp_corr_arguments_columns" columns of table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "campaign_budget_transaction_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "campaign_budget_transaction_aggregate_bool_exp_max_arguments_columns" columns of table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "campaign_budget_transaction_aggregate_bool_exp_min_arguments_columns" columns of table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "campaign_budget_transaction_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "campaign_budget_transaction_aggregate_bool_exp_sum_arguments_columns" columns of table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "campaign_budget_transaction_aggregate_bool_exp_var_samp_arguments_columns" columns of table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Select_Column_Campaign_Budget_Transaction_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** input type for updating data in table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Set_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Campaign_Transaction_Type_Enum>;
};

/** aggregate stddev on columns */
export type Campaign_Budget_Transaction_Stddev_Fields = {
  __typename?: 'campaign_budget_transaction_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Campaign_Budget_Transaction_Stddev_Pop_Fields = {
  __typename?: 'campaign_budget_transaction_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Campaign_Budget_Transaction_Stddev_Samp_Fields = {
  __typename?: 'campaign_budget_transaction_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "campaign_budget_transaction" */
export type Campaign_Budget_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Budget_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Budget_Transaction_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Campaign_Transaction_Type_Enum>;
};

/** aggregate sum on columns */
export type Campaign_Budget_Transaction_Sum_Fields = {
  __typename?: 'campaign_budget_transaction_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Order_By>;
};

/** update columns of table "campaign.budget_transaction" */
export enum Campaign_Budget_Transaction_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullAmount = 'full_amount',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

export type Campaign_Budget_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Campaign_Budget_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Budget_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Budget_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campaign_Budget_Transaction_Var_Pop_Fields = {
  __typename?: 'campaign_budget_transaction_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Campaign_Budget_Transaction_Var_Samp_Fields = {
  __typename?: 'campaign_budget_transaction_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Campaign_Budget_Transaction_Variance_Fields = {
  __typename?: 'campaign_budget_transaction_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "campaign.budget_transaction" */
export type Campaign_Budget_Transaction_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  /** The amount that would have been added or subtracted if the campaign would not have been paused */
  full_amount?: InputMaybe<Order_By>;
};

export type Campaign_Budget_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Campaign_Budget_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Budget_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Budget_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campaign_Budget_Var_Pop_Fields = {
  __typename?: 'campaign_budget_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  without_bonus?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Campaign_Budget_Var_Samp_Fields = {
  __typename?: 'campaign_budget_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  without_bonus?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Campaign_Budget_Variance_Fields = {
  __typename?: 'campaign_budget_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  without_bonus?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "campaign" */
export enum Campaign_Constraint {
  /** unique or primary key constraint on columns "id" */
  CampaignPkey = 'campaign_pkey',
  /** unique or primary key constraint on columns "short_id" */
  CampaignShortIdKey = 'campaign_short_id_key'
}

/** columns and relationships of "campaign.email_template_overwrite" */
export type Campaign_Email_Template_Overwrite = {
  __typename?: 'campaign_email_template_overwrite';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  rejection?: Maybe<Scalars['String']['output']>;
  welcome?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "campaign.email_template_overwrite" */
export type Campaign_Email_Template_Overwrite_Aggregate = {
  __typename?: 'campaign_email_template_overwrite_aggregate';
  aggregate?: Maybe<Campaign_Email_Template_Overwrite_Aggregate_Fields>;
  nodes: Array<Campaign_Email_Template_Overwrite>;
};

/** aggregate fields of "campaign.email_template_overwrite" */
export type Campaign_Email_Template_Overwrite_Aggregate_Fields = {
  __typename?: 'campaign_email_template_overwrite_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Email_Template_Overwrite_Max_Fields>;
  min?: Maybe<Campaign_Email_Template_Overwrite_Min_Fields>;
};


/** aggregate fields of "campaign.email_template_overwrite" */
export type Campaign_Email_Template_Overwrite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "campaign.email_template_overwrite". All fields are combined with a logical 'AND'. */
export type Campaign_Email_Template_Overwrite_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Email_Template_Overwrite_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  rejection?: InputMaybe<String_Comparison_Exp>;
  welcome?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.email_template_overwrite" */
export enum Campaign_Email_Template_Overwrite_Constraint {
  /** unique or primary key constraint on columns "campaign_id" */
  EmailTemplateOverwritePkey = 'email_template_overwrite_pkey'
}

/** input type for inserting data into table "campaign.email_template_overwrite" */
export type Campaign_Email_Template_Overwrite_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  rejection?: InputMaybe<Scalars['String']['input']>;
  welcome?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Email_Template_Overwrite_Max_Fields = {
  __typename?: 'campaign_email_template_overwrite_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  rejection?: Maybe<Scalars['String']['output']>;
  welcome?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Email_Template_Overwrite_Min_Fields = {
  __typename?: 'campaign_email_template_overwrite_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  rejection?: Maybe<Scalars['String']['output']>;
  welcome?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign.email_template_overwrite" */
export type Campaign_Email_Template_Overwrite_Mutation_Response = {
  __typename?: 'campaign_email_template_overwrite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Email_Template_Overwrite>;
};

/** input type for inserting object relation for remote table "campaign.email_template_overwrite" */
export type Campaign_Email_Template_Overwrite_Obj_Rel_Insert_Input = {
  data: Campaign_Email_Template_Overwrite_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Email_Template_Overwrite_On_Conflict>;
};

/** on_conflict condition type for table "campaign.email_template_overwrite" */
export type Campaign_Email_Template_Overwrite_On_Conflict = {
  constraint: Campaign_Email_Template_Overwrite_Constraint;
  update_columns?: Array<Campaign_Email_Template_Overwrite_Update_Column>;
  where?: InputMaybe<Campaign_Email_Template_Overwrite_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.email_template_overwrite". */
export type Campaign_Email_Template_Overwrite_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  rejection?: InputMaybe<Order_By>;
  welcome?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.email_template_overwrite */
export type Campaign_Email_Template_Overwrite_Pk_Columns_Input = {
  campaign_id: Scalars['uuid']['input'];
};

/** select columns of table "campaign.email_template_overwrite" */
export enum Campaign_Email_Template_Overwrite_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Rejection = 'rejection',
  /** column name */
  Welcome = 'welcome'
}

/** input type for updating data in table "campaign.email_template_overwrite" */
export type Campaign_Email_Template_Overwrite_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  rejection?: InputMaybe<Scalars['String']['input']>;
  welcome?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "campaign_email_template_overwrite" */
export type Campaign_Email_Template_Overwrite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Email_Template_Overwrite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Email_Template_Overwrite_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  rejection?: InputMaybe<Scalars['String']['input']>;
  welcome?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "campaign.email_template_overwrite" */
export enum Campaign_Email_Template_Overwrite_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Rejection = 'rejection',
  /** column name */
  Welcome = 'welcome'
}

export type Campaign_Email_Template_Overwrite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Email_Template_Overwrite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Email_Template_Overwrite_Bool_Exp;
};

/** columns and relationships of "campaign.event_log" */
export type Campaign_Event_Log = {
  __typename?: 'campaign_event_log';
  campaign_id: Scalars['uuid']['output'];
  /** An object relationship */
  contact?: Maybe<Contact>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  user_id: Scalars['String']['output'];
};


/** columns and relationships of "campaign.event_log" */
export type Campaign_Event_LogMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "campaign.event_log" */
export type Campaign_Event_Log_Aggregate = {
  __typename?: 'campaign_event_log_aggregate';
  aggregate?: Maybe<Campaign_Event_Log_Aggregate_Fields>;
  nodes: Array<Campaign_Event_Log>;
};

export type Campaign_Event_Log_Aggregate_Bool_Exp = {
  count?: InputMaybe<Campaign_Event_Log_Aggregate_Bool_Exp_Count>;
};

export type Campaign_Event_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Campaign_Event_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "campaign.event_log" */
export type Campaign_Event_Log_Aggregate_Fields = {
  __typename?: 'campaign_event_log_aggregate_fields';
  avg?: Maybe<Campaign_Event_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Event_Log_Max_Fields>;
  min?: Maybe<Campaign_Event_Log_Min_Fields>;
  stddev?: Maybe<Campaign_Event_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Campaign_Event_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campaign_Event_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Campaign_Event_Log_Sum_Fields>;
  var_pop?: Maybe<Campaign_Event_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Campaign_Event_Log_Var_Samp_Fields>;
  variance?: Maybe<Campaign_Event_Log_Variance_Fields>;
};


/** aggregate fields of "campaign.event_log" */
export type Campaign_Event_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Event_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "campaign.event_log" */
export type Campaign_Event_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Campaign_Event_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Campaign_Event_Log_Max_Order_By>;
  min?: InputMaybe<Campaign_Event_Log_Min_Order_By>;
  stddev?: InputMaybe<Campaign_Event_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Campaign_Event_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Campaign_Event_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Campaign_Event_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Campaign_Event_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Campaign_Event_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Campaign_Event_Log_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Campaign_Event_Log_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "campaign.event_log" */
export type Campaign_Event_Log_Arr_Rel_Insert_Input = {
  data: Array<Campaign_Event_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Event_Log_On_Conflict>;
};

/** aggregate avg on columns */
export type Campaign_Event_Log_Avg_Fields = {
  __typename?: 'campaign_event_log_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "campaign.event_log" */
export type Campaign_Event_Log_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "campaign.event_log". All fields are combined with a logical 'AND'. */
export type Campaign_Event_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Event_Log_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Event_Log_Bool_Exp>>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.event_log" */
export enum Campaign_Event_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventLogPkey = 'event_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Campaign_Event_Log_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Campaign_Event_Log_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Campaign_Event_Log_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "campaign.event_log" */
export type Campaign_Event_Log_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "campaign.event_log" */
export type Campaign_Event_Log_Insert_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Event_Log_Max_Fields = {
  __typename?: 'campaign_event_log_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "campaign.event_log" */
export type Campaign_Event_Log_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Campaign_Event_Log_Min_Fields = {
  __typename?: 'campaign_event_log_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "campaign.event_log" */
export type Campaign_Event_Log_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "campaign.event_log" */
export type Campaign_Event_Log_Mutation_Response = {
  __typename?: 'campaign_event_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Event_Log>;
};

/** on_conflict condition type for table "campaign.event_log" */
export type Campaign_Event_Log_On_Conflict = {
  constraint: Campaign_Event_Log_Constraint;
  update_columns?: Array<Campaign_Event_Log_Update_Column>;
  where?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.event_log". */
export type Campaign_Event_Log_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.event_log */
export type Campaign_Event_Log_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Campaign_Event_Log_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "campaign.event_log" */
export enum Campaign_Event_Log_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "campaign.event_log" */
export type Campaign_Event_Log_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Campaign_Event_Log_Stddev_Fields = {
  __typename?: 'campaign_event_log_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "campaign.event_log" */
export type Campaign_Event_Log_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Campaign_Event_Log_Stddev_Pop_Fields = {
  __typename?: 'campaign_event_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "campaign.event_log" */
export type Campaign_Event_Log_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Campaign_Event_Log_Stddev_Samp_Fields = {
  __typename?: 'campaign_event_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "campaign.event_log" */
export type Campaign_Event_Log_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "campaign_event_log" */
export type Campaign_Event_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Event_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Event_Log_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Campaign_Event_Log_Sum_Fields = {
  __typename?: 'campaign_event_log_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "campaign.event_log" */
export type Campaign_Event_Log_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "campaign.event_log" */
export enum Campaign_Event_Log_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  UserId = 'user_id'
}

export type Campaign_Event_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Campaign_Event_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Campaign_Event_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Campaign_Event_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Campaign_Event_Log_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Campaign_Event_Log_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Campaign_Event_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Event_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Event_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campaign_Event_Log_Var_Pop_Fields = {
  __typename?: 'campaign_event_log_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "campaign.event_log" */
export type Campaign_Event_Log_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Campaign_Event_Log_Var_Samp_Fields = {
  __typename?: 'campaign_event_log_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "campaign.event_log" */
export type Campaign_Event_Log_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Campaign_Event_Log_Variance_Fields = {
  __typename?: 'campaign_event_log_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "campaign.event_log" */
export type Campaign_Event_Log_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

export type Campaign_Get_Daily_Budget_Args = {
  c_id?: InputMaybe<Scalars['uuid']['input']>;
  on_day?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for incrementing numeric columns in table "campaign" */
export type Campaign_Inc_Input = {
  daily_budget?: InputMaybe<Scalars['numeric']['input']>;
  daily_media_budget?: InputMaybe<Scalars['numeric']['input']>;
  margin_in_percent?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "campaign" */
export type Campaign_Insert_Input = {
  ad_campaign_metrics?: InputMaybe<Ad_Campaign_Metrics_Arr_Rel_Insert_Input>;
  ads?: InputMaybe<Campaign_Ad_Arr_Rel_Insert_Input>;
  ads_email_list?: InputMaybe<Array<Scalars['String']['input']>>;
  applicant_board_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  applicants_email_list?: InputMaybe<Array<Scalars['String']['input']>>;
  bot_consent?: InputMaybe<Scalars['Boolean']['input']>;
  c_location?: InputMaybe<Organization_Location_Obj_Rel_Insert_Input>;
  call_campaign?: InputMaybe<Anna_Ai_Call_Campaigns_Arr_Rel_Insert_Input>;
  campaign_events?: InputMaybe<Campaign_Event_Log_Arr_Rel_Insert_Input>;
  campaign_status?: InputMaybe<Campaign_Status_Obj_Rel_Insert_Input>;
  campaign_work_location?: InputMaybe<Campaign_Work_Location_Obj_Rel_Insert_Input>;
  category?: InputMaybe<Scalars['String']['input']>;
  chat_bot_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  chat_bot_is_ko?: InputMaybe<Scalars['Boolean']['input']>;
  chat_bot_v2_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  contacts?: InputMaybe<Contact_Arr_Rel_Insert_Input>;
  contacts_per_day?: InputMaybe<New_Contacts_Per_Day_Arr_Rel_Insert_Input>;
  daily_budget?: InputMaybe<Scalars['numeric']['input']>;
  daily_media_budget?: InputMaybe<Scalars['numeric']['input']>;
  email_template_overwrite?: InputMaybe<Campaign_Email_Template_Overwrite_Obj_Rel_Insert_Input>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  forwarding?: InputMaybe<Chat_Bot_Forwarding_Obj_Rel_Insert_Input>;
  funnel?: InputMaybe<Funnel_Funnels_Obj_Rel_Insert_Input>;
  funnel_insights?: InputMaybe<Funnel_Insights_Obj_Rel_Insert_Input>;
  funnel_page_insights?: InputMaybe<Funnel_Page_Insights_Arr_Rel_Insert_Input>;
  funnel_whatsapp_share_clicks?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  job_posting_text?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  location_slug?: InputMaybe<Scalars['String']['input']>;
  margin_in_percent?: InputMaybe<Scalars['float8']['input']>;
  meistertask_url?: InputMaybe<Scalars['String']['input']>;
  monday_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  org_settings_override?: InputMaybe<Campaign_Settings_Override_Obj_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  origin_contacts?: InputMaybe<Contact_Arr_Rel_Insert_Input>;
  pdf_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  perspective_campaign?: InputMaybe<Perspective_Campaign_Obj_Rel_Insert_Input>;
  perspective_campaign_id?: InputMaybe<Scalars['String']['input']>;
  phone_number_default_region?: InputMaybe<Campaign_Iso_2_Country_Codes_Enum>;
  questions?: InputMaybe<Funnel_Question_Arr_Rel_Insert_Input>;
  responsible_person?: InputMaybe<Scalars['String']['input']>;
  rms_connector?: InputMaybe<Rms_Connectors_Obj_Rel_Insert_Input>;
  routing_info?: InputMaybe<Campaign_Routing_Info_Obj_Rel_Insert_Input>;
  short_id?: InputMaybe<Scalars['bpchar']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Stored campaign status (DRAFT, ACTIVE, PAUSED, FINISHED). Maintained from dates, status_override, and linked ad status. */
  status?: InputMaybe<Scalars['String']['input']>;
  status_log?: InputMaybe<Campaign_Status_Log_Arr_Rel_Insert_Input>;
  /** Can be used to manually override the campaign status to set the campaign to paused/finished */
  status_override?: InputMaybe<Campaign_Status_Enum>;
  support_email?: InputMaybe<Scalars['String']['input']>;
  transactions?: InputMaybe<Campaign_Budget_Transaction_Arr_Rel_Insert_Input>;
  unqualified_contacts_per_day?: InputMaybe<New_Unqualified_Contacts_Per_Day_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_location?: InputMaybe<Campaign_Work_Location_Enum>;
};

/** columns and relationships of "campaign.iso_2_country_codes" */
export type Campaign_Iso_2_Country_Codes = {
  __typename?: 'campaign_iso_2_country_codes';
  value: Scalars['String']['output'];
};

/** aggregated selection of "campaign.iso_2_country_codes" */
export type Campaign_Iso_2_Country_Codes_Aggregate = {
  __typename?: 'campaign_iso_2_country_codes_aggregate';
  aggregate?: Maybe<Campaign_Iso_2_Country_Codes_Aggregate_Fields>;
  nodes: Array<Campaign_Iso_2_Country_Codes>;
};

/** aggregate fields of "campaign.iso_2_country_codes" */
export type Campaign_Iso_2_Country_Codes_Aggregate_Fields = {
  __typename?: 'campaign_iso_2_country_codes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Iso_2_Country_Codes_Max_Fields>;
  min?: Maybe<Campaign_Iso_2_Country_Codes_Min_Fields>;
};


/** aggregate fields of "campaign.iso_2_country_codes" */
export type Campaign_Iso_2_Country_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "campaign.iso_2_country_codes". All fields are combined with a logical 'AND'. */
export type Campaign_Iso_2_Country_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Iso_2_Country_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.iso_2_country_codes" */
export enum Campaign_Iso_2_Country_Codes_Constraint {
  /** unique or primary key constraint on columns "value" */
  Iso_2CountryCodesPkey = 'iso_2_country_codes_pkey'
}

export enum Campaign_Iso_2_Country_Codes_Enum {
  Ba = 'BA',
  De = 'DE',
  Es = 'ES',
  Gr = 'GR',
  Hr = 'HR',
  Mk = 'MK',
  Tr = 'TR'
}

/** Boolean expression to compare columns of type "campaign_iso_2_country_codes_enum". All fields are combined with logical 'AND'. */
export type Campaign_Iso_2_Country_Codes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Campaign_Iso_2_Country_Codes_Enum>;
  _in?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Campaign_Iso_2_Country_Codes_Enum>;
  _nin?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Enum>>;
};

/** input type for inserting data into table "campaign.iso_2_country_codes" */
export type Campaign_Iso_2_Country_Codes_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Iso_2_Country_Codes_Max_Fields = {
  __typename?: 'campaign_iso_2_country_codes_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Iso_2_Country_Codes_Min_Fields = {
  __typename?: 'campaign_iso_2_country_codes_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign.iso_2_country_codes" */
export type Campaign_Iso_2_Country_Codes_Mutation_Response = {
  __typename?: 'campaign_iso_2_country_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Iso_2_Country_Codes>;
};

/** on_conflict condition type for table "campaign.iso_2_country_codes" */
export type Campaign_Iso_2_Country_Codes_On_Conflict = {
  constraint: Campaign_Iso_2_Country_Codes_Constraint;
  update_columns?: Array<Campaign_Iso_2_Country_Codes_Update_Column>;
  where?: InputMaybe<Campaign_Iso_2_Country_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.iso_2_country_codes". */
export type Campaign_Iso_2_Country_Codes_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.iso_2_country_codes */
export type Campaign_Iso_2_Country_Codes_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "campaign.iso_2_country_codes" */
export enum Campaign_Iso_2_Country_Codes_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "campaign.iso_2_country_codes" */
export type Campaign_Iso_2_Country_Codes_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "campaign_iso_2_country_codes" */
export type Campaign_Iso_2_Country_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Iso_2_Country_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Iso_2_Country_Codes_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "campaign.iso_2_country_codes" */
export enum Campaign_Iso_2_Country_Codes_Update_Column {
  /** column name */
  Value = 'value'
}

export type Campaign_Iso_2_Country_Codes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Iso_2_Country_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Iso_2_Country_Codes_Bool_Exp;
};

/** columns and relationships of "campaign.job_description" */
export type Campaign_Job_Description = {
  __typename?: 'campaign_job_description';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  job_title: Scalars['String']['output'];
  pay: Scalars['String']['output'];
  working_hours: Scalars['String']['output'];
};

/** aggregated selection of "campaign.job_description" */
export type Campaign_Job_Description_Aggregate = {
  __typename?: 'campaign_job_description_aggregate';
  aggregate?: Maybe<Campaign_Job_Description_Aggregate_Fields>;
  nodes: Array<Campaign_Job_Description>;
};

/** aggregate fields of "campaign.job_description" */
export type Campaign_Job_Description_Aggregate_Fields = {
  __typename?: 'campaign_job_description_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Job_Description_Max_Fields>;
  min?: Maybe<Campaign_Job_Description_Min_Fields>;
};


/** aggregate fields of "campaign.job_description" */
export type Campaign_Job_Description_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Job_Description_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "campaign.job_description". All fields are combined with a logical 'AND'. */
export type Campaign_Job_Description_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Job_Description_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Job_Description_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Job_Description_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  job_title?: InputMaybe<String_Comparison_Exp>;
  pay?: InputMaybe<String_Comparison_Exp>;
  working_hours?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.job_description" */
export enum Campaign_Job_Description_Constraint {
  /** unique or primary key constraint on columns "campaign_id" */
  JobDescriptionPkey = 'job_description_pkey'
}

/** input type for inserting data into table "campaign.job_description" */
export type Campaign_Job_Description_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  pay?: InputMaybe<Scalars['String']['input']>;
  working_hours?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Job_Description_Max_Fields = {
  __typename?: 'campaign_job_description_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  pay?: Maybe<Scalars['String']['output']>;
  working_hours?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Job_Description_Min_Fields = {
  __typename?: 'campaign_job_description_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  pay?: Maybe<Scalars['String']['output']>;
  working_hours?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign.job_description" */
export type Campaign_Job_Description_Mutation_Response = {
  __typename?: 'campaign_job_description_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Job_Description>;
};

/** on_conflict condition type for table "campaign.job_description" */
export type Campaign_Job_Description_On_Conflict = {
  constraint: Campaign_Job_Description_Constraint;
  update_columns?: Array<Campaign_Job_Description_Update_Column>;
  where?: InputMaybe<Campaign_Job_Description_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.job_description". */
export type Campaign_Job_Description_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  job_title?: InputMaybe<Order_By>;
  pay?: InputMaybe<Order_By>;
  working_hours?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.job_description */
export type Campaign_Job_Description_Pk_Columns_Input = {
  campaign_id: Scalars['uuid']['input'];
};

/** select columns of table "campaign.job_description" */
export enum Campaign_Job_Description_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  Pay = 'pay',
  /** column name */
  WorkingHours = 'working_hours'
}

/** input type for updating data in table "campaign.job_description" */
export type Campaign_Job_Description_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  pay?: InputMaybe<Scalars['String']['input']>;
  working_hours?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "campaign_job_description" */
export type Campaign_Job_Description_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Job_Description_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Job_Description_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  pay?: InputMaybe<Scalars['String']['input']>;
  working_hours?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "campaign.job_description" */
export enum Campaign_Job_Description_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  Pay = 'pay',
  /** column name */
  WorkingHours = 'working_hours'
}

export type Campaign_Job_Description_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Job_Description_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Job_Description_Bool_Exp;
};

/** aggregate max on columns */
export type Campaign_Max_Fields = {
  __typename?: 'campaign_max_fields';
  ads_email_list?: Maybe<Array<Scalars['String']['output']>>;
  applicants_email_list?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget?: Maybe<Scalars['numeric']['output']>;
  daily_media_budget?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_posting_text?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  location_slug?: Maybe<Scalars['String']['output']>;
  margin_in_percent?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  meistertask_url?: Maybe<Scalars['String']['output']>;
  monday_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  perspective_campaign_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
  responsible_person?: Maybe<Scalars['String']['output']>;
  short_id?: Maybe<Scalars['bpchar']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  /** Stored campaign status (DRAFT, ACTIVE, PAUSED, FINISHED). Maintained from dates, status_override, and linked ad status. */
  status?: Maybe<Scalars['String']['output']>;
  support_email?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "campaign" */
export type Campaign_Max_Order_By = {
  ads_email_list?: InputMaybe<Order_By>;
  applicants_email_list?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_posting_text?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  location_slug?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
  meistertask_url?: InputMaybe<Order_By>;
  monday_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  perspective_campaign_id?: InputMaybe<Order_By>;
  responsible_person?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  /** Stored campaign status (DRAFT, ACTIVE, PAUSED, FINISHED). Maintained from dates, status_override, and linked ad status. */
  status?: InputMaybe<Order_By>;
  support_email?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Campaign_Min_Fields = {
  __typename?: 'campaign_min_fields';
  ads_email_list?: Maybe<Array<Scalars['String']['output']>>;
  applicants_email_list?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget?: Maybe<Scalars['numeric']['output']>;
  daily_media_budget?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_posting_text?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  location_slug?: Maybe<Scalars['String']['output']>;
  margin_in_percent?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  meistertask_url?: Maybe<Scalars['String']['output']>;
  monday_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  perspective_campaign_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
  responsible_person?: Maybe<Scalars['String']['output']>;
  short_id?: Maybe<Scalars['bpchar']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  /** Stored campaign status (DRAFT, ACTIVE, PAUSED, FINISHED). Maintained from dates, status_override, and linked ad status. */
  status?: Maybe<Scalars['String']['output']>;
  support_email?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "campaign" */
export type Campaign_Min_Order_By = {
  ads_email_list?: InputMaybe<Order_By>;
  applicants_email_list?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_posting_text?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  location_slug?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
  meistertask_url?: InputMaybe<Order_By>;
  monday_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  perspective_campaign_id?: InputMaybe<Order_By>;
  responsible_person?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  /** Stored campaign status (DRAFT, ACTIVE, PAUSED, FINISHED). Maintained from dates, status_override, and linked ad status. */
  status?: InputMaybe<Order_By>;
  support_email?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "campaign" */
export type Campaign_Mutation_Response = {
  __typename?: 'campaign_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign>;
};

/** input type for inserting object relation for remote table "campaign" */
export type Campaign_Obj_Rel_Insert_Input = {
  data: Campaign_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_On_Conflict>;
};

/** on_conflict condition type for table "campaign" */
export type Campaign_On_Conflict = {
  constraint: Campaign_Constraint;
  update_columns?: Array<Campaign_Update_Column>;
  where?: InputMaybe<Campaign_Bool_Exp>;
};

/** Contains orders for new campaigns */
export type Campaign_Order = {
  __typename?: 'campaign_order';
  additional_properties: Scalars['jsonb']['output'];
  budget: Scalars['numeric']['output'];
  completed: Scalars['Boolean']['output'];
  created_campaign?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer?: Maybe<Organization>;
  customer_org_id?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  imported_from: Scalars['uuid']['output'];
  link?: Maybe<Scalars['String']['output']>;
  platform_job_id: Scalars['String']['output'];
  posted_at?: Maybe<Scalars['timestamp']['output']>;
  received_at: Scalars['timestamptz']['output'];
  responsible_user?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  source: Campaign_Order_Source;
  target_locations?: Maybe<Scalars['jsonb']['output']>;
  title: Scalars['String']['output'];
};


/** Contains orders for new campaigns */
export type Campaign_OrderAdditional_PropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Contains orders for new campaigns */
export type Campaign_OrderTarget_LocationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "campaign.order" */
export type Campaign_Order_Aggregate = {
  __typename?: 'campaign_order_aggregate';
  aggregate?: Maybe<Campaign_Order_Aggregate_Fields>;
  nodes: Array<Campaign_Order>;
};

/** aggregate fields of "campaign.order" */
export type Campaign_Order_Aggregate_Fields = {
  __typename?: 'campaign_order_aggregate_fields';
  avg?: Maybe<Campaign_Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Order_Max_Fields>;
  min?: Maybe<Campaign_Order_Min_Fields>;
  stddev?: Maybe<Campaign_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Campaign_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campaign_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Campaign_Order_Sum_Fields>;
  var_pop?: Maybe<Campaign_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Campaign_Order_Var_Samp_Fields>;
  variance?: Maybe<Campaign_Order_Variance_Fields>;
};


/** aggregate fields of "campaign.order" */
export type Campaign_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Campaign_Order_Append_Input = {
  additional_properties?: InputMaybe<Scalars['jsonb']['input']>;
  target_locations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Campaign_Order_Avg_Fields = {
  __typename?: 'campaign_order_avg_fields';
  budget?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "campaign.order". All fields are combined with a logical 'AND'. */
export type Campaign_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Order_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Order_Bool_Exp>>;
  additional_properties?: InputMaybe<Jsonb_Comparison_Exp>;
  budget?: InputMaybe<Numeric_Comparison_Exp>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  created_campaign?: InputMaybe<Uuid_Comparison_Exp>;
  customer?: InputMaybe<Organization_Bool_Exp>;
  customer_org_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_from?: InputMaybe<Uuid_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  platform_job_id?: InputMaybe<String_Comparison_Exp>;
  posted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  received_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  responsible_user?: InputMaybe<Bpchar_Comparison_Exp>;
  source?: InputMaybe<Campaign_Order_Source_Bool_Exp>;
  target_locations?: InputMaybe<Jsonb_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "campaign". */
export type Campaign_Order_By = {
  ad_campaign_metrics_aggregate?: InputMaybe<Ad_Campaign_Metrics_Aggregate_Order_By>;
  ads_aggregate?: InputMaybe<Campaign_Ad_Aggregate_Order_By>;
  ads_email_list?: InputMaybe<Order_By>;
  applicant_board_enabled?: InputMaybe<Order_By>;
  applicants_email_list?: InputMaybe<Order_By>;
  bot_consent?: InputMaybe<Order_By>;
  c_location?: InputMaybe<Organization_Location_Order_By>;
  call_campaign_aggregate?: InputMaybe<Anna_Ai_Call_Campaigns_Aggregate_Order_By>;
  campaign_events_aggregate?: InputMaybe<Campaign_Event_Log_Aggregate_Order_By>;
  campaign_status?: InputMaybe<Campaign_Status_Order_By>;
  campaign_work_location?: InputMaybe<Campaign_Work_Location_Order_By>;
  category?: InputMaybe<Order_By>;
  chat_bot_enabled?: InputMaybe<Order_By>;
  chat_bot_is_ko?: InputMaybe<Order_By>;
  chat_bot_v2_enabled?: InputMaybe<Order_By>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Order_By>;
  contacts_per_day_aggregate?: InputMaybe<New_Contacts_Per_Day_Aggregate_Order_By>;
  cost_per_lead?: InputMaybe<Order_By>;
  cost_per_lead_customer?: InputMaybe<Order_By>;
  customer_budget_bonus?: InputMaybe<Order_By>;
  customer_budget_initial?: InputMaybe<Order_By>;
  customer_budget_total?: InputMaybe<Order_By>;
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  email_template_overwrite?: InputMaybe<Campaign_Email_Template_Overwrite_Order_By>;
  end?: InputMaybe<Order_By>;
  forwarding?: InputMaybe<Chat_Bot_Forwarding_Order_By>;
  funnel?: InputMaybe<Funnel_Funnels_Order_By>;
  funnel_insights?: InputMaybe<Funnel_Insights_Order_By>;
  funnel_page_insights_aggregate?: InputMaybe<Funnel_Page_Insights_Aggregate_Order_By>;
  funnel_whatsapp_share_clicks_aggregate?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_hidden?: InputMaybe<Order_By>;
  is_test?: InputMaybe<Order_By>;
  job_posting_text?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  location_slug?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
  media_budget?: InputMaybe<Order_By>;
  meistertask_url?: InputMaybe<Order_By>;
  monday_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_settings_override?: InputMaybe<Campaign_Settings_Override_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  origin_contacts_aggregate?: InputMaybe<Contact_Aggregate_Order_By>;
  pdf_enabled?: InputMaybe<Order_By>;
  perspective_campaign?: InputMaybe<Perspective_Campaign_Order_By>;
  perspective_campaign_id?: InputMaybe<Order_By>;
  phone_number_default_region?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  questions_aggregate?: InputMaybe<Funnel_Question_Aggregate_Order_By>;
  remaining_customer_budget?: InputMaybe<Order_By>;
  responsible_person?: InputMaybe<Order_By>;
  rms_connector?: InputMaybe<Rms_Connectors_Order_By>;
  routing_info?: InputMaybe<Campaign_Routing_Info_Order_By>;
  short_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_log_aggregate?: InputMaybe<Campaign_Status_Log_Aggregate_Order_By>;
  status_override?: InputMaybe<Order_By>;
  support_email?: InputMaybe<Order_By>;
  transactions_aggregate?: InputMaybe<Campaign_Budget_Transaction_Aggregate_Order_By>;
  unqualified_contacts_per_day_aggregate?: InputMaybe<New_Unqualified_Contacts_Per_Day_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_location?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "campaign.order" */
export enum Campaign_Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderPkey = 'order_pkey',
  /** unique or primary key constraint on columns "imported_from", "platform_job_id" */
  OrderPlatformJobIdImportedFromKey = 'order_platform_job_id_imported_from_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Campaign_Order_Delete_At_Path_Input = {
  additional_properties?: InputMaybe<Array<Scalars['String']['input']>>;
  target_locations?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Campaign_Order_Delete_Elem_Input = {
  additional_properties?: InputMaybe<Scalars['Int']['input']>;
  target_locations?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Campaign_Order_Delete_Key_Input = {
  additional_properties?: InputMaybe<Scalars['String']['input']>;
  target_locations?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "campaign.order" */
export type Campaign_Order_Inc_Input = {
  budget?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "campaign.order" */
export type Campaign_Order_Insert_Input = {
  additional_properties?: InputMaybe<Scalars['jsonb']['input']>;
  budget?: InputMaybe<Scalars['numeric']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_campaign?: InputMaybe<Scalars['uuid']['input']>;
  customer?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  customer_org_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_from?: InputMaybe<Scalars['uuid']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform_job_id?: InputMaybe<Scalars['String']['input']>;
  posted_at?: InputMaybe<Scalars['timestamp']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  responsible_user?: InputMaybe<Scalars['bpchar']['input']>;
  source?: InputMaybe<Campaign_Order_Source_Obj_Rel_Insert_Input>;
  target_locations?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Order_Max_Fields = {
  __typename?: 'campaign_order_max_fields';
  budget?: Maybe<Scalars['numeric']['output']>;
  created_campaign?: Maybe<Scalars['uuid']['output']>;
  customer_org_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_from?: Maybe<Scalars['uuid']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  platform_job_id?: Maybe<Scalars['String']['output']>;
  posted_at?: Maybe<Scalars['timestamp']['output']>;
  received_at?: Maybe<Scalars['timestamptz']['output']>;
  responsible_user?: Maybe<Scalars['bpchar']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Order_Min_Fields = {
  __typename?: 'campaign_order_min_fields';
  budget?: Maybe<Scalars['numeric']['output']>;
  created_campaign?: Maybe<Scalars['uuid']['output']>;
  customer_org_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_from?: Maybe<Scalars['uuid']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  platform_job_id?: Maybe<Scalars['String']['output']>;
  posted_at?: Maybe<Scalars['timestamp']['output']>;
  received_at?: Maybe<Scalars['timestamptz']['output']>;
  responsible_user?: Maybe<Scalars['bpchar']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign.order" */
export type Campaign_Order_Mutation_Response = {
  __typename?: 'campaign_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Order>;
};

/** on_conflict condition type for table "campaign.order" */
export type Campaign_Order_On_Conflict = {
  constraint: Campaign_Order_Constraint;
  update_columns?: Array<Campaign_Order_Update_Column>;
  where?: InputMaybe<Campaign_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.order". */
export type Campaign_Order_Order_By = {
  additional_properties?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  completed?: InputMaybe<Order_By>;
  created_campaign?: InputMaybe<Order_By>;
  customer?: InputMaybe<Organization_Order_By>;
  customer_org_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_from?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  platform_job_id?: InputMaybe<Order_By>;
  posted_at?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  responsible_user?: InputMaybe<Order_By>;
  source?: InputMaybe<Campaign_Order_Source_Order_By>;
  target_locations?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.order */
export type Campaign_Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Campaign_Order_Prepend_Input = {
  additional_properties?: InputMaybe<Scalars['jsonb']['input']>;
  target_locations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "campaign.order" */
export enum Campaign_Order_Select_Column {
  /** column name */
  AdditionalProperties = 'additional_properties',
  /** column name */
  Budget = 'budget',
  /** column name */
  Completed = 'completed',
  /** column name */
  CreatedCampaign = 'created_campaign',
  /** column name */
  CustomerOrgId = 'customer_org_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedFrom = 'imported_from',
  /** column name */
  Link = 'link',
  /** column name */
  PlatformJobId = 'platform_job_id',
  /** column name */
  PostedAt = 'posted_at',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  ResponsibleUser = 'responsible_user',
  /** column name */
  TargetLocations = 'target_locations',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "campaign.order" */
export type Campaign_Order_Set_Input = {
  additional_properties?: InputMaybe<Scalars['jsonb']['input']>;
  budget?: InputMaybe<Scalars['numeric']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_campaign?: InputMaybe<Scalars['uuid']['input']>;
  customer_org_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_from?: InputMaybe<Scalars['uuid']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform_job_id?: InputMaybe<Scalars['String']['input']>;
  posted_at?: InputMaybe<Scalars['timestamp']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  responsible_user?: InputMaybe<Scalars['bpchar']['input']>;
  target_locations?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Contains sources (xml feeds etc.) to import job postings from */
export type Campaign_Order_Source = {
  __typename?: 'campaign_order_source';
  campaign_budget: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  source_type: Campaign_Order_Source_Type_Enum;
  url: Scalars['String']['output'];
};

/** aggregated selection of "campaign.order_source" */
export type Campaign_Order_Source_Aggregate = {
  __typename?: 'campaign_order_source_aggregate';
  aggregate?: Maybe<Campaign_Order_Source_Aggregate_Fields>;
  nodes: Array<Campaign_Order_Source>;
};

/** aggregate fields of "campaign.order_source" */
export type Campaign_Order_Source_Aggregate_Fields = {
  __typename?: 'campaign_order_source_aggregate_fields';
  avg?: Maybe<Campaign_Order_Source_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Order_Source_Max_Fields>;
  min?: Maybe<Campaign_Order_Source_Min_Fields>;
  stddev?: Maybe<Campaign_Order_Source_Stddev_Fields>;
  stddev_pop?: Maybe<Campaign_Order_Source_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campaign_Order_Source_Stddev_Samp_Fields>;
  sum?: Maybe<Campaign_Order_Source_Sum_Fields>;
  var_pop?: Maybe<Campaign_Order_Source_Var_Pop_Fields>;
  var_samp?: Maybe<Campaign_Order_Source_Var_Samp_Fields>;
  variance?: Maybe<Campaign_Order_Source_Variance_Fields>;
};


/** aggregate fields of "campaign.order_source" */
export type Campaign_Order_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Order_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Campaign_Order_Source_Avg_Fields = {
  __typename?: 'campaign_order_source_avg_fields';
  campaign_budget?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "campaign.order_source". All fields are combined with a logical 'AND'. */
export type Campaign_Order_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Order_Source_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Order_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Order_Source_Bool_Exp>>;
  campaign_budget?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
  source_type?: InputMaybe<Campaign_Order_Source_Type_Enum_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.order_source" */
export enum Campaign_Order_Source_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderSourcePkey = 'order_source_pkey'
}

/** input type for incrementing numeric columns in table "campaign.order_source" */
export type Campaign_Order_Source_Inc_Input = {
  campaign_budget?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "campaign.order_source" */
export type Campaign_Order_Source_Insert_Input = {
  campaign_budget?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  source_type?: InputMaybe<Campaign_Order_Source_Type_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Order_Source_Max_Fields = {
  __typename?: 'campaign_order_source_max_fields';
  campaign_budget?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Order_Source_Min_Fields = {
  __typename?: 'campaign_order_source_min_fields';
  campaign_budget?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign.order_source" */
export type Campaign_Order_Source_Mutation_Response = {
  __typename?: 'campaign_order_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Order_Source>;
};

/** input type for inserting object relation for remote table "campaign.order_source" */
export type Campaign_Order_Source_Obj_Rel_Insert_Input = {
  data: Campaign_Order_Source_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Order_Source_On_Conflict>;
};

/** on_conflict condition type for table "campaign.order_source" */
export type Campaign_Order_Source_On_Conflict = {
  constraint: Campaign_Order_Source_Constraint;
  update_columns?: Array<Campaign_Order_Source_Update_Column>;
  where?: InputMaybe<Campaign_Order_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.order_source". */
export type Campaign_Order_Source_Order_By = {
  campaign_budget?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  source_type?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.order_source */
export type Campaign_Order_Source_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "campaign.order_source" */
export enum Campaign_Order_Source_Select_Column {
  /** column name */
  CampaignBudget = 'campaign_budget',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  SourceType = 'source_type',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "campaign.order_source" */
export type Campaign_Order_Source_Set_Input = {
  campaign_budget?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  source_type?: InputMaybe<Campaign_Order_Source_Type_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Campaign_Order_Source_Stddev_Fields = {
  __typename?: 'campaign_order_source_stddev_fields';
  campaign_budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Campaign_Order_Source_Stddev_Pop_Fields = {
  __typename?: 'campaign_order_source_stddev_pop_fields';
  campaign_budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Campaign_Order_Source_Stddev_Samp_Fields = {
  __typename?: 'campaign_order_source_stddev_samp_fields';
  campaign_budget?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "campaign_order_source" */
export type Campaign_Order_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Order_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Order_Source_Stream_Cursor_Value_Input = {
  campaign_budget?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  source_type?: InputMaybe<Campaign_Order_Source_Type_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Campaign_Order_Source_Sum_Fields = {
  __typename?: 'campaign_order_source_sum_fields';
  campaign_budget?: Maybe<Scalars['numeric']['output']>;
};

/** Enum of possible job posting sources */
export type Campaign_Order_Source_Type = {
  __typename?: 'campaign_order_source_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "campaign.order_source_type" */
export type Campaign_Order_Source_Type_Aggregate = {
  __typename?: 'campaign_order_source_type_aggregate';
  aggregate?: Maybe<Campaign_Order_Source_Type_Aggregate_Fields>;
  nodes: Array<Campaign_Order_Source_Type>;
};

/** aggregate fields of "campaign.order_source_type" */
export type Campaign_Order_Source_Type_Aggregate_Fields = {
  __typename?: 'campaign_order_source_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Order_Source_Type_Max_Fields>;
  min?: Maybe<Campaign_Order_Source_Type_Min_Fields>;
};


/** aggregate fields of "campaign.order_source_type" */
export type Campaign_Order_Source_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Order_Source_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "campaign.order_source_type". All fields are combined with a logical 'AND'. */
export type Campaign_Order_Source_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Order_Source_Type_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Order_Source_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Order_Source_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.order_source_type" */
export enum Campaign_Order_Source_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  OrderSourceTypePkey = 'order_source_type_pkey'
}

export enum Campaign_Order_Source_Type_Enum {
  Amrest = 'AMREST',
  HrXml = 'HR_XML',
  Jobcluster = 'JOBCLUSTER',
  Manual = 'MANUAL',
  Softgarden = 'SOFTGARDEN'
}

/** Boolean expression to compare columns of type "campaign_order_source_type_enum". All fields are combined with logical 'AND'. */
export type Campaign_Order_Source_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Campaign_Order_Source_Type_Enum>;
  _in?: InputMaybe<Array<Campaign_Order_Source_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Campaign_Order_Source_Type_Enum>;
  _nin?: InputMaybe<Array<Campaign_Order_Source_Type_Enum>>;
};

/** input type for inserting data into table "campaign.order_source_type" */
export type Campaign_Order_Source_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Order_Source_Type_Max_Fields = {
  __typename?: 'campaign_order_source_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Order_Source_Type_Min_Fields = {
  __typename?: 'campaign_order_source_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign.order_source_type" */
export type Campaign_Order_Source_Type_Mutation_Response = {
  __typename?: 'campaign_order_source_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Order_Source_Type>;
};

/** on_conflict condition type for table "campaign.order_source_type" */
export type Campaign_Order_Source_Type_On_Conflict = {
  constraint: Campaign_Order_Source_Type_Constraint;
  update_columns?: Array<Campaign_Order_Source_Type_Update_Column>;
  where?: InputMaybe<Campaign_Order_Source_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.order_source_type". */
export type Campaign_Order_Source_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.order_source_type */
export type Campaign_Order_Source_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "campaign.order_source_type" */
export enum Campaign_Order_Source_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "campaign.order_source_type" */
export type Campaign_Order_Source_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "campaign_order_source_type" */
export type Campaign_Order_Source_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Order_Source_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Order_Source_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "campaign.order_source_type" */
export enum Campaign_Order_Source_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Campaign_Order_Source_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Order_Source_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Order_Source_Type_Bool_Exp;
};

/** update columns of table "campaign.order_source" */
export enum Campaign_Order_Source_Update_Column {
  /** column name */
  CampaignBudget = 'campaign_budget',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  SourceType = 'source_type',
  /** column name */
  Url = 'url'
}

export type Campaign_Order_Source_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Campaign_Order_Source_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Order_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Order_Source_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campaign_Order_Source_Var_Pop_Fields = {
  __typename?: 'campaign_order_source_var_pop_fields';
  campaign_budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Campaign_Order_Source_Var_Samp_Fields = {
  __typename?: 'campaign_order_source_var_samp_fields';
  campaign_budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Campaign_Order_Source_Variance_Fields = {
  __typename?: 'campaign_order_source_variance_fields';
  campaign_budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev on columns */
export type Campaign_Order_Stddev_Fields = {
  __typename?: 'campaign_order_stddev_fields';
  budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Campaign_Order_Stddev_Pop_Fields = {
  __typename?: 'campaign_order_stddev_pop_fields';
  budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Campaign_Order_Stddev_Samp_Fields = {
  __typename?: 'campaign_order_stddev_samp_fields';
  budget?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "campaign_order" */
export type Campaign_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Order_Stream_Cursor_Value_Input = {
  additional_properties?: InputMaybe<Scalars['jsonb']['input']>;
  budget?: InputMaybe<Scalars['numeric']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_campaign?: InputMaybe<Scalars['uuid']['input']>;
  customer_org_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_from?: InputMaybe<Scalars['uuid']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform_job_id?: InputMaybe<Scalars['String']['input']>;
  posted_at?: InputMaybe<Scalars['timestamp']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  responsible_user?: InputMaybe<Scalars['bpchar']['input']>;
  target_locations?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Campaign_Order_Sum_Fields = {
  __typename?: 'campaign_order_sum_fields';
  budget?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "campaign.order" */
export enum Campaign_Order_Update_Column {
  /** column name */
  AdditionalProperties = 'additional_properties',
  /** column name */
  Budget = 'budget',
  /** column name */
  Completed = 'completed',
  /** column name */
  CreatedCampaign = 'created_campaign',
  /** column name */
  CustomerOrgId = 'customer_org_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedFrom = 'imported_from',
  /** column name */
  Link = 'link',
  /** column name */
  PlatformJobId = 'platform_job_id',
  /** column name */
  PostedAt = 'posted_at',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  ResponsibleUser = 'responsible_user',
  /** column name */
  TargetLocations = 'target_locations',
  /** column name */
  Title = 'title'
}

export type Campaign_Order_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Campaign_Order_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Campaign_Order_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Campaign_Order_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Campaign_Order_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Campaign_Order_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Campaign_Order_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campaign_Order_Var_Pop_Fields = {
  __typename?: 'campaign_order_var_pop_fields';
  budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Campaign_Order_Var_Samp_Fields = {
  __typename?: 'campaign_order_var_samp_fields';
  budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Campaign_Order_Variance_Fields = {
  __typename?: 'campaign_order_variance_fields';
  budget?: Maybe<Scalars['Float']['output']>;
};

/** primary key columns input for table: campaign */
export type Campaign_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "campaign_routing.destination" */
export type Campaign_Routing_Destination = {
  __typename?: 'campaign_routing_destination';
  /** An object relationship */
  campaign?: Maybe<Campaign>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  location_id: Scalars['Int']['output'];
  location_name?: Maybe<Scalars['String']['output']>;
  meistertask_board_id?: Maybe<Scalars['bpchar']['output']>;
  meistertask_qualified_column?: Maybe<Scalars['bpchar']['output']>;
  meistertask_unqualified_column?: Maybe<Scalars['bpchar']['output']>;
  trello_board_id: Scalars['bpchar']['output'];
  trello_qualified_column: Scalars['bpchar']['output'];
  trello_unqualified_column: Scalars['bpchar']['output'];
  type: Scalars['String']['output'];
};

/** aggregated selection of "campaign_routing.destination" */
export type Campaign_Routing_Destination_Aggregate = {
  __typename?: 'campaign_routing_destination_aggregate';
  aggregate?: Maybe<Campaign_Routing_Destination_Aggregate_Fields>;
  nodes: Array<Campaign_Routing_Destination>;
};

export type Campaign_Routing_Destination_Aggregate_Bool_Exp = {
  count?: InputMaybe<Campaign_Routing_Destination_Aggregate_Bool_Exp_Count>;
};

export type Campaign_Routing_Destination_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Campaign_Routing_Destination_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "campaign_routing.destination" */
export type Campaign_Routing_Destination_Aggregate_Fields = {
  __typename?: 'campaign_routing_destination_aggregate_fields';
  avg?: Maybe<Campaign_Routing_Destination_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Routing_Destination_Max_Fields>;
  min?: Maybe<Campaign_Routing_Destination_Min_Fields>;
  stddev?: Maybe<Campaign_Routing_Destination_Stddev_Fields>;
  stddev_pop?: Maybe<Campaign_Routing_Destination_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campaign_Routing_Destination_Stddev_Samp_Fields>;
  sum?: Maybe<Campaign_Routing_Destination_Sum_Fields>;
  var_pop?: Maybe<Campaign_Routing_Destination_Var_Pop_Fields>;
  var_samp?: Maybe<Campaign_Routing_Destination_Var_Samp_Fields>;
  variance?: Maybe<Campaign_Routing_Destination_Variance_Fields>;
};


/** aggregate fields of "campaign_routing.destination" */
export type Campaign_Routing_Destination_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Routing_Destination_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Aggregate_Order_By = {
  avg?: InputMaybe<Campaign_Routing_Destination_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Campaign_Routing_Destination_Max_Order_By>;
  min?: InputMaybe<Campaign_Routing_Destination_Min_Order_By>;
  stddev?: InputMaybe<Campaign_Routing_Destination_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Campaign_Routing_Destination_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Campaign_Routing_Destination_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Campaign_Routing_Destination_Sum_Order_By>;
  var_pop?: InputMaybe<Campaign_Routing_Destination_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Campaign_Routing_Destination_Var_Samp_Order_By>;
  variance?: InputMaybe<Campaign_Routing_Destination_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Arr_Rel_Insert_Input = {
  data: Array<Campaign_Routing_Destination_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Routing_Destination_On_Conflict>;
};

/** aggregate avg on columns */
export type Campaign_Routing_Destination_Avg_Fields = {
  __typename?: 'campaign_routing_destination_avg_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Avg_Order_By = {
  location_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "campaign_routing.destination". All fields are combined with a logical 'AND'. */
export type Campaign_Routing_Destination_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Routing_Destination_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Routing_Destination_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  location_id?: InputMaybe<Int_Comparison_Exp>;
  location_name?: InputMaybe<String_Comparison_Exp>;
  meistertask_board_id?: InputMaybe<Bpchar_Comparison_Exp>;
  meistertask_qualified_column?: InputMaybe<Bpchar_Comparison_Exp>;
  meistertask_unqualified_column?: InputMaybe<Bpchar_Comparison_Exp>;
  trello_board_id?: InputMaybe<Bpchar_Comparison_Exp>;
  trello_qualified_column?: InputMaybe<Bpchar_Comparison_Exp>;
  trello_unqualified_column?: InputMaybe<Bpchar_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign_routing.destination" */
export enum Campaign_Routing_Destination_Constraint {
  /** unique or primary key constraint on columns "type", "location_id" */
  DestinationPkey = 'destination_pkey'
}

/** input type for incrementing numeric columns in table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Inc_Input = {
  location_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  meistertask_board_id?: InputMaybe<Scalars['bpchar']['input']>;
  meistertask_qualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  meistertask_unqualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  trello_board_id?: InputMaybe<Scalars['bpchar']['input']>;
  trello_qualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  trello_unqualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Routing_Destination_Max_Fields = {
  __typename?: 'campaign_routing_destination_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  location_id?: Maybe<Scalars['Int']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  meistertask_board_id?: Maybe<Scalars['bpchar']['output']>;
  meistertask_qualified_column?: Maybe<Scalars['bpchar']['output']>;
  meistertask_unqualified_column?: Maybe<Scalars['bpchar']['output']>;
  trello_board_id?: Maybe<Scalars['bpchar']['output']>;
  trello_qualified_column?: Maybe<Scalars['bpchar']['output']>;
  trello_unqualified_column?: Maybe<Scalars['bpchar']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  meistertask_board_id?: InputMaybe<Order_By>;
  meistertask_qualified_column?: InputMaybe<Order_By>;
  meistertask_unqualified_column?: InputMaybe<Order_By>;
  trello_board_id?: InputMaybe<Order_By>;
  trello_qualified_column?: InputMaybe<Order_By>;
  trello_unqualified_column?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Campaign_Routing_Destination_Min_Fields = {
  __typename?: 'campaign_routing_destination_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  location_id?: Maybe<Scalars['Int']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  meistertask_board_id?: Maybe<Scalars['bpchar']['output']>;
  meistertask_qualified_column?: Maybe<Scalars['bpchar']['output']>;
  meistertask_unqualified_column?: Maybe<Scalars['bpchar']['output']>;
  trello_board_id?: Maybe<Scalars['bpchar']['output']>;
  trello_qualified_column?: Maybe<Scalars['bpchar']['output']>;
  trello_unqualified_column?: Maybe<Scalars['bpchar']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  meistertask_board_id?: InputMaybe<Order_By>;
  meistertask_qualified_column?: InputMaybe<Order_By>;
  meistertask_unqualified_column?: InputMaybe<Order_By>;
  trello_board_id?: InputMaybe<Order_By>;
  trello_qualified_column?: InputMaybe<Order_By>;
  trello_unqualified_column?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Mutation_Response = {
  __typename?: 'campaign_routing_destination_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Routing_Destination>;
};

/** on_conflict condition type for table "campaign_routing.destination" */
export type Campaign_Routing_Destination_On_Conflict = {
  constraint: Campaign_Routing_Destination_Constraint;
  update_columns?: Array<Campaign_Routing_Destination_Update_Column>;
  where?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign_routing.destination". */
export type Campaign_Routing_Destination_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  meistertask_board_id?: InputMaybe<Order_By>;
  meistertask_qualified_column?: InputMaybe<Order_By>;
  meistertask_unqualified_column?: InputMaybe<Order_By>;
  trello_board_id?: InputMaybe<Order_By>;
  trello_qualified_column?: InputMaybe<Order_By>;
  trello_unqualified_column?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign_routing.destination */
export type Campaign_Routing_Destination_Pk_Columns_Input = {
  location_id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

/** select columns of table "campaign_routing.destination" */
export enum Campaign_Routing_Destination_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LocationName = 'location_name',
  /** column name */
  MeistertaskBoardId = 'meistertask_board_id',
  /** column name */
  MeistertaskQualifiedColumn = 'meistertask_qualified_column',
  /** column name */
  MeistertaskUnqualifiedColumn = 'meistertask_unqualified_column',
  /** column name */
  TrelloBoardId = 'trello_board_id',
  /** column name */
  TrelloQualifiedColumn = 'trello_qualified_column',
  /** column name */
  TrelloUnqualifiedColumn = 'trello_unqualified_column',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  meistertask_board_id?: InputMaybe<Scalars['bpchar']['input']>;
  meistertask_qualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  meistertask_unqualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  trello_board_id?: InputMaybe<Scalars['bpchar']['input']>;
  trello_qualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  trello_unqualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Campaign_Routing_Destination_Stddev_Fields = {
  __typename?: 'campaign_routing_destination_stddev_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Stddev_Order_By = {
  location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Campaign_Routing_Destination_Stddev_Pop_Fields = {
  __typename?: 'campaign_routing_destination_stddev_pop_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Stddev_Pop_Order_By = {
  location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Campaign_Routing_Destination_Stddev_Samp_Fields = {
  __typename?: 'campaign_routing_destination_stddev_samp_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Stddev_Samp_Order_By = {
  location_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "campaign_routing_destination" */
export type Campaign_Routing_Destination_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Routing_Destination_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Routing_Destination_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  meistertask_board_id?: InputMaybe<Scalars['bpchar']['input']>;
  meistertask_qualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  meistertask_unqualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  trello_board_id?: InputMaybe<Scalars['bpchar']['input']>;
  trello_qualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  trello_unqualified_column?: InputMaybe<Scalars['bpchar']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Campaign_Routing_Destination_Sum_Fields = {
  __typename?: 'campaign_routing_destination_sum_fields';
  location_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Sum_Order_By = {
  location_id?: InputMaybe<Order_By>;
};

/** update columns of table "campaign_routing.destination" */
export enum Campaign_Routing_Destination_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LocationName = 'location_name',
  /** column name */
  MeistertaskBoardId = 'meistertask_board_id',
  /** column name */
  MeistertaskQualifiedColumn = 'meistertask_qualified_column',
  /** column name */
  MeistertaskUnqualifiedColumn = 'meistertask_unqualified_column',
  /** column name */
  TrelloBoardId = 'trello_board_id',
  /** column name */
  TrelloQualifiedColumn = 'trello_qualified_column',
  /** column name */
  TrelloUnqualifiedColumn = 'trello_unqualified_column',
  /** column name */
  Type = 'type'
}

export type Campaign_Routing_Destination_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Campaign_Routing_Destination_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Routing_Destination_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Routing_Destination_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campaign_Routing_Destination_Var_Pop_Fields = {
  __typename?: 'campaign_routing_destination_var_pop_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Var_Pop_Order_By = {
  location_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Campaign_Routing_Destination_Var_Samp_Fields = {
  __typename?: 'campaign_routing_destination_var_samp_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Var_Samp_Order_By = {
  location_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Campaign_Routing_Destination_Variance_Fields = {
  __typename?: 'campaign_routing_destination_variance_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "campaign_routing.destination" */
export type Campaign_Routing_Destination_Variance_Order_By = {
  location_id?: InputMaybe<Order_By>;
};

/** Contains additional info required when zip code routing is enabled for a campaign */
export type Campaign_Routing_Info = {
  __typename?: 'campaign_routing_info';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  forwarding_webhook: Scalars['String']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  location_id?: Maybe<Scalars['Int']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
  office_id?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** aggregated selection of "campaign_routing.info" */
export type Campaign_Routing_Info_Aggregate = {
  __typename?: 'campaign_routing_info_aggregate';
  aggregate?: Maybe<Campaign_Routing_Info_Aggregate_Fields>;
  nodes: Array<Campaign_Routing_Info>;
};

/** aggregate fields of "campaign_routing.info" */
export type Campaign_Routing_Info_Aggregate_Fields = {
  __typename?: 'campaign_routing_info_aggregate_fields';
  avg?: Maybe<Campaign_Routing_Info_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Routing_Info_Max_Fields>;
  min?: Maybe<Campaign_Routing_Info_Min_Fields>;
  stddev?: Maybe<Campaign_Routing_Info_Stddev_Fields>;
  stddev_pop?: Maybe<Campaign_Routing_Info_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campaign_Routing_Info_Stddev_Samp_Fields>;
  sum?: Maybe<Campaign_Routing_Info_Sum_Fields>;
  var_pop?: Maybe<Campaign_Routing_Info_Var_Pop_Fields>;
  var_samp?: Maybe<Campaign_Routing_Info_Var_Samp_Fields>;
  variance?: Maybe<Campaign_Routing_Info_Variance_Fields>;
};


/** aggregate fields of "campaign_routing.info" */
export type Campaign_Routing_Info_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Routing_Info_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Campaign_Routing_Info_Avg_Fields = {
  __typename?: 'campaign_routing_info_avg_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "campaign_routing.info". All fields are combined with a logical 'AND'. */
export type Campaign_Routing_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Routing_Info_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Routing_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Routing_Info_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  forwarding_webhook?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  location_id?: InputMaybe<Int_Comparison_Exp>;
  make_id?: InputMaybe<Int_Comparison_Exp>;
  office_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign_routing.info" */
export enum Campaign_Routing_Info_Constraint {
  /** unique or primary key constraint on columns "campaign_id" */
  CampaignInfoPkey = 'campaign_info_pkey'
}

/** input type for incrementing numeric columns in table "campaign_routing.info" */
export type Campaign_Routing_Info_Inc_Input = {
  location_id?: InputMaybe<Scalars['Int']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "campaign_routing.info" */
export type Campaign_Routing_Info_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  forwarding_webhook?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
  office_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Routing_Info_Max_Fields = {
  __typename?: 'campaign_routing_info_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  forwarding_webhook?: Maybe<Scalars['String']['output']>;
  location_id?: Maybe<Scalars['Int']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
  office_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Routing_Info_Min_Fields = {
  __typename?: 'campaign_routing_info_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  forwarding_webhook?: Maybe<Scalars['String']['output']>;
  location_id?: Maybe<Scalars['Int']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
  office_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign_routing.info" */
export type Campaign_Routing_Info_Mutation_Response = {
  __typename?: 'campaign_routing_info_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Routing_Info>;
};

/** input type for inserting object relation for remote table "campaign_routing.info" */
export type Campaign_Routing_Info_Obj_Rel_Insert_Input = {
  data: Campaign_Routing_Info_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Routing_Info_On_Conflict>;
};

/** on_conflict condition type for table "campaign_routing.info" */
export type Campaign_Routing_Info_On_Conflict = {
  constraint: Campaign_Routing_Info_Constraint;
  update_columns?: Array<Campaign_Routing_Info_Update_Column>;
  where?: InputMaybe<Campaign_Routing_Info_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign_routing.info". */
export type Campaign_Routing_Info_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  forwarding_webhook?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  office_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign_routing.info */
export type Campaign_Routing_Info_Pk_Columns_Input = {
  campaign_id: Scalars['uuid']['input'];
};

/** select columns of table "campaign_routing.info" */
export enum Campaign_Routing_Info_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ForwardingWebhook = 'forwarding_webhook',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MakeId = 'make_id',
  /** column name */
  OfficeId = 'office_id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "campaign_routing.info" */
export type Campaign_Routing_Info_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  forwarding_webhook?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
  office_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Campaign_Routing_Info_Stddev_Fields = {
  __typename?: 'campaign_routing_info_stddev_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Campaign_Routing_Info_Stddev_Pop_Fields = {
  __typename?: 'campaign_routing_info_stddev_pop_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Campaign_Routing_Info_Stddev_Samp_Fields = {
  __typename?: 'campaign_routing_info_stddev_samp_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "campaign_routing_info" */
export type Campaign_Routing_Info_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Routing_Info_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Routing_Info_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  forwarding_webhook?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
  office_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Campaign_Routing_Info_Sum_Fields = {
  __typename?: 'campaign_routing_info_sum_fields';
  location_id?: Maybe<Scalars['Int']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "campaign_routing.info" */
export enum Campaign_Routing_Info_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ForwardingWebhook = 'forwarding_webhook',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MakeId = 'make_id',
  /** column name */
  OfficeId = 'office_id',
  /** column name */
  Type = 'type'
}

export type Campaign_Routing_Info_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Campaign_Routing_Info_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Routing_Info_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Routing_Info_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campaign_Routing_Info_Var_Pop_Fields = {
  __typename?: 'campaign_routing_info_var_pop_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Campaign_Routing_Info_Var_Samp_Fields = {
  __typename?: 'campaign_routing_info_var_samp_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Campaign_Routing_Info_Variance_Fields = {
  __typename?: 'campaign_routing_info_variance_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "campaign_routing.zipcode" */
export type Campaign_Routing_Zipcode = {
  __typename?: 'campaign_routing_zipcode';
  /** An array relationship */
  destinations: Array<Campaign_Routing_Destination>;
  /** An aggregate relationship */
  destinations_aggregate: Campaign_Routing_Destination_Aggregate;
  kdb_office_id?: Maybe<Scalars['String']['output']>;
  location_id: Scalars['Int']['output'];
  organization_id: Scalars['String']['output'];
  vmb_office_id?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['bpchar']['output'];
};


/** columns and relationships of "campaign_routing.zipcode" */
export type Campaign_Routing_ZipcodeDestinationsArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Destination_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Destination_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
};


/** columns and relationships of "campaign_routing.zipcode" */
export type Campaign_Routing_ZipcodeDestinations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Destination_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Destination_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
};

/** aggregated selection of "campaign_routing.zipcode" */
export type Campaign_Routing_Zipcode_Aggregate = {
  __typename?: 'campaign_routing_zipcode_aggregate';
  aggregate?: Maybe<Campaign_Routing_Zipcode_Aggregate_Fields>;
  nodes: Array<Campaign_Routing_Zipcode>;
};

/** aggregate fields of "campaign_routing.zipcode" */
export type Campaign_Routing_Zipcode_Aggregate_Fields = {
  __typename?: 'campaign_routing_zipcode_aggregate_fields';
  avg?: Maybe<Campaign_Routing_Zipcode_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Routing_Zipcode_Max_Fields>;
  min?: Maybe<Campaign_Routing_Zipcode_Min_Fields>;
  stddev?: Maybe<Campaign_Routing_Zipcode_Stddev_Fields>;
  stddev_pop?: Maybe<Campaign_Routing_Zipcode_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campaign_Routing_Zipcode_Stddev_Samp_Fields>;
  sum?: Maybe<Campaign_Routing_Zipcode_Sum_Fields>;
  var_pop?: Maybe<Campaign_Routing_Zipcode_Var_Pop_Fields>;
  var_samp?: Maybe<Campaign_Routing_Zipcode_Var_Samp_Fields>;
  variance?: Maybe<Campaign_Routing_Zipcode_Variance_Fields>;
};


/** aggregate fields of "campaign_routing.zipcode" */
export type Campaign_Routing_Zipcode_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Routing_Zipcode_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Campaign_Routing_Zipcode_Avg_Fields = {
  __typename?: 'campaign_routing_zipcode_avg_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "campaign_routing.zipcode". All fields are combined with a logical 'AND'. */
export type Campaign_Routing_Zipcode_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Routing_Zipcode_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Routing_Zipcode_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Routing_Zipcode_Bool_Exp>>;
  destinations?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
  destinations_aggregate?: InputMaybe<Campaign_Routing_Destination_Aggregate_Bool_Exp>;
  kdb_office_id?: InputMaybe<String_Comparison_Exp>;
  location_id?: InputMaybe<Int_Comparison_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
  vmb_office_id?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign_routing.zipcode" */
export enum Campaign_Routing_Zipcode_Constraint {
  /** unique or primary key constraint on columns "zipcode", "organization_id" */
  ZipcodePkey = 'zipcode_pkey'
}

/** input type for incrementing numeric columns in table "campaign_routing.zipcode" */
export type Campaign_Routing_Zipcode_Inc_Input = {
  location_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "campaign_routing.zipcode" */
export type Campaign_Routing_Zipcode_Insert_Input = {
  destinations?: InputMaybe<Campaign_Routing_Destination_Arr_Rel_Insert_Input>;
  kdb_office_id?: InputMaybe<Scalars['String']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  vmb_office_id?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Campaign_Routing_Zipcode_Max_Fields = {
  __typename?: 'campaign_routing_zipcode_max_fields';
  kdb_office_id?: Maybe<Scalars['String']['output']>;
  location_id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  vmb_office_id?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Campaign_Routing_Zipcode_Min_Fields = {
  __typename?: 'campaign_routing_zipcode_min_fields';
  kdb_office_id?: Maybe<Scalars['String']['output']>;
  location_id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  vmb_office_id?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "campaign_routing.zipcode" */
export type Campaign_Routing_Zipcode_Mutation_Response = {
  __typename?: 'campaign_routing_zipcode_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Routing_Zipcode>;
};

/** on_conflict condition type for table "campaign_routing.zipcode" */
export type Campaign_Routing_Zipcode_On_Conflict = {
  constraint: Campaign_Routing_Zipcode_Constraint;
  update_columns?: Array<Campaign_Routing_Zipcode_Update_Column>;
  where?: InputMaybe<Campaign_Routing_Zipcode_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign_routing.zipcode". */
export type Campaign_Routing_Zipcode_Order_By = {
  destinations_aggregate?: InputMaybe<Campaign_Routing_Destination_Aggregate_Order_By>;
  kdb_office_id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  vmb_office_id?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign_routing.zipcode */
export type Campaign_Routing_Zipcode_Pk_Columns_Input = {
  organization_id: Scalars['String']['input'];
  zipcode: Scalars['bpchar']['input'];
};

/** select columns of table "campaign_routing.zipcode" */
export enum Campaign_Routing_Zipcode_Select_Column {
  /** column name */
  KdbOfficeId = 'kdb_office_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  VmbOfficeId = 'vmb_office_id',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for updating data in table "campaign_routing.zipcode" */
export type Campaign_Routing_Zipcode_Set_Input = {
  kdb_office_id?: InputMaybe<Scalars['String']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  vmb_office_id?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Campaign_Routing_Zipcode_Stddev_Fields = {
  __typename?: 'campaign_routing_zipcode_stddev_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Campaign_Routing_Zipcode_Stddev_Pop_Fields = {
  __typename?: 'campaign_routing_zipcode_stddev_pop_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Campaign_Routing_Zipcode_Stddev_Samp_Fields = {
  __typename?: 'campaign_routing_zipcode_stddev_samp_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "campaign_routing_zipcode" */
export type Campaign_Routing_Zipcode_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Routing_Zipcode_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Routing_Zipcode_Stream_Cursor_Value_Input = {
  kdb_office_id?: InputMaybe<Scalars['String']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  vmb_office_id?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Campaign_Routing_Zipcode_Sum_Fields = {
  __typename?: 'campaign_routing_zipcode_sum_fields';
  location_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "campaign_routing.zipcode" */
export enum Campaign_Routing_Zipcode_Update_Column {
  /** column name */
  KdbOfficeId = 'kdb_office_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  VmbOfficeId = 'vmb_office_id',
  /** column name */
  Zipcode = 'zipcode'
}

export type Campaign_Routing_Zipcode_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Campaign_Routing_Zipcode_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Routing_Zipcode_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Routing_Zipcode_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campaign_Routing_Zipcode_Var_Pop_Fields = {
  __typename?: 'campaign_routing_zipcode_var_pop_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Campaign_Routing_Zipcode_Var_Samp_Fields = {
  __typename?: 'campaign_routing_zipcode_var_samp_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Campaign_Routing_Zipcode_Variance_Fields = {
  __typename?: 'campaign_routing_zipcode_variance_fields';
  location_id?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "campaign" */
export enum Campaign_Select_Column {
  /** column name */
  AdsEmailList = 'ads_email_list',
  /** column name */
  ApplicantBoardEnabled = 'applicant_board_enabled',
  /** column name */
  ApplicantsEmailList = 'applicants_email_list',
  /** column name */
  BotConsent = 'bot_consent',
  /** column name */
  Category = 'category',
  /** column name */
  ChatBotEnabled = 'chat_bot_enabled',
  /** column name */
  ChatBotIsKo = 'chat_bot_is_ko',
  /** column name */
  ChatBotV2Enabled = 'chat_bot_v2_enabled',
  /** column name */
  DailyBudget = 'daily_budget',
  /** column name */
  DailyMediaBudget = 'daily_media_budget',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'is_hidden',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  JobPostingText = 'job_posting_text',
  /** column name */
  Location = 'location',
  /** column name */
  LocationSlug = 'location_slug',
  /** column name */
  MarginInPercent = 'margin_in_percent',
  /** column name */
  MeistertaskUrl = 'meistertask_url',
  /** column name */
  MondayUrl = 'monday_url',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PdfEnabled = 'pdf_enabled',
  /** column name */
  PerspectiveCampaignId = 'perspective_campaign_id',
  /** column name */
  PhoneNumberDefaultRegion = 'phone_number_default_region',
  /** column name */
  ResponsiblePerson = 'responsible_person',
  /** column name */
  ShortId = 'short_id',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  StatusOverride = 'status_override',
  /** column name */
  SupportEmail = 'support_email',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkLocation = 'work_location'
}

/** select "campaign_aggregate_bool_exp_avg_arguments_columns" columns of table "campaign" */
export enum Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MarginInPercent = 'margin_in_percent'
}

/** select "campaign_aggregate_bool_exp_bool_and_arguments_columns" columns of table "campaign" */
export enum Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ApplicantBoardEnabled = 'applicant_board_enabled',
  /** column name */
  BotConsent = 'bot_consent',
  /** column name */
  ChatBotEnabled = 'chat_bot_enabled',
  /** column name */
  ChatBotIsKo = 'chat_bot_is_ko',
  /** column name */
  ChatBotV2Enabled = 'chat_bot_v2_enabled',
  /** column name */
  IsHidden = 'is_hidden',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  PdfEnabled = 'pdf_enabled'
}

/** select "campaign_aggregate_bool_exp_bool_or_arguments_columns" columns of table "campaign" */
export enum Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ApplicantBoardEnabled = 'applicant_board_enabled',
  /** column name */
  BotConsent = 'bot_consent',
  /** column name */
  ChatBotEnabled = 'chat_bot_enabled',
  /** column name */
  ChatBotIsKo = 'chat_bot_is_ko',
  /** column name */
  ChatBotV2Enabled = 'chat_bot_v2_enabled',
  /** column name */
  IsHidden = 'is_hidden',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  PdfEnabled = 'pdf_enabled'
}

/** select "campaign_aggregate_bool_exp_corr_arguments_columns" columns of table "campaign" */
export enum Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MarginInPercent = 'margin_in_percent'
}

/** select "campaign_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "campaign" */
export enum Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MarginInPercent = 'margin_in_percent'
}

/** select "campaign_aggregate_bool_exp_max_arguments_columns" columns of table "campaign" */
export enum Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MarginInPercent = 'margin_in_percent'
}

/** select "campaign_aggregate_bool_exp_min_arguments_columns" columns of table "campaign" */
export enum Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MarginInPercent = 'margin_in_percent'
}

/** select "campaign_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "campaign" */
export enum Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MarginInPercent = 'margin_in_percent'
}

/** select "campaign_aggregate_bool_exp_sum_arguments_columns" columns of table "campaign" */
export enum Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MarginInPercent = 'margin_in_percent'
}

/** select "campaign_aggregate_bool_exp_var_samp_arguments_columns" columns of table "campaign" */
export enum Campaign_Select_Column_Campaign_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MarginInPercent = 'margin_in_percent'
}

/** input type for updating data in table "campaign" */
export type Campaign_Set_Input = {
  ads_email_list?: InputMaybe<Array<Scalars['String']['input']>>;
  applicant_board_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  applicants_email_list?: InputMaybe<Array<Scalars['String']['input']>>;
  bot_consent?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chat_bot_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  chat_bot_is_ko?: InputMaybe<Scalars['Boolean']['input']>;
  chat_bot_v2_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  daily_budget?: InputMaybe<Scalars['numeric']['input']>;
  daily_media_budget?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  job_posting_text?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  location_slug?: InputMaybe<Scalars['String']['input']>;
  margin_in_percent?: InputMaybe<Scalars['float8']['input']>;
  meistertask_url?: InputMaybe<Scalars['String']['input']>;
  monday_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  pdf_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  perspective_campaign_id?: InputMaybe<Scalars['String']['input']>;
  phone_number_default_region?: InputMaybe<Campaign_Iso_2_Country_Codes_Enum>;
  responsible_person?: InputMaybe<Scalars['String']['input']>;
  short_id?: InputMaybe<Scalars['bpchar']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Stored campaign status (DRAFT, ACTIVE, PAUSED, FINISHED). Maintained from dates, status_override, and linked ad status. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Can be used to manually override the campaign status to set the campaign to paused/finished */
  status_override?: InputMaybe<Campaign_Status_Enum>;
  support_email?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_location?: InputMaybe<Campaign_Work_Location_Enum>;
};

/** Can be used to override settings on a per-campaign basis */
export type Campaign_Settings_Override = {
  __typename?: 'campaign_settings_override';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  color?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  name_prefix: Organization_Name_Prefix_Enum;
  short_name?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "campaign.settings_override" */
export type Campaign_Settings_Override_Aggregate = {
  __typename?: 'campaign_settings_override_aggregate';
  aggregate?: Maybe<Campaign_Settings_Override_Aggregate_Fields>;
  nodes: Array<Campaign_Settings_Override>;
};

/** aggregate fields of "campaign.settings_override" */
export type Campaign_Settings_Override_Aggregate_Fields = {
  __typename?: 'campaign_settings_override_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Settings_Override_Max_Fields>;
  min?: Maybe<Campaign_Settings_Override_Min_Fields>;
};


/** aggregate fields of "campaign.settings_override" */
export type Campaign_Settings_Override_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Settings_Override_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "campaign.settings_override". All fields are combined with a logical 'AND'. */
export type Campaign_Settings_Override_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Settings_Override_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Settings_Override_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Settings_Override_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  logo_url?: InputMaybe<String_Comparison_Exp>;
  name_prefix?: InputMaybe<Organization_Name_Prefix_Enum_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.settings_override" */
export enum Campaign_Settings_Override_Constraint {
  /** unique or primary key constraint on columns "campaign_id" */
  SettingsOverridePkey = 'settings_override_pkey'
}

/** input type for inserting data into table "campaign.settings_override" */
export type Campaign_Settings_Override_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  name_prefix?: InputMaybe<Organization_Name_Prefix_Enum>;
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Settings_Override_Max_Fields = {
  __typename?: 'campaign_settings_override_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Settings_Override_Min_Fields = {
  __typename?: 'campaign_settings_override_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign.settings_override" */
export type Campaign_Settings_Override_Mutation_Response = {
  __typename?: 'campaign_settings_override_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Settings_Override>;
};

/** input type for inserting object relation for remote table "campaign.settings_override" */
export type Campaign_Settings_Override_Obj_Rel_Insert_Input = {
  data: Campaign_Settings_Override_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Settings_Override_On_Conflict>;
};

/** on_conflict condition type for table "campaign.settings_override" */
export type Campaign_Settings_Override_On_Conflict = {
  constraint: Campaign_Settings_Override_Constraint;
  update_columns?: Array<Campaign_Settings_Override_Update_Column>;
  where?: InputMaybe<Campaign_Settings_Override_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.settings_override". */
export type Campaign_Settings_Override_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  logo_url?: InputMaybe<Order_By>;
  name_prefix?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.settings_override */
export type Campaign_Settings_Override_Pk_Columns_Input = {
  campaign_id: Scalars['uuid']['input'];
};

/** select columns of table "campaign.settings_override" */
export enum Campaign_Settings_Override_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Color = 'color',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  NamePrefix = 'name_prefix',
  /** column name */
  ShortName = 'short_name'
}

/** input type for updating data in table "campaign.settings_override" */
export type Campaign_Settings_Override_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  name_prefix?: InputMaybe<Organization_Name_Prefix_Enum>;
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "campaign_settings_override" */
export type Campaign_Settings_Override_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Settings_Override_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Settings_Override_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  name_prefix?: InputMaybe<Organization_Name_Prefix_Enum>;
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "campaign.settings_override" */
export enum Campaign_Settings_Override_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Color = 'color',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  NamePrefix = 'name_prefix',
  /** column name */
  ShortName = 'short_name'
}

export type Campaign_Settings_Override_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Settings_Override_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Settings_Override_Bool_Exp;
};

/** columns and relationships of "campaign_status" */
export type Campaign_Status = {
  __typename?: 'campaign_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "campaign_status" */
export type Campaign_Status_Aggregate = {
  __typename?: 'campaign_status_aggregate';
  aggregate?: Maybe<Campaign_Status_Aggregate_Fields>;
  nodes: Array<Campaign_Status>;
};

/** aggregate fields of "campaign_status" */
export type Campaign_Status_Aggregate_Fields = {
  __typename?: 'campaign_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Status_Max_Fields>;
  min?: Maybe<Campaign_Status_Min_Fields>;
};


/** aggregate fields of "campaign_status" */
export type Campaign_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "campaign_status". All fields are combined with a logical 'AND'. */
export type Campaign_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Status_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign_status" */
export enum Campaign_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  CampaignStatusPkey = 'campaign_status_pkey'
}

export enum Campaign_Status_Enum {
  Off = 'OFF',
  On = 'ON',
  Paused = 'PAUSED'
}

/** Boolean expression to compare columns of type "campaign_status_enum". All fields are combined with logical 'AND'. */
export type Campaign_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Campaign_Status_Enum>;
  _in?: InputMaybe<Array<Campaign_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Campaign_Status_Enum>;
  _nin?: InputMaybe<Array<Campaign_Status_Enum>>;
};

/** columns and relationships of "campaign.status_event" */
export type Campaign_Status_Event = {
  __typename?: 'campaign_status_event';
  value: Scalars['String']['output'];
};

/** aggregated selection of "campaign.status_event" */
export type Campaign_Status_Event_Aggregate = {
  __typename?: 'campaign_status_event_aggregate';
  aggregate?: Maybe<Campaign_Status_Event_Aggregate_Fields>;
  nodes: Array<Campaign_Status_Event>;
};

/** aggregate fields of "campaign.status_event" */
export type Campaign_Status_Event_Aggregate_Fields = {
  __typename?: 'campaign_status_event_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Status_Event_Max_Fields>;
  min?: Maybe<Campaign_Status_Event_Min_Fields>;
};


/** aggregate fields of "campaign.status_event" */
export type Campaign_Status_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Status_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "campaign.status_event". All fields are combined with a logical 'AND'. */
export type Campaign_Status_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Status_Event_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Status_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Status_Event_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.status_event" */
export enum Campaign_Status_Event_Constraint {
  /** unique or primary key constraint on columns "value" */
  StatusEventPkey = 'status_event_pkey'
}

export enum Campaign_Status_Event_Enum {
  Pause = 'PAUSE',
  Resume = 'RESUME'
}

/** Boolean expression to compare columns of type "campaign_status_event_enum". All fields are combined with logical 'AND'. */
export type Campaign_Status_Event_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Campaign_Status_Event_Enum>;
  _in?: InputMaybe<Array<Campaign_Status_Event_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Campaign_Status_Event_Enum>;
  _nin?: InputMaybe<Array<Campaign_Status_Event_Enum>>;
};

/** input type for inserting data into table "campaign.status_event" */
export type Campaign_Status_Event_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Status_Event_Max_Fields = {
  __typename?: 'campaign_status_event_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Status_Event_Min_Fields = {
  __typename?: 'campaign_status_event_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign.status_event" */
export type Campaign_Status_Event_Mutation_Response = {
  __typename?: 'campaign_status_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Status_Event>;
};

/** on_conflict condition type for table "campaign.status_event" */
export type Campaign_Status_Event_On_Conflict = {
  constraint: Campaign_Status_Event_Constraint;
  update_columns?: Array<Campaign_Status_Event_Update_Column>;
  where?: InputMaybe<Campaign_Status_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.status_event". */
export type Campaign_Status_Event_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.status_event */
export type Campaign_Status_Event_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "campaign.status_event" */
export enum Campaign_Status_Event_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "campaign.status_event" */
export type Campaign_Status_Event_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "campaign_status_event" */
export type Campaign_Status_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Status_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Status_Event_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "campaign.status_event" */
export enum Campaign_Status_Event_Update_Column {
  /** column name */
  Value = 'value'
}

export type Campaign_Status_Event_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Status_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Status_Event_Bool_Exp;
};

/** input type for inserting data into table "campaign_status" */
export type Campaign_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "campaign.status_log" */
export type Campaign_Status_Log = {
  __typename?: 'campaign_status_log';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  event: Campaign_Status_Event_Enum;
};

/** aggregated selection of "campaign.status_log" */
export type Campaign_Status_Log_Aggregate = {
  __typename?: 'campaign_status_log_aggregate';
  aggregate?: Maybe<Campaign_Status_Log_Aggregate_Fields>;
  nodes: Array<Campaign_Status_Log>;
};

export type Campaign_Status_Log_Aggregate_Bool_Exp = {
  count?: InputMaybe<Campaign_Status_Log_Aggregate_Bool_Exp_Count>;
};

export type Campaign_Status_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Campaign_Status_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "campaign.status_log" */
export type Campaign_Status_Log_Aggregate_Fields = {
  __typename?: 'campaign_status_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Status_Log_Max_Fields>;
  min?: Maybe<Campaign_Status_Log_Min_Fields>;
};


/** aggregate fields of "campaign.status_log" */
export type Campaign_Status_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Status_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "campaign.status_log" */
export type Campaign_Status_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Campaign_Status_Log_Max_Order_By>;
  min?: InputMaybe<Campaign_Status_Log_Min_Order_By>;
};

/** input type for inserting array relation for remote table "campaign.status_log" */
export type Campaign_Status_Log_Arr_Rel_Insert_Input = {
  data: Array<Campaign_Status_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Status_Log_On_Conflict>;
};

/** Boolean expression to filter rows from the table "campaign.status_log". All fields are combined with a logical 'AND'. */
export type Campaign_Status_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Status_Log_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Status_Log_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Campaign_Status_Event_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.status_log" */
export enum Campaign_Status_Log_Constraint {
  /** unique or primary key constraint on columns "created_at", "campaign_id" */
  StatusLogPkey = 'status_log_pkey'
}

/** input type for inserting data into table "campaign.status_log" */
export type Campaign_Status_Log_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Campaign_Status_Event_Enum>;
};

/** aggregate max on columns */
export type Campaign_Status_Log_Max_Fields = {
  __typename?: 'campaign_status_log_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "campaign.status_log" */
export type Campaign_Status_Log_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Campaign_Status_Log_Min_Fields = {
  __typename?: 'campaign_status_log_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "campaign.status_log" */
export type Campaign_Status_Log_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "campaign.status_log" */
export type Campaign_Status_Log_Mutation_Response = {
  __typename?: 'campaign_status_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Status_Log>;
};

/** on_conflict condition type for table "campaign.status_log" */
export type Campaign_Status_Log_On_Conflict = {
  constraint: Campaign_Status_Log_Constraint;
  update_columns?: Array<Campaign_Status_Log_Update_Column>;
  where?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.status_log". */
export type Campaign_Status_Log_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.status_log */
export type Campaign_Status_Log_Pk_Columns_Input = {
  campaign_id: Scalars['uuid']['input'];
  created_at: Scalars['timestamptz']['input'];
};

/** select columns of table "campaign.status_log" */
export enum Campaign_Status_Log_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Event = 'event'
}

/** input type for updating data in table "campaign.status_log" */
export type Campaign_Status_Log_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Campaign_Status_Event_Enum>;
};

/** Streaming cursor of the table "campaign_status_log" */
export type Campaign_Status_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Status_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Status_Log_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Campaign_Status_Event_Enum>;
};

/** update columns of table "campaign.status_log" */
export enum Campaign_Status_Log_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Event = 'event'
}

export type Campaign_Status_Log_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Status_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Status_Log_Bool_Exp;
};

/** aggregate max on columns */
export type Campaign_Status_Max_Fields = {
  __typename?: 'campaign_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Status_Min_Fields = {
  __typename?: 'campaign_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign_status" */
export type Campaign_Status_Mutation_Response = {
  __typename?: 'campaign_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Status>;
};

/** input type for inserting object relation for remote table "campaign_status" */
export type Campaign_Status_Obj_Rel_Insert_Input = {
  data: Campaign_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Status_On_Conflict>;
};

/** on_conflict condition type for table "campaign_status" */
export type Campaign_Status_On_Conflict = {
  constraint: Campaign_Status_Constraint;
  update_columns?: Array<Campaign_Status_Update_Column>;
  where?: InputMaybe<Campaign_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign_status". */
export type Campaign_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign_status */
export type Campaign_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "campaign_status" */
export enum Campaign_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "campaign_status" */
export type Campaign_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "campaign_status" */
export type Campaign_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "campaign_status" */
export enum Campaign_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Campaign_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Campaign_Stddev_Fields = {
  __typename?: 'campaign_stddev_fields';
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget?: Maybe<Scalars['Float']['output']>;
  daily_media_budget?: Maybe<Scalars['Float']['output']>;
  margin_in_percent?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
};

/** order by stddev() on columns of table "campaign" */
export type Campaign_Stddev_Order_By = {
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Campaign_Stddev_Pop_Fields = {
  __typename?: 'campaign_stddev_pop_fields';
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget?: Maybe<Scalars['Float']['output']>;
  daily_media_budget?: Maybe<Scalars['Float']['output']>;
  margin_in_percent?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
};

/** order by stddev_pop() on columns of table "campaign" */
export type Campaign_Stddev_Pop_Order_By = {
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Campaign_Stddev_Samp_Fields = {
  __typename?: 'campaign_stddev_samp_fields';
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget?: Maybe<Scalars['Float']['output']>;
  daily_media_budget?: Maybe<Scalars['Float']['output']>;
  margin_in_percent?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
};

/** order by stddev_samp() on columns of table "campaign" */
export type Campaign_Stddev_Samp_Order_By = {
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "campaign" */
export type Campaign_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Stream_Cursor_Value_Input = {
  ads_email_list?: InputMaybe<Array<Scalars['String']['input']>>;
  applicant_board_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  applicants_email_list?: InputMaybe<Array<Scalars['String']['input']>>;
  bot_consent?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chat_bot_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  chat_bot_is_ko?: InputMaybe<Scalars['Boolean']['input']>;
  chat_bot_v2_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  daily_budget?: InputMaybe<Scalars['numeric']['input']>;
  daily_media_budget?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  job_posting_text?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  location_slug?: InputMaybe<Scalars['String']['input']>;
  margin_in_percent?: InputMaybe<Scalars['float8']['input']>;
  meistertask_url?: InputMaybe<Scalars['String']['input']>;
  monday_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  pdf_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  perspective_campaign_id?: InputMaybe<Scalars['String']['input']>;
  phone_number_default_region?: InputMaybe<Campaign_Iso_2_Country_Codes_Enum>;
  responsible_person?: InputMaybe<Scalars['String']['input']>;
  short_id?: InputMaybe<Scalars['bpchar']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Stored campaign status (DRAFT, ACTIVE, PAUSED, FINISHED). Maintained from dates, status_override, and linked ad status. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Can be used to manually override the campaign status to set the campaign to paused/finished */
  status_override?: InputMaybe<Campaign_Status_Enum>;
  support_email?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  work_location?: InputMaybe<Campaign_Work_Location_Enum>;
};

/** aggregate sum on columns */
export type Campaign_Sum_Fields = {
  __typename?: 'campaign_sum_fields';
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget?: Maybe<Scalars['numeric']['output']>;
  daily_media_budget?: Maybe<Scalars['numeric']['output']>;
  margin_in_percent?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "campaign" */
export type Campaign_Sum_Order_By = {
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
};

/** columns and relationships of "campaign.transaction_type" */
export type Campaign_Transaction_Type = {
  __typename?: 'campaign_transaction_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "campaign.transaction_type" */
export type Campaign_Transaction_Type_Aggregate = {
  __typename?: 'campaign_transaction_type_aggregate';
  aggregate?: Maybe<Campaign_Transaction_Type_Aggregate_Fields>;
  nodes: Array<Campaign_Transaction_Type>;
};

/** aggregate fields of "campaign.transaction_type" */
export type Campaign_Transaction_Type_Aggregate_Fields = {
  __typename?: 'campaign_transaction_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Transaction_Type_Max_Fields>;
  min?: Maybe<Campaign_Transaction_Type_Min_Fields>;
};


/** aggregate fields of "campaign.transaction_type" */
export type Campaign_Transaction_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Transaction_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "campaign.transaction_type". All fields are combined with a logical 'AND'. */
export type Campaign_Transaction_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Transaction_Type_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Transaction_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Transaction_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign.transaction_type" */
export enum Campaign_Transaction_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  TransactionTypePkey = 'transaction_type_pkey'
}

export enum Campaign_Transaction_Type_Enum {
  Bonus = 'BONUS',
  Daily = 'DAILY',
  Initial = 'INITIAL',
  Manual = 'MANUAL'
}

/** Boolean expression to compare columns of type "campaign_transaction_type_enum". All fields are combined with logical 'AND'. */
export type Campaign_Transaction_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Campaign_Transaction_Type_Enum>;
  _in?: InputMaybe<Array<Campaign_Transaction_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Campaign_Transaction_Type_Enum>;
  _nin?: InputMaybe<Array<Campaign_Transaction_Type_Enum>>;
};

/** input type for inserting data into table "campaign.transaction_type" */
export type Campaign_Transaction_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Transaction_Type_Max_Fields = {
  __typename?: 'campaign_transaction_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Transaction_Type_Min_Fields = {
  __typename?: 'campaign_transaction_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign.transaction_type" */
export type Campaign_Transaction_Type_Mutation_Response = {
  __typename?: 'campaign_transaction_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Transaction_Type>;
};

/** on_conflict condition type for table "campaign.transaction_type" */
export type Campaign_Transaction_Type_On_Conflict = {
  constraint: Campaign_Transaction_Type_Constraint;
  update_columns?: Array<Campaign_Transaction_Type_Update_Column>;
  where?: InputMaybe<Campaign_Transaction_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign.transaction_type". */
export type Campaign_Transaction_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign.transaction_type */
export type Campaign_Transaction_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "campaign.transaction_type" */
export enum Campaign_Transaction_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "campaign.transaction_type" */
export type Campaign_Transaction_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "campaign_transaction_type" */
export type Campaign_Transaction_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Transaction_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Transaction_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "campaign.transaction_type" */
export enum Campaign_Transaction_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Campaign_Transaction_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Transaction_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Transaction_Type_Bool_Exp;
};

/** update columns of table "campaign" */
export enum Campaign_Update_Column {
  /** column name */
  AdsEmailList = 'ads_email_list',
  /** column name */
  ApplicantBoardEnabled = 'applicant_board_enabled',
  /** column name */
  ApplicantsEmailList = 'applicants_email_list',
  /** column name */
  BotConsent = 'bot_consent',
  /** column name */
  Category = 'category',
  /** column name */
  ChatBotEnabled = 'chat_bot_enabled',
  /** column name */
  ChatBotIsKo = 'chat_bot_is_ko',
  /** column name */
  ChatBotV2Enabled = 'chat_bot_v2_enabled',
  /** column name */
  DailyBudget = 'daily_budget',
  /** column name */
  DailyMediaBudget = 'daily_media_budget',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'is_hidden',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  JobPostingText = 'job_posting_text',
  /** column name */
  Location = 'location',
  /** column name */
  LocationSlug = 'location_slug',
  /** column name */
  MarginInPercent = 'margin_in_percent',
  /** column name */
  MeistertaskUrl = 'meistertask_url',
  /** column name */
  MondayUrl = 'monday_url',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PdfEnabled = 'pdf_enabled',
  /** column name */
  PerspectiveCampaignId = 'perspective_campaign_id',
  /** column name */
  PhoneNumberDefaultRegion = 'phone_number_default_region',
  /** column name */
  ResponsiblePerson = 'responsible_person',
  /** column name */
  ShortId = 'short_id',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  StatusOverride = 'status_override',
  /** column name */
  SupportEmail = 'support_email',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkLocation = 'work_location'
}

export type Campaign_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Campaign_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campaign_Var_Pop_Fields = {
  __typename?: 'campaign_var_pop_fields';
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget?: Maybe<Scalars['Float']['output']>;
  daily_media_budget?: Maybe<Scalars['Float']['output']>;
  margin_in_percent?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
};

/** order by var_pop() on columns of table "campaign" */
export type Campaign_Var_Pop_Order_By = {
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Campaign_Var_Samp_Fields = {
  __typename?: 'campaign_var_samp_fields';
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget?: Maybe<Scalars['Float']['output']>;
  daily_media_budget?: Maybe<Scalars['Float']['output']>;
  margin_in_percent?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
};

/** order by var_samp() on columns of table "campaign" */
export type Campaign_Var_Samp_Order_By = {
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Campaign_Variance_Fields = {
  __typename?: 'campaign_variance_fields';
  /** A computed field, executes function "campaign_cost_per_lead" */
  cost_per_lead?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign_cost_per_lead_customer" */
  cost_per_lead_customer?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "campaign.get_bonus" */
  customer_budget_bonus?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_initial_campaign_budget" */
  customer_budget_initial?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "get_total_campaign_budget" */
  customer_budget_total?: Maybe<Scalars['float8']['output']>;
  daily_budget?: Maybe<Scalars['Float']['output']>;
  daily_media_budget?: Maybe<Scalars['Float']['output']>;
  margin_in_percent?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_media_budget" */
  media_budget?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "campaign_profit" */
  profit?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_remaining_campaign_budget" */
  remaining_customer_budget?: Maybe<Scalars['float8']['output']>;
};

/** order by variance() on columns of table "campaign" */
export type Campaign_Variance_Order_By = {
  daily_budget?: InputMaybe<Order_By>;
  daily_media_budget?: InputMaybe<Order_By>;
  margin_in_percent?: InputMaybe<Order_By>;
};

/** columns and relationships of "campaign_work_location" */
export type Campaign_Work_Location = {
  __typename?: 'campaign_work_location';
  value: Scalars['String']['output'];
};

/** aggregated selection of "campaign_work_location" */
export type Campaign_Work_Location_Aggregate = {
  __typename?: 'campaign_work_location_aggregate';
  aggregate?: Maybe<Campaign_Work_Location_Aggregate_Fields>;
  nodes: Array<Campaign_Work_Location>;
};

/** aggregate fields of "campaign_work_location" */
export type Campaign_Work_Location_Aggregate_Fields = {
  __typename?: 'campaign_work_location_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Campaign_Work_Location_Max_Fields>;
  min?: Maybe<Campaign_Work_Location_Min_Fields>;
};


/** aggregate fields of "campaign_work_location" */
export type Campaign_Work_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campaign_Work_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "campaign_work_location". All fields are combined with a logical 'AND'. */
export type Campaign_Work_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Campaign_Work_Location_Bool_Exp>>;
  _not?: InputMaybe<Campaign_Work_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Campaign_Work_Location_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campaign_work_location" */
export enum Campaign_Work_Location_Constraint {
  /** unique or primary key constraint on columns "value" */
  CampaignWorkLocationPkey = 'campaign_work_location_pkey'
}

export enum Campaign_Work_Location_Enum {
  Hybrid = 'HYBRID',
  Office = 'OFFICE',
  Remote = 'REMOTE'
}

/** Boolean expression to compare columns of type "campaign_work_location_enum". All fields are combined with logical 'AND'. */
export type Campaign_Work_Location_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Campaign_Work_Location_Enum>;
  _in?: InputMaybe<Array<Campaign_Work_Location_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Campaign_Work_Location_Enum>;
  _nin?: InputMaybe<Array<Campaign_Work_Location_Enum>>;
};

/** input type for inserting data into table "campaign_work_location" */
export type Campaign_Work_Location_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Campaign_Work_Location_Max_Fields = {
  __typename?: 'campaign_work_location_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Campaign_Work_Location_Min_Fields = {
  __typename?: 'campaign_work_location_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "campaign_work_location" */
export type Campaign_Work_Location_Mutation_Response = {
  __typename?: 'campaign_work_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaign_Work_Location>;
};

/** input type for inserting object relation for remote table "campaign_work_location" */
export type Campaign_Work_Location_Obj_Rel_Insert_Input = {
  data: Campaign_Work_Location_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Campaign_Work_Location_On_Conflict>;
};

/** on_conflict condition type for table "campaign_work_location" */
export type Campaign_Work_Location_On_Conflict = {
  constraint: Campaign_Work_Location_Constraint;
  update_columns?: Array<Campaign_Work_Location_Update_Column>;
  where?: InputMaybe<Campaign_Work_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "campaign_work_location". */
export type Campaign_Work_Location_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campaign_work_location */
export type Campaign_Work_Location_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "campaign_work_location" */
export enum Campaign_Work_Location_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "campaign_work_location" */
export type Campaign_Work_Location_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "campaign_work_location" */
export type Campaign_Work_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campaign_Work_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campaign_Work_Location_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "campaign_work_location" */
export enum Campaign_Work_Location_Update_Column {
  /** column name */
  Value = 'value'
}

export type Campaign_Work_Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campaign_Work_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campaign_Work_Location_Bool_Exp;
};

/** columns and relationships of "chat_bot.customers" */
export type Chat_Bot_Customers = {
  __typename?: 'chat_bot_customers';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  /** An object relationship */
  contact?: Maybe<Contact>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  contact_payload?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  has_completed_conversation: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  messages: Array<Chat_Bot_Messages>;
  /** An aggregate relationship */
  messages_aggregate: Chat_Bot_Messages_Aggregate;
  remainder_count: Scalars['Int']['output'];
  retry_count: Scalars['Int']['output'];
  sent_initial_message_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "chat_bot.customers" */
export type Chat_Bot_CustomersContact_PayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "chat_bot.customers" */
export type Chat_Bot_CustomersMessagesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Messages_Order_By>>;
  where?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
};


/** columns and relationships of "chat_bot.customers" */
export type Chat_Bot_CustomersMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Messages_Order_By>>;
  where?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
};

/** aggregated selection of "chat_bot.customers" */
export type Chat_Bot_Customers_Aggregate = {
  __typename?: 'chat_bot_customers_aggregate';
  aggregate?: Maybe<Chat_Bot_Customers_Aggregate_Fields>;
  nodes: Array<Chat_Bot_Customers>;
};

export type Chat_Bot_Customers_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Chat_Bot_Customers_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Chat_Bot_Customers_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Chat_Bot_Customers_Aggregate_Bool_Exp_Count>;
};

export type Chat_Bot_Customers_Aggregate_Bool_Exp_Bool_And = {
  arguments: Chat_Bot_Customers_Select_Column_Chat_Bot_Customers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Chat_Bot_Customers_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Chat_Bot_Customers_Select_Column_Chat_Bot_Customers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Chat_Bot_Customers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Bot_Customers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "chat_bot.customers" */
export type Chat_Bot_Customers_Aggregate_Fields = {
  __typename?: 'chat_bot_customers_aggregate_fields';
  avg?: Maybe<Chat_Bot_Customers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Bot_Customers_Max_Fields>;
  min?: Maybe<Chat_Bot_Customers_Min_Fields>;
  stddev?: Maybe<Chat_Bot_Customers_Stddev_Fields>;
  stddev_pop?: Maybe<Chat_Bot_Customers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chat_Bot_Customers_Stddev_Samp_Fields>;
  sum?: Maybe<Chat_Bot_Customers_Sum_Fields>;
  var_pop?: Maybe<Chat_Bot_Customers_Var_Pop_Fields>;
  var_samp?: Maybe<Chat_Bot_Customers_Var_Samp_Fields>;
  variance?: Maybe<Chat_Bot_Customers_Variance_Fields>;
};


/** aggregate fields of "chat_bot.customers" */
export type Chat_Bot_Customers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Bot_Customers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "chat_bot.customers" */
export type Chat_Bot_Customers_Aggregate_Order_By = {
  avg?: InputMaybe<Chat_Bot_Customers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Bot_Customers_Max_Order_By>;
  min?: InputMaybe<Chat_Bot_Customers_Min_Order_By>;
  stddev?: InputMaybe<Chat_Bot_Customers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Chat_Bot_Customers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Chat_Bot_Customers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Chat_Bot_Customers_Sum_Order_By>;
  var_pop?: InputMaybe<Chat_Bot_Customers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Chat_Bot_Customers_Var_Samp_Order_By>;
  variance?: InputMaybe<Chat_Bot_Customers_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Chat_Bot_Customers_Append_Input = {
  contact_payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "chat_bot.customers" */
export type Chat_Bot_Customers_Arr_Rel_Insert_Input = {
  data: Array<Chat_Bot_Customers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Chat_Bot_Customers_On_Conflict>;
};

/** aggregate avg on columns */
export type Chat_Bot_Customers_Avg_Fields = {
  __typename?: 'chat_bot_customers_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  remainder_count?: Maybe<Scalars['Float']['output']>;
  retry_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "chat_bot.customers" */
export type Chat_Bot_Customers_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "chat_bot.customers". All fields are combined with a logical 'AND'. */
export type Chat_Bot_Customers_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Bot_Customers_Bool_Exp>>;
  _not?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Bot_Customers_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_payload?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  has_completed_conversation?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  messages?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
  messages_aggregate?: InputMaybe<Chat_Bot_Messages_Aggregate_Bool_Exp>;
  remainder_count?: InputMaybe<Int_Comparison_Exp>;
  retry_count?: InputMaybe<Int_Comparison_Exp>;
  sent_initial_message_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_bot.customers" */
export enum Chat_Bot_Customers_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContactPkey = 'contact_pkey',
  /** unique or primary key constraint on columns "id", "contact_id", "campaign_id" */
  IdContactIdCampaignIdIdx = 'id_contact_id_campaign_id_idx'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Chat_Bot_Customers_Delete_At_Path_Input = {
  contact_payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Chat_Bot_Customers_Delete_Elem_Input = {
  contact_payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Chat_Bot_Customers_Delete_Key_Input = {
  contact_payload?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "chat_bot.customers" */
export type Chat_Bot_Customers_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  remainder_count?: InputMaybe<Scalars['Int']['input']>;
  retry_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "chat_bot.customers" */
export type Chat_Bot_Customers_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_payload?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_completed_conversation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  messages?: InputMaybe<Chat_Bot_Messages_Arr_Rel_Insert_Input>;
  remainder_count?: InputMaybe<Scalars['Int']['input']>;
  retry_count?: InputMaybe<Scalars['Int']['input']>;
  sent_initial_message_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Chat_Bot_Customers_Max_Fields = {
  __typename?: 'chat_bot_customers_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  remainder_count?: Maybe<Scalars['Int']['output']>;
  retry_count?: Maybe<Scalars['Int']['output']>;
  sent_initial_message_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "chat_bot.customers" */
export type Chat_Bot_Customers_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
  sent_initial_message_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Bot_Customers_Min_Fields = {
  __typename?: 'chat_bot_customers_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  remainder_count?: Maybe<Scalars['Int']['output']>;
  retry_count?: Maybe<Scalars['Int']['output']>;
  sent_initial_message_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "chat_bot.customers" */
export type Chat_Bot_Customers_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
  sent_initial_message_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "chat_bot.customers" */
export type Chat_Bot_Customers_Mutation_Response = {
  __typename?: 'chat_bot_customers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Bot_Customers>;
};

/** input type for inserting object relation for remote table "chat_bot.customers" */
export type Chat_Bot_Customers_Obj_Rel_Insert_Input = {
  data: Chat_Bot_Customers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Chat_Bot_Customers_On_Conflict>;
};

/** on_conflict condition type for table "chat_bot.customers" */
export type Chat_Bot_Customers_On_Conflict = {
  constraint: Chat_Bot_Customers_Constraint;
  update_columns?: Array<Chat_Bot_Customers_Update_Column>;
  where?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_bot.customers". */
export type Chat_Bot_Customers_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  contact_payload?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  has_completed_conversation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Chat_Bot_Messages_Aggregate_Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
  sent_initial_message_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_bot.customers */
export type Chat_Bot_Customers_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Chat_Bot_Customers_Prepend_Input = {
  contact_payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "chat_bot.customers" */
export enum Chat_Bot_Customers_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  ContactPayload = 'contact_payload',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasCompletedConversation = 'has_completed_conversation',
  /** column name */
  Id = 'id',
  /** column name */
  RemainderCount = 'remainder_count',
  /** column name */
  RetryCount = 'retry_count',
  /** column name */
  SentInitialMessageAt = 'sent_initial_message_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "chat_bot_customers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "chat_bot.customers" */
export enum Chat_Bot_Customers_Select_Column_Chat_Bot_Customers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasCompletedConversation = 'has_completed_conversation'
}

/** select "chat_bot_customers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "chat_bot.customers" */
export enum Chat_Bot_Customers_Select_Column_Chat_Bot_Customers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasCompletedConversation = 'has_completed_conversation'
}

/** input type for updating data in table "chat_bot.customers" */
export type Chat_Bot_Customers_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_payload?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_completed_conversation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  remainder_count?: InputMaybe<Scalars['Int']['input']>;
  retry_count?: InputMaybe<Scalars['Int']['input']>;
  sent_initial_message_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Chat_Bot_Customers_Stddev_Fields = {
  __typename?: 'chat_bot_customers_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  remainder_count?: Maybe<Scalars['Float']['output']>;
  retry_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "chat_bot.customers" */
export type Chat_Bot_Customers_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Chat_Bot_Customers_Stddev_Pop_Fields = {
  __typename?: 'chat_bot_customers_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  remainder_count?: Maybe<Scalars['Float']['output']>;
  retry_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "chat_bot.customers" */
export type Chat_Bot_Customers_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Chat_Bot_Customers_Stddev_Samp_Fields = {
  __typename?: 'chat_bot_customers_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  remainder_count?: Maybe<Scalars['Float']['output']>;
  retry_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "chat_bot.customers" */
export type Chat_Bot_Customers_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "chat_bot_customers" */
export type Chat_Bot_Customers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Bot_Customers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Bot_Customers_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_payload?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_completed_conversation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  remainder_count?: InputMaybe<Scalars['Int']['input']>;
  retry_count?: InputMaybe<Scalars['Int']['input']>;
  sent_initial_message_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Chat_Bot_Customers_Sum_Fields = {
  __typename?: 'chat_bot_customers_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  remainder_count?: Maybe<Scalars['Int']['output']>;
  retry_count?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "chat_bot.customers" */
export type Chat_Bot_Customers_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
};

/** update columns of table "chat_bot.customers" */
export enum Chat_Bot_Customers_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  ContactPayload = 'contact_payload',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasCompletedConversation = 'has_completed_conversation',
  /** column name */
  Id = 'id',
  /** column name */
  RemainderCount = 'remainder_count',
  /** column name */
  RetryCount = 'retry_count',
  /** column name */
  SentInitialMessageAt = 'sent_initial_message_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Chat_Bot_Customers_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Chat_Bot_Customers_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Chat_Bot_Customers_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Chat_Bot_Customers_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Chat_Bot_Customers_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Chat_Bot_Customers_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Chat_Bot_Customers_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_Bot_Customers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chat_Bot_Customers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Chat_Bot_Customers_Var_Pop_Fields = {
  __typename?: 'chat_bot_customers_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  remainder_count?: Maybe<Scalars['Float']['output']>;
  retry_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "chat_bot.customers" */
export type Chat_Bot_Customers_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Chat_Bot_Customers_Var_Samp_Fields = {
  __typename?: 'chat_bot_customers_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  remainder_count?: Maybe<Scalars['Float']['output']>;
  retry_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "chat_bot.customers" */
export type Chat_Bot_Customers_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Chat_Bot_Customers_Variance_Fields = {
  __typename?: 'chat_bot_customers_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  remainder_count?: Maybe<Scalars['Float']['output']>;
  retry_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "chat_bot.customers" */
export type Chat_Bot_Customers_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  remainder_count?: InputMaybe<Order_By>;
  retry_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "chat_bot.forwarding" */
export type Chat_Bot_Forwarding = {
  __typename?: 'chat_bot_forwarding';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
  webhook_url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "chat_bot.forwarding" */
export type Chat_Bot_Forwarding_Aggregate = {
  __typename?: 'chat_bot_forwarding_aggregate';
  aggregate?: Maybe<Chat_Bot_Forwarding_Aggregate_Fields>;
  nodes: Array<Chat_Bot_Forwarding>;
};

/** aggregate fields of "chat_bot.forwarding" */
export type Chat_Bot_Forwarding_Aggregate_Fields = {
  __typename?: 'chat_bot_forwarding_aggregate_fields';
  avg?: Maybe<Chat_Bot_Forwarding_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Bot_Forwarding_Max_Fields>;
  min?: Maybe<Chat_Bot_Forwarding_Min_Fields>;
  stddev?: Maybe<Chat_Bot_Forwarding_Stddev_Fields>;
  stddev_pop?: Maybe<Chat_Bot_Forwarding_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chat_Bot_Forwarding_Stddev_Samp_Fields>;
  sum?: Maybe<Chat_Bot_Forwarding_Sum_Fields>;
  var_pop?: Maybe<Chat_Bot_Forwarding_Var_Pop_Fields>;
  var_samp?: Maybe<Chat_Bot_Forwarding_Var_Samp_Fields>;
  variance?: Maybe<Chat_Bot_Forwarding_Variance_Fields>;
};


/** aggregate fields of "chat_bot.forwarding" */
export type Chat_Bot_Forwarding_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Bot_Forwarding_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Chat_Bot_Forwarding_Avg_Fields = {
  __typename?: 'chat_bot_forwarding_avg_fields';
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "chat_bot.forwarding". All fields are combined with a logical 'AND'. */
export type Chat_Bot_Forwarding_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Bot_Forwarding_Bool_Exp>>;
  _not?: InputMaybe<Chat_Bot_Forwarding_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Bot_Forwarding_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  make_id?: InputMaybe<Int_Comparison_Exp>;
  webhook_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_bot.forwarding" */
export enum Chat_Bot_Forwarding_Constraint {
  /** unique or primary key constraint on columns "campaign_id" */
  ForwardingCampaignIdKey = 'forwarding_campaign_id_key',
  /** unique or primary key constraint on columns "campaign_id" */
  ForwardingPkey = 'forwarding_pkey'
}

/** input type for incrementing numeric columns in table "chat_bot.forwarding" */
export type Chat_Bot_Forwarding_Inc_Input = {
  make_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "chat_bot.forwarding" */
export type Chat_Bot_Forwarding_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
  webhook_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Chat_Bot_Forwarding_Max_Fields = {
  __typename?: 'chat_bot_forwarding_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
  webhook_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Chat_Bot_Forwarding_Min_Fields = {
  __typename?: 'chat_bot_forwarding_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  make_id?: Maybe<Scalars['Int']['output']>;
  webhook_url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "chat_bot.forwarding" */
export type Chat_Bot_Forwarding_Mutation_Response = {
  __typename?: 'chat_bot_forwarding_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Bot_Forwarding>;
};

/** input type for inserting object relation for remote table "chat_bot.forwarding" */
export type Chat_Bot_Forwarding_Obj_Rel_Insert_Input = {
  data: Chat_Bot_Forwarding_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Chat_Bot_Forwarding_On_Conflict>;
};

/** on_conflict condition type for table "chat_bot.forwarding" */
export type Chat_Bot_Forwarding_On_Conflict = {
  constraint: Chat_Bot_Forwarding_Constraint;
  update_columns?: Array<Chat_Bot_Forwarding_Update_Column>;
  where?: InputMaybe<Chat_Bot_Forwarding_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_bot.forwarding". */
export type Chat_Bot_Forwarding_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  make_id?: InputMaybe<Order_By>;
  webhook_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_bot.forwarding */
export type Chat_Bot_Forwarding_Pk_Columns_Input = {
  campaign_id: Scalars['uuid']['input'];
};

/** select columns of table "chat_bot.forwarding" */
export enum Chat_Bot_Forwarding_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MakeId = 'make_id',
  /** column name */
  WebhookUrl = 'webhook_url'
}

/** input type for updating data in table "chat_bot.forwarding" */
export type Chat_Bot_Forwarding_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
  webhook_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Chat_Bot_Forwarding_Stddev_Fields = {
  __typename?: 'chat_bot_forwarding_stddev_fields';
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Chat_Bot_Forwarding_Stddev_Pop_Fields = {
  __typename?: 'chat_bot_forwarding_stddev_pop_fields';
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Chat_Bot_Forwarding_Stddev_Samp_Fields = {
  __typename?: 'chat_bot_forwarding_stddev_samp_fields';
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "chat_bot_forwarding" */
export type Chat_Bot_Forwarding_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Bot_Forwarding_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Bot_Forwarding_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  make_id?: InputMaybe<Scalars['Int']['input']>;
  webhook_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Chat_Bot_Forwarding_Sum_Fields = {
  __typename?: 'chat_bot_forwarding_sum_fields';
  make_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "chat_bot.forwarding" */
export enum Chat_Bot_Forwarding_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MakeId = 'make_id',
  /** column name */
  WebhookUrl = 'webhook_url'
}

export type Chat_Bot_Forwarding_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Chat_Bot_Forwarding_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_Bot_Forwarding_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chat_Bot_Forwarding_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Chat_Bot_Forwarding_Var_Pop_Fields = {
  __typename?: 'chat_bot_forwarding_var_pop_fields';
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Chat_Bot_Forwarding_Var_Samp_Fields = {
  __typename?: 'chat_bot_forwarding_var_samp_fields';
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Chat_Bot_Forwarding_Variance_Fields = {
  __typename?: 'chat_bot_forwarding_variance_fields';
  make_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "chat_bot.message_type" */
export type Chat_Bot_Message_Type = {
  __typename?: 'chat_bot_message_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "chat_bot.message_type" */
export type Chat_Bot_Message_Type_Aggregate = {
  __typename?: 'chat_bot_message_type_aggregate';
  aggregate?: Maybe<Chat_Bot_Message_Type_Aggregate_Fields>;
  nodes: Array<Chat_Bot_Message_Type>;
};

/** aggregate fields of "chat_bot.message_type" */
export type Chat_Bot_Message_Type_Aggregate_Fields = {
  __typename?: 'chat_bot_message_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Bot_Message_Type_Max_Fields>;
  min?: Maybe<Chat_Bot_Message_Type_Min_Fields>;
};


/** aggregate fields of "chat_bot.message_type" */
export type Chat_Bot_Message_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Bot_Message_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "chat_bot.message_type". All fields are combined with a logical 'AND'. */
export type Chat_Bot_Message_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Bot_Message_Type_Bool_Exp>>;
  _not?: InputMaybe<Chat_Bot_Message_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Bot_Message_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_bot.message_type" */
export enum Chat_Bot_Message_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  MessageTypePkey = 'message_type_pkey'
}

export enum Chat_Bot_Message_Type_Enum {
  Button = 'BUTTON',
  Message = 'MESSAGE'
}

/** Boolean expression to compare columns of type "chat_bot_message_type_enum". All fields are combined with logical 'AND'. */
export type Chat_Bot_Message_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Chat_Bot_Message_Type_Enum>;
  _in?: InputMaybe<Array<Chat_Bot_Message_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Chat_Bot_Message_Type_Enum>;
  _nin?: InputMaybe<Array<Chat_Bot_Message_Type_Enum>>;
};

/** input type for inserting data into table "chat_bot.message_type" */
export type Chat_Bot_Message_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Chat_Bot_Message_Type_Max_Fields = {
  __typename?: 'chat_bot_message_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Chat_Bot_Message_Type_Min_Fields = {
  __typename?: 'chat_bot_message_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "chat_bot.message_type" */
export type Chat_Bot_Message_Type_Mutation_Response = {
  __typename?: 'chat_bot_message_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Bot_Message_Type>;
};

/** on_conflict condition type for table "chat_bot.message_type" */
export type Chat_Bot_Message_Type_On_Conflict = {
  constraint: Chat_Bot_Message_Type_Constraint;
  update_columns?: Array<Chat_Bot_Message_Type_Update_Column>;
  where?: InputMaybe<Chat_Bot_Message_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_bot.message_type". */
export type Chat_Bot_Message_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_bot.message_type */
export type Chat_Bot_Message_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "chat_bot.message_type" */
export enum Chat_Bot_Message_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "chat_bot.message_type" */
export type Chat_Bot_Message_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "chat_bot_message_type" */
export type Chat_Bot_Message_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Bot_Message_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Bot_Message_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "chat_bot.message_type" */
export enum Chat_Bot_Message_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Chat_Bot_Message_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_Bot_Message_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chat_Bot_Message_Type_Bool_Exp;
};

/** This table contains all types of messages that are broadcasted from landbot. You can find more information here: https://help.landbot.io/article/n9zxrqx1ig-message-hooks-landbot-webhooks */
export type Chat_Bot_Messages = {
  __typename?: 'chat_bot_messages';
  _raw: Scalars['jsonb']['output'];
  /** An object relationship */
  applicant?: Maybe<Contact>;
  channel_id: Scalars['Int']['output'];
  /** An object relationship */
  contact: Chat_Bot_Customers;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  customer_id: Scalars['Int']['output'];
  data: Scalars['jsonb']['output'];
  id: Scalars['bigint']['output'];
  sender_type: Scalars['String']['output'];
  type: Chat_Bot_Message_Type_Enum;
};


/** This table contains all types of messages that are broadcasted from landbot. You can find more information here: https://help.landbot.io/article/n9zxrqx1ig-message-hooks-landbot-webhooks */
export type Chat_Bot_Messages_RawArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** This table contains all types of messages that are broadcasted from landbot. You can find more information here: https://help.landbot.io/article/n9zxrqx1ig-message-hooks-landbot-webhooks */
export type Chat_Bot_MessagesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "chat_bot.messages" */
export type Chat_Bot_Messages_Aggregate = {
  __typename?: 'chat_bot_messages_aggregate';
  aggregate?: Maybe<Chat_Bot_Messages_Aggregate_Fields>;
  nodes: Array<Chat_Bot_Messages>;
};

export type Chat_Bot_Messages_Aggregate_Bool_Exp = {
  count?: InputMaybe<Chat_Bot_Messages_Aggregate_Bool_Exp_Count>;
};

export type Chat_Bot_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Bot_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "chat_bot.messages" */
export type Chat_Bot_Messages_Aggregate_Fields = {
  __typename?: 'chat_bot_messages_aggregate_fields';
  avg?: Maybe<Chat_Bot_Messages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Bot_Messages_Max_Fields>;
  min?: Maybe<Chat_Bot_Messages_Min_Fields>;
  stddev?: Maybe<Chat_Bot_Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Chat_Bot_Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chat_Bot_Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Chat_Bot_Messages_Sum_Fields>;
  var_pop?: Maybe<Chat_Bot_Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Chat_Bot_Messages_Var_Samp_Fields>;
  variance?: Maybe<Chat_Bot_Messages_Variance_Fields>;
};


/** aggregate fields of "chat_bot.messages" */
export type Chat_Bot_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Bot_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "chat_bot.messages" */
export type Chat_Bot_Messages_Aggregate_Order_By = {
  avg?: InputMaybe<Chat_Bot_Messages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Bot_Messages_Max_Order_By>;
  min?: InputMaybe<Chat_Bot_Messages_Min_Order_By>;
  stddev?: InputMaybe<Chat_Bot_Messages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Chat_Bot_Messages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Chat_Bot_Messages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Chat_Bot_Messages_Sum_Order_By>;
  var_pop?: InputMaybe<Chat_Bot_Messages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Chat_Bot_Messages_Var_Samp_Order_By>;
  variance?: InputMaybe<Chat_Bot_Messages_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Chat_Bot_Messages_Append_Input = {
  _raw?: InputMaybe<Scalars['jsonb']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "chat_bot.messages" */
export type Chat_Bot_Messages_Arr_Rel_Insert_Input = {
  data: Array<Chat_Bot_Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Chat_Bot_Messages_On_Conflict>;
};

/** aggregate avg on columns */
export type Chat_Bot_Messages_Avg_Fields = {
  __typename?: 'chat_bot_messages_avg_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  customer_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "chat_bot.messages" */
export type Chat_Bot_Messages_Avg_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "chat_bot.messages". All fields are combined with a logical 'AND'. */
export type Chat_Bot_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Bot_Messages_Bool_Exp>>;
  _not?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Bot_Messages_Bool_Exp>>;
  _raw?: InputMaybe<Jsonb_Comparison_Exp>;
  applicant?: InputMaybe<Contact_Bool_Exp>;
  channel_id?: InputMaybe<Int_Comparison_Exp>;
  contact?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_id?: InputMaybe<Int_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  sender_type?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Chat_Bot_Message_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_bot.messages" */
export enum Chat_Bot_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagePkey = 'message_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Chat_Bot_Messages_Delete_At_Path_Input = {
  _raw?: InputMaybe<Array<Scalars['String']['input']>>;
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Chat_Bot_Messages_Delete_Elem_Input = {
  _raw?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Chat_Bot_Messages_Delete_Key_Input = {
  _raw?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "chat_bot.messages" */
export type Chat_Bot_Messages_Inc_Input = {
  channel_id?: InputMaybe<Scalars['Int']['input']>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "chat_bot.messages" */
export type Chat_Bot_Messages_Insert_Input = {
  _raw?: InputMaybe<Scalars['jsonb']['input']>;
  applicant?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  channel_id?: InputMaybe<Scalars['Int']['input']>;
  contact?: InputMaybe<Chat_Bot_Customers_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sender_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Chat_Bot_Message_Type_Enum>;
};

/** aggregate max on columns */
export type Chat_Bot_Messages_Max_Fields = {
  __typename?: 'chat_bot_messages_max_fields';
  channel_id?: Maybe<Scalars['Int']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  sender_type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "chat_bot.messages" */
export type Chat_Bot_Messages_Max_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sender_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Bot_Messages_Min_Fields = {
  __typename?: 'chat_bot_messages_min_fields';
  channel_id?: Maybe<Scalars['Int']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  sender_type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "chat_bot.messages" */
export type Chat_Bot_Messages_Min_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sender_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "chat_bot.messages" */
export type Chat_Bot_Messages_Mutation_Response = {
  __typename?: 'chat_bot_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Bot_Messages>;
};

/** on_conflict condition type for table "chat_bot.messages" */
export type Chat_Bot_Messages_On_Conflict = {
  constraint: Chat_Bot_Messages_Constraint;
  update_columns?: Array<Chat_Bot_Messages_Update_Column>;
  where?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_bot.messages". */
export type Chat_Bot_Messages_Order_By = {
  _raw?: InputMaybe<Order_By>;
  applicant?: InputMaybe<Contact_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Chat_Bot_Customers_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sender_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_bot.messages */
export type Chat_Bot_Messages_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Chat_Bot_Messages_Prepend_Input = {
  _raw?: InputMaybe<Scalars['jsonb']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "chat_bot.messages" */
export enum Chat_Bot_Messages_Select_Column {
  /** column name */
  Raw = '_raw',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  SenderType = 'sender_type',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "chat_bot.messages" */
export type Chat_Bot_Messages_Set_Input = {
  _raw?: InputMaybe<Scalars['jsonb']['input']>;
  channel_id?: InputMaybe<Scalars['Int']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sender_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Chat_Bot_Message_Type_Enum>;
};

/** aggregate stddev on columns */
export type Chat_Bot_Messages_Stddev_Fields = {
  __typename?: 'chat_bot_messages_stddev_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  customer_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "chat_bot.messages" */
export type Chat_Bot_Messages_Stddev_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Chat_Bot_Messages_Stddev_Pop_Fields = {
  __typename?: 'chat_bot_messages_stddev_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  customer_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "chat_bot.messages" */
export type Chat_Bot_Messages_Stddev_Pop_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Chat_Bot_Messages_Stddev_Samp_Fields = {
  __typename?: 'chat_bot_messages_stddev_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  customer_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "chat_bot.messages" */
export type Chat_Bot_Messages_Stddev_Samp_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "chat_bot_messages" */
export type Chat_Bot_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Bot_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Bot_Messages_Stream_Cursor_Value_Input = {
  _raw?: InputMaybe<Scalars['jsonb']['input']>;
  channel_id?: InputMaybe<Scalars['Int']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sender_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Chat_Bot_Message_Type_Enum>;
};

/** aggregate sum on columns */
export type Chat_Bot_Messages_Sum_Fields = {
  __typename?: 'chat_bot_messages_sum_fields';
  channel_id?: Maybe<Scalars['Int']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "chat_bot.messages" */
export type Chat_Bot_Messages_Sum_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "chat_bot.messages" */
export enum Chat_Bot_Messages_Update_Column {
  /** column name */
  Raw = '_raw',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  SenderType = 'sender_type',
  /** column name */
  Type = 'type'
}

export type Chat_Bot_Messages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Chat_Bot_Messages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Chat_Bot_Messages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Chat_Bot_Messages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Chat_Bot_Messages_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Chat_Bot_Messages_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Chat_Bot_Messages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_Bot_Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chat_Bot_Messages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Chat_Bot_Messages_Var_Pop_Fields = {
  __typename?: 'chat_bot_messages_var_pop_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  customer_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "chat_bot.messages" */
export type Chat_Bot_Messages_Var_Pop_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Chat_Bot_Messages_Var_Samp_Fields = {
  __typename?: 'chat_bot_messages_var_samp_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  customer_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "chat_bot.messages" */
export type Chat_Bot_Messages_Var_Samp_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Chat_Bot_Messages_Variance_Fields = {
  __typename?: 'chat_bot_messages_variance_fields';
  channel_id?: Maybe<Scalars['Float']['output']>;
  customer_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "chat_bot.messages" */
export type Chat_Bot_Messages_Variance_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "contact" */
export type Contact = {
  __typename?: 'contact';
  accepted_data_privacy_agreement: Scalars['Boolean']['output'];
  /** An array relationship */
  answers: Array<Answer>;
  /** An aggregate relationship */
  answers_aggregate: Answer_Aggregate;
  birthdate?: Maybe<Scalars['String']['output']>;
  bot_consent?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  /** An object relationship */
  chat_bot_contact?: Maybe<Chat_Bot_Customers>;
  city?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  contact_board_entries: Array<Board_Contact_Board_Entry>;
  /** An aggregate relationship */
  contact_board_entries_aggregate: Board_Contact_Board_Entry_Aggregate;
  /** An array relationship */
  contacts: Array<Chat_Bot_Customers>;
  /** An aggregate relationship */
  contacts_aggregate: Chat_Bot_Customers_Aggregate;
  converted_at?: Maybe<Scalars['timestamptz']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  cv?: Maybe<File_Upload>;
  cv_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email_address: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  form_of_address?: Maybe<Scalars['String']['output']>;
  funnel_file_id?: Maybe<Scalars['uuid']['output']>;
  has_completed_chatbot?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  last_name: Scalars['String']['output'];
  /** An object relationship */
  origin_campaign?: Maybe<Campaign>;
  origin_campaign_id?: Maybe<Scalars['uuid']['output']>;
  perspective_id?: Maybe<Scalars['String']['output']>;
  phone_number: Scalars['String']['output'];
  qa_source?: Maybe<Qa_Source_Enum>;
  /** An object relationship */
  qa_source_enum?: Maybe<Qa_Source>;
  qualified: Scalars['Boolean']['output'];
  routing_location_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  utm_source?: Maybe<Ad_Platform_Enum>;
  zip_code?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "contact" */
export type ContactAnswersArgs = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By>>;
  where?: InputMaybe<Answer_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By>>;
  where?: InputMaybe<Answer_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactContact_Board_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Entry_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactContact_Board_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Entry_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactContactsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Customers_Order_By>>;
  where?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Customers_Order_By>>;
  where?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
};

/** aggregated selection of "contact" */
export type Contact_Aggregate = {
  __typename?: 'contact_aggregate';
  aggregate?: Maybe<Contact_Aggregate_Fields>;
  nodes: Array<Contact>;
};

export type Contact_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Contact_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Contact_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Contact_Aggregate_Bool_Exp_Count>;
};

export type Contact_Aggregate_Bool_Exp_Bool_And = {
  arguments: Contact_Select_Column_Contact_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contact_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Contact_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Contact_Select_Column_Contact_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contact_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Contact_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contact_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contact" */
export type Contact_Aggregate_Fields = {
  __typename?: 'contact_aggregate_fields';
  avg?: Maybe<Contact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Contact_Max_Fields>;
  min?: Maybe<Contact_Min_Fields>;
  stddev?: Maybe<Contact_Stddev_Fields>;
  stddev_pop?: Maybe<Contact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contact_Stddev_Samp_Fields>;
  sum?: Maybe<Contact_Sum_Fields>;
  var_pop?: Maybe<Contact_Var_Pop_Fields>;
  var_samp?: Maybe<Contact_Var_Samp_Fields>;
  variance?: Maybe<Contact_Variance_Fields>;
};


/** aggregate fields of "contact" */
export type Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "contact" */
export type Contact_Aggregate_Order_By = {
  avg?: InputMaybe<Contact_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contact_Max_Order_By>;
  min?: InputMaybe<Contact_Min_Order_By>;
  stddev?: InputMaybe<Contact_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Contact_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Contact_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Contact_Sum_Order_By>;
  var_pop?: InputMaybe<Contact_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Contact_Var_Samp_Order_By>;
  variance?: InputMaybe<Contact_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "contact" */
export type Contact_Arr_Rel_Insert_Input = {
  data: Array<Contact_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};

/** aggregate avg on columns */
export type Contact_Avg_Fields = {
  __typename?: 'contact_avg_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "contact" */
export type Contact_Avg_Order_By = {
  routing_location_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "contact". All fields are combined with a logical 'AND'. */
export type Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_Bool_Exp>>;
  _not?: InputMaybe<Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Contact_Bool_Exp>>;
  accepted_data_privacy_agreement?: InputMaybe<Boolean_Comparison_Exp>;
  answers?: InputMaybe<Answer_Bool_Exp>;
  answers_aggregate?: InputMaybe<Answer_Aggregate_Bool_Exp>;
  birthdate?: InputMaybe<String_Comparison_Exp>;
  bot_consent?: InputMaybe<Boolean_Comparison_Exp>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  chat_bot_contact?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  contact_board_entries?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
  contact_board_entries_aggregate?: InputMaybe<Board_Contact_Board_Entry_Aggregate_Bool_Exp>;
  contacts?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Chat_Bot_Customers_Aggregate_Bool_Exp>;
  converted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cv?: InputMaybe<File_Upload_Bool_Exp>;
  cv_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  form_of_address?: InputMaybe<String_Comparison_Exp>;
  funnel_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_completed_chatbot?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  origin_campaign?: InputMaybe<Campaign_Bool_Exp>;
  origin_campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  perspective_id?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  qa_source?: InputMaybe<Qa_Source_Enum_Comparison_Exp>;
  qa_source_enum?: InputMaybe<Qa_Source_Bool_Exp>;
  qualified?: InputMaybe<Boolean_Comparison_Exp>;
  routing_location_id?: InputMaybe<Int_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utm_source?: InputMaybe<Ad_Platform_Enum_Comparison_Exp>;
  zip_code?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "contact" */
export enum Contact_Constraint {
  /** unique or primary key constraint on columns "cv_id" */
  ContactCvIdKey = 'contact_cv_id_key',
  /** unique or primary key constraint on columns "perspective_id" */
  ContactPerspectiveIdKey = 'contact_perspective_id_key',
  /** unique or primary key constraint on columns "id" */
  ContactPkey = 'contact_pkey'
}

/** input type for incrementing numeric columns in table "contact" */
export type Contact_Inc_Input = {
  routing_location_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "contact" */
export type Contact_Insert_Input = {
  accepted_data_privacy_agreement?: InputMaybe<Scalars['Boolean']['input']>;
  answers?: InputMaybe<Answer_Arr_Rel_Insert_Input>;
  birthdate?: InputMaybe<Scalars['String']['input']>;
  bot_consent?: InputMaybe<Scalars['Boolean']['input']>;
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  chat_bot_contact?: InputMaybe<Chat_Bot_Customers_Obj_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact_board_entries?: InputMaybe<Board_Contact_Board_Entry_Arr_Rel_Insert_Input>;
  contacts?: InputMaybe<Chat_Bot_Customers_Arr_Rel_Insert_Input>;
  converted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cv?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  cv_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  form_of_address?: InputMaybe<Scalars['String']['input']>;
  funnel_file_id?: InputMaybe<Scalars['uuid']['input']>;
  has_completed_chatbot?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  origin_campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  origin_campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  perspective_id?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  qa_source?: InputMaybe<Qa_Source_Enum>;
  qa_source_enum?: InputMaybe<Qa_Source_Obj_Rel_Insert_Input>;
  qualified?: InputMaybe<Scalars['Boolean']['input']>;
  routing_location_id?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utm_source?: InputMaybe<Ad_Platform_Enum>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

/** applied via funnelui */
export type Contact_Logs = {
  __typename?: 'contact_logs';
  bot_ended_at?: Maybe<Scalars['timestamp']['output']>;
  bot_started_at?: Maybe<Scalars['timestamp']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamp']['output'];
  error?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['Int']['output'];
  payload: Scalars['jsonb']['output'];
  qualified_at?: Maybe<Scalars['timestamp']['output']>;
  report_generated_at?: Maybe<Scalars['timestamp']['output']>;
  rms_forwarded_at?: Maybe<Scalars['timestamp']['output']>;
};


/** applied via funnelui */
export type Contact_LogsErrorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** applied via funnelui */
export type Contact_LogsPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "contact.logs" */
export type Contact_Logs_Aggregate = {
  __typename?: 'contact_logs_aggregate';
  aggregate?: Maybe<Contact_Logs_Aggregate_Fields>;
  nodes: Array<Contact_Logs>;
};

/** aggregate fields of "contact.logs" */
export type Contact_Logs_Aggregate_Fields = {
  __typename?: 'contact_logs_aggregate_fields';
  avg?: Maybe<Contact_Logs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Contact_Logs_Max_Fields>;
  min?: Maybe<Contact_Logs_Min_Fields>;
  stddev?: Maybe<Contact_Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Contact_Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contact_Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Contact_Logs_Sum_Fields>;
  var_pop?: Maybe<Contact_Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Contact_Logs_Var_Samp_Fields>;
  variance?: Maybe<Contact_Logs_Variance_Fields>;
};


/** aggregate fields of "contact.logs" */
export type Contact_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Contact_Logs_Append_Input = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Contact_Logs_Avg_Fields = {
  __typename?: 'contact_logs_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "contact.logs". All fields are combined with a logical 'AND'. */
export type Contact_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_Logs_Bool_Exp>>;
  _not?: InputMaybe<Contact_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Contact_Logs_Bool_Exp>>;
  bot_ended_at?: InputMaybe<Timestamp_Comparison_Exp>;
  bot_started_at?: InputMaybe<Timestamp_Comparison_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  error?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  qualified_at?: InputMaybe<Timestamp_Comparison_Exp>;
  report_generated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  rms_forwarded_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "contact.logs" */
export enum Contact_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogsPkey = 'logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Contact_Logs_Delete_At_Path_Input = {
  error?: InputMaybe<Array<Scalars['String']['input']>>;
  payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Contact_Logs_Delete_Elem_Input = {
  error?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Contact_Logs_Delete_Key_Input = {
  error?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "contact.logs" */
export type Contact_Logs_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "contact.logs" */
export type Contact_Logs_Insert_Input = {
  bot_ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  bot_started_at?: InputMaybe<Scalars['timestamp']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  qualified_at?: InputMaybe<Scalars['timestamp']['input']>;
  report_generated_at?: InputMaybe<Scalars['timestamp']['input']>;
  rms_forwarded_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Contact_Logs_Max_Fields = {
  __typename?: 'contact_logs_max_fields';
  bot_ended_at?: Maybe<Scalars['timestamp']['output']>;
  bot_started_at?: Maybe<Scalars['timestamp']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  qualified_at?: Maybe<Scalars['timestamp']['output']>;
  report_generated_at?: Maybe<Scalars['timestamp']['output']>;
  rms_forwarded_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Contact_Logs_Min_Fields = {
  __typename?: 'contact_logs_min_fields';
  bot_ended_at?: Maybe<Scalars['timestamp']['output']>;
  bot_started_at?: Maybe<Scalars['timestamp']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  qualified_at?: Maybe<Scalars['timestamp']['output']>;
  report_generated_at?: Maybe<Scalars['timestamp']['output']>;
  rms_forwarded_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "contact.logs" */
export type Contact_Logs_Mutation_Response = {
  __typename?: 'contact_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contact_Logs>;
};

/** on_conflict condition type for table "contact.logs" */
export type Contact_Logs_On_Conflict = {
  constraint: Contact_Logs_Constraint;
  update_columns?: Array<Contact_Logs_Update_Column>;
  where?: InputMaybe<Contact_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "contact.logs". */
export type Contact_Logs_Order_By = {
  bot_ended_at?: InputMaybe<Order_By>;
  bot_started_at?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  qualified_at?: InputMaybe<Order_By>;
  report_generated_at?: InputMaybe<Order_By>;
  rms_forwarded_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contact.logs */
export type Contact_Logs_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Contact_Logs_Prepend_Input = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "contact.logs" */
export enum Contact_Logs_Select_Column {
  /** column name */
  BotEndedAt = 'bot_ended_at',
  /** column name */
  BotStartedAt = 'bot_started_at',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Error = 'error',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  QualifiedAt = 'qualified_at',
  /** column name */
  ReportGeneratedAt = 'report_generated_at',
  /** column name */
  RmsForwardedAt = 'rms_forwarded_at'
}

/** input type for updating data in table "contact.logs" */
export type Contact_Logs_Set_Input = {
  bot_ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  bot_started_at?: InputMaybe<Scalars['timestamp']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  qualified_at?: InputMaybe<Scalars['timestamp']['input']>;
  report_generated_at?: InputMaybe<Scalars['timestamp']['input']>;
  rms_forwarded_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Contact_Logs_Stddev_Fields = {
  __typename?: 'contact_logs_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Contact_Logs_Stddev_Pop_Fields = {
  __typename?: 'contact_logs_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Contact_Logs_Stddev_Samp_Fields = {
  __typename?: 'contact_logs_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "contact_logs" */
export type Contact_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_Logs_Stream_Cursor_Value_Input = {
  bot_ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  bot_started_at?: InputMaybe<Scalars['timestamp']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  qualified_at?: InputMaybe<Scalars['timestamp']['input']>;
  report_generated_at?: InputMaybe<Scalars['timestamp']['input']>;
  rms_forwarded_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Contact_Logs_Sum_Fields = {
  __typename?: 'contact_logs_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "contact.logs" */
export enum Contact_Logs_Update_Column {
  /** column name */
  BotEndedAt = 'bot_ended_at',
  /** column name */
  BotStartedAt = 'bot_started_at',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Error = 'error',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  QualifiedAt = 'qualified_at',
  /** column name */
  ReportGeneratedAt = 'report_generated_at',
  /** column name */
  RmsForwardedAt = 'rms_forwarded_at'
}

export type Contact_Logs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Contact_Logs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Contact_Logs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Contact_Logs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Contact_Logs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Contact_Logs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Contact_Logs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contact_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contact_Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contact_Logs_Var_Pop_Fields = {
  __typename?: 'contact_logs_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Contact_Logs_Var_Samp_Fields = {
  __typename?: 'contact_logs_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Contact_Logs_Variance_Fields = {
  __typename?: 'contact_logs_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Contact_Max_Fields = {
  __typename?: 'contact_max_fields';
  birthdate?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  converted_at?: Maybe<Scalars['timestamptz']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  cv_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  form_of_address?: Maybe<Scalars['String']['output']>;
  funnel_file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  origin_campaign_id?: Maybe<Scalars['uuid']['output']>;
  perspective_id?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  routing_location_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "contact" */
export type Contact_Max_Order_By = {
  birthdate?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  converted_at?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  cv_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  form_of_address?: InputMaybe<Order_By>;
  funnel_file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  origin_campaign_id?: InputMaybe<Order_By>;
  perspective_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  routing_location_id?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contact_Min_Fields = {
  __typename?: 'contact_min_fields';
  birthdate?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  converted_at?: Maybe<Scalars['timestamptz']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  cv_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  form_of_address?: Maybe<Scalars['String']['output']>;
  funnel_file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  origin_campaign_id?: Maybe<Scalars['uuid']['output']>;
  perspective_id?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  routing_location_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "contact" */
export type Contact_Min_Order_By = {
  birthdate?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  converted_at?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  cv_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  form_of_address?: InputMaybe<Order_By>;
  funnel_file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  origin_campaign_id?: InputMaybe<Order_By>;
  perspective_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  routing_location_id?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "contact" */
export type Contact_Mutation_Response = {
  __typename?: 'contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contact>;
};

/** input type for inserting object relation for remote table "contact" */
export type Contact_Obj_Rel_Insert_Input = {
  data: Contact_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};

/** on_conflict condition type for table "contact" */
export type Contact_On_Conflict = {
  constraint: Contact_Constraint;
  update_columns?: Array<Contact_Update_Column>;
  where?: InputMaybe<Contact_Bool_Exp>;
};

/** Ordering options when selecting data from "contact". */
export type Contact_Order_By = {
  accepted_data_privacy_agreement?: InputMaybe<Order_By>;
  answers_aggregate?: InputMaybe<Answer_Aggregate_Order_By>;
  birthdate?: InputMaybe<Order_By>;
  bot_consent?: InputMaybe<Order_By>;
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  chat_bot_contact?: InputMaybe<Chat_Bot_Customers_Order_By>;
  city?: InputMaybe<Order_By>;
  contact_board_entries_aggregate?: InputMaybe<Board_Contact_Board_Entry_Aggregate_Order_By>;
  contacts_aggregate?: InputMaybe<Chat_Bot_Customers_Aggregate_Order_By>;
  converted_at?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  cv?: InputMaybe<File_Upload_Order_By>;
  cv_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  form_of_address?: InputMaybe<Order_By>;
  funnel_file_id?: InputMaybe<Order_By>;
  has_completed_chatbot?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  origin_campaign?: InputMaybe<Campaign_Order_By>;
  origin_campaign_id?: InputMaybe<Order_By>;
  perspective_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  qa_source?: InputMaybe<Order_By>;
  qa_source_enum?: InputMaybe<Qa_Source_Order_By>;
  qualified?: InputMaybe<Order_By>;
  routing_location_id?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contact */
export type Contact_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "contact" */
export enum Contact_Select_Column {
  /** column name */
  AcceptedDataPrivacyAgreement = 'accepted_data_privacy_agreement',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  BotConsent = 'bot_consent',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  City = 'city',
  /** column name */
  ConvertedAt = 'converted_at',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CvId = 'cv_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormOfAddress = 'form_of_address',
  /** column name */
  FunnelFileId = 'funnel_file_id',
  /** column name */
  HasCompletedChatbot = 'has_completed_chatbot',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OriginCampaignId = 'origin_campaign_id',
  /** column name */
  PerspectiveId = 'perspective_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  QaSource = 'qa_source',
  /** column name */
  Qualified = 'qualified',
  /** column name */
  RoutingLocationId = 'routing_location_id',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtmSource = 'utm_source',
  /** column name */
  ZipCode = 'zip_code'
}

/** select "contact_aggregate_bool_exp_bool_and_arguments_columns" columns of table "contact" */
export enum Contact_Select_Column_Contact_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AcceptedDataPrivacyAgreement = 'accepted_data_privacy_agreement',
  /** column name */
  BotConsent = 'bot_consent',
  /** column name */
  HasCompletedChatbot = 'has_completed_chatbot',
  /** column name */
  Qualified = 'qualified'
}

/** select "contact_aggregate_bool_exp_bool_or_arguments_columns" columns of table "contact" */
export enum Contact_Select_Column_Contact_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AcceptedDataPrivacyAgreement = 'accepted_data_privacy_agreement',
  /** column name */
  BotConsent = 'bot_consent',
  /** column name */
  HasCompletedChatbot = 'has_completed_chatbot',
  /** column name */
  Qualified = 'qualified'
}

/** input type for updating data in table "contact" */
export type Contact_Set_Input = {
  accepted_data_privacy_agreement?: InputMaybe<Scalars['Boolean']['input']>;
  birthdate?: InputMaybe<Scalars['String']['input']>;
  bot_consent?: InputMaybe<Scalars['Boolean']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  converted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cv_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  form_of_address?: InputMaybe<Scalars['String']['input']>;
  funnel_file_id?: InputMaybe<Scalars['uuid']['input']>;
  has_completed_chatbot?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  origin_campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  perspective_id?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  qa_source?: InputMaybe<Qa_Source_Enum>;
  qualified?: InputMaybe<Scalars['Boolean']['input']>;
  routing_location_id?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utm_source?: InputMaybe<Ad_Platform_Enum>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Contact_Stddev_Fields = {
  __typename?: 'contact_stddev_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "contact" */
export type Contact_Stddev_Order_By = {
  routing_location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Contact_Stddev_Pop_Fields = {
  __typename?: 'contact_stddev_pop_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "contact" */
export type Contact_Stddev_Pop_Order_By = {
  routing_location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Contact_Stddev_Samp_Fields = {
  __typename?: 'contact_stddev_samp_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "contact" */
export type Contact_Stddev_Samp_Order_By = {
  routing_location_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "contact" */
export type Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_Stream_Cursor_Value_Input = {
  accepted_data_privacy_agreement?: InputMaybe<Scalars['Boolean']['input']>;
  birthdate?: InputMaybe<Scalars['String']['input']>;
  bot_consent?: InputMaybe<Scalars['Boolean']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  converted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cv_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  form_of_address?: InputMaybe<Scalars['String']['input']>;
  funnel_file_id?: InputMaybe<Scalars['uuid']['input']>;
  has_completed_chatbot?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  origin_campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  perspective_id?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  qa_source?: InputMaybe<Qa_Source_Enum>;
  qualified?: InputMaybe<Scalars['Boolean']['input']>;
  routing_location_id?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utm_source?: InputMaybe<Ad_Platform_Enum>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Contact_Sum_Fields = {
  __typename?: 'contact_sum_fields';
  routing_location_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "contact" */
export type Contact_Sum_Order_By = {
  routing_location_id?: InputMaybe<Order_By>;
};

/** update columns of table "contact" */
export enum Contact_Update_Column {
  /** column name */
  AcceptedDataPrivacyAgreement = 'accepted_data_privacy_agreement',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  BotConsent = 'bot_consent',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  City = 'city',
  /** column name */
  ConvertedAt = 'converted_at',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CvId = 'cv_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormOfAddress = 'form_of_address',
  /** column name */
  FunnelFileId = 'funnel_file_id',
  /** column name */
  HasCompletedChatbot = 'has_completed_chatbot',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OriginCampaignId = 'origin_campaign_id',
  /** column name */
  PerspectiveId = 'perspective_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  QaSource = 'qa_source',
  /** column name */
  Qualified = 'qualified',
  /** column name */
  RoutingLocationId = 'routing_location_id',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtmSource = 'utm_source',
  /** column name */
  ZipCode = 'zip_code'
}

export type Contact_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Contact_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contact_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contact_Var_Pop_Fields = {
  __typename?: 'contact_var_pop_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "contact" */
export type Contact_Var_Pop_Order_By = {
  routing_location_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Contact_Var_Samp_Fields = {
  __typename?: 'contact_var_samp_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "contact" */
export type Contact_Var_Samp_Order_By = {
  routing_location_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Contact_Variance_Fields = {
  __typename?: 'contact_variance_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "contact" */
export type Contact_Variance_Order_By = {
  routing_location_id?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "file.pdf_templates" */
export type File_Pdf_Templates = {
  __typename?: 'file_pdf_templates';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  template: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "file.pdf_templates" */
export type File_Pdf_Templates_Aggregate = {
  __typename?: 'file_pdf_templates_aggregate';
  aggregate?: Maybe<File_Pdf_Templates_Aggregate_Fields>;
  nodes: Array<File_Pdf_Templates>;
};

/** aggregate fields of "file.pdf_templates" */
export type File_Pdf_Templates_Aggregate_Fields = {
  __typename?: 'file_pdf_templates_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<File_Pdf_Templates_Max_Fields>;
  min?: Maybe<File_Pdf_Templates_Min_Fields>;
};


/** aggregate fields of "file.pdf_templates" */
export type File_Pdf_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Pdf_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "file.pdf_templates". All fields are combined with a logical 'AND'. */
export type File_Pdf_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<File_Pdf_Templates_Bool_Exp>>;
  _not?: InputMaybe<File_Pdf_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<File_Pdf_Templates_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  template?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "file.pdf_templates" */
export enum File_Pdf_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  PdfTemplatesPkey = 'pdf_templates_pkey'
}

/** input type for inserting data into table "file.pdf_templates" */
export type File_Pdf_Templates_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type File_Pdf_Templates_Max_Fields = {
  __typename?: 'file_pdf_templates_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type File_Pdf_Templates_Min_Fields = {
  __typename?: 'file_pdf_templates_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "file.pdf_templates" */
export type File_Pdf_Templates_Mutation_Response = {
  __typename?: 'file_pdf_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<File_Pdf_Templates>;
};

/** on_conflict condition type for table "file.pdf_templates" */
export type File_Pdf_Templates_On_Conflict = {
  constraint: File_Pdf_Templates_Constraint;
  update_columns?: Array<File_Pdf_Templates_Update_Column>;
  where?: InputMaybe<File_Pdf_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "file.pdf_templates". */
export type File_Pdf_Templates_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: file.pdf_templates */
export type File_Pdf_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "file.pdf_templates" */
export enum File_Pdf_Templates_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Template = 'template',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "file.pdf_templates" */
export type File_Pdf_Templates_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "file_pdf_templates" */
export type File_Pdf_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Pdf_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Pdf_Templates_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "file.pdf_templates" */
export enum File_Pdf_Templates_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Template = 'template',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type File_Pdf_Templates_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_Pdf_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: File_Pdf_Templates_Bool_Exp;
};

/** columns and relationships of "file.upload" */
export type File_Upload = {
  __typename?: 'file_upload';
  bucket: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  original_filename: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

/** aggregated selection of "file.upload" */
export type File_Upload_Aggregate = {
  __typename?: 'file_upload_aggregate';
  aggregate?: Maybe<File_Upload_Aggregate_Fields>;
  nodes: Array<File_Upload>;
};

/** aggregate fields of "file.upload" */
export type File_Upload_Aggregate_Fields = {
  __typename?: 'file_upload_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<File_Upload_Max_Fields>;
  min?: Maybe<File_Upload_Min_Fields>;
};


/** aggregate fields of "file.upload" */
export type File_Upload_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Upload_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "file.upload". All fields are combined with a logical 'AND'. */
export type File_Upload_Bool_Exp = {
  _and?: InputMaybe<Array<File_Upload_Bool_Exp>>;
  _not?: InputMaybe<File_Upload_Bool_Exp>;
  _or?: InputMaybe<Array<File_Upload_Bool_Exp>>;
  bucket?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  original_filename?: InputMaybe<String_Comparison_Exp>;
  path?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "file.upload" */
export enum File_Upload_Constraint {
  /** unique or primary key constraint on columns "bucket", "filename", "path" */
  UploadFilenamePathBucketKey = 'upload_filename_path_bucket_key',
  /** unique or primary key constraint on columns "id" */
  UploadPkey = 'upload_pkey'
}

/** input type for inserting data into table "file.upload" */
export type File_Upload_Insert_Input = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  original_filename?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type File_Upload_Max_Fields = {
  __typename?: 'file_upload_max_fields';
  bucket?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  original_filename?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type File_Upload_Min_Fields = {
  __typename?: 'file_upload_min_fields';
  bucket?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  original_filename?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "file.upload" */
export type File_Upload_Mutation_Response = {
  __typename?: 'file_upload_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<File_Upload>;
};

/** input type for inserting object relation for remote table "file.upload" */
export type File_Upload_Obj_Rel_Insert_Input = {
  data: File_Upload_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<File_Upload_On_Conflict>;
};

/** on_conflict condition type for table "file.upload" */
export type File_Upload_On_Conflict = {
  constraint: File_Upload_Constraint;
  update_columns?: Array<File_Upload_Update_Column>;
  where?: InputMaybe<File_Upload_Bool_Exp>;
};

/** Ordering options when selecting data from "file.upload". */
export type File_Upload_Order_By = {
  bucket?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  original_filename?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
};

/** primary key columns input for table: file.upload */
export type File_Upload_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "file.upload" */
export enum File_Upload_Select_Column {
  /** column name */
  Bucket = 'bucket',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFilename = 'original_filename',
  /** column name */
  Path = 'path'
}

/** input type for updating data in table "file.upload" */
export type File_Upload_Set_Input = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  original_filename?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "file_upload" */
export type File_Upload_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Upload_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Upload_Stream_Cursor_Value_Input = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  original_filename?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "file.upload" */
export enum File_Upload_Update_Column {
  /** column name */
  Bucket = 'bucket',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFilename = 'original_filename',
  /** column name */
  Path = 'path'
}

export type File_Upload_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_Upload_Set_Input>;
  /** filter the rows which have to be updated */
  where: File_Upload_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "funnel.benefits" */
export type Funnel_Benefits = {
  __typename?: 'funnel_benefits';
  description: Scalars['String']['output'];
  /** An object relationship */
  funnel: Funnel_Funnels;
  funnel_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  title: Scalars['String']['output'];
};

/** aggregated selection of "funnel.benefits" */
export type Funnel_Benefits_Aggregate = {
  __typename?: 'funnel_benefits_aggregate';
  aggregate?: Maybe<Funnel_Benefits_Aggregate_Fields>;
  nodes: Array<Funnel_Benefits>;
};

export type Funnel_Benefits_Aggregate_Bool_Exp = {
  count?: InputMaybe<Funnel_Benefits_Aggregate_Bool_Exp_Count>;
};

export type Funnel_Benefits_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Funnel_Benefits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Funnel_Benefits_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "funnel.benefits" */
export type Funnel_Benefits_Aggregate_Fields = {
  __typename?: 'funnel_benefits_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Funnel_Benefits_Max_Fields>;
  min?: Maybe<Funnel_Benefits_Min_Fields>;
};


/** aggregate fields of "funnel.benefits" */
export type Funnel_Benefits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funnel_Benefits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "funnel.benefits" */
export type Funnel_Benefits_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Funnel_Benefits_Max_Order_By>;
  min?: InputMaybe<Funnel_Benefits_Min_Order_By>;
};

/** input type for inserting array relation for remote table "funnel.benefits" */
export type Funnel_Benefits_Arr_Rel_Insert_Input = {
  data: Array<Funnel_Benefits_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Funnel_Benefits_On_Conflict>;
};

/** Boolean expression to filter rows from the table "funnel.benefits". All fields are combined with a logical 'AND'. */
export type Funnel_Benefits_Bool_Exp = {
  _and?: InputMaybe<Array<Funnel_Benefits_Bool_Exp>>;
  _not?: InputMaybe<Funnel_Benefits_Bool_Exp>;
  _or?: InputMaybe<Array<Funnel_Benefits_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  funnel?: InputMaybe<Funnel_Funnels_Bool_Exp>;
  funnel_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "funnel.benefits" */
export enum Funnel_Benefits_Constraint {
  /** unique or primary key constraint on columns "id" */
  FunnelExpectationsPkey = 'funnel_expectations_pkey'
}

/** input type for inserting data into table "funnel.benefits" */
export type Funnel_Benefits_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  funnel?: InputMaybe<Funnel_Funnels_Obj_Rel_Insert_Input>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Funnel_Benefits_Max_Fields = {
  __typename?: 'funnel_benefits_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "funnel.benefits" */
export type Funnel_Benefits_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Funnel_Benefits_Min_Fields = {
  __typename?: 'funnel_benefits_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "funnel.benefits" */
export type Funnel_Benefits_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "funnel.benefits" */
export type Funnel_Benefits_Mutation_Response = {
  __typename?: 'funnel_benefits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Funnel_Benefits>;
};

/** on_conflict condition type for table "funnel.benefits" */
export type Funnel_Benefits_On_Conflict = {
  constraint: Funnel_Benefits_Constraint;
  update_columns?: Array<Funnel_Benefits_Update_Column>;
  where?: InputMaybe<Funnel_Benefits_Bool_Exp>;
};

/** Ordering options when selecting data from "funnel.benefits". */
export type Funnel_Benefits_Order_By = {
  description?: InputMaybe<Order_By>;
  funnel?: InputMaybe<Funnel_Funnels_Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: funnel.benefits */
export type Funnel_Benefits_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "funnel.benefits" */
export enum Funnel_Benefits_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "funnel.benefits" */
export type Funnel_Benefits_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "funnel_benefits" */
export type Funnel_Benefits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funnel_Benefits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funnel_Benefits_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "funnel.benefits" */
export enum Funnel_Benefits_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

export type Funnel_Benefits_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funnel_Benefits_Set_Input>;
  /** filter the rows which have to be updated */
  where: Funnel_Benefits_Bool_Exp;
};

/** columns and relationships of "funnel.chatbot_message" */
export type Funnel_Chatbot_Message = {
  __typename?: 'funnel_chatbot_message';
  body: Scalars['String']['output'];
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  /** An object relationship */
  contact?: Maybe<Contact>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  direction: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  seq: Scalars['bigint']['output'];
  wa_id: Scalars['String']['output'];
  whatsapp_message_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "funnel.chatbot_message" */
export type Funnel_Chatbot_Message_Aggregate = {
  __typename?: 'funnel_chatbot_message_aggregate';
  aggregate?: Maybe<Funnel_Chatbot_Message_Aggregate_Fields>;
  nodes: Array<Funnel_Chatbot_Message>;
};

/** aggregate fields of "funnel.chatbot_message" */
export type Funnel_Chatbot_Message_Aggregate_Fields = {
  __typename?: 'funnel_chatbot_message_aggregate_fields';
  avg?: Maybe<Funnel_Chatbot_Message_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Funnel_Chatbot_Message_Max_Fields>;
  min?: Maybe<Funnel_Chatbot_Message_Min_Fields>;
  stddev?: Maybe<Funnel_Chatbot_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Funnel_Chatbot_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Funnel_Chatbot_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Funnel_Chatbot_Message_Sum_Fields>;
  var_pop?: Maybe<Funnel_Chatbot_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Funnel_Chatbot_Message_Var_Samp_Fields>;
  variance?: Maybe<Funnel_Chatbot_Message_Variance_Fields>;
};


/** aggregate fields of "funnel.chatbot_message" */
export type Funnel_Chatbot_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funnel_Chatbot_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Funnel_Chatbot_Message_Avg_Fields = {
  __typename?: 'funnel_chatbot_message_avg_fields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "funnel.chatbot_message". All fields are combined with a logical 'AND'. */
export type Funnel_Chatbot_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Funnel_Chatbot_Message_Bool_Exp>>;
  _not?: InputMaybe<Funnel_Chatbot_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Funnel_Chatbot_Message_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  direction?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  seq?: InputMaybe<Bigint_Comparison_Exp>;
  wa_id?: InputMaybe<String_Comparison_Exp>;
  whatsapp_message_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "funnel.chatbot_message" */
export enum Funnel_Chatbot_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatbotMessagePkey = 'chatbot_message_pkey'
}

/** input type for inserting data into table "funnel.chatbot_message" */
export type Funnel_Chatbot_Message_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  wa_id?: InputMaybe<Scalars['String']['input']>;
  whatsapp_message_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Funnel_Chatbot_Message_Max_Fields = {
  __typename?: 'funnel_chatbot_message_max_fields';
  body?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  seq?: Maybe<Scalars['bigint']['output']>;
  wa_id?: Maybe<Scalars['String']['output']>;
  whatsapp_message_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Funnel_Chatbot_Message_Min_Fields = {
  __typename?: 'funnel_chatbot_message_min_fields';
  body?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  seq?: Maybe<Scalars['bigint']['output']>;
  wa_id?: Maybe<Scalars['String']['output']>;
  whatsapp_message_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "funnel.chatbot_message" */
export type Funnel_Chatbot_Message_Mutation_Response = {
  __typename?: 'funnel_chatbot_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Funnel_Chatbot_Message>;
};

/** on_conflict condition type for table "funnel.chatbot_message" */
export type Funnel_Chatbot_Message_On_Conflict = {
  constraint: Funnel_Chatbot_Message_Constraint;
  update_columns?: Array<Funnel_Chatbot_Message_Update_Column>;
  where?: InputMaybe<Funnel_Chatbot_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "funnel.chatbot_message". */
export type Funnel_Chatbot_Message_Order_By = {
  body?: InputMaybe<Order_By>;
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seq?: InputMaybe<Order_By>;
  wa_id?: InputMaybe<Order_By>;
  whatsapp_message_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: funnel.chatbot_message */
export type Funnel_Chatbot_Message_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "funnel.chatbot_message" */
export enum Funnel_Chatbot_Message_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Direction = 'direction',
  /** column name */
  Id = 'id',
  /** column name */
  Seq = 'seq',
  /** column name */
  WaId = 'wa_id',
  /** column name */
  WhatsappMessageId = 'whatsapp_message_id'
}

/** input type for updating data in table "funnel.chatbot_message" */
export type Funnel_Chatbot_Message_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  wa_id?: InputMaybe<Scalars['String']['input']>;
  whatsapp_message_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Funnel_Chatbot_Message_Stddev_Fields = {
  __typename?: 'funnel_chatbot_message_stddev_fields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Funnel_Chatbot_Message_Stddev_Pop_Fields = {
  __typename?: 'funnel_chatbot_message_stddev_pop_fields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Funnel_Chatbot_Message_Stddev_Samp_Fields = {
  __typename?: 'funnel_chatbot_message_stddev_samp_fields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "funnel_chatbot_message" */
export type Funnel_Chatbot_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funnel_Chatbot_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funnel_Chatbot_Message_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  seq?: InputMaybe<Scalars['bigint']['input']>;
  wa_id?: InputMaybe<Scalars['String']['input']>;
  whatsapp_message_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Funnel_Chatbot_Message_Sum_Fields = {
  __typename?: 'funnel_chatbot_message_sum_fields';
  seq?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "funnel.chatbot_message" */
export enum Funnel_Chatbot_Message_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Direction = 'direction',
  /** column name */
  Id = 'id',
  /** column name */
  WaId = 'wa_id',
  /** column name */
  WhatsappMessageId = 'whatsapp_message_id'
}

export type Funnel_Chatbot_Message_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funnel_Chatbot_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Funnel_Chatbot_Message_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Funnel_Chatbot_Message_Var_Pop_Fields = {
  __typename?: 'funnel_chatbot_message_var_pop_fields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Funnel_Chatbot_Message_Var_Samp_Fields = {
  __typename?: 'funnel_chatbot_message_var_samp_fields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Funnel_Chatbot_Message_Variance_Fields = {
  __typename?: 'funnel_chatbot_message_variance_fields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "funnel.chatbot_session" */
export type Funnel_Chatbot_Session = {
  __typename?: 'funnel_chatbot_session';
  answers: Scalars['jsonb']['output'];
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  /** An object relationship */
  contact?: Maybe<Contact>;
  contact_fields: Scalars['jsonb']['output'];
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  funnel: Funnel_Funnels;
  funnel_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  state: Scalars['String']['output'];
  step_index: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  wa_id: Scalars['String']['output'];
};


/** columns and relationships of "funnel.chatbot_session" */
export type Funnel_Chatbot_SessionAnswersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "funnel.chatbot_session" */
export type Funnel_Chatbot_SessionContact_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "funnel.chatbot_session" */
export type Funnel_Chatbot_Session_Aggregate = {
  __typename?: 'funnel_chatbot_session_aggregate';
  aggregate?: Maybe<Funnel_Chatbot_Session_Aggregate_Fields>;
  nodes: Array<Funnel_Chatbot_Session>;
};

/** aggregate fields of "funnel.chatbot_session" */
export type Funnel_Chatbot_Session_Aggregate_Fields = {
  __typename?: 'funnel_chatbot_session_aggregate_fields';
  avg?: Maybe<Funnel_Chatbot_Session_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Funnel_Chatbot_Session_Max_Fields>;
  min?: Maybe<Funnel_Chatbot_Session_Min_Fields>;
  stddev?: Maybe<Funnel_Chatbot_Session_Stddev_Fields>;
  stddev_pop?: Maybe<Funnel_Chatbot_Session_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Funnel_Chatbot_Session_Stddev_Samp_Fields>;
  sum?: Maybe<Funnel_Chatbot_Session_Sum_Fields>;
  var_pop?: Maybe<Funnel_Chatbot_Session_Var_Pop_Fields>;
  var_samp?: Maybe<Funnel_Chatbot_Session_Var_Samp_Fields>;
  variance?: Maybe<Funnel_Chatbot_Session_Variance_Fields>;
};


/** aggregate fields of "funnel.chatbot_session" */
export type Funnel_Chatbot_Session_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funnel_Chatbot_Session_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Funnel_Chatbot_Session_Append_Input = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  contact_fields?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Funnel_Chatbot_Session_Avg_Fields = {
  __typename?: 'funnel_chatbot_session_avg_fields';
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "funnel.chatbot_session". All fields are combined with a logical 'AND'. */
export type Funnel_Chatbot_Session_Bool_Exp = {
  _and?: InputMaybe<Array<Funnel_Chatbot_Session_Bool_Exp>>;
  _not?: InputMaybe<Funnel_Chatbot_Session_Bool_Exp>;
  _or?: InputMaybe<Array<Funnel_Chatbot_Session_Bool_Exp>>;
  answers?: InputMaybe<Jsonb_Comparison_Exp>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  funnel?: InputMaybe<Funnel_Funnels_Bool_Exp>;
  funnel_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  step_index?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  wa_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "funnel.chatbot_session" */
export enum Funnel_Chatbot_Session_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatbotSessionPkey = 'chatbot_session_pkey',
  /** unique or primary key constraint on columns "wa_id" */
  ChatbotSessionWaIdKey = 'chatbot_session_wa_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Funnel_Chatbot_Session_Delete_At_Path_Input = {
  answers?: InputMaybe<Array<Scalars['String']['input']>>;
  contact_fields?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Funnel_Chatbot_Session_Delete_Elem_Input = {
  answers?: InputMaybe<Scalars['Int']['input']>;
  contact_fields?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Funnel_Chatbot_Session_Delete_Key_Input = {
  answers?: InputMaybe<Scalars['String']['input']>;
  contact_fields?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "funnel.chatbot_session" */
export type Funnel_Chatbot_Session_Inc_Input = {
  step_index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "funnel.chatbot_session" */
export type Funnel_Chatbot_Session_Insert_Input = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_fields?: InputMaybe<Scalars['jsonb']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  funnel?: InputMaybe<Funnel_Funnels_Obj_Rel_Insert_Input>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  step_index?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wa_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Funnel_Chatbot_Session_Max_Fields = {
  __typename?: 'funnel_chatbot_session_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  step_index?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wa_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Funnel_Chatbot_Session_Min_Fields = {
  __typename?: 'funnel_chatbot_session_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  step_index?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wa_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "funnel.chatbot_session" */
export type Funnel_Chatbot_Session_Mutation_Response = {
  __typename?: 'funnel_chatbot_session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Funnel_Chatbot_Session>;
};

/** on_conflict condition type for table "funnel.chatbot_session" */
export type Funnel_Chatbot_Session_On_Conflict = {
  constraint: Funnel_Chatbot_Session_Constraint;
  update_columns?: Array<Funnel_Chatbot_Session_Update_Column>;
  where?: InputMaybe<Funnel_Chatbot_Session_Bool_Exp>;
};

/** Ordering options when selecting data from "funnel.chatbot_session". */
export type Funnel_Chatbot_Session_Order_By = {
  answers?: InputMaybe<Order_By>;
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_fields?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  funnel?: InputMaybe<Funnel_Funnels_Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wa_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: funnel.chatbot_session */
export type Funnel_Chatbot_Session_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Funnel_Chatbot_Session_Prepend_Input = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  contact_fields?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "funnel.chatbot_session" */
export enum Funnel_Chatbot_Session_Select_Column {
  /** column name */
  Answers = 'answers',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactFields = 'contact_fields',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  StepIndex = 'step_index',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WaId = 'wa_id'
}

/** input type for updating data in table "funnel.chatbot_session" */
export type Funnel_Chatbot_Session_Set_Input = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_fields?: InputMaybe<Scalars['jsonb']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  step_index?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wa_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Funnel_Chatbot_Session_Stddev_Fields = {
  __typename?: 'funnel_chatbot_session_stddev_fields';
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Funnel_Chatbot_Session_Stddev_Pop_Fields = {
  __typename?: 'funnel_chatbot_session_stddev_pop_fields';
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Funnel_Chatbot_Session_Stddev_Samp_Fields = {
  __typename?: 'funnel_chatbot_session_stddev_samp_fields';
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "funnel_chatbot_session" */
export type Funnel_Chatbot_Session_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funnel_Chatbot_Session_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funnel_Chatbot_Session_Stream_Cursor_Value_Input = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_fields?: InputMaybe<Scalars['jsonb']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  step_index?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wa_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Funnel_Chatbot_Session_Sum_Fields = {
  __typename?: 'funnel_chatbot_session_sum_fields';
  step_index?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "funnel.chatbot_session" */
export enum Funnel_Chatbot_Session_Update_Column {
  /** column name */
  Answers = 'answers',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ContactFields = 'contact_fields',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  StepIndex = 'step_index',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WaId = 'wa_id'
}

export type Funnel_Chatbot_Session_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Funnel_Chatbot_Session_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Funnel_Chatbot_Session_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Funnel_Chatbot_Session_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Funnel_Chatbot_Session_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Funnel_Chatbot_Session_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Funnel_Chatbot_Session_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funnel_Chatbot_Session_Set_Input>;
  /** filter the rows which have to be updated */
  where: Funnel_Chatbot_Session_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Funnel_Chatbot_Session_Var_Pop_Fields = {
  __typename?: 'funnel_chatbot_session_var_pop_fields';
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Funnel_Chatbot_Session_Var_Samp_Fields = {
  __typename?: 'funnel_chatbot_session_var_samp_fields';
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Funnel_Chatbot_Session_Variance_Fields = {
  __typename?: 'funnel_chatbot_session_variance_fields';
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "funnel.funnels" */
export type Funnel_Funnels = {
  __typename?: 'funnel_funnels';
  application_webhook_url: Scalars['String']['output'];
  /** An object relationship */
  benefit_icon?: Maybe<File_Upload>;
  benefit_icon_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  benefits: Array<Funnel_Benefits>;
  /** An aggregate relationship */
  benefits_aggregate: Funnel_Benefits_Aggregate;
  benefits_intro?: Maybe<Scalars['String']['output']>;
  bot_consent_enabled: Scalars['Boolean']['output'];
  call_to_action?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  campaign?: Maybe<Campaign>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  chatbot_funnel_enabled: Scalars['Boolean']['output'];
  company_privacy_policy_title?: Maybe<Scalars['String']['output']>;
  company_privacy_policy_url?: Maybe<Scalars['String']['output']>;
  contact_question_birthdate_enabled: Scalars['Boolean']['output'];
  contact_question_form_of_address_enabled: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  cv_question_enabled: Scalars['Boolean']['output'];
  cv_required?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  /** An object relationship */
  expectation_icon?: Maybe<File_Upload>;
  expectation_icon_id?: Maybe<Scalars['uuid']['output']>;
  expectations_intro?: Maybe<Scalars['String']['output']>;
  expectations_items: Scalars['jsonb']['output'];
  formality_type: Scalars['String']['output'];
  header_color?: Maybe<Scalars['String']['output']>;
  highlights: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  img_1?: Maybe<File_Upload>;
  /** An object relationship */
  img_1_2?: Maybe<File_Upload>;
  img_1_2_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  img_1_3?: Maybe<File_Upload>;
  img_1_3_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  img_1_4?: Maybe<File_Upload>;
  img_1_4_id?: Maybe<Scalars['uuid']['output']>;
  img_1_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  img_2?: Maybe<File_Upload>;
  /** An object relationship */
  img_2_2?: Maybe<File_Upload>;
  img_2_2_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  img_2_3?: Maybe<File_Upload>;
  img_2_3_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  img_2_4?: Maybe<File_Upload>;
  img_2_4_id?: Maybe<Scalars['uuid']['output']>;
  img_2_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  img_3?: Maybe<File_Upload>;
  /** An object relationship */
  img_3_2?: Maybe<File_Upload>;
  img_3_2_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  img_3_3?: Maybe<File_Upload>;
  img_3_3_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  img_3_4?: Maybe<File_Upload>;
  img_3_4_id?: Maybe<Scalars['uuid']['output']>;
  img_3_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  insight?: Maybe<Funnel_Insights>;
  job_byline?: Maybe<Scalars['String']['output']>;
  job_caption?: Maybe<Scalars['String']['output']>;
  job_intro?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  location_question_city_enabled: Scalars['Boolean']['output'];
  location_question_country_enabled: Scalars['Boolean']['output'];
  location_question_postalcode_enabled: Scalars['Boolean']['output'];
  location_question_street_enabled: Scalars['Boolean']['output'];
  /** An object relationship */
  logo?: Maybe<File_Upload>;
  logo_id?: Maybe<Scalars['uuid']['output']>;
  next_steps: Scalars['jsonb']['output'];
  /** An array relationship */
  page_insights: Array<Funnel_Page_Insights>;
  /** An aggregate relationship */
  page_insights_aggregate: Funnel_Page_Insights_Aggregate;
  /** An array relationship */
  questions: Array<Funnel_Question>;
  /** An aggregate relationship */
  questions_aggregate: Funnel_Question_Aggregate;
  slug: Scalars['String']['output'];
  sub_call_to_action?: Maybe<Scalars['String']['output']>;
  template: Scalars['String']['output'];
  theme_color?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  video_1_id?: Maybe<Scalars['String']['output']>;
  video_2_id?: Maybe<Scalars['String']['output']>;
  video_3_id?: Maybe<Scalars['String']['output']>;
  we_are_byline?: Maybe<Scalars['String']['output']>;
  we_are_call_to_action?: Maybe<Scalars['String']['output']>;
  we_are_copy?: Maybe<Scalars['String']['output']>;
  we_are_intro?: Maybe<Scalars['String']['output']>;
  whatsapp_apply_label?: Maybe<Scalars['String']['output']>;
  whatsapp_apply_message_template?: Maybe<Scalars['String']['output']>;
  whatsapp_intro_message?: Maybe<Scalars['String']['output']>;
  whatsapp_outro_message?: Maybe<Scalars['String']['output']>;
  whatsapp_share_caption?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  whatsapp_share_clicks: Array<Funnel_Whatsapp_Share_Clicks>;
  /** An aggregate relationship */
  whatsapp_share_clicks_aggregate: Funnel_Whatsapp_Share_Clicks_Aggregate;
  whatsapp_share_label?: Maybe<Scalars['String']['output']>;
  whatsapp_share_title?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "funnel.funnels" */
export type Funnel_FunnelsBenefitsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Benefits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Benefits_Order_By>>;
  where?: InputMaybe<Funnel_Benefits_Bool_Exp>;
};


/** columns and relationships of "funnel.funnels" */
export type Funnel_FunnelsBenefits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Benefits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Benefits_Order_By>>;
  where?: InputMaybe<Funnel_Benefits_Bool_Exp>;
};


/** columns and relationships of "funnel.funnels" */
export type Funnel_FunnelsExpectations_ItemsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "funnel.funnels" */
export type Funnel_FunnelsNext_StepsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "funnel.funnels" */
export type Funnel_FunnelsPage_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Page_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};


/** columns and relationships of "funnel.funnels" */
export type Funnel_FunnelsPage_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Page_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};


/** columns and relationships of "funnel.funnels" */
export type Funnel_FunnelsQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Order_By>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


/** columns and relationships of "funnel.funnels" */
export type Funnel_FunnelsQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Order_By>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


/** columns and relationships of "funnel.funnels" */
export type Funnel_FunnelsWhatsapp_Share_ClicksArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Order_By>>;
  where?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
};


/** columns and relationships of "funnel.funnels" */
export type Funnel_FunnelsWhatsapp_Share_Clicks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Order_By>>;
  where?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
};

/** aggregated selection of "funnel.funnels" */
export type Funnel_Funnels_Aggregate = {
  __typename?: 'funnel_funnels_aggregate';
  aggregate?: Maybe<Funnel_Funnels_Aggregate_Fields>;
  nodes: Array<Funnel_Funnels>;
};

/** aggregate fields of "funnel.funnels" */
export type Funnel_Funnels_Aggregate_Fields = {
  __typename?: 'funnel_funnels_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Funnel_Funnels_Max_Fields>;
  min?: Maybe<Funnel_Funnels_Min_Fields>;
};


/** aggregate fields of "funnel.funnels" */
export type Funnel_Funnels_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funnel_Funnels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Funnel_Funnels_Append_Input = {
  expectations_items?: InputMaybe<Scalars['jsonb']['input']>;
  next_steps?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "funnel.funnels". All fields are combined with a logical 'AND'. */
export type Funnel_Funnels_Bool_Exp = {
  _and?: InputMaybe<Array<Funnel_Funnels_Bool_Exp>>;
  _not?: InputMaybe<Funnel_Funnels_Bool_Exp>;
  _or?: InputMaybe<Array<Funnel_Funnels_Bool_Exp>>;
  application_webhook_url?: InputMaybe<String_Comparison_Exp>;
  benefit_icon?: InputMaybe<File_Upload_Bool_Exp>;
  benefit_icon_id?: InputMaybe<Uuid_Comparison_Exp>;
  benefits?: InputMaybe<Funnel_Benefits_Bool_Exp>;
  benefits_aggregate?: InputMaybe<Funnel_Benefits_Aggregate_Bool_Exp>;
  benefits_intro?: InputMaybe<String_Comparison_Exp>;
  bot_consent_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  call_to_action?: InputMaybe<String_Comparison_Exp>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  chatbot_funnel_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  company_privacy_policy_title?: InputMaybe<String_Comparison_Exp>;
  company_privacy_policy_url?: InputMaybe<String_Comparison_Exp>;
  contact_question_birthdate_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  contact_question_form_of_address_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cv_question_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  cv_required?: InputMaybe<Boolean_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  expectation_icon?: InputMaybe<File_Upload_Bool_Exp>;
  expectation_icon_id?: InputMaybe<Uuid_Comparison_Exp>;
  expectations_intro?: InputMaybe<String_Comparison_Exp>;
  expectations_items?: InputMaybe<Jsonb_Comparison_Exp>;
  formality_type?: InputMaybe<String_Comparison_Exp>;
  header_color?: InputMaybe<String_Comparison_Exp>;
  highlights?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  img_1?: InputMaybe<File_Upload_Bool_Exp>;
  img_1_2?: InputMaybe<File_Upload_Bool_Exp>;
  img_1_2_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_1_3?: InputMaybe<File_Upload_Bool_Exp>;
  img_1_3_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_1_4?: InputMaybe<File_Upload_Bool_Exp>;
  img_1_4_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_1_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_2?: InputMaybe<File_Upload_Bool_Exp>;
  img_2_2?: InputMaybe<File_Upload_Bool_Exp>;
  img_2_2_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_2_3?: InputMaybe<File_Upload_Bool_Exp>;
  img_2_3_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_2_4?: InputMaybe<File_Upload_Bool_Exp>;
  img_2_4_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_2_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_3?: InputMaybe<File_Upload_Bool_Exp>;
  img_3_2?: InputMaybe<File_Upload_Bool_Exp>;
  img_3_2_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_3_3?: InputMaybe<File_Upload_Bool_Exp>;
  img_3_3_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_3_4?: InputMaybe<File_Upload_Bool_Exp>;
  img_3_4_id?: InputMaybe<Uuid_Comparison_Exp>;
  img_3_id?: InputMaybe<Uuid_Comparison_Exp>;
  insight?: InputMaybe<Funnel_Insights_Bool_Exp>;
  job_byline?: InputMaybe<String_Comparison_Exp>;
  job_caption?: InputMaybe<String_Comparison_Exp>;
  job_intro?: InputMaybe<String_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  location_question_city_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  location_question_country_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  location_question_postalcode_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  location_question_street_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  logo?: InputMaybe<File_Upload_Bool_Exp>;
  logo_id?: InputMaybe<Uuid_Comparison_Exp>;
  next_steps?: InputMaybe<Jsonb_Comparison_Exp>;
  page_insights?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
  page_insights_aggregate?: InputMaybe<Funnel_Page_Insights_Aggregate_Bool_Exp>;
  questions?: InputMaybe<Funnel_Question_Bool_Exp>;
  questions_aggregate?: InputMaybe<Funnel_Question_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  sub_call_to_action?: InputMaybe<String_Comparison_Exp>;
  template?: InputMaybe<String_Comparison_Exp>;
  theme_color?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  video_1_id?: InputMaybe<String_Comparison_Exp>;
  video_2_id?: InputMaybe<String_Comparison_Exp>;
  video_3_id?: InputMaybe<String_Comparison_Exp>;
  we_are_byline?: InputMaybe<String_Comparison_Exp>;
  we_are_call_to_action?: InputMaybe<String_Comparison_Exp>;
  we_are_copy?: InputMaybe<String_Comparison_Exp>;
  we_are_intro?: InputMaybe<String_Comparison_Exp>;
  whatsapp_apply_label?: InputMaybe<String_Comparison_Exp>;
  whatsapp_apply_message_template?: InputMaybe<String_Comparison_Exp>;
  whatsapp_intro_message?: InputMaybe<String_Comparison_Exp>;
  whatsapp_outro_message?: InputMaybe<String_Comparison_Exp>;
  whatsapp_share_caption?: InputMaybe<String_Comparison_Exp>;
  whatsapp_share_clicks?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
  whatsapp_share_clicks_aggregate?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Aggregate_Bool_Exp>;
  whatsapp_share_label?: InputMaybe<String_Comparison_Exp>;
  whatsapp_share_title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "funnel.funnels" */
export enum Funnel_Funnels_Constraint {
  /** unique or primary key constraint on columns "campaign_id" */
  FunnelCampaignIdKey = 'funnel_campaign_id_key',
  /** unique or primary key constraint on columns "id" */
  FunnelsPkey = 'funnels_pkey',
  /** unique or primary key constraint on columns "slug" */
  FunnelsSlugKey = 'funnels_slug_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Funnel_Funnels_Delete_At_Path_Input = {
  expectations_items?: InputMaybe<Array<Scalars['String']['input']>>;
  next_steps?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Funnel_Funnels_Delete_Elem_Input = {
  expectations_items?: InputMaybe<Scalars['Int']['input']>;
  next_steps?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Funnel_Funnels_Delete_Key_Input = {
  expectations_items?: InputMaybe<Scalars['String']['input']>;
  next_steps?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "funnel.funnels" */
export type Funnel_Funnels_Insert_Input = {
  application_webhook_url?: InputMaybe<Scalars['String']['input']>;
  benefit_icon?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  benefit_icon_id?: InputMaybe<Scalars['uuid']['input']>;
  benefits?: InputMaybe<Funnel_Benefits_Arr_Rel_Insert_Input>;
  benefits_intro?: InputMaybe<Scalars['String']['input']>;
  bot_consent_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  call_to_action?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  chatbot_funnel_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  company_privacy_policy_title?: InputMaybe<Scalars['String']['input']>;
  company_privacy_policy_url?: InputMaybe<Scalars['String']['input']>;
  contact_question_birthdate_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  contact_question_form_of_address_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cv_question_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  cv_required?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expectation_icon?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  expectation_icon_id?: InputMaybe<Scalars['uuid']['input']>;
  expectations_intro?: InputMaybe<Scalars['String']['input']>;
  expectations_items?: InputMaybe<Scalars['jsonb']['input']>;
  formality_type?: InputMaybe<Scalars['String']['input']>;
  header_color?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  img_1?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_1_2?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_1_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_3?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_1_3_id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_4?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_1_4_id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_2_2?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_2_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_3?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_2_3_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_4?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_2_4_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_3_2?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_3_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_3?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_3_3_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_4?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  img_3_4_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_id?: InputMaybe<Scalars['uuid']['input']>;
  insight?: InputMaybe<Funnel_Insights_Obj_Rel_Insert_Input>;
  job_byline?: InputMaybe<Scalars['String']['input']>;
  job_caption?: InputMaybe<Scalars['String']['input']>;
  job_intro?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  location_question_city_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_question_country_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_question_postalcode_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_question_street_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<File_Upload_Obj_Rel_Insert_Input>;
  logo_id?: InputMaybe<Scalars['uuid']['input']>;
  next_steps?: InputMaybe<Scalars['jsonb']['input']>;
  page_insights?: InputMaybe<Funnel_Page_Insights_Arr_Rel_Insert_Input>;
  questions?: InputMaybe<Funnel_Question_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sub_call_to_action?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  theme_color?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  video_1_id?: InputMaybe<Scalars['String']['input']>;
  video_2_id?: InputMaybe<Scalars['String']['input']>;
  video_3_id?: InputMaybe<Scalars['String']['input']>;
  we_are_byline?: InputMaybe<Scalars['String']['input']>;
  we_are_call_to_action?: InputMaybe<Scalars['String']['input']>;
  we_are_copy?: InputMaybe<Scalars['String']['input']>;
  we_are_intro?: InputMaybe<Scalars['String']['input']>;
  whatsapp_apply_label?: InputMaybe<Scalars['String']['input']>;
  whatsapp_apply_message_template?: InputMaybe<Scalars['String']['input']>;
  whatsapp_intro_message?: InputMaybe<Scalars['String']['input']>;
  whatsapp_outro_message?: InputMaybe<Scalars['String']['input']>;
  whatsapp_share_caption?: InputMaybe<Scalars['String']['input']>;
  whatsapp_share_clicks?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Arr_Rel_Insert_Input>;
  whatsapp_share_label?: InputMaybe<Scalars['String']['input']>;
  whatsapp_share_title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Funnel_Funnels_Max_Fields = {
  __typename?: 'funnel_funnels_max_fields';
  application_webhook_url?: Maybe<Scalars['String']['output']>;
  benefit_icon_id?: Maybe<Scalars['uuid']['output']>;
  benefits_intro?: Maybe<Scalars['String']['output']>;
  call_to_action?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  company_privacy_policy_title?: Maybe<Scalars['String']['output']>;
  company_privacy_policy_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expectation_icon_id?: Maybe<Scalars['uuid']['output']>;
  expectations_intro?: Maybe<Scalars['String']['output']>;
  formality_type?: Maybe<Scalars['String']['output']>;
  header_color?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  img_1_2_id?: Maybe<Scalars['uuid']['output']>;
  img_1_3_id?: Maybe<Scalars['uuid']['output']>;
  img_1_4_id?: Maybe<Scalars['uuid']['output']>;
  img_1_id?: Maybe<Scalars['uuid']['output']>;
  img_2_2_id?: Maybe<Scalars['uuid']['output']>;
  img_2_3_id?: Maybe<Scalars['uuid']['output']>;
  img_2_4_id?: Maybe<Scalars['uuid']['output']>;
  img_2_id?: Maybe<Scalars['uuid']['output']>;
  img_3_2_id?: Maybe<Scalars['uuid']['output']>;
  img_3_3_id?: Maybe<Scalars['uuid']['output']>;
  img_3_4_id?: Maybe<Scalars['uuid']['output']>;
  img_3_id?: Maybe<Scalars['uuid']['output']>;
  job_byline?: Maybe<Scalars['String']['output']>;
  job_caption?: Maybe<Scalars['String']['output']>;
  job_intro?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  logo_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sub_call_to_action?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  theme_color?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  video_1_id?: Maybe<Scalars['String']['output']>;
  video_2_id?: Maybe<Scalars['String']['output']>;
  video_3_id?: Maybe<Scalars['String']['output']>;
  we_are_byline?: Maybe<Scalars['String']['output']>;
  we_are_call_to_action?: Maybe<Scalars['String']['output']>;
  we_are_copy?: Maybe<Scalars['String']['output']>;
  we_are_intro?: Maybe<Scalars['String']['output']>;
  whatsapp_apply_label?: Maybe<Scalars['String']['output']>;
  whatsapp_apply_message_template?: Maybe<Scalars['String']['output']>;
  whatsapp_intro_message?: Maybe<Scalars['String']['output']>;
  whatsapp_outro_message?: Maybe<Scalars['String']['output']>;
  whatsapp_share_caption?: Maybe<Scalars['String']['output']>;
  whatsapp_share_label?: Maybe<Scalars['String']['output']>;
  whatsapp_share_title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Funnel_Funnels_Min_Fields = {
  __typename?: 'funnel_funnels_min_fields';
  application_webhook_url?: Maybe<Scalars['String']['output']>;
  benefit_icon_id?: Maybe<Scalars['uuid']['output']>;
  benefits_intro?: Maybe<Scalars['String']['output']>;
  call_to_action?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  company_privacy_policy_title?: Maybe<Scalars['String']['output']>;
  company_privacy_policy_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expectation_icon_id?: Maybe<Scalars['uuid']['output']>;
  expectations_intro?: Maybe<Scalars['String']['output']>;
  formality_type?: Maybe<Scalars['String']['output']>;
  header_color?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  img_1_2_id?: Maybe<Scalars['uuid']['output']>;
  img_1_3_id?: Maybe<Scalars['uuid']['output']>;
  img_1_4_id?: Maybe<Scalars['uuid']['output']>;
  img_1_id?: Maybe<Scalars['uuid']['output']>;
  img_2_2_id?: Maybe<Scalars['uuid']['output']>;
  img_2_3_id?: Maybe<Scalars['uuid']['output']>;
  img_2_4_id?: Maybe<Scalars['uuid']['output']>;
  img_2_id?: Maybe<Scalars['uuid']['output']>;
  img_3_2_id?: Maybe<Scalars['uuid']['output']>;
  img_3_3_id?: Maybe<Scalars['uuid']['output']>;
  img_3_4_id?: Maybe<Scalars['uuid']['output']>;
  img_3_id?: Maybe<Scalars['uuid']['output']>;
  job_byline?: Maybe<Scalars['String']['output']>;
  job_caption?: Maybe<Scalars['String']['output']>;
  job_intro?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  logo_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sub_call_to_action?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  theme_color?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  video_1_id?: Maybe<Scalars['String']['output']>;
  video_2_id?: Maybe<Scalars['String']['output']>;
  video_3_id?: Maybe<Scalars['String']['output']>;
  we_are_byline?: Maybe<Scalars['String']['output']>;
  we_are_call_to_action?: Maybe<Scalars['String']['output']>;
  we_are_copy?: Maybe<Scalars['String']['output']>;
  we_are_intro?: Maybe<Scalars['String']['output']>;
  whatsapp_apply_label?: Maybe<Scalars['String']['output']>;
  whatsapp_apply_message_template?: Maybe<Scalars['String']['output']>;
  whatsapp_intro_message?: Maybe<Scalars['String']['output']>;
  whatsapp_outro_message?: Maybe<Scalars['String']['output']>;
  whatsapp_share_caption?: Maybe<Scalars['String']['output']>;
  whatsapp_share_label?: Maybe<Scalars['String']['output']>;
  whatsapp_share_title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "funnel.funnels" */
export type Funnel_Funnels_Mutation_Response = {
  __typename?: 'funnel_funnels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Funnel_Funnels>;
};

/** input type for inserting object relation for remote table "funnel.funnels" */
export type Funnel_Funnels_Obj_Rel_Insert_Input = {
  data: Funnel_Funnels_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Funnel_Funnels_On_Conflict>;
};

/** on_conflict condition type for table "funnel.funnels" */
export type Funnel_Funnels_On_Conflict = {
  constraint: Funnel_Funnels_Constraint;
  update_columns?: Array<Funnel_Funnels_Update_Column>;
  where?: InputMaybe<Funnel_Funnels_Bool_Exp>;
};

/** Ordering options when selecting data from "funnel.funnels". */
export type Funnel_Funnels_Order_By = {
  application_webhook_url?: InputMaybe<Order_By>;
  benefit_icon?: InputMaybe<File_Upload_Order_By>;
  benefit_icon_id?: InputMaybe<Order_By>;
  benefits_aggregate?: InputMaybe<Funnel_Benefits_Aggregate_Order_By>;
  benefits_intro?: InputMaybe<Order_By>;
  bot_consent_enabled?: InputMaybe<Order_By>;
  call_to_action?: InputMaybe<Order_By>;
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  chatbot_funnel_enabled?: InputMaybe<Order_By>;
  company_privacy_policy_title?: InputMaybe<Order_By>;
  company_privacy_policy_url?: InputMaybe<Order_By>;
  contact_question_birthdate_enabled?: InputMaybe<Order_By>;
  contact_question_form_of_address_enabled?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  cv_question_enabled?: InputMaybe<Order_By>;
  cv_required?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  expectation_icon?: InputMaybe<File_Upload_Order_By>;
  expectation_icon_id?: InputMaybe<Order_By>;
  expectations_intro?: InputMaybe<Order_By>;
  expectations_items?: InputMaybe<Order_By>;
  formality_type?: InputMaybe<Order_By>;
  header_color?: InputMaybe<Order_By>;
  highlights?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  img_1?: InputMaybe<File_Upload_Order_By>;
  img_1_2?: InputMaybe<File_Upload_Order_By>;
  img_1_2_id?: InputMaybe<Order_By>;
  img_1_3?: InputMaybe<File_Upload_Order_By>;
  img_1_3_id?: InputMaybe<Order_By>;
  img_1_4?: InputMaybe<File_Upload_Order_By>;
  img_1_4_id?: InputMaybe<Order_By>;
  img_1_id?: InputMaybe<Order_By>;
  img_2?: InputMaybe<File_Upload_Order_By>;
  img_2_2?: InputMaybe<File_Upload_Order_By>;
  img_2_2_id?: InputMaybe<Order_By>;
  img_2_3?: InputMaybe<File_Upload_Order_By>;
  img_2_3_id?: InputMaybe<Order_By>;
  img_2_4?: InputMaybe<File_Upload_Order_By>;
  img_2_4_id?: InputMaybe<Order_By>;
  img_2_id?: InputMaybe<Order_By>;
  img_3?: InputMaybe<File_Upload_Order_By>;
  img_3_2?: InputMaybe<File_Upload_Order_By>;
  img_3_2_id?: InputMaybe<Order_By>;
  img_3_3?: InputMaybe<File_Upload_Order_By>;
  img_3_3_id?: InputMaybe<Order_By>;
  img_3_4?: InputMaybe<File_Upload_Order_By>;
  img_3_4_id?: InputMaybe<Order_By>;
  img_3_id?: InputMaybe<Order_By>;
  insight?: InputMaybe<Funnel_Insights_Order_By>;
  job_byline?: InputMaybe<Order_By>;
  job_caption?: InputMaybe<Order_By>;
  job_intro?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  location_question_city_enabled?: InputMaybe<Order_By>;
  location_question_country_enabled?: InputMaybe<Order_By>;
  location_question_postalcode_enabled?: InputMaybe<Order_By>;
  location_question_street_enabled?: InputMaybe<Order_By>;
  logo?: InputMaybe<File_Upload_Order_By>;
  logo_id?: InputMaybe<Order_By>;
  next_steps?: InputMaybe<Order_By>;
  page_insights_aggregate?: InputMaybe<Funnel_Page_Insights_Aggregate_Order_By>;
  questions_aggregate?: InputMaybe<Funnel_Question_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  sub_call_to_action?: InputMaybe<Order_By>;
  template?: InputMaybe<Order_By>;
  theme_color?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_1_id?: InputMaybe<Order_By>;
  video_2_id?: InputMaybe<Order_By>;
  video_3_id?: InputMaybe<Order_By>;
  we_are_byline?: InputMaybe<Order_By>;
  we_are_call_to_action?: InputMaybe<Order_By>;
  we_are_copy?: InputMaybe<Order_By>;
  we_are_intro?: InputMaybe<Order_By>;
  whatsapp_apply_label?: InputMaybe<Order_By>;
  whatsapp_apply_message_template?: InputMaybe<Order_By>;
  whatsapp_intro_message?: InputMaybe<Order_By>;
  whatsapp_outro_message?: InputMaybe<Order_By>;
  whatsapp_share_caption?: InputMaybe<Order_By>;
  whatsapp_share_clicks_aggregate?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Aggregate_Order_By>;
  whatsapp_share_label?: InputMaybe<Order_By>;
  whatsapp_share_title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: funnel.funnels */
export type Funnel_Funnels_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Funnel_Funnels_Prepend_Input = {
  expectations_items?: InputMaybe<Scalars['jsonb']['input']>;
  next_steps?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "funnel.funnels" */
export enum Funnel_Funnels_Select_Column {
  /** column name */
  ApplicationWebhookUrl = 'application_webhook_url',
  /** column name */
  BenefitIconId = 'benefit_icon_id',
  /** column name */
  BenefitsIntro = 'benefits_intro',
  /** column name */
  BotConsentEnabled = 'bot_consent_enabled',
  /** column name */
  CallToAction = 'call_to_action',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ChatbotFunnelEnabled = 'chatbot_funnel_enabled',
  /** column name */
  CompanyPrivacyPolicyTitle = 'company_privacy_policy_title',
  /** column name */
  CompanyPrivacyPolicyUrl = 'company_privacy_policy_url',
  /** column name */
  ContactQuestionBirthdateEnabled = 'contact_question_birthdate_enabled',
  /** column name */
  ContactQuestionFormOfAddressEnabled = 'contact_question_form_of_address_enabled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CvQuestionEnabled = 'cv_question_enabled',
  /** column name */
  CvRequired = 'cv_required',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ExpectationIconId = 'expectation_icon_id',
  /** column name */
  ExpectationsIntro = 'expectations_intro',
  /** column name */
  ExpectationsItems = 'expectations_items',
  /** column name */
  FormalityType = 'formality_type',
  /** column name */
  HeaderColor = 'header_color',
  /** column name */
  Highlights = 'highlights',
  /** column name */
  Id = 'id',
  /** column name */
  Img_1_2Id = 'img_1_2_id',
  /** column name */
  Img_1_3Id = 'img_1_3_id',
  /** column name */
  Img_1_4Id = 'img_1_4_id',
  /** column name */
  Img_1Id = 'img_1_id',
  /** column name */
  Img_2_2Id = 'img_2_2_id',
  /** column name */
  Img_2_3Id = 'img_2_3_id',
  /** column name */
  Img_2_4Id = 'img_2_4_id',
  /** column name */
  Img_2Id = 'img_2_id',
  /** column name */
  Img_3_2Id = 'img_3_2_id',
  /** column name */
  Img_3_3Id = 'img_3_3_id',
  /** column name */
  Img_3_4Id = 'img_3_4_id',
  /** column name */
  Img_3Id = 'img_3_id',
  /** column name */
  JobByline = 'job_byline',
  /** column name */
  JobCaption = 'job_caption',
  /** column name */
  JobIntro = 'job_intro',
  /** column name */
  Locale = 'locale',
  /** column name */
  LocationQuestionCityEnabled = 'location_question_city_enabled',
  /** column name */
  LocationQuestionCountryEnabled = 'location_question_country_enabled',
  /** column name */
  LocationQuestionPostalcodeEnabled = 'location_question_postalcode_enabled',
  /** column name */
  LocationQuestionStreetEnabled = 'location_question_street_enabled',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  NextSteps = 'next_steps',
  /** column name */
  Slug = 'slug',
  /** column name */
  SubCallToAction = 'sub_call_to_action',
  /** column name */
  Template = 'template',
  /** column name */
  ThemeColor = 'theme_color',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Video_1Id = 'video_1_id',
  /** column name */
  Video_2Id = 'video_2_id',
  /** column name */
  Video_3Id = 'video_3_id',
  /** column name */
  WeAreByline = 'we_are_byline',
  /** column name */
  WeAreCallToAction = 'we_are_call_to_action',
  /** column name */
  WeAreCopy = 'we_are_copy',
  /** column name */
  WeAreIntro = 'we_are_intro',
  /** column name */
  WhatsappApplyLabel = 'whatsapp_apply_label',
  /** column name */
  WhatsappApplyMessageTemplate = 'whatsapp_apply_message_template',
  /** column name */
  WhatsappIntroMessage = 'whatsapp_intro_message',
  /** column name */
  WhatsappOutroMessage = 'whatsapp_outro_message',
  /** column name */
  WhatsappShareCaption = 'whatsapp_share_caption',
  /** column name */
  WhatsappShareLabel = 'whatsapp_share_label',
  /** column name */
  WhatsappShareTitle = 'whatsapp_share_title'
}

/** input type for updating data in table "funnel.funnels" */
export type Funnel_Funnels_Set_Input = {
  application_webhook_url?: InputMaybe<Scalars['String']['input']>;
  benefit_icon_id?: InputMaybe<Scalars['uuid']['input']>;
  benefits_intro?: InputMaybe<Scalars['String']['input']>;
  bot_consent_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  call_to_action?: InputMaybe<Scalars['String']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  chatbot_funnel_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  company_privacy_policy_title?: InputMaybe<Scalars['String']['input']>;
  company_privacy_policy_url?: InputMaybe<Scalars['String']['input']>;
  contact_question_birthdate_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  contact_question_form_of_address_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cv_question_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  cv_required?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expectation_icon_id?: InputMaybe<Scalars['uuid']['input']>;
  expectations_intro?: InputMaybe<Scalars['String']['input']>;
  expectations_items?: InputMaybe<Scalars['jsonb']['input']>;
  formality_type?: InputMaybe<Scalars['String']['input']>;
  header_color?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_3_id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_4_id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_3_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_4_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_3_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_4_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_id?: InputMaybe<Scalars['uuid']['input']>;
  job_byline?: InputMaybe<Scalars['String']['input']>;
  job_caption?: InputMaybe<Scalars['String']['input']>;
  job_intro?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  location_question_city_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_question_country_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_question_postalcode_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_question_street_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo_id?: InputMaybe<Scalars['uuid']['input']>;
  next_steps?: InputMaybe<Scalars['jsonb']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sub_call_to_action?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  theme_color?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  video_1_id?: InputMaybe<Scalars['String']['input']>;
  video_2_id?: InputMaybe<Scalars['String']['input']>;
  video_3_id?: InputMaybe<Scalars['String']['input']>;
  we_are_byline?: InputMaybe<Scalars['String']['input']>;
  we_are_call_to_action?: InputMaybe<Scalars['String']['input']>;
  we_are_copy?: InputMaybe<Scalars['String']['input']>;
  we_are_intro?: InputMaybe<Scalars['String']['input']>;
  whatsapp_apply_label?: InputMaybe<Scalars['String']['input']>;
  whatsapp_apply_message_template?: InputMaybe<Scalars['String']['input']>;
  whatsapp_intro_message?: InputMaybe<Scalars['String']['input']>;
  whatsapp_outro_message?: InputMaybe<Scalars['String']['input']>;
  whatsapp_share_caption?: InputMaybe<Scalars['String']['input']>;
  whatsapp_share_label?: InputMaybe<Scalars['String']['input']>;
  whatsapp_share_title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "funnel_funnels" */
export type Funnel_Funnels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funnel_Funnels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funnel_Funnels_Stream_Cursor_Value_Input = {
  application_webhook_url?: InputMaybe<Scalars['String']['input']>;
  benefit_icon_id?: InputMaybe<Scalars['uuid']['input']>;
  benefits_intro?: InputMaybe<Scalars['String']['input']>;
  bot_consent_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  call_to_action?: InputMaybe<Scalars['String']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  chatbot_funnel_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  company_privacy_policy_title?: InputMaybe<Scalars['String']['input']>;
  company_privacy_policy_url?: InputMaybe<Scalars['String']['input']>;
  contact_question_birthdate_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  contact_question_form_of_address_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cv_question_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  cv_required?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expectation_icon_id?: InputMaybe<Scalars['uuid']['input']>;
  expectations_intro?: InputMaybe<Scalars['String']['input']>;
  expectations_items?: InputMaybe<Scalars['jsonb']['input']>;
  formality_type?: InputMaybe<Scalars['String']['input']>;
  header_color?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_3_id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_4_id?: InputMaybe<Scalars['uuid']['input']>;
  img_1_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_3_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_4_id?: InputMaybe<Scalars['uuid']['input']>;
  img_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_2_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_3_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_4_id?: InputMaybe<Scalars['uuid']['input']>;
  img_3_id?: InputMaybe<Scalars['uuid']['input']>;
  job_byline?: InputMaybe<Scalars['String']['input']>;
  job_caption?: InputMaybe<Scalars['String']['input']>;
  job_intro?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  location_question_city_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_question_country_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_question_postalcode_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_question_street_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo_id?: InputMaybe<Scalars['uuid']['input']>;
  next_steps?: InputMaybe<Scalars['jsonb']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sub_call_to_action?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  theme_color?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  video_1_id?: InputMaybe<Scalars['String']['input']>;
  video_2_id?: InputMaybe<Scalars['String']['input']>;
  video_3_id?: InputMaybe<Scalars['String']['input']>;
  we_are_byline?: InputMaybe<Scalars['String']['input']>;
  we_are_call_to_action?: InputMaybe<Scalars['String']['input']>;
  we_are_copy?: InputMaybe<Scalars['String']['input']>;
  we_are_intro?: InputMaybe<Scalars['String']['input']>;
  whatsapp_apply_label?: InputMaybe<Scalars['String']['input']>;
  whatsapp_apply_message_template?: InputMaybe<Scalars['String']['input']>;
  whatsapp_intro_message?: InputMaybe<Scalars['String']['input']>;
  whatsapp_outro_message?: InputMaybe<Scalars['String']['input']>;
  whatsapp_share_caption?: InputMaybe<Scalars['String']['input']>;
  whatsapp_share_label?: InputMaybe<Scalars['String']['input']>;
  whatsapp_share_title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "funnel.funnels" */
export enum Funnel_Funnels_Update_Column {
  /** column name */
  ApplicationWebhookUrl = 'application_webhook_url',
  /** column name */
  BenefitIconId = 'benefit_icon_id',
  /** column name */
  BenefitsIntro = 'benefits_intro',
  /** column name */
  BotConsentEnabled = 'bot_consent_enabled',
  /** column name */
  CallToAction = 'call_to_action',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ChatbotFunnelEnabled = 'chatbot_funnel_enabled',
  /** column name */
  CompanyPrivacyPolicyTitle = 'company_privacy_policy_title',
  /** column name */
  CompanyPrivacyPolicyUrl = 'company_privacy_policy_url',
  /** column name */
  ContactQuestionBirthdateEnabled = 'contact_question_birthdate_enabled',
  /** column name */
  ContactQuestionFormOfAddressEnabled = 'contact_question_form_of_address_enabled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CvQuestionEnabled = 'cv_question_enabled',
  /** column name */
  CvRequired = 'cv_required',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ExpectationIconId = 'expectation_icon_id',
  /** column name */
  ExpectationsIntro = 'expectations_intro',
  /** column name */
  ExpectationsItems = 'expectations_items',
  /** column name */
  FormalityType = 'formality_type',
  /** column name */
  HeaderColor = 'header_color',
  /** column name */
  Highlights = 'highlights',
  /** column name */
  Id = 'id',
  /** column name */
  Img_1_2Id = 'img_1_2_id',
  /** column name */
  Img_1_3Id = 'img_1_3_id',
  /** column name */
  Img_1_4Id = 'img_1_4_id',
  /** column name */
  Img_1Id = 'img_1_id',
  /** column name */
  Img_2_2Id = 'img_2_2_id',
  /** column name */
  Img_2_3Id = 'img_2_3_id',
  /** column name */
  Img_2_4Id = 'img_2_4_id',
  /** column name */
  Img_2Id = 'img_2_id',
  /** column name */
  Img_3_2Id = 'img_3_2_id',
  /** column name */
  Img_3_3Id = 'img_3_3_id',
  /** column name */
  Img_3_4Id = 'img_3_4_id',
  /** column name */
  Img_3Id = 'img_3_id',
  /** column name */
  JobByline = 'job_byline',
  /** column name */
  JobCaption = 'job_caption',
  /** column name */
  JobIntro = 'job_intro',
  /** column name */
  Locale = 'locale',
  /** column name */
  LocationQuestionCityEnabled = 'location_question_city_enabled',
  /** column name */
  LocationQuestionCountryEnabled = 'location_question_country_enabled',
  /** column name */
  LocationQuestionPostalcodeEnabled = 'location_question_postalcode_enabled',
  /** column name */
  LocationQuestionStreetEnabled = 'location_question_street_enabled',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  NextSteps = 'next_steps',
  /** column name */
  Slug = 'slug',
  /** column name */
  SubCallToAction = 'sub_call_to_action',
  /** column name */
  Template = 'template',
  /** column name */
  ThemeColor = 'theme_color',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Video_1Id = 'video_1_id',
  /** column name */
  Video_2Id = 'video_2_id',
  /** column name */
  Video_3Id = 'video_3_id',
  /** column name */
  WeAreByline = 'we_are_byline',
  /** column name */
  WeAreCallToAction = 'we_are_call_to_action',
  /** column name */
  WeAreCopy = 'we_are_copy',
  /** column name */
  WeAreIntro = 'we_are_intro',
  /** column name */
  WhatsappApplyLabel = 'whatsapp_apply_label',
  /** column name */
  WhatsappApplyMessageTemplate = 'whatsapp_apply_message_template',
  /** column name */
  WhatsappIntroMessage = 'whatsapp_intro_message',
  /** column name */
  WhatsappOutroMessage = 'whatsapp_outro_message',
  /** column name */
  WhatsappShareCaption = 'whatsapp_share_caption',
  /** column name */
  WhatsappShareLabel = 'whatsapp_share_label',
  /** column name */
  WhatsappShareTitle = 'whatsapp_share_title'
}

export type Funnel_Funnels_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Funnel_Funnels_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Funnel_Funnels_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Funnel_Funnels_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Funnel_Funnels_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Funnel_Funnels_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funnel_Funnels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Funnel_Funnels_Bool_Exp;
};

/** columns and relationships of "funnel.insights" */
export type Funnel_Insights = {
  __typename?: 'funnel_insights';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  click_through_rate?: Maybe<Scalars['numeric']['output']>;
  click_throughs: Scalars['Int']['output'];
  /** An object relationship */
  funnel?: Maybe<Funnel_Funnels>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  /** Total visits to the funnel */
  sessions: Scalars['Int']['output'];
};

/** aggregated selection of "funnel.insights" */
export type Funnel_Insights_Aggregate = {
  __typename?: 'funnel_insights_aggregate';
  aggregate?: Maybe<Funnel_Insights_Aggregate_Fields>;
  nodes: Array<Funnel_Insights>;
};

/** aggregate fields of "funnel.insights" */
export type Funnel_Insights_Aggregate_Fields = {
  __typename?: 'funnel_insights_aggregate_fields';
  avg?: Maybe<Funnel_Insights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Funnel_Insights_Max_Fields>;
  min?: Maybe<Funnel_Insights_Min_Fields>;
  stddev?: Maybe<Funnel_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Funnel_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Funnel_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Funnel_Insights_Sum_Fields>;
  var_pop?: Maybe<Funnel_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Funnel_Insights_Var_Samp_Fields>;
  variance?: Maybe<Funnel_Insights_Variance_Fields>;
};


/** aggregate fields of "funnel.insights" */
export type Funnel_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funnel_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Funnel_Insights_Avg_Fields = {
  __typename?: 'funnel_insights_avg_fields';
  click_through_rate?: Maybe<Scalars['Float']['output']>;
  click_throughs?: Maybe<Scalars['Float']['output']>;
  /** Total visits to the funnel */
  sessions?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "funnel.insights". All fields are combined with a logical 'AND'. */
export type Funnel_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Funnel_Insights_Bool_Exp>>;
  _not?: InputMaybe<Funnel_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Funnel_Insights_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  click_through_rate?: InputMaybe<Numeric_Comparison_Exp>;
  click_throughs?: InputMaybe<Int_Comparison_Exp>;
  funnel?: InputMaybe<Funnel_Funnels_Bool_Exp>;
  funnel_id?: InputMaybe<Uuid_Comparison_Exp>;
  sessions?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "funnel.insights" */
export enum Funnel_Insights_Constraint {
  /** unique or primary key constraint on columns "campaign_id" */
  CampaignInsightsCampaignIdKey = 'campaign_insights_campaign_id_key',
  /** unique or primary key constraint on columns "funnel_id" */
  InsightsFunnelIdKey = 'insights_funnel_id_key'
}

/** input type for incrementing numeric columns in table "funnel.insights" */
export type Funnel_Insights_Inc_Input = {
  click_through_rate?: InputMaybe<Scalars['numeric']['input']>;
  click_throughs?: InputMaybe<Scalars['Int']['input']>;
  /** Total visits to the funnel */
  sessions?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "funnel.insights" */
export type Funnel_Insights_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  click_through_rate?: InputMaybe<Scalars['numeric']['input']>;
  click_throughs?: InputMaybe<Scalars['Int']['input']>;
  funnel?: InputMaybe<Funnel_Funnels_Obj_Rel_Insert_Input>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Total visits to the funnel */
  sessions?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Funnel_Insights_Max_Fields = {
  __typename?: 'funnel_insights_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  click_through_rate?: Maybe<Scalars['numeric']['output']>;
  click_throughs?: Maybe<Scalars['Int']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  /** Total visits to the funnel */
  sessions?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Funnel_Insights_Min_Fields = {
  __typename?: 'funnel_insights_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  click_through_rate?: Maybe<Scalars['numeric']['output']>;
  click_throughs?: Maybe<Scalars['Int']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  /** Total visits to the funnel */
  sessions?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "funnel.insights" */
export type Funnel_Insights_Mutation_Response = {
  __typename?: 'funnel_insights_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Funnel_Insights>;
};

/** input type for inserting object relation for remote table "funnel.insights" */
export type Funnel_Insights_Obj_Rel_Insert_Input = {
  data: Funnel_Insights_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Funnel_Insights_On_Conflict>;
};

/** on_conflict condition type for table "funnel.insights" */
export type Funnel_Insights_On_Conflict = {
  constraint: Funnel_Insights_Constraint;
  update_columns?: Array<Funnel_Insights_Update_Column>;
  where?: InputMaybe<Funnel_Insights_Bool_Exp>;
};

/** Ordering options when selecting data from "funnel.insights". */
export type Funnel_Insights_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  click_through_rate?: InputMaybe<Order_By>;
  click_throughs?: InputMaybe<Order_By>;
  funnel?: InputMaybe<Funnel_Funnels_Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  sessions?: InputMaybe<Order_By>;
};

/** select columns of table "funnel.insights" */
export enum Funnel_Insights_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ClickThroughRate = 'click_through_rate',
  /** column name */
  ClickThroughs = 'click_throughs',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Sessions = 'sessions'
}

/** input type for updating data in table "funnel.insights" */
export type Funnel_Insights_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  click_through_rate?: InputMaybe<Scalars['numeric']['input']>;
  click_throughs?: InputMaybe<Scalars['Int']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Total visits to the funnel */
  sessions?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Funnel_Insights_Stddev_Fields = {
  __typename?: 'funnel_insights_stddev_fields';
  click_through_rate?: Maybe<Scalars['Float']['output']>;
  click_throughs?: Maybe<Scalars['Float']['output']>;
  /** Total visits to the funnel */
  sessions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Funnel_Insights_Stddev_Pop_Fields = {
  __typename?: 'funnel_insights_stddev_pop_fields';
  click_through_rate?: Maybe<Scalars['Float']['output']>;
  click_throughs?: Maybe<Scalars['Float']['output']>;
  /** Total visits to the funnel */
  sessions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Funnel_Insights_Stddev_Samp_Fields = {
  __typename?: 'funnel_insights_stddev_samp_fields';
  click_through_rate?: Maybe<Scalars['Float']['output']>;
  click_throughs?: Maybe<Scalars['Float']['output']>;
  /** Total visits to the funnel */
  sessions?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "funnel_insights" */
export type Funnel_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funnel_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funnel_Insights_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  click_through_rate?: InputMaybe<Scalars['numeric']['input']>;
  click_throughs?: InputMaybe<Scalars['Int']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Total visits to the funnel */
  sessions?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Funnel_Insights_Sum_Fields = {
  __typename?: 'funnel_insights_sum_fields';
  click_through_rate?: Maybe<Scalars['numeric']['output']>;
  click_throughs?: Maybe<Scalars['Int']['output']>;
  /** Total visits to the funnel */
  sessions?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "funnel.insights" */
export enum Funnel_Insights_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ClickThroughRate = 'click_through_rate',
  /** column name */
  ClickThroughs = 'click_throughs',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Sessions = 'sessions'
}

export type Funnel_Insights_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Funnel_Insights_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funnel_Insights_Set_Input>;
  /** filter the rows which have to be updated */
  where: Funnel_Insights_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Funnel_Insights_Var_Pop_Fields = {
  __typename?: 'funnel_insights_var_pop_fields';
  click_through_rate?: Maybe<Scalars['Float']['output']>;
  click_throughs?: Maybe<Scalars['Float']['output']>;
  /** Total visits to the funnel */
  sessions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Funnel_Insights_Var_Samp_Fields = {
  __typename?: 'funnel_insights_var_samp_fields';
  click_through_rate?: Maybe<Scalars['Float']['output']>;
  click_throughs?: Maybe<Scalars['Float']['output']>;
  /** Total visits to the funnel */
  sessions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Funnel_Insights_Variance_Fields = {
  __typename?: 'funnel_insights_variance_fields';
  click_through_rate?: Maybe<Scalars['Float']['output']>;
  click_throughs?: Maybe<Scalars['Float']['output']>;
  /** Total visits to the funnel */
  sessions?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "funnel.page_insights" */
export type Funnel_Page_Insights = {
  __typename?: 'funnel_page_insights';
  /** An object relationship */
  campaign?: Maybe<Campaign>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  funnel?: Maybe<Funnel_Funnels>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  index: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  question?: Maybe<Funnel_Question>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  visitors: Scalars['Int']['output'];
};

/** aggregated selection of "funnel.page_insights" */
export type Funnel_Page_Insights_Aggregate = {
  __typename?: 'funnel_page_insights_aggregate';
  aggregate?: Maybe<Funnel_Page_Insights_Aggregate_Fields>;
  nodes: Array<Funnel_Page_Insights>;
};

export type Funnel_Page_Insights_Aggregate_Bool_Exp = {
  count?: InputMaybe<Funnel_Page_Insights_Aggregate_Bool_Exp_Count>;
};

export type Funnel_Page_Insights_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "funnel.page_insights" */
export type Funnel_Page_Insights_Aggregate_Fields = {
  __typename?: 'funnel_page_insights_aggregate_fields';
  avg?: Maybe<Funnel_Page_Insights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Funnel_Page_Insights_Max_Fields>;
  min?: Maybe<Funnel_Page_Insights_Min_Fields>;
  stddev?: Maybe<Funnel_Page_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Funnel_Page_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Funnel_Page_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Funnel_Page_Insights_Sum_Fields>;
  var_pop?: Maybe<Funnel_Page_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Funnel_Page_Insights_Var_Samp_Fields>;
  variance?: Maybe<Funnel_Page_Insights_Variance_Fields>;
};


/** aggregate fields of "funnel.page_insights" */
export type Funnel_Page_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "funnel.page_insights" */
export type Funnel_Page_Insights_Aggregate_Order_By = {
  avg?: InputMaybe<Funnel_Page_Insights_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Funnel_Page_Insights_Max_Order_By>;
  min?: InputMaybe<Funnel_Page_Insights_Min_Order_By>;
  stddev?: InputMaybe<Funnel_Page_Insights_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Funnel_Page_Insights_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Funnel_Page_Insights_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Funnel_Page_Insights_Sum_Order_By>;
  var_pop?: InputMaybe<Funnel_Page_Insights_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Funnel_Page_Insights_Var_Samp_Order_By>;
  variance?: InputMaybe<Funnel_Page_Insights_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "funnel.page_insights" */
export type Funnel_Page_Insights_Arr_Rel_Insert_Input = {
  data: Array<Funnel_Page_Insights_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Funnel_Page_Insights_On_Conflict>;
};

/** aggregate avg on columns */
export type Funnel_Page_Insights_Avg_Fields = {
  __typename?: 'funnel_page_insights_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
  visitors?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "funnel.page_insights" */
export type Funnel_Page_Insights_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "funnel.page_insights". All fields are combined with a logical 'AND'. */
export type Funnel_Page_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Funnel_Page_Insights_Bool_Exp>>;
  _not?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Funnel_Page_Insights_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  funnel?: InputMaybe<Funnel_Funnels_Bool_Exp>;
  funnel_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  question?: InputMaybe<Funnel_Question_Bool_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  visitors?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "funnel.page_insights" */
export enum Funnel_Page_Insights_Constraint {
  /** unique or primary key constraint on columns "id" */
  PageInsightsPkey = 'page_insights_pkey'
}

/** input type for incrementing numeric columns in table "funnel.page_insights" */
export type Funnel_Page_Insights_Inc_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
  visitors?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "funnel.page_insights" */
export type Funnel_Page_Insights_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  funnel?: InputMaybe<Funnel_Funnels_Obj_Rel_Insert_Input>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Funnel_Question_Obj_Rel_Insert_Input>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  visitors?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Funnel_Page_Insights_Max_Fields = {
  __typename?: 'funnel_page_insights_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  visitors?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "funnel.page_insights" */
export type Funnel_Page_Insights_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Funnel_Page_Insights_Min_Fields = {
  __typename?: 'funnel_page_insights_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  visitors?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "funnel.page_insights" */
export type Funnel_Page_Insights_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "funnel.page_insights" */
export type Funnel_Page_Insights_Mutation_Response = {
  __typename?: 'funnel_page_insights_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Funnel_Page_Insights>;
};

/** on_conflict condition type for table "funnel.page_insights" */
export type Funnel_Page_Insights_On_Conflict = {
  constraint: Funnel_Page_Insights_Constraint;
  update_columns?: Array<Funnel_Page_Insights_Update_Column>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};

/** Ordering options when selecting data from "funnel.page_insights". */
export type Funnel_Page_Insights_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  funnel?: InputMaybe<Funnel_Funnels_Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  question?: InputMaybe<Funnel_Question_Order_By>;
  question_id?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** primary key columns input for table: funnel.page_insights */
export type Funnel_Page_Insights_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "funnel.page_insights" */
export enum Funnel_Page_Insights_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  Name = 'name',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  Visitors = 'visitors'
}

/** input type for updating data in table "funnel.page_insights" */
export type Funnel_Page_Insights_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  visitors?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Funnel_Page_Insights_Stddev_Fields = {
  __typename?: 'funnel_page_insights_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
  visitors?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "funnel.page_insights" */
export type Funnel_Page_Insights_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Funnel_Page_Insights_Stddev_Pop_Fields = {
  __typename?: 'funnel_page_insights_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
  visitors?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "funnel.page_insights" */
export type Funnel_Page_Insights_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Funnel_Page_Insights_Stddev_Samp_Fields = {
  __typename?: 'funnel_page_insights_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
  visitors?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "funnel.page_insights" */
export type Funnel_Page_Insights_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "funnel_page_insights" */
export type Funnel_Page_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funnel_Page_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funnel_Page_Insights_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  visitors?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Funnel_Page_Insights_Sum_Fields = {
  __typename?: 'funnel_page_insights_sum_fields';
  index?: Maybe<Scalars['Int']['output']>;
  visitors?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "funnel.page_insights" */
export type Funnel_Page_Insights_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** update columns of table "funnel.page_insights" */
export enum Funnel_Page_Insights_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  Name = 'name',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  Visitors = 'visitors'
}

export type Funnel_Page_Insights_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Funnel_Page_Insights_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funnel_Page_Insights_Set_Input>;
  /** filter the rows which have to be updated */
  where: Funnel_Page_Insights_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Funnel_Page_Insights_Var_Pop_Fields = {
  __typename?: 'funnel_page_insights_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
  visitors?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "funnel.page_insights" */
export type Funnel_Page_Insights_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Funnel_Page_Insights_Var_Samp_Fields = {
  __typename?: 'funnel_page_insights_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
  visitors?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "funnel.page_insights" */
export type Funnel_Page_Insights_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Funnel_Page_Insights_Variance_Fields = {
  __typename?: 'funnel_page_insights_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
  visitors?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "funnel.page_insights" */
export type Funnel_Page_Insights_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** columns and relationships of "funnel.question" */
export type Funnel_Question = {
  __typename?: 'funnel_question';
  /** An array relationship */
  answers: Array<Answer>;
  /** An aggregate relationship */
  answers_aggregate: Answer_Aggregate;
  archived: Scalars['Boolean']['output'];
  /** An object relationship */
  campaign?: Maybe<Campaign>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  child_questions: Array<Funnel_Question>;
  /** An aggregate relationship */
  child_questions_aggregate: Funnel_Question_Aggregate;
  field_name: Scalars['String']['output'];
  /** An object relationship */
  funnel?: Maybe<Funnel_Funnels>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_required: Scalars['Boolean']['output'];
  /** An array relationship */
  options: Array<Funnel_Question_Option>;
  /** An aggregate relationship */
  options_aggregate: Funnel_Question_Option_Aggregate;
  /** An array relationship */
  page_insights: Array<Funnel_Page_Insights>;
  /** An aggregate relationship */
  page_insights_aggregate: Funnel_Page_Insights_Aggregate;
  /** An object relationship */
  parent_question?: Maybe<Funnel_Question>;
  parent_question_id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  question_type: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


/** columns and relationships of "funnel.question" */
export type Funnel_QuestionAnswersArgs = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By>>;
  where?: InputMaybe<Answer_Bool_Exp>;
};


/** columns and relationships of "funnel.question" */
export type Funnel_QuestionAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By>>;
  where?: InputMaybe<Answer_Bool_Exp>;
};


/** columns and relationships of "funnel.question" */
export type Funnel_QuestionChild_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Order_By>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


/** columns and relationships of "funnel.question" */
export type Funnel_QuestionChild_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Order_By>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


/** columns and relationships of "funnel.question" */
export type Funnel_QuestionOptionsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Option_Order_By>>;
  where?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
};


/** columns and relationships of "funnel.question" */
export type Funnel_QuestionOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Option_Order_By>>;
  where?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
};


/** columns and relationships of "funnel.question" */
export type Funnel_QuestionPage_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Page_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};


/** columns and relationships of "funnel.question" */
export type Funnel_QuestionPage_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Page_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};

/** aggregated selection of "funnel.question" */
export type Funnel_Question_Aggregate = {
  __typename?: 'funnel_question_aggregate';
  aggregate?: Maybe<Funnel_Question_Aggregate_Fields>;
  nodes: Array<Funnel_Question>;
};

export type Funnel_Question_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Funnel_Question_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Funnel_Question_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Funnel_Question_Aggregate_Bool_Exp_Count>;
};

export type Funnel_Question_Aggregate_Bool_Exp_Bool_And = {
  arguments: Funnel_Question_Select_Column_Funnel_Question_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Funnel_Question_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Funnel_Question_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Funnel_Question_Select_Column_Funnel_Question_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Funnel_Question_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Funnel_Question_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Funnel_Question_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "funnel.question" */
export type Funnel_Question_Aggregate_Fields = {
  __typename?: 'funnel_question_aggregate_fields';
  avg?: Maybe<Funnel_Question_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Funnel_Question_Max_Fields>;
  min?: Maybe<Funnel_Question_Min_Fields>;
  stddev?: Maybe<Funnel_Question_Stddev_Fields>;
  stddev_pop?: Maybe<Funnel_Question_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Funnel_Question_Stddev_Samp_Fields>;
  sum?: Maybe<Funnel_Question_Sum_Fields>;
  var_pop?: Maybe<Funnel_Question_Var_Pop_Fields>;
  var_samp?: Maybe<Funnel_Question_Var_Samp_Fields>;
  variance?: Maybe<Funnel_Question_Variance_Fields>;
};


/** aggregate fields of "funnel.question" */
export type Funnel_Question_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "funnel.question" */
export type Funnel_Question_Aggregate_Order_By = {
  avg?: InputMaybe<Funnel_Question_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Funnel_Question_Max_Order_By>;
  min?: InputMaybe<Funnel_Question_Min_Order_By>;
  stddev?: InputMaybe<Funnel_Question_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Funnel_Question_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Funnel_Question_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Funnel_Question_Sum_Order_By>;
  var_pop?: InputMaybe<Funnel_Question_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Funnel_Question_Var_Samp_Order_By>;
  variance?: InputMaybe<Funnel_Question_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "funnel.question" */
export type Funnel_Question_Arr_Rel_Insert_Input = {
  data: Array<Funnel_Question_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Funnel_Question_On_Conflict>;
};

/** aggregate avg on columns */
export type Funnel_Question_Avg_Fields = {
  __typename?: 'funnel_question_avg_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "funnel.question" */
export type Funnel_Question_Avg_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "funnel.question". All fields are combined with a logical 'AND'. */
export type Funnel_Question_Bool_Exp = {
  _and?: InputMaybe<Array<Funnel_Question_Bool_Exp>>;
  _not?: InputMaybe<Funnel_Question_Bool_Exp>;
  _or?: InputMaybe<Array<Funnel_Question_Bool_Exp>>;
  answers?: InputMaybe<Answer_Bool_Exp>;
  answers_aggregate?: InputMaybe<Answer_Aggregate_Bool_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  child_questions?: InputMaybe<Funnel_Question_Bool_Exp>;
  child_questions_aggregate?: InputMaybe<Funnel_Question_Aggregate_Bool_Exp>;
  field_name?: InputMaybe<String_Comparison_Exp>;
  funnel?: InputMaybe<Funnel_Funnels_Bool_Exp>;
  funnel_id?: InputMaybe<Uuid_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_required?: InputMaybe<Boolean_Comparison_Exp>;
  options?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
  options_aggregate?: InputMaybe<Funnel_Question_Option_Aggregate_Bool_Exp>;
  page_insights?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
  page_insights_aggregate?: InputMaybe<Funnel_Page_Insights_Aggregate_Bool_Exp>;
  parent_question?: InputMaybe<Funnel_Question_Bool_Exp>;
  parent_question_id?: InputMaybe<Uuid_Comparison_Exp>;
  position?: InputMaybe<Int_Comparison_Exp>;
  question_type?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "funnel.question" */
export enum Funnel_Question_Constraint {
  /** unique or primary key constraint on columns "campaign_id", "field_name" */
  QuestionCampaignIdFieldNameKey = 'question_campaign_id_field_name_key',
  /** unique or primary key constraint on columns "id" */
  QuestionPkey = 'question_pkey',
  /** unique or primary key constraint on columns "id" */
  QuestionUuidKey = 'question_uuid_key'
}

/** input type for incrementing numeric columns in table "funnel.question" */
export type Funnel_Question_Inc_Input = {
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "funnel.question" */
export type Funnel_Question_Insert_Input = {
  answers?: InputMaybe<Answer_Arr_Rel_Insert_Input>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  child_questions?: InputMaybe<Funnel_Question_Arr_Rel_Insert_Input>;
  field_name?: InputMaybe<Scalars['String']['input']>;
  funnel?: InputMaybe<Funnel_Funnels_Obj_Rel_Insert_Input>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Funnel_Question_Option_Arr_Rel_Insert_Input>;
  page_insights?: InputMaybe<Funnel_Page_Insights_Arr_Rel_Insert_Input>;
  parent_question?: InputMaybe<Funnel_Question_Obj_Rel_Insert_Input>;
  parent_question_id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Funnel_Question_Max_Fields = {
  __typename?: 'funnel_question_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  field_name?: Maybe<Scalars['String']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_question_id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "funnel.question" */
export type Funnel_Question_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Funnel_Question_Min_Fields = {
  __typename?: 'funnel_question_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  field_name?: Maybe<Scalars['String']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_question_id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "funnel.question" */
export type Funnel_Question_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "funnel.question" */
export type Funnel_Question_Mutation_Response = {
  __typename?: 'funnel_question_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Funnel_Question>;
};

/** input type for inserting object relation for remote table "funnel.question" */
export type Funnel_Question_Obj_Rel_Insert_Input = {
  data: Funnel_Question_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Funnel_Question_On_Conflict>;
};

/** on_conflict condition type for table "funnel.question" */
export type Funnel_Question_On_Conflict = {
  constraint: Funnel_Question_Constraint;
  update_columns?: Array<Funnel_Question_Update_Column>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};

/** columns and relationships of "funnel.question_option" */
export type Funnel_Question_Option = {
  __typename?: 'funnel_question_option';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isKnockout: Scalars['Boolean']['output'];
  /** An object relationship */
  question: Funnel_Question;
  question_id: Scalars['uuid']['output'];
  redirect_behavior: Scalars['String']['output'];
  /** An object relationship */
  redirect_question?: Maybe<Funnel_Question>;
  redirect_question_id?: Maybe<Scalars['uuid']['output']>;
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "funnel.question_option" */
export type Funnel_Question_Option_Aggregate = {
  __typename?: 'funnel_question_option_aggregate';
  aggregate?: Maybe<Funnel_Question_Option_Aggregate_Fields>;
  nodes: Array<Funnel_Question_Option>;
};

export type Funnel_Question_Option_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Funnel_Question_Option_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Funnel_Question_Option_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Funnel_Question_Option_Aggregate_Bool_Exp_Count>;
};

export type Funnel_Question_Option_Aggregate_Bool_Exp_Bool_And = {
  arguments: Funnel_Question_Option_Select_Column_Funnel_Question_Option_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Funnel_Question_Option_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Funnel_Question_Option_Select_Column_Funnel_Question_Option_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Funnel_Question_Option_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Funnel_Question_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "funnel.question_option" */
export type Funnel_Question_Option_Aggregate_Fields = {
  __typename?: 'funnel_question_option_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Funnel_Question_Option_Max_Fields>;
  min?: Maybe<Funnel_Question_Option_Min_Fields>;
};


/** aggregate fields of "funnel.question_option" */
export type Funnel_Question_Option_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funnel_Question_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "funnel.question_option" */
export type Funnel_Question_Option_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Funnel_Question_Option_Max_Order_By>;
  min?: InputMaybe<Funnel_Question_Option_Min_Order_By>;
};

/** input type for inserting array relation for remote table "funnel.question_option" */
export type Funnel_Question_Option_Arr_Rel_Insert_Input = {
  data: Array<Funnel_Question_Option_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Funnel_Question_Option_On_Conflict>;
};

/** Boolean expression to filter rows from the table "funnel.question_option". All fields are combined with a logical 'AND'. */
export type Funnel_Question_Option_Bool_Exp = {
  _and?: InputMaybe<Array<Funnel_Question_Option_Bool_Exp>>;
  _not?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
  _or?: InputMaybe<Array<Funnel_Question_Option_Bool_Exp>>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isKnockout?: InputMaybe<Boolean_Comparison_Exp>;
  question?: InputMaybe<Funnel_Question_Bool_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  redirect_behavior?: InputMaybe<String_Comparison_Exp>;
  redirect_question?: InputMaybe<Funnel_Question_Bool_Exp>;
  redirect_question_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "funnel.question_option" */
export enum Funnel_Question_Option_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionOptionPkey = 'question_option_pkey'
}

/** input type for inserting data into table "funnel.question_option" */
export type Funnel_Question_Option_Insert_Input = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isKnockout?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Funnel_Question_Obj_Rel_Insert_Input>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  redirect_behavior?: InputMaybe<Scalars['String']['input']>;
  redirect_question?: InputMaybe<Funnel_Question_Obj_Rel_Insert_Input>;
  redirect_question_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Funnel_Question_Option_Max_Fields = {
  __typename?: 'funnel_question_option_max_fields';
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  redirect_behavior?: Maybe<Scalars['String']['output']>;
  redirect_question_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "funnel.question_option" */
export type Funnel_Question_Option_Max_Order_By = {
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  redirect_behavior?: InputMaybe<Order_By>;
  redirect_question_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Funnel_Question_Option_Min_Fields = {
  __typename?: 'funnel_question_option_min_fields';
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  redirect_behavior?: Maybe<Scalars['String']['output']>;
  redirect_question_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "funnel.question_option" */
export type Funnel_Question_Option_Min_Order_By = {
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  redirect_behavior?: InputMaybe<Order_By>;
  redirect_question_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "funnel.question_option" */
export type Funnel_Question_Option_Mutation_Response = {
  __typename?: 'funnel_question_option_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Funnel_Question_Option>;
};

/** on_conflict condition type for table "funnel.question_option" */
export type Funnel_Question_Option_On_Conflict = {
  constraint: Funnel_Question_Option_Constraint;
  update_columns?: Array<Funnel_Question_Option_Update_Column>;
  where?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
};

/** Ordering options when selecting data from "funnel.question_option". */
export type Funnel_Question_Option_Order_By = {
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isKnockout?: InputMaybe<Order_By>;
  question?: InputMaybe<Funnel_Question_Order_By>;
  question_id?: InputMaybe<Order_By>;
  redirect_behavior?: InputMaybe<Order_By>;
  redirect_question?: InputMaybe<Funnel_Question_Order_By>;
  redirect_question_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: funnel.question_option */
export type Funnel_Question_Option_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "funnel.question_option" */
export enum Funnel_Question_Option_Select_Column {
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IsKnockout = 'isKnockout',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  RedirectBehavior = 'redirect_behavior',
  /** column name */
  RedirectQuestionId = 'redirect_question_id',
  /** column name */
  Title = 'title',
  /** column name */
  Value = 'value'
}

/** select "funnel_question_option_aggregate_bool_exp_bool_and_arguments_columns" columns of table "funnel.question_option" */
export enum Funnel_Question_Option_Select_Column_Funnel_Question_Option_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsKnockout = 'isKnockout'
}

/** select "funnel_question_option_aggregate_bool_exp_bool_or_arguments_columns" columns of table "funnel.question_option" */
export enum Funnel_Question_Option_Select_Column_Funnel_Question_Option_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsKnockout = 'isKnockout'
}

/** input type for updating data in table "funnel.question_option" */
export type Funnel_Question_Option_Set_Input = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isKnockout?: InputMaybe<Scalars['Boolean']['input']>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  redirect_behavior?: InputMaybe<Scalars['String']['input']>;
  redirect_question_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "funnel_question_option" */
export type Funnel_Question_Option_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funnel_Question_Option_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funnel_Question_Option_Stream_Cursor_Value_Input = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isKnockout?: InputMaybe<Scalars['Boolean']['input']>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  redirect_behavior?: InputMaybe<Scalars['String']['input']>;
  redirect_question_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "funnel.question_option" */
export enum Funnel_Question_Option_Update_Column {
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IsKnockout = 'isKnockout',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  RedirectBehavior = 'redirect_behavior',
  /** column name */
  RedirectQuestionId = 'redirect_question_id',
  /** column name */
  Title = 'title',
  /** column name */
  Value = 'value'
}

export type Funnel_Question_Option_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funnel_Question_Option_Set_Input>;
  /** filter the rows which have to be updated */
  where: Funnel_Question_Option_Bool_Exp;
};

/** Ordering options when selecting data from "funnel.question". */
export type Funnel_Question_Order_By = {
  answers_aggregate?: InputMaybe<Answer_Aggregate_Order_By>;
  archived?: InputMaybe<Order_By>;
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  child_questions_aggregate?: InputMaybe<Funnel_Question_Aggregate_Order_By>;
  field_name?: InputMaybe<Order_By>;
  funnel?: InputMaybe<Funnel_Funnels_Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_required?: InputMaybe<Order_By>;
  options_aggregate?: InputMaybe<Funnel_Question_Option_Aggregate_Order_By>;
  page_insights_aggregate?: InputMaybe<Funnel_Page_Insights_Aggregate_Order_By>;
  parent_question?: InputMaybe<Funnel_Question_Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: funnel.question */
export type Funnel_Question_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "funnel.question" */
export enum Funnel_Question_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  FieldName = 'field_name',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IsRequired = 'is_required',
  /** column name */
  ParentQuestionId = 'parent_question_id',
  /** column name */
  Position = 'position',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  Title = 'title'
}

/** select "funnel_question_aggregate_bool_exp_bool_and_arguments_columns" columns of table "funnel.question" */
export enum Funnel_Question_Select_Column_Funnel_Question_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  IsRequired = 'is_required'
}

/** select "funnel_question_aggregate_bool_exp_bool_or_arguments_columns" columns of table "funnel.question" */
export enum Funnel_Question_Select_Column_Funnel_Question_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  IsRequired = 'is_required'
}

/** input type for updating data in table "funnel.question" */
export type Funnel_Question_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  field_name?: InputMaybe<Scalars['String']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  parent_question_id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Funnel_Question_Stddev_Fields = {
  __typename?: 'funnel_question_stddev_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "funnel.question" */
export type Funnel_Question_Stddev_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Funnel_Question_Stddev_Pop_Fields = {
  __typename?: 'funnel_question_stddev_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "funnel.question" */
export type Funnel_Question_Stddev_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Funnel_Question_Stddev_Samp_Fields = {
  __typename?: 'funnel_question_stddev_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "funnel.question" */
export type Funnel_Question_Stddev_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "funnel_question" */
export type Funnel_Question_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funnel_Question_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funnel_Question_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  field_name?: InputMaybe<Scalars['String']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  parent_question_id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Funnel_Question_Sum_Fields = {
  __typename?: 'funnel_question_sum_fields';
  position?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "funnel.question" */
export type Funnel_Question_Sum_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** update columns of table "funnel.question" */
export enum Funnel_Question_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  FieldName = 'field_name',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IsRequired = 'is_required',
  /** column name */
  ParentQuestionId = 'parent_question_id',
  /** column name */
  Position = 'position',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  Title = 'title'
}

export type Funnel_Question_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Funnel_Question_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funnel_Question_Set_Input>;
  /** filter the rows which have to be updated */
  where: Funnel_Question_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Funnel_Question_Var_Pop_Fields = {
  __typename?: 'funnel_question_var_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "funnel.question" */
export type Funnel_Question_Var_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Funnel_Question_Var_Samp_Fields = {
  __typename?: 'funnel_question_var_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "funnel.question" */
export type Funnel_Question_Var_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Funnel_Question_Variance_Fields = {
  __typename?: 'funnel_question_variance_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "funnel.question" */
export type Funnel_Question_Variance_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** columns and relationships of "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks = {
  __typename?: 'funnel_whatsapp_share_clicks';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  funnel: Funnel_Funnels;
  funnel_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  source: Scalars['String']['output'];
};

/** aggregated selection of "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Aggregate = {
  __typename?: 'funnel_whatsapp_share_clicks_aggregate';
  aggregate?: Maybe<Funnel_Whatsapp_Share_Clicks_Aggregate_Fields>;
  nodes: Array<Funnel_Whatsapp_Share_Clicks>;
};

export type Funnel_Whatsapp_Share_Clicks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Aggregate_Bool_Exp_Count>;
};

export type Funnel_Whatsapp_Share_Clicks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Aggregate_Fields = {
  __typename?: 'funnel_whatsapp_share_clicks_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Funnel_Whatsapp_Share_Clicks_Max_Fields>;
  min?: Maybe<Funnel_Whatsapp_Share_Clicks_Min_Fields>;
};


/** aggregate fields of "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Max_Order_By>;
  min?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Arr_Rel_Insert_Input = {
  data: Array<Funnel_Whatsapp_Share_Clicks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Funnel_Whatsapp_Share_Clicks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "funnel.whatsapp_share_clicks". All fields are combined with a logical 'AND'. */
export type Funnel_Whatsapp_Share_Clicks_Bool_Exp = {
  _and?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Bool_Exp>>;
  _not?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
  _or?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  funnel?: InputMaybe<Funnel_Funnels_Bool_Exp>;
  funnel_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "funnel.whatsapp_share_clicks" */
export enum Funnel_Whatsapp_Share_Clicks_Constraint {
  /** unique or primary key constraint on columns "id" */
  WhatsappShareClicksPkey = 'whatsapp_share_clicks_pkey'
}

/** input type for inserting data into table "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  funnel?: InputMaybe<Funnel_Funnels_Obj_Rel_Insert_Input>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Funnel_Whatsapp_Share_Clicks_Max_Fields = {
  __typename?: 'funnel_whatsapp_share_clicks_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Funnel_Whatsapp_Share_Clicks_Min_Fields = {
  __typename?: 'funnel_whatsapp_share_clicks_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  funnel_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Mutation_Response = {
  __typename?: 'funnel_whatsapp_share_clicks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Funnel_Whatsapp_Share_Clicks>;
};

/** on_conflict condition type for table "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_On_Conflict = {
  constraint: Funnel_Whatsapp_Share_Clicks_Constraint;
  update_columns?: Array<Funnel_Whatsapp_Share_Clicks_Update_Column>;
  where?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
};

/** Ordering options when selecting data from "funnel.whatsapp_share_clicks". */
export type Funnel_Whatsapp_Share_Clicks_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  funnel?: InputMaybe<Funnel_Funnels_Order_By>;
  funnel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: funnel.whatsapp_share_clicks */
export type Funnel_Whatsapp_Share_Clicks_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "funnel.whatsapp_share_clicks" */
export enum Funnel_Whatsapp_Share_Clicks_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Id = 'id',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "funnel.whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "funnel_whatsapp_share_clicks" */
export type Funnel_Whatsapp_Share_Clicks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funnel_Whatsapp_Share_Clicks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funnel_Whatsapp_Share_Clicks_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  funnel_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "funnel.whatsapp_share_clicks" */
export enum Funnel_Whatsapp_Share_Clicks_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FunnelId = 'funnel_id',
  /** column name */
  Id = 'id',
  /** column name */
  Source = 'source'
}

export type Funnel_Whatsapp_Share_Clicks_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Funnel_Whatsapp_Share_Clicks_Bool_Exp;
};

/** columns and relationships of "huk_contacts" */
export type Huk_Contacts = {
  __typename?: 'huk_contacts';
  accepted_data_privacy_agreement?: Maybe<Scalars['Boolean']['output']>;
  birthdate?: Maybe<Scalars['String']['output']>;
  bot_consent?: Maybe<Scalars['Boolean']['output']>;
  camp_id?: Maybe<Scalars['uuid']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  campaign_name?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  converted_at?: Maybe<Scalars['timestamptz']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  cv_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  form_of_address?: Maybe<Scalars['String']['output']>;
  funnel_file_id?: Maybe<Scalars['uuid']['output']>;
  has_completed_chatbot?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  origin_campaign_id?: Maybe<Scalars['uuid']['output']>;
  perspective_id?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  qualified?: Maybe<Scalars['Boolean']['output']>;
  routing_location_id?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "huk_contacts" */
export type Huk_Contacts_Aggregate = {
  __typename?: 'huk_contacts_aggregate';
  aggregate?: Maybe<Huk_Contacts_Aggregate_Fields>;
  nodes: Array<Huk_Contacts>;
};

/** aggregate fields of "huk_contacts" */
export type Huk_Contacts_Aggregate_Fields = {
  __typename?: 'huk_contacts_aggregate_fields';
  avg?: Maybe<Huk_Contacts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Huk_Contacts_Max_Fields>;
  min?: Maybe<Huk_Contacts_Min_Fields>;
  stddev?: Maybe<Huk_Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Huk_Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Huk_Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Huk_Contacts_Sum_Fields>;
  var_pop?: Maybe<Huk_Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Huk_Contacts_Var_Samp_Fields>;
  variance?: Maybe<Huk_Contacts_Variance_Fields>;
};


/** aggregate fields of "huk_contacts" */
export type Huk_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Huk_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Huk_Contacts_Avg_Fields = {
  __typename?: 'huk_contacts_avg_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "huk_contacts". All fields are combined with a logical 'AND'. */
export type Huk_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Huk_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Huk_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Huk_Contacts_Bool_Exp>>;
  accepted_data_privacy_agreement?: InputMaybe<Boolean_Comparison_Exp>;
  birthdate?: InputMaybe<String_Comparison_Exp>;
  bot_consent?: InputMaybe<Boolean_Comparison_Exp>;
  camp_id?: InputMaybe<Uuid_Comparison_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  campaign_name?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  converted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cv_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  end?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  form_of_address?: InputMaybe<String_Comparison_Exp>;
  funnel_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_completed_chatbot?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  origin_campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  perspective_id?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  qualified?: InputMaybe<Boolean_Comparison_Exp>;
  routing_location_id?: InputMaybe<Int_Comparison_Exp>;
  start?: InputMaybe<Timestamptz_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utm_source?: InputMaybe<String_Comparison_Exp>;
  zip_code?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Huk_Contacts_Max_Fields = {
  __typename?: 'huk_contacts_max_fields';
  birthdate?: Maybe<Scalars['String']['output']>;
  camp_id?: Maybe<Scalars['uuid']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  campaign_name?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  converted_at?: Maybe<Scalars['timestamptz']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  cv_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  form_of_address?: Maybe<Scalars['String']['output']>;
  funnel_file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  origin_campaign_id?: Maybe<Scalars['uuid']['output']>;
  perspective_id?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  routing_location_id?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Huk_Contacts_Min_Fields = {
  __typename?: 'huk_contacts_min_fields';
  birthdate?: Maybe<Scalars['String']['output']>;
  camp_id?: Maybe<Scalars['uuid']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  campaign_name?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  converted_at?: Maybe<Scalars['timestamptz']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  cv_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  form_of_address?: Maybe<Scalars['String']['output']>;
  funnel_file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  origin_campaign_id?: Maybe<Scalars['uuid']['output']>;
  perspective_id?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  routing_location_id?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "huk_contacts". */
export type Huk_Contacts_Order_By = {
  accepted_data_privacy_agreement?: InputMaybe<Order_By>;
  birthdate?: InputMaybe<Order_By>;
  bot_consent?: InputMaybe<Order_By>;
  camp_id?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  campaign_name?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  converted_at?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  cv_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  form_of_address?: InputMaybe<Order_By>;
  funnel_file_id?: InputMaybe<Order_By>;
  has_completed_chatbot?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  origin_campaign_id?: InputMaybe<Order_By>;
  perspective_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  qualified?: InputMaybe<Order_By>;
  routing_location_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** select columns of table "huk_contacts" */
export enum Huk_Contacts_Select_Column {
  /** column name */
  AcceptedDataPrivacyAgreement = 'accepted_data_privacy_agreement',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  BotConsent = 'bot_consent',
  /** column name */
  CampId = 'camp_id',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CampaignName = 'campaign_name',
  /** column name */
  Category = 'category',
  /** column name */
  City = 'city',
  /** column name */
  ConvertedAt = 'converted_at',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CvId = 'cv_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  End = 'end',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormOfAddress = 'form_of_address',
  /** column name */
  FunnelFileId = 'funnel_file_id',
  /** column name */
  HasCompletedChatbot = 'has_completed_chatbot',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OriginCampaignId = 'origin_campaign_id',
  /** column name */
  PerspectiveId = 'perspective_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Qualified = 'qualified',
  /** column name */
  RoutingLocationId = 'routing_location_id',
  /** column name */
  Start = 'start',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtmSource = 'utm_source',
  /** column name */
  ZipCode = 'zip_code'
}

/** aggregate stddev on columns */
export type Huk_Contacts_Stddev_Fields = {
  __typename?: 'huk_contacts_stddev_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Huk_Contacts_Stddev_Pop_Fields = {
  __typename?: 'huk_contacts_stddev_pop_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Huk_Contacts_Stddev_Samp_Fields = {
  __typename?: 'huk_contacts_stddev_samp_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "huk_contacts" */
export type Huk_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Huk_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Huk_Contacts_Stream_Cursor_Value_Input = {
  accepted_data_privacy_agreement?: InputMaybe<Scalars['Boolean']['input']>;
  birthdate?: InputMaybe<Scalars['String']['input']>;
  bot_consent?: InputMaybe<Scalars['Boolean']['input']>;
  camp_id?: InputMaybe<Scalars['uuid']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  campaign_name?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  converted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cv_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  form_of_address?: InputMaybe<Scalars['String']['input']>;
  funnel_file_id?: InputMaybe<Scalars['uuid']['input']>;
  has_completed_chatbot?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  origin_campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  perspective_id?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  qualified?: InputMaybe<Scalars['Boolean']['input']>;
  routing_location_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Huk_Contacts_Sum_Fields = {
  __typename?: 'huk_contacts_sum_fields';
  routing_location_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Huk_Contacts_Var_Pop_Fields = {
  __typename?: 'huk_contacts_var_pop_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Huk_Contacts_Var_Samp_Fields = {
  __typename?: 'huk_contacts_var_samp_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Huk_Contacts_Variance_Fields = {
  __typename?: 'huk_contacts_variance_fields';
  routing_location_id?: Maybe<Scalars['Float']['output']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "ad.campaign_metrics" */
  delete_ad_campaign_metrics?: Maybe<Ad_Campaign_Metrics_Mutation_Response>;
  /** delete single row from the table: "ad.campaign_metrics" */
  delete_ad_campaign_metrics_by_pk?: Maybe<Ad_Campaign_Metrics>;
  /** delete data from the table: "ad.comment" */
  delete_ad_comment?: Maybe<Ad_Comment_Mutation_Response>;
  /** delete single row from the table: "ad.comment" */
  delete_ad_comment_by_pk?: Maybe<Ad_Comment>;
  /** delete data from the table: "ad.creative" */
  delete_ad_creative?: Maybe<Ad_Creative_Mutation_Response>;
  /** delete single row from the table: "ad.creative" */
  delete_ad_creative_by_pk?: Maybe<Ad_Creative>;
  /** delete data from the table: "ad.creative_feedback" */
  delete_ad_creative_feedback?: Maybe<Ad_Creative_Feedback_Mutation_Response>;
  /** delete single row from the table: "ad.creative_feedback" */
  delete_ad_creative_feedback_by_pk?: Maybe<Ad_Creative_Feedback>;
  /** delete data from the table: "ad.platform" */
  delete_ad_platform?: Maybe<Ad_Platform_Mutation_Response>;
  /** delete single row from the table: "ad.platform" */
  delete_ad_platform_by_pk?: Maybe<Ad_Platform>;
  /** delete data from the table: "ad.providers" */
  delete_ad_providers?: Maybe<Ad_Providers_Mutation_Response>;
  /** delete single row from the table: "ad.providers" */
  delete_ad_providers_by_pk?: Maybe<Ad_Providers>;
  /** delete data from the table: "ad.setting" */
  delete_ad_setting?: Maybe<Ad_Setting_Mutation_Response>;
  /** delete single row from the table: "ad.setting" */
  delete_ad_setting_by_pk?: Maybe<Ad_Setting>;
  /** delete data from the table: "ad.status" */
  delete_ad_status?: Maybe<Ad_Status_Mutation_Response>;
  /** delete single row from the table: "ad.status" */
  delete_ad_status_by_pk?: Maybe<Ad_Status>;
  /** delete data from the table: "anna_ai.call_campaigns" */
  delete_anna_ai_call_campaigns?: Maybe<Anna_Ai_Call_Campaigns_Mutation_Response>;
  /** delete single row from the table: "anna_ai.call_campaigns" */
  delete_anna_ai_call_campaigns_by_pk?: Maybe<Anna_Ai_Call_Campaigns>;
  /** delete data from the table: "anna_ai.call_states" */
  delete_anna_ai_call_states?: Maybe<Anna_Ai_Call_States_Mutation_Response>;
  /** delete single row from the table: "anna_ai.call_states" */
  delete_anna_ai_call_states_by_pk?: Maybe<Anna_Ai_Call_States>;
  /** delete data from the table: "anna_ai.outbound_calls" */
  delete_anna_ai_outbound_calls?: Maybe<Anna_Ai_Outbound_Calls_Mutation_Response>;
  /** delete single row from the table: "anna_ai.outbound_calls" */
  delete_anna_ai_outbound_calls_by_pk?: Maybe<Anna_Ai_Outbound_Calls>;
  /** delete data from the table: "answer" */
  delete_answer?: Maybe<Answer_Mutation_Response>;
  /** delete single row from the table: "answer" */
  delete_answer_by_pk?: Maybe<Answer>;
  /** delete data from the table: "applicant.event" */
  delete_applicant_event?: Maybe<Applicant_Event_Mutation_Response>;
  /** delete single row from the table: "applicant.event" */
  delete_applicant_event_by_pk?: Maybe<Applicant_Event>;
  /** delete data from the table: "board.column_type" */
  delete_board_column_type?: Maybe<Board_Column_Type_Mutation_Response>;
  /** delete single row from the table: "board.column_type" */
  delete_board_column_type_by_pk?: Maybe<Board_Column_Type>;
  /** delete data from the table: "board.contact_board" */
  delete_board_contact_board?: Maybe<Board_Contact_Board_Mutation_Response>;
  /** delete single row from the table: "board.contact_board" */
  delete_board_contact_board_by_pk?: Maybe<Board_Contact_Board>;
  /** delete data from the table: "board.contact_board_column" */
  delete_board_contact_board_column?: Maybe<Board_Contact_Board_Column_Mutation_Response>;
  /** delete single row from the table: "board.contact_board_column" */
  delete_board_contact_board_column_by_pk?: Maybe<Board_Contact_Board_Column>;
  /** delete data from the table: "board.contact_board_entry" */
  delete_board_contact_board_entry?: Maybe<Board_Contact_Board_Entry_Mutation_Response>;
  /** delete single row from the table: "board.contact_board_entry" */
  delete_board_contact_board_entry_by_pk?: Maybe<Board_Contact_Board_Entry>;
  /** delete data from the table: "board.note" */
  delete_board_note?: Maybe<Board_Note_Mutation_Response>;
  /** delete single row from the table: "board.note" */
  delete_board_note_by_pk?: Maybe<Board_Note>;
  /** delete data from the table: "bot.assignee" */
  delete_bot_assignee?: Maybe<Bot_Assignee_Mutation_Response>;
  /** delete single row from the table: "bot.assignee" */
  delete_bot_assignee_by_pk?: Maybe<Bot_Assignee>;
  /** delete data from the table: "bot.channel" */
  delete_bot_channel?: Maybe<Bot_Channel_Mutation_Response>;
  /** delete single row from the table: "bot.channel" */
  delete_bot_channel_by_pk?: Maybe<Bot_Channel>;
  /** delete data from the table: "bot.conversation" */
  delete_bot_conversation?: Maybe<Bot_Conversation_Mutation_Response>;
  /** delete single row from the table: "bot.conversation" */
  delete_bot_conversation_by_pk?: Maybe<Bot_Conversation>;
  /** delete data from the table: "bot.conversation_state" */
  delete_bot_conversation_state?: Maybe<Bot_Conversation_State_Mutation_Response>;
  /** delete single row from the table: "bot.conversation_state" */
  delete_bot_conversation_state_by_pk?: Maybe<Bot_Conversation_State>;
  /** delete data from the table: "bot.message" */
  delete_bot_message?: Maybe<Bot_Message_Mutation_Response>;
  /** delete single row from the table: "bot.message" */
  delete_bot_message_by_pk?: Maybe<Bot_Message>;
  /** delete data from the table: "bot.message_status" */
  delete_bot_message_status?: Maybe<Bot_Message_Status_Mutation_Response>;
  /** delete single row from the table: "bot.message_status" */
  delete_bot_message_status_by_pk?: Maybe<Bot_Message_Status>;
  /** delete data from the table: "bot.sender" */
  delete_bot_sender?: Maybe<Bot_Sender_Mutation_Response>;
  /** delete single row from the table: "bot.sender" */
  delete_bot_sender_by_pk?: Maybe<Bot_Sender>;
  /** delete data from the table: "campaign" */
  delete_campaign?: Maybe<Campaign_Mutation_Response>;
  /** delete data from the table: "campaign.ad" */
  delete_campaign_ad?: Maybe<Campaign_Ad_Mutation_Response>;
  /** delete single row from the table: "campaign.ad" */
  delete_campaign_ad_by_pk?: Maybe<Campaign_Ad>;
  /** delete data from the table: "campaign.budget" */
  delete_campaign_budget?: Maybe<Campaign_Budget_Mutation_Response>;
  /** delete data from the table: "campaign.budget_transaction" */
  delete_campaign_budget_transaction?: Maybe<Campaign_Budget_Transaction_Mutation_Response>;
  /** delete single row from the table: "campaign.budget_transaction" */
  delete_campaign_budget_transaction_by_pk?: Maybe<Campaign_Budget_Transaction>;
  /** delete single row from the table: "campaign" */
  delete_campaign_by_pk?: Maybe<Campaign>;
  /** delete data from the table: "campaign.email_template_overwrite" */
  delete_campaign_email_template_overwrite?: Maybe<Campaign_Email_Template_Overwrite_Mutation_Response>;
  /** delete single row from the table: "campaign.email_template_overwrite" */
  delete_campaign_email_template_overwrite_by_pk?: Maybe<Campaign_Email_Template_Overwrite>;
  /** delete data from the table: "campaign.event_log" */
  delete_campaign_event_log?: Maybe<Campaign_Event_Log_Mutation_Response>;
  /** delete single row from the table: "campaign.event_log" */
  delete_campaign_event_log_by_pk?: Maybe<Campaign_Event_Log>;
  /** delete data from the table: "campaign.iso_2_country_codes" */
  delete_campaign_iso_2_country_codes?: Maybe<Campaign_Iso_2_Country_Codes_Mutation_Response>;
  /** delete single row from the table: "campaign.iso_2_country_codes" */
  delete_campaign_iso_2_country_codes_by_pk?: Maybe<Campaign_Iso_2_Country_Codes>;
  /** delete data from the table: "campaign.job_description" */
  delete_campaign_job_description?: Maybe<Campaign_Job_Description_Mutation_Response>;
  /** delete single row from the table: "campaign.job_description" */
  delete_campaign_job_description_by_pk?: Maybe<Campaign_Job_Description>;
  /** delete data from the table: "campaign.order" */
  delete_campaign_order?: Maybe<Campaign_Order_Mutation_Response>;
  /** delete single row from the table: "campaign.order" */
  delete_campaign_order_by_pk?: Maybe<Campaign_Order>;
  /** delete data from the table: "campaign.order_source" */
  delete_campaign_order_source?: Maybe<Campaign_Order_Source_Mutation_Response>;
  /** delete single row from the table: "campaign.order_source" */
  delete_campaign_order_source_by_pk?: Maybe<Campaign_Order_Source>;
  /** delete data from the table: "campaign.order_source_type" */
  delete_campaign_order_source_type?: Maybe<Campaign_Order_Source_Type_Mutation_Response>;
  /** delete single row from the table: "campaign.order_source_type" */
  delete_campaign_order_source_type_by_pk?: Maybe<Campaign_Order_Source_Type>;
  /** delete data from the table: "campaign_routing.destination" */
  delete_campaign_routing_destination?: Maybe<Campaign_Routing_Destination_Mutation_Response>;
  /** delete single row from the table: "campaign_routing.destination" */
  delete_campaign_routing_destination_by_pk?: Maybe<Campaign_Routing_Destination>;
  /** delete data from the table: "campaign_routing.info" */
  delete_campaign_routing_info?: Maybe<Campaign_Routing_Info_Mutation_Response>;
  /** delete single row from the table: "campaign_routing.info" */
  delete_campaign_routing_info_by_pk?: Maybe<Campaign_Routing_Info>;
  /** delete data from the table: "campaign_routing.zipcode" */
  delete_campaign_routing_zipcode?: Maybe<Campaign_Routing_Zipcode_Mutation_Response>;
  /** delete single row from the table: "campaign_routing.zipcode" */
  delete_campaign_routing_zipcode_by_pk?: Maybe<Campaign_Routing_Zipcode>;
  /** delete data from the table: "campaign.settings_override" */
  delete_campaign_settings_override?: Maybe<Campaign_Settings_Override_Mutation_Response>;
  /** delete single row from the table: "campaign.settings_override" */
  delete_campaign_settings_override_by_pk?: Maybe<Campaign_Settings_Override>;
  /** delete data from the table: "campaign_status" */
  delete_campaign_status?: Maybe<Campaign_Status_Mutation_Response>;
  /** delete single row from the table: "campaign_status" */
  delete_campaign_status_by_pk?: Maybe<Campaign_Status>;
  /** delete data from the table: "campaign.status_event" */
  delete_campaign_status_event?: Maybe<Campaign_Status_Event_Mutation_Response>;
  /** delete single row from the table: "campaign.status_event" */
  delete_campaign_status_event_by_pk?: Maybe<Campaign_Status_Event>;
  /** delete data from the table: "campaign.status_log" */
  delete_campaign_status_log?: Maybe<Campaign_Status_Log_Mutation_Response>;
  /** delete single row from the table: "campaign.status_log" */
  delete_campaign_status_log_by_pk?: Maybe<Campaign_Status_Log>;
  /** delete data from the table: "campaign.transaction_type" */
  delete_campaign_transaction_type?: Maybe<Campaign_Transaction_Type_Mutation_Response>;
  /** delete single row from the table: "campaign.transaction_type" */
  delete_campaign_transaction_type_by_pk?: Maybe<Campaign_Transaction_Type>;
  /** delete data from the table: "campaign_work_location" */
  delete_campaign_work_location?: Maybe<Campaign_Work_Location_Mutation_Response>;
  /** delete single row from the table: "campaign_work_location" */
  delete_campaign_work_location_by_pk?: Maybe<Campaign_Work_Location>;
  /** delete data from the table: "chat_bot.customers" */
  delete_chat_bot_customers?: Maybe<Chat_Bot_Customers_Mutation_Response>;
  /** delete single row from the table: "chat_bot.customers" */
  delete_chat_bot_customers_by_pk?: Maybe<Chat_Bot_Customers>;
  /** delete data from the table: "chat_bot.forwarding" */
  delete_chat_bot_forwarding?: Maybe<Chat_Bot_Forwarding_Mutation_Response>;
  /** delete single row from the table: "chat_bot.forwarding" */
  delete_chat_bot_forwarding_by_pk?: Maybe<Chat_Bot_Forwarding>;
  /** delete data from the table: "chat_bot.message_type" */
  delete_chat_bot_message_type?: Maybe<Chat_Bot_Message_Type_Mutation_Response>;
  /** delete single row from the table: "chat_bot.message_type" */
  delete_chat_bot_message_type_by_pk?: Maybe<Chat_Bot_Message_Type>;
  /** delete data from the table: "chat_bot.messages" */
  delete_chat_bot_messages?: Maybe<Chat_Bot_Messages_Mutation_Response>;
  /** delete single row from the table: "chat_bot.messages" */
  delete_chat_bot_messages_by_pk?: Maybe<Chat_Bot_Messages>;
  /** delete data from the table: "contact" */
  delete_contact?: Maybe<Contact_Mutation_Response>;
  /** delete single row from the table: "contact" */
  delete_contact_by_pk?: Maybe<Contact>;
  /** delete data from the table: "contact.logs" */
  delete_contact_logs?: Maybe<Contact_Logs_Mutation_Response>;
  /** delete single row from the table: "contact.logs" */
  delete_contact_logs_by_pk?: Maybe<Contact_Logs>;
  /** delete data from the table: "file.pdf_templates" */
  delete_file_pdf_templates?: Maybe<File_Pdf_Templates_Mutation_Response>;
  /** delete single row from the table: "file.pdf_templates" */
  delete_file_pdf_templates_by_pk?: Maybe<File_Pdf_Templates>;
  /** delete data from the table: "file.upload" */
  delete_file_upload?: Maybe<File_Upload_Mutation_Response>;
  /** delete single row from the table: "file.upload" */
  delete_file_upload_by_pk?: Maybe<File_Upload>;
  /** delete data from the table: "funnel.benefits" */
  delete_funnel_benefits?: Maybe<Funnel_Benefits_Mutation_Response>;
  /** delete single row from the table: "funnel.benefits" */
  delete_funnel_benefits_by_pk?: Maybe<Funnel_Benefits>;
  /** delete data from the table: "funnel.chatbot_message" */
  delete_funnel_chatbot_message?: Maybe<Funnel_Chatbot_Message_Mutation_Response>;
  /** delete single row from the table: "funnel.chatbot_message" */
  delete_funnel_chatbot_message_by_pk?: Maybe<Funnel_Chatbot_Message>;
  /** delete data from the table: "funnel.chatbot_session" */
  delete_funnel_chatbot_session?: Maybe<Funnel_Chatbot_Session_Mutation_Response>;
  /** delete single row from the table: "funnel.chatbot_session" */
  delete_funnel_chatbot_session_by_pk?: Maybe<Funnel_Chatbot_Session>;
  /** delete data from the table: "funnel.funnels" */
  delete_funnel_funnels?: Maybe<Funnel_Funnels_Mutation_Response>;
  /** delete single row from the table: "funnel.funnels" */
  delete_funnel_funnels_by_pk?: Maybe<Funnel_Funnels>;
  /** delete data from the table: "funnel.insights" */
  delete_funnel_insights?: Maybe<Funnel_Insights_Mutation_Response>;
  /** delete data from the table: "funnel.page_insights" */
  delete_funnel_page_insights?: Maybe<Funnel_Page_Insights_Mutation_Response>;
  /** delete single row from the table: "funnel.page_insights" */
  delete_funnel_page_insights_by_pk?: Maybe<Funnel_Page_Insights>;
  /** delete data from the table: "funnel.question" */
  delete_funnel_question?: Maybe<Funnel_Question_Mutation_Response>;
  /** delete single row from the table: "funnel.question" */
  delete_funnel_question_by_pk?: Maybe<Funnel_Question>;
  /** delete data from the table: "funnel.question_option" */
  delete_funnel_question_option?: Maybe<Funnel_Question_Option_Mutation_Response>;
  /** delete single row from the table: "funnel.question_option" */
  delete_funnel_question_option_by_pk?: Maybe<Funnel_Question_Option>;
  /** delete data from the table: "funnel.whatsapp_share_clicks" */
  delete_funnel_whatsapp_share_clicks?: Maybe<Funnel_Whatsapp_Share_Clicks_Mutation_Response>;
  /** delete single row from the table: "funnel.whatsapp_share_clicks" */
  delete_funnel_whatsapp_share_clicks_by_pk?: Maybe<Funnel_Whatsapp_Share_Clicks>;
  /** delete data from the table: "organization" */
  delete_organization?: Maybe<Organization_Mutation_Response>;
  /** delete single row from the table: "organization" */
  delete_organization_by_pk?: Maybe<Organization>;
  /** delete data from the table: "organization.location" */
  delete_organization_location?: Maybe<Organization_Location_Mutation_Response>;
  /** delete single row from the table: "organization.location" */
  delete_organization_location_by_pk?: Maybe<Organization_Location>;
  /** delete data from the table: "organization_name_prefix" */
  delete_organization_name_prefix?: Maybe<Organization_Name_Prefix_Mutation_Response>;
  /** delete single row from the table: "organization_name_prefix" */
  delete_organization_name_prefix_by_pk?: Maybe<Organization_Name_Prefix>;
  /** delete data from the table: "organization.news" */
  delete_organization_news?: Maybe<Organization_News_Mutation_Response>;
  /** delete single row from the table: "organization.news" */
  delete_organization_news_by_pk?: Maybe<Organization_News>;
  /** delete data from the table: "organization.region" */
  delete_organization_region?: Maybe<Organization_Region_Mutation_Response>;
  /** delete single row from the table: "organization.region" */
  delete_organization_region_by_pk?: Maybe<Organization_Region>;
  /** delete data from the table: "organization.settings" */
  delete_organization_settings?: Maybe<Organization_Settings_Mutation_Response>;
  /** delete single row from the table: "organization.settings" */
  delete_organization_settings_by_pk?: Maybe<Organization_Settings>;
  /** delete data from the table: "perspective_campaign" */
  delete_perspective_campaign?: Maybe<Perspective_Campaign_Mutation_Response>;
  /** delete single row from the table: "perspective_campaign" */
  delete_perspective_campaign_by_pk?: Maybe<Perspective_Campaign>;
  /** delete data from the table: "qa_source" */
  delete_qa_source?: Maybe<Qa_Source_Mutation_Response>;
  /** delete single row from the table: "qa_source" */
  delete_qa_source_by_pk?: Maybe<Qa_Source>;
  /** delete data from the table: "rms.connectors" */
  delete_rms_connectors?: Maybe<Rms_Connectors_Mutation_Response>;
  /** delete single row from the table: "rms.connectors" */
  delete_rms_connectors_by_pk?: Maybe<Rms_Connectors>;
  /** delete data from the table: "rms.forwarded_logs" */
  delete_rms_forwarded_logs?: Maybe<Rms_Forwarded_Logs_Mutation_Response>;
  /** delete single row from the table: "rms.forwarded_logs" */
  delete_rms_forwarded_logs_by_pk?: Maybe<Rms_Forwarded_Logs>;
  /** delete data from the table: "rms.org_setups" */
  delete_rms_org_setups?: Maybe<Rms_Org_Setups_Mutation_Response>;
  /** delete single row from the table: "rms.org_setups" */
  delete_rms_org_setups_by_pk?: Maybe<Rms_Org_Setups>;
  /** delete data from the table: "system.api_keys" */
  delete_system_api_keys?: Maybe<System_Api_Keys_Mutation_Response>;
  /** delete single row from the table: "system.api_keys" */
  delete_system_api_keys_by_pk?: Maybe<System_Api_Keys>;
  /** delete data from the table: "system.call_daily_stats" */
  delete_system_call_daily_stats?: Maybe<System_Call_Daily_Stats_Mutation_Response>;
  /** delete single row from the table: "system.call_daily_stats" */
  delete_system_call_daily_stats_by_pk?: Maybe<System_Call_Daily_Stats>;
  /** delete data from the table: "system.email_daily_stats" */
  delete_system_email_daily_stats?: Maybe<System_Email_Daily_Stats_Mutation_Response>;
  /** delete single row from the table: "system.email_daily_stats" */
  delete_system_email_daily_stats_by_pk?: Maybe<System_Email_Daily_Stats>;
  /** delete data from the table: "system.running_release" */
  delete_system_running_release?: Maybe<System_Running_Release_Mutation_Response>;
  /** delete single row from the table: "system.running_release" */
  delete_system_running_release_by_pk?: Maybe<System_Running_Release>;
  /** delete data from the table: "system.sms_daily_stats" */
  delete_system_sms_daily_stats?: Maybe<System_Sms_Daily_Stats_Mutation_Response>;
  /** delete single row from the table: "system.sms_daily_stats" */
  delete_system_sms_daily_stats_by_pk?: Maybe<System_Sms_Daily_Stats>;
  /** insert data into the table: "ad.campaign_metrics" */
  insert_ad_campaign_metrics?: Maybe<Ad_Campaign_Metrics_Mutation_Response>;
  /** insert a single row into the table: "ad.campaign_metrics" */
  insert_ad_campaign_metrics_one?: Maybe<Ad_Campaign_Metrics>;
  /** insert data into the table: "ad.comment" */
  insert_ad_comment?: Maybe<Ad_Comment_Mutation_Response>;
  /** insert a single row into the table: "ad.comment" */
  insert_ad_comment_one?: Maybe<Ad_Comment>;
  /** insert data into the table: "ad.creative" */
  insert_ad_creative?: Maybe<Ad_Creative_Mutation_Response>;
  /** insert data into the table: "ad.creative_feedback" */
  insert_ad_creative_feedback?: Maybe<Ad_Creative_Feedback_Mutation_Response>;
  /** insert a single row into the table: "ad.creative_feedback" */
  insert_ad_creative_feedback_one?: Maybe<Ad_Creative_Feedback>;
  /** insert a single row into the table: "ad.creative" */
  insert_ad_creative_one?: Maybe<Ad_Creative>;
  /** insert data into the table: "ad.platform" */
  insert_ad_platform?: Maybe<Ad_Platform_Mutation_Response>;
  /** insert a single row into the table: "ad.platform" */
  insert_ad_platform_one?: Maybe<Ad_Platform>;
  /** insert data into the table: "ad.providers" */
  insert_ad_providers?: Maybe<Ad_Providers_Mutation_Response>;
  /** insert a single row into the table: "ad.providers" */
  insert_ad_providers_one?: Maybe<Ad_Providers>;
  /** insert data into the table: "ad.setting" */
  insert_ad_setting?: Maybe<Ad_Setting_Mutation_Response>;
  /** insert a single row into the table: "ad.setting" */
  insert_ad_setting_one?: Maybe<Ad_Setting>;
  /** insert data into the table: "ad.status" */
  insert_ad_status?: Maybe<Ad_Status_Mutation_Response>;
  /** insert a single row into the table: "ad.status" */
  insert_ad_status_one?: Maybe<Ad_Status>;
  /** insert data into the table: "anna_ai.call_campaigns" */
  insert_anna_ai_call_campaigns?: Maybe<Anna_Ai_Call_Campaigns_Mutation_Response>;
  /** insert a single row into the table: "anna_ai.call_campaigns" */
  insert_anna_ai_call_campaigns_one?: Maybe<Anna_Ai_Call_Campaigns>;
  /** insert data into the table: "anna_ai.call_states" */
  insert_anna_ai_call_states?: Maybe<Anna_Ai_Call_States_Mutation_Response>;
  /** insert a single row into the table: "anna_ai.call_states" */
  insert_anna_ai_call_states_one?: Maybe<Anna_Ai_Call_States>;
  /** insert data into the table: "anna_ai.outbound_calls" */
  insert_anna_ai_outbound_calls?: Maybe<Anna_Ai_Outbound_Calls_Mutation_Response>;
  /** insert a single row into the table: "anna_ai.outbound_calls" */
  insert_anna_ai_outbound_calls_one?: Maybe<Anna_Ai_Outbound_Calls>;
  /** insert data into the table: "answer" */
  insert_answer?: Maybe<Answer_Mutation_Response>;
  /** insert a single row into the table: "answer" */
  insert_answer_one?: Maybe<Answer>;
  /** insert data into the table: "applicant.event" */
  insert_applicant_event?: Maybe<Applicant_Event_Mutation_Response>;
  /** insert a single row into the table: "applicant.event" */
  insert_applicant_event_one?: Maybe<Applicant_Event>;
  /** insert data into the table: "board.column_type" */
  insert_board_column_type?: Maybe<Board_Column_Type_Mutation_Response>;
  /** insert a single row into the table: "board.column_type" */
  insert_board_column_type_one?: Maybe<Board_Column_Type>;
  /** insert data into the table: "board.contact_board" */
  insert_board_contact_board?: Maybe<Board_Contact_Board_Mutation_Response>;
  /** insert data into the table: "board.contact_board_column" */
  insert_board_contact_board_column?: Maybe<Board_Contact_Board_Column_Mutation_Response>;
  /** insert a single row into the table: "board.contact_board_column" */
  insert_board_contact_board_column_one?: Maybe<Board_Contact_Board_Column>;
  /** insert data into the table: "board.contact_board_entry" */
  insert_board_contact_board_entry?: Maybe<Board_Contact_Board_Entry_Mutation_Response>;
  /** insert a single row into the table: "board.contact_board_entry" */
  insert_board_contact_board_entry_one?: Maybe<Board_Contact_Board_Entry>;
  /** insert a single row into the table: "board.contact_board" */
  insert_board_contact_board_one?: Maybe<Board_Contact_Board>;
  /** insert data into the table: "board.note" */
  insert_board_note?: Maybe<Board_Note_Mutation_Response>;
  /** insert a single row into the table: "board.note" */
  insert_board_note_one?: Maybe<Board_Note>;
  /** insert data into the table: "bot.assignee" */
  insert_bot_assignee?: Maybe<Bot_Assignee_Mutation_Response>;
  /** insert a single row into the table: "bot.assignee" */
  insert_bot_assignee_one?: Maybe<Bot_Assignee>;
  /** insert data into the table: "bot.channel" */
  insert_bot_channel?: Maybe<Bot_Channel_Mutation_Response>;
  /** insert a single row into the table: "bot.channel" */
  insert_bot_channel_one?: Maybe<Bot_Channel>;
  /** insert data into the table: "bot.conversation" */
  insert_bot_conversation?: Maybe<Bot_Conversation_Mutation_Response>;
  /** insert a single row into the table: "bot.conversation" */
  insert_bot_conversation_one?: Maybe<Bot_Conversation>;
  /** insert data into the table: "bot.conversation_state" */
  insert_bot_conversation_state?: Maybe<Bot_Conversation_State_Mutation_Response>;
  /** insert a single row into the table: "bot.conversation_state" */
  insert_bot_conversation_state_one?: Maybe<Bot_Conversation_State>;
  /** insert data into the table: "bot.message" */
  insert_bot_message?: Maybe<Bot_Message_Mutation_Response>;
  /** insert a single row into the table: "bot.message" */
  insert_bot_message_one?: Maybe<Bot_Message>;
  /** insert data into the table: "bot.message_status" */
  insert_bot_message_status?: Maybe<Bot_Message_Status_Mutation_Response>;
  /** insert a single row into the table: "bot.message_status" */
  insert_bot_message_status_one?: Maybe<Bot_Message_Status>;
  /** insert data into the table: "bot.sender" */
  insert_bot_sender?: Maybe<Bot_Sender_Mutation_Response>;
  /** insert a single row into the table: "bot.sender" */
  insert_bot_sender_one?: Maybe<Bot_Sender>;
  /** insert data into the table: "campaign" */
  insert_campaign?: Maybe<Campaign_Mutation_Response>;
  /** insert data into the table: "campaign.ad" */
  insert_campaign_ad?: Maybe<Campaign_Ad_Mutation_Response>;
  /** insert a single row into the table: "campaign.ad" */
  insert_campaign_ad_one?: Maybe<Campaign_Ad>;
  /** insert data into the table: "campaign.budget" */
  insert_campaign_budget?: Maybe<Campaign_Budget_Mutation_Response>;
  /** insert a single row into the table: "campaign.budget" */
  insert_campaign_budget_one?: Maybe<Campaign_Budget>;
  /** insert data into the table: "campaign.budget_transaction" */
  insert_campaign_budget_transaction?: Maybe<Campaign_Budget_Transaction_Mutation_Response>;
  /** insert a single row into the table: "campaign.budget_transaction" */
  insert_campaign_budget_transaction_one?: Maybe<Campaign_Budget_Transaction>;
  /** insert data into the table: "campaign.email_template_overwrite" */
  insert_campaign_email_template_overwrite?: Maybe<Campaign_Email_Template_Overwrite_Mutation_Response>;
  /** insert a single row into the table: "campaign.email_template_overwrite" */
  insert_campaign_email_template_overwrite_one?: Maybe<Campaign_Email_Template_Overwrite>;
  /** insert data into the table: "campaign.event_log" */
  insert_campaign_event_log?: Maybe<Campaign_Event_Log_Mutation_Response>;
  /** insert a single row into the table: "campaign.event_log" */
  insert_campaign_event_log_one?: Maybe<Campaign_Event_Log>;
  /** insert data into the table: "campaign.iso_2_country_codes" */
  insert_campaign_iso_2_country_codes?: Maybe<Campaign_Iso_2_Country_Codes_Mutation_Response>;
  /** insert a single row into the table: "campaign.iso_2_country_codes" */
  insert_campaign_iso_2_country_codes_one?: Maybe<Campaign_Iso_2_Country_Codes>;
  /** insert data into the table: "campaign.job_description" */
  insert_campaign_job_description?: Maybe<Campaign_Job_Description_Mutation_Response>;
  /** insert a single row into the table: "campaign.job_description" */
  insert_campaign_job_description_one?: Maybe<Campaign_Job_Description>;
  /** insert a single row into the table: "campaign" */
  insert_campaign_one?: Maybe<Campaign>;
  /** insert data into the table: "campaign.order" */
  insert_campaign_order?: Maybe<Campaign_Order_Mutation_Response>;
  /** insert a single row into the table: "campaign.order" */
  insert_campaign_order_one?: Maybe<Campaign_Order>;
  /** insert data into the table: "campaign.order_source" */
  insert_campaign_order_source?: Maybe<Campaign_Order_Source_Mutation_Response>;
  /** insert a single row into the table: "campaign.order_source" */
  insert_campaign_order_source_one?: Maybe<Campaign_Order_Source>;
  /** insert data into the table: "campaign.order_source_type" */
  insert_campaign_order_source_type?: Maybe<Campaign_Order_Source_Type_Mutation_Response>;
  /** insert a single row into the table: "campaign.order_source_type" */
  insert_campaign_order_source_type_one?: Maybe<Campaign_Order_Source_Type>;
  /** insert data into the table: "campaign_routing.destination" */
  insert_campaign_routing_destination?: Maybe<Campaign_Routing_Destination_Mutation_Response>;
  /** insert a single row into the table: "campaign_routing.destination" */
  insert_campaign_routing_destination_one?: Maybe<Campaign_Routing_Destination>;
  /** insert data into the table: "campaign_routing.info" */
  insert_campaign_routing_info?: Maybe<Campaign_Routing_Info_Mutation_Response>;
  /** insert a single row into the table: "campaign_routing.info" */
  insert_campaign_routing_info_one?: Maybe<Campaign_Routing_Info>;
  /** insert data into the table: "campaign_routing.zipcode" */
  insert_campaign_routing_zipcode?: Maybe<Campaign_Routing_Zipcode_Mutation_Response>;
  /** insert a single row into the table: "campaign_routing.zipcode" */
  insert_campaign_routing_zipcode_one?: Maybe<Campaign_Routing_Zipcode>;
  /** insert data into the table: "campaign.settings_override" */
  insert_campaign_settings_override?: Maybe<Campaign_Settings_Override_Mutation_Response>;
  /** insert a single row into the table: "campaign.settings_override" */
  insert_campaign_settings_override_one?: Maybe<Campaign_Settings_Override>;
  /** insert data into the table: "campaign_status" */
  insert_campaign_status?: Maybe<Campaign_Status_Mutation_Response>;
  /** insert data into the table: "campaign.status_event" */
  insert_campaign_status_event?: Maybe<Campaign_Status_Event_Mutation_Response>;
  /** insert a single row into the table: "campaign.status_event" */
  insert_campaign_status_event_one?: Maybe<Campaign_Status_Event>;
  /** insert data into the table: "campaign.status_log" */
  insert_campaign_status_log?: Maybe<Campaign_Status_Log_Mutation_Response>;
  /** insert a single row into the table: "campaign.status_log" */
  insert_campaign_status_log_one?: Maybe<Campaign_Status_Log>;
  /** insert a single row into the table: "campaign_status" */
  insert_campaign_status_one?: Maybe<Campaign_Status>;
  /** insert data into the table: "campaign.transaction_type" */
  insert_campaign_transaction_type?: Maybe<Campaign_Transaction_Type_Mutation_Response>;
  /** insert a single row into the table: "campaign.transaction_type" */
  insert_campaign_transaction_type_one?: Maybe<Campaign_Transaction_Type>;
  /** insert data into the table: "campaign_work_location" */
  insert_campaign_work_location?: Maybe<Campaign_Work_Location_Mutation_Response>;
  /** insert a single row into the table: "campaign_work_location" */
  insert_campaign_work_location_one?: Maybe<Campaign_Work_Location>;
  /** insert data into the table: "chat_bot.customers" */
  insert_chat_bot_customers?: Maybe<Chat_Bot_Customers_Mutation_Response>;
  /** insert a single row into the table: "chat_bot.customers" */
  insert_chat_bot_customers_one?: Maybe<Chat_Bot_Customers>;
  /** insert data into the table: "chat_bot.forwarding" */
  insert_chat_bot_forwarding?: Maybe<Chat_Bot_Forwarding_Mutation_Response>;
  /** insert a single row into the table: "chat_bot.forwarding" */
  insert_chat_bot_forwarding_one?: Maybe<Chat_Bot_Forwarding>;
  /** insert data into the table: "chat_bot.message_type" */
  insert_chat_bot_message_type?: Maybe<Chat_Bot_Message_Type_Mutation_Response>;
  /** insert a single row into the table: "chat_bot.message_type" */
  insert_chat_bot_message_type_one?: Maybe<Chat_Bot_Message_Type>;
  /** insert data into the table: "chat_bot.messages" */
  insert_chat_bot_messages?: Maybe<Chat_Bot_Messages_Mutation_Response>;
  /** insert a single row into the table: "chat_bot.messages" */
  insert_chat_bot_messages_one?: Maybe<Chat_Bot_Messages>;
  /** insert data into the table: "contact" */
  insert_contact?: Maybe<Contact_Mutation_Response>;
  /** insert data into the table: "contact.logs" */
  insert_contact_logs?: Maybe<Contact_Logs_Mutation_Response>;
  /** insert a single row into the table: "contact.logs" */
  insert_contact_logs_one?: Maybe<Contact_Logs>;
  /** insert a single row into the table: "contact" */
  insert_contact_one?: Maybe<Contact>;
  /** insert data into the table: "file.pdf_templates" */
  insert_file_pdf_templates?: Maybe<File_Pdf_Templates_Mutation_Response>;
  /** insert a single row into the table: "file.pdf_templates" */
  insert_file_pdf_templates_one?: Maybe<File_Pdf_Templates>;
  /** insert data into the table: "file.upload" */
  insert_file_upload?: Maybe<File_Upload_Mutation_Response>;
  /** insert a single row into the table: "file.upload" */
  insert_file_upload_one?: Maybe<File_Upload>;
  /** insert data into the table: "funnel.benefits" */
  insert_funnel_benefits?: Maybe<Funnel_Benefits_Mutation_Response>;
  /** insert a single row into the table: "funnel.benefits" */
  insert_funnel_benefits_one?: Maybe<Funnel_Benefits>;
  /** insert data into the table: "funnel.chatbot_message" */
  insert_funnel_chatbot_message?: Maybe<Funnel_Chatbot_Message_Mutation_Response>;
  /** insert a single row into the table: "funnel.chatbot_message" */
  insert_funnel_chatbot_message_one?: Maybe<Funnel_Chatbot_Message>;
  /** insert data into the table: "funnel.chatbot_session" */
  insert_funnel_chatbot_session?: Maybe<Funnel_Chatbot_Session_Mutation_Response>;
  /** insert a single row into the table: "funnel.chatbot_session" */
  insert_funnel_chatbot_session_one?: Maybe<Funnel_Chatbot_Session>;
  /** insert data into the table: "funnel.funnels" */
  insert_funnel_funnels?: Maybe<Funnel_Funnels_Mutation_Response>;
  /** insert a single row into the table: "funnel.funnels" */
  insert_funnel_funnels_one?: Maybe<Funnel_Funnels>;
  /** insert data into the table: "funnel.insights" */
  insert_funnel_insights?: Maybe<Funnel_Insights_Mutation_Response>;
  /** insert a single row into the table: "funnel.insights" */
  insert_funnel_insights_one?: Maybe<Funnel_Insights>;
  /** insert data into the table: "funnel.page_insights" */
  insert_funnel_page_insights?: Maybe<Funnel_Page_Insights_Mutation_Response>;
  /** insert a single row into the table: "funnel.page_insights" */
  insert_funnel_page_insights_one?: Maybe<Funnel_Page_Insights>;
  /** insert data into the table: "funnel.question" */
  insert_funnel_question?: Maybe<Funnel_Question_Mutation_Response>;
  /** insert a single row into the table: "funnel.question" */
  insert_funnel_question_one?: Maybe<Funnel_Question>;
  /** insert data into the table: "funnel.question_option" */
  insert_funnel_question_option?: Maybe<Funnel_Question_Option_Mutation_Response>;
  /** insert a single row into the table: "funnel.question_option" */
  insert_funnel_question_option_one?: Maybe<Funnel_Question_Option>;
  /** insert data into the table: "funnel.whatsapp_share_clicks" */
  insert_funnel_whatsapp_share_clicks?: Maybe<Funnel_Whatsapp_Share_Clicks_Mutation_Response>;
  /** insert a single row into the table: "funnel.whatsapp_share_clicks" */
  insert_funnel_whatsapp_share_clicks_one?: Maybe<Funnel_Whatsapp_Share_Clicks>;
  /** insert data into the table: "organization" */
  insert_organization?: Maybe<Organization_Mutation_Response>;
  /** insert data into the table: "organization.location" */
  insert_organization_location?: Maybe<Organization_Location_Mutation_Response>;
  /** insert a single row into the table: "organization.location" */
  insert_organization_location_one?: Maybe<Organization_Location>;
  /** insert data into the table: "organization_name_prefix" */
  insert_organization_name_prefix?: Maybe<Organization_Name_Prefix_Mutation_Response>;
  /** insert a single row into the table: "organization_name_prefix" */
  insert_organization_name_prefix_one?: Maybe<Organization_Name_Prefix>;
  /** insert data into the table: "organization.news" */
  insert_organization_news?: Maybe<Organization_News_Mutation_Response>;
  /** insert a single row into the table: "organization.news" */
  insert_organization_news_one?: Maybe<Organization_News>;
  /** insert a single row into the table: "organization" */
  insert_organization_one?: Maybe<Organization>;
  /** insert data into the table: "organization.region" */
  insert_organization_region?: Maybe<Organization_Region_Mutation_Response>;
  /** insert a single row into the table: "organization.region" */
  insert_organization_region_one?: Maybe<Organization_Region>;
  /** insert data into the table: "organization.settings" */
  insert_organization_settings?: Maybe<Organization_Settings_Mutation_Response>;
  /** insert a single row into the table: "organization.settings" */
  insert_organization_settings_one?: Maybe<Organization_Settings>;
  /** insert data into the table: "perspective_campaign" */
  insert_perspective_campaign?: Maybe<Perspective_Campaign_Mutation_Response>;
  /** insert a single row into the table: "perspective_campaign" */
  insert_perspective_campaign_one?: Maybe<Perspective_Campaign>;
  /** insert data into the table: "qa_source" */
  insert_qa_source?: Maybe<Qa_Source_Mutation_Response>;
  /** insert a single row into the table: "qa_source" */
  insert_qa_source_one?: Maybe<Qa_Source>;
  /** insert data into the table: "rms.connectors" */
  insert_rms_connectors?: Maybe<Rms_Connectors_Mutation_Response>;
  /** insert a single row into the table: "rms.connectors" */
  insert_rms_connectors_one?: Maybe<Rms_Connectors>;
  /** insert data into the table: "rms.forwarded_logs" */
  insert_rms_forwarded_logs?: Maybe<Rms_Forwarded_Logs_Mutation_Response>;
  /** insert a single row into the table: "rms.forwarded_logs" */
  insert_rms_forwarded_logs_one?: Maybe<Rms_Forwarded_Logs>;
  /** insert data into the table: "rms.org_setups" */
  insert_rms_org_setups?: Maybe<Rms_Org_Setups_Mutation_Response>;
  /** insert a single row into the table: "rms.org_setups" */
  insert_rms_org_setups_one?: Maybe<Rms_Org_Setups>;
  /** insert data into the table: "system.api_keys" */
  insert_system_api_keys?: Maybe<System_Api_Keys_Mutation_Response>;
  /** insert a single row into the table: "system.api_keys" */
  insert_system_api_keys_one?: Maybe<System_Api_Keys>;
  /** insert data into the table: "system.call_daily_stats" */
  insert_system_call_daily_stats?: Maybe<System_Call_Daily_Stats_Mutation_Response>;
  /** insert a single row into the table: "system.call_daily_stats" */
  insert_system_call_daily_stats_one?: Maybe<System_Call_Daily_Stats>;
  /** insert data into the table: "system.email_daily_stats" */
  insert_system_email_daily_stats?: Maybe<System_Email_Daily_Stats_Mutation_Response>;
  /** insert a single row into the table: "system.email_daily_stats" */
  insert_system_email_daily_stats_one?: Maybe<System_Email_Daily_Stats>;
  /** insert data into the table: "system.running_release" */
  insert_system_running_release?: Maybe<System_Running_Release_Mutation_Response>;
  /** insert a single row into the table: "system.running_release" */
  insert_system_running_release_one?: Maybe<System_Running_Release>;
  /** insert data into the table: "system.sms_daily_stats" */
  insert_system_sms_daily_stats?: Maybe<System_Sms_Daily_Stats_Mutation_Response>;
  /** insert a single row into the table: "system.sms_daily_stats" */
  insert_system_sms_daily_stats_one?: Maybe<System_Sms_Daily_Stats>;
  /** update data of the table: "ad.campaign_metrics" */
  update_ad_campaign_metrics?: Maybe<Ad_Campaign_Metrics_Mutation_Response>;
  /** update single row of the table: "ad.campaign_metrics" */
  update_ad_campaign_metrics_by_pk?: Maybe<Ad_Campaign_Metrics>;
  /** update multiples rows of table: "ad.campaign_metrics" */
  update_ad_campaign_metrics_many?: Maybe<Array<Maybe<Ad_Campaign_Metrics_Mutation_Response>>>;
  /** update data of the table: "ad.comment" */
  update_ad_comment?: Maybe<Ad_Comment_Mutation_Response>;
  /** update single row of the table: "ad.comment" */
  update_ad_comment_by_pk?: Maybe<Ad_Comment>;
  /** update multiples rows of table: "ad.comment" */
  update_ad_comment_many?: Maybe<Array<Maybe<Ad_Comment_Mutation_Response>>>;
  /** update data of the table: "ad.creative" */
  update_ad_creative?: Maybe<Ad_Creative_Mutation_Response>;
  /** update single row of the table: "ad.creative" */
  update_ad_creative_by_pk?: Maybe<Ad_Creative>;
  /** update data of the table: "ad.creative_feedback" */
  update_ad_creative_feedback?: Maybe<Ad_Creative_Feedback_Mutation_Response>;
  /** update single row of the table: "ad.creative_feedback" */
  update_ad_creative_feedback_by_pk?: Maybe<Ad_Creative_Feedback>;
  /** update multiples rows of table: "ad.creative_feedback" */
  update_ad_creative_feedback_many?: Maybe<Array<Maybe<Ad_Creative_Feedback_Mutation_Response>>>;
  /** update multiples rows of table: "ad.creative" */
  update_ad_creative_many?: Maybe<Array<Maybe<Ad_Creative_Mutation_Response>>>;
  /** update data of the table: "ad.platform" */
  update_ad_platform?: Maybe<Ad_Platform_Mutation_Response>;
  /** update single row of the table: "ad.platform" */
  update_ad_platform_by_pk?: Maybe<Ad_Platform>;
  /** update multiples rows of table: "ad.platform" */
  update_ad_platform_many?: Maybe<Array<Maybe<Ad_Platform_Mutation_Response>>>;
  /** update data of the table: "ad.providers" */
  update_ad_providers?: Maybe<Ad_Providers_Mutation_Response>;
  /** update single row of the table: "ad.providers" */
  update_ad_providers_by_pk?: Maybe<Ad_Providers>;
  /** update multiples rows of table: "ad.providers" */
  update_ad_providers_many?: Maybe<Array<Maybe<Ad_Providers_Mutation_Response>>>;
  /** update data of the table: "ad.setting" */
  update_ad_setting?: Maybe<Ad_Setting_Mutation_Response>;
  /** update single row of the table: "ad.setting" */
  update_ad_setting_by_pk?: Maybe<Ad_Setting>;
  /** update multiples rows of table: "ad.setting" */
  update_ad_setting_many?: Maybe<Array<Maybe<Ad_Setting_Mutation_Response>>>;
  /** update data of the table: "ad.status" */
  update_ad_status?: Maybe<Ad_Status_Mutation_Response>;
  /** update single row of the table: "ad.status" */
  update_ad_status_by_pk?: Maybe<Ad_Status>;
  /** update multiples rows of table: "ad.status" */
  update_ad_status_many?: Maybe<Array<Maybe<Ad_Status_Mutation_Response>>>;
  /** update data of the table: "anna_ai.call_campaigns" */
  update_anna_ai_call_campaigns?: Maybe<Anna_Ai_Call_Campaigns_Mutation_Response>;
  /** update single row of the table: "anna_ai.call_campaigns" */
  update_anna_ai_call_campaigns_by_pk?: Maybe<Anna_Ai_Call_Campaigns>;
  /** update multiples rows of table: "anna_ai.call_campaigns" */
  update_anna_ai_call_campaigns_many?: Maybe<Array<Maybe<Anna_Ai_Call_Campaigns_Mutation_Response>>>;
  /** update data of the table: "anna_ai.call_states" */
  update_anna_ai_call_states?: Maybe<Anna_Ai_Call_States_Mutation_Response>;
  /** update single row of the table: "anna_ai.call_states" */
  update_anna_ai_call_states_by_pk?: Maybe<Anna_Ai_Call_States>;
  /** update multiples rows of table: "anna_ai.call_states" */
  update_anna_ai_call_states_many?: Maybe<Array<Maybe<Anna_Ai_Call_States_Mutation_Response>>>;
  /** update data of the table: "anna_ai.outbound_calls" */
  update_anna_ai_outbound_calls?: Maybe<Anna_Ai_Outbound_Calls_Mutation_Response>;
  /** update single row of the table: "anna_ai.outbound_calls" */
  update_anna_ai_outbound_calls_by_pk?: Maybe<Anna_Ai_Outbound_Calls>;
  /** update multiples rows of table: "anna_ai.outbound_calls" */
  update_anna_ai_outbound_calls_many?: Maybe<Array<Maybe<Anna_Ai_Outbound_Calls_Mutation_Response>>>;
  /** update data of the table: "answer" */
  update_answer?: Maybe<Answer_Mutation_Response>;
  /** update single row of the table: "answer" */
  update_answer_by_pk?: Maybe<Answer>;
  /** update multiples rows of table: "answer" */
  update_answer_many?: Maybe<Array<Maybe<Answer_Mutation_Response>>>;
  /** update data of the table: "applicant.event" */
  update_applicant_event?: Maybe<Applicant_Event_Mutation_Response>;
  /** update single row of the table: "applicant.event" */
  update_applicant_event_by_pk?: Maybe<Applicant_Event>;
  /** update multiples rows of table: "applicant.event" */
  update_applicant_event_many?: Maybe<Array<Maybe<Applicant_Event_Mutation_Response>>>;
  /** update data of the table: "board.column_type" */
  update_board_column_type?: Maybe<Board_Column_Type_Mutation_Response>;
  /** update single row of the table: "board.column_type" */
  update_board_column_type_by_pk?: Maybe<Board_Column_Type>;
  /** update multiples rows of table: "board.column_type" */
  update_board_column_type_many?: Maybe<Array<Maybe<Board_Column_Type_Mutation_Response>>>;
  /** update data of the table: "board.contact_board" */
  update_board_contact_board?: Maybe<Board_Contact_Board_Mutation_Response>;
  /** update single row of the table: "board.contact_board" */
  update_board_contact_board_by_pk?: Maybe<Board_Contact_Board>;
  /** update data of the table: "board.contact_board_column" */
  update_board_contact_board_column?: Maybe<Board_Contact_Board_Column_Mutation_Response>;
  /** update single row of the table: "board.contact_board_column" */
  update_board_contact_board_column_by_pk?: Maybe<Board_Contact_Board_Column>;
  /** update multiples rows of table: "board.contact_board_column" */
  update_board_contact_board_column_many?: Maybe<Array<Maybe<Board_Contact_Board_Column_Mutation_Response>>>;
  /** update data of the table: "board.contact_board_entry" */
  update_board_contact_board_entry?: Maybe<Board_Contact_Board_Entry_Mutation_Response>;
  /** update single row of the table: "board.contact_board_entry" */
  update_board_contact_board_entry_by_pk?: Maybe<Board_Contact_Board_Entry>;
  /** update multiples rows of table: "board.contact_board_entry" */
  update_board_contact_board_entry_many?: Maybe<Array<Maybe<Board_Contact_Board_Entry_Mutation_Response>>>;
  /** update multiples rows of table: "board.contact_board" */
  update_board_contact_board_many?: Maybe<Array<Maybe<Board_Contact_Board_Mutation_Response>>>;
  /** update data of the table: "board.note" */
  update_board_note?: Maybe<Board_Note_Mutation_Response>;
  /** update single row of the table: "board.note" */
  update_board_note_by_pk?: Maybe<Board_Note>;
  /** update multiples rows of table: "board.note" */
  update_board_note_many?: Maybe<Array<Maybe<Board_Note_Mutation_Response>>>;
  /** update data of the table: "bot.assignee" */
  update_bot_assignee?: Maybe<Bot_Assignee_Mutation_Response>;
  /** update single row of the table: "bot.assignee" */
  update_bot_assignee_by_pk?: Maybe<Bot_Assignee>;
  /** update multiples rows of table: "bot.assignee" */
  update_bot_assignee_many?: Maybe<Array<Maybe<Bot_Assignee_Mutation_Response>>>;
  /** update data of the table: "bot.channel" */
  update_bot_channel?: Maybe<Bot_Channel_Mutation_Response>;
  /** update single row of the table: "bot.channel" */
  update_bot_channel_by_pk?: Maybe<Bot_Channel>;
  /** update multiples rows of table: "bot.channel" */
  update_bot_channel_many?: Maybe<Array<Maybe<Bot_Channel_Mutation_Response>>>;
  /** update data of the table: "bot.conversation" */
  update_bot_conversation?: Maybe<Bot_Conversation_Mutation_Response>;
  /** update single row of the table: "bot.conversation" */
  update_bot_conversation_by_pk?: Maybe<Bot_Conversation>;
  /** update multiples rows of table: "bot.conversation" */
  update_bot_conversation_many?: Maybe<Array<Maybe<Bot_Conversation_Mutation_Response>>>;
  /** update data of the table: "bot.conversation_state" */
  update_bot_conversation_state?: Maybe<Bot_Conversation_State_Mutation_Response>;
  /** update single row of the table: "bot.conversation_state" */
  update_bot_conversation_state_by_pk?: Maybe<Bot_Conversation_State>;
  /** update multiples rows of table: "bot.conversation_state" */
  update_bot_conversation_state_many?: Maybe<Array<Maybe<Bot_Conversation_State_Mutation_Response>>>;
  /** update data of the table: "bot.message" */
  update_bot_message?: Maybe<Bot_Message_Mutation_Response>;
  /** update single row of the table: "bot.message" */
  update_bot_message_by_pk?: Maybe<Bot_Message>;
  /** update multiples rows of table: "bot.message" */
  update_bot_message_many?: Maybe<Array<Maybe<Bot_Message_Mutation_Response>>>;
  /** update data of the table: "bot.message_status" */
  update_bot_message_status?: Maybe<Bot_Message_Status_Mutation_Response>;
  /** update single row of the table: "bot.message_status" */
  update_bot_message_status_by_pk?: Maybe<Bot_Message_Status>;
  /** update multiples rows of table: "bot.message_status" */
  update_bot_message_status_many?: Maybe<Array<Maybe<Bot_Message_Status_Mutation_Response>>>;
  /** update data of the table: "bot.sender" */
  update_bot_sender?: Maybe<Bot_Sender_Mutation_Response>;
  /** update single row of the table: "bot.sender" */
  update_bot_sender_by_pk?: Maybe<Bot_Sender>;
  /** update multiples rows of table: "bot.sender" */
  update_bot_sender_many?: Maybe<Array<Maybe<Bot_Sender_Mutation_Response>>>;
  /** update data of the table: "campaign" */
  update_campaign?: Maybe<Campaign_Mutation_Response>;
  /** update data of the table: "campaign.ad" */
  update_campaign_ad?: Maybe<Campaign_Ad_Mutation_Response>;
  /** update single row of the table: "campaign.ad" */
  update_campaign_ad_by_pk?: Maybe<Campaign_Ad>;
  /** update multiples rows of table: "campaign.ad" */
  update_campaign_ad_many?: Maybe<Array<Maybe<Campaign_Ad_Mutation_Response>>>;
  /** update data of the table: "campaign.budget" */
  update_campaign_budget?: Maybe<Campaign_Budget_Mutation_Response>;
  /** update multiples rows of table: "campaign.budget" */
  update_campaign_budget_many?: Maybe<Array<Maybe<Campaign_Budget_Mutation_Response>>>;
  /** update data of the table: "campaign.budget_transaction" */
  update_campaign_budget_transaction?: Maybe<Campaign_Budget_Transaction_Mutation_Response>;
  /** update single row of the table: "campaign.budget_transaction" */
  update_campaign_budget_transaction_by_pk?: Maybe<Campaign_Budget_Transaction>;
  /** update multiples rows of table: "campaign.budget_transaction" */
  update_campaign_budget_transaction_many?: Maybe<Array<Maybe<Campaign_Budget_Transaction_Mutation_Response>>>;
  /** update single row of the table: "campaign" */
  update_campaign_by_pk?: Maybe<Campaign>;
  /** update data of the table: "campaign.email_template_overwrite" */
  update_campaign_email_template_overwrite?: Maybe<Campaign_Email_Template_Overwrite_Mutation_Response>;
  /** update single row of the table: "campaign.email_template_overwrite" */
  update_campaign_email_template_overwrite_by_pk?: Maybe<Campaign_Email_Template_Overwrite>;
  /** update multiples rows of table: "campaign.email_template_overwrite" */
  update_campaign_email_template_overwrite_many?: Maybe<Array<Maybe<Campaign_Email_Template_Overwrite_Mutation_Response>>>;
  /** update data of the table: "campaign.event_log" */
  update_campaign_event_log?: Maybe<Campaign_Event_Log_Mutation_Response>;
  /** update single row of the table: "campaign.event_log" */
  update_campaign_event_log_by_pk?: Maybe<Campaign_Event_Log>;
  /** update multiples rows of table: "campaign.event_log" */
  update_campaign_event_log_many?: Maybe<Array<Maybe<Campaign_Event_Log_Mutation_Response>>>;
  /** update data of the table: "campaign.iso_2_country_codes" */
  update_campaign_iso_2_country_codes?: Maybe<Campaign_Iso_2_Country_Codes_Mutation_Response>;
  /** update single row of the table: "campaign.iso_2_country_codes" */
  update_campaign_iso_2_country_codes_by_pk?: Maybe<Campaign_Iso_2_Country_Codes>;
  /** update multiples rows of table: "campaign.iso_2_country_codes" */
  update_campaign_iso_2_country_codes_many?: Maybe<Array<Maybe<Campaign_Iso_2_Country_Codes_Mutation_Response>>>;
  /** update data of the table: "campaign.job_description" */
  update_campaign_job_description?: Maybe<Campaign_Job_Description_Mutation_Response>;
  /** update single row of the table: "campaign.job_description" */
  update_campaign_job_description_by_pk?: Maybe<Campaign_Job_Description>;
  /** update multiples rows of table: "campaign.job_description" */
  update_campaign_job_description_many?: Maybe<Array<Maybe<Campaign_Job_Description_Mutation_Response>>>;
  /** update multiples rows of table: "campaign" */
  update_campaign_many?: Maybe<Array<Maybe<Campaign_Mutation_Response>>>;
  /** update data of the table: "campaign.order" */
  update_campaign_order?: Maybe<Campaign_Order_Mutation_Response>;
  /** update single row of the table: "campaign.order" */
  update_campaign_order_by_pk?: Maybe<Campaign_Order>;
  /** update multiples rows of table: "campaign.order" */
  update_campaign_order_many?: Maybe<Array<Maybe<Campaign_Order_Mutation_Response>>>;
  /** update data of the table: "campaign.order_source" */
  update_campaign_order_source?: Maybe<Campaign_Order_Source_Mutation_Response>;
  /** update single row of the table: "campaign.order_source" */
  update_campaign_order_source_by_pk?: Maybe<Campaign_Order_Source>;
  /** update multiples rows of table: "campaign.order_source" */
  update_campaign_order_source_many?: Maybe<Array<Maybe<Campaign_Order_Source_Mutation_Response>>>;
  /** update data of the table: "campaign.order_source_type" */
  update_campaign_order_source_type?: Maybe<Campaign_Order_Source_Type_Mutation_Response>;
  /** update single row of the table: "campaign.order_source_type" */
  update_campaign_order_source_type_by_pk?: Maybe<Campaign_Order_Source_Type>;
  /** update multiples rows of table: "campaign.order_source_type" */
  update_campaign_order_source_type_many?: Maybe<Array<Maybe<Campaign_Order_Source_Type_Mutation_Response>>>;
  /** update data of the table: "campaign_routing.destination" */
  update_campaign_routing_destination?: Maybe<Campaign_Routing_Destination_Mutation_Response>;
  /** update single row of the table: "campaign_routing.destination" */
  update_campaign_routing_destination_by_pk?: Maybe<Campaign_Routing_Destination>;
  /** update multiples rows of table: "campaign_routing.destination" */
  update_campaign_routing_destination_many?: Maybe<Array<Maybe<Campaign_Routing_Destination_Mutation_Response>>>;
  /** update data of the table: "campaign_routing.info" */
  update_campaign_routing_info?: Maybe<Campaign_Routing_Info_Mutation_Response>;
  /** update single row of the table: "campaign_routing.info" */
  update_campaign_routing_info_by_pk?: Maybe<Campaign_Routing_Info>;
  /** update multiples rows of table: "campaign_routing.info" */
  update_campaign_routing_info_many?: Maybe<Array<Maybe<Campaign_Routing_Info_Mutation_Response>>>;
  /** update data of the table: "campaign_routing.zipcode" */
  update_campaign_routing_zipcode?: Maybe<Campaign_Routing_Zipcode_Mutation_Response>;
  /** update single row of the table: "campaign_routing.zipcode" */
  update_campaign_routing_zipcode_by_pk?: Maybe<Campaign_Routing_Zipcode>;
  /** update multiples rows of table: "campaign_routing.zipcode" */
  update_campaign_routing_zipcode_many?: Maybe<Array<Maybe<Campaign_Routing_Zipcode_Mutation_Response>>>;
  /** update data of the table: "campaign.settings_override" */
  update_campaign_settings_override?: Maybe<Campaign_Settings_Override_Mutation_Response>;
  /** update single row of the table: "campaign.settings_override" */
  update_campaign_settings_override_by_pk?: Maybe<Campaign_Settings_Override>;
  /** update multiples rows of table: "campaign.settings_override" */
  update_campaign_settings_override_many?: Maybe<Array<Maybe<Campaign_Settings_Override_Mutation_Response>>>;
  /** update data of the table: "campaign_status" */
  update_campaign_status?: Maybe<Campaign_Status_Mutation_Response>;
  /** update single row of the table: "campaign_status" */
  update_campaign_status_by_pk?: Maybe<Campaign_Status>;
  /** update data of the table: "campaign.status_event" */
  update_campaign_status_event?: Maybe<Campaign_Status_Event_Mutation_Response>;
  /** update single row of the table: "campaign.status_event" */
  update_campaign_status_event_by_pk?: Maybe<Campaign_Status_Event>;
  /** update multiples rows of table: "campaign.status_event" */
  update_campaign_status_event_many?: Maybe<Array<Maybe<Campaign_Status_Event_Mutation_Response>>>;
  /** update data of the table: "campaign.status_log" */
  update_campaign_status_log?: Maybe<Campaign_Status_Log_Mutation_Response>;
  /** update single row of the table: "campaign.status_log" */
  update_campaign_status_log_by_pk?: Maybe<Campaign_Status_Log>;
  /** update multiples rows of table: "campaign.status_log" */
  update_campaign_status_log_many?: Maybe<Array<Maybe<Campaign_Status_Log_Mutation_Response>>>;
  /** update multiples rows of table: "campaign_status" */
  update_campaign_status_many?: Maybe<Array<Maybe<Campaign_Status_Mutation_Response>>>;
  /** update data of the table: "campaign.transaction_type" */
  update_campaign_transaction_type?: Maybe<Campaign_Transaction_Type_Mutation_Response>;
  /** update single row of the table: "campaign.transaction_type" */
  update_campaign_transaction_type_by_pk?: Maybe<Campaign_Transaction_Type>;
  /** update multiples rows of table: "campaign.transaction_type" */
  update_campaign_transaction_type_many?: Maybe<Array<Maybe<Campaign_Transaction_Type_Mutation_Response>>>;
  /** update data of the table: "campaign_work_location" */
  update_campaign_work_location?: Maybe<Campaign_Work_Location_Mutation_Response>;
  /** update single row of the table: "campaign_work_location" */
  update_campaign_work_location_by_pk?: Maybe<Campaign_Work_Location>;
  /** update multiples rows of table: "campaign_work_location" */
  update_campaign_work_location_many?: Maybe<Array<Maybe<Campaign_Work_Location_Mutation_Response>>>;
  /** update data of the table: "chat_bot.customers" */
  update_chat_bot_customers?: Maybe<Chat_Bot_Customers_Mutation_Response>;
  /** update single row of the table: "chat_bot.customers" */
  update_chat_bot_customers_by_pk?: Maybe<Chat_Bot_Customers>;
  /** update multiples rows of table: "chat_bot.customers" */
  update_chat_bot_customers_many?: Maybe<Array<Maybe<Chat_Bot_Customers_Mutation_Response>>>;
  /** update data of the table: "chat_bot.forwarding" */
  update_chat_bot_forwarding?: Maybe<Chat_Bot_Forwarding_Mutation_Response>;
  /** update single row of the table: "chat_bot.forwarding" */
  update_chat_bot_forwarding_by_pk?: Maybe<Chat_Bot_Forwarding>;
  /** update multiples rows of table: "chat_bot.forwarding" */
  update_chat_bot_forwarding_many?: Maybe<Array<Maybe<Chat_Bot_Forwarding_Mutation_Response>>>;
  /** update data of the table: "chat_bot.message_type" */
  update_chat_bot_message_type?: Maybe<Chat_Bot_Message_Type_Mutation_Response>;
  /** update single row of the table: "chat_bot.message_type" */
  update_chat_bot_message_type_by_pk?: Maybe<Chat_Bot_Message_Type>;
  /** update multiples rows of table: "chat_bot.message_type" */
  update_chat_bot_message_type_many?: Maybe<Array<Maybe<Chat_Bot_Message_Type_Mutation_Response>>>;
  /** update data of the table: "chat_bot.messages" */
  update_chat_bot_messages?: Maybe<Chat_Bot_Messages_Mutation_Response>;
  /** update single row of the table: "chat_bot.messages" */
  update_chat_bot_messages_by_pk?: Maybe<Chat_Bot_Messages>;
  /** update multiples rows of table: "chat_bot.messages" */
  update_chat_bot_messages_many?: Maybe<Array<Maybe<Chat_Bot_Messages_Mutation_Response>>>;
  /** update data of the table: "contact" */
  update_contact?: Maybe<Contact_Mutation_Response>;
  /** update single row of the table: "contact" */
  update_contact_by_pk?: Maybe<Contact>;
  /** update data of the table: "contact.logs" */
  update_contact_logs?: Maybe<Contact_Logs_Mutation_Response>;
  /** update single row of the table: "contact.logs" */
  update_contact_logs_by_pk?: Maybe<Contact_Logs>;
  /** update multiples rows of table: "contact.logs" */
  update_contact_logs_many?: Maybe<Array<Maybe<Contact_Logs_Mutation_Response>>>;
  /** update multiples rows of table: "contact" */
  update_contact_many?: Maybe<Array<Maybe<Contact_Mutation_Response>>>;
  /** update data of the table: "file.pdf_templates" */
  update_file_pdf_templates?: Maybe<File_Pdf_Templates_Mutation_Response>;
  /** update single row of the table: "file.pdf_templates" */
  update_file_pdf_templates_by_pk?: Maybe<File_Pdf_Templates>;
  /** update multiples rows of table: "file.pdf_templates" */
  update_file_pdf_templates_many?: Maybe<Array<Maybe<File_Pdf_Templates_Mutation_Response>>>;
  /** update data of the table: "file.upload" */
  update_file_upload?: Maybe<File_Upload_Mutation_Response>;
  /** update single row of the table: "file.upload" */
  update_file_upload_by_pk?: Maybe<File_Upload>;
  /** update multiples rows of table: "file.upload" */
  update_file_upload_many?: Maybe<Array<Maybe<File_Upload_Mutation_Response>>>;
  /** update data of the table: "funnel.benefits" */
  update_funnel_benefits?: Maybe<Funnel_Benefits_Mutation_Response>;
  /** update single row of the table: "funnel.benefits" */
  update_funnel_benefits_by_pk?: Maybe<Funnel_Benefits>;
  /** update multiples rows of table: "funnel.benefits" */
  update_funnel_benefits_many?: Maybe<Array<Maybe<Funnel_Benefits_Mutation_Response>>>;
  /** update data of the table: "funnel.chatbot_message" */
  update_funnel_chatbot_message?: Maybe<Funnel_Chatbot_Message_Mutation_Response>;
  /** update single row of the table: "funnel.chatbot_message" */
  update_funnel_chatbot_message_by_pk?: Maybe<Funnel_Chatbot_Message>;
  /** update multiples rows of table: "funnel.chatbot_message" */
  update_funnel_chatbot_message_many?: Maybe<Array<Maybe<Funnel_Chatbot_Message_Mutation_Response>>>;
  /** update data of the table: "funnel.chatbot_session" */
  update_funnel_chatbot_session?: Maybe<Funnel_Chatbot_Session_Mutation_Response>;
  /** update single row of the table: "funnel.chatbot_session" */
  update_funnel_chatbot_session_by_pk?: Maybe<Funnel_Chatbot_Session>;
  /** update multiples rows of table: "funnel.chatbot_session" */
  update_funnel_chatbot_session_many?: Maybe<Array<Maybe<Funnel_Chatbot_Session_Mutation_Response>>>;
  /** update data of the table: "funnel.funnels" */
  update_funnel_funnels?: Maybe<Funnel_Funnels_Mutation_Response>;
  /** update single row of the table: "funnel.funnels" */
  update_funnel_funnels_by_pk?: Maybe<Funnel_Funnels>;
  /** update multiples rows of table: "funnel.funnels" */
  update_funnel_funnels_many?: Maybe<Array<Maybe<Funnel_Funnels_Mutation_Response>>>;
  /** update data of the table: "funnel.insights" */
  update_funnel_insights?: Maybe<Funnel_Insights_Mutation_Response>;
  /** update multiples rows of table: "funnel.insights" */
  update_funnel_insights_many?: Maybe<Array<Maybe<Funnel_Insights_Mutation_Response>>>;
  /** update data of the table: "funnel.page_insights" */
  update_funnel_page_insights?: Maybe<Funnel_Page_Insights_Mutation_Response>;
  /** update single row of the table: "funnel.page_insights" */
  update_funnel_page_insights_by_pk?: Maybe<Funnel_Page_Insights>;
  /** update multiples rows of table: "funnel.page_insights" */
  update_funnel_page_insights_many?: Maybe<Array<Maybe<Funnel_Page_Insights_Mutation_Response>>>;
  /** update data of the table: "funnel.question" */
  update_funnel_question?: Maybe<Funnel_Question_Mutation_Response>;
  /** update single row of the table: "funnel.question" */
  update_funnel_question_by_pk?: Maybe<Funnel_Question>;
  /** update multiples rows of table: "funnel.question" */
  update_funnel_question_many?: Maybe<Array<Maybe<Funnel_Question_Mutation_Response>>>;
  /** update data of the table: "funnel.question_option" */
  update_funnel_question_option?: Maybe<Funnel_Question_Option_Mutation_Response>;
  /** update single row of the table: "funnel.question_option" */
  update_funnel_question_option_by_pk?: Maybe<Funnel_Question_Option>;
  /** update multiples rows of table: "funnel.question_option" */
  update_funnel_question_option_many?: Maybe<Array<Maybe<Funnel_Question_Option_Mutation_Response>>>;
  /** update data of the table: "funnel.whatsapp_share_clicks" */
  update_funnel_whatsapp_share_clicks?: Maybe<Funnel_Whatsapp_Share_Clicks_Mutation_Response>;
  /** update single row of the table: "funnel.whatsapp_share_clicks" */
  update_funnel_whatsapp_share_clicks_by_pk?: Maybe<Funnel_Whatsapp_Share_Clicks>;
  /** update multiples rows of table: "funnel.whatsapp_share_clicks" */
  update_funnel_whatsapp_share_clicks_many?: Maybe<Array<Maybe<Funnel_Whatsapp_Share_Clicks_Mutation_Response>>>;
  /** update data of the table: "organization" */
  update_organization?: Maybe<Organization_Mutation_Response>;
  /** update single row of the table: "organization" */
  update_organization_by_pk?: Maybe<Organization>;
  /** update data of the table: "organization.location" */
  update_organization_location?: Maybe<Organization_Location_Mutation_Response>;
  /** update single row of the table: "organization.location" */
  update_organization_location_by_pk?: Maybe<Organization_Location>;
  /** update multiples rows of table: "organization.location" */
  update_organization_location_many?: Maybe<Array<Maybe<Organization_Location_Mutation_Response>>>;
  /** update multiples rows of table: "organization" */
  update_organization_many?: Maybe<Array<Maybe<Organization_Mutation_Response>>>;
  /** update data of the table: "organization_name_prefix" */
  update_organization_name_prefix?: Maybe<Organization_Name_Prefix_Mutation_Response>;
  /** update single row of the table: "organization_name_prefix" */
  update_organization_name_prefix_by_pk?: Maybe<Organization_Name_Prefix>;
  /** update multiples rows of table: "organization_name_prefix" */
  update_organization_name_prefix_many?: Maybe<Array<Maybe<Organization_Name_Prefix_Mutation_Response>>>;
  /** update data of the table: "organization.news" */
  update_organization_news?: Maybe<Organization_News_Mutation_Response>;
  /** update single row of the table: "organization.news" */
  update_organization_news_by_pk?: Maybe<Organization_News>;
  /** update multiples rows of table: "organization.news" */
  update_organization_news_many?: Maybe<Array<Maybe<Organization_News_Mutation_Response>>>;
  /** update data of the table: "organization.region" */
  update_organization_region?: Maybe<Organization_Region_Mutation_Response>;
  /** update single row of the table: "organization.region" */
  update_organization_region_by_pk?: Maybe<Organization_Region>;
  /** update multiples rows of table: "organization.region" */
  update_organization_region_many?: Maybe<Array<Maybe<Organization_Region_Mutation_Response>>>;
  /** update data of the table: "organization.settings" */
  update_organization_settings?: Maybe<Organization_Settings_Mutation_Response>;
  /** update single row of the table: "organization.settings" */
  update_organization_settings_by_pk?: Maybe<Organization_Settings>;
  /** update multiples rows of table: "organization.settings" */
  update_organization_settings_many?: Maybe<Array<Maybe<Organization_Settings_Mutation_Response>>>;
  /** update data of the table: "perspective_campaign" */
  update_perspective_campaign?: Maybe<Perspective_Campaign_Mutation_Response>;
  /** update single row of the table: "perspective_campaign" */
  update_perspective_campaign_by_pk?: Maybe<Perspective_Campaign>;
  /** update multiples rows of table: "perspective_campaign" */
  update_perspective_campaign_many?: Maybe<Array<Maybe<Perspective_Campaign_Mutation_Response>>>;
  /** update data of the table: "qa_source" */
  update_qa_source?: Maybe<Qa_Source_Mutation_Response>;
  /** update single row of the table: "qa_source" */
  update_qa_source_by_pk?: Maybe<Qa_Source>;
  /** update multiples rows of table: "qa_source" */
  update_qa_source_many?: Maybe<Array<Maybe<Qa_Source_Mutation_Response>>>;
  /** update data of the table: "rms.connectors" */
  update_rms_connectors?: Maybe<Rms_Connectors_Mutation_Response>;
  /** update single row of the table: "rms.connectors" */
  update_rms_connectors_by_pk?: Maybe<Rms_Connectors>;
  /** update multiples rows of table: "rms.connectors" */
  update_rms_connectors_many?: Maybe<Array<Maybe<Rms_Connectors_Mutation_Response>>>;
  /** update data of the table: "rms.forwarded_logs" */
  update_rms_forwarded_logs?: Maybe<Rms_Forwarded_Logs_Mutation_Response>;
  /** update single row of the table: "rms.forwarded_logs" */
  update_rms_forwarded_logs_by_pk?: Maybe<Rms_Forwarded_Logs>;
  /** update multiples rows of table: "rms.forwarded_logs" */
  update_rms_forwarded_logs_many?: Maybe<Array<Maybe<Rms_Forwarded_Logs_Mutation_Response>>>;
  /** update data of the table: "rms.org_setups" */
  update_rms_org_setups?: Maybe<Rms_Org_Setups_Mutation_Response>;
  /** update single row of the table: "rms.org_setups" */
  update_rms_org_setups_by_pk?: Maybe<Rms_Org_Setups>;
  /** update multiples rows of table: "rms.org_setups" */
  update_rms_org_setups_many?: Maybe<Array<Maybe<Rms_Org_Setups_Mutation_Response>>>;
  /** update data of the table: "system.api_keys" */
  update_system_api_keys?: Maybe<System_Api_Keys_Mutation_Response>;
  /** update single row of the table: "system.api_keys" */
  update_system_api_keys_by_pk?: Maybe<System_Api_Keys>;
  /** update multiples rows of table: "system.api_keys" */
  update_system_api_keys_many?: Maybe<Array<Maybe<System_Api_Keys_Mutation_Response>>>;
  /** update data of the table: "system.call_daily_stats" */
  update_system_call_daily_stats?: Maybe<System_Call_Daily_Stats_Mutation_Response>;
  /** update single row of the table: "system.call_daily_stats" */
  update_system_call_daily_stats_by_pk?: Maybe<System_Call_Daily_Stats>;
  /** update multiples rows of table: "system.call_daily_stats" */
  update_system_call_daily_stats_many?: Maybe<Array<Maybe<System_Call_Daily_Stats_Mutation_Response>>>;
  /** update data of the table: "system.email_daily_stats" */
  update_system_email_daily_stats?: Maybe<System_Email_Daily_Stats_Mutation_Response>;
  /** update single row of the table: "system.email_daily_stats" */
  update_system_email_daily_stats_by_pk?: Maybe<System_Email_Daily_Stats>;
  /** update multiples rows of table: "system.email_daily_stats" */
  update_system_email_daily_stats_many?: Maybe<Array<Maybe<System_Email_Daily_Stats_Mutation_Response>>>;
  /** update data of the table: "system.running_release" */
  update_system_running_release?: Maybe<System_Running_Release_Mutation_Response>;
  /** update single row of the table: "system.running_release" */
  update_system_running_release_by_pk?: Maybe<System_Running_Release>;
  /** update multiples rows of table: "system.running_release" */
  update_system_running_release_many?: Maybe<Array<Maybe<System_Running_Release_Mutation_Response>>>;
  /** update data of the table: "system.sms_daily_stats" */
  update_system_sms_daily_stats?: Maybe<System_Sms_Daily_Stats_Mutation_Response>;
  /** update single row of the table: "system.sms_daily_stats" */
  update_system_sms_daily_stats_by_pk?: Maybe<System_Sms_Daily_Stats>;
  /** update multiples rows of table: "system.sms_daily_stats" */
  update_system_sms_daily_stats_many?: Maybe<Array<Maybe<System_Sms_Daily_Stats_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Campaign_MetricsArgs = {
  where: Ad_Campaign_Metrics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Campaign_Metrics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_CommentArgs = {
  where: Ad_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Comment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_CreativeArgs = {
  where: Ad_Creative_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Creative_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_Creative_FeedbackArgs = {
  where: Ad_Creative_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Creative_Feedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_PlatformArgs = {
  where: Ad_Platform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Platform_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_ProvidersArgs = {
  where: Ad_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Providers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_SettingArgs = {
  where: Ad_Setting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Setting_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_StatusArgs = {
  where: Ad_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Anna_Ai_Call_CampaignsArgs = {
  where: Anna_Ai_Call_Campaigns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anna_Ai_Call_Campaigns_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Anna_Ai_Call_StatesArgs = {
  where: Anna_Ai_Call_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anna_Ai_Call_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Anna_Ai_Outbound_CallsArgs = {
  where: Anna_Ai_Outbound_Calls_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anna_Ai_Outbound_Calls_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AnswerArgs = {
  where: Answer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Answer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Applicant_EventArgs = {
  where: Applicant_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Applicant_Event_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Board_Column_TypeArgs = {
  where: Board_Column_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Board_Column_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Board_Contact_BoardArgs = {
  where: Board_Contact_Board_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Board_Contact_Board_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Board_Contact_Board_ColumnArgs = {
  where: Board_Contact_Board_Column_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Board_Contact_Board_Column_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Board_Contact_Board_EntryArgs = {
  where: Board_Contact_Board_Entry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Board_Contact_Board_Entry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Board_NoteArgs = {
  where: Board_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Board_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bot_AssigneeArgs = {
  where: Bot_Assignee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bot_Assignee_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bot_ChannelArgs = {
  where: Bot_Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bot_Channel_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bot_ConversationArgs = {
  where: Bot_Conversation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bot_Conversation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bot_Conversation_StateArgs = {
  where: Bot_Conversation_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bot_Conversation_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bot_MessageArgs = {
  where: Bot_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bot_Message_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bot_Message_StatusArgs = {
  where: Bot_Message_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bot_Message_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bot_SenderArgs = {
  where: Bot_Sender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bot_Sender_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CampaignArgs = {
  where: Campaign_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_AdArgs = {
  where: Campaign_Ad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Ad_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_BudgetArgs = {
  where: Campaign_Budget_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Budget_TransactionArgs = {
  where: Campaign_Budget_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Budget_Transaction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Email_Template_OverwriteArgs = {
  where: Campaign_Email_Template_Overwrite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Email_Template_Overwrite_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Event_LogArgs = {
  where: Campaign_Event_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Event_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Iso_2_Country_CodesArgs = {
  where: Campaign_Iso_2_Country_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Iso_2_Country_Codes_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Job_DescriptionArgs = {
  where: Campaign_Job_Description_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Job_Description_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_OrderArgs = {
  where: Campaign_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Order_SourceArgs = {
  where: Campaign_Order_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Order_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Order_Source_TypeArgs = {
  where: Campaign_Order_Source_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Order_Source_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Routing_DestinationArgs = {
  where: Campaign_Routing_Destination_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Routing_Destination_By_PkArgs = {
  location_id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Routing_InfoArgs = {
  where: Campaign_Routing_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Routing_Info_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Routing_ZipcodeArgs = {
  where: Campaign_Routing_Zipcode_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Routing_Zipcode_By_PkArgs = {
  organization_id: Scalars['String']['input'];
  zipcode: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Settings_OverrideArgs = {
  where: Campaign_Settings_Override_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Settings_Override_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_StatusArgs = {
  where: Campaign_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Status_EventArgs = {
  where: Campaign_Status_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Status_Event_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Status_LogArgs = {
  where: Campaign_Status_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Status_Log_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
  created_at: Scalars['timestamptz']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Transaction_TypeArgs = {
  where: Campaign_Transaction_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Transaction_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Work_LocationArgs = {
  where: Campaign_Work_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campaign_Work_Location_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_Bot_CustomersArgs = {
  where: Chat_Bot_Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Bot_Customers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_Bot_ForwardingArgs = {
  where: Chat_Bot_Forwarding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Bot_Forwarding_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_Bot_Message_TypeArgs = {
  where: Chat_Bot_Message_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Bot_Message_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_Bot_MessagesArgs = {
  where: Chat_Bot_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Bot_Messages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ContactArgs = {
  where: Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contact_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Contact_LogsArgs = {
  where: Contact_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contact_Logs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_File_Pdf_TemplatesArgs = {
  where: File_Pdf_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_Pdf_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_File_UploadArgs = {
  where: File_Upload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_Upload_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Funnel_BenefitsArgs = {
  where: Funnel_Benefits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Benefits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Chatbot_MessageArgs = {
  where: Funnel_Chatbot_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Chatbot_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Chatbot_SessionArgs = {
  where: Funnel_Chatbot_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Chatbot_Session_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Funnel_FunnelsArgs = {
  where: Funnel_Funnels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Funnels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Funnel_InsightsArgs = {
  where: Funnel_Insights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Page_InsightsArgs = {
  where: Funnel_Page_Insights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Page_Insights_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Funnel_QuestionArgs = {
  where: Funnel_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Question_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Question_OptionArgs = {
  where: Funnel_Question_Option_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Question_Option_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Whatsapp_Share_ClicksArgs = {
  where: Funnel_Whatsapp_Share_Clicks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funnel_Whatsapp_Share_Clicks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationArgs = {
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_LocationArgs = {
  where: Organization_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Location_By_PkArgs = {
  organization_id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Name_PrefixArgs = {
  where: Organization_Name_Prefix_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Name_Prefix_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_NewsArgs = {
  where: Organization_News_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_News_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_RegionArgs = {
  where: Organization_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Region_By_PkArgs = {
  organization_id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_SettingsArgs = {
  where: Organization_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Settings_By_PkArgs = {
  organization_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Perspective_CampaignArgs = {
  where: Perspective_Campaign_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Perspective_Campaign_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Qa_SourceArgs = {
  where: Qa_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Qa_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rms_ConnectorsArgs = {
  where: Rms_Connectors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rms_Connectors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rms_Forwarded_LogsArgs = {
  where: Rms_Forwarded_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rms_Forwarded_Logs_By_PkArgs = {
  contact_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rms_Org_SetupsArgs = {
  where: Rms_Org_Setups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rms_Org_Setups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_System_Api_KeysArgs = {
  where: System_Api_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_System_Api_Keys_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_System_Call_Daily_StatsArgs = {
  where: System_Call_Daily_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_System_Call_Daily_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_System_Email_Daily_StatsArgs = {
  where: System_Email_Daily_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_System_Email_Daily_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_System_Running_ReleaseArgs = {
  where: System_Running_Release_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_System_Running_Release_By_PkArgs = {
  service: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_System_Sms_Daily_StatsArgs = {
  where: System_Sms_Daily_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_System_Sms_Daily_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Ad_Campaign_MetricsArgs = {
  objects: Array<Ad_Campaign_Metrics_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Campaign_Metrics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Campaign_Metrics_OneArgs = {
  object: Ad_Campaign_Metrics_Insert_Input;
  on_conflict?: InputMaybe<Ad_Campaign_Metrics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_CommentArgs = {
  objects: Array<Ad_Comment_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Comment_OneArgs = {
  object: Ad_Comment_Insert_Input;
  on_conflict?: InputMaybe<Ad_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_CreativeArgs = {
  objects: Array<Ad_Creative_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Creative_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Creative_FeedbackArgs = {
  objects: Array<Ad_Creative_Feedback_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Creative_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Creative_Feedback_OneArgs = {
  object: Ad_Creative_Feedback_Insert_Input;
  on_conflict?: InputMaybe<Ad_Creative_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Creative_OneArgs = {
  object: Ad_Creative_Insert_Input;
  on_conflict?: InputMaybe<Ad_Creative_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_PlatformArgs = {
  objects: Array<Ad_Platform_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Platform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Platform_OneArgs = {
  object: Ad_Platform_Insert_Input;
  on_conflict?: InputMaybe<Ad_Platform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_ProvidersArgs = {
  objects: Array<Ad_Providers_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Providers_OneArgs = {
  object: Ad_Providers_Insert_Input;
  on_conflict?: InputMaybe<Ad_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_SettingArgs = {
  objects: Array<Ad_Setting_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Setting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Setting_OneArgs = {
  object: Ad_Setting_Insert_Input;
  on_conflict?: InputMaybe<Ad_Setting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_StatusArgs = {
  objects: Array<Ad_Status_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Status_OneArgs = {
  object: Ad_Status_Insert_Input;
  on_conflict?: InputMaybe<Ad_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anna_Ai_Call_CampaignsArgs = {
  objects: Array<Anna_Ai_Call_Campaigns_Insert_Input>;
  on_conflict?: InputMaybe<Anna_Ai_Call_Campaigns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anna_Ai_Call_Campaigns_OneArgs = {
  object: Anna_Ai_Call_Campaigns_Insert_Input;
  on_conflict?: InputMaybe<Anna_Ai_Call_Campaigns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anna_Ai_Call_StatesArgs = {
  objects: Array<Anna_Ai_Call_States_Insert_Input>;
  on_conflict?: InputMaybe<Anna_Ai_Call_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anna_Ai_Call_States_OneArgs = {
  object: Anna_Ai_Call_States_Insert_Input;
  on_conflict?: InputMaybe<Anna_Ai_Call_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anna_Ai_Outbound_CallsArgs = {
  objects: Array<Anna_Ai_Outbound_Calls_Insert_Input>;
  on_conflict?: InputMaybe<Anna_Ai_Outbound_Calls_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anna_Ai_Outbound_Calls_OneArgs = {
  object: Anna_Ai_Outbound_Calls_Insert_Input;
  on_conflict?: InputMaybe<Anna_Ai_Outbound_Calls_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AnswerArgs = {
  objects: Array<Answer_Insert_Input>;
  on_conflict?: InputMaybe<Answer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Answer_OneArgs = {
  object: Answer_Insert_Input;
  on_conflict?: InputMaybe<Answer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Applicant_EventArgs = {
  objects: Array<Applicant_Event_Insert_Input>;
  on_conflict?: InputMaybe<Applicant_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Applicant_Event_OneArgs = {
  object: Applicant_Event_Insert_Input;
  on_conflict?: InputMaybe<Applicant_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_Column_TypeArgs = {
  objects: Array<Board_Column_Type_Insert_Input>;
  on_conflict?: InputMaybe<Board_Column_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_Column_Type_OneArgs = {
  object: Board_Column_Type_Insert_Input;
  on_conflict?: InputMaybe<Board_Column_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_Contact_BoardArgs = {
  objects: Array<Board_Contact_Board_Insert_Input>;
  on_conflict?: InputMaybe<Board_Contact_Board_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_Contact_Board_ColumnArgs = {
  objects: Array<Board_Contact_Board_Column_Insert_Input>;
  on_conflict?: InputMaybe<Board_Contact_Board_Column_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_Contact_Board_Column_OneArgs = {
  object: Board_Contact_Board_Column_Insert_Input;
  on_conflict?: InputMaybe<Board_Contact_Board_Column_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_Contact_Board_EntryArgs = {
  objects: Array<Board_Contact_Board_Entry_Insert_Input>;
  on_conflict?: InputMaybe<Board_Contact_Board_Entry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_Contact_Board_Entry_OneArgs = {
  object: Board_Contact_Board_Entry_Insert_Input;
  on_conflict?: InputMaybe<Board_Contact_Board_Entry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_Contact_Board_OneArgs = {
  object: Board_Contact_Board_Insert_Input;
  on_conflict?: InputMaybe<Board_Contact_Board_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_NoteArgs = {
  objects: Array<Board_Note_Insert_Input>;
  on_conflict?: InputMaybe<Board_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_Note_OneArgs = {
  object: Board_Note_Insert_Input;
  on_conflict?: InputMaybe<Board_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_AssigneeArgs = {
  objects: Array<Bot_Assignee_Insert_Input>;
  on_conflict?: InputMaybe<Bot_Assignee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_Assignee_OneArgs = {
  object: Bot_Assignee_Insert_Input;
  on_conflict?: InputMaybe<Bot_Assignee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_ChannelArgs = {
  objects: Array<Bot_Channel_Insert_Input>;
  on_conflict?: InputMaybe<Bot_Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_Channel_OneArgs = {
  object: Bot_Channel_Insert_Input;
  on_conflict?: InputMaybe<Bot_Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_ConversationArgs = {
  objects: Array<Bot_Conversation_Insert_Input>;
  on_conflict?: InputMaybe<Bot_Conversation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_Conversation_OneArgs = {
  object: Bot_Conversation_Insert_Input;
  on_conflict?: InputMaybe<Bot_Conversation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_Conversation_StateArgs = {
  objects: Array<Bot_Conversation_State_Insert_Input>;
  on_conflict?: InputMaybe<Bot_Conversation_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_Conversation_State_OneArgs = {
  object: Bot_Conversation_State_Insert_Input;
  on_conflict?: InputMaybe<Bot_Conversation_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_MessageArgs = {
  objects: Array<Bot_Message_Insert_Input>;
  on_conflict?: InputMaybe<Bot_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_Message_OneArgs = {
  object: Bot_Message_Insert_Input;
  on_conflict?: InputMaybe<Bot_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_Message_StatusArgs = {
  objects: Array<Bot_Message_Status_Insert_Input>;
  on_conflict?: InputMaybe<Bot_Message_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_Message_Status_OneArgs = {
  object: Bot_Message_Status_Insert_Input;
  on_conflict?: InputMaybe<Bot_Message_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_SenderArgs = {
  objects: Array<Bot_Sender_Insert_Input>;
  on_conflict?: InputMaybe<Bot_Sender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bot_Sender_OneArgs = {
  object: Bot_Sender_Insert_Input;
  on_conflict?: InputMaybe<Bot_Sender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CampaignArgs = {
  objects: Array<Campaign_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_AdArgs = {
  objects: Array<Campaign_Ad_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Ad_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Ad_OneArgs = {
  object: Campaign_Ad_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Ad_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_BudgetArgs = {
  objects: Array<Campaign_Budget_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Budget_OneArgs = {
  object: Campaign_Budget_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Budget_TransactionArgs = {
  objects: Array<Campaign_Budget_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Budget_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Budget_Transaction_OneArgs = {
  object: Campaign_Budget_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Budget_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Email_Template_OverwriteArgs = {
  objects: Array<Campaign_Email_Template_Overwrite_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Email_Template_Overwrite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Email_Template_Overwrite_OneArgs = {
  object: Campaign_Email_Template_Overwrite_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Email_Template_Overwrite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Event_LogArgs = {
  objects: Array<Campaign_Event_Log_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Event_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Event_Log_OneArgs = {
  object: Campaign_Event_Log_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Event_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Iso_2_Country_CodesArgs = {
  objects: Array<Campaign_Iso_2_Country_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Iso_2_Country_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Iso_2_Country_Codes_OneArgs = {
  object: Campaign_Iso_2_Country_Codes_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Iso_2_Country_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Job_DescriptionArgs = {
  objects: Array<Campaign_Job_Description_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Job_Description_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Job_Description_OneArgs = {
  object: Campaign_Job_Description_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Job_Description_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_OneArgs = {
  object: Campaign_Insert_Input;
  on_conflict?: InputMaybe<Campaign_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_OrderArgs = {
  objects: Array<Campaign_Order_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Order_OneArgs = {
  object: Campaign_Order_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Order_SourceArgs = {
  objects: Array<Campaign_Order_Source_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Order_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Order_Source_OneArgs = {
  object: Campaign_Order_Source_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Order_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Order_Source_TypeArgs = {
  objects: Array<Campaign_Order_Source_Type_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Order_Source_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Order_Source_Type_OneArgs = {
  object: Campaign_Order_Source_Type_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Order_Source_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Routing_DestinationArgs = {
  objects: Array<Campaign_Routing_Destination_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Routing_Destination_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Routing_Destination_OneArgs = {
  object: Campaign_Routing_Destination_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Routing_Destination_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Routing_InfoArgs = {
  objects: Array<Campaign_Routing_Info_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Routing_Info_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Routing_Info_OneArgs = {
  object: Campaign_Routing_Info_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Routing_Info_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Routing_ZipcodeArgs = {
  objects: Array<Campaign_Routing_Zipcode_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Routing_Zipcode_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Routing_Zipcode_OneArgs = {
  object: Campaign_Routing_Zipcode_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Routing_Zipcode_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Settings_OverrideArgs = {
  objects: Array<Campaign_Settings_Override_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Settings_Override_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Settings_Override_OneArgs = {
  object: Campaign_Settings_Override_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Settings_Override_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_StatusArgs = {
  objects: Array<Campaign_Status_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Status_EventArgs = {
  objects: Array<Campaign_Status_Event_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Status_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Status_Event_OneArgs = {
  object: Campaign_Status_Event_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Status_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Status_LogArgs = {
  objects: Array<Campaign_Status_Log_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Status_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Status_Log_OneArgs = {
  object: Campaign_Status_Log_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Status_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Status_OneArgs = {
  object: Campaign_Status_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Transaction_TypeArgs = {
  objects: Array<Campaign_Transaction_Type_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Transaction_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Transaction_Type_OneArgs = {
  object: Campaign_Transaction_Type_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Transaction_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Work_LocationArgs = {
  objects: Array<Campaign_Work_Location_Insert_Input>;
  on_conflict?: InputMaybe<Campaign_Work_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campaign_Work_Location_OneArgs = {
  object: Campaign_Work_Location_Insert_Input;
  on_conflict?: InputMaybe<Campaign_Work_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Bot_CustomersArgs = {
  objects: Array<Chat_Bot_Customers_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Bot_Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Bot_Customers_OneArgs = {
  object: Chat_Bot_Customers_Insert_Input;
  on_conflict?: InputMaybe<Chat_Bot_Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Bot_ForwardingArgs = {
  objects: Array<Chat_Bot_Forwarding_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Bot_Forwarding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Bot_Forwarding_OneArgs = {
  object: Chat_Bot_Forwarding_Insert_Input;
  on_conflict?: InputMaybe<Chat_Bot_Forwarding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Bot_Message_TypeArgs = {
  objects: Array<Chat_Bot_Message_Type_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Bot_Message_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Bot_Message_Type_OneArgs = {
  object: Chat_Bot_Message_Type_Insert_Input;
  on_conflict?: InputMaybe<Chat_Bot_Message_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Bot_MessagesArgs = {
  objects: Array<Chat_Bot_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Bot_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Bot_Messages_OneArgs = {
  object: Chat_Bot_Messages_Insert_Input;
  on_conflict?: InputMaybe<Chat_Bot_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContactArgs = {
  objects: Array<Contact_Insert_Input>;
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_LogsArgs = {
  objects: Array<Contact_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Contact_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_Logs_OneArgs = {
  object: Contact_Logs_Insert_Input;
  on_conflict?: InputMaybe<Contact_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_OneArgs = {
  object: Contact_Insert_Input;
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_Pdf_TemplatesArgs = {
  objects: Array<File_Pdf_Templates_Insert_Input>;
  on_conflict?: InputMaybe<File_Pdf_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_Pdf_Templates_OneArgs = {
  object: File_Pdf_Templates_Insert_Input;
  on_conflict?: InputMaybe<File_Pdf_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_UploadArgs = {
  objects: Array<File_Upload_Insert_Input>;
  on_conflict?: InputMaybe<File_Upload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_Upload_OneArgs = {
  object: File_Upload_Insert_Input;
  on_conflict?: InputMaybe<File_Upload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_BenefitsArgs = {
  objects: Array<Funnel_Benefits_Insert_Input>;
  on_conflict?: InputMaybe<Funnel_Benefits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Benefits_OneArgs = {
  object: Funnel_Benefits_Insert_Input;
  on_conflict?: InputMaybe<Funnel_Benefits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Chatbot_MessageArgs = {
  objects: Array<Funnel_Chatbot_Message_Insert_Input>;
  on_conflict?: InputMaybe<Funnel_Chatbot_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Chatbot_Message_OneArgs = {
  object: Funnel_Chatbot_Message_Insert_Input;
  on_conflict?: InputMaybe<Funnel_Chatbot_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Chatbot_SessionArgs = {
  objects: Array<Funnel_Chatbot_Session_Insert_Input>;
  on_conflict?: InputMaybe<Funnel_Chatbot_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Chatbot_Session_OneArgs = {
  object: Funnel_Chatbot_Session_Insert_Input;
  on_conflict?: InputMaybe<Funnel_Chatbot_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_FunnelsArgs = {
  objects: Array<Funnel_Funnels_Insert_Input>;
  on_conflict?: InputMaybe<Funnel_Funnels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Funnels_OneArgs = {
  object: Funnel_Funnels_Insert_Input;
  on_conflict?: InputMaybe<Funnel_Funnels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_InsightsArgs = {
  objects: Array<Funnel_Insights_Insert_Input>;
  on_conflict?: InputMaybe<Funnel_Insights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Insights_OneArgs = {
  object: Funnel_Insights_Insert_Input;
  on_conflict?: InputMaybe<Funnel_Insights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Page_InsightsArgs = {
  objects: Array<Funnel_Page_Insights_Insert_Input>;
  on_conflict?: InputMaybe<Funnel_Page_Insights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Page_Insights_OneArgs = {
  object: Funnel_Page_Insights_Insert_Input;
  on_conflict?: InputMaybe<Funnel_Page_Insights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_QuestionArgs = {
  objects: Array<Funnel_Question_Insert_Input>;
  on_conflict?: InputMaybe<Funnel_Question_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Question_OneArgs = {
  object: Funnel_Question_Insert_Input;
  on_conflict?: InputMaybe<Funnel_Question_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Question_OptionArgs = {
  objects: Array<Funnel_Question_Option_Insert_Input>;
  on_conflict?: InputMaybe<Funnel_Question_Option_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Question_Option_OneArgs = {
  object: Funnel_Question_Option_Insert_Input;
  on_conflict?: InputMaybe<Funnel_Question_Option_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Whatsapp_Share_ClicksArgs = {
  objects: Array<Funnel_Whatsapp_Share_Clicks_Insert_Input>;
  on_conflict?: InputMaybe<Funnel_Whatsapp_Share_Clicks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funnel_Whatsapp_Share_Clicks_OneArgs = {
  object: Funnel_Whatsapp_Share_Clicks_Insert_Input;
  on_conflict?: InputMaybe<Funnel_Whatsapp_Share_Clicks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationArgs = {
  objects: Array<Organization_Insert_Input>;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_LocationArgs = {
  objects: Array<Organization_Location_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Location_OneArgs = {
  object: Organization_Location_Insert_Input;
  on_conflict?: InputMaybe<Organization_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Name_PrefixArgs = {
  objects: Array<Organization_Name_Prefix_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Name_Prefix_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Name_Prefix_OneArgs = {
  object: Organization_Name_Prefix_Insert_Input;
  on_conflict?: InputMaybe<Organization_Name_Prefix_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_NewsArgs = {
  objects: Array<Organization_News_Insert_Input>;
  on_conflict?: InputMaybe<Organization_News_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_News_OneArgs = {
  object: Organization_News_Insert_Input;
  on_conflict?: InputMaybe<Organization_News_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_OneArgs = {
  object: Organization_Insert_Input;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_RegionArgs = {
  objects: Array<Organization_Region_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Region_OneArgs = {
  object: Organization_Region_Insert_Input;
  on_conflict?: InputMaybe<Organization_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_SettingsArgs = {
  objects: Array<Organization_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Settings_OneArgs = {
  object: Organization_Settings_Insert_Input;
  on_conflict?: InputMaybe<Organization_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Perspective_CampaignArgs = {
  objects: Array<Perspective_Campaign_Insert_Input>;
  on_conflict?: InputMaybe<Perspective_Campaign_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Perspective_Campaign_OneArgs = {
  object: Perspective_Campaign_Insert_Input;
  on_conflict?: InputMaybe<Perspective_Campaign_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Qa_SourceArgs = {
  objects: Array<Qa_Source_Insert_Input>;
  on_conflict?: InputMaybe<Qa_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Qa_Source_OneArgs = {
  object: Qa_Source_Insert_Input;
  on_conflict?: InputMaybe<Qa_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rms_ConnectorsArgs = {
  objects: Array<Rms_Connectors_Insert_Input>;
  on_conflict?: InputMaybe<Rms_Connectors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rms_Connectors_OneArgs = {
  object: Rms_Connectors_Insert_Input;
  on_conflict?: InputMaybe<Rms_Connectors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rms_Forwarded_LogsArgs = {
  objects: Array<Rms_Forwarded_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Rms_Forwarded_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rms_Forwarded_Logs_OneArgs = {
  object: Rms_Forwarded_Logs_Insert_Input;
  on_conflict?: InputMaybe<Rms_Forwarded_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rms_Org_SetupsArgs = {
  objects: Array<Rms_Org_Setups_Insert_Input>;
  on_conflict?: InputMaybe<Rms_Org_Setups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rms_Org_Setups_OneArgs = {
  object: Rms_Org_Setups_Insert_Input;
  on_conflict?: InputMaybe<Rms_Org_Setups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Api_KeysArgs = {
  objects: Array<System_Api_Keys_Insert_Input>;
  on_conflict?: InputMaybe<System_Api_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Api_Keys_OneArgs = {
  object: System_Api_Keys_Insert_Input;
  on_conflict?: InputMaybe<System_Api_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Call_Daily_StatsArgs = {
  objects: Array<System_Call_Daily_Stats_Insert_Input>;
  on_conflict?: InputMaybe<System_Call_Daily_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Call_Daily_Stats_OneArgs = {
  object: System_Call_Daily_Stats_Insert_Input;
  on_conflict?: InputMaybe<System_Call_Daily_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Email_Daily_StatsArgs = {
  objects: Array<System_Email_Daily_Stats_Insert_Input>;
  on_conflict?: InputMaybe<System_Email_Daily_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Email_Daily_Stats_OneArgs = {
  object: System_Email_Daily_Stats_Insert_Input;
  on_conflict?: InputMaybe<System_Email_Daily_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Running_ReleaseArgs = {
  objects: Array<System_Running_Release_Insert_Input>;
  on_conflict?: InputMaybe<System_Running_Release_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Running_Release_OneArgs = {
  object: System_Running_Release_Insert_Input;
  on_conflict?: InputMaybe<System_Running_Release_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Sms_Daily_StatsArgs = {
  objects: Array<System_Sms_Daily_Stats_Insert_Input>;
  on_conflict?: InputMaybe<System_Sms_Daily_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Sms_Daily_Stats_OneArgs = {
  object: System_Sms_Daily_Stats_Insert_Input;
  on_conflict?: InputMaybe<System_Sms_Daily_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Campaign_MetricsArgs = {
  _inc?: InputMaybe<Ad_Campaign_Metrics_Inc_Input>;
  _set?: InputMaybe<Ad_Campaign_Metrics_Set_Input>;
  where: Ad_Campaign_Metrics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Campaign_Metrics_By_PkArgs = {
  _inc?: InputMaybe<Ad_Campaign_Metrics_Inc_Input>;
  _set?: InputMaybe<Ad_Campaign_Metrics_Set_Input>;
  pk_columns: Ad_Campaign_Metrics_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Campaign_Metrics_ManyArgs = {
  updates: Array<Ad_Campaign_Metrics_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_CommentArgs = {
  _set?: InputMaybe<Ad_Comment_Set_Input>;
  where: Ad_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Comment_By_PkArgs = {
  _set?: InputMaybe<Ad_Comment_Set_Input>;
  pk_columns: Ad_Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Comment_ManyArgs = {
  updates: Array<Ad_Comment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_CreativeArgs = {
  _set?: InputMaybe<Ad_Creative_Set_Input>;
  where: Ad_Creative_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Creative_By_PkArgs = {
  _set?: InputMaybe<Ad_Creative_Set_Input>;
  pk_columns: Ad_Creative_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Creative_FeedbackArgs = {
  _set?: InputMaybe<Ad_Creative_Feedback_Set_Input>;
  where: Ad_Creative_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Creative_Feedback_By_PkArgs = {
  _set?: InputMaybe<Ad_Creative_Feedback_Set_Input>;
  pk_columns: Ad_Creative_Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Creative_Feedback_ManyArgs = {
  updates: Array<Ad_Creative_Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Creative_ManyArgs = {
  updates: Array<Ad_Creative_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_PlatformArgs = {
  _set?: InputMaybe<Ad_Platform_Set_Input>;
  where: Ad_Platform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Platform_By_PkArgs = {
  _set?: InputMaybe<Ad_Platform_Set_Input>;
  pk_columns: Ad_Platform_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Platform_ManyArgs = {
  updates: Array<Ad_Platform_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_ProvidersArgs = {
  _set?: InputMaybe<Ad_Providers_Set_Input>;
  where: Ad_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Providers_By_PkArgs = {
  _set?: InputMaybe<Ad_Providers_Set_Input>;
  pk_columns: Ad_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Providers_ManyArgs = {
  updates: Array<Ad_Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_SettingArgs = {
  _set?: InputMaybe<Ad_Setting_Set_Input>;
  where: Ad_Setting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Setting_By_PkArgs = {
  _set?: InputMaybe<Ad_Setting_Set_Input>;
  pk_columns: Ad_Setting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Setting_ManyArgs = {
  updates: Array<Ad_Setting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_StatusArgs = {
  _set?: InputMaybe<Ad_Status_Set_Input>;
  where: Ad_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Status_By_PkArgs = {
  _set?: InputMaybe<Ad_Status_Set_Input>;
  pk_columns: Ad_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Status_ManyArgs = {
  updates: Array<Ad_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Anna_Ai_Call_CampaignsArgs = {
  _append?: InputMaybe<Anna_Ai_Call_Campaigns_Append_Input>;
  _delete_at_path?: InputMaybe<Anna_Ai_Call_Campaigns_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Anna_Ai_Call_Campaigns_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Anna_Ai_Call_Campaigns_Delete_Key_Input>;
  _inc?: InputMaybe<Anna_Ai_Call_Campaigns_Inc_Input>;
  _prepend?: InputMaybe<Anna_Ai_Call_Campaigns_Prepend_Input>;
  _set?: InputMaybe<Anna_Ai_Call_Campaigns_Set_Input>;
  where: Anna_Ai_Call_Campaigns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anna_Ai_Call_Campaigns_By_PkArgs = {
  _append?: InputMaybe<Anna_Ai_Call_Campaigns_Append_Input>;
  _delete_at_path?: InputMaybe<Anna_Ai_Call_Campaigns_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Anna_Ai_Call_Campaigns_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Anna_Ai_Call_Campaigns_Delete_Key_Input>;
  _inc?: InputMaybe<Anna_Ai_Call_Campaigns_Inc_Input>;
  _prepend?: InputMaybe<Anna_Ai_Call_Campaigns_Prepend_Input>;
  _set?: InputMaybe<Anna_Ai_Call_Campaigns_Set_Input>;
  pk_columns: Anna_Ai_Call_Campaigns_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anna_Ai_Call_Campaigns_ManyArgs = {
  updates: Array<Anna_Ai_Call_Campaigns_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Anna_Ai_Call_StatesArgs = {
  _set?: InputMaybe<Anna_Ai_Call_States_Set_Input>;
  where: Anna_Ai_Call_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anna_Ai_Call_States_By_PkArgs = {
  _set?: InputMaybe<Anna_Ai_Call_States_Set_Input>;
  pk_columns: Anna_Ai_Call_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anna_Ai_Call_States_ManyArgs = {
  updates: Array<Anna_Ai_Call_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Anna_Ai_Outbound_CallsArgs = {
  _append?: InputMaybe<Anna_Ai_Outbound_Calls_Append_Input>;
  _delete_at_path?: InputMaybe<Anna_Ai_Outbound_Calls_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Anna_Ai_Outbound_Calls_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Anna_Ai_Outbound_Calls_Delete_Key_Input>;
  _prepend?: InputMaybe<Anna_Ai_Outbound_Calls_Prepend_Input>;
  _set?: InputMaybe<Anna_Ai_Outbound_Calls_Set_Input>;
  where: Anna_Ai_Outbound_Calls_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anna_Ai_Outbound_Calls_By_PkArgs = {
  _append?: InputMaybe<Anna_Ai_Outbound_Calls_Append_Input>;
  _delete_at_path?: InputMaybe<Anna_Ai_Outbound_Calls_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Anna_Ai_Outbound_Calls_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Anna_Ai_Outbound_Calls_Delete_Key_Input>;
  _prepend?: InputMaybe<Anna_Ai_Outbound_Calls_Prepend_Input>;
  _set?: InputMaybe<Anna_Ai_Outbound_Calls_Set_Input>;
  pk_columns: Anna_Ai_Outbound_Calls_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anna_Ai_Outbound_Calls_ManyArgs = {
  updates: Array<Anna_Ai_Outbound_Calls_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AnswerArgs = {
  _set?: InputMaybe<Answer_Set_Input>;
  where: Answer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Answer_By_PkArgs = {
  _set?: InputMaybe<Answer_Set_Input>;
  pk_columns: Answer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Answer_ManyArgs = {
  updates: Array<Answer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_EventArgs = {
  _append?: InputMaybe<Applicant_Event_Append_Input>;
  _delete_at_path?: InputMaybe<Applicant_Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Applicant_Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Applicant_Event_Delete_Key_Input>;
  _inc?: InputMaybe<Applicant_Event_Inc_Input>;
  _prepend?: InputMaybe<Applicant_Event_Prepend_Input>;
  _set?: InputMaybe<Applicant_Event_Set_Input>;
  where: Applicant_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Event_By_PkArgs = {
  _append?: InputMaybe<Applicant_Event_Append_Input>;
  _delete_at_path?: InputMaybe<Applicant_Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Applicant_Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Applicant_Event_Delete_Key_Input>;
  _inc?: InputMaybe<Applicant_Event_Inc_Input>;
  _prepend?: InputMaybe<Applicant_Event_Prepend_Input>;
  _set?: InputMaybe<Applicant_Event_Set_Input>;
  pk_columns: Applicant_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Event_ManyArgs = {
  updates: Array<Applicant_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Column_TypeArgs = {
  _set?: InputMaybe<Board_Column_Type_Set_Input>;
  where: Board_Column_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Column_Type_By_PkArgs = {
  _set?: InputMaybe<Board_Column_Type_Set_Input>;
  pk_columns: Board_Column_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Column_Type_ManyArgs = {
  updates: Array<Board_Column_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Contact_BoardArgs = {
  _set?: InputMaybe<Board_Contact_Board_Set_Input>;
  where: Board_Contact_Board_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Contact_Board_By_PkArgs = {
  _set?: InputMaybe<Board_Contact_Board_Set_Input>;
  pk_columns: Board_Contact_Board_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Contact_Board_ColumnArgs = {
  _inc?: InputMaybe<Board_Contact_Board_Column_Inc_Input>;
  _set?: InputMaybe<Board_Contact_Board_Column_Set_Input>;
  where: Board_Contact_Board_Column_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Contact_Board_Column_By_PkArgs = {
  _inc?: InputMaybe<Board_Contact_Board_Column_Inc_Input>;
  _set?: InputMaybe<Board_Contact_Board_Column_Set_Input>;
  pk_columns: Board_Contact_Board_Column_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Contact_Board_Column_ManyArgs = {
  updates: Array<Board_Contact_Board_Column_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Contact_Board_EntryArgs = {
  _inc?: InputMaybe<Board_Contact_Board_Entry_Inc_Input>;
  _set?: InputMaybe<Board_Contact_Board_Entry_Set_Input>;
  where: Board_Contact_Board_Entry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Contact_Board_Entry_By_PkArgs = {
  _inc?: InputMaybe<Board_Contact_Board_Entry_Inc_Input>;
  _set?: InputMaybe<Board_Contact_Board_Entry_Set_Input>;
  pk_columns: Board_Contact_Board_Entry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Contact_Board_Entry_ManyArgs = {
  updates: Array<Board_Contact_Board_Entry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Contact_Board_ManyArgs = {
  updates: Array<Board_Contact_Board_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Board_NoteArgs = {
  _set?: InputMaybe<Board_Note_Set_Input>;
  where: Board_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Note_By_PkArgs = {
  _set?: InputMaybe<Board_Note_Set_Input>;
  pk_columns: Board_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Note_ManyArgs = {
  updates: Array<Board_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_AssigneeArgs = {
  _set?: InputMaybe<Bot_Assignee_Set_Input>;
  where: Bot_Assignee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Assignee_By_PkArgs = {
  _set?: InputMaybe<Bot_Assignee_Set_Input>;
  pk_columns: Bot_Assignee_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Assignee_ManyArgs = {
  updates: Array<Bot_Assignee_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_ChannelArgs = {
  _set?: InputMaybe<Bot_Channel_Set_Input>;
  where: Bot_Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Channel_By_PkArgs = {
  _set?: InputMaybe<Bot_Channel_Set_Input>;
  pk_columns: Bot_Channel_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Channel_ManyArgs = {
  updates: Array<Bot_Channel_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_ConversationArgs = {
  _inc?: InputMaybe<Bot_Conversation_Inc_Input>;
  _set?: InputMaybe<Bot_Conversation_Set_Input>;
  where: Bot_Conversation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Conversation_By_PkArgs = {
  _inc?: InputMaybe<Bot_Conversation_Inc_Input>;
  _set?: InputMaybe<Bot_Conversation_Set_Input>;
  pk_columns: Bot_Conversation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Conversation_ManyArgs = {
  updates: Array<Bot_Conversation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Conversation_StateArgs = {
  _set?: InputMaybe<Bot_Conversation_State_Set_Input>;
  where: Bot_Conversation_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Conversation_State_By_PkArgs = {
  _set?: InputMaybe<Bot_Conversation_State_Set_Input>;
  pk_columns: Bot_Conversation_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Conversation_State_ManyArgs = {
  updates: Array<Bot_Conversation_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_MessageArgs = {
  _inc?: InputMaybe<Bot_Message_Inc_Input>;
  _set?: InputMaybe<Bot_Message_Set_Input>;
  where: Bot_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Message_By_PkArgs = {
  _inc?: InputMaybe<Bot_Message_Inc_Input>;
  _set?: InputMaybe<Bot_Message_Set_Input>;
  pk_columns: Bot_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Message_ManyArgs = {
  updates: Array<Bot_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Message_StatusArgs = {
  _set?: InputMaybe<Bot_Message_Status_Set_Input>;
  where: Bot_Message_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Message_Status_By_PkArgs = {
  _set?: InputMaybe<Bot_Message_Status_Set_Input>;
  pk_columns: Bot_Message_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Message_Status_ManyArgs = {
  updates: Array<Bot_Message_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_SenderArgs = {
  _set?: InputMaybe<Bot_Sender_Set_Input>;
  where: Bot_Sender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Sender_By_PkArgs = {
  _set?: InputMaybe<Bot_Sender_Set_Input>;
  pk_columns: Bot_Sender_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bot_Sender_ManyArgs = {
  updates: Array<Bot_Sender_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CampaignArgs = {
  _inc?: InputMaybe<Campaign_Inc_Input>;
  _set?: InputMaybe<Campaign_Set_Input>;
  where: Campaign_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_AdArgs = {
  _set?: InputMaybe<Campaign_Ad_Set_Input>;
  where: Campaign_Ad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Ad_By_PkArgs = {
  _set?: InputMaybe<Campaign_Ad_Set_Input>;
  pk_columns: Campaign_Ad_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Ad_ManyArgs = {
  updates: Array<Campaign_Ad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_BudgetArgs = {
  _inc?: InputMaybe<Campaign_Budget_Inc_Input>;
  _set?: InputMaybe<Campaign_Budget_Set_Input>;
  where: Campaign_Budget_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Budget_ManyArgs = {
  updates: Array<Campaign_Budget_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Budget_TransactionArgs = {
  _inc?: InputMaybe<Campaign_Budget_Transaction_Inc_Input>;
  _set?: InputMaybe<Campaign_Budget_Transaction_Set_Input>;
  where: Campaign_Budget_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Budget_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Campaign_Budget_Transaction_Inc_Input>;
  _set?: InputMaybe<Campaign_Budget_Transaction_Set_Input>;
  pk_columns: Campaign_Budget_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Budget_Transaction_ManyArgs = {
  updates: Array<Campaign_Budget_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_By_PkArgs = {
  _inc?: InputMaybe<Campaign_Inc_Input>;
  _set?: InputMaybe<Campaign_Set_Input>;
  pk_columns: Campaign_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Email_Template_OverwriteArgs = {
  _set?: InputMaybe<Campaign_Email_Template_Overwrite_Set_Input>;
  where: Campaign_Email_Template_Overwrite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Email_Template_Overwrite_By_PkArgs = {
  _set?: InputMaybe<Campaign_Email_Template_Overwrite_Set_Input>;
  pk_columns: Campaign_Email_Template_Overwrite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Email_Template_Overwrite_ManyArgs = {
  updates: Array<Campaign_Email_Template_Overwrite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Event_LogArgs = {
  _append?: InputMaybe<Campaign_Event_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Campaign_Event_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Campaign_Event_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Campaign_Event_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Campaign_Event_Log_Inc_Input>;
  _prepend?: InputMaybe<Campaign_Event_Log_Prepend_Input>;
  _set?: InputMaybe<Campaign_Event_Log_Set_Input>;
  where: Campaign_Event_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Event_Log_By_PkArgs = {
  _append?: InputMaybe<Campaign_Event_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Campaign_Event_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Campaign_Event_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Campaign_Event_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Campaign_Event_Log_Inc_Input>;
  _prepend?: InputMaybe<Campaign_Event_Log_Prepend_Input>;
  _set?: InputMaybe<Campaign_Event_Log_Set_Input>;
  pk_columns: Campaign_Event_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Event_Log_ManyArgs = {
  updates: Array<Campaign_Event_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Iso_2_Country_CodesArgs = {
  _set?: InputMaybe<Campaign_Iso_2_Country_Codes_Set_Input>;
  where: Campaign_Iso_2_Country_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Iso_2_Country_Codes_By_PkArgs = {
  _set?: InputMaybe<Campaign_Iso_2_Country_Codes_Set_Input>;
  pk_columns: Campaign_Iso_2_Country_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Iso_2_Country_Codes_ManyArgs = {
  updates: Array<Campaign_Iso_2_Country_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Job_DescriptionArgs = {
  _set?: InputMaybe<Campaign_Job_Description_Set_Input>;
  where: Campaign_Job_Description_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Job_Description_By_PkArgs = {
  _set?: InputMaybe<Campaign_Job_Description_Set_Input>;
  pk_columns: Campaign_Job_Description_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Job_Description_ManyArgs = {
  updates: Array<Campaign_Job_Description_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_ManyArgs = {
  updates: Array<Campaign_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_OrderArgs = {
  _append?: InputMaybe<Campaign_Order_Append_Input>;
  _delete_at_path?: InputMaybe<Campaign_Order_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Campaign_Order_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Campaign_Order_Delete_Key_Input>;
  _inc?: InputMaybe<Campaign_Order_Inc_Input>;
  _prepend?: InputMaybe<Campaign_Order_Prepend_Input>;
  _set?: InputMaybe<Campaign_Order_Set_Input>;
  where: Campaign_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Order_By_PkArgs = {
  _append?: InputMaybe<Campaign_Order_Append_Input>;
  _delete_at_path?: InputMaybe<Campaign_Order_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Campaign_Order_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Campaign_Order_Delete_Key_Input>;
  _inc?: InputMaybe<Campaign_Order_Inc_Input>;
  _prepend?: InputMaybe<Campaign_Order_Prepend_Input>;
  _set?: InputMaybe<Campaign_Order_Set_Input>;
  pk_columns: Campaign_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Order_ManyArgs = {
  updates: Array<Campaign_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Order_SourceArgs = {
  _inc?: InputMaybe<Campaign_Order_Source_Inc_Input>;
  _set?: InputMaybe<Campaign_Order_Source_Set_Input>;
  where: Campaign_Order_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Order_Source_By_PkArgs = {
  _inc?: InputMaybe<Campaign_Order_Source_Inc_Input>;
  _set?: InputMaybe<Campaign_Order_Source_Set_Input>;
  pk_columns: Campaign_Order_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Order_Source_ManyArgs = {
  updates: Array<Campaign_Order_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Order_Source_TypeArgs = {
  _set?: InputMaybe<Campaign_Order_Source_Type_Set_Input>;
  where: Campaign_Order_Source_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Order_Source_Type_By_PkArgs = {
  _set?: InputMaybe<Campaign_Order_Source_Type_Set_Input>;
  pk_columns: Campaign_Order_Source_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Order_Source_Type_ManyArgs = {
  updates: Array<Campaign_Order_Source_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Routing_DestinationArgs = {
  _inc?: InputMaybe<Campaign_Routing_Destination_Inc_Input>;
  _set?: InputMaybe<Campaign_Routing_Destination_Set_Input>;
  where: Campaign_Routing_Destination_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Routing_Destination_By_PkArgs = {
  _inc?: InputMaybe<Campaign_Routing_Destination_Inc_Input>;
  _set?: InputMaybe<Campaign_Routing_Destination_Set_Input>;
  pk_columns: Campaign_Routing_Destination_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Routing_Destination_ManyArgs = {
  updates: Array<Campaign_Routing_Destination_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Routing_InfoArgs = {
  _inc?: InputMaybe<Campaign_Routing_Info_Inc_Input>;
  _set?: InputMaybe<Campaign_Routing_Info_Set_Input>;
  where: Campaign_Routing_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Routing_Info_By_PkArgs = {
  _inc?: InputMaybe<Campaign_Routing_Info_Inc_Input>;
  _set?: InputMaybe<Campaign_Routing_Info_Set_Input>;
  pk_columns: Campaign_Routing_Info_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Routing_Info_ManyArgs = {
  updates: Array<Campaign_Routing_Info_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Routing_ZipcodeArgs = {
  _inc?: InputMaybe<Campaign_Routing_Zipcode_Inc_Input>;
  _set?: InputMaybe<Campaign_Routing_Zipcode_Set_Input>;
  where: Campaign_Routing_Zipcode_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Routing_Zipcode_By_PkArgs = {
  _inc?: InputMaybe<Campaign_Routing_Zipcode_Inc_Input>;
  _set?: InputMaybe<Campaign_Routing_Zipcode_Set_Input>;
  pk_columns: Campaign_Routing_Zipcode_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Routing_Zipcode_ManyArgs = {
  updates: Array<Campaign_Routing_Zipcode_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Settings_OverrideArgs = {
  _set?: InputMaybe<Campaign_Settings_Override_Set_Input>;
  where: Campaign_Settings_Override_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Settings_Override_By_PkArgs = {
  _set?: InputMaybe<Campaign_Settings_Override_Set_Input>;
  pk_columns: Campaign_Settings_Override_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Settings_Override_ManyArgs = {
  updates: Array<Campaign_Settings_Override_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_StatusArgs = {
  _set?: InputMaybe<Campaign_Status_Set_Input>;
  where: Campaign_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Status_By_PkArgs = {
  _set?: InputMaybe<Campaign_Status_Set_Input>;
  pk_columns: Campaign_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Status_EventArgs = {
  _set?: InputMaybe<Campaign_Status_Event_Set_Input>;
  where: Campaign_Status_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Status_Event_By_PkArgs = {
  _set?: InputMaybe<Campaign_Status_Event_Set_Input>;
  pk_columns: Campaign_Status_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Status_Event_ManyArgs = {
  updates: Array<Campaign_Status_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Status_LogArgs = {
  _set?: InputMaybe<Campaign_Status_Log_Set_Input>;
  where: Campaign_Status_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Status_Log_By_PkArgs = {
  _set?: InputMaybe<Campaign_Status_Log_Set_Input>;
  pk_columns: Campaign_Status_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Status_Log_ManyArgs = {
  updates: Array<Campaign_Status_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Status_ManyArgs = {
  updates: Array<Campaign_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Transaction_TypeArgs = {
  _set?: InputMaybe<Campaign_Transaction_Type_Set_Input>;
  where: Campaign_Transaction_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Transaction_Type_By_PkArgs = {
  _set?: InputMaybe<Campaign_Transaction_Type_Set_Input>;
  pk_columns: Campaign_Transaction_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Transaction_Type_ManyArgs = {
  updates: Array<Campaign_Transaction_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Work_LocationArgs = {
  _set?: InputMaybe<Campaign_Work_Location_Set_Input>;
  where: Campaign_Work_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Work_Location_By_PkArgs = {
  _set?: InputMaybe<Campaign_Work_Location_Set_Input>;
  pk_columns: Campaign_Work_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campaign_Work_Location_ManyArgs = {
  updates: Array<Campaign_Work_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_CustomersArgs = {
  _append?: InputMaybe<Chat_Bot_Customers_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Bot_Customers_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Bot_Customers_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Bot_Customers_Delete_Key_Input>;
  _inc?: InputMaybe<Chat_Bot_Customers_Inc_Input>;
  _prepend?: InputMaybe<Chat_Bot_Customers_Prepend_Input>;
  _set?: InputMaybe<Chat_Bot_Customers_Set_Input>;
  where: Chat_Bot_Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_Customers_By_PkArgs = {
  _append?: InputMaybe<Chat_Bot_Customers_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Bot_Customers_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Bot_Customers_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Bot_Customers_Delete_Key_Input>;
  _inc?: InputMaybe<Chat_Bot_Customers_Inc_Input>;
  _prepend?: InputMaybe<Chat_Bot_Customers_Prepend_Input>;
  _set?: InputMaybe<Chat_Bot_Customers_Set_Input>;
  pk_columns: Chat_Bot_Customers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_Customers_ManyArgs = {
  updates: Array<Chat_Bot_Customers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_ForwardingArgs = {
  _inc?: InputMaybe<Chat_Bot_Forwarding_Inc_Input>;
  _set?: InputMaybe<Chat_Bot_Forwarding_Set_Input>;
  where: Chat_Bot_Forwarding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_Forwarding_By_PkArgs = {
  _inc?: InputMaybe<Chat_Bot_Forwarding_Inc_Input>;
  _set?: InputMaybe<Chat_Bot_Forwarding_Set_Input>;
  pk_columns: Chat_Bot_Forwarding_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_Forwarding_ManyArgs = {
  updates: Array<Chat_Bot_Forwarding_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_Message_TypeArgs = {
  _set?: InputMaybe<Chat_Bot_Message_Type_Set_Input>;
  where: Chat_Bot_Message_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_Message_Type_By_PkArgs = {
  _set?: InputMaybe<Chat_Bot_Message_Type_Set_Input>;
  pk_columns: Chat_Bot_Message_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_Message_Type_ManyArgs = {
  updates: Array<Chat_Bot_Message_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_MessagesArgs = {
  _append?: InputMaybe<Chat_Bot_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Bot_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Bot_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Bot_Messages_Delete_Key_Input>;
  _inc?: InputMaybe<Chat_Bot_Messages_Inc_Input>;
  _prepend?: InputMaybe<Chat_Bot_Messages_Prepend_Input>;
  _set?: InputMaybe<Chat_Bot_Messages_Set_Input>;
  where: Chat_Bot_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_Messages_By_PkArgs = {
  _append?: InputMaybe<Chat_Bot_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Bot_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Bot_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Bot_Messages_Delete_Key_Input>;
  _inc?: InputMaybe<Chat_Bot_Messages_Inc_Input>;
  _prepend?: InputMaybe<Chat_Bot_Messages_Prepend_Input>;
  _set?: InputMaybe<Chat_Bot_Messages_Set_Input>;
  pk_columns: Chat_Bot_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bot_Messages_ManyArgs = {
  updates: Array<Chat_Bot_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContactArgs = {
  _inc?: InputMaybe<Contact_Inc_Input>;
  _set?: InputMaybe<Contact_Set_Input>;
  where: Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_By_PkArgs = {
  _inc?: InputMaybe<Contact_Inc_Input>;
  _set?: InputMaybe<Contact_Set_Input>;
  pk_columns: Contact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_LogsArgs = {
  _append?: InputMaybe<Contact_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Contact_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Contact_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Contact_Logs_Delete_Key_Input>;
  _inc?: InputMaybe<Contact_Logs_Inc_Input>;
  _prepend?: InputMaybe<Contact_Logs_Prepend_Input>;
  _set?: InputMaybe<Contact_Logs_Set_Input>;
  where: Contact_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_Logs_By_PkArgs = {
  _append?: InputMaybe<Contact_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Contact_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Contact_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Contact_Logs_Delete_Key_Input>;
  _inc?: InputMaybe<Contact_Logs_Inc_Input>;
  _prepend?: InputMaybe<Contact_Logs_Prepend_Input>;
  _set?: InputMaybe<Contact_Logs_Set_Input>;
  pk_columns: Contact_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_Logs_ManyArgs = {
  updates: Array<Contact_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_ManyArgs = {
  updates: Array<Contact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_File_Pdf_TemplatesArgs = {
  _set?: InputMaybe<File_Pdf_Templates_Set_Input>;
  where: File_Pdf_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_Pdf_Templates_By_PkArgs = {
  _set?: InputMaybe<File_Pdf_Templates_Set_Input>;
  pk_columns: File_Pdf_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_Pdf_Templates_ManyArgs = {
  updates: Array<File_Pdf_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_File_UploadArgs = {
  _set?: InputMaybe<File_Upload_Set_Input>;
  where: File_Upload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_Upload_By_PkArgs = {
  _set?: InputMaybe<File_Upload_Set_Input>;
  pk_columns: File_Upload_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_Upload_ManyArgs = {
  updates: Array<File_Upload_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_BenefitsArgs = {
  _set?: InputMaybe<Funnel_Benefits_Set_Input>;
  where: Funnel_Benefits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Benefits_By_PkArgs = {
  _set?: InputMaybe<Funnel_Benefits_Set_Input>;
  pk_columns: Funnel_Benefits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Benefits_ManyArgs = {
  updates: Array<Funnel_Benefits_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Chatbot_MessageArgs = {
  _set?: InputMaybe<Funnel_Chatbot_Message_Set_Input>;
  where: Funnel_Chatbot_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Chatbot_Message_By_PkArgs = {
  _set?: InputMaybe<Funnel_Chatbot_Message_Set_Input>;
  pk_columns: Funnel_Chatbot_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Chatbot_Message_ManyArgs = {
  updates: Array<Funnel_Chatbot_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Chatbot_SessionArgs = {
  _append?: InputMaybe<Funnel_Chatbot_Session_Append_Input>;
  _delete_at_path?: InputMaybe<Funnel_Chatbot_Session_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Funnel_Chatbot_Session_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Funnel_Chatbot_Session_Delete_Key_Input>;
  _inc?: InputMaybe<Funnel_Chatbot_Session_Inc_Input>;
  _prepend?: InputMaybe<Funnel_Chatbot_Session_Prepend_Input>;
  _set?: InputMaybe<Funnel_Chatbot_Session_Set_Input>;
  where: Funnel_Chatbot_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Chatbot_Session_By_PkArgs = {
  _append?: InputMaybe<Funnel_Chatbot_Session_Append_Input>;
  _delete_at_path?: InputMaybe<Funnel_Chatbot_Session_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Funnel_Chatbot_Session_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Funnel_Chatbot_Session_Delete_Key_Input>;
  _inc?: InputMaybe<Funnel_Chatbot_Session_Inc_Input>;
  _prepend?: InputMaybe<Funnel_Chatbot_Session_Prepend_Input>;
  _set?: InputMaybe<Funnel_Chatbot_Session_Set_Input>;
  pk_columns: Funnel_Chatbot_Session_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Chatbot_Session_ManyArgs = {
  updates: Array<Funnel_Chatbot_Session_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_FunnelsArgs = {
  _append?: InputMaybe<Funnel_Funnels_Append_Input>;
  _delete_at_path?: InputMaybe<Funnel_Funnels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Funnel_Funnels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Funnel_Funnels_Delete_Key_Input>;
  _prepend?: InputMaybe<Funnel_Funnels_Prepend_Input>;
  _set?: InputMaybe<Funnel_Funnels_Set_Input>;
  where: Funnel_Funnels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Funnels_By_PkArgs = {
  _append?: InputMaybe<Funnel_Funnels_Append_Input>;
  _delete_at_path?: InputMaybe<Funnel_Funnels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Funnel_Funnels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Funnel_Funnels_Delete_Key_Input>;
  _prepend?: InputMaybe<Funnel_Funnels_Prepend_Input>;
  _set?: InputMaybe<Funnel_Funnels_Set_Input>;
  pk_columns: Funnel_Funnels_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Funnels_ManyArgs = {
  updates: Array<Funnel_Funnels_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_InsightsArgs = {
  _inc?: InputMaybe<Funnel_Insights_Inc_Input>;
  _set?: InputMaybe<Funnel_Insights_Set_Input>;
  where: Funnel_Insights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Insights_ManyArgs = {
  updates: Array<Funnel_Insights_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Page_InsightsArgs = {
  _inc?: InputMaybe<Funnel_Page_Insights_Inc_Input>;
  _set?: InputMaybe<Funnel_Page_Insights_Set_Input>;
  where: Funnel_Page_Insights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Page_Insights_By_PkArgs = {
  _inc?: InputMaybe<Funnel_Page_Insights_Inc_Input>;
  _set?: InputMaybe<Funnel_Page_Insights_Set_Input>;
  pk_columns: Funnel_Page_Insights_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Page_Insights_ManyArgs = {
  updates: Array<Funnel_Page_Insights_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_QuestionArgs = {
  _inc?: InputMaybe<Funnel_Question_Inc_Input>;
  _set?: InputMaybe<Funnel_Question_Set_Input>;
  where: Funnel_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Question_By_PkArgs = {
  _inc?: InputMaybe<Funnel_Question_Inc_Input>;
  _set?: InputMaybe<Funnel_Question_Set_Input>;
  pk_columns: Funnel_Question_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Question_ManyArgs = {
  updates: Array<Funnel_Question_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Question_OptionArgs = {
  _set?: InputMaybe<Funnel_Question_Option_Set_Input>;
  where: Funnel_Question_Option_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Question_Option_By_PkArgs = {
  _set?: InputMaybe<Funnel_Question_Option_Set_Input>;
  pk_columns: Funnel_Question_Option_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Question_Option_ManyArgs = {
  updates: Array<Funnel_Question_Option_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Whatsapp_Share_ClicksArgs = {
  _set?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Set_Input>;
  where: Funnel_Whatsapp_Share_Clicks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Whatsapp_Share_Clicks_By_PkArgs = {
  _set?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Set_Input>;
  pk_columns: Funnel_Whatsapp_Share_Clicks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Funnel_Whatsapp_Share_Clicks_ManyArgs = {
  updates: Array<Funnel_Whatsapp_Share_Clicks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationArgs = {
  _set?: InputMaybe<Organization_Set_Input>;
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_By_PkArgs = {
  _set?: InputMaybe<Organization_Set_Input>;
  pk_columns: Organization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_LocationArgs = {
  _set?: InputMaybe<Organization_Location_Set_Input>;
  where: Organization_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Location_By_PkArgs = {
  _set?: InputMaybe<Organization_Location_Set_Input>;
  pk_columns: Organization_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Location_ManyArgs = {
  updates: Array<Organization_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_ManyArgs = {
  updates: Array<Organization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Name_PrefixArgs = {
  _set?: InputMaybe<Organization_Name_Prefix_Set_Input>;
  where: Organization_Name_Prefix_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Name_Prefix_By_PkArgs = {
  _set?: InputMaybe<Organization_Name_Prefix_Set_Input>;
  pk_columns: Organization_Name_Prefix_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Name_Prefix_ManyArgs = {
  updates: Array<Organization_Name_Prefix_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_NewsArgs = {
  _set?: InputMaybe<Organization_News_Set_Input>;
  where: Organization_News_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_News_By_PkArgs = {
  _set?: InputMaybe<Organization_News_Set_Input>;
  pk_columns: Organization_News_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_News_ManyArgs = {
  updates: Array<Organization_News_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_RegionArgs = {
  _set?: InputMaybe<Organization_Region_Set_Input>;
  where: Organization_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Region_By_PkArgs = {
  _set?: InputMaybe<Organization_Region_Set_Input>;
  pk_columns: Organization_Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Region_ManyArgs = {
  updates: Array<Organization_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_SettingsArgs = {
  _set?: InputMaybe<Organization_Settings_Set_Input>;
  where: Organization_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Settings_By_PkArgs = {
  _set?: InputMaybe<Organization_Settings_Set_Input>;
  pk_columns: Organization_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Settings_ManyArgs = {
  updates: Array<Organization_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Perspective_CampaignArgs = {
  _set?: InputMaybe<Perspective_Campaign_Set_Input>;
  where: Perspective_Campaign_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Perspective_Campaign_By_PkArgs = {
  _set?: InputMaybe<Perspective_Campaign_Set_Input>;
  pk_columns: Perspective_Campaign_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Perspective_Campaign_ManyArgs = {
  updates: Array<Perspective_Campaign_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Qa_SourceArgs = {
  _set?: InputMaybe<Qa_Source_Set_Input>;
  where: Qa_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Qa_Source_By_PkArgs = {
  _set?: InputMaybe<Qa_Source_Set_Input>;
  pk_columns: Qa_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Qa_Source_ManyArgs = {
  updates: Array<Qa_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rms_ConnectorsArgs = {
  _append?: InputMaybe<Rms_Connectors_Append_Input>;
  _delete_at_path?: InputMaybe<Rms_Connectors_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rms_Connectors_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rms_Connectors_Delete_Key_Input>;
  _prepend?: InputMaybe<Rms_Connectors_Prepend_Input>;
  _set?: InputMaybe<Rms_Connectors_Set_Input>;
  where: Rms_Connectors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rms_Connectors_By_PkArgs = {
  _append?: InputMaybe<Rms_Connectors_Append_Input>;
  _delete_at_path?: InputMaybe<Rms_Connectors_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rms_Connectors_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rms_Connectors_Delete_Key_Input>;
  _prepend?: InputMaybe<Rms_Connectors_Prepend_Input>;
  _set?: InputMaybe<Rms_Connectors_Set_Input>;
  pk_columns: Rms_Connectors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rms_Connectors_ManyArgs = {
  updates: Array<Rms_Connectors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rms_Forwarded_LogsArgs = {
  _append?: InputMaybe<Rms_Forwarded_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Rms_Forwarded_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rms_Forwarded_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rms_Forwarded_Logs_Delete_Key_Input>;
  _prepend?: InputMaybe<Rms_Forwarded_Logs_Prepend_Input>;
  _set?: InputMaybe<Rms_Forwarded_Logs_Set_Input>;
  where: Rms_Forwarded_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rms_Forwarded_Logs_By_PkArgs = {
  _append?: InputMaybe<Rms_Forwarded_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Rms_Forwarded_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rms_Forwarded_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rms_Forwarded_Logs_Delete_Key_Input>;
  _prepend?: InputMaybe<Rms_Forwarded_Logs_Prepend_Input>;
  _set?: InputMaybe<Rms_Forwarded_Logs_Set_Input>;
  pk_columns: Rms_Forwarded_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rms_Forwarded_Logs_ManyArgs = {
  updates: Array<Rms_Forwarded_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rms_Org_SetupsArgs = {
  _append?: InputMaybe<Rms_Org_Setups_Append_Input>;
  _delete_at_path?: InputMaybe<Rms_Org_Setups_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rms_Org_Setups_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rms_Org_Setups_Delete_Key_Input>;
  _prepend?: InputMaybe<Rms_Org_Setups_Prepend_Input>;
  _set?: InputMaybe<Rms_Org_Setups_Set_Input>;
  where: Rms_Org_Setups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rms_Org_Setups_By_PkArgs = {
  _append?: InputMaybe<Rms_Org_Setups_Append_Input>;
  _delete_at_path?: InputMaybe<Rms_Org_Setups_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rms_Org_Setups_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rms_Org_Setups_Delete_Key_Input>;
  _prepend?: InputMaybe<Rms_Org_Setups_Prepend_Input>;
  _set?: InputMaybe<Rms_Org_Setups_Set_Input>;
  pk_columns: Rms_Org_Setups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rms_Org_Setups_ManyArgs = {
  updates: Array<Rms_Org_Setups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_System_Api_KeysArgs = {
  _set?: InputMaybe<System_Api_Keys_Set_Input>;
  where: System_Api_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_System_Api_Keys_By_PkArgs = {
  _set?: InputMaybe<System_Api_Keys_Set_Input>;
  pk_columns: System_Api_Keys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_System_Api_Keys_ManyArgs = {
  updates: Array<System_Api_Keys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_System_Call_Daily_StatsArgs = {
  _inc?: InputMaybe<System_Call_Daily_Stats_Inc_Input>;
  _set?: InputMaybe<System_Call_Daily_Stats_Set_Input>;
  where: System_Call_Daily_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_System_Call_Daily_Stats_By_PkArgs = {
  _inc?: InputMaybe<System_Call_Daily_Stats_Inc_Input>;
  _set?: InputMaybe<System_Call_Daily_Stats_Set_Input>;
  pk_columns: System_Call_Daily_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_System_Call_Daily_Stats_ManyArgs = {
  updates: Array<System_Call_Daily_Stats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_System_Email_Daily_StatsArgs = {
  _inc?: InputMaybe<System_Email_Daily_Stats_Inc_Input>;
  _set?: InputMaybe<System_Email_Daily_Stats_Set_Input>;
  where: System_Email_Daily_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_System_Email_Daily_Stats_By_PkArgs = {
  _inc?: InputMaybe<System_Email_Daily_Stats_Inc_Input>;
  _set?: InputMaybe<System_Email_Daily_Stats_Set_Input>;
  pk_columns: System_Email_Daily_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_System_Email_Daily_Stats_ManyArgs = {
  updates: Array<System_Email_Daily_Stats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_System_Running_ReleaseArgs = {
  _set?: InputMaybe<System_Running_Release_Set_Input>;
  where: System_Running_Release_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_System_Running_Release_By_PkArgs = {
  _set?: InputMaybe<System_Running_Release_Set_Input>;
  pk_columns: System_Running_Release_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_System_Running_Release_ManyArgs = {
  updates: Array<System_Running_Release_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_System_Sms_Daily_StatsArgs = {
  _inc?: InputMaybe<System_Sms_Daily_Stats_Inc_Input>;
  _set?: InputMaybe<System_Sms_Daily_Stats_Set_Input>;
  where: System_Sms_Daily_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_System_Sms_Daily_Stats_By_PkArgs = {
  _inc?: InputMaybe<System_Sms_Daily_Stats_Inc_Input>;
  _set?: InputMaybe<System_Sms_Daily_Stats_Set_Input>;
  pk_columns: System_Sms_Daily_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_System_Sms_Daily_Stats_ManyArgs = {
  updates: Array<System_Sms_Daily_Stats_Updates>;
};

/** columns and relationships of "new_contacts_per_day" */
export type New_Contacts_Per_Day = {
  __typename?: 'new_contacts_per_day';
  /** An object relationship */
  campaign?: Maybe<Campaign>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  new_contacts?: Maybe<Scalars['bigint']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "new_contacts_per_day" */
export type New_Contacts_Per_Day_Aggregate = {
  __typename?: 'new_contacts_per_day_aggregate';
  aggregate?: Maybe<New_Contacts_Per_Day_Aggregate_Fields>;
  nodes: Array<New_Contacts_Per_Day>;
};

export type New_Contacts_Per_Day_Aggregate_Bool_Exp = {
  count?: InputMaybe<New_Contacts_Per_Day_Aggregate_Bool_Exp_Count>;
};

export type New_Contacts_Per_Day_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<New_Contacts_Per_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<New_Contacts_Per_Day_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "new_contacts_per_day" */
export type New_Contacts_Per_Day_Aggregate_Fields = {
  __typename?: 'new_contacts_per_day_aggregate_fields';
  avg?: Maybe<New_Contacts_Per_Day_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<New_Contacts_Per_Day_Max_Fields>;
  min?: Maybe<New_Contacts_Per_Day_Min_Fields>;
  stddev?: Maybe<New_Contacts_Per_Day_Stddev_Fields>;
  stddev_pop?: Maybe<New_Contacts_Per_Day_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<New_Contacts_Per_Day_Stddev_Samp_Fields>;
  sum?: Maybe<New_Contacts_Per_Day_Sum_Fields>;
  var_pop?: Maybe<New_Contacts_Per_Day_Var_Pop_Fields>;
  var_samp?: Maybe<New_Contacts_Per_Day_Var_Samp_Fields>;
  variance?: Maybe<New_Contacts_Per_Day_Variance_Fields>;
};


/** aggregate fields of "new_contacts_per_day" */
export type New_Contacts_Per_Day_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<New_Contacts_Per_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Aggregate_Order_By = {
  avg?: InputMaybe<New_Contacts_Per_Day_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<New_Contacts_Per_Day_Max_Order_By>;
  min?: InputMaybe<New_Contacts_Per_Day_Min_Order_By>;
  stddev?: InputMaybe<New_Contacts_Per_Day_Stddev_Order_By>;
  stddev_pop?: InputMaybe<New_Contacts_Per_Day_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<New_Contacts_Per_Day_Stddev_Samp_Order_By>;
  sum?: InputMaybe<New_Contacts_Per_Day_Sum_Order_By>;
  var_pop?: InputMaybe<New_Contacts_Per_Day_Var_Pop_Order_By>;
  var_samp?: InputMaybe<New_Contacts_Per_Day_Var_Samp_Order_By>;
  variance?: InputMaybe<New_Contacts_Per_Day_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Arr_Rel_Insert_Input = {
  data: Array<New_Contacts_Per_Day_Insert_Input>;
};

/** aggregate avg on columns */
export type New_Contacts_Per_Day_Avg_Fields = {
  __typename?: 'new_contacts_per_day_avg_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Avg_Order_By = {
  new_contacts?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "new_contacts_per_day". All fields are combined with a logical 'AND'. */
export type New_Contacts_Per_Day_Bool_Exp = {
  _and?: InputMaybe<Array<New_Contacts_Per_Day_Bool_Exp>>;
  _not?: InputMaybe<New_Contacts_Per_Day_Bool_Exp>;
  _or?: InputMaybe<Array<New_Contacts_Per_Day_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<String_Comparison_Exp>;
  new_contacts?: InputMaybe<Bigint_Comparison_Exp>;
  utm_source?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  new_contacts?: InputMaybe<Scalars['bigint']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type New_Contacts_Per_Day_Max_Fields = {
  __typename?: 'new_contacts_per_day_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  new_contacts?: Maybe<Scalars['bigint']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  new_contacts?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type New_Contacts_Per_Day_Min_Fields = {
  __typename?: 'new_contacts_per_day_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  new_contacts?: Maybe<Scalars['bigint']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  new_contacts?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "new_contacts_per_day". */
export type New_Contacts_Per_Day_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  new_contacts?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
};

/** select columns of table "new_contacts_per_day" */
export enum New_Contacts_Per_Day_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Date = 'date',
  /** column name */
  NewContacts = 'new_contacts',
  /** column name */
  UtmSource = 'utm_source'
}

/** aggregate stddev on columns */
export type New_Contacts_Per_Day_Stddev_Fields = {
  __typename?: 'new_contacts_per_day_stddev_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Stddev_Order_By = {
  new_contacts?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type New_Contacts_Per_Day_Stddev_Pop_Fields = {
  __typename?: 'new_contacts_per_day_stddev_pop_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Stddev_Pop_Order_By = {
  new_contacts?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type New_Contacts_Per_Day_Stddev_Samp_Fields = {
  __typename?: 'new_contacts_per_day_stddev_samp_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Stddev_Samp_Order_By = {
  new_contacts?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: New_Contacts_Per_Day_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type New_Contacts_Per_Day_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  new_contacts?: InputMaybe<Scalars['bigint']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type New_Contacts_Per_Day_Sum_Fields = {
  __typename?: 'new_contacts_per_day_sum_fields';
  new_contacts?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Sum_Order_By = {
  new_contacts?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type New_Contacts_Per_Day_Var_Pop_Fields = {
  __typename?: 'new_contacts_per_day_var_pop_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Var_Pop_Order_By = {
  new_contacts?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type New_Contacts_Per_Day_Var_Samp_Fields = {
  __typename?: 'new_contacts_per_day_var_samp_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Var_Samp_Order_By = {
  new_contacts?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type New_Contacts_Per_Day_Variance_Fields = {
  __typename?: 'new_contacts_per_day_variance_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "new_contacts_per_day" */
export type New_Contacts_Per_Day_Variance_Order_By = {
  new_contacts?: InputMaybe<Order_By>;
};

/** columns and relationships of "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day = {
  __typename?: 'new_unqualified_contacts_per_day';
  /** An object relationship */
  campaign?: Maybe<Campaign>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  new_unqualified_contacts?: Maybe<Scalars['bigint']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Aggregate = {
  __typename?: 'new_unqualified_contacts_per_day_aggregate';
  aggregate?: Maybe<New_Unqualified_Contacts_Per_Day_Aggregate_Fields>;
  nodes: Array<New_Unqualified_Contacts_Per_Day>;
};

export type New_Unqualified_Contacts_Per_Day_Aggregate_Bool_Exp = {
  count?: InputMaybe<New_Unqualified_Contacts_Per_Day_Aggregate_Bool_Exp_Count>;
};

export type New_Unqualified_Contacts_Per_Day_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<New_Unqualified_Contacts_Per_Day_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Aggregate_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_aggregate_fields';
  avg?: Maybe<New_Unqualified_Contacts_Per_Day_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<New_Unqualified_Contacts_Per_Day_Max_Fields>;
  min?: Maybe<New_Unqualified_Contacts_Per_Day_Min_Fields>;
  stddev?: Maybe<New_Unqualified_Contacts_Per_Day_Stddev_Fields>;
  stddev_pop?: Maybe<New_Unqualified_Contacts_Per_Day_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<New_Unqualified_Contacts_Per_Day_Stddev_Samp_Fields>;
  sum?: Maybe<New_Unqualified_Contacts_Per_Day_Sum_Fields>;
  var_pop?: Maybe<New_Unqualified_Contacts_Per_Day_Var_Pop_Fields>;
  var_samp?: Maybe<New_Unqualified_Contacts_Per_Day_Var_Samp_Fields>;
  variance?: Maybe<New_Unqualified_Contacts_Per_Day_Variance_Fields>;
};


/** aggregate fields of "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Aggregate_Order_By = {
  avg?: InputMaybe<New_Unqualified_Contacts_Per_Day_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<New_Unqualified_Contacts_Per_Day_Max_Order_By>;
  min?: InputMaybe<New_Unqualified_Contacts_Per_Day_Min_Order_By>;
  stddev?: InputMaybe<New_Unqualified_Contacts_Per_Day_Stddev_Order_By>;
  stddev_pop?: InputMaybe<New_Unqualified_Contacts_Per_Day_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<New_Unqualified_Contacts_Per_Day_Stddev_Samp_Order_By>;
  sum?: InputMaybe<New_Unqualified_Contacts_Per_Day_Sum_Order_By>;
  var_pop?: InputMaybe<New_Unqualified_Contacts_Per_Day_Var_Pop_Order_By>;
  var_samp?: InputMaybe<New_Unqualified_Contacts_Per_Day_Var_Samp_Order_By>;
  variance?: InputMaybe<New_Unqualified_Contacts_Per_Day_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Arr_Rel_Insert_Input = {
  data: Array<New_Unqualified_Contacts_Per_Day_Insert_Input>;
};

/** aggregate avg on columns */
export type New_Unqualified_Contacts_Per_Day_Avg_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_avg_fields';
  new_unqualified_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Avg_Order_By = {
  new_unqualified_contacts?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "new_unqualified_contacts_per_day". All fields are combined with a logical 'AND'. */
export type New_Unqualified_Contacts_Per_Day_Bool_Exp = {
  _and?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Bool_Exp>>;
  _not?: InputMaybe<New_Unqualified_Contacts_Per_Day_Bool_Exp>;
  _or?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<String_Comparison_Exp>;
  new_unqualified_contacts?: InputMaybe<Bigint_Comparison_Exp>;
  utm_source?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  new_unqualified_contacts?: InputMaybe<Scalars['bigint']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type New_Unqualified_Contacts_Per_Day_Max_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  new_unqualified_contacts?: Maybe<Scalars['bigint']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  new_unqualified_contacts?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type New_Unqualified_Contacts_Per_Day_Min_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  new_unqualified_contacts?: Maybe<Scalars['bigint']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  new_unqualified_contacts?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "new_unqualified_contacts_per_day". */
export type New_Unqualified_Contacts_Per_Day_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  new_unqualified_contacts?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
};

/** select columns of table "new_unqualified_contacts_per_day" */
export enum New_Unqualified_Contacts_Per_Day_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Date = 'date',
  /** column name */
  NewUnqualifiedContacts = 'new_unqualified_contacts',
  /** column name */
  UtmSource = 'utm_source'
}

/** aggregate stddev on columns */
export type New_Unqualified_Contacts_Per_Day_Stddev_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_stddev_fields';
  new_unqualified_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Stddev_Order_By = {
  new_unqualified_contacts?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type New_Unqualified_Contacts_Per_Day_Stddev_Pop_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_stddev_pop_fields';
  new_unqualified_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Stddev_Pop_Order_By = {
  new_unqualified_contacts?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type New_Unqualified_Contacts_Per_Day_Stddev_Samp_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_stddev_samp_fields';
  new_unqualified_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Stddev_Samp_Order_By = {
  new_unqualified_contacts?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: New_Unqualified_Contacts_Per_Day_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type New_Unqualified_Contacts_Per_Day_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  new_unqualified_contacts?: InputMaybe<Scalars['bigint']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type New_Unqualified_Contacts_Per_Day_Sum_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_sum_fields';
  new_unqualified_contacts?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Sum_Order_By = {
  new_unqualified_contacts?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type New_Unqualified_Contacts_Per_Day_Var_Pop_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_var_pop_fields';
  new_unqualified_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Var_Pop_Order_By = {
  new_unqualified_contacts?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type New_Unqualified_Contacts_Per_Day_Var_Samp_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_var_samp_fields';
  new_unqualified_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Var_Samp_Order_By = {
  new_unqualified_contacts?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type New_Unqualified_Contacts_Per_Day_Variance_Fields = {
  __typename?: 'new_unqualified_contacts_per_day_variance_fields';
  new_unqualified_contacts?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "new_unqualified_contacts_per_day" */
export type New_Unqualified_Contacts_Per_Day_Variance_Order_By = {
  new_unqualified_contacts?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** tracks b2b organizations */
export type Organization = {
  __typename?: 'organization';
  /** Wheter this is an active customer */
  active: Scalars['Boolean']['output'];
  /** An object relationship */
  budget?: Maybe<Organization_Budget>;
  /** An array relationship */
  campaigns: Array<Campaign>;
  /** An aggregate relationship */
  campaigns_aggregate: Campaign_Aggregate;
  color?: Maybe<Scalars['String']['output']>;
  /** 2 or 3 letter code for the country of the organization, e.g. DE, AUT */
  country_code?: Maybe<Scalars['bpchar']['output']>;
  /** url slug of the organization */
  id: Scalars['String']['output'];
  is_partner: Scalars['Boolean']['output'];
  /** Whether this organization is a test customer */
  is_test: Scalars['Boolean']['output'];
  logo_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The commodity of the short_name of the organization. For example, "die" for Huk => Die Huk. */
  name_prefix?: Maybe<Organization_Name_Prefix_Enum>;
  /** An object relationship */
  partner_organization?: Maybe<Organization>;
  partner_organization_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  regions: Array<Organization_Region>;
  /** An aggregate relationship */
  regions_aggregate: Organization_Region_Aggregate;
  /** An object relationship */
  rms_org_setup?: Maybe<Rms_Org_Setups>;
  /** An object relationship */
  settings?: Maybe<Organization_Settings>;
  /** The name to be used whenever a shorter variant of the name is needed. */
  short_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  sub_organizations: Array<Organization>;
  /** An aggregate relationship */
  sub_organizations_aggregate: Organization_Aggregate;
};


/** tracks b2b organizations */
export type OrganizationCampaignsArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_By>>;
  where?: InputMaybe<Campaign_Bool_Exp>;
};


/** tracks b2b organizations */
export type OrganizationCampaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_By>>;
  where?: InputMaybe<Campaign_Bool_Exp>;
};


/** tracks b2b organizations */
export type OrganizationRegionsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Region_Order_By>>;
  where?: InputMaybe<Organization_Region_Bool_Exp>;
};


/** tracks b2b organizations */
export type OrganizationRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Region_Order_By>>;
  where?: InputMaybe<Organization_Region_Bool_Exp>;
};


/** tracks b2b organizations */
export type OrganizationSub_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** tracks b2b organizations */
export type OrganizationSub_Organizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** aggregated selection of "organization" */
export type Organization_Aggregate = {
  __typename?: 'organization_aggregate';
  aggregate?: Maybe<Organization_Aggregate_Fields>;
  nodes: Array<Organization>;
};

export type Organization_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Aggregate_Bool_Exp_Count>;
};

export type Organization_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization" */
export type Organization_Aggregate_Fields = {
  __typename?: 'organization_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Max_Fields>;
  min?: Maybe<Organization_Min_Fields>;
};


/** aggregate fields of "organization" */
export type Organization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization" */
export type Organization_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Max_Order_By>;
  min?: InputMaybe<Organization_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization" */
export type Organization_Arr_Rel_Insert_Input = {
  data: Array<Organization_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization". All fields are combined with a logical 'AND'. */
export type Organization_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Bool_Exp>>;
  _not?: InputMaybe<Organization_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  budget?: InputMaybe<Organization_Budget_Bool_Exp>;
  campaigns?: InputMaybe<Campaign_Bool_Exp>;
  campaigns_aggregate?: InputMaybe<Campaign_Aggregate_Bool_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_partner?: InputMaybe<Boolean_Comparison_Exp>;
  is_test?: InputMaybe<Boolean_Comparison_Exp>;
  logo_url?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_prefix?: InputMaybe<Organization_Name_Prefix_Enum_Comparison_Exp>;
  partner_organization?: InputMaybe<Organization_Bool_Exp>;
  partner_organization_id?: InputMaybe<String_Comparison_Exp>;
  regions?: InputMaybe<Organization_Region_Bool_Exp>;
  regions_aggregate?: InputMaybe<Organization_Region_Aggregate_Bool_Exp>;
  rms_org_setup?: InputMaybe<Rms_Org_Setups_Bool_Exp>;
  settings?: InputMaybe<Organization_Settings_Bool_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  sub_organizations?: InputMaybe<Organization_Bool_Exp>;
  sub_organizations_aggregate?: InputMaybe<Organization_Aggregate_Bool_Exp>;
};

/** columns and relationships of "organization.budget" */
export type Organization_Budget = {
  __typename?: 'organization_budget';
  bonus?: Maybe<Scalars['numeric']['output']>;
  media_budget?: Maybe<Scalars['float8']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  spend?: Maybe<Scalars['float8']['output']>;
  total_budget?: Maybe<Scalars['float8']['output']>;
};

/** aggregated selection of "organization.budget" */
export type Organization_Budget_Aggregate = {
  __typename?: 'organization_budget_aggregate';
  aggregate?: Maybe<Organization_Budget_Aggregate_Fields>;
  nodes: Array<Organization_Budget>;
};

/** aggregate fields of "organization.budget" */
export type Organization_Budget_Aggregate_Fields = {
  __typename?: 'organization_budget_aggregate_fields';
  avg?: Maybe<Organization_Budget_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Budget_Max_Fields>;
  min?: Maybe<Organization_Budget_Min_Fields>;
  stddev?: Maybe<Organization_Budget_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Budget_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Budget_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Budget_Sum_Fields>;
  var_pop?: Maybe<Organization_Budget_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Budget_Var_Samp_Fields>;
  variance?: Maybe<Organization_Budget_Variance_Fields>;
};


/** aggregate fields of "organization.budget" */
export type Organization_Budget_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Budget_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Organization_Budget_Avg_Fields = {
  __typename?: 'organization_budget_avg_fields';
  bonus?: Maybe<Scalars['Float']['output']>;
  media_budget?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
  total_budget?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organization.budget". All fields are combined with a logical 'AND'. */
export type Organization_Budget_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Budget_Bool_Exp>>;
  _not?: InputMaybe<Organization_Budget_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Budget_Bool_Exp>>;
  bonus?: InputMaybe<Numeric_Comparison_Exp>;
  media_budget?: InputMaybe<Float8_Comparison_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
  spend?: InputMaybe<Float8_Comparison_Exp>;
  total_budget?: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for inserting data into table "organization.budget" */
export type Organization_Budget_Insert_Input = {
  bonus?: InputMaybe<Scalars['numeric']['input']>;
  media_budget?: InputMaybe<Scalars['float8']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  spend?: InputMaybe<Scalars['float8']['input']>;
  total_budget?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type Organization_Budget_Max_Fields = {
  __typename?: 'organization_budget_max_fields';
  bonus?: Maybe<Scalars['numeric']['output']>;
  media_budget?: Maybe<Scalars['float8']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  spend?: Maybe<Scalars['float8']['output']>;
  total_budget?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Organization_Budget_Min_Fields = {
  __typename?: 'organization_budget_min_fields';
  bonus?: Maybe<Scalars['numeric']['output']>;
  media_budget?: Maybe<Scalars['float8']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  spend?: Maybe<Scalars['float8']['output']>;
  total_budget?: Maybe<Scalars['float8']['output']>;
};

/** input type for inserting object relation for remote table "organization.budget" */
export type Organization_Budget_Obj_Rel_Insert_Input = {
  data: Organization_Budget_Insert_Input;
};

/** Ordering options when selecting data from "organization.budget". */
export type Organization_Budget_Order_By = {
  bonus?: InputMaybe<Order_By>;
  media_budget?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  spend?: InputMaybe<Order_By>;
  total_budget?: InputMaybe<Order_By>;
};

/** select columns of table "organization.budget" */
export enum Organization_Budget_Select_Column {
  /** column name */
  Bonus = 'bonus',
  /** column name */
  MediaBudget = 'media_budget',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Spend = 'spend',
  /** column name */
  TotalBudget = 'total_budget'
}

/** aggregate stddev on columns */
export type Organization_Budget_Stddev_Fields = {
  __typename?: 'organization_budget_stddev_fields';
  bonus?: Maybe<Scalars['Float']['output']>;
  media_budget?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
  total_budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Organization_Budget_Stddev_Pop_Fields = {
  __typename?: 'organization_budget_stddev_pop_fields';
  bonus?: Maybe<Scalars['Float']['output']>;
  media_budget?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
  total_budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Organization_Budget_Stddev_Samp_Fields = {
  __typename?: 'organization_budget_stddev_samp_fields';
  bonus?: Maybe<Scalars['Float']['output']>;
  media_budget?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
  total_budget?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "organization_budget" */
export type Organization_Budget_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Budget_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Budget_Stream_Cursor_Value_Input = {
  bonus?: InputMaybe<Scalars['numeric']['input']>;
  media_budget?: InputMaybe<Scalars['float8']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  spend?: InputMaybe<Scalars['float8']['input']>;
  total_budget?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Organization_Budget_Sum_Fields = {
  __typename?: 'organization_budget_sum_fields';
  bonus?: Maybe<Scalars['numeric']['output']>;
  media_budget?: Maybe<Scalars['float8']['output']>;
  spend?: Maybe<Scalars['float8']['output']>;
  total_budget?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Organization_Budget_Var_Pop_Fields = {
  __typename?: 'organization_budget_var_pop_fields';
  bonus?: Maybe<Scalars['Float']['output']>;
  media_budget?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
  total_budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Organization_Budget_Var_Samp_Fields = {
  __typename?: 'organization_budget_var_samp_fields';
  bonus?: Maybe<Scalars['Float']['output']>;
  media_budget?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
  total_budget?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Organization_Budget_Variance_Fields = {
  __typename?: 'organization_budget_variance_fields';
  bonus?: Maybe<Scalars['Float']['output']>;
  media_budget?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
  total_budget?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "organization" */
export enum Organization_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationPkey = 'organization_pkey'
}

/** columns and relationships of "organization_contacts_per_day" */
export type Organization_Contacts_Per_Day = {
  __typename?: 'organization_contacts_per_day';
  date?: Maybe<Scalars['String']['output']>;
  new_contacts?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  organization?: Maybe<Organization>;
  organization_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "organization_contacts_per_day" */
export type Organization_Contacts_Per_Day_Aggregate = {
  __typename?: 'organization_contacts_per_day_aggregate';
  aggregate?: Maybe<Organization_Contacts_Per_Day_Aggregate_Fields>;
  nodes: Array<Organization_Contacts_Per_Day>;
};

/** aggregate fields of "organization_contacts_per_day" */
export type Organization_Contacts_Per_Day_Aggregate_Fields = {
  __typename?: 'organization_contacts_per_day_aggregate_fields';
  avg?: Maybe<Organization_Contacts_Per_Day_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Contacts_Per_Day_Max_Fields>;
  min?: Maybe<Organization_Contacts_Per_Day_Min_Fields>;
  stddev?: Maybe<Organization_Contacts_Per_Day_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Contacts_Per_Day_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Contacts_Per_Day_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Contacts_Per_Day_Sum_Fields>;
  var_pop?: Maybe<Organization_Contacts_Per_Day_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Contacts_Per_Day_Var_Samp_Fields>;
  variance?: Maybe<Organization_Contacts_Per_Day_Variance_Fields>;
};


/** aggregate fields of "organization_contacts_per_day" */
export type Organization_Contacts_Per_Day_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Contacts_Per_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Organization_Contacts_Per_Day_Avg_Fields = {
  __typename?: 'organization_contacts_per_day_avg_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organization_contacts_per_day". All fields are combined with a logical 'AND'. */
export type Organization_Contacts_Per_Day_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Contacts_Per_Day_Bool_Exp>>;
  _not?: InputMaybe<Organization_Contacts_Per_Day_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Contacts_Per_Day_Bool_Exp>>;
  date?: InputMaybe<String_Comparison_Exp>;
  new_contacts?: InputMaybe<Bigint_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Organization_Contacts_Per_Day_Max_Fields = {
  __typename?: 'organization_contacts_per_day_max_fields';
  date?: Maybe<Scalars['String']['output']>;
  new_contacts?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organization_Contacts_Per_Day_Min_Fields = {
  __typename?: 'organization_contacts_per_day_min_fields';
  date?: Maybe<Scalars['String']['output']>;
  new_contacts?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "organization_contacts_per_day". */
export type Organization_Contacts_Per_Day_Order_By = {
  date?: InputMaybe<Order_By>;
  new_contacts?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** select columns of table "organization_contacts_per_day" */
export enum Organization_Contacts_Per_Day_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  NewContacts = 'new_contacts',
  /** column name */
  OrganizationId = 'organization_id'
}

/** aggregate stddev on columns */
export type Organization_Contacts_Per_Day_Stddev_Fields = {
  __typename?: 'organization_contacts_per_day_stddev_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Organization_Contacts_Per_Day_Stddev_Pop_Fields = {
  __typename?: 'organization_contacts_per_day_stddev_pop_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Organization_Contacts_Per_Day_Stddev_Samp_Fields = {
  __typename?: 'organization_contacts_per_day_stddev_samp_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "organization_contacts_per_day" */
export type Organization_Contacts_Per_Day_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Contacts_Per_Day_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Contacts_Per_Day_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['String']['input']>;
  new_contacts?: InputMaybe<Scalars['bigint']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Organization_Contacts_Per_Day_Sum_Fields = {
  __typename?: 'organization_contacts_per_day_sum_fields';
  new_contacts?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Organization_Contacts_Per_Day_Var_Pop_Fields = {
  __typename?: 'organization_contacts_per_day_var_pop_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Organization_Contacts_Per_Day_Var_Samp_Fields = {
  __typename?: 'organization_contacts_per_day_var_samp_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Organization_Contacts_Per_Day_Variance_Fields = {
  __typename?: 'organization_contacts_per_day_variance_fields';
  new_contacts?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting data into table "organization" */
export type Organization_Insert_Input = {
  /** Wheter this is an active customer */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Organization_Budget_Obj_Rel_Insert_Input>;
  campaigns?: InputMaybe<Campaign_Arr_Rel_Insert_Input>;
  color?: InputMaybe<Scalars['String']['input']>;
  /** 2 or 3 letter code for the country of the organization, e.g. DE, AUT */
  country_code?: InputMaybe<Scalars['bpchar']['input']>;
  /** url slug of the organization */
  id?: InputMaybe<Scalars['String']['input']>;
  is_partner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this organization is a test customer */
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The commodity of the short_name of the organization. For example, "die" for Huk => Die Huk. */
  name_prefix?: InputMaybe<Organization_Name_Prefix_Enum>;
  partner_organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  partner_organization_id?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Organization_Region_Arr_Rel_Insert_Input>;
  rms_org_setup?: InputMaybe<Rms_Org_Setups_Obj_Rel_Insert_Input>;
  settings?: InputMaybe<Organization_Settings_Obj_Rel_Insert_Input>;
  /** The name to be used whenever a shorter variant of the name is needed. */
  short_name?: InputMaybe<Scalars['String']['input']>;
  sub_organizations?: InputMaybe<Organization_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "organization.location" */
export type Organization_Location = {
  __typename?: 'organization_location';
  /** An array relationship */
  campaigns: Array<Campaign>;
  /** An aggregate relationship */
  campaigns_aggregate: Campaign_Aggregate;
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['String']['output'];
  /** An object relationship */
  parent_region?: Maybe<Organization_Region>;
  region_slug: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


/** columns and relationships of "organization.location" */
export type Organization_LocationCampaignsArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_By>>;
  where?: InputMaybe<Campaign_Bool_Exp>;
};


/** columns and relationships of "organization.location" */
export type Organization_LocationCampaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_By>>;
  where?: InputMaybe<Campaign_Bool_Exp>;
};

/** aggregated selection of "organization.location" */
export type Organization_Location_Aggregate = {
  __typename?: 'organization_location_aggregate';
  aggregate?: Maybe<Organization_Location_Aggregate_Fields>;
  nodes: Array<Organization_Location>;
};

export type Organization_Location_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Location_Aggregate_Bool_Exp_Count>;
};

export type Organization_Location_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Location_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization.location" */
export type Organization_Location_Aggregate_Fields = {
  __typename?: 'organization_location_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Location_Max_Fields>;
  min?: Maybe<Organization_Location_Min_Fields>;
};


/** aggregate fields of "organization.location" */
export type Organization_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization.location" */
export type Organization_Location_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Location_Max_Order_By>;
  min?: InputMaybe<Organization_Location_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization.location" */
export type Organization_Location_Arr_Rel_Insert_Input = {
  data: Array<Organization_Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Location_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization.location". All fields are combined with a logical 'AND'. */
export type Organization_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Location_Bool_Exp>>;
  _not?: InputMaybe<Organization_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Location_Bool_Exp>>;
  campaigns?: InputMaybe<Campaign_Bool_Exp>;
  campaigns_aggregate?: InputMaybe<Campaign_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
  parent_region?: InputMaybe<Organization_Region_Bool_Exp>;
  region_slug?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization.location" */
export enum Organization_Location_Constraint {
  /** unique or primary key constraint on columns "organization_id", "slug" */
  LocationPkey = 'location_pkey'
}

/** input type for inserting data into table "organization.location" */
export type Organization_Location_Insert_Input = {
  campaigns?: InputMaybe<Campaign_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  parent_region?: InputMaybe<Organization_Region_Obj_Rel_Insert_Input>;
  region_slug?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_Location_Max_Fields = {
  __typename?: 'organization_location_max_fields';
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  region_slug?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organization.location" */
export type Organization_Location_Max_Order_By = {
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  region_slug?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Location_Min_Fields = {
  __typename?: 'organization_location_min_fields';
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  region_slug?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organization.location" */
export type Organization_Location_Min_Order_By = {
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  region_slug?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization.location" */
export type Organization_Location_Mutation_Response = {
  __typename?: 'organization_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Location>;
};

/** input type for inserting object relation for remote table "organization.location" */
export type Organization_Location_Obj_Rel_Insert_Input = {
  data: Organization_Location_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Location_On_Conflict>;
};

/** on_conflict condition type for table "organization.location" */
export type Organization_Location_On_Conflict = {
  constraint: Organization_Location_Constraint;
  update_columns?: Array<Organization_Location_Update_Column>;
  where?: InputMaybe<Organization_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "organization.location". */
export type Organization_Location_Order_By = {
  campaigns_aggregate?: InputMaybe<Campaign_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parent_region?: InputMaybe<Organization_Region_Order_By>;
  region_slug?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization.location */
export type Organization_Location_Pk_Columns_Input = {
  organization_id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

/** select columns of table "organization.location" */
export enum Organization_Location_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RegionSlug = 'region_slug',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "organization.location" */
export type Organization_Location_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  region_slug?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_location" */
export type Organization_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Location_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  region_slug?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization.location" */
export enum Organization_Location_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RegionSlug = 'region_slug',
  /** column name */
  Slug = 'slug'
}

export type Organization_Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Location_Bool_Exp;
};

/** aggregate max on columns */
export type Organization_Max_Fields = {
  __typename?: 'organization_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  /** 2 or 3 letter code for the country of the organization, e.g. DE, AUT */
  country_code?: Maybe<Scalars['bpchar']['output']>;
  /** url slug of the organization */
  id?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner_organization_id?: Maybe<Scalars['String']['output']>;
  /** The name to be used whenever a shorter variant of the name is needed. */
  short_name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organization" */
export type Organization_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  /** 2 or 3 letter code for the country of the organization, e.g. DE, AUT */
  country_code?: InputMaybe<Order_By>;
  /** url slug of the organization */
  id?: InputMaybe<Order_By>;
  logo_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_organization_id?: InputMaybe<Order_By>;
  /** The name to be used whenever a shorter variant of the name is needed. */
  short_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Min_Fields = {
  __typename?: 'organization_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  /** 2 or 3 letter code for the country of the organization, e.g. DE, AUT */
  country_code?: Maybe<Scalars['bpchar']['output']>;
  /** url slug of the organization */
  id?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner_organization_id?: Maybe<Scalars['String']['output']>;
  /** The name to be used whenever a shorter variant of the name is needed. */
  short_name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organization" */
export type Organization_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  /** 2 or 3 letter code for the country of the organization, e.g. DE, AUT */
  country_code?: InputMaybe<Order_By>;
  /** url slug of the organization */
  id?: InputMaybe<Order_By>;
  logo_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_organization_id?: InputMaybe<Order_By>;
  /** The name to be used whenever a shorter variant of the name is needed. */
  short_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization" */
export type Organization_Mutation_Response = {
  __typename?: 'organization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization>;
};

/** columns and relationships of "organization_name_prefix" */
export type Organization_Name_Prefix = {
  __typename?: 'organization_name_prefix';
  value: Scalars['String']['output'];
};

/** aggregated selection of "organization_name_prefix" */
export type Organization_Name_Prefix_Aggregate = {
  __typename?: 'organization_name_prefix_aggregate';
  aggregate?: Maybe<Organization_Name_Prefix_Aggregate_Fields>;
  nodes: Array<Organization_Name_Prefix>;
};

/** aggregate fields of "organization_name_prefix" */
export type Organization_Name_Prefix_Aggregate_Fields = {
  __typename?: 'organization_name_prefix_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Name_Prefix_Max_Fields>;
  min?: Maybe<Organization_Name_Prefix_Min_Fields>;
};


/** aggregate fields of "organization_name_prefix" */
export type Organization_Name_Prefix_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Name_Prefix_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization_name_prefix". All fields are combined with a logical 'AND'. */
export type Organization_Name_Prefix_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Name_Prefix_Bool_Exp>>;
  _not?: InputMaybe<Organization_Name_Prefix_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Name_Prefix_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_name_prefix" */
export enum Organization_Name_Prefix_Constraint {
  /** unique or primary key constraint on columns "value" */
  OrganizationNamePrefixPkey = 'organization_name_prefix_pkey'
}

export enum Organization_Name_Prefix_Enum {
  Am = 'AM',
  Das = 'DAS',
  Der = 'DER',
  Die = 'DIE',
  Kein = 'KEIN'
}

/** Boolean expression to compare columns of type "organization_name_prefix_enum". All fields are combined with logical 'AND'. */
export type Organization_Name_Prefix_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Organization_Name_Prefix_Enum>;
  _in?: InputMaybe<Array<Organization_Name_Prefix_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Organization_Name_Prefix_Enum>;
  _nin?: InputMaybe<Array<Organization_Name_Prefix_Enum>>;
};

/** input type for inserting data into table "organization_name_prefix" */
export type Organization_Name_Prefix_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_Name_Prefix_Max_Fields = {
  __typename?: 'organization_name_prefix_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organization_Name_Prefix_Min_Fields = {
  __typename?: 'organization_name_prefix_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "organization_name_prefix" */
export type Organization_Name_Prefix_Mutation_Response = {
  __typename?: 'organization_name_prefix_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Name_Prefix>;
};

/** on_conflict condition type for table "organization_name_prefix" */
export type Organization_Name_Prefix_On_Conflict = {
  constraint: Organization_Name_Prefix_Constraint;
  update_columns?: Array<Organization_Name_Prefix_Update_Column>;
  where?: InputMaybe<Organization_Name_Prefix_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_name_prefix". */
export type Organization_Name_Prefix_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_name_prefix */
export type Organization_Name_Prefix_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "organization_name_prefix" */
export enum Organization_Name_Prefix_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "organization_name_prefix" */
export type Organization_Name_Prefix_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_name_prefix" */
export type Organization_Name_Prefix_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Name_Prefix_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Name_Prefix_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization_name_prefix" */
export enum Organization_Name_Prefix_Update_Column {
  /** column name */
  Value = 'value'
}

export type Organization_Name_Prefix_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Name_Prefix_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Name_Prefix_Bool_Exp;
};

/** app news */
export type Organization_News = {
  __typename?: 'organization_news';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organization_id?: Maybe<Scalars['String']['output']>;
  show_after: Scalars['timestamptz']['output'];
  show_until: Scalars['timestamp']['output'];
};

/** aggregated selection of "organization.news" */
export type Organization_News_Aggregate = {
  __typename?: 'organization_news_aggregate';
  aggregate?: Maybe<Organization_News_Aggregate_Fields>;
  nodes: Array<Organization_News>;
};

/** aggregate fields of "organization.news" */
export type Organization_News_Aggregate_Fields = {
  __typename?: 'organization_news_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_News_Max_Fields>;
  min?: Maybe<Organization_News_Min_Fields>;
};


/** aggregate fields of "organization.news" */
export type Organization_News_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_News_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization.news". All fields are combined with a logical 'AND'. */
export type Organization_News_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_News_Bool_Exp>>;
  _not?: InputMaybe<Organization_News_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_News_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
  show_after?: InputMaybe<Timestamptz_Comparison_Exp>;
  show_until?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization.news" */
export enum Organization_News_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  NewsOrganizationIdKey = 'news_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  NewsPkey = 'news_pkey'
}

/** input type for inserting data into table "organization.news" */
export type Organization_News_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  show_after?: InputMaybe<Scalars['timestamptz']['input']>;
  show_until?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Organization_News_Max_Fields = {
  __typename?: 'organization_news_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  show_after?: Maybe<Scalars['timestamptz']['output']>;
  show_until?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Organization_News_Min_Fields = {
  __typename?: 'organization_news_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  show_after?: Maybe<Scalars['timestamptz']['output']>;
  show_until?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "organization.news" */
export type Organization_News_Mutation_Response = {
  __typename?: 'organization_news_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_News>;
};

/** on_conflict condition type for table "organization.news" */
export type Organization_News_On_Conflict = {
  constraint: Organization_News_Constraint;
  update_columns?: Array<Organization_News_Update_Column>;
  where?: InputMaybe<Organization_News_Bool_Exp>;
};

/** Ordering options when selecting data from "organization.news". */
export type Organization_News_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  show_after?: InputMaybe<Order_By>;
  show_until?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization.news */
export type Organization_News_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization.news" */
export enum Organization_News_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ShowAfter = 'show_after',
  /** column name */
  ShowUntil = 'show_until'
}

/** input type for updating data in table "organization.news" */
export type Organization_News_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  show_after?: InputMaybe<Scalars['timestamptz']['input']>;
  show_until?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "organization_news" */
export type Organization_News_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_News_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_News_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  show_after?: InputMaybe<Scalars['timestamptz']['input']>;
  show_until?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "organization.news" */
export enum Organization_News_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ShowAfter = 'show_after',
  /** column name */
  ShowUntil = 'show_until'
}

export type Organization_News_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_News_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_News_Bool_Exp;
};

/** input type for inserting object relation for remote table "organization" */
export type Organization_Obj_Rel_Insert_Input = {
  data: Organization_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** on_conflict condition type for table "organization" */
export type Organization_On_Conflict = {
  constraint: Organization_Constraint;
  update_columns?: Array<Organization_Update_Column>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** Ordering options when selecting data from "organization". */
export type Organization_Order_By = {
  active?: InputMaybe<Order_By>;
  budget?: InputMaybe<Organization_Budget_Order_By>;
  campaigns_aggregate?: InputMaybe<Campaign_Aggregate_Order_By>;
  color?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_partner?: InputMaybe<Order_By>;
  is_test?: InputMaybe<Order_By>;
  logo_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_prefix?: InputMaybe<Order_By>;
  partner_organization?: InputMaybe<Organization_Order_By>;
  partner_organization_id?: InputMaybe<Order_By>;
  regions_aggregate?: InputMaybe<Organization_Region_Aggregate_Order_By>;
  rms_org_setup?: InputMaybe<Rms_Org_Setups_Order_By>;
  settings?: InputMaybe<Organization_Settings_Order_By>;
  short_name?: InputMaybe<Order_By>;
  sub_organizations_aggregate?: InputMaybe<Organization_Aggregate_Order_By>;
};

/** primary key columns input for table: organization */
export type Organization_Pk_Columns_Input = {
  /** url slug of the organization */
  id: Scalars['String']['input'];
};

/** columns and relationships of "organization.region" */
export type Organization_Region = {
  __typename?: 'organization_region';
  /** An array relationship */
  locations: Array<Organization_Location>;
  /** An aggregate relationship */
  locations_aggregate: Organization_Location_Aggregate;
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


/** columns and relationships of "organization.region" */
export type Organization_RegionLocationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Location_Order_By>>;
  where?: InputMaybe<Organization_Location_Bool_Exp>;
};


/** columns and relationships of "organization.region" */
export type Organization_RegionLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Location_Order_By>>;
  where?: InputMaybe<Organization_Location_Bool_Exp>;
};

/** aggregated selection of "organization.region" */
export type Organization_Region_Aggregate = {
  __typename?: 'organization_region_aggregate';
  aggregate?: Maybe<Organization_Region_Aggregate_Fields>;
  nodes: Array<Organization_Region>;
};

export type Organization_Region_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Region_Aggregate_Bool_Exp_Count>;
};

export type Organization_Region_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Region_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization.region" */
export type Organization_Region_Aggregate_Fields = {
  __typename?: 'organization_region_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Region_Max_Fields>;
  min?: Maybe<Organization_Region_Min_Fields>;
};


/** aggregate fields of "organization.region" */
export type Organization_Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization.region" */
export type Organization_Region_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Region_Max_Order_By>;
  min?: InputMaybe<Organization_Region_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization.region" */
export type Organization_Region_Arr_Rel_Insert_Input = {
  data: Array<Organization_Region_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Region_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization.region". All fields are combined with a logical 'AND'. */
export type Organization_Region_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Region_Bool_Exp>>;
  _not?: InputMaybe<Organization_Region_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Region_Bool_Exp>>;
  locations?: InputMaybe<Organization_Location_Bool_Exp>;
  locations_aggregate?: InputMaybe<Organization_Location_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization.region" */
export enum Organization_Region_Constraint {
  /** unique or primary key constraint on columns "organization_id", "slug" */
  RegionPkey = 'region_pkey'
}

/** input type for inserting data into table "organization.region" */
export type Organization_Region_Insert_Input = {
  locations?: InputMaybe<Organization_Location_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_Region_Max_Fields = {
  __typename?: 'organization_region_max_fields';
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organization.region" */
export type Organization_Region_Max_Order_By = {
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Region_Min_Fields = {
  __typename?: 'organization_region_min_fields';
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organization.region" */
export type Organization_Region_Min_Order_By = {
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization.region" */
export type Organization_Region_Mutation_Response = {
  __typename?: 'organization_region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Region>;
};

/** input type for inserting object relation for remote table "organization.region" */
export type Organization_Region_Obj_Rel_Insert_Input = {
  data: Organization_Region_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Region_On_Conflict>;
};

/** on_conflict condition type for table "organization.region" */
export type Organization_Region_On_Conflict = {
  constraint: Organization_Region_Constraint;
  update_columns?: Array<Organization_Region_Update_Column>;
  where?: InputMaybe<Organization_Region_Bool_Exp>;
};

/** Ordering options when selecting data from "organization.region". */
export type Organization_Region_Order_By = {
  locations_aggregate?: InputMaybe<Organization_Location_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization.region */
export type Organization_Region_Pk_Columns_Input = {
  organization_id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

/** select columns of table "organization.region" */
export enum Organization_Region_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "organization.region" */
export type Organization_Region_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_region" */
export type Organization_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Region_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization.region" */
export enum Organization_Region_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Slug = 'slug'
}

export type Organization_Region_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Region_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Region_Bool_Exp;
};

/** select columns of table "organization" */
export enum Organization_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Color = 'color',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsPartner = 'is_partner',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  Name = 'name',
  /** column name */
  NamePrefix = 'name_prefix',
  /** column name */
  PartnerOrganizationId = 'partner_organization_id',
  /** column name */
  ShortName = 'short_name'
}

/** select "organization_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization" */
export enum Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  IsPartner = 'is_partner',
  /** column name */
  IsTest = 'is_test'
}

/** select "organization_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization" */
export enum Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  IsPartner = 'is_partner',
  /** column name */
  IsTest = 'is_test'
}

/** input type for updating data in table "organization" */
export type Organization_Set_Input = {
  /** Wheter this is an active customer */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  /** 2 or 3 letter code for the country of the organization, e.g. DE, AUT */
  country_code?: InputMaybe<Scalars['bpchar']['input']>;
  /** url slug of the organization */
  id?: InputMaybe<Scalars['String']['input']>;
  is_partner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this organization is a test customer */
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The commodity of the short_name of the organization. For example, "die" for Huk => Die Huk. */
  name_prefix?: InputMaybe<Organization_Name_Prefix_Enum>;
  partner_organization_id?: InputMaybe<Scalars['String']['input']>;
  /** The name to be used whenever a shorter variant of the name is needed. */
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "organization.settings" */
export type Organization_Settings = {
  __typename?: 'organization_settings';
  address_formally: Scalars['Boolean']['output'];
  notification_emails_enabled: Scalars['Boolean']['output'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['String']['output'];
  rejection_emails_enabled: Scalars['Boolean']['output'];
  welcome_emails_enabled: Scalars['Boolean']['output'];
};

/** aggregated selection of "organization.settings" */
export type Organization_Settings_Aggregate = {
  __typename?: 'organization_settings_aggregate';
  aggregate?: Maybe<Organization_Settings_Aggregate_Fields>;
  nodes: Array<Organization_Settings>;
};

/** aggregate fields of "organization.settings" */
export type Organization_Settings_Aggregate_Fields = {
  __typename?: 'organization_settings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Settings_Max_Fields>;
  min?: Maybe<Organization_Settings_Min_Fields>;
};


/** aggregate fields of "organization.settings" */
export type Organization_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization.settings". All fields are combined with a logical 'AND'. */
export type Organization_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Settings_Bool_Exp>>;
  _not?: InputMaybe<Organization_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Settings_Bool_Exp>>;
  address_formally?: InputMaybe<Boolean_Comparison_Exp>;
  notification_emails_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
  rejection_emails_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welcome_emails_enabled?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization.settings" */
export enum Organization_Settings_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  SettingsPkey = 'settings_pkey'
}

/** input type for inserting data into table "organization.settings" */
export type Organization_Settings_Insert_Input = {
  address_formally?: InputMaybe<Scalars['Boolean']['input']>;
  notification_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  rejection_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  welcome_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Organization_Settings_Max_Fields = {
  __typename?: 'organization_settings_max_fields';
  organization_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organization_Settings_Min_Fields = {
  __typename?: 'organization_settings_min_fields';
  organization_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "organization.settings" */
export type Organization_Settings_Mutation_Response = {
  __typename?: 'organization_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Settings>;
};

/** input type for inserting object relation for remote table "organization.settings" */
export type Organization_Settings_Obj_Rel_Insert_Input = {
  data: Organization_Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Settings_On_Conflict>;
};

/** on_conflict condition type for table "organization.settings" */
export type Organization_Settings_On_Conflict = {
  constraint: Organization_Settings_Constraint;
  update_columns?: Array<Organization_Settings_Update_Column>;
  where?: InputMaybe<Organization_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "organization.settings". */
export type Organization_Settings_Order_By = {
  address_formally?: InputMaybe<Order_By>;
  notification_emails_enabled?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  rejection_emails_enabled?: InputMaybe<Order_By>;
  welcome_emails_enabled?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization.settings */
export type Organization_Settings_Pk_Columns_Input = {
  organization_id: Scalars['String']['input'];
};

/** select columns of table "organization.settings" */
export enum Organization_Settings_Select_Column {
  /** column name */
  AddressFormally = 'address_formally',
  /** column name */
  NotificationEmailsEnabled = 'notification_emails_enabled',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RejectionEmailsEnabled = 'rejection_emails_enabled',
  /** column name */
  WelcomeEmailsEnabled = 'welcome_emails_enabled'
}

/** input type for updating data in table "organization.settings" */
export type Organization_Settings_Set_Input = {
  address_formally?: InputMaybe<Scalars['Boolean']['input']>;
  notification_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  rejection_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  welcome_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "organization_settings" */
export type Organization_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Settings_Stream_Cursor_Value_Input = {
  address_formally?: InputMaybe<Scalars['Boolean']['input']>;
  notification_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  rejection_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  welcome_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "organization.settings" */
export enum Organization_Settings_Update_Column {
  /** column name */
  AddressFormally = 'address_formally',
  /** column name */
  NotificationEmailsEnabled = 'notification_emails_enabled',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RejectionEmailsEnabled = 'rejection_emails_enabled',
  /** column name */
  WelcomeEmailsEnabled = 'welcome_emails_enabled'
}

export type Organization_Settings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Settings_Bool_Exp;
};

/** Streaming cursor of the table "organization" */
export type Organization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Stream_Cursor_Value_Input = {
  /** Wheter this is an active customer */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  /** 2 or 3 letter code for the country of the organization, e.g. DE, AUT */
  country_code?: InputMaybe<Scalars['bpchar']['input']>;
  /** url slug of the organization */
  id?: InputMaybe<Scalars['String']['input']>;
  is_partner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this organization is a test customer */
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The commodity of the short_name of the organization. For example, "die" for Huk => Die Huk. */
  name_prefix?: InputMaybe<Organization_Name_Prefix_Enum>;
  partner_organization_id?: InputMaybe<Scalars['String']['input']>;
  /** The name to be used whenever a shorter variant of the name is needed. */
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization" */
export enum Organization_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Color = 'color',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsPartner = 'is_partner',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  Name = 'name',
  /** column name */
  NamePrefix = 'name_prefix',
  /** column name */
  PartnerOrganizationId = 'partner_organization_id',
  /** column name */
  ShortName = 'short_name'
}

export type Organization_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Bool_Exp;
};

/** tracks individual campaigns */
export type Perspective_Campaign = {
  __typename?: 'perspective_campaign';
  /** An object relationship */
  campaign?: Maybe<Campaign>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** aggregated selection of "perspective_campaign" */
export type Perspective_Campaign_Aggregate = {
  __typename?: 'perspective_campaign_aggregate';
  aggregate?: Maybe<Perspective_Campaign_Aggregate_Fields>;
  nodes: Array<Perspective_Campaign>;
};

/** aggregate fields of "perspective_campaign" */
export type Perspective_Campaign_Aggregate_Fields = {
  __typename?: 'perspective_campaign_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Perspective_Campaign_Max_Fields>;
  min?: Maybe<Perspective_Campaign_Min_Fields>;
};


/** aggregate fields of "perspective_campaign" */
export type Perspective_Campaign_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Perspective_Campaign_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "perspective_campaign". All fields are combined with a logical 'AND'. */
export type Perspective_Campaign_Bool_Exp = {
  _and?: InputMaybe<Array<Perspective_Campaign_Bool_Exp>>;
  _not?: InputMaybe<Perspective_Campaign_Bool_Exp>;
  _or?: InputMaybe<Array<Perspective_Campaign_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "perspective_campaign" */
export enum Perspective_Campaign_Constraint {
  /** unique or primary key constraint on columns "id" */
  CampaignPerspectiveIdKey = 'campaign_perspective_id_key',
  /** unique or primary key constraint on columns "id" */
  PerspectiveCampaignPkey = 'perspective_campaign_pkey'
}

/** input type for inserting data into table "perspective_campaign" */
export type Perspective_Campaign_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Perspective_Campaign_Max_Fields = {
  __typename?: 'perspective_campaign_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Perspective_Campaign_Min_Fields = {
  __typename?: 'perspective_campaign_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "perspective_campaign" */
export type Perspective_Campaign_Mutation_Response = {
  __typename?: 'perspective_campaign_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Perspective_Campaign>;
};

/** input type for inserting object relation for remote table "perspective_campaign" */
export type Perspective_Campaign_Obj_Rel_Insert_Input = {
  data: Perspective_Campaign_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Perspective_Campaign_On_Conflict>;
};

/** on_conflict condition type for table "perspective_campaign" */
export type Perspective_Campaign_On_Conflict = {
  constraint: Perspective_Campaign_Constraint;
  update_columns?: Array<Perspective_Campaign_Update_Column>;
  where?: InputMaybe<Perspective_Campaign_Bool_Exp>;
};

/** Ordering options when selecting data from "perspective_campaign". */
export type Perspective_Campaign_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: perspective_campaign */
export type Perspective_Campaign_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "perspective_campaign" */
export enum Perspective_Campaign_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "perspective_campaign" */
export type Perspective_Campaign_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "perspective_campaign" */
export type Perspective_Campaign_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Perspective_Campaign_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Perspective_Campaign_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "perspective_campaign" */
export enum Perspective_Campaign_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Url = 'url'
}

export type Perspective_Campaign_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Perspective_Campaign_Set_Input>;
  /** filter the rows which have to be updated */
  where: Perspective_Campaign_Bool_Exp;
};

/** columns and relationships of "qa_source" */
export type Qa_Source = {
  __typename?: 'qa_source';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "qa_source" */
export type Qa_Source_Aggregate = {
  __typename?: 'qa_source_aggregate';
  aggregate?: Maybe<Qa_Source_Aggregate_Fields>;
  nodes: Array<Qa_Source>;
};

/** aggregate fields of "qa_source" */
export type Qa_Source_Aggregate_Fields = {
  __typename?: 'qa_source_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Qa_Source_Max_Fields>;
  min?: Maybe<Qa_Source_Min_Fields>;
};


/** aggregate fields of "qa_source" */
export type Qa_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Qa_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "qa_source". All fields are combined with a logical 'AND'. */
export type Qa_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Qa_Source_Bool_Exp>>;
  _not?: InputMaybe<Qa_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Qa_Source_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "qa_source" */
export enum Qa_Source_Constraint {
  /** unique or primary key constraint on columns "value" */
  QaSourcePkey = 'qa_source_pkey'
}

export enum Qa_Source_Enum {
  /** Reserved for Landbot Q&A */
  ChatbotV1 = 'chatbot_v1',
  /** Legacy LLM chatbot (obsolete) */
  ChatbotV2 = 'chatbot_v2',
  /** Q&A completed via web funnel apply */
  Funnel = 'funnel',
  /** Q&A completed via Funnel Chatbot over WhatsApp */
  FunnelChatbot = 'funnel_chatbot'
}

/** Boolean expression to compare columns of type "qa_source_enum". All fields are combined with logical 'AND'. */
export type Qa_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Qa_Source_Enum>;
  _in?: InputMaybe<Array<Qa_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Qa_Source_Enum>;
  _nin?: InputMaybe<Array<Qa_Source_Enum>>;
};

/** input type for inserting data into table "qa_source" */
export type Qa_Source_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Qa_Source_Max_Fields = {
  __typename?: 'qa_source_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Qa_Source_Min_Fields = {
  __typename?: 'qa_source_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "qa_source" */
export type Qa_Source_Mutation_Response = {
  __typename?: 'qa_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Qa_Source>;
};

/** input type for inserting object relation for remote table "qa_source" */
export type Qa_Source_Obj_Rel_Insert_Input = {
  data: Qa_Source_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Qa_Source_On_Conflict>;
};

/** on_conflict condition type for table "qa_source" */
export type Qa_Source_On_Conflict = {
  constraint: Qa_Source_Constraint;
  update_columns?: Array<Qa_Source_Update_Column>;
  where?: InputMaybe<Qa_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "qa_source". */
export type Qa_Source_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: qa_source */
export type Qa_Source_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "qa_source" */
export enum Qa_Source_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "qa_source" */
export type Qa_Source_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "qa_source" */
export type Qa_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Qa_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Qa_Source_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "qa_source" */
export enum Qa_Source_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Qa_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Qa_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Qa_Source_Bool_Exp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** An array relationship */
  ad_campaign_metrics: Array<Ad_Campaign_Metrics>;
  /** An aggregate relationship */
  ad_campaign_metrics_aggregate: Ad_Campaign_Metrics_Aggregate;
  /** fetch data from the table: "ad.campaign_metrics" using primary key columns */
  ad_campaign_metrics_by_pk?: Maybe<Ad_Campaign_Metrics>;
  /** fetch data from the table: "ad.comment" */
  ad_comment: Array<Ad_Comment>;
  /** fetch aggregated fields from the table: "ad.comment" */
  ad_comment_aggregate: Ad_Comment_Aggregate;
  /** fetch data from the table: "ad.comment" using primary key columns */
  ad_comment_by_pk?: Maybe<Ad_Comment>;
  /** fetch data from the table: "ad.creative" */
  ad_creative: Array<Ad_Creative>;
  /** fetch aggregated fields from the table: "ad.creative" */
  ad_creative_aggregate: Ad_Creative_Aggregate;
  /** fetch data from the table: "ad.creative" using primary key columns */
  ad_creative_by_pk?: Maybe<Ad_Creative>;
  /** fetch data from the table: "ad.creative_feedback" */
  ad_creative_feedback: Array<Ad_Creative_Feedback>;
  /** fetch aggregated fields from the table: "ad.creative_feedback" */
  ad_creative_feedback_aggregate: Ad_Creative_Feedback_Aggregate;
  /** fetch data from the table: "ad.creative_feedback" using primary key columns */
  ad_creative_feedback_by_pk?: Maybe<Ad_Creative_Feedback>;
  /** fetch data from the table: "ad.platform" */
  ad_platform: Array<Ad_Platform>;
  /** fetch aggregated fields from the table: "ad.platform" */
  ad_platform_aggregate: Ad_Platform_Aggregate;
  /** fetch data from the table: "ad.platform" using primary key columns */
  ad_platform_by_pk?: Maybe<Ad_Platform>;
  /** fetch data from the table: "ad.providers" */
  ad_providers: Array<Ad_Providers>;
  /** fetch aggregated fields from the table: "ad.providers" */
  ad_providers_aggregate: Ad_Providers_Aggregate;
  /** fetch data from the table: "ad.providers" using primary key columns */
  ad_providers_by_pk?: Maybe<Ad_Providers>;
  /** fetch data from the table: "ad.setting" */
  ad_setting: Array<Ad_Setting>;
  /** fetch aggregated fields from the table: "ad.setting" */
  ad_setting_aggregate: Ad_Setting_Aggregate;
  /** fetch data from the table: "ad.setting" using primary key columns */
  ad_setting_by_pk?: Maybe<Ad_Setting>;
  /** fetch data from the table: "ad.status" */
  ad_status: Array<Ad_Status>;
  /** fetch aggregated fields from the table: "ad.status" */
  ad_status_aggregate: Ad_Status_Aggregate;
  /** fetch data from the table: "ad.status" using primary key columns */
  ad_status_by_pk?: Maybe<Ad_Status>;
  /** fetch data from the table: "anna_ai.call_campaigns" */
  anna_ai_call_campaigns: Array<Anna_Ai_Call_Campaigns>;
  /** fetch aggregated fields from the table: "anna_ai.call_campaigns" */
  anna_ai_call_campaigns_aggregate: Anna_Ai_Call_Campaigns_Aggregate;
  /** fetch data from the table: "anna_ai.call_campaigns" using primary key columns */
  anna_ai_call_campaigns_by_pk?: Maybe<Anna_Ai_Call_Campaigns>;
  /** fetch data from the table: "anna_ai.call_states" */
  anna_ai_call_states: Array<Anna_Ai_Call_States>;
  /** fetch aggregated fields from the table: "anna_ai.call_states" */
  anna_ai_call_states_aggregate: Anna_Ai_Call_States_Aggregate;
  /** fetch data from the table: "anna_ai.call_states" using primary key columns */
  anna_ai_call_states_by_pk?: Maybe<Anna_Ai_Call_States>;
  /** fetch data from the table: "anna_ai.outbound_calls" */
  anna_ai_outbound_calls: Array<Anna_Ai_Outbound_Calls>;
  /** fetch aggregated fields from the table: "anna_ai.outbound_calls" */
  anna_ai_outbound_calls_aggregate: Anna_Ai_Outbound_Calls_Aggregate;
  /** fetch data from the table: "anna_ai.outbound_calls" using primary key columns */
  anna_ai_outbound_calls_by_pk?: Maybe<Anna_Ai_Outbound_Calls>;
  /** fetch data from the table: "answer" */
  answer: Array<Answer>;
  /** fetch aggregated fields from the table: "answer" */
  answer_aggregate: Answer_Aggregate;
  /** fetch data from the table: "answer" using primary key columns */
  answer_by_pk?: Maybe<Answer>;
  /** fetch data from the table: "applicant.event" */
  applicant_event: Array<Applicant_Event>;
  /** fetch aggregated fields from the table: "applicant.event" */
  applicant_event_aggregate: Applicant_Event_Aggregate;
  /** fetch data from the table: "applicant.event" using primary key columns */
  applicant_event_by_pk?: Maybe<Applicant_Event>;
  /** fetch data from the table: "board.column_type" */
  board_column_type: Array<Board_Column_Type>;
  /** fetch aggregated fields from the table: "board.column_type" */
  board_column_type_aggregate: Board_Column_Type_Aggregate;
  /** fetch data from the table: "board.column_type" using primary key columns */
  board_column_type_by_pk?: Maybe<Board_Column_Type>;
  /** fetch data from the table: "board.contact_board" */
  board_contact_board: Array<Board_Contact_Board>;
  /** fetch aggregated fields from the table: "board.contact_board" */
  board_contact_board_aggregate: Board_Contact_Board_Aggregate;
  /** fetch data from the table: "board.contact_board" using primary key columns */
  board_contact_board_by_pk?: Maybe<Board_Contact_Board>;
  /** fetch data from the table: "board.contact_board_column" */
  board_contact_board_column: Array<Board_Contact_Board_Column>;
  /** fetch aggregated fields from the table: "board.contact_board_column" */
  board_contact_board_column_aggregate: Board_Contact_Board_Column_Aggregate;
  /** fetch data from the table: "board.contact_board_column" using primary key columns */
  board_contact_board_column_by_pk?: Maybe<Board_Contact_Board_Column>;
  /** fetch data from the table: "board.contact_board_entry" */
  board_contact_board_entry: Array<Board_Contact_Board_Entry>;
  /** fetch aggregated fields from the table: "board.contact_board_entry" */
  board_contact_board_entry_aggregate: Board_Contact_Board_Entry_Aggregate;
  /** fetch data from the table: "board.contact_board_entry" using primary key columns */
  board_contact_board_entry_by_pk?: Maybe<Board_Contact_Board_Entry>;
  /** fetch data from the table: "board.note" */
  board_note: Array<Board_Note>;
  /** fetch aggregated fields from the table: "board.note" */
  board_note_aggregate: Board_Note_Aggregate;
  /** fetch data from the table: "board.note" using primary key columns */
  board_note_by_pk?: Maybe<Board_Note>;
  /** fetch data from the table: "bot.assignee" */
  bot_assignee: Array<Bot_Assignee>;
  /** fetch aggregated fields from the table: "bot.assignee" */
  bot_assignee_aggregate: Bot_Assignee_Aggregate;
  /** fetch data from the table: "bot.assignee" using primary key columns */
  bot_assignee_by_pk?: Maybe<Bot_Assignee>;
  /** fetch data from the table: "bot.channel" */
  bot_channel: Array<Bot_Channel>;
  /** fetch aggregated fields from the table: "bot.channel" */
  bot_channel_aggregate: Bot_Channel_Aggregate;
  /** fetch data from the table: "bot.channel" using primary key columns */
  bot_channel_by_pk?: Maybe<Bot_Channel>;
  /** fetch data from the table: "bot.conversation" */
  bot_conversation: Array<Bot_Conversation>;
  /** fetch aggregated fields from the table: "bot.conversation" */
  bot_conversation_aggregate: Bot_Conversation_Aggregate;
  /** fetch data from the table: "bot.conversation" using primary key columns */
  bot_conversation_by_pk?: Maybe<Bot_Conversation>;
  /** fetch data from the table: "bot.conversation_state" */
  bot_conversation_state: Array<Bot_Conversation_State>;
  /** fetch aggregated fields from the table: "bot.conversation_state" */
  bot_conversation_state_aggregate: Bot_Conversation_State_Aggregate;
  /** fetch data from the table: "bot.conversation_state" using primary key columns */
  bot_conversation_state_by_pk?: Maybe<Bot_Conversation_State>;
  /** fetch data from the table: "bot.message" */
  bot_message: Array<Bot_Message>;
  /** fetch aggregated fields from the table: "bot.message" */
  bot_message_aggregate: Bot_Message_Aggregate;
  /** fetch data from the table: "bot.message" using primary key columns */
  bot_message_by_pk?: Maybe<Bot_Message>;
  /** fetch data from the table: "bot.message_status" */
  bot_message_status: Array<Bot_Message_Status>;
  /** fetch aggregated fields from the table: "bot.message_status" */
  bot_message_status_aggregate: Bot_Message_Status_Aggregate;
  /** fetch data from the table: "bot.message_status" using primary key columns */
  bot_message_status_by_pk?: Maybe<Bot_Message_Status>;
  /** fetch data from the table: "bot.sender" */
  bot_sender: Array<Bot_Sender>;
  /** fetch aggregated fields from the table: "bot.sender" */
  bot_sender_aggregate: Bot_Sender_Aggregate;
  /** fetch data from the table: "bot.sender" using primary key columns */
  bot_sender_by_pk?: Maybe<Bot_Sender>;
  /** fetch data from the table: "campaign" */
  campaign: Array<Campaign>;
  /** fetch data from the table: "campaign.ad" */
  campaign_ad: Array<Campaign_Ad>;
  /** fetch aggregated fields from the table: "campaign.ad" */
  campaign_ad_aggregate: Campaign_Ad_Aggregate;
  /** fetch data from the table: "campaign.ad" using primary key columns */
  campaign_ad_by_pk?: Maybe<Campaign_Ad>;
  /** fetch aggregated fields from the table: "campaign" */
  campaign_aggregate: Campaign_Aggregate;
  /** fetch data from the table: "campaign.budget" */
  campaign_budget: Array<Campaign_Budget>;
  /** fetch aggregated fields from the table: "campaign.budget" */
  campaign_budget_aggregate: Campaign_Budget_Aggregate;
  /** fetch data from the table: "campaign.budget_transaction" */
  campaign_budget_transaction: Array<Campaign_Budget_Transaction>;
  /** fetch aggregated fields from the table: "campaign.budget_transaction" */
  campaign_budget_transaction_aggregate: Campaign_Budget_Transaction_Aggregate;
  /** fetch data from the table: "campaign.budget_transaction" using primary key columns */
  campaign_budget_transaction_by_pk?: Maybe<Campaign_Budget_Transaction>;
  /** fetch data from the table: "campaign" using primary key columns */
  campaign_by_pk?: Maybe<Campaign>;
  /** fetch data from the table: "campaign.email_template_overwrite" */
  campaign_email_template_overwrite: Array<Campaign_Email_Template_Overwrite>;
  /** fetch aggregated fields from the table: "campaign.email_template_overwrite" */
  campaign_email_template_overwrite_aggregate: Campaign_Email_Template_Overwrite_Aggregate;
  /** fetch data from the table: "campaign.email_template_overwrite" using primary key columns */
  campaign_email_template_overwrite_by_pk?: Maybe<Campaign_Email_Template_Overwrite>;
  /** fetch data from the table: "campaign.event_log" */
  campaign_event_log: Array<Campaign_Event_Log>;
  /** fetch aggregated fields from the table: "campaign.event_log" */
  campaign_event_log_aggregate: Campaign_Event_Log_Aggregate;
  /** fetch data from the table: "campaign.event_log" using primary key columns */
  campaign_event_log_by_pk?: Maybe<Campaign_Event_Log>;
  /** execute function "campaign.get_daily_budget" which returns "campaign.budget_transaction" */
  campaign_get_daily_budget: Array<Campaign_Budget_Transaction>;
  /** execute function "campaign.get_daily_budget" and query aggregates on result of table type "campaign.budget_transaction" */
  campaign_get_daily_budget_aggregate: Campaign_Budget_Transaction_Aggregate;
  /** fetch data from the table: "campaign.iso_2_country_codes" */
  campaign_iso_2_country_codes: Array<Campaign_Iso_2_Country_Codes>;
  /** fetch aggregated fields from the table: "campaign.iso_2_country_codes" */
  campaign_iso_2_country_codes_aggregate: Campaign_Iso_2_Country_Codes_Aggregate;
  /** fetch data from the table: "campaign.iso_2_country_codes" using primary key columns */
  campaign_iso_2_country_codes_by_pk?: Maybe<Campaign_Iso_2_Country_Codes>;
  /** fetch data from the table: "campaign.job_description" */
  campaign_job_description: Array<Campaign_Job_Description>;
  /** fetch aggregated fields from the table: "campaign.job_description" */
  campaign_job_description_aggregate: Campaign_Job_Description_Aggregate;
  /** fetch data from the table: "campaign.job_description" using primary key columns */
  campaign_job_description_by_pk?: Maybe<Campaign_Job_Description>;
  /** fetch data from the table: "campaign.order" */
  campaign_order: Array<Campaign_Order>;
  /** fetch aggregated fields from the table: "campaign.order" */
  campaign_order_aggregate: Campaign_Order_Aggregate;
  /** fetch data from the table: "campaign.order" using primary key columns */
  campaign_order_by_pk?: Maybe<Campaign_Order>;
  /** fetch data from the table: "campaign.order_source" */
  campaign_order_source: Array<Campaign_Order_Source>;
  /** fetch aggregated fields from the table: "campaign.order_source" */
  campaign_order_source_aggregate: Campaign_Order_Source_Aggregate;
  /** fetch data from the table: "campaign.order_source" using primary key columns */
  campaign_order_source_by_pk?: Maybe<Campaign_Order_Source>;
  /** fetch data from the table: "campaign.order_source_type" */
  campaign_order_source_type: Array<Campaign_Order_Source_Type>;
  /** fetch aggregated fields from the table: "campaign.order_source_type" */
  campaign_order_source_type_aggregate: Campaign_Order_Source_Type_Aggregate;
  /** fetch data from the table: "campaign.order_source_type" using primary key columns */
  campaign_order_source_type_by_pk?: Maybe<Campaign_Order_Source_Type>;
  /** fetch data from the table: "campaign_routing.destination" */
  campaign_routing_destination: Array<Campaign_Routing_Destination>;
  /** fetch aggregated fields from the table: "campaign_routing.destination" */
  campaign_routing_destination_aggregate: Campaign_Routing_Destination_Aggregate;
  /** fetch data from the table: "campaign_routing.destination" using primary key columns */
  campaign_routing_destination_by_pk?: Maybe<Campaign_Routing_Destination>;
  /** fetch data from the table: "campaign_routing.info" */
  campaign_routing_info: Array<Campaign_Routing_Info>;
  /** fetch aggregated fields from the table: "campaign_routing.info" */
  campaign_routing_info_aggregate: Campaign_Routing_Info_Aggregate;
  /** fetch data from the table: "campaign_routing.info" using primary key columns */
  campaign_routing_info_by_pk?: Maybe<Campaign_Routing_Info>;
  /** fetch data from the table: "campaign_routing.zipcode" */
  campaign_routing_zipcode: Array<Campaign_Routing_Zipcode>;
  /** fetch aggregated fields from the table: "campaign_routing.zipcode" */
  campaign_routing_zipcode_aggregate: Campaign_Routing_Zipcode_Aggregate;
  /** fetch data from the table: "campaign_routing.zipcode" using primary key columns */
  campaign_routing_zipcode_by_pk?: Maybe<Campaign_Routing_Zipcode>;
  /** fetch data from the table: "campaign.settings_override" */
  campaign_settings_override: Array<Campaign_Settings_Override>;
  /** fetch aggregated fields from the table: "campaign.settings_override" */
  campaign_settings_override_aggregate: Campaign_Settings_Override_Aggregate;
  /** fetch data from the table: "campaign.settings_override" using primary key columns */
  campaign_settings_override_by_pk?: Maybe<Campaign_Settings_Override>;
  /** fetch data from the table: "campaign_status" */
  campaign_status: Array<Campaign_Status>;
  /** fetch aggregated fields from the table: "campaign_status" */
  campaign_status_aggregate: Campaign_Status_Aggregate;
  /** fetch data from the table: "campaign_status" using primary key columns */
  campaign_status_by_pk?: Maybe<Campaign_Status>;
  /** fetch data from the table: "campaign.status_event" */
  campaign_status_event: Array<Campaign_Status_Event>;
  /** fetch aggregated fields from the table: "campaign.status_event" */
  campaign_status_event_aggregate: Campaign_Status_Event_Aggregate;
  /** fetch data from the table: "campaign.status_event" using primary key columns */
  campaign_status_event_by_pk?: Maybe<Campaign_Status_Event>;
  /** fetch data from the table: "campaign.status_log" */
  campaign_status_log: Array<Campaign_Status_Log>;
  /** fetch aggregated fields from the table: "campaign.status_log" */
  campaign_status_log_aggregate: Campaign_Status_Log_Aggregate;
  /** fetch data from the table: "campaign.status_log" using primary key columns */
  campaign_status_log_by_pk?: Maybe<Campaign_Status_Log>;
  /** fetch data from the table: "campaign.transaction_type" */
  campaign_transaction_type: Array<Campaign_Transaction_Type>;
  /** fetch aggregated fields from the table: "campaign.transaction_type" */
  campaign_transaction_type_aggregate: Campaign_Transaction_Type_Aggregate;
  /** fetch data from the table: "campaign.transaction_type" using primary key columns */
  campaign_transaction_type_by_pk?: Maybe<Campaign_Transaction_Type>;
  /** fetch data from the table: "campaign_work_location" */
  campaign_work_location: Array<Campaign_Work_Location>;
  /** fetch aggregated fields from the table: "campaign_work_location" */
  campaign_work_location_aggregate: Campaign_Work_Location_Aggregate;
  /** fetch data from the table: "campaign_work_location" using primary key columns */
  campaign_work_location_by_pk?: Maybe<Campaign_Work_Location>;
  /** fetch data from the table: "chat_bot.customers" */
  chat_bot_customers: Array<Chat_Bot_Customers>;
  /** fetch aggregated fields from the table: "chat_bot.customers" */
  chat_bot_customers_aggregate: Chat_Bot_Customers_Aggregate;
  /** fetch data from the table: "chat_bot.customers" using primary key columns */
  chat_bot_customers_by_pk?: Maybe<Chat_Bot_Customers>;
  /** fetch data from the table: "chat_bot.forwarding" */
  chat_bot_forwarding: Array<Chat_Bot_Forwarding>;
  /** fetch aggregated fields from the table: "chat_bot.forwarding" */
  chat_bot_forwarding_aggregate: Chat_Bot_Forwarding_Aggregate;
  /** fetch data from the table: "chat_bot.forwarding" using primary key columns */
  chat_bot_forwarding_by_pk?: Maybe<Chat_Bot_Forwarding>;
  /** fetch data from the table: "chat_bot.message_type" */
  chat_bot_message_type: Array<Chat_Bot_Message_Type>;
  /** fetch aggregated fields from the table: "chat_bot.message_type" */
  chat_bot_message_type_aggregate: Chat_Bot_Message_Type_Aggregate;
  /** fetch data from the table: "chat_bot.message_type" using primary key columns */
  chat_bot_message_type_by_pk?: Maybe<Chat_Bot_Message_Type>;
  /** fetch data from the table: "chat_bot.messages" */
  chat_bot_messages: Array<Chat_Bot_Messages>;
  /** fetch aggregated fields from the table: "chat_bot.messages" */
  chat_bot_messages_aggregate: Chat_Bot_Messages_Aggregate;
  /** fetch data from the table: "chat_bot.messages" using primary key columns */
  chat_bot_messages_by_pk?: Maybe<Chat_Bot_Messages>;
  /** fetch data from the table: "contact" */
  contact: Array<Contact>;
  /** fetch aggregated fields from the table: "contact" */
  contact_aggregate: Contact_Aggregate;
  /** fetch data from the table: "contact" using primary key columns */
  contact_by_pk?: Maybe<Contact>;
  /** fetch data from the table: "contact.logs" */
  contact_logs: Array<Contact_Logs>;
  /** fetch aggregated fields from the table: "contact.logs" */
  contact_logs_aggregate: Contact_Logs_Aggregate;
  /** fetch data from the table: "contact.logs" using primary key columns */
  contact_logs_by_pk?: Maybe<Contact_Logs>;
  /** fetch data from the table: "file.pdf_templates" */
  file_pdf_templates: Array<File_Pdf_Templates>;
  /** fetch aggregated fields from the table: "file.pdf_templates" */
  file_pdf_templates_aggregate: File_Pdf_Templates_Aggregate;
  /** fetch data from the table: "file.pdf_templates" using primary key columns */
  file_pdf_templates_by_pk?: Maybe<File_Pdf_Templates>;
  /** fetch data from the table: "file.upload" */
  file_upload: Array<File_Upload>;
  /** fetch aggregated fields from the table: "file.upload" */
  file_upload_aggregate: File_Upload_Aggregate;
  /** fetch data from the table: "file.upload" using primary key columns */
  file_upload_by_pk?: Maybe<File_Upload>;
  /** fetch data from the table: "funnel.benefits" */
  funnel_benefits: Array<Funnel_Benefits>;
  /** fetch aggregated fields from the table: "funnel.benefits" */
  funnel_benefits_aggregate: Funnel_Benefits_Aggregate;
  /** fetch data from the table: "funnel.benefits" using primary key columns */
  funnel_benefits_by_pk?: Maybe<Funnel_Benefits>;
  /** fetch data from the table: "funnel.chatbot_message" */
  funnel_chatbot_message: Array<Funnel_Chatbot_Message>;
  /** fetch aggregated fields from the table: "funnel.chatbot_message" */
  funnel_chatbot_message_aggregate: Funnel_Chatbot_Message_Aggregate;
  /** fetch data from the table: "funnel.chatbot_message" using primary key columns */
  funnel_chatbot_message_by_pk?: Maybe<Funnel_Chatbot_Message>;
  /** fetch data from the table: "funnel.chatbot_session" */
  funnel_chatbot_session: Array<Funnel_Chatbot_Session>;
  /** fetch aggregated fields from the table: "funnel.chatbot_session" */
  funnel_chatbot_session_aggregate: Funnel_Chatbot_Session_Aggregate;
  /** fetch data from the table: "funnel.chatbot_session" using primary key columns */
  funnel_chatbot_session_by_pk?: Maybe<Funnel_Chatbot_Session>;
  /** fetch data from the table: "funnel.funnels" */
  funnel_funnels: Array<Funnel_Funnels>;
  /** fetch aggregated fields from the table: "funnel.funnels" */
  funnel_funnels_aggregate: Funnel_Funnels_Aggregate;
  /** fetch data from the table: "funnel.funnels" using primary key columns */
  funnel_funnels_by_pk?: Maybe<Funnel_Funnels>;
  /** fetch data from the table: "funnel.insights" */
  funnel_insights: Array<Funnel_Insights>;
  /** fetch aggregated fields from the table: "funnel.insights" */
  funnel_insights_aggregate: Funnel_Insights_Aggregate;
  /** An array relationship */
  funnel_page_insights: Array<Funnel_Page_Insights>;
  /** An aggregate relationship */
  funnel_page_insights_aggregate: Funnel_Page_Insights_Aggregate;
  /** fetch data from the table: "funnel.page_insights" using primary key columns */
  funnel_page_insights_by_pk?: Maybe<Funnel_Page_Insights>;
  /** fetch data from the table: "funnel.question" */
  funnel_question: Array<Funnel_Question>;
  /** fetch aggregated fields from the table: "funnel.question" */
  funnel_question_aggregate: Funnel_Question_Aggregate;
  /** fetch data from the table: "funnel.question" using primary key columns */
  funnel_question_by_pk?: Maybe<Funnel_Question>;
  /** fetch data from the table: "funnel.question_option" */
  funnel_question_option: Array<Funnel_Question_Option>;
  /** fetch aggregated fields from the table: "funnel.question_option" */
  funnel_question_option_aggregate: Funnel_Question_Option_Aggregate;
  /** fetch data from the table: "funnel.question_option" using primary key columns */
  funnel_question_option_by_pk?: Maybe<Funnel_Question_Option>;
  /** An array relationship */
  funnel_whatsapp_share_clicks: Array<Funnel_Whatsapp_Share_Clicks>;
  /** An aggregate relationship */
  funnel_whatsapp_share_clicks_aggregate: Funnel_Whatsapp_Share_Clicks_Aggregate;
  /** fetch data from the table: "funnel.whatsapp_share_clicks" using primary key columns */
  funnel_whatsapp_share_clicks_by_pk?: Maybe<Funnel_Whatsapp_Share_Clicks>;
  /** fetch data from the table: "huk_contacts" */
  huk_contacts: Array<Huk_Contacts>;
  /** fetch aggregated fields from the table: "huk_contacts" */
  huk_contacts_aggregate: Huk_Contacts_Aggregate;
  /** fetch data from the table: "new_contacts_per_day" */
  new_contacts_per_day: Array<New_Contacts_Per_Day>;
  /** fetch aggregated fields from the table: "new_contacts_per_day" */
  new_contacts_per_day_aggregate: New_Contacts_Per_Day_Aggregate;
  /** fetch data from the table: "new_unqualified_contacts_per_day" */
  new_unqualified_contacts_per_day: Array<New_Unqualified_Contacts_Per_Day>;
  /** fetch aggregated fields from the table: "new_unqualified_contacts_per_day" */
  new_unqualified_contacts_per_day_aggregate: New_Unqualified_Contacts_Per_Day_Aggregate;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization.budget" */
  organization_budget: Array<Organization_Budget>;
  /** fetch aggregated fields from the table: "organization.budget" */
  organization_budget_aggregate: Organization_Budget_Aggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "organization_contacts_per_day" */
  organization_contacts_per_day: Array<Organization_Contacts_Per_Day>;
  /** fetch aggregated fields from the table: "organization_contacts_per_day" */
  organization_contacts_per_day_aggregate: Organization_Contacts_Per_Day_Aggregate;
  /** fetch data from the table: "organization.location" */
  organization_location: Array<Organization_Location>;
  /** fetch aggregated fields from the table: "organization.location" */
  organization_location_aggregate: Organization_Location_Aggregate;
  /** fetch data from the table: "organization.location" using primary key columns */
  organization_location_by_pk?: Maybe<Organization_Location>;
  /** fetch data from the table: "organization_name_prefix" */
  organization_name_prefix: Array<Organization_Name_Prefix>;
  /** fetch aggregated fields from the table: "organization_name_prefix" */
  organization_name_prefix_aggregate: Organization_Name_Prefix_Aggregate;
  /** fetch data from the table: "organization_name_prefix" using primary key columns */
  organization_name_prefix_by_pk?: Maybe<Organization_Name_Prefix>;
  /** fetch data from the table: "organization.news" */
  organization_news: Array<Organization_News>;
  /** fetch aggregated fields from the table: "organization.news" */
  organization_news_aggregate: Organization_News_Aggregate;
  /** fetch data from the table: "organization.news" using primary key columns */
  organization_news_by_pk?: Maybe<Organization_News>;
  /** fetch data from the table: "organization.region" */
  organization_region: Array<Organization_Region>;
  /** fetch aggregated fields from the table: "organization.region" */
  organization_region_aggregate: Organization_Region_Aggregate;
  /** fetch data from the table: "organization.region" using primary key columns */
  organization_region_by_pk?: Maybe<Organization_Region>;
  /** fetch data from the table: "organization.settings" */
  organization_settings: Array<Organization_Settings>;
  /** fetch aggregated fields from the table: "organization.settings" */
  organization_settings_aggregate: Organization_Settings_Aggregate;
  /** fetch data from the table: "organization.settings" using primary key columns */
  organization_settings_by_pk?: Maybe<Organization_Settings>;
  /** fetch data from the table: "perspective_campaign" */
  perspective_campaign: Array<Perspective_Campaign>;
  /** fetch aggregated fields from the table: "perspective_campaign" */
  perspective_campaign_aggregate: Perspective_Campaign_Aggregate;
  /** fetch data from the table: "perspective_campaign" using primary key columns */
  perspective_campaign_by_pk?: Maybe<Perspective_Campaign>;
  /** fetch data from the table: "qa_source" */
  qa_source: Array<Qa_Source>;
  /** fetch aggregated fields from the table: "qa_source" */
  qa_source_aggregate: Qa_Source_Aggregate;
  /** fetch data from the table: "qa_source" using primary key columns */
  qa_source_by_pk?: Maybe<Qa_Source>;
  /** fetch data from the table: "rms.connectors" */
  rms_connectors: Array<Rms_Connectors>;
  /** fetch aggregated fields from the table: "rms.connectors" */
  rms_connectors_aggregate: Rms_Connectors_Aggregate;
  /** fetch data from the table: "rms.connectors" using primary key columns */
  rms_connectors_by_pk?: Maybe<Rms_Connectors>;
  /** fetch data from the table: "rms.forwarded_logs" */
  rms_forwarded_logs: Array<Rms_Forwarded_Logs>;
  /** fetch aggregated fields from the table: "rms.forwarded_logs" */
  rms_forwarded_logs_aggregate: Rms_Forwarded_Logs_Aggregate;
  /** fetch data from the table: "rms.forwarded_logs" using primary key columns */
  rms_forwarded_logs_by_pk?: Maybe<Rms_Forwarded_Logs>;
  /** fetch data from the table: "rms.org_setups" */
  rms_org_setups: Array<Rms_Org_Setups>;
  /** fetch aggregated fields from the table: "rms.org_setups" */
  rms_org_setups_aggregate: Rms_Org_Setups_Aggregate;
  /** fetch data from the table: "rms.org_setups" using primary key columns */
  rms_org_setups_by_pk?: Maybe<Rms_Org_Setups>;
  /** fetch data from the table: "system.api_keys" */
  system_api_keys: Array<System_Api_Keys>;
  /** fetch aggregated fields from the table: "system.api_keys" */
  system_api_keys_aggregate: System_Api_Keys_Aggregate;
  /** fetch data from the table: "system.api_keys" using primary key columns */
  system_api_keys_by_pk?: Maybe<System_Api_Keys>;
  /** fetch data from the table: "system.call_daily_stats" */
  system_call_daily_stats: Array<System_Call_Daily_Stats>;
  /** fetch aggregated fields from the table: "system.call_daily_stats" */
  system_call_daily_stats_aggregate: System_Call_Daily_Stats_Aggregate;
  /** fetch data from the table: "system.call_daily_stats" using primary key columns */
  system_call_daily_stats_by_pk?: Maybe<System_Call_Daily_Stats>;
  /** fetch data from the table: "system.email_daily_stats" */
  system_email_daily_stats: Array<System_Email_Daily_Stats>;
  /** fetch aggregated fields from the table: "system.email_daily_stats" */
  system_email_daily_stats_aggregate: System_Email_Daily_Stats_Aggregate;
  /** fetch data from the table: "system.email_daily_stats" using primary key columns */
  system_email_daily_stats_by_pk?: Maybe<System_Email_Daily_Stats>;
  /** fetch data from the table: "system.running_release" */
  system_running_release: Array<System_Running_Release>;
  /** fetch aggregated fields from the table: "system.running_release" */
  system_running_release_aggregate: System_Running_Release_Aggregate;
  /** fetch data from the table: "system.running_release" using primary key columns */
  system_running_release_by_pk?: Maybe<System_Running_Release>;
  /** fetch data from the table: "system.sms_daily_stats" */
  system_sms_daily_stats: Array<System_Sms_Daily_Stats>;
  /** fetch aggregated fields from the table: "system.sms_daily_stats" */
  system_sms_daily_stats_aggregate: System_Sms_Daily_Stats_Aggregate;
  /** fetch data from the table: "system.sms_daily_stats" using primary key columns */
  system_sms_daily_stats_by_pk?: Maybe<System_Sms_Daily_Stats>;
};


export type Query_RootAd_Campaign_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Metrics_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
};


export type Query_RootAd_Campaign_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Metrics_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
};


export type Query_RootAd_Campaign_Metrics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAd_CommentArgs = {
  distinct_on?: InputMaybe<Array<Ad_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Comment_Order_By>>;
  where?: InputMaybe<Ad_Comment_Bool_Exp>;
};


export type Query_RootAd_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Comment_Order_By>>;
  where?: InputMaybe<Ad_Comment_Bool_Exp>;
};


export type Query_RootAd_Comment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAd_CreativeArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Order_By>>;
  where?: InputMaybe<Ad_Creative_Bool_Exp>;
};


export type Query_RootAd_Creative_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Order_By>>;
  where?: InputMaybe<Ad_Creative_Bool_Exp>;
};


export type Query_RootAd_Creative_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAd_Creative_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Feedback_Order_By>>;
  where?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
};


export type Query_RootAd_Creative_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Feedback_Order_By>>;
  where?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
};


export type Query_RootAd_Creative_Feedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAd_PlatformArgs = {
  distinct_on?: InputMaybe<Array<Ad_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Platform_Order_By>>;
  where?: InputMaybe<Ad_Platform_Bool_Exp>;
};


export type Query_RootAd_Platform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Platform_Order_By>>;
  where?: InputMaybe<Ad_Platform_Bool_Exp>;
};


export type Query_RootAd_Platform_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAd_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Ad_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Providers_Order_By>>;
  where?: InputMaybe<Ad_Providers_Bool_Exp>;
};


export type Query_RootAd_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Providers_Order_By>>;
  where?: InputMaybe<Ad_Providers_Bool_Exp>;
};


export type Query_RootAd_Providers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAd_SettingArgs = {
  distinct_on?: InputMaybe<Array<Ad_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Setting_Order_By>>;
  where?: InputMaybe<Ad_Setting_Bool_Exp>;
};


export type Query_RootAd_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Setting_Order_By>>;
  where?: InputMaybe<Ad_Setting_Bool_Exp>;
};


export type Query_RootAd_Setting_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAd_StatusArgs = {
  distinct_on?: InputMaybe<Array<Ad_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Status_Order_By>>;
  where?: InputMaybe<Ad_Status_Bool_Exp>;
};


export type Query_RootAd_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Status_Order_By>>;
  where?: InputMaybe<Ad_Status_Bool_Exp>;
};


export type Query_RootAd_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAnna_Ai_Call_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Order_By>>;
  where?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
};


export type Query_RootAnna_Ai_Call_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Order_By>>;
  where?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
};


export type Query_RootAnna_Ai_Call_Campaigns_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAnna_Ai_Call_StatesArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Call_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Call_States_Order_By>>;
  where?: InputMaybe<Anna_Ai_Call_States_Bool_Exp>;
};


export type Query_RootAnna_Ai_Call_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Call_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Call_States_Order_By>>;
  where?: InputMaybe<Anna_Ai_Call_States_Bool_Exp>;
};


export type Query_RootAnna_Ai_Call_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAnna_Ai_Outbound_CallsArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Order_By>>;
  where?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
};


export type Query_RootAnna_Ai_Outbound_Calls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Order_By>>;
  where?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
};


export type Query_RootAnna_Ai_Outbound_Calls_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAnswerArgs = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By>>;
  where?: InputMaybe<Answer_Bool_Exp>;
};


export type Query_RootAnswer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By>>;
  where?: InputMaybe<Answer_Bool_Exp>;
};


export type Query_RootAnswer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplicant_EventArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Event_Order_By>>;
  where?: InputMaybe<Applicant_Event_Bool_Exp>;
};


export type Query_RootApplicant_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Event_Order_By>>;
  where?: InputMaybe<Applicant_Event_Bool_Exp>;
};


export type Query_RootApplicant_Event_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootBoard_Column_TypeArgs = {
  distinct_on?: InputMaybe<Array<Board_Column_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Column_Type_Order_By>>;
  where?: InputMaybe<Board_Column_Type_Bool_Exp>;
};


export type Query_RootBoard_Column_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Column_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Column_Type_Order_By>>;
  where?: InputMaybe<Board_Column_Type_Bool_Exp>;
};


export type Query_RootBoard_Column_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootBoard_Contact_BoardArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Bool_Exp>;
};


export type Query_RootBoard_Contact_Board_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Bool_Exp>;
};


export type Query_RootBoard_Contact_Board_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBoard_Contact_Board_ColumnArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Column_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
};


export type Query_RootBoard_Contact_Board_Column_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Column_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
};


export type Query_RootBoard_Contact_Board_Column_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBoard_Contact_Board_EntryArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Entry_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
};


export type Query_RootBoard_Contact_Board_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Entry_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
};


export type Query_RootBoard_Contact_Board_Entry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBoard_NoteArgs = {
  distinct_on?: InputMaybe<Array<Board_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Note_Order_By>>;
  where?: InputMaybe<Board_Note_Bool_Exp>;
};


export type Query_RootBoard_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Note_Order_By>>;
  where?: InputMaybe<Board_Note_Bool_Exp>;
};


export type Query_RootBoard_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBot_AssigneeArgs = {
  distinct_on?: InputMaybe<Array<Bot_Assignee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Assignee_Order_By>>;
  where?: InputMaybe<Bot_Assignee_Bool_Exp>;
};


export type Query_RootBot_Assignee_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Assignee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Assignee_Order_By>>;
  where?: InputMaybe<Bot_Assignee_Bool_Exp>;
};


export type Query_RootBot_Assignee_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootBot_ChannelArgs = {
  distinct_on?: InputMaybe<Array<Bot_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Channel_Order_By>>;
  where?: InputMaybe<Bot_Channel_Bool_Exp>;
};


export type Query_RootBot_Channel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Channel_Order_By>>;
  where?: InputMaybe<Bot_Channel_Bool_Exp>;
};


export type Query_RootBot_Channel_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootBot_ConversationArgs = {
  distinct_on?: InputMaybe<Array<Bot_Conversation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Conversation_Order_By>>;
  where?: InputMaybe<Bot_Conversation_Bool_Exp>;
};


export type Query_RootBot_Conversation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Conversation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Conversation_Order_By>>;
  where?: InputMaybe<Bot_Conversation_Bool_Exp>;
};


export type Query_RootBot_Conversation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBot_Conversation_StateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Conversation_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Conversation_State_Order_By>>;
  where?: InputMaybe<Bot_Conversation_State_Bool_Exp>;
};


export type Query_RootBot_Conversation_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Conversation_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Conversation_State_Order_By>>;
  where?: InputMaybe<Bot_Conversation_State_Bool_Exp>;
};


export type Query_RootBot_Conversation_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootBot_MessageArgs = {
  distinct_on?: InputMaybe<Array<Bot_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Message_Order_By>>;
  where?: InputMaybe<Bot_Message_Bool_Exp>;
};


export type Query_RootBot_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Message_Order_By>>;
  where?: InputMaybe<Bot_Message_Bool_Exp>;
};


export type Query_RootBot_Message_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBot_Message_StatusArgs = {
  distinct_on?: InputMaybe<Array<Bot_Message_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Message_Status_Order_By>>;
  where?: InputMaybe<Bot_Message_Status_Bool_Exp>;
};


export type Query_RootBot_Message_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Message_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Message_Status_Order_By>>;
  where?: InputMaybe<Bot_Message_Status_Bool_Exp>;
};


export type Query_RootBot_Message_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootBot_SenderArgs = {
  distinct_on?: InputMaybe<Array<Bot_Sender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Sender_Order_By>>;
  where?: InputMaybe<Bot_Sender_Bool_Exp>;
};


export type Query_RootBot_Sender_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Sender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Sender_Order_By>>;
  where?: InputMaybe<Bot_Sender_Bool_Exp>;
};


export type Query_RootBot_Sender_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCampaignArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_By>>;
  where?: InputMaybe<Campaign_Bool_Exp>;
};


export type Query_RootCampaign_AdArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Ad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Ad_Order_By>>;
  where?: InputMaybe<Campaign_Ad_Bool_Exp>;
};


export type Query_RootCampaign_Ad_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Ad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Ad_Order_By>>;
  where?: InputMaybe<Campaign_Ad_Bool_Exp>;
};


export type Query_RootCampaign_Ad_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCampaign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_By>>;
  where?: InputMaybe<Campaign_Bool_Exp>;
};


export type Query_RootCampaign_BudgetArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Budget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Bool_Exp>;
};


export type Query_RootCampaign_Budget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Budget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Bool_Exp>;
};


export type Query_RootCampaign_Budget_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Transaction_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


export type Query_RootCampaign_Budget_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Transaction_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


export type Query_RootCampaign_Budget_Transaction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCampaign_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCampaign_Email_Template_OverwriteArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Order_By>>;
  where?: InputMaybe<Campaign_Email_Template_Overwrite_Bool_Exp>;
};


export type Query_RootCampaign_Email_Template_Overwrite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Order_By>>;
  where?: InputMaybe<Campaign_Email_Template_Overwrite_Bool_Exp>;
};


export type Query_RootCampaign_Email_Template_Overwrite_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


export type Query_RootCampaign_Event_LogArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Event_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Event_Log_Order_By>>;
  where?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
};


export type Query_RootCampaign_Event_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Event_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Event_Log_Order_By>>;
  where?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
};


export type Query_RootCampaign_Event_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCampaign_Get_Daily_BudgetArgs = {
  args: Campaign_Get_Daily_Budget_Args;
  distinct_on?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Transaction_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


export type Query_RootCampaign_Get_Daily_Budget_AggregateArgs = {
  args: Campaign_Get_Daily_Budget_Args;
  distinct_on?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Transaction_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


export type Query_RootCampaign_Iso_2_Country_CodesArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Order_By>>;
  where?: InputMaybe<Campaign_Iso_2_Country_Codes_Bool_Exp>;
};


export type Query_RootCampaign_Iso_2_Country_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Order_By>>;
  where?: InputMaybe<Campaign_Iso_2_Country_Codes_Bool_Exp>;
};


export type Query_RootCampaign_Iso_2_Country_Codes_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCampaign_Job_DescriptionArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Job_Description_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Job_Description_Order_By>>;
  where?: InputMaybe<Campaign_Job_Description_Bool_Exp>;
};


export type Query_RootCampaign_Job_Description_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Job_Description_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Job_Description_Order_By>>;
  where?: InputMaybe<Campaign_Job_Description_Bool_Exp>;
};


export type Query_RootCampaign_Job_Description_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


export type Query_RootCampaign_OrderArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Order_By>>;
  where?: InputMaybe<Campaign_Order_Bool_Exp>;
};


export type Query_RootCampaign_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Order_By>>;
  where?: InputMaybe<Campaign_Order_Bool_Exp>;
};


export type Query_RootCampaign_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCampaign_Order_SourceArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Source_Order_By>>;
  where?: InputMaybe<Campaign_Order_Source_Bool_Exp>;
};


export type Query_RootCampaign_Order_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Source_Order_By>>;
  where?: InputMaybe<Campaign_Order_Source_Bool_Exp>;
};


export type Query_RootCampaign_Order_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCampaign_Order_Source_TypeArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Source_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Source_Type_Order_By>>;
  where?: InputMaybe<Campaign_Order_Source_Type_Bool_Exp>;
};


export type Query_RootCampaign_Order_Source_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Source_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Source_Type_Order_By>>;
  where?: InputMaybe<Campaign_Order_Source_Type_Bool_Exp>;
};


export type Query_RootCampaign_Order_Source_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCampaign_Routing_DestinationArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Destination_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Destination_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
};


export type Query_RootCampaign_Routing_Destination_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Destination_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Destination_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
};


export type Query_RootCampaign_Routing_Destination_By_PkArgs = {
  location_id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};


export type Query_RootCampaign_Routing_InfoArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Info_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Info_Bool_Exp>;
};


export type Query_RootCampaign_Routing_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Info_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Info_Bool_Exp>;
};


export type Query_RootCampaign_Routing_Info_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


export type Query_RootCampaign_Routing_ZipcodeArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Zipcode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Zipcode_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Zipcode_Bool_Exp>;
};


export type Query_RootCampaign_Routing_Zipcode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Zipcode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Zipcode_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Zipcode_Bool_Exp>;
};


export type Query_RootCampaign_Routing_Zipcode_By_PkArgs = {
  organization_id: Scalars['String']['input'];
  zipcode: Scalars['bpchar']['input'];
};


export type Query_RootCampaign_Settings_OverrideArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Settings_Override_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Settings_Override_Order_By>>;
  where?: InputMaybe<Campaign_Settings_Override_Bool_Exp>;
};


export type Query_RootCampaign_Settings_Override_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Settings_Override_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Settings_Override_Order_By>>;
  where?: InputMaybe<Campaign_Settings_Override_Bool_Exp>;
};


export type Query_RootCampaign_Settings_Override_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


export type Query_RootCampaign_StatusArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Order_By>>;
  where?: InputMaybe<Campaign_Status_Bool_Exp>;
};


export type Query_RootCampaign_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Order_By>>;
  where?: InputMaybe<Campaign_Status_Bool_Exp>;
};


export type Query_RootCampaign_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCampaign_Status_EventArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Event_Order_By>>;
  where?: InputMaybe<Campaign_Status_Event_Bool_Exp>;
};


export type Query_RootCampaign_Status_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Event_Order_By>>;
  where?: InputMaybe<Campaign_Status_Event_Bool_Exp>;
};


export type Query_RootCampaign_Status_Event_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCampaign_Status_LogArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Log_Order_By>>;
  where?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
};


export type Query_RootCampaign_Status_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Log_Order_By>>;
  where?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
};


export type Query_RootCampaign_Status_Log_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
  created_at: Scalars['timestamptz']['input'];
};


export type Query_RootCampaign_Transaction_TypeArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Transaction_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Transaction_Type_Order_By>>;
  where?: InputMaybe<Campaign_Transaction_Type_Bool_Exp>;
};


export type Query_RootCampaign_Transaction_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Transaction_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Transaction_Type_Order_By>>;
  where?: InputMaybe<Campaign_Transaction_Type_Bool_Exp>;
};


export type Query_RootCampaign_Transaction_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCampaign_Work_LocationArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Work_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Work_Location_Order_By>>;
  where?: InputMaybe<Campaign_Work_Location_Bool_Exp>;
};


export type Query_RootCampaign_Work_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Work_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Work_Location_Order_By>>;
  where?: InputMaybe<Campaign_Work_Location_Bool_Exp>;
};


export type Query_RootCampaign_Work_Location_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootChat_Bot_CustomersArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Customers_Order_By>>;
  where?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
};


export type Query_RootChat_Bot_Customers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Customers_Order_By>>;
  where?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
};


export type Query_RootChat_Bot_Customers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootChat_Bot_ForwardingArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Forwarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Forwarding_Order_By>>;
  where?: InputMaybe<Chat_Bot_Forwarding_Bool_Exp>;
};


export type Query_RootChat_Bot_Forwarding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Forwarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Forwarding_Order_By>>;
  where?: InputMaybe<Chat_Bot_Forwarding_Bool_Exp>;
};


export type Query_RootChat_Bot_Forwarding_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


export type Query_RootChat_Bot_Message_TypeArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Message_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Message_Type_Order_By>>;
  where?: InputMaybe<Chat_Bot_Message_Type_Bool_Exp>;
};


export type Query_RootChat_Bot_Message_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Message_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Message_Type_Order_By>>;
  where?: InputMaybe<Chat_Bot_Message_Type_Bool_Exp>;
};


export type Query_RootChat_Bot_Message_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootChat_Bot_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Messages_Order_By>>;
  where?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
};


export type Query_RootChat_Bot_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Messages_Order_By>>;
  where?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
};


export type Query_RootChat_Bot_Messages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootContactArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Query_RootContact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Query_RootContact_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootContact_LogsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Logs_Order_By>>;
  where?: InputMaybe<Contact_Logs_Bool_Exp>;
};


export type Query_RootContact_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Logs_Order_By>>;
  where?: InputMaybe<Contact_Logs_Bool_Exp>;
};


export type Query_RootContact_Logs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFile_Pdf_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<File_Pdf_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Pdf_Templates_Order_By>>;
  where?: InputMaybe<File_Pdf_Templates_Bool_Exp>;
};


export type Query_RootFile_Pdf_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Pdf_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Pdf_Templates_Order_By>>;
  where?: InputMaybe<File_Pdf_Templates_Bool_Exp>;
};


export type Query_RootFile_Pdf_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_UploadArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Upload_Order_By>>;
  where?: InputMaybe<File_Upload_Bool_Exp>;
};


export type Query_RootFile_Upload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Upload_Order_By>>;
  where?: InputMaybe<File_Upload_Bool_Exp>;
};


export type Query_RootFile_Upload_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFunnel_BenefitsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Benefits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Benefits_Order_By>>;
  where?: InputMaybe<Funnel_Benefits_Bool_Exp>;
};


export type Query_RootFunnel_Benefits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Benefits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Benefits_Order_By>>;
  where?: InputMaybe<Funnel_Benefits_Bool_Exp>;
};


export type Query_RootFunnel_Benefits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFunnel_Chatbot_MessageArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Chatbot_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Chatbot_Message_Order_By>>;
  where?: InputMaybe<Funnel_Chatbot_Message_Bool_Exp>;
};


export type Query_RootFunnel_Chatbot_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Chatbot_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Chatbot_Message_Order_By>>;
  where?: InputMaybe<Funnel_Chatbot_Message_Bool_Exp>;
};


export type Query_RootFunnel_Chatbot_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFunnel_Chatbot_SessionArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Chatbot_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Chatbot_Session_Order_By>>;
  where?: InputMaybe<Funnel_Chatbot_Session_Bool_Exp>;
};


export type Query_RootFunnel_Chatbot_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Chatbot_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Chatbot_Session_Order_By>>;
  where?: InputMaybe<Funnel_Chatbot_Session_Bool_Exp>;
};


export type Query_RootFunnel_Chatbot_Session_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFunnel_FunnelsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Funnels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Funnels_Order_By>>;
  where?: InputMaybe<Funnel_Funnels_Bool_Exp>;
};


export type Query_RootFunnel_Funnels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Funnels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Funnels_Order_By>>;
  where?: InputMaybe<Funnel_Funnels_Bool_Exp>;
};


export type Query_RootFunnel_Funnels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFunnel_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Insights_Bool_Exp>;
};


export type Query_RootFunnel_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Insights_Bool_Exp>;
};


export type Query_RootFunnel_Page_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Page_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};


export type Query_RootFunnel_Page_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Page_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};


export type Query_RootFunnel_Page_Insights_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFunnel_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Order_By>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


export type Query_RootFunnel_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Order_By>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


export type Query_RootFunnel_Question_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFunnel_Question_OptionArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Option_Order_By>>;
  where?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
};


export type Query_RootFunnel_Question_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Option_Order_By>>;
  where?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
};


export type Query_RootFunnel_Question_Option_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFunnel_Whatsapp_Share_ClicksArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Order_By>>;
  where?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
};


export type Query_RootFunnel_Whatsapp_Share_Clicks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Order_By>>;
  where?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
};


export type Query_RootFunnel_Whatsapp_Share_Clicks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootHuk_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Huk_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Huk_Contacts_Order_By>>;
  where?: InputMaybe<Huk_Contacts_Bool_Exp>;
};


export type Query_RootHuk_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Huk_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Huk_Contacts_Order_By>>;
  where?: InputMaybe<Huk_Contacts_Bool_Exp>;
};


export type Query_RootNew_Contacts_Per_DayArgs = {
  distinct_on?: InputMaybe<Array<New_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Contacts_Per_Day_Bool_Exp>;
};


export type Query_RootNew_Contacts_Per_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<New_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Contacts_Per_Day_Bool_Exp>;
};


export type Query_RootNew_Unqualified_Contacts_Per_DayArgs = {
  distinct_on?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Unqualified_Contacts_Per_Day_Bool_Exp>;
};


export type Query_RootNew_Unqualified_Contacts_Per_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Unqualified_Contacts_Per_Day_Bool_Exp>;
};


export type Query_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_BudgetArgs = {
  distinct_on?: InputMaybe<Array<Organization_Budget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Budget_Order_By>>;
  where?: InputMaybe<Organization_Budget_Bool_Exp>;
};


export type Query_RootOrganization_Budget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Budget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Budget_Order_By>>;
  where?: InputMaybe<Organization_Budget_Bool_Exp>;
};


export type Query_RootOrganization_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootOrganization_Contacts_Per_DayArgs = {
  distinct_on?: InputMaybe<Array<Organization_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<Organization_Contacts_Per_Day_Bool_Exp>;
};


export type Query_RootOrganization_Contacts_Per_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<Organization_Contacts_Per_Day_Bool_Exp>;
};


export type Query_RootOrganization_LocationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Location_Order_By>>;
  where?: InputMaybe<Organization_Location_Bool_Exp>;
};


export type Query_RootOrganization_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Location_Order_By>>;
  where?: InputMaybe<Organization_Location_Bool_Exp>;
};


export type Query_RootOrganization_Location_By_PkArgs = {
  organization_id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type Query_RootOrganization_Name_PrefixArgs = {
  distinct_on?: InputMaybe<Array<Organization_Name_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Name_Prefix_Order_By>>;
  where?: InputMaybe<Organization_Name_Prefix_Bool_Exp>;
};


export type Query_RootOrganization_Name_Prefix_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Name_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Name_Prefix_Order_By>>;
  where?: InputMaybe<Organization_Name_Prefix_Bool_Exp>;
};


export type Query_RootOrganization_Name_Prefix_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootOrganization_NewsArgs = {
  distinct_on?: InputMaybe<Array<Organization_News_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_News_Order_By>>;
  where?: InputMaybe<Organization_News_Bool_Exp>;
};


export type Query_RootOrganization_News_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_News_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_News_Order_By>>;
  where?: InputMaybe<Organization_News_Bool_Exp>;
};


export type Query_RootOrganization_News_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_RegionArgs = {
  distinct_on?: InputMaybe<Array<Organization_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Region_Order_By>>;
  where?: InputMaybe<Organization_Region_Bool_Exp>;
};


export type Query_RootOrganization_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Region_Order_By>>;
  where?: InputMaybe<Organization_Region_Bool_Exp>;
};


export type Query_RootOrganization_Region_By_PkArgs = {
  organization_id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type Query_RootOrganization_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Settings_Order_By>>;
  where?: InputMaybe<Organization_Settings_Bool_Exp>;
};


export type Query_RootOrganization_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Settings_Order_By>>;
  where?: InputMaybe<Organization_Settings_Bool_Exp>;
};


export type Query_RootOrganization_Settings_By_PkArgs = {
  organization_id: Scalars['String']['input'];
};


export type Query_RootPerspective_CampaignArgs = {
  distinct_on?: InputMaybe<Array<Perspective_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Perspective_Campaign_Order_By>>;
  where?: InputMaybe<Perspective_Campaign_Bool_Exp>;
};


export type Query_RootPerspective_Campaign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Perspective_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Perspective_Campaign_Order_By>>;
  where?: InputMaybe<Perspective_Campaign_Bool_Exp>;
};


export type Query_RootPerspective_Campaign_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootQa_SourceArgs = {
  distinct_on?: InputMaybe<Array<Qa_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Qa_Source_Order_By>>;
  where?: InputMaybe<Qa_Source_Bool_Exp>;
};


export type Query_RootQa_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Qa_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Qa_Source_Order_By>>;
  where?: InputMaybe<Qa_Source_Bool_Exp>;
};


export type Query_RootQa_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootRms_ConnectorsArgs = {
  distinct_on?: InputMaybe<Array<Rms_Connectors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Connectors_Order_By>>;
  where?: InputMaybe<Rms_Connectors_Bool_Exp>;
};


export type Query_RootRms_Connectors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rms_Connectors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Connectors_Order_By>>;
  where?: InputMaybe<Rms_Connectors_Bool_Exp>;
};


export type Query_RootRms_Connectors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRms_Forwarded_LogsArgs = {
  distinct_on?: InputMaybe<Array<Rms_Forwarded_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Forwarded_Logs_Order_By>>;
  where?: InputMaybe<Rms_Forwarded_Logs_Bool_Exp>;
};


export type Query_RootRms_Forwarded_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rms_Forwarded_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Forwarded_Logs_Order_By>>;
  where?: InputMaybe<Rms_Forwarded_Logs_Bool_Exp>;
};


export type Query_RootRms_Forwarded_Logs_By_PkArgs = {
  contact_id: Scalars['uuid']['input'];
};


export type Query_RootRms_Org_SetupsArgs = {
  distinct_on?: InputMaybe<Array<Rms_Org_Setups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Org_Setups_Order_By>>;
  where?: InputMaybe<Rms_Org_Setups_Bool_Exp>;
};


export type Query_RootRms_Org_Setups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rms_Org_Setups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Org_Setups_Order_By>>;
  where?: InputMaybe<Rms_Org_Setups_Bool_Exp>;
};


export type Query_RootRms_Org_Setups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSystem_Api_KeysArgs = {
  distinct_on?: InputMaybe<Array<System_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Api_Keys_Order_By>>;
  where?: InputMaybe<System_Api_Keys_Bool_Exp>;
};


export type Query_RootSystem_Api_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Api_Keys_Order_By>>;
  where?: InputMaybe<System_Api_Keys_Bool_Exp>;
};


export type Query_RootSystem_Api_Keys_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSystem_Call_Daily_StatsArgs = {
  distinct_on?: InputMaybe<Array<System_Call_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Call_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Call_Daily_Stats_Bool_Exp>;
};


export type Query_RootSystem_Call_Daily_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Call_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Call_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Call_Daily_Stats_Bool_Exp>;
};


export type Query_RootSystem_Call_Daily_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};


export type Query_RootSystem_Email_Daily_StatsArgs = {
  distinct_on?: InputMaybe<Array<System_Email_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Email_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Email_Daily_Stats_Bool_Exp>;
};


export type Query_RootSystem_Email_Daily_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Email_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Email_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Email_Daily_Stats_Bool_Exp>;
};


export type Query_RootSystem_Email_Daily_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};


export type Query_RootSystem_Running_ReleaseArgs = {
  distinct_on?: InputMaybe<Array<System_Running_Release_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Running_Release_Order_By>>;
  where?: InputMaybe<System_Running_Release_Bool_Exp>;
};


export type Query_RootSystem_Running_Release_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Running_Release_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Running_Release_Order_By>>;
  where?: InputMaybe<System_Running_Release_Bool_Exp>;
};


export type Query_RootSystem_Running_Release_By_PkArgs = {
  service: Scalars['String']['input'];
};


export type Query_RootSystem_Sms_Daily_StatsArgs = {
  distinct_on?: InputMaybe<Array<System_Sms_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Sms_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Sms_Daily_Stats_Bool_Exp>;
};


export type Query_RootSystem_Sms_Daily_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Sms_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Sms_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Sms_Daily_Stats_Bool_Exp>;
};


export type Query_RootSystem_Sms_Daily_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};

/** columns and relationships of "rms.connectors" */
export type Rms_Connectors = {
  __typename?: 'rms_connectors';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  custom_mappings?: Maybe<Scalars['jsonb']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  job_id?: Maybe<Scalars['String']['output']>;
  webhook?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "rms.connectors" */
export type Rms_ConnectorsCustom_MappingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "rms.connectors" */
export type Rms_Connectors_Aggregate = {
  __typename?: 'rms_connectors_aggregate';
  aggregate?: Maybe<Rms_Connectors_Aggregate_Fields>;
  nodes: Array<Rms_Connectors>;
};

/** aggregate fields of "rms.connectors" */
export type Rms_Connectors_Aggregate_Fields = {
  __typename?: 'rms_connectors_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Rms_Connectors_Max_Fields>;
  min?: Maybe<Rms_Connectors_Min_Fields>;
};


/** aggregate fields of "rms.connectors" */
export type Rms_Connectors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rms_Connectors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Rms_Connectors_Append_Input = {
  custom_mappings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "rms.connectors". All fields are combined with a logical 'AND'. */
export type Rms_Connectors_Bool_Exp = {
  _and?: InputMaybe<Array<Rms_Connectors_Bool_Exp>>;
  _not?: InputMaybe<Rms_Connectors_Bool_Exp>;
  _or?: InputMaybe<Array<Rms_Connectors_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  custom_mappings?: InputMaybe<Jsonb_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_id?: InputMaybe<String_Comparison_Exp>;
  webhook?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "rms.connectors" */
export enum Rms_Connectors_Constraint {
  /** unique or primary key constraint on columns "campaign_id" */
  ConnectorsCampaignIdKey = 'connectors_campaign_id_key',
  /** unique or primary key constraint on columns "id" */
  ConnectorsPkey = 'connectors_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Rms_Connectors_Delete_At_Path_Input = {
  custom_mappings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Rms_Connectors_Delete_Elem_Input = {
  custom_mappings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Rms_Connectors_Delete_Key_Input = {
  custom_mappings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "rms.connectors" */
export type Rms_Connectors_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  custom_mappings?: InputMaybe<Scalars['jsonb']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  job_id?: InputMaybe<Scalars['String']['input']>;
  webhook?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Rms_Connectors_Max_Fields = {
  __typename?: 'rms_connectors_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_id?: Maybe<Scalars['String']['output']>;
  webhook?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Rms_Connectors_Min_Fields = {
  __typename?: 'rms_connectors_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_id?: Maybe<Scalars['String']['output']>;
  webhook?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "rms.connectors" */
export type Rms_Connectors_Mutation_Response = {
  __typename?: 'rms_connectors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rms_Connectors>;
};

/** input type for inserting object relation for remote table "rms.connectors" */
export type Rms_Connectors_Obj_Rel_Insert_Input = {
  data: Rms_Connectors_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Rms_Connectors_On_Conflict>;
};

/** on_conflict condition type for table "rms.connectors" */
export type Rms_Connectors_On_Conflict = {
  constraint: Rms_Connectors_Constraint;
  update_columns?: Array<Rms_Connectors_Update_Column>;
  where?: InputMaybe<Rms_Connectors_Bool_Exp>;
};

/** Ordering options when selecting data from "rms.connectors". */
export type Rms_Connectors_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  custom_mappings?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  webhook?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rms.connectors */
export type Rms_Connectors_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Rms_Connectors_Prepend_Input = {
  custom_mappings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "rms.connectors" */
export enum Rms_Connectors_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CustomMappings = 'custom_mappings',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Webhook = 'webhook'
}

/** input type for updating data in table "rms.connectors" */
export type Rms_Connectors_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  custom_mappings?: InputMaybe<Scalars['jsonb']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  job_id?: InputMaybe<Scalars['String']['input']>;
  webhook?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "rms_connectors" */
export type Rms_Connectors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rms_Connectors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rms_Connectors_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  custom_mappings?: InputMaybe<Scalars['jsonb']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  job_id?: InputMaybe<Scalars['String']['input']>;
  webhook?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "rms.connectors" */
export enum Rms_Connectors_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CustomMappings = 'custom_mappings',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Webhook = 'webhook'
}

export type Rms_Connectors_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Rms_Connectors_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Rms_Connectors_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Rms_Connectors_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Rms_Connectors_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Rms_Connectors_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rms_Connectors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rms_Connectors_Bool_Exp;
};

/** columns and relationships of "rms.forwarded_logs" */
export type Rms_Forwarded_Logs = {
  __typename?: 'rms_forwarded_logs';
  /** An object relationship */
  campaign: Campaign;
  campaign_id: Scalars['uuid']['output'];
  /** An object relationship */
  connector?: Maybe<Rms_Connectors>;
  connector_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  contact: Contact;
  contact_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  result_json?: Maybe<Scalars['jsonb']['output']>;
  rms_type: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};


/** columns and relationships of "rms.forwarded_logs" */
export type Rms_Forwarded_LogsResult_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "rms.forwarded_logs" */
export type Rms_Forwarded_Logs_Aggregate = {
  __typename?: 'rms_forwarded_logs_aggregate';
  aggregate?: Maybe<Rms_Forwarded_Logs_Aggregate_Fields>;
  nodes: Array<Rms_Forwarded_Logs>;
};

/** aggregate fields of "rms.forwarded_logs" */
export type Rms_Forwarded_Logs_Aggregate_Fields = {
  __typename?: 'rms_forwarded_logs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Rms_Forwarded_Logs_Max_Fields>;
  min?: Maybe<Rms_Forwarded_Logs_Min_Fields>;
};


/** aggregate fields of "rms.forwarded_logs" */
export type Rms_Forwarded_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rms_Forwarded_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Rms_Forwarded_Logs_Append_Input = {
  result_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "rms.forwarded_logs". All fields are combined with a logical 'AND'. */
export type Rms_Forwarded_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Rms_Forwarded_Logs_Bool_Exp>>;
  _not?: InputMaybe<Rms_Forwarded_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Rms_Forwarded_Logs_Bool_Exp>>;
  campaign?: InputMaybe<Campaign_Bool_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  connector?: InputMaybe<Rms_Connectors_Bool_Exp>;
  connector_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  result_json?: InputMaybe<Jsonb_Comparison_Exp>;
  rms_type?: InputMaybe<String_Comparison_Exp>;
  success?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "rms.forwarded_logs" */
export enum Rms_Forwarded_Logs_Constraint {
  /** unique or primary key constraint on columns "contact_id" */
  ForwardedLogsContactIdKey = 'forwarded_logs_contact_id_key',
  /** unique or primary key constraint on columns "contact_id" */
  ForwardedLogsPkey = 'forwarded_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Rms_Forwarded_Logs_Delete_At_Path_Input = {
  result_json?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Rms_Forwarded_Logs_Delete_Elem_Input = {
  result_json?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Rms_Forwarded_Logs_Delete_Key_Input = {
  result_json?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "rms.forwarded_logs" */
export type Rms_Forwarded_Logs_Insert_Input = {
  campaign?: InputMaybe<Campaign_Obj_Rel_Insert_Input>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  connector?: InputMaybe<Rms_Connectors_Obj_Rel_Insert_Input>;
  connector_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  result_json?: InputMaybe<Scalars['jsonb']['input']>;
  rms_type?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Rms_Forwarded_Logs_Max_Fields = {
  __typename?: 'rms_forwarded_logs_max_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  connector_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rms_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Rms_Forwarded_Logs_Min_Fields = {
  __typename?: 'rms_forwarded_logs_min_fields';
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  connector_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rms_type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "rms.forwarded_logs" */
export type Rms_Forwarded_Logs_Mutation_Response = {
  __typename?: 'rms_forwarded_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rms_Forwarded_Logs>;
};

/** input type for inserting object relation for remote table "rms.forwarded_logs" */
export type Rms_Forwarded_Logs_Obj_Rel_Insert_Input = {
  data: Rms_Forwarded_Logs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Rms_Forwarded_Logs_On_Conflict>;
};

/** on_conflict condition type for table "rms.forwarded_logs" */
export type Rms_Forwarded_Logs_On_Conflict = {
  constraint: Rms_Forwarded_Logs_Constraint;
  update_columns?: Array<Rms_Forwarded_Logs_Update_Column>;
  where?: InputMaybe<Rms_Forwarded_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "rms.forwarded_logs". */
export type Rms_Forwarded_Logs_Order_By = {
  campaign?: InputMaybe<Campaign_Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  connector?: InputMaybe<Rms_Connectors_Order_By>;
  connector_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_json?: InputMaybe<Order_By>;
  rms_type?: InputMaybe<Order_By>;
  success?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rms.forwarded_logs */
export type Rms_Forwarded_Logs_Pk_Columns_Input = {
  contact_id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Rms_Forwarded_Logs_Prepend_Input = {
  result_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "rms.forwarded_logs" */
export enum Rms_Forwarded_Logs_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ConnectorId = 'connector_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ResultJson = 'result_json',
  /** column name */
  RmsType = 'rms_type',
  /** column name */
  Success = 'success'
}

/** input type for updating data in table "rms.forwarded_logs" */
export type Rms_Forwarded_Logs_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  connector_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  result_json?: InputMaybe<Scalars['jsonb']['input']>;
  rms_type?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "rms_forwarded_logs" */
export type Rms_Forwarded_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rms_Forwarded_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rms_Forwarded_Logs_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  connector_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  result_json?: InputMaybe<Scalars['jsonb']['input']>;
  rms_type?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "rms.forwarded_logs" */
export enum Rms_Forwarded_Logs_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  ConnectorId = 'connector_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ResultJson = 'result_json',
  /** column name */
  RmsType = 'rms_type',
  /** column name */
  Success = 'success'
}

export type Rms_Forwarded_Logs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Rms_Forwarded_Logs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Rms_Forwarded_Logs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Rms_Forwarded_Logs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Rms_Forwarded_Logs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Rms_Forwarded_Logs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rms_Forwarded_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rms_Forwarded_Logs_Bool_Exp;
};

/** columns and relationships of "rms.org_setups" */
export type Rms_Org_Setups = {
  __typename?: 'rms_org_setups';
  credentials: Scalars['jsonb']['output'];
  endpoint: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['String']['output'];
  rms_type: Scalars['String']['output'];
};


/** columns and relationships of "rms.org_setups" */
export type Rms_Org_SetupsCredentialsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "rms.org_setups" */
export type Rms_Org_Setups_Aggregate = {
  __typename?: 'rms_org_setups_aggregate';
  aggregate?: Maybe<Rms_Org_Setups_Aggregate_Fields>;
  nodes: Array<Rms_Org_Setups>;
};

/** aggregate fields of "rms.org_setups" */
export type Rms_Org_Setups_Aggregate_Fields = {
  __typename?: 'rms_org_setups_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Rms_Org_Setups_Max_Fields>;
  min?: Maybe<Rms_Org_Setups_Min_Fields>;
};


/** aggregate fields of "rms.org_setups" */
export type Rms_Org_Setups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rms_Org_Setups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Rms_Org_Setups_Append_Input = {
  credentials?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "rms.org_setups". All fields are combined with a logical 'AND'. */
export type Rms_Org_Setups_Bool_Exp = {
  _and?: InputMaybe<Array<Rms_Org_Setups_Bool_Exp>>;
  _not?: InputMaybe<Rms_Org_Setups_Bool_Exp>;
  _or?: InputMaybe<Array<Rms_Org_Setups_Bool_Exp>>;
  credentials?: InputMaybe<Jsonb_Comparison_Exp>;
  endpoint?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<String_Comparison_Exp>;
  rms_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "rms.org_setups" */
export enum Rms_Org_Setups_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  OrgSetupsOrganizationIdKey = 'org_setups_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  OrgSetupsPkey = 'org_setups_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Rms_Org_Setups_Delete_At_Path_Input = {
  credentials?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Rms_Org_Setups_Delete_Elem_Input = {
  credentials?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Rms_Org_Setups_Delete_Key_Input = {
  credentials?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "rms.org_setups" */
export type Rms_Org_Setups_Insert_Input = {
  credentials?: InputMaybe<Scalars['jsonb']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  rms_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Rms_Org_Setups_Max_Fields = {
  __typename?: 'rms_org_setups_max_fields';
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  rms_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Rms_Org_Setups_Min_Fields = {
  __typename?: 'rms_org_setups_min_fields';
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  rms_type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "rms.org_setups" */
export type Rms_Org_Setups_Mutation_Response = {
  __typename?: 'rms_org_setups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rms_Org_Setups>;
};

/** input type for inserting object relation for remote table "rms.org_setups" */
export type Rms_Org_Setups_Obj_Rel_Insert_Input = {
  data: Rms_Org_Setups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Rms_Org_Setups_On_Conflict>;
};

/** on_conflict condition type for table "rms.org_setups" */
export type Rms_Org_Setups_On_Conflict = {
  constraint: Rms_Org_Setups_Constraint;
  update_columns?: Array<Rms_Org_Setups_Update_Column>;
  where?: InputMaybe<Rms_Org_Setups_Bool_Exp>;
};

/** Ordering options when selecting data from "rms.org_setups". */
export type Rms_Org_Setups_Order_By = {
  credentials?: InputMaybe<Order_By>;
  endpoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  rms_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rms.org_setups */
export type Rms_Org_Setups_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Rms_Org_Setups_Prepend_Input = {
  credentials?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "rms.org_setups" */
export enum Rms_Org_Setups_Select_Column {
  /** column name */
  Credentials = 'credentials',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RmsType = 'rms_type'
}

/** input type for updating data in table "rms.org_setups" */
export type Rms_Org_Setups_Set_Input = {
  credentials?: InputMaybe<Scalars['jsonb']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  rms_type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "rms_org_setups" */
export type Rms_Org_Setups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rms_Org_Setups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rms_Org_Setups_Stream_Cursor_Value_Input = {
  credentials?: InputMaybe<Scalars['jsonb']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  rms_type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "rms.org_setups" */
export enum Rms_Org_Setups_Update_Column {
  /** column name */
  Credentials = 'credentials',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RmsType = 'rms_type'
}

export type Rms_Org_Setups_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Rms_Org_Setups_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Rms_Org_Setups_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Rms_Org_Setups_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Rms_Org_Setups_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Rms_Org_Setups_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rms_Org_Setups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rms_Org_Setups_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** An array relationship */
  ad_campaign_metrics: Array<Ad_Campaign_Metrics>;
  /** An aggregate relationship */
  ad_campaign_metrics_aggregate: Ad_Campaign_Metrics_Aggregate;
  /** fetch data from the table: "ad.campaign_metrics" using primary key columns */
  ad_campaign_metrics_by_pk?: Maybe<Ad_Campaign_Metrics>;
  /** fetch data from the table in a streaming manner: "ad.campaign_metrics" */
  ad_campaign_metrics_stream: Array<Ad_Campaign_Metrics>;
  /** fetch data from the table: "ad.comment" */
  ad_comment: Array<Ad_Comment>;
  /** fetch aggregated fields from the table: "ad.comment" */
  ad_comment_aggregate: Ad_Comment_Aggregate;
  /** fetch data from the table: "ad.comment" using primary key columns */
  ad_comment_by_pk?: Maybe<Ad_Comment>;
  /** fetch data from the table in a streaming manner: "ad.comment" */
  ad_comment_stream: Array<Ad_Comment>;
  /** fetch data from the table: "ad.creative" */
  ad_creative: Array<Ad_Creative>;
  /** fetch aggregated fields from the table: "ad.creative" */
  ad_creative_aggregate: Ad_Creative_Aggregate;
  /** fetch data from the table: "ad.creative" using primary key columns */
  ad_creative_by_pk?: Maybe<Ad_Creative>;
  /** fetch data from the table: "ad.creative_feedback" */
  ad_creative_feedback: Array<Ad_Creative_Feedback>;
  /** fetch aggregated fields from the table: "ad.creative_feedback" */
  ad_creative_feedback_aggregate: Ad_Creative_Feedback_Aggregate;
  /** fetch data from the table: "ad.creative_feedback" using primary key columns */
  ad_creative_feedback_by_pk?: Maybe<Ad_Creative_Feedback>;
  /** fetch data from the table in a streaming manner: "ad.creative_feedback" */
  ad_creative_feedback_stream: Array<Ad_Creative_Feedback>;
  /** fetch data from the table in a streaming manner: "ad.creative" */
  ad_creative_stream: Array<Ad_Creative>;
  /** fetch data from the table: "ad.platform" */
  ad_platform: Array<Ad_Platform>;
  /** fetch aggregated fields from the table: "ad.platform" */
  ad_platform_aggregate: Ad_Platform_Aggregate;
  /** fetch data from the table: "ad.platform" using primary key columns */
  ad_platform_by_pk?: Maybe<Ad_Platform>;
  /** fetch data from the table in a streaming manner: "ad.platform" */
  ad_platform_stream: Array<Ad_Platform>;
  /** fetch data from the table: "ad.providers" */
  ad_providers: Array<Ad_Providers>;
  /** fetch aggregated fields from the table: "ad.providers" */
  ad_providers_aggregate: Ad_Providers_Aggregate;
  /** fetch data from the table: "ad.providers" using primary key columns */
  ad_providers_by_pk?: Maybe<Ad_Providers>;
  /** fetch data from the table in a streaming manner: "ad.providers" */
  ad_providers_stream: Array<Ad_Providers>;
  /** fetch data from the table: "ad.setting" */
  ad_setting: Array<Ad_Setting>;
  /** fetch aggregated fields from the table: "ad.setting" */
  ad_setting_aggregate: Ad_Setting_Aggregate;
  /** fetch data from the table: "ad.setting" using primary key columns */
  ad_setting_by_pk?: Maybe<Ad_Setting>;
  /** fetch data from the table in a streaming manner: "ad.setting" */
  ad_setting_stream: Array<Ad_Setting>;
  /** fetch data from the table: "ad.status" */
  ad_status: Array<Ad_Status>;
  /** fetch aggregated fields from the table: "ad.status" */
  ad_status_aggregate: Ad_Status_Aggregate;
  /** fetch data from the table: "ad.status" using primary key columns */
  ad_status_by_pk?: Maybe<Ad_Status>;
  /** fetch data from the table in a streaming manner: "ad.status" */
  ad_status_stream: Array<Ad_Status>;
  /** fetch data from the table: "anna_ai.call_campaigns" */
  anna_ai_call_campaigns: Array<Anna_Ai_Call_Campaigns>;
  /** fetch aggregated fields from the table: "anna_ai.call_campaigns" */
  anna_ai_call_campaigns_aggregate: Anna_Ai_Call_Campaigns_Aggregate;
  /** fetch data from the table: "anna_ai.call_campaigns" using primary key columns */
  anna_ai_call_campaigns_by_pk?: Maybe<Anna_Ai_Call_Campaigns>;
  /** fetch data from the table in a streaming manner: "anna_ai.call_campaigns" */
  anna_ai_call_campaigns_stream: Array<Anna_Ai_Call_Campaigns>;
  /** fetch data from the table: "anna_ai.call_states" */
  anna_ai_call_states: Array<Anna_Ai_Call_States>;
  /** fetch aggregated fields from the table: "anna_ai.call_states" */
  anna_ai_call_states_aggregate: Anna_Ai_Call_States_Aggregate;
  /** fetch data from the table: "anna_ai.call_states" using primary key columns */
  anna_ai_call_states_by_pk?: Maybe<Anna_Ai_Call_States>;
  /** fetch data from the table in a streaming manner: "anna_ai.call_states" */
  anna_ai_call_states_stream: Array<Anna_Ai_Call_States>;
  /** fetch data from the table: "anna_ai.outbound_calls" */
  anna_ai_outbound_calls: Array<Anna_Ai_Outbound_Calls>;
  /** fetch aggregated fields from the table: "anna_ai.outbound_calls" */
  anna_ai_outbound_calls_aggregate: Anna_Ai_Outbound_Calls_Aggregate;
  /** fetch data from the table: "anna_ai.outbound_calls" using primary key columns */
  anna_ai_outbound_calls_by_pk?: Maybe<Anna_Ai_Outbound_Calls>;
  /** fetch data from the table in a streaming manner: "anna_ai.outbound_calls" */
  anna_ai_outbound_calls_stream: Array<Anna_Ai_Outbound_Calls>;
  /** fetch data from the table: "answer" */
  answer: Array<Answer>;
  /** fetch aggregated fields from the table: "answer" */
  answer_aggregate: Answer_Aggregate;
  /** fetch data from the table: "answer" using primary key columns */
  answer_by_pk?: Maybe<Answer>;
  /** fetch data from the table in a streaming manner: "answer" */
  answer_stream: Array<Answer>;
  /** fetch data from the table: "applicant.event" */
  applicant_event: Array<Applicant_Event>;
  /** fetch aggregated fields from the table: "applicant.event" */
  applicant_event_aggregate: Applicant_Event_Aggregate;
  /** fetch data from the table: "applicant.event" using primary key columns */
  applicant_event_by_pk?: Maybe<Applicant_Event>;
  /** fetch data from the table in a streaming manner: "applicant.event" */
  applicant_event_stream: Array<Applicant_Event>;
  /** fetch data from the table: "board.column_type" */
  board_column_type: Array<Board_Column_Type>;
  /** fetch aggregated fields from the table: "board.column_type" */
  board_column_type_aggregate: Board_Column_Type_Aggregate;
  /** fetch data from the table: "board.column_type" using primary key columns */
  board_column_type_by_pk?: Maybe<Board_Column_Type>;
  /** fetch data from the table in a streaming manner: "board.column_type" */
  board_column_type_stream: Array<Board_Column_Type>;
  /** fetch data from the table: "board.contact_board" */
  board_contact_board: Array<Board_Contact_Board>;
  /** fetch aggregated fields from the table: "board.contact_board" */
  board_contact_board_aggregate: Board_Contact_Board_Aggregate;
  /** fetch data from the table: "board.contact_board" using primary key columns */
  board_contact_board_by_pk?: Maybe<Board_Contact_Board>;
  /** fetch data from the table: "board.contact_board_column" */
  board_contact_board_column: Array<Board_Contact_Board_Column>;
  /** fetch aggregated fields from the table: "board.contact_board_column" */
  board_contact_board_column_aggregate: Board_Contact_Board_Column_Aggregate;
  /** fetch data from the table: "board.contact_board_column" using primary key columns */
  board_contact_board_column_by_pk?: Maybe<Board_Contact_Board_Column>;
  /** fetch data from the table in a streaming manner: "board.contact_board_column" */
  board_contact_board_column_stream: Array<Board_Contact_Board_Column>;
  /** fetch data from the table: "board.contact_board_entry" */
  board_contact_board_entry: Array<Board_Contact_Board_Entry>;
  /** fetch aggregated fields from the table: "board.contact_board_entry" */
  board_contact_board_entry_aggregate: Board_Contact_Board_Entry_Aggregate;
  /** fetch data from the table: "board.contact_board_entry" using primary key columns */
  board_contact_board_entry_by_pk?: Maybe<Board_Contact_Board_Entry>;
  /** fetch data from the table in a streaming manner: "board.contact_board_entry" */
  board_contact_board_entry_stream: Array<Board_Contact_Board_Entry>;
  /** fetch data from the table in a streaming manner: "board.contact_board" */
  board_contact_board_stream: Array<Board_Contact_Board>;
  /** fetch data from the table: "board.note" */
  board_note: Array<Board_Note>;
  /** fetch aggregated fields from the table: "board.note" */
  board_note_aggregate: Board_Note_Aggregate;
  /** fetch data from the table: "board.note" using primary key columns */
  board_note_by_pk?: Maybe<Board_Note>;
  /** fetch data from the table in a streaming manner: "board.note" */
  board_note_stream: Array<Board_Note>;
  /** fetch data from the table: "bot.assignee" */
  bot_assignee: Array<Bot_Assignee>;
  /** fetch aggregated fields from the table: "bot.assignee" */
  bot_assignee_aggregate: Bot_Assignee_Aggregate;
  /** fetch data from the table: "bot.assignee" using primary key columns */
  bot_assignee_by_pk?: Maybe<Bot_Assignee>;
  /** fetch data from the table in a streaming manner: "bot.assignee" */
  bot_assignee_stream: Array<Bot_Assignee>;
  /** fetch data from the table: "bot.channel" */
  bot_channel: Array<Bot_Channel>;
  /** fetch aggregated fields from the table: "bot.channel" */
  bot_channel_aggregate: Bot_Channel_Aggregate;
  /** fetch data from the table: "bot.channel" using primary key columns */
  bot_channel_by_pk?: Maybe<Bot_Channel>;
  /** fetch data from the table in a streaming manner: "bot.channel" */
  bot_channel_stream: Array<Bot_Channel>;
  /** fetch data from the table: "bot.conversation" */
  bot_conversation: Array<Bot_Conversation>;
  /** fetch aggregated fields from the table: "bot.conversation" */
  bot_conversation_aggregate: Bot_Conversation_Aggregate;
  /** fetch data from the table: "bot.conversation" using primary key columns */
  bot_conversation_by_pk?: Maybe<Bot_Conversation>;
  /** fetch data from the table: "bot.conversation_state" */
  bot_conversation_state: Array<Bot_Conversation_State>;
  /** fetch aggregated fields from the table: "bot.conversation_state" */
  bot_conversation_state_aggregate: Bot_Conversation_State_Aggregate;
  /** fetch data from the table: "bot.conversation_state" using primary key columns */
  bot_conversation_state_by_pk?: Maybe<Bot_Conversation_State>;
  /** fetch data from the table in a streaming manner: "bot.conversation_state" */
  bot_conversation_state_stream: Array<Bot_Conversation_State>;
  /** fetch data from the table in a streaming manner: "bot.conversation" */
  bot_conversation_stream: Array<Bot_Conversation>;
  /** fetch data from the table: "bot.message" */
  bot_message: Array<Bot_Message>;
  /** fetch aggregated fields from the table: "bot.message" */
  bot_message_aggregate: Bot_Message_Aggregate;
  /** fetch data from the table: "bot.message" using primary key columns */
  bot_message_by_pk?: Maybe<Bot_Message>;
  /** fetch data from the table: "bot.message_status" */
  bot_message_status: Array<Bot_Message_Status>;
  /** fetch aggregated fields from the table: "bot.message_status" */
  bot_message_status_aggregate: Bot_Message_Status_Aggregate;
  /** fetch data from the table: "bot.message_status" using primary key columns */
  bot_message_status_by_pk?: Maybe<Bot_Message_Status>;
  /** fetch data from the table in a streaming manner: "bot.message_status" */
  bot_message_status_stream: Array<Bot_Message_Status>;
  /** fetch data from the table in a streaming manner: "bot.message" */
  bot_message_stream: Array<Bot_Message>;
  /** fetch data from the table: "bot.sender" */
  bot_sender: Array<Bot_Sender>;
  /** fetch aggregated fields from the table: "bot.sender" */
  bot_sender_aggregate: Bot_Sender_Aggregate;
  /** fetch data from the table: "bot.sender" using primary key columns */
  bot_sender_by_pk?: Maybe<Bot_Sender>;
  /** fetch data from the table in a streaming manner: "bot.sender" */
  bot_sender_stream: Array<Bot_Sender>;
  /** fetch data from the table: "campaign" */
  campaign: Array<Campaign>;
  /** fetch data from the table: "campaign.ad" */
  campaign_ad: Array<Campaign_Ad>;
  /** fetch aggregated fields from the table: "campaign.ad" */
  campaign_ad_aggregate: Campaign_Ad_Aggregate;
  /** fetch data from the table: "campaign.ad" using primary key columns */
  campaign_ad_by_pk?: Maybe<Campaign_Ad>;
  /** fetch data from the table in a streaming manner: "campaign.ad" */
  campaign_ad_stream: Array<Campaign_Ad>;
  /** fetch aggregated fields from the table: "campaign" */
  campaign_aggregate: Campaign_Aggregate;
  /** fetch data from the table: "campaign.budget" */
  campaign_budget: Array<Campaign_Budget>;
  /** fetch aggregated fields from the table: "campaign.budget" */
  campaign_budget_aggregate: Campaign_Budget_Aggregate;
  /** fetch data from the table in a streaming manner: "campaign.budget" */
  campaign_budget_stream: Array<Campaign_Budget>;
  /** fetch data from the table: "campaign.budget_transaction" */
  campaign_budget_transaction: Array<Campaign_Budget_Transaction>;
  /** fetch aggregated fields from the table: "campaign.budget_transaction" */
  campaign_budget_transaction_aggregate: Campaign_Budget_Transaction_Aggregate;
  /** fetch data from the table: "campaign.budget_transaction" using primary key columns */
  campaign_budget_transaction_by_pk?: Maybe<Campaign_Budget_Transaction>;
  /** fetch data from the table in a streaming manner: "campaign.budget_transaction" */
  campaign_budget_transaction_stream: Array<Campaign_Budget_Transaction>;
  /** fetch data from the table: "campaign" using primary key columns */
  campaign_by_pk?: Maybe<Campaign>;
  /** fetch data from the table: "campaign.email_template_overwrite" */
  campaign_email_template_overwrite: Array<Campaign_Email_Template_Overwrite>;
  /** fetch aggregated fields from the table: "campaign.email_template_overwrite" */
  campaign_email_template_overwrite_aggregate: Campaign_Email_Template_Overwrite_Aggregate;
  /** fetch data from the table: "campaign.email_template_overwrite" using primary key columns */
  campaign_email_template_overwrite_by_pk?: Maybe<Campaign_Email_Template_Overwrite>;
  /** fetch data from the table in a streaming manner: "campaign.email_template_overwrite" */
  campaign_email_template_overwrite_stream: Array<Campaign_Email_Template_Overwrite>;
  /** fetch data from the table: "campaign.event_log" */
  campaign_event_log: Array<Campaign_Event_Log>;
  /** fetch aggregated fields from the table: "campaign.event_log" */
  campaign_event_log_aggregate: Campaign_Event_Log_Aggregate;
  /** fetch data from the table: "campaign.event_log" using primary key columns */
  campaign_event_log_by_pk?: Maybe<Campaign_Event_Log>;
  /** fetch data from the table in a streaming manner: "campaign.event_log" */
  campaign_event_log_stream: Array<Campaign_Event_Log>;
  /** execute function "campaign.get_daily_budget" which returns "campaign.budget_transaction" */
  campaign_get_daily_budget: Array<Campaign_Budget_Transaction>;
  /** execute function "campaign.get_daily_budget" and query aggregates on result of table type "campaign.budget_transaction" */
  campaign_get_daily_budget_aggregate: Campaign_Budget_Transaction_Aggregate;
  /** fetch data from the table: "campaign.iso_2_country_codes" */
  campaign_iso_2_country_codes: Array<Campaign_Iso_2_Country_Codes>;
  /** fetch aggregated fields from the table: "campaign.iso_2_country_codes" */
  campaign_iso_2_country_codes_aggregate: Campaign_Iso_2_Country_Codes_Aggregate;
  /** fetch data from the table: "campaign.iso_2_country_codes" using primary key columns */
  campaign_iso_2_country_codes_by_pk?: Maybe<Campaign_Iso_2_Country_Codes>;
  /** fetch data from the table in a streaming manner: "campaign.iso_2_country_codes" */
  campaign_iso_2_country_codes_stream: Array<Campaign_Iso_2_Country_Codes>;
  /** fetch data from the table: "campaign.job_description" */
  campaign_job_description: Array<Campaign_Job_Description>;
  /** fetch aggregated fields from the table: "campaign.job_description" */
  campaign_job_description_aggregate: Campaign_Job_Description_Aggregate;
  /** fetch data from the table: "campaign.job_description" using primary key columns */
  campaign_job_description_by_pk?: Maybe<Campaign_Job_Description>;
  /** fetch data from the table in a streaming manner: "campaign.job_description" */
  campaign_job_description_stream: Array<Campaign_Job_Description>;
  /** fetch data from the table: "campaign.order" */
  campaign_order: Array<Campaign_Order>;
  /** fetch aggregated fields from the table: "campaign.order" */
  campaign_order_aggregate: Campaign_Order_Aggregate;
  /** fetch data from the table: "campaign.order" using primary key columns */
  campaign_order_by_pk?: Maybe<Campaign_Order>;
  /** fetch data from the table: "campaign.order_source" */
  campaign_order_source: Array<Campaign_Order_Source>;
  /** fetch aggregated fields from the table: "campaign.order_source" */
  campaign_order_source_aggregate: Campaign_Order_Source_Aggregate;
  /** fetch data from the table: "campaign.order_source" using primary key columns */
  campaign_order_source_by_pk?: Maybe<Campaign_Order_Source>;
  /** fetch data from the table in a streaming manner: "campaign.order_source" */
  campaign_order_source_stream: Array<Campaign_Order_Source>;
  /** fetch data from the table: "campaign.order_source_type" */
  campaign_order_source_type: Array<Campaign_Order_Source_Type>;
  /** fetch aggregated fields from the table: "campaign.order_source_type" */
  campaign_order_source_type_aggregate: Campaign_Order_Source_Type_Aggregate;
  /** fetch data from the table: "campaign.order_source_type" using primary key columns */
  campaign_order_source_type_by_pk?: Maybe<Campaign_Order_Source_Type>;
  /** fetch data from the table in a streaming manner: "campaign.order_source_type" */
  campaign_order_source_type_stream: Array<Campaign_Order_Source_Type>;
  /** fetch data from the table in a streaming manner: "campaign.order" */
  campaign_order_stream: Array<Campaign_Order>;
  /** fetch data from the table: "campaign_routing.destination" */
  campaign_routing_destination: Array<Campaign_Routing_Destination>;
  /** fetch aggregated fields from the table: "campaign_routing.destination" */
  campaign_routing_destination_aggregate: Campaign_Routing_Destination_Aggregate;
  /** fetch data from the table: "campaign_routing.destination" using primary key columns */
  campaign_routing_destination_by_pk?: Maybe<Campaign_Routing_Destination>;
  /** fetch data from the table in a streaming manner: "campaign_routing.destination" */
  campaign_routing_destination_stream: Array<Campaign_Routing_Destination>;
  /** fetch data from the table: "campaign_routing.info" */
  campaign_routing_info: Array<Campaign_Routing_Info>;
  /** fetch aggregated fields from the table: "campaign_routing.info" */
  campaign_routing_info_aggregate: Campaign_Routing_Info_Aggregate;
  /** fetch data from the table: "campaign_routing.info" using primary key columns */
  campaign_routing_info_by_pk?: Maybe<Campaign_Routing_Info>;
  /** fetch data from the table in a streaming manner: "campaign_routing.info" */
  campaign_routing_info_stream: Array<Campaign_Routing_Info>;
  /** fetch data from the table: "campaign_routing.zipcode" */
  campaign_routing_zipcode: Array<Campaign_Routing_Zipcode>;
  /** fetch aggregated fields from the table: "campaign_routing.zipcode" */
  campaign_routing_zipcode_aggregate: Campaign_Routing_Zipcode_Aggregate;
  /** fetch data from the table: "campaign_routing.zipcode" using primary key columns */
  campaign_routing_zipcode_by_pk?: Maybe<Campaign_Routing_Zipcode>;
  /** fetch data from the table in a streaming manner: "campaign_routing.zipcode" */
  campaign_routing_zipcode_stream: Array<Campaign_Routing_Zipcode>;
  /** fetch data from the table: "campaign.settings_override" */
  campaign_settings_override: Array<Campaign_Settings_Override>;
  /** fetch aggregated fields from the table: "campaign.settings_override" */
  campaign_settings_override_aggregate: Campaign_Settings_Override_Aggregate;
  /** fetch data from the table: "campaign.settings_override" using primary key columns */
  campaign_settings_override_by_pk?: Maybe<Campaign_Settings_Override>;
  /** fetch data from the table in a streaming manner: "campaign.settings_override" */
  campaign_settings_override_stream: Array<Campaign_Settings_Override>;
  /** fetch data from the table: "campaign_status" */
  campaign_status: Array<Campaign_Status>;
  /** fetch aggregated fields from the table: "campaign_status" */
  campaign_status_aggregate: Campaign_Status_Aggregate;
  /** fetch data from the table: "campaign_status" using primary key columns */
  campaign_status_by_pk?: Maybe<Campaign_Status>;
  /** fetch data from the table: "campaign.status_event" */
  campaign_status_event: Array<Campaign_Status_Event>;
  /** fetch aggregated fields from the table: "campaign.status_event" */
  campaign_status_event_aggregate: Campaign_Status_Event_Aggregate;
  /** fetch data from the table: "campaign.status_event" using primary key columns */
  campaign_status_event_by_pk?: Maybe<Campaign_Status_Event>;
  /** fetch data from the table in a streaming manner: "campaign.status_event" */
  campaign_status_event_stream: Array<Campaign_Status_Event>;
  /** fetch data from the table: "campaign.status_log" */
  campaign_status_log: Array<Campaign_Status_Log>;
  /** fetch aggregated fields from the table: "campaign.status_log" */
  campaign_status_log_aggregate: Campaign_Status_Log_Aggregate;
  /** fetch data from the table: "campaign.status_log" using primary key columns */
  campaign_status_log_by_pk?: Maybe<Campaign_Status_Log>;
  /** fetch data from the table in a streaming manner: "campaign.status_log" */
  campaign_status_log_stream: Array<Campaign_Status_Log>;
  /** fetch data from the table in a streaming manner: "campaign_status" */
  campaign_status_stream: Array<Campaign_Status>;
  /** fetch data from the table in a streaming manner: "campaign" */
  campaign_stream: Array<Campaign>;
  /** fetch data from the table: "campaign.transaction_type" */
  campaign_transaction_type: Array<Campaign_Transaction_Type>;
  /** fetch aggregated fields from the table: "campaign.transaction_type" */
  campaign_transaction_type_aggregate: Campaign_Transaction_Type_Aggregate;
  /** fetch data from the table: "campaign.transaction_type" using primary key columns */
  campaign_transaction_type_by_pk?: Maybe<Campaign_Transaction_Type>;
  /** fetch data from the table in a streaming manner: "campaign.transaction_type" */
  campaign_transaction_type_stream: Array<Campaign_Transaction_Type>;
  /** fetch data from the table: "campaign_work_location" */
  campaign_work_location: Array<Campaign_Work_Location>;
  /** fetch aggregated fields from the table: "campaign_work_location" */
  campaign_work_location_aggregate: Campaign_Work_Location_Aggregate;
  /** fetch data from the table: "campaign_work_location" using primary key columns */
  campaign_work_location_by_pk?: Maybe<Campaign_Work_Location>;
  /** fetch data from the table in a streaming manner: "campaign_work_location" */
  campaign_work_location_stream: Array<Campaign_Work_Location>;
  /** fetch data from the table: "chat_bot.customers" */
  chat_bot_customers: Array<Chat_Bot_Customers>;
  /** fetch aggregated fields from the table: "chat_bot.customers" */
  chat_bot_customers_aggregate: Chat_Bot_Customers_Aggregate;
  /** fetch data from the table: "chat_bot.customers" using primary key columns */
  chat_bot_customers_by_pk?: Maybe<Chat_Bot_Customers>;
  /** fetch data from the table in a streaming manner: "chat_bot.customers" */
  chat_bot_customers_stream: Array<Chat_Bot_Customers>;
  /** fetch data from the table: "chat_bot.forwarding" */
  chat_bot_forwarding: Array<Chat_Bot_Forwarding>;
  /** fetch aggregated fields from the table: "chat_bot.forwarding" */
  chat_bot_forwarding_aggregate: Chat_Bot_Forwarding_Aggregate;
  /** fetch data from the table: "chat_bot.forwarding" using primary key columns */
  chat_bot_forwarding_by_pk?: Maybe<Chat_Bot_Forwarding>;
  /** fetch data from the table in a streaming manner: "chat_bot.forwarding" */
  chat_bot_forwarding_stream: Array<Chat_Bot_Forwarding>;
  /** fetch data from the table: "chat_bot.message_type" */
  chat_bot_message_type: Array<Chat_Bot_Message_Type>;
  /** fetch aggregated fields from the table: "chat_bot.message_type" */
  chat_bot_message_type_aggregate: Chat_Bot_Message_Type_Aggregate;
  /** fetch data from the table: "chat_bot.message_type" using primary key columns */
  chat_bot_message_type_by_pk?: Maybe<Chat_Bot_Message_Type>;
  /** fetch data from the table in a streaming manner: "chat_bot.message_type" */
  chat_bot_message_type_stream: Array<Chat_Bot_Message_Type>;
  /** fetch data from the table: "chat_bot.messages" */
  chat_bot_messages: Array<Chat_Bot_Messages>;
  /** fetch aggregated fields from the table: "chat_bot.messages" */
  chat_bot_messages_aggregate: Chat_Bot_Messages_Aggregate;
  /** fetch data from the table: "chat_bot.messages" using primary key columns */
  chat_bot_messages_by_pk?: Maybe<Chat_Bot_Messages>;
  /** fetch data from the table in a streaming manner: "chat_bot.messages" */
  chat_bot_messages_stream: Array<Chat_Bot_Messages>;
  /** fetch data from the table: "contact" */
  contact: Array<Contact>;
  /** fetch aggregated fields from the table: "contact" */
  contact_aggregate: Contact_Aggregate;
  /** fetch data from the table: "contact" using primary key columns */
  contact_by_pk?: Maybe<Contact>;
  /** fetch data from the table: "contact.logs" */
  contact_logs: Array<Contact_Logs>;
  /** fetch aggregated fields from the table: "contact.logs" */
  contact_logs_aggregate: Contact_Logs_Aggregate;
  /** fetch data from the table: "contact.logs" using primary key columns */
  contact_logs_by_pk?: Maybe<Contact_Logs>;
  /** fetch data from the table in a streaming manner: "contact.logs" */
  contact_logs_stream: Array<Contact_Logs>;
  /** fetch data from the table in a streaming manner: "contact" */
  contact_stream: Array<Contact>;
  /** fetch data from the table: "file.pdf_templates" */
  file_pdf_templates: Array<File_Pdf_Templates>;
  /** fetch aggregated fields from the table: "file.pdf_templates" */
  file_pdf_templates_aggregate: File_Pdf_Templates_Aggregate;
  /** fetch data from the table: "file.pdf_templates" using primary key columns */
  file_pdf_templates_by_pk?: Maybe<File_Pdf_Templates>;
  /** fetch data from the table in a streaming manner: "file.pdf_templates" */
  file_pdf_templates_stream: Array<File_Pdf_Templates>;
  /** fetch data from the table: "file.upload" */
  file_upload: Array<File_Upload>;
  /** fetch aggregated fields from the table: "file.upload" */
  file_upload_aggregate: File_Upload_Aggregate;
  /** fetch data from the table: "file.upload" using primary key columns */
  file_upload_by_pk?: Maybe<File_Upload>;
  /** fetch data from the table in a streaming manner: "file.upload" */
  file_upload_stream: Array<File_Upload>;
  /** fetch data from the table: "funnel.benefits" */
  funnel_benefits: Array<Funnel_Benefits>;
  /** fetch aggregated fields from the table: "funnel.benefits" */
  funnel_benefits_aggregate: Funnel_Benefits_Aggregate;
  /** fetch data from the table: "funnel.benefits" using primary key columns */
  funnel_benefits_by_pk?: Maybe<Funnel_Benefits>;
  /** fetch data from the table in a streaming manner: "funnel.benefits" */
  funnel_benefits_stream: Array<Funnel_Benefits>;
  /** fetch data from the table: "funnel.chatbot_message" */
  funnel_chatbot_message: Array<Funnel_Chatbot_Message>;
  /** fetch aggregated fields from the table: "funnel.chatbot_message" */
  funnel_chatbot_message_aggregate: Funnel_Chatbot_Message_Aggregate;
  /** fetch data from the table: "funnel.chatbot_message" using primary key columns */
  funnel_chatbot_message_by_pk?: Maybe<Funnel_Chatbot_Message>;
  /** fetch data from the table in a streaming manner: "funnel.chatbot_message" */
  funnel_chatbot_message_stream: Array<Funnel_Chatbot_Message>;
  /** fetch data from the table: "funnel.chatbot_session" */
  funnel_chatbot_session: Array<Funnel_Chatbot_Session>;
  /** fetch aggregated fields from the table: "funnel.chatbot_session" */
  funnel_chatbot_session_aggregate: Funnel_Chatbot_Session_Aggregate;
  /** fetch data from the table: "funnel.chatbot_session" using primary key columns */
  funnel_chatbot_session_by_pk?: Maybe<Funnel_Chatbot_Session>;
  /** fetch data from the table in a streaming manner: "funnel.chatbot_session" */
  funnel_chatbot_session_stream: Array<Funnel_Chatbot_Session>;
  /** fetch data from the table: "funnel.funnels" */
  funnel_funnels: Array<Funnel_Funnels>;
  /** fetch aggregated fields from the table: "funnel.funnels" */
  funnel_funnels_aggregate: Funnel_Funnels_Aggregate;
  /** fetch data from the table: "funnel.funnels" using primary key columns */
  funnel_funnels_by_pk?: Maybe<Funnel_Funnels>;
  /** fetch data from the table in a streaming manner: "funnel.funnels" */
  funnel_funnels_stream: Array<Funnel_Funnels>;
  /** fetch data from the table: "funnel.insights" */
  funnel_insights: Array<Funnel_Insights>;
  /** fetch aggregated fields from the table: "funnel.insights" */
  funnel_insights_aggregate: Funnel_Insights_Aggregate;
  /** fetch data from the table in a streaming manner: "funnel.insights" */
  funnel_insights_stream: Array<Funnel_Insights>;
  /** An array relationship */
  funnel_page_insights: Array<Funnel_Page_Insights>;
  /** An aggregate relationship */
  funnel_page_insights_aggregate: Funnel_Page_Insights_Aggregate;
  /** fetch data from the table: "funnel.page_insights" using primary key columns */
  funnel_page_insights_by_pk?: Maybe<Funnel_Page_Insights>;
  /** fetch data from the table in a streaming manner: "funnel.page_insights" */
  funnel_page_insights_stream: Array<Funnel_Page_Insights>;
  /** fetch data from the table: "funnel.question" */
  funnel_question: Array<Funnel_Question>;
  /** fetch aggregated fields from the table: "funnel.question" */
  funnel_question_aggregate: Funnel_Question_Aggregate;
  /** fetch data from the table: "funnel.question" using primary key columns */
  funnel_question_by_pk?: Maybe<Funnel_Question>;
  /** fetch data from the table: "funnel.question_option" */
  funnel_question_option: Array<Funnel_Question_Option>;
  /** fetch aggregated fields from the table: "funnel.question_option" */
  funnel_question_option_aggregate: Funnel_Question_Option_Aggregate;
  /** fetch data from the table: "funnel.question_option" using primary key columns */
  funnel_question_option_by_pk?: Maybe<Funnel_Question_Option>;
  /** fetch data from the table in a streaming manner: "funnel.question_option" */
  funnel_question_option_stream: Array<Funnel_Question_Option>;
  /** fetch data from the table in a streaming manner: "funnel.question" */
  funnel_question_stream: Array<Funnel_Question>;
  /** An array relationship */
  funnel_whatsapp_share_clicks: Array<Funnel_Whatsapp_Share_Clicks>;
  /** An aggregate relationship */
  funnel_whatsapp_share_clicks_aggregate: Funnel_Whatsapp_Share_Clicks_Aggregate;
  /** fetch data from the table: "funnel.whatsapp_share_clicks" using primary key columns */
  funnel_whatsapp_share_clicks_by_pk?: Maybe<Funnel_Whatsapp_Share_Clicks>;
  /** fetch data from the table in a streaming manner: "funnel.whatsapp_share_clicks" */
  funnel_whatsapp_share_clicks_stream: Array<Funnel_Whatsapp_Share_Clicks>;
  /** fetch data from the table: "huk_contacts" */
  huk_contacts: Array<Huk_Contacts>;
  /** fetch aggregated fields from the table: "huk_contacts" */
  huk_contacts_aggregate: Huk_Contacts_Aggregate;
  /** fetch data from the table in a streaming manner: "huk_contacts" */
  huk_contacts_stream: Array<Huk_Contacts>;
  /** fetch data from the table: "new_contacts_per_day" */
  new_contacts_per_day: Array<New_Contacts_Per_Day>;
  /** fetch aggregated fields from the table: "new_contacts_per_day" */
  new_contacts_per_day_aggregate: New_Contacts_Per_Day_Aggregate;
  /** fetch data from the table in a streaming manner: "new_contacts_per_day" */
  new_contacts_per_day_stream: Array<New_Contacts_Per_Day>;
  /** fetch data from the table: "new_unqualified_contacts_per_day" */
  new_unqualified_contacts_per_day: Array<New_Unqualified_Contacts_Per_Day>;
  /** fetch aggregated fields from the table: "new_unqualified_contacts_per_day" */
  new_unqualified_contacts_per_day_aggregate: New_Unqualified_Contacts_Per_Day_Aggregate;
  /** fetch data from the table in a streaming manner: "new_unqualified_contacts_per_day" */
  new_unqualified_contacts_per_day_stream: Array<New_Unqualified_Contacts_Per_Day>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization.budget" */
  organization_budget: Array<Organization_Budget>;
  /** fetch aggregated fields from the table: "organization.budget" */
  organization_budget_aggregate: Organization_Budget_Aggregate;
  /** fetch data from the table in a streaming manner: "organization.budget" */
  organization_budget_stream: Array<Organization_Budget>;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "organization_contacts_per_day" */
  organization_contacts_per_day: Array<Organization_Contacts_Per_Day>;
  /** fetch aggregated fields from the table: "organization_contacts_per_day" */
  organization_contacts_per_day_aggregate: Organization_Contacts_Per_Day_Aggregate;
  /** fetch data from the table in a streaming manner: "organization_contacts_per_day" */
  organization_contacts_per_day_stream: Array<Organization_Contacts_Per_Day>;
  /** fetch data from the table: "organization.location" */
  organization_location: Array<Organization_Location>;
  /** fetch aggregated fields from the table: "organization.location" */
  organization_location_aggregate: Organization_Location_Aggregate;
  /** fetch data from the table: "organization.location" using primary key columns */
  organization_location_by_pk?: Maybe<Organization_Location>;
  /** fetch data from the table in a streaming manner: "organization.location" */
  organization_location_stream: Array<Organization_Location>;
  /** fetch data from the table: "organization_name_prefix" */
  organization_name_prefix: Array<Organization_Name_Prefix>;
  /** fetch aggregated fields from the table: "organization_name_prefix" */
  organization_name_prefix_aggregate: Organization_Name_Prefix_Aggregate;
  /** fetch data from the table: "organization_name_prefix" using primary key columns */
  organization_name_prefix_by_pk?: Maybe<Organization_Name_Prefix>;
  /** fetch data from the table in a streaming manner: "organization_name_prefix" */
  organization_name_prefix_stream: Array<Organization_Name_Prefix>;
  /** fetch data from the table: "organization.news" */
  organization_news: Array<Organization_News>;
  /** fetch aggregated fields from the table: "organization.news" */
  organization_news_aggregate: Organization_News_Aggregate;
  /** fetch data from the table: "organization.news" using primary key columns */
  organization_news_by_pk?: Maybe<Organization_News>;
  /** fetch data from the table in a streaming manner: "organization.news" */
  organization_news_stream: Array<Organization_News>;
  /** fetch data from the table: "organization.region" */
  organization_region: Array<Organization_Region>;
  /** fetch aggregated fields from the table: "organization.region" */
  organization_region_aggregate: Organization_Region_Aggregate;
  /** fetch data from the table: "organization.region" using primary key columns */
  organization_region_by_pk?: Maybe<Organization_Region>;
  /** fetch data from the table in a streaming manner: "organization.region" */
  organization_region_stream: Array<Organization_Region>;
  /** fetch data from the table: "organization.settings" */
  organization_settings: Array<Organization_Settings>;
  /** fetch aggregated fields from the table: "organization.settings" */
  organization_settings_aggregate: Organization_Settings_Aggregate;
  /** fetch data from the table: "organization.settings" using primary key columns */
  organization_settings_by_pk?: Maybe<Organization_Settings>;
  /** fetch data from the table in a streaming manner: "organization.settings" */
  organization_settings_stream: Array<Organization_Settings>;
  /** fetch data from the table in a streaming manner: "organization" */
  organization_stream: Array<Organization>;
  /** fetch data from the table: "perspective_campaign" */
  perspective_campaign: Array<Perspective_Campaign>;
  /** fetch aggregated fields from the table: "perspective_campaign" */
  perspective_campaign_aggregate: Perspective_Campaign_Aggregate;
  /** fetch data from the table: "perspective_campaign" using primary key columns */
  perspective_campaign_by_pk?: Maybe<Perspective_Campaign>;
  /** fetch data from the table in a streaming manner: "perspective_campaign" */
  perspective_campaign_stream: Array<Perspective_Campaign>;
  /** fetch data from the table: "qa_source" */
  qa_source: Array<Qa_Source>;
  /** fetch aggregated fields from the table: "qa_source" */
  qa_source_aggregate: Qa_Source_Aggregate;
  /** fetch data from the table: "qa_source" using primary key columns */
  qa_source_by_pk?: Maybe<Qa_Source>;
  /** fetch data from the table in a streaming manner: "qa_source" */
  qa_source_stream: Array<Qa_Source>;
  /** fetch data from the table: "rms.connectors" */
  rms_connectors: Array<Rms_Connectors>;
  /** fetch aggregated fields from the table: "rms.connectors" */
  rms_connectors_aggregate: Rms_Connectors_Aggregate;
  /** fetch data from the table: "rms.connectors" using primary key columns */
  rms_connectors_by_pk?: Maybe<Rms_Connectors>;
  /** fetch data from the table in a streaming manner: "rms.connectors" */
  rms_connectors_stream: Array<Rms_Connectors>;
  /** fetch data from the table: "rms.forwarded_logs" */
  rms_forwarded_logs: Array<Rms_Forwarded_Logs>;
  /** fetch aggregated fields from the table: "rms.forwarded_logs" */
  rms_forwarded_logs_aggregate: Rms_Forwarded_Logs_Aggregate;
  /** fetch data from the table: "rms.forwarded_logs" using primary key columns */
  rms_forwarded_logs_by_pk?: Maybe<Rms_Forwarded_Logs>;
  /** fetch data from the table in a streaming manner: "rms.forwarded_logs" */
  rms_forwarded_logs_stream: Array<Rms_Forwarded_Logs>;
  /** fetch data from the table: "rms.org_setups" */
  rms_org_setups: Array<Rms_Org_Setups>;
  /** fetch aggregated fields from the table: "rms.org_setups" */
  rms_org_setups_aggregate: Rms_Org_Setups_Aggregate;
  /** fetch data from the table: "rms.org_setups" using primary key columns */
  rms_org_setups_by_pk?: Maybe<Rms_Org_Setups>;
  /** fetch data from the table in a streaming manner: "rms.org_setups" */
  rms_org_setups_stream: Array<Rms_Org_Setups>;
  /** fetch data from the table: "system.api_keys" */
  system_api_keys: Array<System_Api_Keys>;
  /** fetch aggregated fields from the table: "system.api_keys" */
  system_api_keys_aggregate: System_Api_Keys_Aggregate;
  /** fetch data from the table: "system.api_keys" using primary key columns */
  system_api_keys_by_pk?: Maybe<System_Api_Keys>;
  /** fetch data from the table in a streaming manner: "system.api_keys" */
  system_api_keys_stream: Array<System_Api_Keys>;
  /** fetch data from the table: "system.call_daily_stats" */
  system_call_daily_stats: Array<System_Call_Daily_Stats>;
  /** fetch aggregated fields from the table: "system.call_daily_stats" */
  system_call_daily_stats_aggregate: System_Call_Daily_Stats_Aggregate;
  /** fetch data from the table: "system.call_daily_stats" using primary key columns */
  system_call_daily_stats_by_pk?: Maybe<System_Call_Daily_Stats>;
  /** fetch data from the table in a streaming manner: "system.call_daily_stats" */
  system_call_daily_stats_stream: Array<System_Call_Daily_Stats>;
  /** fetch data from the table: "system.email_daily_stats" */
  system_email_daily_stats: Array<System_Email_Daily_Stats>;
  /** fetch aggregated fields from the table: "system.email_daily_stats" */
  system_email_daily_stats_aggregate: System_Email_Daily_Stats_Aggregate;
  /** fetch data from the table: "system.email_daily_stats" using primary key columns */
  system_email_daily_stats_by_pk?: Maybe<System_Email_Daily_Stats>;
  /** fetch data from the table in a streaming manner: "system.email_daily_stats" */
  system_email_daily_stats_stream: Array<System_Email_Daily_Stats>;
  /** fetch data from the table: "system.running_release" */
  system_running_release: Array<System_Running_Release>;
  /** fetch aggregated fields from the table: "system.running_release" */
  system_running_release_aggregate: System_Running_Release_Aggregate;
  /** fetch data from the table: "system.running_release" using primary key columns */
  system_running_release_by_pk?: Maybe<System_Running_Release>;
  /** fetch data from the table in a streaming manner: "system.running_release" */
  system_running_release_stream: Array<System_Running_Release>;
  /** fetch data from the table: "system.sms_daily_stats" */
  system_sms_daily_stats: Array<System_Sms_Daily_Stats>;
  /** fetch aggregated fields from the table: "system.sms_daily_stats" */
  system_sms_daily_stats_aggregate: System_Sms_Daily_Stats_Aggregate;
  /** fetch data from the table: "system.sms_daily_stats" using primary key columns */
  system_sms_daily_stats_by_pk?: Maybe<System_Sms_Daily_Stats>;
  /** fetch data from the table in a streaming manner: "system.sms_daily_stats" */
  system_sms_daily_stats_stream: Array<System_Sms_Daily_Stats>;
};


export type Subscription_RootAd_Campaign_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Metrics_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
};


export type Subscription_RootAd_Campaign_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Metrics_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
};


export type Subscription_RootAd_Campaign_Metrics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAd_Campaign_Metrics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Campaign_Metrics_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Campaign_Metrics_Bool_Exp>;
};


export type Subscription_RootAd_CommentArgs = {
  distinct_on?: InputMaybe<Array<Ad_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Comment_Order_By>>;
  where?: InputMaybe<Ad_Comment_Bool_Exp>;
};


export type Subscription_RootAd_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Comment_Order_By>>;
  where?: InputMaybe<Ad_Comment_Bool_Exp>;
};


export type Subscription_RootAd_Comment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAd_Comment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Comment_Bool_Exp>;
};


export type Subscription_RootAd_CreativeArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Order_By>>;
  where?: InputMaybe<Ad_Creative_Bool_Exp>;
};


export type Subscription_RootAd_Creative_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Order_By>>;
  where?: InputMaybe<Ad_Creative_Bool_Exp>;
};


export type Subscription_RootAd_Creative_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAd_Creative_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Feedback_Order_By>>;
  where?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
};


export type Subscription_RootAd_Creative_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Creative_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Creative_Feedback_Order_By>>;
  where?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
};


export type Subscription_RootAd_Creative_Feedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAd_Creative_Feedback_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Creative_Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Creative_Feedback_Bool_Exp>;
};


export type Subscription_RootAd_Creative_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Creative_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Creative_Bool_Exp>;
};


export type Subscription_RootAd_PlatformArgs = {
  distinct_on?: InputMaybe<Array<Ad_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Platform_Order_By>>;
  where?: InputMaybe<Ad_Platform_Bool_Exp>;
};


export type Subscription_RootAd_Platform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Platform_Order_By>>;
  where?: InputMaybe<Ad_Platform_Bool_Exp>;
};


export type Subscription_RootAd_Platform_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAd_Platform_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Platform_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Platform_Bool_Exp>;
};


export type Subscription_RootAd_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Ad_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Providers_Order_By>>;
  where?: InputMaybe<Ad_Providers_Bool_Exp>;
};


export type Subscription_RootAd_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Providers_Order_By>>;
  where?: InputMaybe<Ad_Providers_Bool_Exp>;
};


export type Subscription_RootAd_Providers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAd_Providers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Providers_Bool_Exp>;
};


export type Subscription_RootAd_SettingArgs = {
  distinct_on?: InputMaybe<Array<Ad_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Setting_Order_By>>;
  where?: InputMaybe<Ad_Setting_Bool_Exp>;
};


export type Subscription_RootAd_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Setting_Order_By>>;
  where?: InputMaybe<Ad_Setting_Bool_Exp>;
};


export type Subscription_RootAd_Setting_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAd_Setting_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Setting_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Setting_Bool_Exp>;
};


export type Subscription_RootAd_StatusArgs = {
  distinct_on?: InputMaybe<Array<Ad_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Status_Order_By>>;
  where?: InputMaybe<Ad_Status_Bool_Exp>;
};


export type Subscription_RootAd_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Status_Order_By>>;
  where?: InputMaybe<Ad_Status_Bool_Exp>;
};


export type Subscription_RootAd_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAd_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Status_Bool_Exp>;
};


export type Subscription_RootAnna_Ai_Call_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Order_By>>;
  where?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
};


export type Subscription_RootAnna_Ai_Call_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Call_Campaigns_Order_By>>;
  where?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
};


export type Subscription_RootAnna_Ai_Call_Campaigns_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAnna_Ai_Call_Campaigns_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anna_Ai_Call_Campaigns_Stream_Cursor_Input>>;
  where?: InputMaybe<Anna_Ai_Call_Campaigns_Bool_Exp>;
};


export type Subscription_RootAnna_Ai_Call_StatesArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Call_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Call_States_Order_By>>;
  where?: InputMaybe<Anna_Ai_Call_States_Bool_Exp>;
};


export type Subscription_RootAnna_Ai_Call_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Call_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Call_States_Order_By>>;
  where?: InputMaybe<Anna_Ai_Call_States_Bool_Exp>;
};


export type Subscription_RootAnna_Ai_Call_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAnna_Ai_Call_States_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anna_Ai_Call_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Anna_Ai_Call_States_Bool_Exp>;
};


export type Subscription_RootAnna_Ai_Outbound_CallsArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Order_By>>;
  where?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
};


export type Subscription_RootAnna_Ai_Outbound_Calls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anna_Ai_Outbound_Calls_Order_By>>;
  where?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
};


export type Subscription_RootAnna_Ai_Outbound_Calls_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAnna_Ai_Outbound_Calls_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anna_Ai_Outbound_Calls_Stream_Cursor_Input>>;
  where?: InputMaybe<Anna_Ai_Outbound_Calls_Bool_Exp>;
};


export type Subscription_RootAnswerArgs = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By>>;
  where?: InputMaybe<Answer_Bool_Exp>;
};


export type Subscription_RootAnswer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By>>;
  where?: InputMaybe<Answer_Bool_Exp>;
};


export type Subscription_RootAnswer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAnswer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Answer_Stream_Cursor_Input>>;
  where?: InputMaybe<Answer_Bool_Exp>;
};


export type Subscription_RootApplicant_EventArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Event_Order_By>>;
  where?: InputMaybe<Applicant_Event_Bool_Exp>;
};


export type Subscription_RootApplicant_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Event_Order_By>>;
  where?: InputMaybe<Applicant_Event_Bool_Exp>;
};


export type Subscription_RootApplicant_Event_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootApplicant_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Event_Bool_Exp>;
};


export type Subscription_RootBoard_Column_TypeArgs = {
  distinct_on?: InputMaybe<Array<Board_Column_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Column_Type_Order_By>>;
  where?: InputMaybe<Board_Column_Type_Bool_Exp>;
};


export type Subscription_RootBoard_Column_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Column_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Column_Type_Order_By>>;
  where?: InputMaybe<Board_Column_Type_Bool_Exp>;
};


export type Subscription_RootBoard_Column_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBoard_Column_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Board_Column_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Board_Column_Type_Bool_Exp>;
};


export type Subscription_RootBoard_Contact_BoardArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Bool_Exp>;
};


export type Subscription_RootBoard_Contact_Board_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Bool_Exp>;
};


export type Subscription_RootBoard_Contact_Board_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBoard_Contact_Board_ColumnArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Column_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
};


export type Subscription_RootBoard_Contact_Board_Column_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Column_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
};


export type Subscription_RootBoard_Contact_Board_Column_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBoard_Contact_Board_Column_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Board_Contact_Board_Column_Stream_Cursor_Input>>;
  where?: InputMaybe<Board_Contact_Board_Column_Bool_Exp>;
};


export type Subscription_RootBoard_Contact_Board_EntryArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Entry_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
};


export type Subscription_RootBoard_Contact_Board_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Contact_Board_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Contact_Board_Entry_Order_By>>;
  where?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
};


export type Subscription_RootBoard_Contact_Board_Entry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBoard_Contact_Board_Entry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Board_Contact_Board_Entry_Stream_Cursor_Input>>;
  where?: InputMaybe<Board_Contact_Board_Entry_Bool_Exp>;
};


export type Subscription_RootBoard_Contact_Board_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Board_Contact_Board_Stream_Cursor_Input>>;
  where?: InputMaybe<Board_Contact_Board_Bool_Exp>;
};


export type Subscription_RootBoard_NoteArgs = {
  distinct_on?: InputMaybe<Array<Board_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Note_Order_By>>;
  where?: InputMaybe<Board_Note_Bool_Exp>;
};


export type Subscription_RootBoard_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Board_Note_Order_By>>;
  where?: InputMaybe<Board_Note_Bool_Exp>;
};


export type Subscription_RootBoard_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBoard_Note_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Board_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Board_Note_Bool_Exp>;
};


export type Subscription_RootBot_AssigneeArgs = {
  distinct_on?: InputMaybe<Array<Bot_Assignee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Assignee_Order_By>>;
  where?: InputMaybe<Bot_Assignee_Bool_Exp>;
};


export type Subscription_RootBot_Assignee_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Assignee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Assignee_Order_By>>;
  where?: InputMaybe<Bot_Assignee_Bool_Exp>;
};


export type Subscription_RootBot_Assignee_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBot_Assignee_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bot_Assignee_Stream_Cursor_Input>>;
  where?: InputMaybe<Bot_Assignee_Bool_Exp>;
};


export type Subscription_RootBot_ChannelArgs = {
  distinct_on?: InputMaybe<Array<Bot_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Channel_Order_By>>;
  where?: InputMaybe<Bot_Channel_Bool_Exp>;
};


export type Subscription_RootBot_Channel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Channel_Order_By>>;
  where?: InputMaybe<Bot_Channel_Bool_Exp>;
};


export type Subscription_RootBot_Channel_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBot_Channel_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bot_Channel_Stream_Cursor_Input>>;
  where?: InputMaybe<Bot_Channel_Bool_Exp>;
};


export type Subscription_RootBot_ConversationArgs = {
  distinct_on?: InputMaybe<Array<Bot_Conversation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Conversation_Order_By>>;
  where?: InputMaybe<Bot_Conversation_Bool_Exp>;
};


export type Subscription_RootBot_Conversation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Conversation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Conversation_Order_By>>;
  where?: InputMaybe<Bot_Conversation_Bool_Exp>;
};


export type Subscription_RootBot_Conversation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBot_Conversation_StateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Conversation_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Conversation_State_Order_By>>;
  where?: InputMaybe<Bot_Conversation_State_Bool_Exp>;
};


export type Subscription_RootBot_Conversation_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Conversation_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Conversation_State_Order_By>>;
  where?: InputMaybe<Bot_Conversation_State_Bool_Exp>;
};


export type Subscription_RootBot_Conversation_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBot_Conversation_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bot_Conversation_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Bot_Conversation_State_Bool_Exp>;
};


export type Subscription_RootBot_Conversation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bot_Conversation_Stream_Cursor_Input>>;
  where?: InputMaybe<Bot_Conversation_Bool_Exp>;
};


export type Subscription_RootBot_MessageArgs = {
  distinct_on?: InputMaybe<Array<Bot_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Message_Order_By>>;
  where?: InputMaybe<Bot_Message_Bool_Exp>;
};


export type Subscription_RootBot_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Message_Order_By>>;
  where?: InputMaybe<Bot_Message_Bool_Exp>;
};


export type Subscription_RootBot_Message_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBot_Message_StatusArgs = {
  distinct_on?: InputMaybe<Array<Bot_Message_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Message_Status_Order_By>>;
  where?: InputMaybe<Bot_Message_Status_Bool_Exp>;
};


export type Subscription_RootBot_Message_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Message_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Message_Status_Order_By>>;
  where?: InputMaybe<Bot_Message_Status_Bool_Exp>;
};


export type Subscription_RootBot_Message_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBot_Message_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bot_Message_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Bot_Message_Status_Bool_Exp>;
};


export type Subscription_RootBot_Message_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bot_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Bot_Message_Bool_Exp>;
};


export type Subscription_RootBot_SenderArgs = {
  distinct_on?: InputMaybe<Array<Bot_Sender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Sender_Order_By>>;
  where?: InputMaybe<Bot_Sender_Bool_Exp>;
};


export type Subscription_RootBot_Sender_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bot_Sender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bot_Sender_Order_By>>;
  where?: InputMaybe<Bot_Sender_Bool_Exp>;
};


export type Subscription_RootBot_Sender_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBot_Sender_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bot_Sender_Stream_Cursor_Input>>;
  where?: InputMaybe<Bot_Sender_Bool_Exp>;
};


export type Subscription_RootCampaignArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_By>>;
  where?: InputMaybe<Campaign_Bool_Exp>;
};


export type Subscription_RootCampaign_AdArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Ad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Ad_Order_By>>;
  where?: InputMaybe<Campaign_Ad_Bool_Exp>;
};


export type Subscription_RootCampaign_Ad_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Ad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Ad_Order_By>>;
  where?: InputMaybe<Campaign_Ad_Bool_Exp>;
};


export type Subscription_RootCampaign_Ad_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCampaign_Ad_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Ad_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Ad_Bool_Exp>;
};


export type Subscription_RootCampaign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_By>>;
  where?: InputMaybe<Campaign_Bool_Exp>;
};


export type Subscription_RootCampaign_BudgetArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Budget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Bool_Exp>;
};


export type Subscription_RootCampaign_Budget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Budget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Bool_Exp>;
};


export type Subscription_RootCampaign_Budget_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Budget_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Budget_Bool_Exp>;
};


export type Subscription_RootCampaign_Budget_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Transaction_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


export type Subscription_RootCampaign_Budget_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Transaction_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


export type Subscription_RootCampaign_Budget_Transaction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCampaign_Budget_Transaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Budget_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


export type Subscription_RootCampaign_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCampaign_Email_Template_OverwriteArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Order_By>>;
  where?: InputMaybe<Campaign_Email_Template_Overwrite_Bool_Exp>;
};


export type Subscription_RootCampaign_Email_Template_Overwrite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Email_Template_Overwrite_Order_By>>;
  where?: InputMaybe<Campaign_Email_Template_Overwrite_Bool_Exp>;
};


export type Subscription_RootCampaign_Email_Template_Overwrite_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


export type Subscription_RootCampaign_Email_Template_Overwrite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Email_Template_Overwrite_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Email_Template_Overwrite_Bool_Exp>;
};


export type Subscription_RootCampaign_Event_LogArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Event_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Event_Log_Order_By>>;
  where?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
};


export type Subscription_RootCampaign_Event_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Event_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Event_Log_Order_By>>;
  where?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
};


export type Subscription_RootCampaign_Event_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCampaign_Event_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Event_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Event_Log_Bool_Exp>;
};


export type Subscription_RootCampaign_Get_Daily_BudgetArgs = {
  args: Campaign_Get_Daily_Budget_Args;
  distinct_on?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Transaction_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


export type Subscription_RootCampaign_Get_Daily_Budget_AggregateArgs = {
  args: Campaign_Get_Daily_Budget_Args;
  distinct_on?: InputMaybe<Array<Campaign_Budget_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Budget_Transaction_Order_By>>;
  where?: InputMaybe<Campaign_Budget_Transaction_Bool_Exp>;
};


export type Subscription_RootCampaign_Iso_2_Country_CodesArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Order_By>>;
  where?: InputMaybe<Campaign_Iso_2_Country_Codes_Bool_Exp>;
};


export type Subscription_RootCampaign_Iso_2_Country_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Iso_2_Country_Codes_Order_By>>;
  where?: InputMaybe<Campaign_Iso_2_Country_Codes_Bool_Exp>;
};


export type Subscription_RootCampaign_Iso_2_Country_Codes_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCampaign_Iso_2_Country_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Iso_2_Country_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Iso_2_Country_Codes_Bool_Exp>;
};


export type Subscription_RootCampaign_Job_DescriptionArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Job_Description_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Job_Description_Order_By>>;
  where?: InputMaybe<Campaign_Job_Description_Bool_Exp>;
};


export type Subscription_RootCampaign_Job_Description_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Job_Description_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Job_Description_Order_By>>;
  where?: InputMaybe<Campaign_Job_Description_Bool_Exp>;
};


export type Subscription_RootCampaign_Job_Description_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


export type Subscription_RootCampaign_Job_Description_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Job_Description_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Job_Description_Bool_Exp>;
};


export type Subscription_RootCampaign_OrderArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Order_By>>;
  where?: InputMaybe<Campaign_Order_Bool_Exp>;
};


export type Subscription_RootCampaign_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Order_By>>;
  where?: InputMaybe<Campaign_Order_Bool_Exp>;
};


export type Subscription_RootCampaign_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCampaign_Order_SourceArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Source_Order_By>>;
  where?: InputMaybe<Campaign_Order_Source_Bool_Exp>;
};


export type Subscription_RootCampaign_Order_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Source_Order_By>>;
  where?: InputMaybe<Campaign_Order_Source_Bool_Exp>;
};


export type Subscription_RootCampaign_Order_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCampaign_Order_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Order_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Order_Source_Bool_Exp>;
};


export type Subscription_RootCampaign_Order_Source_TypeArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Source_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Source_Type_Order_By>>;
  where?: InputMaybe<Campaign_Order_Source_Type_Bool_Exp>;
};


export type Subscription_RootCampaign_Order_Source_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Order_Source_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Order_Source_Type_Order_By>>;
  where?: InputMaybe<Campaign_Order_Source_Type_Bool_Exp>;
};


export type Subscription_RootCampaign_Order_Source_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCampaign_Order_Source_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Order_Source_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Order_Source_Type_Bool_Exp>;
};


export type Subscription_RootCampaign_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Order_Bool_Exp>;
};


export type Subscription_RootCampaign_Routing_DestinationArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Destination_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Destination_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
};


export type Subscription_RootCampaign_Routing_Destination_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Destination_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Destination_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
};


export type Subscription_RootCampaign_Routing_Destination_By_PkArgs = {
  location_id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};


export type Subscription_RootCampaign_Routing_Destination_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Routing_Destination_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Routing_Destination_Bool_Exp>;
};


export type Subscription_RootCampaign_Routing_InfoArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Info_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Info_Bool_Exp>;
};


export type Subscription_RootCampaign_Routing_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Info_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Info_Bool_Exp>;
};


export type Subscription_RootCampaign_Routing_Info_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


export type Subscription_RootCampaign_Routing_Info_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Routing_Info_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Routing_Info_Bool_Exp>;
};


export type Subscription_RootCampaign_Routing_ZipcodeArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Zipcode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Zipcode_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Zipcode_Bool_Exp>;
};


export type Subscription_RootCampaign_Routing_Zipcode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Routing_Zipcode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Routing_Zipcode_Order_By>>;
  where?: InputMaybe<Campaign_Routing_Zipcode_Bool_Exp>;
};


export type Subscription_RootCampaign_Routing_Zipcode_By_PkArgs = {
  organization_id: Scalars['String']['input'];
  zipcode: Scalars['bpchar']['input'];
};


export type Subscription_RootCampaign_Routing_Zipcode_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Routing_Zipcode_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Routing_Zipcode_Bool_Exp>;
};


export type Subscription_RootCampaign_Settings_OverrideArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Settings_Override_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Settings_Override_Order_By>>;
  where?: InputMaybe<Campaign_Settings_Override_Bool_Exp>;
};


export type Subscription_RootCampaign_Settings_Override_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Settings_Override_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Settings_Override_Order_By>>;
  where?: InputMaybe<Campaign_Settings_Override_Bool_Exp>;
};


export type Subscription_RootCampaign_Settings_Override_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


export type Subscription_RootCampaign_Settings_Override_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Settings_Override_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Settings_Override_Bool_Exp>;
};


export type Subscription_RootCampaign_StatusArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Order_By>>;
  where?: InputMaybe<Campaign_Status_Bool_Exp>;
};


export type Subscription_RootCampaign_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Order_By>>;
  where?: InputMaybe<Campaign_Status_Bool_Exp>;
};


export type Subscription_RootCampaign_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCampaign_Status_EventArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Event_Order_By>>;
  where?: InputMaybe<Campaign_Status_Event_Bool_Exp>;
};


export type Subscription_RootCampaign_Status_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Event_Order_By>>;
  where?: InputMaybe<Campaign_Status_Event_Bool_Exp>;
};


export type Subscription_RootCampaign_Status_Event_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCampaign_Status_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Status_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Status_Event_Bool_Exp>;
};


export type Subscription_RootCampaign_Status_LogArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Log_Order_By>>;
  where?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
};


export type Subscription_RootCampaign_Status_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Status_Log_Order_By>>;
  where?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
};


export type Subscription_RootCampaign_Status_Log_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
  created_at: Scalars['timestamptz']['input'];
};


export type Subscription_RootCampaign_Status_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Status_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Status_Log_Bool_Exp>;
};


export type Subscription_RootCampaign_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Status_Bool_Exp>;
};


export type Subscription_RootCampaign_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Bool_Exp>;
};


export type Subscription_RootCampaign_Transaction_TypeArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Transaction_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Transaction_Type_Order_By>>;
  where?: InputMaybe<Campaign_Transaction_Type_Bool_Exp>;
};


export type Subscription_RootCampaign_Transaction_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Transaction_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Transaction_Type_Order_By>>;
  where?: InputMaybe<Campaign_Transaction_Type_Bool_Exp>;
};


export type Subscription_RootCampaign_Transaction_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCampaign_Transaction_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Transaction_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Transaction_Type_Bool_Exp>;
};


export type Subscription_RootCampaign_Work_LocationArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Work_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Work_Location_Order_By>>;
  where?: InputMaybe<Campaign_Work_Location_Bool_Exp>;
};


export type Subscription_RootCampaign_Work_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campaign_Work_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Campaign_Work_Location_Order_By>>;
  where?: InputMaybe<Campaign_Work_Location_Bool_Exp>;
};


export type Subscription_RootCampaign_Work_Location_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCampaign_Work_Location_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Campaign_Work_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Campaign_Work_Location_Bool_Exp>;
};


export type Subscription_RootChat_Bot_CustomersArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Customers_Order_By>>;
  where?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
};


export type Subscription_RootChat_Bot_Customers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Customers_Order_By>>;
  where?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
};


export type Subscription_RootChat_Bot_Customers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootChat_Bot_Customers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Bot_Customers_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Bot_Customers_Bool_Exp>;
};


export type Subscription_RootChat_Bot_ForwardingArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Forwarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Forwarding_Order_By>>;
  where?: InputMaybe<Chat_Bot_Forwarding_Bool_Exp>;
};


export type Subscription_RootChat_Bot_Forwarding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Forwarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Forwarding_Order_By>>;
  where?: InputMaybe<Chat_Bot_Forwarding_Bool_Exp>;
};


export type Subscription_RootChat_Bot_Forwarding_By_PkArgs = {
  campaign_id: Scalars['uuid']['input'];
};


export type Subscription_RootChat_Bot_Forwarding_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Bot_Forwarding_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Bot_Forwarding_Bool_Exp>;
};


export type Subscription_RootChat_Bot_Message_TypeArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Message_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Message_Type_Order_By>>;
  where?: InputMaybe<Chat_Bot_Message_Type_Bool_Exp>;
};


export type Subscription_RootChat_Bot_Message_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Message_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Message_Type_Order_By>>;
  where?: InputMaybe<Chat_Bot_Message_Type_Bool_Exp>;
};


export type Subscription_RootChat_Bot_Message_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootChat_Bot_Message_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Bot_Message_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Bot_Message_Type_Bool_Exp>;
};


export type Subscription_RootChat_Bot_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Messages_Order_By>>;
  where?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
};


export type Subscription_RootChat_Bot_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bot_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Bot_Messages_Order_By>>;
  where?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
};


export type Subscription_RootChat_Bot_Messages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootChat_Bot_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Bot_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Bot_Messages_Bool_Exp>;
};


export type Subscription_RootContactArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootContact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootContact_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootContact_LogsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Logs_Order_By>>;
  where?: InputMaybe<Contact_Logs_Bool_Exp>;
};


export type Subscription_RootContact_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Logs_Order_By>>;
  where?: InputMaybe<Contact_Logs_Bool_Exp>;
};


export type Subscription_RootContact_Logs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootContact_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contact_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Contact_Logs_Bool_Exp>;
};


export type Subscription_RootContact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contact_Stream_Cursor_Input>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootFile_Pdf_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<File_Pdf_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Pdf_Templates_Order_By>>;
  where?: InputMaybe<File_Pdf_Templates_Bool_Exp>;
};


export type Subscription_RootFile_Pdf_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Pdf_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Pdf_Templates_Order_By>>;
  where?: InputMaybe<File_Pdf_Templates_Bool_Exp>;
};


export type Subscription_RootFile_Pdf_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Pdf_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<File_Pdf_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Pdf_Templates_Bool_Exp>;
};


export type Subscription_RootFile_UploadArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Upload_Order_By>>;
  where?: InputMaybe<File_Upload_Bool_Exp>;
};


export type Subscription_RootFile_Upload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Upload_Order_By>>;
  where?: InputMaybe<File_Upload_Bool_Exp>;
};


export type Subscription_RootFile_Upload_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Upload_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<File_Upload_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Upload_Bool_Exp>;
};


export type Subscription_RootFunnel_BenefitsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Benefits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Benefits_Order_By>>;
  where?: InputMaybe<Funnel_Benefits_Bool_Exp>;
};


export type Subscription_RootFunnel_Benefits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Benefits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Benefits_Order_By>>;
  where?: InputMaybe<Funnel_Benefits_Bool_Exp>;
};


export type Subscription_RootFunnel_Benefits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFunnel_Benefits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funnel_Benefits_Stream_Cursor_Input>>;
  where?: InputMaybe<Funnel_Benefits_Bool_Exp>;
};


export type Subscription_RootFunnel_Chatbot_MessageArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Chatbot_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Chatbot_Message_Order_By>>;
  where?: InputMaybe<Funnel_Chatbot_Message_Bool_Exp>;
};


export type Subscription_RootFunnel_Chatbot_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Chatbot_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Chatbot_Message_Order_By>>;
  where?: InputMaybe<Funnel_Chatbot_Message_Bool_Exp>;
};


export type Subscription_RootFunnel_Chatbot_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFunnel_Chatbot_Message_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funnel_Chatbot_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Funnel_Chatbot_Message_Bool_Exp>;
};


export type Subscription_RootFunnel_Chatbot_SessionArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Chatbot_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Chatbot_Session_Order_By>>;
  where?: InputMaybe<Funnel_Chatbot_Session_Bool_Exp>;
};


export type Subscription_RootFunnel_Chatbot_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Chatbot_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Chatbot_Session_Order_By>>;
  where?: InputMaybe<Funnel_Chatbot_Session_Bool_Exp>;
};


export type Subscription_RootFunnel_Chatbot_Session_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFunnel_Chatbot_Session_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funnel_Chatbot_Session_Stream_Cursor_Input>>;
  where?: InputMaybe<Funnel_Chatbot_Session_Bool_Exp>;
};


export type Subscription_RootFunnel_FunnelsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Funnels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Funnels_Order_By>>;
  where?: InputMaybe<Funnel_Funnels_Bool_Exp>;
};


export type Subscription_RootFunnel_Funnels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Funnels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Funnels_Order_By>>;
  where?: InputMaybe<Funnel_Funnels_Bool_Exp>;
};


export type Subscription_RootFunnel_Funnels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFunnel_Funnels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funnel_Funnels_Stream_Cursor_Input>>;
  where?: InputMaybe<Funnel_Funnels_Bool_Exp>;
};


export type Subscription_RootFunnel_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Insights_Bool_Exp>;
};


export type Subscription_RootFunnel_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Insights_Bool_Exp>;
};


export type Subscription_RootFunnel_Insights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funnel_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Funnel_Insights_Bool_Exp>;
};


export type Subscription_RootFunnel_Page_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Page_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};


export type Subscription_RootFunnel_Page_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Page_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Page_Insights_Order_By>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};


export type Subscription_RootFunnel_Page_Insights_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFunnel_Page_Insights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funnel_Page_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Funnel_Page_Insights_Bool_Exp>;
};


export type Subscription_RootFunnel_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Order_By>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


export type Subscription_RootFunnel_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Order_By>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


export type Subscription_RootFunnel_Question_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFunnel_Question_OptionArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Option_Order_By>>;
  where?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
};


export type Subscription_RootFunnel_Question_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Question_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Question_Option_Order_By>>;
  where?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
};


export type Subscription_RootFunnel_Question_Option_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFunnel_Question_Option_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funnel_Question_Option_Stream_Cursor_Input>>;
  where?: InputMaybe<Funnel_Question_Option_Bool_Exp>;
};


export type Subscription_RootFunnel_Question_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funnel_Question_Stream_Cursor_Input>>;
  where?: InputMaybe<Funnel_Question_Bool_Exp>;
};


export type Subscription_RootFunnel_Whatsapp_Share_ClicksArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Order_By>>;
  where?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
};


export type Subscription_RootFunnel_Whatsapp_Share_Clicks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funnel_Whatsapp_Share_Clicks_Order_By>>;
  where?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
};


export type Subscription_RootFunnel_Whatsapp_Share_Clicks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFunnel_Whatsapp_Share_Clicks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funnel_Whatsapp_Share_Clicks_Stream_Cursor_Input>>;
  where?: InputMaybe<Funnel_Whatsapp_Share_Clicks_Bool_Exp>;
};


export type Subscription_RootHuk_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Huk_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Huk_Contacts_Order_By>>;
  where?: InputMaybe<Huk_Contacts_Bool_Exp>;
};


export type Subscription_RootHuk_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Huk_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Huk_Contacts_Order_By>>;
  where?: InputMaybe<Huk_Contacts_Bool_Exp>;
};


export type Subscription_RootHuk_Contacts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Huk_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Huk_Contacts_Bool_Exp>;
};


export type Subscription_RootNew_Contacts_Per_DayArgs = {
  distinct_on?: InputMaybe<Array<New_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Contacts_Per_Day_Bool_Exp>;
};


export type Subscription_RootNew_Contacts_Per_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<New_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Contacts_Per_Day_Bool_Exp>;
};


export type Subscription_RootNew_Contacts_Per_Day_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<New_Contacts_Per_Day_Stream_Cursor_Input>>;
  where?: InputMaybe<New_Contacts_Per_Day_Bool_Exp>;
};


export type Subscription_RootNew_Unqualified_Contacts_Per_DayArgs = {
  distinct_on?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Unqualified_Contacts_Per_Day_Bool_Exp>;
};


export type Subscription_RootNew_Unqualified_Contacts_Per_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<New_Unqualified_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<New_Unqualified_Contacts_Per_Day_Bool_Exp>;
};


export type Subscription_RootNew_Unqualified_Contacts_Per_Day_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<New_Unqualified_Contacts_Per_Day_Stream_Cursor_Input>>;
  where?: InputMaybe<New_Unqualified_Contacts_Per_Day_Bool_Exp>;
};


export type Subscription_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_BudgetArgs = {
  distinct_on?: InputMaybe<Array<Organization_Budget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Budget_Order_By>>;
  where?: InputMaybe<Organization_Budget_Bool_Exp>;
};


export type Subscription_RootOrganization_Budget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Budget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Budget_Order_By>>;
  where?: InputMaybe<Organization_Budget_Bool_Exp>;
};


export type Subscription_RootOrganization_Budget_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Budget_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Budget_Bool_Exp>;
};


export type Subscription_RootOrganization_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootOrganization_Contacts_Per_DayArgs = {
  distinct_on?: InputMaybe<Array<Organization_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<Organization_Contacts_Per_Day_Bool_Exp>;
};


export type Subscription_RootOrganization_Contacts_Per_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Contacts_Per_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Contacts_Per_Day_Order_By>>;
  where?: InputMaybe<Organization_Contacts_Per_Day_Bool_Exp>;
};


export type Subscription_RootOrganization_Contacts_Per_Day_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Contacts_Per_Day_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Contacts_Per_Day_Bool_Exp>;
};


export type Subscription_RootOrganization_LocationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Location_Order_By>>;
  where?: InputMaybe<Organization_Location_Bool_Exp>;
};


export type Subscription_RootOrganization_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Location_Order_By>>;
  where?: InputMaybe<Organization_Location_Bool_Exp>;
};


export type Subscription_RootOrganization_Location_By_PkArgs = {
  organization_id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type Subscription_RootOrganization_Location_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Location_Bool_Exp>;
};


export type Subscription_RootOrganization_Name_PrefixArgs = {
  distinct_on?: InputMaybe<Array<Organization_Name_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Name_Prefix_Order_By>>;
  where?: InputMaybe<Organization_Name_Prefix_Bool_Exp>;
};


export type Subscription_RootOrganization_Name_Prefix_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Name_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Name_Prefix_Order_By>>;
  where?: InputMaybe<Organization_Name_Prefix_Bool_Exp>;
};


export type Subscription_RootOrganization_Name_Prefix_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootOrganization_Name_Prefix_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Name_Prefix_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Name_Prefix_Bool_Exp>;
};


export type Subscription_RootOrganization_NewsArgs = {
  distinct_on?: InputMaybe<Array<Organization_News_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_News_Order_By>>;
  where?: InputMaybe<Organization_News_Bool_Exp>;
};


export type Subscription_RootOrganization_News_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_News_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_News_Order_By>>;
  where?: InputMaybe<Organization_News_Bool_Exp>;
};


export type Subscription_RootOrganization_News_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_News_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_News_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_News_Bool_Exp>;
};


export type Subscription_RootOrganization_RegionArgs = {
  distinct_on?: InputMaybe<Array<Organization_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Region_Order_By>>;
  where?: InputMaybe<Organization_Region_Bool_Exp>;
};


export type Subscription_RootOrganization_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Region_Order_By>>;
  where?: InputMaybe<Organization_Region_Bool_Exp>;
};


export type Subscription_RootOrganization_Region_By_PkArgs = {
  organization_id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type Subscription_RootOrganization_Region_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Region_Bool_Exp>;
};


export type Subscription_RootOrganization_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Settings_Order_By>>;
  where?: InputMaybe<Organization_Settings_Bool_Exp>;
};


export type Subscription_RootOrganization_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Settings_Order_By>>;
  where?: InputMaybe<Organization_Settings_Bool_Exp>;
};


export type Subscription_RootOrganization_Settings_By_PkArgs = {
  organization_id: Scalars['String']['input'];
};


export type Subscription_RootOrganization_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Settings_Bool_Exp>;
};


export type Subscription_RootOrganization_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootPerspective_CampaignArgs = {
  distinct_on?: InputMaybe<Array<Perspective_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Perspective_Campaign_Order_By>>;
  where?: InputMaybe<Perspective_Campaign_Bool_Exp>;
};


export type Subscription_RootPerspective_Campaign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Perspective_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Perspective_Campaign_Order_By>>;
  where?: InputMaybe<Perspective_Campaign_Bool_Exp>;
};


export type Subscription_RootPerspective_Campaign_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootPerspective_Campaign_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Perspective_Campaign_Stream_Cursor_Input>>;
  where?: InputMaybe<Perspective_Campaign_Bool_Exp>;
};


export type Subscription_RootQa_SourceArgs = {
  distinct_on?: InputMaybe<Array<Qa_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Qa_Source_Order_By>>;
  where?: InputMaybe<Qa_Source_Bool_Exp>;
};


export type Subscription_RootQa_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Qa_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Qa_Source_Order_By>>;
  where?: InputMaybe<Qa_Source_Bool_Exp>;
};


export type Subscription_RootQa_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQa_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Qa_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Qa_Source_Bool_Exp>;
};


export type Subscription_RootRms_ConnectorsArgs = {
  distinct_on?: InputMaybe<Array<Rms_Connectors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Connectors_Order_By>>;
  where?: InputMaybe<Rms_Connectors_Bool_Exp>;
};


export type Subscription_RootRms_Connectors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rms_Connectors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Connectors_Order_By>>;
  where?: InputMaybe<Rms_Connectors_Bool_Exp>;
};


export type Subscription_RootRms_Connectors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRms_Connectors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rms_Connectors_Stream_Cursor_Input>>;
  where?: InputMaybe<Rms_Connectors_Bool_Exp>;
};


export type Subscription_RootRms_Forwarded_LogsArgs = {
  distinct_on?: InputMaybe<Array<Rms_Forwarded_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Forwarded_Logs_Order_By>>;
  where?: InputMaybe<Rms_Forwarded_Logs_Bool_Exp>;
};


export type Subscription_RootRms_Forwarded_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rms_Forwarded_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Forwarded_Logs_Order_By>>;
  where?: InputMaybe<Rms_Forwarded_Logs_Bool_Exp>;
};


export type Subscription_RootRms_Forwarded_Logs_By_PkArgs = {
  contact_id: Scalars['uuid']['input'];
};


export type Subscription_RootRms_Forwarded_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rms_Forwarded_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Rms_Forwarded_Logs_Bool_Exp>;
};


export type Subscription_RootRms_Org_SetupsArgs = {
  distinct_on?: InputMaybe<Array<Rms_Org_Setups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Org_Setups_Order_By>>;
  where?: InputMaybe<Rms_Org_Setups_Bool_Exp>;
};


export type Subscription_RootRms_Org_Setups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rms_Org_Setups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rms_Org_Setups_Order_By>>;
  where?: InputMaybe<Rms_Org_Setups_Bool_Exp>;
};


export type Subscription_RootRms_Org_Setups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRms_Org_Setups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rms_Org_Setups_Stream_Cursor_Input>>;
  where?: InputMaybe<Rms_Org_Setups_Bool_Exp>;
};


export type Subscription_RootSystem_Api_KeysArgs = {
  distinct_on?: InputMaybe<Array<System_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Api_Keys_Order_By>>;
  where?: InputMaybe<System_Api_Keys_Bool_Exp>;
};


export type Subscription_RootSystem_Api_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Api_Keys_Order_By>>;
  where?: InputMaybe<System_Api_Keys_Bool_Exp>;
};


export type Subscription_RootSystem_Api_Keys_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSystem_Api_Keys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<System_Api_Keys_Stream_Cursor_Input>>;
  where?: InputMaybe<System_Api_Keys_Bool_Exp>;
};


export type Subscription_RootSystem_Call_Daily_StatsArgs = {
  distinct_on?: InputMaybe<Array<System_Call_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Call_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Call_Daily_Stats_Bool_Exp>;
};


export type Subscription_RootSystem_Call_Daily_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Call_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Call_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Call_Daily_Stats_Bool_Exp>;
};


export type Subscription_RootSystem_Call_Daily_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};


export type Subscription_RootSystem_Call_Daily_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<System_Call_Daily_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<System_Call_Daily_Stats_Bool_Exp>;
};


export type Subscription_RootSystem_Email_Daily_StatsArgs = {
  distinct_on?: InputMaybe<Array<System_Email_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Email_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Email_Daily_Stats_Bool_Exp>;
};


export type Subscription_RootSystem_Email_Daily_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Email_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Email_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Email_Daily_Stats_Bool_Exp>;
};


export type Subscription_RootSystem_Email_Daily_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};


export type Subscription_RootSystem_Email_Daily_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<System_Email_Daily_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<System_Email_Daily_Stats_Bool_Exp>;
};


export type Subscription_RootSystem_Running_ReleaseArgs = {
  distinct_on?: InputMaybe<Array<System_Running_Release_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Running_Release_Order_By>>;
  where?: InputMaybe<System_Running_Release_Bool_Exp>;
};


export type Subscription_RootSystem_Running_Release_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Running_Release_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Running_Release_Order_By>>;
  where?: InputMaybe<System_Running_Release_Bool_Exp>;
};


export type Subscription_RootSystem_Running_Release_By_PkArgs = {
  service: Scalars['String']['input'];
};


export type Subscription_RootSystem_Running_Release_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<System_Running_Release_Stream_Cursor_Input>>;
  where?: InputMaybe<System_Running_Release_Bool_Exp>;
};


export type Subscription_RootSystem_Sms_Daily_StatsArgs = {
  distinct_on?: InputMaybe<Array<System_Sms_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Sms_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Sms_Daily_Stats_Bool_Exp>;
};


export type Subscription_RootSystem_Sms_Daily_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Sms_Daily_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<System_Sms_Daily_Stats_Order_By>>;
  where?: InputMaybe<System_Sms_Daily_Stats_Bool_Exp>;
};


export type Subscription_RootSystem_Sms_Daily_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};


export type Subscription_RootSystem_Sms_Daily_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<System_Sms_Daily_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<System_Sms_Daily_Stats_Bool_Exp>;
};

/** columns and relationships of "system.api_keys" */
export type System_Api_Keys = {
  __typename?: 'system_api_keys';
  created_at: Scalars['timestamptz']['output'];
  expired_at?: Maybe<Scalars['timestamptz']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "system.api_keys" */
export type System_Api_Keys_Aggregate = {
  __typename?: 'system_api_keys_aggregate';
  aggregate?: Maybe<System_Api_Keys_Aggregate_Fields>;
  nodes: Array<System_Api_Keys>;
};

/** aggregate fields of "system.api_keys" */
export type System_Api_Keys_Aggregate_Fields = {
  __typename?: 'system_api_keys_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<System_Api_Keys_Max_Fields>;
  min?: Maybe<System_Api_Keys_Min_Fields>;
};


/** aggregate fields of "system.api_keys" */
export type System_Api_Keys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<System_Api_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "system.api_keys". All fields are combined with a logical 'AND'. */
export type System_Api_Keys_Bool_Exp = {
  _and?: InputMaybe<Array<System_Api_Keys_Bool_Exp>>;
  _not?: InputMaybe<System_Api_Keys_Bool_Exp>;
  _or?: InputMaybe<Array<System_Api_Keys_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expired_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.api_keys" */
export enum System_Api_Keys_Constraint {
  /** unique or primary key constraint on columns "value" */
  ApiKeysPkey = 'api_keys_pkey'
}

/** input type for inserting data into table "system.api_keys" */
export type System_Api_Keys_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type System_Api_Keys_Max_Fields = {
  __typename?: 'system_api_keys_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expired_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type System_Api_Keys_Min_Fields = {
  __typename?: 'system_api_keys_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expired_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "system.api_keys" */
export type System_Api_Keys_Mutation_Response = {
  __typename?: 'system_api_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<System_Api_Keys>;
};

/** on_conflict condition type for table "system.api_keys" */
export type System_Api_Keys_On_Conflict = {
  constraint: System_Api_Keys_Constraint;
  update_columns?: Array<System_Api_Keys_Update_Column>;
  where?: InputMaybe<System_Api_Keys_Bool_Exp>;
};

/** Ordering options when selecting data from "system.api_keys". */
export type System_Api_Keys_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expired_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.api_keys */
export type System_Api_Keys_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "system.api_keys" */
export enum System_Api_Keys_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiredAt = 'expired_at',
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "system.api_keys" */
export type System_Api_Keys_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "system_api_keys" */
export type System_Api_Keys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: System_Api_Keys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type System_Api_Keys_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "system.api_keys" */
export enum System_Api_Keys_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiredAt = 'expired_at',
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

export type System_Api_Keys_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<System_Api_Keys_Set_Input>;
  /** filter the rows which have to be updated */
  where: System_Api_Keys_Bool_Exp;
};

/** columns and relationships of "system.call_daily_stats" */
export type System_Call_Daily_Stats = {
  __typename?: 'system_call_daily_stats';
  cost: Scalars['Int']['output'];
  date: Scalars['date']['output'];
  tag: Scalars['String']['output'];
  usage: Scalars['Int']['output'];
};

/** aggregated selection of "system.call_daily_stats" */
export type System_Call_Daily_Stats_Aggregate = {
  __typename?: 'system_call_daily_stats_aggregate';
  aggregate?: Maybe<System_Call_Daily_Stats_Aggregate_Fields>;
  nodes: Array<System_Call_Daily_Stats>;
};

/** aggregate fields of "system.call_daily_stats" */
export type System_Call_Daily_Stats_Aggregate_Fields = {
  __typename?: 'system_call_daily_stats_aggregate_fields';
  avg?: Maybe<System_Call_Daily_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<System_Call_Daily_Stats_Max_Fields>;
  min?: Maybe<System_Call_Daily_Stats_Min_Fields>;
  stddev?: Maybe<System_Call_Daily_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<System_Call_Daily_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<System_Call_Daily_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<System_Call_Daily_Stats_Sum_Fields>;
  var_pop?: Maybe<System_Call_Daily_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<System_Call_Daily_Stats_Var_Samp_Fields>;
  variance?: Maybe<System_Call_Daily_Stats_Variance_Fields>;
};


/** aggregate fields of "system.call_daily_stats" */
export type System_Call_Daily_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<System_Call_Daily_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type System_Call_Daily_Stats_Avg_Fields = {
  __typename?: 'system_call_daily_stats_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "system.call_daily_stats". All fields are combined with a logical 'AND'. */
export type System_Call_Daily_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<System_Call_Daily_Stats_Bool_Exp>>;
  _not?: InputMaybe<System_Call_Daily_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<System_Call_Daily_Stats_Bool_Exp>>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  usage?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.call_daily_stats" */
export enum System_Call_Daily_Stats_Constraint {
  /** unique or primary key constraint on columns "tag", "date" */
  CallDailyStatsPkey = 'call_daily_stats_pkey'
}

/** input type for incrementing numeric columns in table "system.call_daily_stats" */
export type System_Call_Daily_Stats_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "system.call_daily_stats" */
export type System_Call_Daily_Stats_Insert_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type System_Call_Daily_Stats_Max_Fields = {
  __typename?: 'system_call_daily_stats_max_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type System_Call_Daily_Stats_Min_Fields = {
  __typename?: 'system_call_daily_stats_min_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "system.call_daily_stats" */
export type System_Call_Daily_Stats_Mutation_Response = {
  __typename?: 'system_call_daily_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<System_Call_Daily_Stats>;
};

/** on_conflict condition type for table "system.call_daily_stats" */
export type System_Call_Daily_Stats_On_Conflict = {
  constraint: System_Call_Daily_Stats_Constraint;
  update_columns?: Array<System_Call_Daily_Stats_Update_Column>;
  where?: InputMaybe<System_Call_Daily_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "system.call_daily_stats". */
export type System_Call_Daily_Stats_Order_By = {
  cost?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  usage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.call_daily_stats */
export type System_Call_Daily_Stats_Pk_Columns_Input = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};

/** select columns of table "system.call_daily_stats" */
export enum System_Call_Daily_Stats_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  Date = 'date',
  /** column name */
  Tag = 'tag',
  /** column name */
  Usage = 'usage'
}

/** input type for updating data in table "system.call_daily_stats" */
export type System_Call_Daily_Stats_Set_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type System_Call_Daily_Stats_Stddev_Fields = {
  __typename?: 'system_call_daily_stats_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type System_Call_Daily_Stats_Stddev_Pop_Fields = {
  __typename?: 'system_call_daily_stats_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type System_Call_Daily_Stats_Stddev_Samp_Fields = {
  __typename?: 'system_call_daily_stats_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "system_call_daily_stats" */
export type System_Call_Daily_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: System_Call_Daily_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type System_Call_Daily_Stats_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type System_Call_Daily_Stats_Sum_Fields = {
  __typename?: 'system_call_daily_stats_sum_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "system.call_daily_stats" */
export enum System_Call_Daily_Stats_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  Date = 'date',
  /** column name */
  Tag = 'tag',
  /** column name */
  Usage = 'usage'
}

export type System_Call_Daily_Stats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<System_Call_Daily_Stats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<System_Call_Daily_Stats_Set_Input>;
  /** filter the rows which have to be updated */
  where: System_Call_Daily_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type System_Call_Daily_Stats_Var_Pop_Fields = {
  __typename?: 'system_call_daily_stats_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type System_Call_Daily_Stats_Var_Samp_Fields = {
  __typename?: 'system_call_daily_stats_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type System_Call_Daily_Stats_Variance_Fields = {
  __typename?: 'system_call_daily_stats_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "system.email_daily_stats" */
export type System_Email_Daily_Stats = {
  __typename?: 'system_email_daily_stats';
  cost: Scalars['Int']['output'];
  date: Scalars['date']['output'];
  tag: Scalars['String']['output'];
  usage: Scalars['Int']['output'];
};

/** aggregated selection of "system.email_daily_stats" */
export type System_Email_Daily_Stats_Aggregate = {
  __typename?: 'system_email_daily_stats_aggregate';
  aggregate?: Maybe<System_Email_Daily_Stats_Aggregate_Fields>;
  nodes: Array<System_Email_Daily_Stats>;
};

/** aggregate fields of "system.email_daily_stats" */
export type System_Email_Daily_Stats_Aggregate_Fields = {
  __typename?: 'system_email_daily_stats_aggregate_fields';
  avg?: Maybe<System_Email_Daily_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<System_Email_Daily_Stats_Max_Fields>;
  min?: Maybe<System_Email_Daily_Stats_Min_Fields>;
  stddev?: Maybe<System_Email_Daily_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<System_Email_Daily_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<System_Email_Daily_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<System_Email_Daily_Stats_Sum_Fields>;
  var_pop?: Maybe<System_Email_Daily_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<System_Email_Daily_Stats_Var_Samp_Fields>;
  variance?: Maybe<System_Email_Daily_Stats_Variance_Fields>;
};


/** aggregate fields of "system.email_daily_stats" */
export type System_Email_Daily_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<System_Email_Daily_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type System_Email_Daily_Stats_Avg_Fields = {
  __typename?: 'system_email_daily_stats_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "system.email_daily_stats". All fields are combined with a logical 'AND'. */
export type System_Email_Daily_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<System_Email_Daily_Stats_Bool_Exp>>;
  _not?: InputMaybe<System_Email_Daily_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<System_Email_Daily_Stats_Bool_Exp>>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  usage?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.email_daily_stats" */
export enum System_Email_Daily_Stats_Constraint {
  /** unique or primary key constraint on columns "tag", "date" */
  EmailDailyStatsPkey = 'email_daily_stats_pkey'
}

/** input type for incrementing numeric columns in table "system.email_daily_stats" */
export type System_Email_Daily_Stats_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "system.email_daily_stats" */
export type System_Email_Daily_Stats_Insert_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type System_Email_Daily_Stats_Max_Fields = {
  __typename?: 'system_email_daily_stats_max_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type System_Email_Daily_Stats_Min_Fields = {
  __typename?: 'system_email_daily_stats_min_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "system.email_daily_stats" */
export type System_Email_Daily_Stats_Mutation_Response = {
  __typename?: 'system_email_daily_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<System_Email_Daily_Stats>;
};

/** on_conflict condition type for table "system.email_daily_stats" */
export type System_Email_Daily_Stats_On_Conflict = {
  constraint: System_Email_Daily_Stats_Constraint;
  update_columns?: Array<System_Email_Daily_Stats_Update_Column>;
  where?: InputMaybe<System_Email_Daily_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "system.email_daily_stats". */
export type System_Email_Daily_Stats_Order_By = {
  cost?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  usage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.email_daily_stats */
export type System_Email_Daily_Stats_Pk_Columns_Input = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};

/** select columns of table "system.email_daily_stats" */
export enum System_Email_Daily_Stats_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  Date = 'date',
  /** column name */
  Tag = 'tag',
  /** column name */
  Usage = 'usage'
}

/** input type for updating data in table "system.email_daily_stats" */
export type System_Email_Daily_Stats_Set_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type System_Email_Daily_Stats_Stddev_Fields = {
  __typename?: 'system_email_daily_stats_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type System_Email_Daily_Stats_Stddev_Pop_Fields = {
  __typename?: 'system_email_daily_stats_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type System_Email_Daily_Stats_Stddev_Samp_Fields = {
  __typename?: 'system_email_daily_stats_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "system_email_daily_stats" */
export type System_Email_Daily_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: System_Email_Daily_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type System_Email_Daily_Stats_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type System_Email_Daily_Stats_Sum_Fields = {
  __typename?: 'system_email_daily_stats_sum_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "system.email_daily_stats" */
export enum System_Email_Daily_Stats_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  Date = 'date',
  /** column name */
  Tag = 'tag',
  /** column name */
  Usage = 'usage'
}

export type System_Email_Daily_Stats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<System_Email_Daily_Stats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<System_Email_Daily_Stats_Set_Input>;
  /** filter the rows which have to be updated */
  where: System_Email_Daily_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type System_Email_Daily_Stats_Var_Pop_Fields = {
  __typename?: 'system_email_daily_stats_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type System_Email_Daily_Stats_Var_Samp_Fields = {
  __typename?: 'system_email_daily_stats_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type System_Email_Daily_Stats_Variance_Fields = {
  __typename?: 'system_email_daily_stats_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "system.running_release" */
export type System_Running_Release = {
  __typename?: 'system_running_release';
  announced_at: Scalars['timestamptz']['output'];
  dist: Scalars['String']['output'];
  release?: Maybe<Scalars['String']['output']>;
  service: Scalars['String']['output'];
};

/** aggregated selection of "system.running_release" */
export type System_Running_Release_Aggregate = {
  __typename?: 'system_running_release_aggregate';
  aggregate?: Maybe<System_Running_Release_Aggregate_Fields>;
  nodes: Array<System_Running_Release>;
};

/** aggregate fields of "system.running_release" */
export type System_Running_Release_Aggregate_Fields = {
  __typename?: 'system_running_release_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<System_Running_Release_Max_Fields>;
  min?: Maybe<System_Running_Release_Min_Fields>;
};


/** aggregate fields of "system.running_release" */
export type System_Running_Release_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<System_Running_Release_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "system.running_release". All fields are combined with a logical 'AND'. */
export type System_Running_Release_Bool_Exp = {
  _and?: InputMaybe<Array<System_Running_Release_Bool_Exp>>;
  _not?: InputMaybe<System_Running_Release_Bool_Exp>;
  _or?: InputMaybe<Array<System_Running_Release_Bool_Exp>>;
  announced_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dist?: InputMaybe<String_Comparison_Exp>;
  release?: InputMaybe<String_Comparison_Exp>;
  service?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.running_release" */
export enum System_Running_Release_Constraint {
  /** unique or primary key constraint on columns "service" */
  RunningReleasePkey = 'running_release_pkey'
}

/** input type for inserting data into table "system.running_release" */
export type System_Running_Release_Insert_Input = {
  announced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dist?: InputMaybe<Scalars['String']['input']>;
  release?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type System_Running_Release_Max_Fields = {
  __typename?: 'system_running_release_max_fields';
  announced_at?: Maybe<Scalars['timestamptz']['output']>;
  dist?: Maybe<Scalars['String']['output']>;
  release?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type System_Running_Release_Min_Fields = {
  __typename?: 'system_running_release_min_fields';
  announced_at?: Maybe<Scalars['timestamptz']['output']>;
  dist?: Maybe<Scalars['String']['output']>;
  release?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "system.running_release" */
export type System_Running_Release_Mutation_Response = {
  __typename?: 'system_running_release_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<System_Running_Release>;
};

/** on_conflict condition type for table "system.running_release" */
export type System_Running_Release_On_Conflict = {
  constraint: System_Running_Release_Constraint;
  update_columns?: Array<System_Running_Release_Update_Column>;
  where?: InputMaybe<System_Running_Release_Bool_Exp>;
};

/** Ordering options when selecting data from "system.running_release". */
export type System_Running_Release_Order_By = {
  announced_at?: InputMaybe<Order_By>;
  dist?: InputMaybe<Order_By>;
  release?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.running_release */
export type System_Running_Release_Pk_Columns_Input = {
  service: Scalars['String']['input'];
};

/** select columns of table "system.running_release" */
export enum System_Running_Release_Select_Column {
  /** column name */
  AnnouncedAt = 'announced_at',
  /** column name */
  Dist = 'dist',
  /** column name */
  Release = 'release',
  /** column name */
  Service = 'service'
}

/** input type for updating data in table "system.running_release" */
export type System_Running_Release_Set_Input = {
  announced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dist?: InputMaybe<Scalars['String']['input']>;
  release?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "system_running_release" */
export type System_Running_Release_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: System_Running_Release_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type System_Running_Release_Stream_Cursor_Value_Input = {
  announced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dist?: InputMaybe<Scalars['String']['input']>;
  release?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "system.running_release" */
export enum System_Running_Release_Update_Column {
  /** column name */
  AnnouncedAt = 'announced_at',
  /** column name */
  Dist = 'dist',
  /** column name */
  Release = 'release',
  /** column name */
  Service = 'service'
}

export type System_Running_Release_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<System_Running_Release_Set_Input>;
  /** filter the rows which have to be updated */
  where: System_Running_Release_Bool_Exp;
};

/** columns and relationships of "system.sms_daily_stats" */
export type System_Sms_Daily_Stats = {
  __typename?: 'system_sms_daily_stats';
  cost: Scalars['Int']['output'];
  date: Scalars['date']['output'];
  tag: Scalars['String']['output'];
  usage: Scalars['Int']['output'];
};

/** aggregated selection of "system.sms_daily_stats" */
export type System_Sms_Daily_Stats_Aggregate = {
  __typename?: 'system_sms_daily_stats_aggregate';
  aggregate?: Maybe<System_Sms_Daily_Stats_Aggregate_Fields>;
  nodes: Array<System_Sms_Daily_Stats>;
};

/** aggregate fields of "system.sms_daily_stats" */
export type System_Sms_Daily_Stats_Aggregate_Fields = {
  __typename?: 'system_sms_daily_stats_aggregate_fields';
  avg?: Maybe<System_Sms_Daily_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<System_Sms_Daily_Stats_Max_Fields>;
  min?: Maybe<System_Sms_Daily_Stats_Min_Fields>;
  stddev?: Maybe<System_Sms_Daily_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<System_Sms_Daily_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<System_Sms_Daily_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<System_Sms_Daily_Stats_Sum_Fields>;
  var_pop?: Maybe<System_Sms_Daily_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<System_Sms_Daily_Stats_Var_Samp_Fields>;
  variance?: Maybe<System_Sms_Daily_Stats_Variance_Fields>;
};


/** aggregate fields of "system.sms_daily_stats" */
export type System_Sms_Daily_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<System_Sms_Daily_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type System_Sms_Daily_Stats_Avg_Fields = {
  __typename?: 'system_sms_daily_stats_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "system.sms_daily_stats". All fields are combined with a logical 'AND'. */
export type System_Sms_Daily_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<System_Sms_Daily_Stats_Bool_Exp>>;
  _not?: InputMaybe<System_Sms_Daily_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<System_Sms_Daily_Stats_Bool_Exp>>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  usage?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.sms_daily_stats" */
export enum System_Sms_Daily_Stats_Constraint {
  /** unique or primary key constraint on columns "tag", "date" */
  SmsDailyStatsPkey = 'sms_daily_stats_pkey'
}

/** input type for incrementing numeric columns in table "system.sms_daily_stats" */
export type System_Sms_Daily_Stats_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "system.sms_daily_stats" */
export type System_Sms_Daily_Stats_Insert_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type System_Sms_Daily_Stats_Max_Fields = {
  __typename?: 'system_sms_daily_stats_max_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type System_Sms_Daily_Stats_Min_Fields = {
  __typename?: 'system_sms_daily_stats_min_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "system.sms_daily_stats" */
export type System_Sms_Daily_Stats_Mutation_Response = {
  __typename?: 'system_sms_daily_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<System_Sms_Daily_Stats>;
};

/** on_conflict condition type for table "system.sms_daily_stats" */
export type System_Sms_Daily_Stats_On_Conflict = {
  constraint: System_Sms_Daily_Stats_Constraint;
  update_columns?: Array<System_Sms_Daily_Stats_Update_Column>;
  where?: InputMaybe<System_Sms_Daily_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "system.sms_daily_stats". */
export type System_Sms_Daily_Stats_Order_By = {
  cost?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  usage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.sms_daily_stats */
export type System_Sms_Daily_Stats_Pk_Columns_Input = {
  date: Scalars['date']['input'];
  tag: Scalars['String']['input'];
};

/** select columns of table "system.sms_daily_stats" */
export enum System_Sms_Daily_Stats_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  Date = 'date',
  /** column name */
  Tag = 'tag',
  /** column name */
  Usage = 'usage'
}

/** input type for updating data in table "system.sms_daily_stats" */
export type System_Sms_Daily_Stats_Set_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type System_Sms_Daily_Stats_Stddev_Fields = {
  __typename?: 'system_sms_daily_stats_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type System_Sms_Daily_Stats_Stddev_Pop_Fields = {
  __typename?: 'system_sms_daily_stats_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type System_Sms_Daily_Stats_Stddev_Samp_Fields = {
  __typename?: 'system_sms_daily_stats_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "system_sms_daily_stats" */
export type System_Sms_Daily_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: System_Sms_Daily_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type System_Sms_Daily_Stats_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type System_Sms_Daily_Stats_Sum_Fields = {
  __typename?: 'system_sms_daily_stats_sum_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "system.sms_daily_stats" */
export enum System_Sms_Daily_Stats_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  Date = 'date',
  /** column name */
  Tag = 'tag',
  /** column name */
  Usage = 'usage'
}

export type System_Sms_Daily_Stats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<System_Sms_Daily_Stats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<System_Sms_Daily_Stats_Set_Input>;
  /** filter the rows which have to be updated */
  where: System_Sms_Daily_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type System_Sms_Daily_Stats_Var_Pop_Fields = {
  __typename?: 'system_sms_daily_stats_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type System_Sms_Daily_Stats_Var_Samp_Fields = {
  __typename?: 'system_sms_daily_stats_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type System_Sms_Daily_Stats_Variance_Fields = {
  __typename?: 'system_sms_daily_stats_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type Timetz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timetz']['input']>;
  _gt?: InputMaybe<Scalars['timetz']['input']>;
  _gte?: InputMaybe<Scalars['timetz']['input']>;
  _in?: InputMaybe<Array<Scalars['timetz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timetz']['input']>;
  _lte?: InputMaybe<Scalars['timetz']['input']>;
  _neq?: InputMaybe<Scalars['timetz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timetz']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type CampaignFragment = { __typename?: 'campaign', id: string, name: string, category?: string | null, start?: string | null, end?: string | null, customer_budget_initial?: any | null, customer_budget_total?: any | null, customer_budget_bonus?: any | null, remaining_customer_budget?: any | null, margin_in_percent?: any, media_budget?: any | null, work_location?: Campaign_Work_Location_Enum | null, status?: string | null, location_slug?: string | null, daily_budget: any, pdf_enabled?: boolean | null, monday_url?: string | null, meistertask_url?: string | null, organization_id?: string, perspective_campaign_id?: string | null, is_test: boolean, daily_media_budget?: any | null, applicants_email_list?: Array<string>, ads_email_list?: Array<string>, support_email?: string | null, is_hidden: boolean, chat_bot_is_ko: boolean, chat_bot_enabled: boolean, chat_bot_v2_enabled: boolean, job_posting_text?: string | null, phone_number_default_region: Campaign_Iso_2_Country_Codes_Enum, short_id: string, responsible_person?: string | null, applicant_board_enabled: boolean, forwarding?: { __typename?: 'chat_bot_forwarding', webhook_url?: string | null } | null, organization: { __typename?: 'organization', name: string, id: string }, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, qualified_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, total_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null } | null, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, call_campaign: Array<{ __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean }>, c_location?: { __typename?: 'organization_location', organization_id: string, slug: string, name: string, parent_region?: { __typename?: 'organization_region', organization_id: string, slug: string, name: string } | null } | null, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }>, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform_specific_id: string, clicks: number, impressions: number, spend?: any, reach?: number | null, cpc?: string | null, status: string, platform: Ad_Platform_Enum }>, routing_info?: { __typename?: 'campaign_routing_info', type: string, forwarding_webhook: string, location_id?: number | null, office_id?: string | null } | null, org_settings_override?: { __typename?: 'campaign_settings_override', logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum } | null };

export type GetCampaignByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  hasAdvancedAccessToCampaigns: Scalars['Boolean']['input'];
  canSeeInternalInsights: Scalars['Boolean']['input'];
  hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: Scalars['Boolean']['input'];
}>;


export type GetCampaignByIdQuery = { __typename?: 'query_root', campaign_by_pk?: { __typename?: 'campaign', id: string, name: string, category?: string | null, start?: string | null, end?: string | null, customer_budget_initial?: any | null, customer_budget_total?: any | null, customer_budget_bonus?: any | null, remaining_customer_budget?: any | null, margin_in_percent?: any, media_budget?: any | null, work_location?: Campaign_Work_Location_Enum | null, status?: string | null, location_slug?: string | null, daily_budget: any, pdf_enabled?: boolean | null, monday_url?: string | null, meistertask_url?: string | null, organization_id?: string, perspective_campaign_id?: string | null, is_test: boolean, daily_media_budget?: any | null, applicants_email_list?: Array<string>, ads_email_list?: Array<string>, support_email?: string | null, is_hidden: boolean, chat_bot_is_ko: boolean, chat_bot_enabled: boolean, chat_bot_v2_enabled: boolean, job_posting_text?: string | null, phone_number_default_region: Campaign_Iso_2_Country_Codes_Enum, short_id: string, responsible_person?: string | null, applicant_board_enabled: boolean, forwarding?: { __typename?: 'chat_bot_forwarding', webhook_url?: string | null } | null, organization: { __typename?: 'organization', name: string, id: string }, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, qualified_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, total_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null } | null, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, call_campaign: Array<{ __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean }>, c_location?: { __typename?: 'organization_location', organization_id: string, slug: string, name: string, parent_region?: { __typename?: 'organization_region', organization_id: string, slug: string, name: string } | null } | null, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }>, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform_specific_id: string, clicks: number, impressions: number, spend?: any, reach?: number | null, cpc?: string | null, status: string, platform: Ad_Platform_Enum }>, routing_info?: { __typename?: 'campaign_routing_info', type: string, forwarding_webhook: string, location_id?: number | null, office_id?: string | null } | null, org_settings_override?: { __typename?: 'campaign_settings_override', logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum } | null } | null };

export type GetCampaignByIdForDuplicationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  hasAdvancedAccessToCampaigns: Scalars['Boolean']['input'];
  canSeeInternalInsights: Scalars['Boolean']['input'];
  hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: Scalars['Boolean']['input'];
}>;


export type GetCampaignByIdForDuplicationQuery = { __typename?: 'query_root', campaign_by_pk?: { __typename?: 'campaign', id: string, name: string, category?: string | null, start?: string | null, end?: string | null, customer_budget_initial?: any | null, customer_budget_total?: any | null, customer_budget_bonus?: any | null, remaining_customer_budget?: any | null, margin_in_percent?: any, media_budget?: any | null, work_location?: Campaign_Work_Location_Enum | null, status?: string | null, location_slug?: string | null, daily_budget: any, pdf_enabled?: boolean | null, monday_url?: string | null, meistertask_url?: string | null, organization_id?: string, perspective_campaign_id?: string | null, is_test: boolean, daily_media_budget?: any | null, applicants_email_list?: Array<string>, ads_email_list?: Array<string>, support_email?: string | null, is_hidden: boolean, chat_bot_is_ko: boolean, chat_bot_enabled: boolean, chat_bot_v2_enabled: boolean, job_posting_text?: string | null, phone_number_default_region: Campaign_Iso_2_Country_Codes_Enum, short_id: string, responsible_person?: string | null, applicant_board_enabled: boolean, funnel?: { __typename?: 'funnel_funnels', id: string, enabled: boolean, campaign_id?: string | null, job_caption?: string | null, job_intro?: string | null, job_byline?: string | null, expectations_items: any, expectations_intro?: string | null, img_1_id?: string | null, img_1_2_id?: string | null, img_1_3_id?: string | null, img_1_4_id?: string | null, img_2_id?: string | null, img_2_2_id?: string | null, img_2_3_id?: string | null, img_2_4_id?: string | null, img_3_id?: string | null, img_3_2_id?: string | null, img_3_3_id?: string | null, img_3_4_id?: string | null, logo_id?: string | null, video_1_id?: string | null, video_2_id?: string | null, video_3_id?: string | null, benefit_icon_id?: string | null, expectation_icon_id?: string | null, company_privacy_policy_url?: string | null, company_privacy_policy_title?: string | null, bot_consent_enabled: boolean, chatbot_funnel_enabled: boolean, whatsapp_apply_label?: string | null, whatsapp_apply_message_template?: string | null, whatsapp_intro_message?: string | null, whatsapp_outro_message?: string | null, whatsapp_share_caption?: string | null, whatsapp_share_title?: string | null, whatsapp_share_label?: string | null, header_color?: string | null, we_are_intro?: string | null, we_are_byline?: string | null, we_are_copy?: string | null, we_are_call_to_action?: string | null, call_to_action?: string | null, sub_call_to_action?: string | null, formality_type: string, locale: string, theme_color?: string | null, benefits_intro?: string | null, template: string, next_steps: any, slug: string, highlights: string, cv_required?: boolean | null, location_question_country_enabled: boolean, location_question_city_enabled: boolean, location_question_street_enabled: boolean, location_question_postalcode_enabled: boolean, contact_question_birthdate_enabled: boolean, contact_question_form_of_address_enabled: boolean, cv_question_enabled: boolean, benefits: Array<{ __typename?: 'funnel_benefits', description: string, title: string, id: string }>, questions: Array<{ __typename?: 'funnel_question', title: string, question_type: string, position?: number | null, parent_question_id?: string | null, is_required: boolean, archived: boolean, uuid: string, options: Array<{ __typename?: 'funnel_question_option', icon?: string | null, id: string, title: string, value?: string | null, isKnockout: boolean, redirect_question_id?: string | null, redirect_behavior: string }>, child_questions: Array<{ __typename?: 'funnel_question', icon?: string | null, id: string, position?: number | null, title: string, is_required: boolean, question_type: string, parent_question_id?: string | null, archived: boolean, options: Array<{ __typename?: 'funnel_question_option', title: string }> }> }>, campaign?: { __typename?: 'campaign', status?: string | null, is_hidden: boolean, short_id: string } | null } | null, rms_connector?: { __typename?: 'rms_connectors', id: string, enabled: boolean, webhook?: string | null, job_id?: string | null, custom_mappings?: any | null } | null, forwarding?: { __typename?: 'chat_bot_forwarding', webhook_url?: string | null } | null, organization: { __typename?: 'organization', name: string, id: string }, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, qualified_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, total_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null } | null, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, call_campaign: Array<{ __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean }>, c_location?: { __typename?: 'organization_location', organization_id: string, slug: string, name: string, parent_region?: { __typename?: 'organization_region', organization_id: string, slug: string, name: string } | null } | null, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }>, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform_specific_id: string, clicks: number, impressions: number, spend?: any, reach?: number | null, cpc?: string | null, status: string, platform: Ad_Platform_Enum }>, routing_info?: { __typename?: 'campaign_routing_info', type: string, forwarding_webhook: string, location_id?: number | null, office_id?: string | null } | null, org_settings_override?: { __typename?: 'campaign_settings_override', logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum } | null } | null };

export type GetCampaignsQueryVariables = Exact<{
  query?: InputMaybe<Campaign_Bool_Exp>;
  order_by?: InputMaybe<Array<Campaign_Order_By> | Campaign_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetCampaignsQuery = { __typename?: 'query_root', AllCampaigns: Array<{ __typename?: 'campaign', id: string, name: string, status?: string | null, is_test: boolean, is_hidden: boolean, applicant_board_enabled: boolean, start?: string | null, end?: string | null, daily_budget: any, remaining_customer_budget?: any | null, customer_budget_total?: any | null, short_id: string, responsible_person?: string | null, chat_bot_enabled: boolean, chat_bot_v2_enabled: boolean, work_location?: Campaign_Work_Location_Enum | null, monday_url?: string | null, organization: { __typename?: 'organization', id: string, name: string, short_name?: string | null, name_prefix?: Organization_Name_Prefix_Enum | null, rms_org_setup?: { __typename?: 'rms_org_setups', rms_type: string } | null, settings?: { __typename?: 'organization_settings', organization_id: string, address_formally: boolean, rejection_emails_enabled: boolean, notification_emails_enabled: boolean, welcome_emails_enabled: boolean } | null }, org_settings_override?: { __typename?: 'campaign_settings_override', logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum } | null, c_location?: { __typename?: 'organization_location', slug: string, name: string, organization_id: string, parent_region?: { __typename?: 'organization_region', slug: string, name: string, organization_id: string } | null } | null, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, funnel?: { __typename?: 'funnel_funnels', campaign_id?: string | null, slug: string, chatbot_funnel_enabled: boolean } | null, call_campaign: Array<{ __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean }>, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform: Ad_Platform_Enum }>, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }> }>, campaign_aggregate: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } };

export type ContactMetaFragment = { __typename?: 'contact', id: string, converted_at?: string | null, first_name: string, last_name: string, qualified: boolean, email_address: string, phone_number: string, routing_location_id?: number | null, campaign: { __typename?: 'campaign', id: string, name: string, location?: { __typename?: 'organization_location', slug: string, organization_id: string, name: string, region_slug: string } | null } };

export type GetContactsQueryVariables = Exact<{
  query?: InputMaybe<Contact_Bool_Exp>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetContactsQuery = { __typename?: 'query_root', AllContacts: Array<{ __typename?: 'contact', id: string, converted_at?: string | null, first_name: string, last_name: string, qualified: boolean, email_address: string, phone_number: string, routing_location_id?: number | null, campaign: { __typename?: 'campaign', id: string, name: string, location?: { __typename?: 'organization_location', slug: string, organization_id: string, name: string, region_slug: string } | null } }>, contact_aggregate: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null } };

export type GetImpersonationOrganizationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetImpersonationOrganizationQuery = { __typename?: 'query_root', organization_by_pk?: { __typename?: 'organization', id: string, name: string, regions: Array<{ __typename?: 'organization_region', name: string, slug: string, organization_id: string, locations: Array<{ __typename?: 'organization_location', slug: string, name: string, organization_id: string, campaign_count: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } }> }> } | null };

export type ImpersonationFragment = { __typename?: 'organization', id: string, name: string, regions: Array<{ __typename?: 'organization_region', name: string, slug: string, organization_id: string, locations: Array<{ __typename?: 'organization_location', slug: string, name: string, organization_id: string, campaign_count: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } }> }> };

export type GetOrganizationsQueryVariables = Exact<{
  excludedOrganizations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  canSeeInternalInsights?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrganizationsQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', name: string, id: string, active: boolean, name_prefix?: Organization_Name_Prefix_Enum | null, is_partner: boolean, partner_organization_id?: string | null, short_name?: string | null, logo_url?: string | null, country?: string | null, budget_from_transactions?: { __typename?: 'organization_budget', spend?: any | null, bonus?: any | null, media_budget?: any | null, total_budget?: any | null } | null, campaigns_aggregate: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, settings?: { __typename?: 'organization_settings', address_formally: boolean, organization_id: string, notification_emails_enabled: boolean, welcome_emails_enabled: boolean, rejection_emails_enabled: boolean } | null }> };

export type GetPaginatedOrganizationsQueryVariables = Exact<{
  query: Organization_Bool_Exp;
  excludedOrganizations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  canSeeInternalInsights?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetPaginatedOrganizationsQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', name: string, id: string, active: boolean, name_prefix?: Organization_Name_Prefix_Enum | null, is_partner: boolean, partner_organization_id?: string | null, short_name?: string | null, logo_url?: string | null, country?: string | null, budget_from_transactions?: { __typename?: 'organization_budget', spend?: any | null, bonus?: any | null, media_budget?: any | null, total_budget?: any | null } | null, campaigns_aggregate: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, settings?: { __typename?: 'organization_settings', address_formally: boolean, organization_id: string, notification_emails_enabled: boolean, welcome_emails_enabled: boolean, rejection_emails_enabled: boolean } | null }>, organization_aggregate: { __typename?: 'organization_aggregate', aggregate?: { __typename?: 'organization_aggregate_fields', count: number } | null } };

export type InsertCampaignFragment = { __typename?: 'campaign', id: string, short_id: string, name: string, category?: string | null, start?: string | null, end?: string | null, location?: string | null, work_location?: Campaign_Work_Location_Enum | null, pdf_enabled?: boolean | null, monday_url?: string | null, organization_id: string, perspective_campaign_id?: string | null, is_test: boolean, media_budget?: any | null, daily_media_budget?: any | null, applicants_email_list: Array<string>, ads_email_list: Array<string>, forwarding?: { __typename?: 'chat_bot_forwarding', webhook_url?: string | null } | null, organization: { __typename?: 'organization', id: string, name: string }, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null } | null, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }>, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', impressions: number, spend?: any, reach?: number | null }>, routing_info?: { __typename?: 'campaign_routing_info', campaign_id: string, forwarding_webhook: string, location_id?: number | null, office_id?: string | null, type: string } | null };

export type NewContactsPerDayFragment = { __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null };

export type OrganizationFragment = { __typename?: 'organization', name: string, id: string, active: boolean, name_prefix?: Organization_Name_Prefix_Enum | null, is_partner: boolean, partner_organization_id?: string | null, short_name?: string | null, logo_url?: string | null, country?: string | null, campaigns_aggregate: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, settings?: { __typename?: 'organization_settings', address_formally: boolean, organization_id: string, notification_emails_enabled: boolean, welcome_emails_enabled: boolean, rejection_emails_enabled: boolean } | null };

export type DeleteApplicantMutationVariables = Exact<{
  applicant_id: Scalars['uuid']['input'];
}>;


export type DeleteApplicantMutation = { __typename?: 'mutation_root', update_contact_by_pk?: { __typename?: 'contact', id: string } | null };

export type CountCampaignsByStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CountCampaignsByStatusQuery = { __typename?: 'query_root', active_campaigns: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, paused_campaigns: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, draft_campaigns: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, finished_campaigns: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } };

export type DeleteForwardingMutationVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type DeleteForwardingMutation = { __typename?: 'mutation_root', delete_chat_bot_forwarding?: { __typename?: 'chat_bot_forwarding_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'chat_bot_forwarding', campaign_id: string, webhook_url?: string | null }> } | null };

export type GetAdCampaignsQueryVariables = Exact<{
  filter?: InputMaybe<Uuid_Comparison_Exp>;
}>;


export type GetAdCampaignsQuery = { __typename?: 'query_root', ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', id: string, created_at: string, platform: Ad_Platform_Enum, platform_specific_id: string, name: string }> };

export type AdCampaignFragment = { __typename?: 'ad_campaign_metrics', id: string, created_at: string, platform: Ad_Platform_Enum, platform_specific_id: string, name: string };

export type GetCampaignContactsPerDayQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCampaignContactsPerDayQuery = { __typename?: 'query_root', campaign_by_pk?: { __typename?: 'campaign', total_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, qualified_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }> } | null, new_unqualified_contacts_per_day: Array<{ __typename?: 'new_unqualified_contacts_per_day', date?: string | null, new_unqualified_contacts?: any | null, utm_source?: string | null }> };

export type CampaignContactsPerDayFragment = { __typename?: 'campaign', total_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, qualified_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }> };

export type GetCampaignEmailOverwriteQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCampaignEmailOverwriteQuery = { __typename?: 'query_root', campaign_by_pk?: { __typename?: 'campaign', support_email?: string | null, email_template_overwrite?: { __typename?: 'campaign_email_template_overwrite', campaign_id: string, rejection?: string | null, welcome?: string | null } | null } | null };

export type CampaignEmailOverwriteFragment = { __typename?: 'campaign_email_template_overwrite', campaign_id: string, rejection?: string | null, welcome?: string | null };

export type GetCampaignFunnelAnalyticsQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetCampaignFunnelAnalyticsQuery = { __typename?: 'query_root', campaign_by_pk?: { __typename?: 'campaign', funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null, sessions: number } | null, funnel_whatsapp_share_clicks_aggregate: { __typename?: 'funnel_whatsapp_share_clicks_aggregate', aggregate?: { __typename?: 'funnel_whatsapp_share_clicks_aggregate_fields', count: number } | null }, funnel_page_insights: Array<{ __typename?: 'funnel_page_insights', index: number, visitors: number, name?: string | null, question?: { __typename?: 'funnel_question', title: string } | null }> } | null };

export type CampaignFunnelAnalyticsFragment = { __typename?: 'campaign', funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null, sessions: number } | null, funnel_whatsapp_share_clicks_aggregate: { __typename?: 'funnel_whatsapp_share_clicks_aggregate', aggregate?: { __typename?: 'funnel_whatsapp_share_clicks_aggregate_fields', count: number } | null }, funnel_page_insights: Array<{ __typename?: 'funnel_page_insights', index: number, visitors: number, name?: string | null, question?: { __typename?: 'funnel_question', title: string } | null }> };

export type GetCampaignKpisQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
  hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: Scalars['Boolean']['input'];
  canSeeInternalInsights: Scalars['Boolean']['input'];
}>;


export type GetCampaignKpisQuery = { __typename?: 'query_root', campaign_by_pk?: { __typename?: 'campaign', customer_budget_initial?: any | null, customer_budget_bonus?: any | null, customer_budget_total?: any | null, remaining_customer_budget?: any | null, margin_in_percent?: any, media_budget?: any | null, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform_specific_id: string, platform: Ad_Platform_Enum, impressions: number, reach?: number | null, clicks: number, spend?: any, cpc?: string | null }> } | null };

export type CampaignKpisFragment = { __typename?: 'campaign', customer_budget_initial?: any | null, customer_budget_bonus?: any | null, customer_budget_total?: any | null, remaining_customer_budget?: any | null, margin_in_percent?: any, media_budget?: any | null, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform_specific_id: string, platform: Ad_Platform_Enum, impressions: number, reach?: number | null, clicks: number, spend?: any, cpc?: string | null }> };

export type GetCampaignStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCampaignStatusesQuery = { __typename?: 'query_root', campaign: Array<{ __typename?: 'campaign', status?: string | null }> };

export type GetLinkedAdCampaignsQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetLinkedAdCampaignsQuery = { __typename?: 'query_root', ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', id: string, created_at: string, platform: Ad_Platform_Enum, platform_specific_id: string, name: string }> };

export type GetMinifiedCampaignQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetMinifiedCampaignQuery = { __typename?: 'query_root', campaign_by_pk?: { __typename?: 'campaign', id: string, name: string, status?: string | null, is_test: boolean, is_hidden: boolean, applicant_board_enabled: boolean, start?: string | null, end?: string | null, daily_budget: any, remaining_customer_budget?: any | null, customer_budget_total?: any | null, short_id: string, responsible_person?: string | null, chat_bot_enabled: boolean, chat_bot_v2_enabled: boolean, work_location?: Campaign_Work_Location_Enum | null, monday_url?: string | null, organization: { __typename?: 'organization', id: string, name: string, short_name?: string | null, name_prefix?: Organization_Name_Prefix_Enum | null, rms_org_setup?: { __typename?: 'rms_org_setups', rms_type: string } | null, settings?: { __typename?: 'organization_settings', organization_id: string, address_formally: boolean, rejection_emails_enabled: boolean, notification_emails_enabled: boolean, welcome_emails_enabled: boolean } | null }, org_settings_override?: { __typename?: 'campaign_settings_override', logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum } | null, c_location?: { __typename?: 'organization_location', slug: string, name: string, organization_id: string, parent_region?: { __typename?: 'organization_region', slug: string, name: string, organization_id: string } | null } | null, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, funnel?: { __typename?: 'funnel_funnels', campaign_id?: string | null, slug: string, chatbot_funnel_enabled: boolean } | null, call_campaign: Array<{ __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean }>, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform: Ad_Platform_Enum }>, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }> } | null };

export type MinifiedCampaignFragment = { __typename?: 'campaign', id: string, name: string, status?: string | null, is_test: boolean, is_hidden: boolean, applicant_board_enabled: boolean, start?: string | null, end?: string | null, daily_budget: any, remaining_customer_budget?: any | null, customer_budget_total?: any | null, short_id: string, responsible_person?: string | null, chat_bot_enabled: boolean, chat_bot_v2_enabled: boolean, work_location?: Campaign_Work_Location_Enum | null, monday_url?: string | null, organization: { __typename?: 'organization', id: string, name: string, short_name?: string | null, name_prefix?: Organization_Name_Prefix_Enum | null, rms_org_setup?: { __typename?: 'rms_org_setups', rms_type: string } | null, settings?: { __typename?: 'organization_settings', organization_id: string, address_formally: boolean, rejection_emails_enabled: boolean, notification_emails_enabled: boolean, welcome_emails_enabled: boolean } | null }, org_settings_override?: { __typename?: 'campaign_settings_override', logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum } | null, c_location?: { __typename?: 'organization_location', slug: string, name: string, organization_id: string, parent_region?: { __typename?: 'organization_region', slug: string, name: string, organization_id: string } | null } | null, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, funnel?: { __typename?: 'funnel_funnels', campaign_id?: string | null, slug: string, chatbot_funnel_enabled: boolean } | null, call_campaign: Array<{ __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean }>, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform: Ad_Platform_Enum }>, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }> };

export type InsertCampaignMutationVariables = Exact<{
  campaign: Campaign_Insert_Input;
  isAdmin: Scalars['Boolean']['input'];
}>;


export type InsertCampaignMutation = { __typename?: 'mutation_root', insert_campaign_one?: { __typename?: 'campaign', id: string, short_id: string, name: string, category?: string | null, start?: string | null, end?: string | null, location?: string | null, work_location?: Campaign_Work_Location_Enum | null, pdf_enabled?: boolean | null, monday_url?: string | null, organization_id: string, perspective_campaign_id?: string | null, is_test: boolean, media_budget?: any | null, daily_media_budget?: any | null, applicants_email_list: Array<string>, ads_email_list: Array<string>, forwarding?: { __typename?: 'chat_bot_forwarding', webhook_url?: string | null } | null, organization: { __typename?: 'organization', id: string, name: string }, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null } | null, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }>, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', impressions: number, spend?: any, reach?: number | null }>, routing_info?: { __typename?: 'campaign_routing_info', campaign_id: string, forwarding_webhook: string, location_id?: number | null, office_id?: string | null, type: string } | null } | null };

export type PauseCampaignMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PauseCampaignMutation = { __typename?: 'mutation_root', insert_campaign_status_log_one?: { __typename?: 'campaign_status_log', created_at: string } | null, update_campaign_by_pk?: { __typename?: 'campaign', id: string, status_override?: Campaign_Status_Enum | null } | null };

export type ResumeCampaignMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ResumeCampaignMutation = { __typename?: 'mutation_root', insert_campaign_status_log_one?: { __typename?: 'campaign_status_log', created_at: string } | null, update_campaign_by_pk?: { __typename?: 'campaign', id: string, status_override?: Campaign_Status_Enum | null } | null };

export type StopCampaignMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type StopCampaignMutation = { __typename?: 'mutation_root', update_campaign_by_pk?: { __typename?: 'campaign', id: string, end?: string | null, status?: string | null } | null };

export type ToggleCampaignVisibilityMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  is_hidden: Scalars['Boolean']['input'];
}>;


export type ToggleCampaignVisibilityMutation = { __typename?: 'mutation_root', update_campaign_by_pk?: { __typename?: 'campaign', id: string, is_hidden: boolean } | null };

export type UpdateCampaignMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Campaign_Set_Input;
  routingInfo: Campaign_Routing_Info_Insert_Input;
  isAdmin: Scalars['Boolean']['input'];
}>;


export type UpdateCampaignMutation = { __typename?: 'mutation_root', update_campaign_by_pk?: { __typename?: 'campaign', id: string, short_id: string, name: string, category?: string | null, start?: string | null, end?: string | null, location?: string | null, work_location?: Campaign_Work_Location_Enum | null, pdf_enabled?: boolean | null, monday_url?: string | null, organization_id: string, perspective_campaign_id?: string | null, is_test: boolean, media_budget?: any | null, daily_media_budget?: any | null, applicants_email_list: Array<string>, ads_email_list: Array<string>, forwarding?: { __typename?: 'chat_bot_forwarding', webhook_url?: string | null } | null, organization: { __typename?: 'organization', id: string, name: string }, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null } | null, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }>, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', impressions: number, spend?: any, reach?: number | null }>, routing_info?: { __typename?: 'campaign_routing_info', campaign_id: string, forwarding_webhook: string, location_id?: number | null, office_id?: string | null, type: string } | null } | null, insert_campaign_routing_info_one?: { __typename?: 'campaign_routing_info', campaign_id: string, type: string, location_id?: number | null, office_id?: string | null } | null };

export type UpsertCampaignEmailTemplatesMutationVariables = Exact<{
  email_templates: Campaign_Email_Template_Overwrite_Insert_Input;
}>;


export type UpsertCampaignEmailTemplatesMutation = { __typename?: 'mutation_root', insert_campaign_email_template_overwrite_one?: { __typename?: 'campaign_email_template_overwrite', welcome?: string | null, rejection?: string | null, campaign_id: string } | null };

export type UpsertCampaignSettingsOverrideMutationVariables = Exact<{
  cso: Campaign_Settings_Override_Insert_Input;
}>;


export type UpsertCampaignSettingsOverrideMutation = { __typename?: 'mutation_root', insert_campaign_settings_override_one?: { __typename?: 'campaign_settings_override', campaign_id: string, logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum } | null };

export type UpsertChatBotForwardingMutationVariables = Exact<{
  forwarding: Chat_Bot_Forwarding_Insert_Input;
}>;


export type UpsertChatBotForwardingMutation = { __typename?: 'mutation_root', insert_chat_bot_forwarding_one?: { __typename?: 'chat_bot_forwarding', campaign_id: string, webhook_url?: string | null } | null };

export type ApproveAdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ApproveAdMutation = { __typename?: 'mutation_root', update_campaign_ad_by_pk?: { __typename?: 'campaign_ad', id: string, status: Ad_Status_Enum } | null };

export type CreativeFeedbackFragment = { __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string };

export type DeleteAdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteAdMutation = { __typename?: 'mutation_root', delete_campaign_ad_by_pk?: { __typename?: 'campaign_ad', id: string, campaign_id: string, status: Ad_Status_Enum, platform: Ad_Platform_Enum, creative: { __typename?: 'ad_creative', id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> } } | null };

export type GetActiveAdsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetActiveAdsQuery = { __typename?: 'query_root', campaign_ad: Array<{ __typename?: 'campaign_ad', id: string, campaign_id: string, status: Ad_Status_Enum, platform: Ad_Platform_Enum, campaign: { __typename?: 'campaign', name: string, status?: string | null, is_hidden: boolean }, creative: { __typename?: 'ad_creative', id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> } }>, campaign_ad_aggregate: { __typename?: 'campaign_ad_aggregate', aggregate?: { __typename?: 'campaign_ad_aggregate_fields', count: number } | null } };

export type GetAdChangelogQueryVariables = Exact<{
  ad_id: Scalars['uuid']['input'];
}>;


export type GetAdChangelogQuery = { __typename?: 'query_root', campaign_ad_by_pk?: { __typename?: 'campaign_ad', id: string, platform: Ad_Platform_Enum, creatives_history: Array<{ __typename?: 'ad_creative', id: string, creative_upload_id: string, created_at: string, benefits: string, mime_type?: string | null, funnel_url?: string | null, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> }> } | null };

export type CreativesHistoryItemFragment = { __typename?: 'ad_creative', id: string, creative_upload_id: string, created_at: string, benefits: string, mime_type?: string | null, funnel_url?: string | null, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> };

export type GetAdCreativeOriginalNameQueryVariables = Exact<{
  adId: Scalars['uuid']['input'];
}>;


export type GetAdCreativeOriginalNameQuery = { __typename?: 'query_root', campaign_ad_by_pk?: { __typename?: 'campaign_ad', creative: { __typename?: 'ad_creative', creative_upload: { __typename?: 'file_upload', original_filename: string } } } | null };

export type GetAdsQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetAdsQuery = { __typename?: 'query_root', campaign_ad: Array<{ __typename?: 'campaign_ad', id: string, campaign_id: string, status: Ad_Status_Enum, platform: Ad_Platform_Enum, creative: { __typename?: 'ad_creative', id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> } }> };

export type AdFragment = { __typename?: 'campaign_ad', id: string, campaign_id: string, status: Ad_Status_Enum, platform: Ad_Platform_Enum, creative: { __typename?: 'ad_creative', id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> } };

export type GetFirstAdCreativeQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetFirstAdCreativeQuery = { __typename?: 'query_root', campaign_ad: Array<{ __typename?: 'campaign_ad', creative: { __typename?: 'ad_creative', id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> } }> };

export type InsertAdMutationVariables = Exact<{
  input: Campaign_Ad_Insert_Input;
}>;


export type InsertAdMutation = { __typename?: 'mutation_root', insert_campaign_ad_one?: { __typename?: 'campaign_ad', id: string, campaign_id: string, status: Ad_Status_Enum, platform: Ad_Platform_Enum, creative: { __typename?: 'ad_creative', id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> } } | null };

export type InsertCreativeMutationVariables = Exact<{
  input: Ad_Creative_Insert_Input;
}>;


export type InsertCreativeMutation = { __typename?: 'mutation_root', insert_ad_creative_one?: { __typename?: 'ad_creative', created_at: string, id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> } | null };

export type InsertCreativeFeedbackMutationVariables = Exact<{
  creative_id: Scalars['uuid']['input'];
  feedback: Scalars['String']['input'];
}>;


export type InsertCreativeFeedbackMutation = { __typename?: 'mutation_root', insert_ad_creative_feedback_one?: { __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string } | null };

export type LinkAdCampaignMutationVariables = Exact<{
  adCampaignId: Scalars['uuid']['input'];
  campaignId: Scalars['uuid']['input'];
}>;


export type LinkAdCampaignMutation = { __typename?: 'mutation_root', update_ad_campaign_metrics_by_pk?: { __typename?: 'ad_campaign_metrics', id: string, created_at: string, platform: Ad_Platform_Enum, platform_specific_id: string, name: string } | null };

export type GetTrafficByPlatformQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrafficByPlatformQuery = { __typename?: 'query_root', ad_platform: Array<{ __typename?: 'ad_platform', value: string, campaign_metrics_aggregate: { __typename?: 'ad_campaign_metrics_aggregate', aggregate?: { __typename?: 'ad_campaign_metrics_aggregate_fields', sum?: { __typename?: 'ad_campaign_metrics_sum_fields', conversions?: number | null } | null } | null } }> };

export type PlatformTrafficMetricsFragment = { __typename?: 'ad_platform', value: string, campaign_metrics_aggregate: { __typename?: 'ad_campaign_metrics_aggregate', aggregate?: { __typename?: 'ad_campaign_metrics_aggregate_fields', sum?: { __typename?: 'ad_campaign_metrics_sum_fields', conversions?: number | null } | null } | null } };

export type UnlinkAdCampaignMutationVariables = Exact<{
  adCampaignId: Scalars['uuid']['input'];
}>;


export type UnlinkAdCampaignMutation = { __typename?: 'mutation_root', update_ad_campaign_metrics_by_pk?: { __typename?: 'ad_campaign_metrics', id: string, created_at: string, platform: Ad_Platform_Enum, platform_specific_id: string, name: string } | null };

export type UpdateAdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Campaign_Ad_Set_Input;
}>;


export type UpdateAdMutation = { __typename?: 'mutation_root', update_campaign_ad_by_pk?: { __typename?: 'campaign_ad', id: string, campaign_id: string, status: Ad_Status_Enum, platform: Ad_Platform_Enum, creative: { __typename?: 'ad_creative', id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> } } | null };

export type UpdateCreativeMutationVariables = Exact<{
  ad_id: Scalars['uuid']['input'];
  creative_id: Scalars['uuid']['input'];
  input: Ad_Creative_Set_Input;
}>;


export type UpdateCreativeMutation = { __typename?: 'mutation_root', update_ad_creative_by_pk?: { __typename?: 'ad_creative', id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> } | null, update_campaign_ad_by_pk?: { __typename?: 'campaign_ad', id: string, creative: { __typename?: 'ad_creative', id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> } } | null };

export type WithdrawAdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type WithdrawAdMutation = { __typename?: 'mutation_root', update_campaign_ad_by_pk?: { __typename?: 'campaign_ad', id: string, status: Ad_Status_Enum } | null };

export type GetCampaignAtsInsightsQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetCampaignAtsInsightsQuery = { __typename?: 'query_root', success_true: { __typename?: 'rms_forwarded_logs_aggregate', aggregate?: { __typename?: 'rms_forwarded_logs_aggregate_fields', count: number } | null }, success_false: { __typename?: 'rms_forwarded_logs_aggregate', aggregate?: { __typename?: 'rms_forwarded_logs_aggregate_fields', count: number } | null } };

export type CampaignBudgetTransactionFragment = { __typename?: 'campaign_budget_transaction', amount: any, created_at: string, type: Campaign_Transaction_Type_Enum, id: string, campaign: { __typename?: 'campaign', id: string, margin_in_percent: any } };

export type IncreaseCampaignBudgetMutationVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
  amount: Scalars['float8']['input'];
  new_end: Scalars['timestamptz']['input'];
  new_daily_budget?: InputMaybe<Scalars['numeric']['input']>;
  new_daily_media_budget?: InputMaybe<Scalars['numeric']['input']>;
}>;


export type IncreaseCampaignBudgetMutation = { __typename?: 'mutation_root', insert_campaign_budget_transaction_one?: { __typename?: 'campaign_budget_transaction', amount: any, created_at: string, type: Campaign_Transaction_Type_Enum, id: string, campaign: { __typename?: 'campaign', id: string, margin_in_percent: any } } | null, update_campaign_by_pk?: { __typename?: 'campaign', id: string } | null };

export type InsertBudgetTransactionMutationVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
  amount: Scalars['float8']['input'];
}>;


export type InsertBudgetTransactionMutation = { __typename?: 'mutation_root', insert_campaign_budget_transaction_one?: { __typename?: 'campaign_budget_transaction', amount: any, created_at: string, type: Campaign_Transaction_Type_Enum, id: string, campaign: { __typename?: 'campaign', id: string, margin_in_percent: any } } | null };

export type InsertInitialBudgetMutationVariables = Exact<{
  budget: Scalars['float8']['input'];
  campaignId: Scalars['uuid']['input'];
}>;


export type InsertInitialBudgetMutation = { __typename?: 'mutation_root', insert_campaign_budget_transaction_one?: { __typename?: 'campaign_budget_transaction', id: string } | null };

export type ResetDailyTransactionsMutationVariables = Exact<{
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type ResetDailyTransactionsMutation = { __typename?: 'mutation_root', delete_campaign_budget_transaction?: { __typename?: 'campaign_budget_transaction_mutation_response', affected_rows: number } | null };

export type UpdateInitialTransactionMutationVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
  amount: Scalars['float8']['input'];
}>;


export type UpdateInitialTransactionMutation = { __typename?: 'mutation_root', update_campaign_budget_transaction?: { __typename?: 'campaign_budget_transaction_mutation_response', affected_rows: number } | null };

export type GetCampaignBudgetQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  createdAtSort?: InputMaybe<Order_By>;
}>;


export type GetCampaignBudgetQuery = { __typename?: 'query_root', campaign_budget: Array<{ __typename?: 'campaign_budget', amount?: any | null }>, campaign_budget_transaction: Array<{ __typename?: 'campaign_budget_transaction', amount: any, created_at: string, type: Campaign_Transaction_Type_Enum, id: string, campaign: { __typename?: 'campaign', id: string, margin_in_percent: any } }>, campaign_budget_transaction_aggregate: { __typename?: 'campaign_budget_transaction_aggregate', aggregate?: { __typename?: 'campaign_budget_transaction_aggregate_fields', count: number } | null } };

export type GetCampaignBudgetTransactionsQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetCampaignBudgetTransactionsQuery = { __typename?: 'query_root', campaign_budget_transaction: Array<{ __typename?: 'campaign_budget_transaction', amount: any, created_at: string, type: Campaign_Transaction_Type_Enum }> };

export type GetOrganizationCampaignBudgetQueryVariables = Exact<{
  org_id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationCampaignBudgetQuery = { __typename?: 'query_root', campaign_budget_aggregate: { __typename?: 'campaign_budget_aggregate', aggregate?: { __typename?: 'campaign_budget_aggregate_fields', count: number } | null } };

export type DeleteFunnelQuestionMutationVariables = Exact<{
  uuid: Scalars['uuid']['input'];
}>;


export type DeleteFunnelQuestionMutation = { __typename?: 'mutation_root', update_funnel_question?: { __typename?: 'funnel_question_mutation_response', affected_rows: number } | null };

export type FunnelQuestionFragment = { __typename?: 'funnel_question', title: string, question_type: string, position?: number | null, parent_question_id?: string | null, is_required: boolean, archived: boolean, uuid: string, options: Array<{ __typename?: 'funnel_question_option', icon?: string | null, id: string, title: string, value?: string | null, isKnockout: boolean, redirect_question_id?: string | null, redirect_behavior: string }>, child_questions: Array<{ __typename?: 'funnel_question', icon?: string | null, id: string, position?: number | null, title: string, is_required: boolean, question_type: string, parent_question_id?: string | null, archived: boolean, options: Array<{ __typename?: 'funnel_question_option', title: string }> }> };

export type GetFunnelForCampaignQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetFunnelForCampaignQuery = { __typename?: 'query_root', funnel_funnels: Array<{ __typename?: 'funnel_funnels', id: string, enabled: boolean, campaign_id?: string | null, job_caption?: string | null, job_intro?: string | null, job_byline?: string | null, expectations_items: any, expectations_intro?: string | null, img_1_id?: string | null, img_1_2_id?: string | null, img_1_3_id?: string | null, img_1_4_id?: string | null, img_2_id?: string | null, img_2_2_id?: string | null, img_2_3_id?: string | null, img_2_4_id?: string | null, img_3_id?: string | null, img_3_2_id?: string | null, img_3_3_id?: string | null, img_3_4_id?: string | null, logo_id?: string | null, video_1_id?: string | null, video_2_id?: string | null, video_3_id?: string | null, benefit_icon_id?: string | null, expectation_icon_id?: string | null, company_privacy_policy_url?: string | null, company_privacy_policy_title?: string | null, bot_consent_enabled: boolean, chatbot_funnel_enabled: boolean, whatsapp_apply_label?: string | null, whatsapp_apply_message_template?: string | null, whatsapp_intro_message?: string | null, whatsapp_outro_message?: string | null, whatsapp_share_caption?: string | null, whatsapp_share_title?: string | null, whatsapp_share_label?: string | null, header_color?: string | null, we_are_intro?: string | null, we_are_byline?: string | null, we_are_copy?: string | null, we_are_call_to_action?: string | null, call_to_action?: string | null, sub_call_to_action?: string | null, formality_type: string, locale: string, theme_color?: string | null, benefits_intro?: string | null, template: string, next_steps: any, slug: string, highlights: string, cv_required?: boolean | null, location_question_country_enabled: boolean, location_question_city_enabled: boolean, location_question_street_enabled: boolean, location_question_postalcode_enabled: boolean, contact_question_birthdate_enabled: boolean, contact_question_form_of_address_enabled: boolean, cv_question_enabled: boolean, benefits: Array<{ __typename?: 'funnel_benefits', description: string, title: string, id: string }>, questions: Array<{ __typename?: 'funnel_question', title: string, question_type: string, position?: number | null, parent_question_id?: string | null, is_required: boolean, archived: boolean, uuid: string, options: Array<{ __typename?: 'funnel_question_option', icon?: string | null, id: string, title: string, value?: string | null, isKnockout: boolean, redirect_question_id?: string | null, redirect_behavior: string }>, child_questions: Array<{ __typename?: 'funnel_question', icon?: string | null, id: string, position?: number | null, title: string, is_required: boolean, question_type: string, parent_question_id?: string | null, archived: boolean, options: Array<{ __typename?: 'funnel_question_option', title: string }> }> }>, campaign?: { __typename?: 'campaign', status?: string | null, is_hidden: boolean, short_id: string } | null }> };

export type GetFunnelQuestionQueryVariables = Exact<{
  uuid: Scalars['uuid']['input'];
}>;


export type GetFunnelQuestionQuery = { __typename?: 'query_root', funnel_question: Array<{ __typename?: 'funnel_question', title: string, question_type: string, position?: number | null, parent_question_id?: string | null, is_required: boolean, archived: boolean, uuid: string, options: Array<{ __typename?: 'funnel_question_option', icon?: string | null, id: string, title: string, value?: string | null, isKnockout: boolean, redirect_question_id?: string | null, redirect_behavior: string }>, child_questions: Array<{ __typename?: 'funnel_question', icon?: string | null, id: string, position?: number | null, title: string, is_required: boolean, question_type: string, parent_question_id?: string | null, archived: boolean, options: Array<{ __typename?: 'funnel_question_option', title: string }> }> }> };

export type GetFunnelQuestionsQueryVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
}>;


export type GetFunnelQuestionsQuery = { __typename?: 'query_root', funnel_question: Array<{ __typename?: 'funnel_question', title: string, question_type: string, position?: number | null, parent_question_id?: string | null, is_required: boolean, archived: boolean, uuid: string, options: Array<{ __typename?: 'funnel_question_option', icon?: string | null, id: string, title: string, value?: string | null, isKnockout: boolean, redirect_question_id?: string | null, redirect_behavior: string }>, child_questions: Array<{ __typename?: 'funnel_question', icon?: string | null, id: string, position?: number | null, title: string, is_required: boolean, question_type: string, parent_question_id?: string | null, archived: boolean, options: Array<{ __typename?: 'funnel_question_option', title: string }> }> }> };

export type InsertFunnelQuestionMutationVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
}>;


export type InsertFunnelQuestionMutation = { __typename?: 'mutation_root', insert_funnel_question?: { __typename?: 'funnel_question_mutation_response', affected_rows: number } | null };

export type ToggleFunnelMutationVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type ToggleFunnelMutation = { __typename?: 'mutation_root', update_funnel_funnels?: { __typename?: 'funnel_funnels_mutation_response', returning: Array<{ __typename?: 'funnel_funnels', campaign_id?: string | null, enabled: boolean }> } | null };

export type UpdateFunnelQuestionMutationVariables = Exact<{
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  question_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFunnelQuestionMutation = { __typename?: 'mutation_root', update_funnel_question?: { __typename?: 'funnel_question_mutation_response', affected_rows: number } | null };

export type UpsertFunnelMutationVariables = Exact<{
  funnel: Funnel_Funnels_Insert_Input;
}>;


export type UpsertFunnelMutation = { __typename?: 'mutation_root', insert_funnel_funnels_one?: { __typename?: 'funnel_funnels', campaign_id?: string | null } | null };

export type UpsertFunnelQuestionMutationVariables = Exact<{
  question: Funnel_Question_Insert_Input;
}>;


export type UpsertFunnelQuestionMutation = { __typename?: 'mutation_root', insert_funnel_question?: { __typename?: 'funnel_question_mutation_response', returning: Array<{ __typename?: 'funnel_question', id: string, title: string, question_type: string, position?: number | null, parent_question_id?: string | null, is_required: boolean, icon?: string | null }> } | null };

export type UpsertFunnelV2MutationVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
  funnel: Funnel_Funnels_Insert_Input;
  benefit_inserts: Array<Funnel_Benefits_Insert_Input> | Funnel_Benefits_Insert_Input;
  question_updates: Array<Funnel_Question_Insert_Input> | Funnel_Question_Insert_Input;
  question_inserts: Array<Funnel_Question_Insert_Input> | Funnel_Question_Insert_Input;
  question_ids_to_keep: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpsertFunnelV2Mutation = { __typename?: 'mutation_root', insert_funnel_funnels_one?: { __typename?: 'funnel_funnels', campaign_id?: string | null } | null, delete_funnel_benefits?: { __typename?: 'funnel_benefits_mutation_response', affected_rows: number } | null, insert_funnel_benefits?: { __typename?: 'funnel_benefits_mutation_response', affected_rows: number } | null, delete_funnel_question_option?: { __typename?: 'funnel_question_option_mutation_response', affected_rows: number } | null, delete_funnel_question?: { __typename?: 'funnel_question_mutation_response', affected_rows: number } | null, update_questions?: { __typename?: 'funnel_question_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'funnel_question', id: string }> } | null, insert_questions?: { __typename?: 'funnel_question_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'funnel_question', id: string }> } | null };

export type GetInsightCampaignDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  hasAdvancedAccessToCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  canSeeInternalInsights: Scalars['Boolean']['input'];
  hasAdvancedAccessToCampaignsOrCanSeeInternalInsights?: Scalars['Boolean']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetInsightCampaignDetailsQuery = { __typename?: 'query_root', campaign_by_pk?: { __typename?: 'campaign', name: string, id: string, category?: string | null, start?: string | null, end?: string | null, customer_budget_initial?: any | null, customer_budget_total?: any | null, customer_budget_bonus?: any | null, remaining_customer_budget?: any | null, margin_in_percent?: any, media_budget?: any | null, work_location?: Campaign_Work_Location_Enum | null, status?: string | null, location_slug?: string | null, daily_budget: any, pdf_enabled?: boolean | null, monday_url?: string | null, meistertask_url?: string | null, organization_id?: string, perspective_campaign_id?: string | null, is_test: boolean, daily_media_budget?: any | null, applicants_email_list?: Array<string>, ads_email_list?: Array<string>, support_email?: string | null, is_hidden: boolean, chat_bot_is_ko: boolean, chat_bot_enabled: boolean, chat_bot_v2_enabled: boolean, job_posting_text?: string | null, phone_number_default_region: Campaign_Iso_2_Country_Codes_Enum, short_id: string, responsible_person?: string | null, applicant_board_enabled: boolean, funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null, sessions: number } | null, qualified_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, unqualified_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, funnel_page_insights: Array<{ __typename?: 'funnel_page_insights', index: number, visitors: number, name?: string | null, question?: { __typename?: 'funnel_question', title: string } | null }>, organization: { __typename?: 'organization', name: string, id: string, name_prefix?: Organization_Name_Prefix_Enum | null, short_name?: string | null, settings?: { __typename?: 'organization_settings', organization_id: string, address_formally: boolean, rejection_emails_enabled: boolean, notification_emails_enabled: boolean, welcome_emails_enabled: boolean } | null }, email_template_overwrite?: { __typename?: 'campaign_email_template_overwrite', campaign_id: string, rejection?: string | null, welcome?: string | null } | null, unqualified_contacts_per_day: Array<{ __typename?: 'new_unqualified_contacts_per_day', date?: string | null, new_unqualified_contacts?: any | null, utm_source?: string | null }>, forwarding?: { __typename?: 'chat_bot_forwarding', webhook_url?: string | null } | null, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, qualified_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, total_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, call_campaign: Array<{ __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean }>, c_location?: { __typename?: 'organization_location', organization_id: string, slug: string, name: string, parent_region?: { __typename?: 'organization_region', organization_id: string, slug: string, name: string } | null } | null, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }>, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform_specific_id: string, clicks: number, impressions: number, spend?: any, reach?: number | null, cpc?: string | null, status: string, platform: Ad_Platform_Enum }>, routing_info?: { __typename?: 'campaign_routing_info', type: string, forwarding_webhook: string, location_id?: number | null, office_id?: string | null } | null, org_settings_override?: { __typename?: 'campaign_settings_override', logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum } | null } | null };

export type GetQuestionsQueryVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
}>;


export type GetQuestionsQuery = { __typename?: 'query_root', funnel_question: Array<{ __typename?: 'funnel_question', id: string, field_name: string, title: string, question_type: string, total_answer_count: { __typename?: 'answer_aggregate', aggregate?: { __typename?: 'answer_aggregate_fields', count: number } | null }, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }>, answers: Array<{ __typename?: 'answer', value?: string | null }>, answer_categories: Array<{ __typename?: 'answer', value?: string | null }>, answers_aggregate: { __typename?: 'answer_aggregate', aggregate?: { __typename?: 'answer_aggregate_fields', count: number } | null } }> };

export type InsightsQuestionFragment = { __typename?: 'funnel_question', id: string, field_name: string, title: string, question_type: string, total_answer_count: { __typename?: 'answer_aggregate', aggregate?: { __typename?: 'answer_aggregate_fields', count: number } | null }, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }>, answers: Array<{ __typename?: 'answer', value?: string | null }>, answer_categories: Array<{ __typename?: 'answer', value?: string | null }>, answers_aggregate: { __typename?: 'answer_aggregate', aggregate?: { __typename?: 'answer_aggregate_fields', count: number } | null } };

export type GetUnqualifiedContactsByCampaignIdQueryVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
}>;


export type GetUnqualifiedContactsByCampaignIdQuery = { __typename?: 'query_root', new_unqualified_contacts_per_day: Array<{ __typename?: 'new_unqualified_contacts_per_day', date?: string | null, new_unqualified_contacts?: any | null, utm_source?: string | null }> };

export type CampaignDetailsFragment = { __typename?: 'campaign', name: string, id: string, category?: string | null, start?: string | null, end?: string | null, customer_budget_initial?: any | null, customer_budget_total?: any | null, customer_budget_bonus?: any | null, remaining_customer_budget?: any | null, margin_in_percent?: any, media_budget?: any | null, work_location?: Campaign_Work_Location_Enum | null, status?: string | null, location_slug?: string | null, daily_budget: any, pdf_enabled?: boolean | null, monday_url?: string | null, meistertask_url?: string | null, organization_id?: string, perspective_campaign_id?: string | null, is_test: boolean, daily_media_budget?: any | null, applicants_email_list?: Array<string>, ads_email_list?: Array<string>, support_email?: string | null, is_hidden: boolean, chat_bot_is_ko: boolean, chat_bot_enabled: boolean, chat_bot_v2_enabled: boolean, job_posting_text?: string | null, phone_number_default_region: Campaign_Iso_2_Country_Codes_Enum, short_id: string, responsible_person?: string | null, applicant_board_enabled: boolean, funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null, sessions: number } | null, qualified_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, unqualified_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, funnel_page_insights: Array<{ __typename?: 'funnel_page_insights', index: number, visitors: number, name?: string | null, question?: { __typename?: 'funnel_question', title: string } | null }>, organization: { __typename?: 'organization', name: string, id: string, name_prefix?: Organization_Name_Prefix_Enum | null, short_name?: string | null, settings?: { __typename?: 'organization_settings', organization_id: string, address_formally: boolean, rejection_emails_enabled: boolean, notification_emails_enabled: boolean, welcome_emails_enabled: boolean } | null }, email_template_overwrite?: { __typename?: 'campaign_email_template_overwrite', campaign_id: string, rejection?: string | null, welcome?: string | null } | null, unqualified_contacts_per_day: Array<{ __typename?: 'new_unqualified_contacts_per_day', date?: string | null, new_unqualified_contacts?: any | null, utm_source?: string | null }>, forwarding?: { __typename?: 'chat_bot_forwarding', webhook_url?: string | null } | null, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, qualified_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, total_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, call_campaign: Array<{ __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean }>, c_location?: { __typename?: 'organization_location', organization_id: string, slug: string, name: string, parent_region?: { __typename?: 'organization_region', organization_id: string, slug: string, name: string } | null } | null, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }>, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform_specific_id: string, clicks: number, impressions: number, spend?: any, reach?: number | null, cpc?: string | null, status: string, platform: Ad_Platform_Enum }>, routing_info?: { __typename?: 'campaign_routing_info', type: string, forwarding_webhook: string, location_id?: number | null, office_id?: string | null } | null, org_settings_override?: { __typename?: 'campaign_settings_override', logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum } | null };

export type AdCreativeFragment = { __typename?: 'ad_creative', id: string, benefits: string, funnel_url?: string | null, call_to_action_text_color_hex?: string | null, call_to_action?: string | null, call_to_action_background_color_hex?: string | null, headline_text_color_hex?: string | null, headline?: string | null, headline_background_color_hex?: string | null, mime_type?: string | null, creative_upload_id: string, feedback: Array<{ __typename?: 'ad_creative_feedback', created_at: string, id: string, text: string }> };

export type QuestionFragment = { __typename?: 'funnel_question', id: string, field_name: string, title: string, question_type: string, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }>, answers: Array<{ __typename?: 'answer', value?: string | null }>, answer_categories: Array<{ __typename?: 'answer', value?: string | null }>, answers_aggregate: { __typename?: 'answer_aggregate', aggregate?: { __typename?: 'answer_aggregate_fields', count: number } | null } };

export type UnqualifiedContactsPerDayFragment = { __typename?: 'new_unqualified_contacts_per_day', date?: string | null, new_unqualified_contacts?: any | null, utm_source?: string | null };

export type AssignOrderMutationVariables = Exact<{
  order_id: Scalars['uuid']['input'];
  responsible_user_id: Scalars['bpchar']['input'];
}>;


export type AssignOrderMutation = { __typename?: 'mutation_root', update_campaign_order_by_pk?: { __typename?: 'campaign_order', id: string, responsible_user?: string | null } | null };

export type CampaignOrderFragment = { __typename?: 'campaign_order', id: string, platform_job_id: string, budget: any, title: string, link?: string | null, description: string, responsible_user?: string | null, completed: boolean, created_campaign?: string | null, received_at: string, additional_properties: any, target_locations?: any | null, customer?: { __typename?: 'organization', id: string, short_name?: string | null, name: string, logo_url?: string | null } | null, source: { __typename?: 'campaign_order_source', id: string, url: string, source_type: Campaign_Order_Source_Type_Enum } };

export type CompleteOrderMutationVariables = Exact<{
  order_id: Scalars['uuid']['input'];
}>;


export type CompleteOrderMutation = { __typename?: 'mutation_root', update_campaign_order_by_pk?: { __typename?: 'campaign_order', id: string, completed: boolean } | null };

export type GetCampaignOrderByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCampaignOrderByIdQuery = { __typename?: 'query_root', campaign_order_by_pk?: { __typename?: 'campaign_order', id: string, platform_job_id: string, budget: any, title: string, link?: string | null, description: string, responsible_user?: string | null, completed: boolean, created_campaign?: string | null, received_at: string, additional_properties: any, target_locations?: any | null, customer?: { __typename?: 'organization', id: string, short_name?: string | null, name: string, logo_url?: string | null } | null, source: { __typename?: 'campaign_order_source', id: string, url: string, source_type: Campaign_Order_Source_Type_Enum } } | null };

export type GetCampaignOrdersQueryVariables = Exact<{
  query: Campaign_Order_Bool_Exp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetCampaignOrdersQuery = { __typename?: 'query_root', campaign_order: Array<{ __typename?: 'campaign_order', id: string, platform_job_id: string, budget: any, title: string, link?: string | null, description: string, responsible_user?: string | null, completed: boolean, created_campaign?: string | null, received_at: string, additional_properties: any, target_locations?: any | null, customer?: { __typename?: 'organization', id: string, short_name?: string | null, name: string, logo_url?: string | null } | null, source: { __typename?: 'campaign_order_source', id: string, url: string, source_type: Campaign_Order_Source_Type_Enum } }>, campaign_order_aggregate: { __typename?: 'campaign_order_aggregate', aggregate?: { __typename?: 'campaign_order_aggregate_fields', count: number } | null } };

export type SetCreatedCampaignForOrderMutationVariables = Exact<{
  order_id: Scalars['uuid']['input'];
  campaign_id: Scalars['uuid']['input'];
}>;


export type SetCreatedCampaignForOrderMutation = { __typename?: 'mutation_root', update_campaign_order_by_pk?: { __typename?: 'campaign_order', id: string, created_campaign?: string | null } | null };

export type UnassignOrderMutationVariables = Exact<{
  order_id: Scalars['uuid']['input'];
}>;


export type UnassignOrderMutation = { __typename?: 'mutation_root', update_campaign_order_by_pk?: { __typename?: 'campaign_order', id: string, responsible_user?: string | null } | null };

export type GetDistinctResponsiblePersonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDistinctResponsiblePersonsQuery = { __typename?: 'query_root', distinct_persons: Array<{ __typename?: 'campaign', responsible_person?: string | null }> };

export type GetDistinctResponsiblePersonsByOrgIdQueryVariables = Exact<{
  organization_id: Scalars['String']['input'];
}>;


export type GetDistinctResponsiblePersonsByOrgIdQuery = { __typename?: 'query_root', distinct_persons: Array<{ __typename?: 'campaign', responsible_person?: string | null }> };

export type DestinationFragment = { __typename?: 'campaign_routing_destination', location_id: number, location_name?: string | null, trello_board_id: string, trello_qualified_column: string, trello_unqualified_column: string, meistertask_board_id?: string | null, meistertask_qualified_column?: string | null, meistertask_unqualified_column?: string | null, type: string, campaign_id?: string | null, campaign?: { __typename?: 'campaign', id: string, name: string, status?: string | null, start?: string | null, end?: string | null } | null };

export type DestinationCampaignFragment = { __typename?: 'campaign', id: string, name: string, status?: string | null, start?: string | null, end?: string | null };

export type GetDestinationCampaignsQueryVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;


export type GetDestinationCampaignsQuery = { __typename?: 'query_root', campaign: Array<{ __typename?: 'campaign', id: string, name: string, status?: string | null, start?: string | null, end?: string | null }> };

export type GetDestinationIdsForTypeQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetDestinationIdsForTypeQuery = { __typename?: 'query_root', campaign_routing_destination: Array<{ __typename?: 'campaign_routing_destination', type: string, location_id: number }> };

export type GetDestinationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDestinationTypesQuery = { __typename?: 'query_root', types: Array<{ __typename?: 'campaign_routing_destination', type: string, location_id: number, location_name?: string | null }> };

export type GetDestinationsForTypeQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetDestinationsForTypeQuery = { __typename?: 'query_root', destinations: Array<{ __typename?: 'campaign_routing_destination', location_id: number, location_name?: string | null, trello_board_id: string, trello_qualified_column: string, trello_unqualified_column: string, meistertask_board_id?: string | null, meistertask_qualified_column?: string | null, meistertask_unqualified_column?: string | null, type: string, campaign_id?: string | null, campaign?: { __typename?: 'campaign', id: string, name: string, status?: string | null, start?: string | null, end?: string | null } | null }> };

export type UpdateDestinationMutationVariables = Exact<{
  locationId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  dest: Campaign_Routing_Destination_Set_Input;
}>;


export type UpdateDestinationMutation = { __typename?: 'mutation_root', update_campaign_routing_destination_by_pk?: { __typename?: 'campaign_routing_destination', location_id: number, location_name?: string | null, trello_board_id: string, trello_qualified_column: string, trello_unqualified_column: string, meistertask_board_id?: string | null, meistertask_qualified_column?: string | null, meistertask_unqualified_column?: string | null, type: string, campaign_id?: string | null, campaign?: { __typename?: 'campaign', id: string, name: string, status?: string | null, start?: string | null, end?: string | null } | null } | null };

export type GetCampaignChatBotSettingsQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetCampaignChatBotSettingsQuery = { __typename?: 'query_root', campaign_by_pk?: { __typename?: 'campaign', id: string, chat_bot_v2_enabled: boolean, chat_bot_enabled: boolean } | null };

export type GetChatContentQueryVariables = Exact<{
  contact_id: Scalars['uuid']['input'];
}>;


export type GetChatContentQuery = { __typename?: 'query_root', chat_bot_messages: Array<{ __typename?: 'chat_bot_messages', type: Chat_Bot_Message_Type_Enum, data: any, sender_type: string, created_at: string, id: any }> };

export type ChatMessageFragment = { __typename?: 'chat_bot_messages', type: Chat_Bot_Message_Type_Enum, data: any, sender_type: string, created_at: string, id: any };

export type LlmChatBotConversationFragment = { __typename?: 'bot_conversation', id: string, started_at: any, contact_id: string, messages: Array<{ __typename?: 'bot_message', id: any, sent_at: string, sent_by: Bot_Sender_Enum, text: string }> };

export type GetLlmChatBotContentSubscriptionVariables = Exact<{
  contactId: Scalars['uuid']['input'];
}>;


export type GetLlmChatBotContentSubscription = { __typename?: 'subscription_root', bot_conversation: Array<{ __typename?: 'bot_conversation', id: string, started_at: any, contact_id: string, messages: Array<{ __typename?: 'bot_message', id: any, sent_at: string, sent_by: Bot_Sender_Enum, text: string }> }> };

export type PollLlmChatBotContentQueryVariables = Exact<{
  contactId: Scalars['uuid']['input'];
}>;


export type PollLlmChatBotContentQuery = { __typename?: 'query_root', bot_conversation: Array<{ __typename?: 'bot_conversation', id: string, started_at: any, contact_id: string, messages: Array<{ __typename?: 'bot_message', id: any, sent_at: string, sent_by: Bot_Sender_Enum, text: string }> }> };

export type CreateContactBoardWithColumnsMutationVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
}>;


export type CreateContactBoardWithColumnsMutation = { __typename?: 'mutation_root', insert_board_contact_board_one?: { __typename?: 'board_contact_board', id: string, campaign_id: string, columns: Array<{ __typename?: 'board_contact_board_column', id: string, board_id: string, name: string, position: number, type?: Board_Column_Type_Enum | null }> } | null };

export type GetBoardIdsQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetBoardIdsQuery = { __typename?: 'query_root', board_contact_board: Array<{ __typename?: 'board_contact_board', id: string }> };

export type GetContactIdByDraggableIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetContactIdByDraggableIdQuery = { __typename?: 'query_root', board_contact_board_entry_by_pk?: { __typename?: 'board_contact_board_entry', contact_id: string } | null };

export type GetAnnaCallCampaignQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetAnnaCallCampaignQuery = { __typename?: 'query_root', anna_ai_call_campaigns: Array<{ __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean, tier: string, call_wait_time: number, webhook?: string | null, pathway_id: string, campaign_data: any, inbound: boolean, max_calls: number, from: string }> };

export type GetAnnaContactByIdQueryVariables = Exact<{
  contact_id: Scalars['uuid']['input'];
}>;


export type GetAnnaContactByIdQuery = { __typename?: 'query_root', latest_anna_ai_outbound_call: Array<{ __typename?: 'anna_ai_outbound_calls', contact_id?: string | null, state: string, started_at?: string | null, planned_at: string, ended_at?: string | null, duration?: string | null, summary?: string | null, transcripts?: any | null, q_and_a?: any | null, lang_skill: string, overall_impression: string, has_recording: boolean, end_call_result?: string | null, file_id?: string | null }>, outbound_call_attempts_count: { __typename?: 'anna_ai_outbound_calls_aggregate', aggregate?: { __typename?: 'anna_ai_outbound_calls_aggregate_fields', count: number } | null } };

export type GetAnnaFileByIdQueryVariables = Exact<{
  contact_id: Scalars['uuid']['input'];
}>;


export type GetAnnaFileByIdQuery = { __typename?: 'query_root', latest_anna_ai_outbound_call: Array<{ __typename?: 'anna_ai_outbound_calls', id: string, has_recording: boolean, file_id?: string | null, created_at?: string | null }> };

export type AnnaFileFragmentFragment = { __typename?: 'anna_ai_outbound_calls', id: string, has_recording: boolean, file_id?: string | null, created_at?: string | null };

export type UpsertAnnaCallCampaignMutationVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
  enabled: Scalars['Boolean']['input'];
  tier: Scalars['String']['input'];
  callWaitTime: Scalars['Int']['input'];
  webhook: Scalars['String']['input'];
  pathwayId: Scalars['uuid']['input'];
  campaignData: Scalars['jsonb']['input'];
  inbound: Scalars['Boolean']['input'];
  maxCalls: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertAnnaCallCampaignMutation = { __typename?: 'mutation_root', insert_anna_ai_call_campaigns_one?: { __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean, tier: string, call_wait_time: number, webhook?: string | null, pathway_id: string, campaign_data: any, inbound: boolean, max_calls: number, from: string } | null };

export type ContactBoardColumnFragment = { __typename?: 'board_contact_board_column', id: string, board_id: string, name: string, position: number, type?: Board_Column_Type_Enum | null };

export type DeleteContactBoardColumnByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteContactBoardColumnByIdMutation = { __typename?: 'mutation_root', delete_board_contact_board_column_by_pk?: { __typename?: 'board_contact_board_column', id: string, board_id: string, name: string, position: number, type?: Board_Column_Type_Enum | null } | null };

export type GetContactBoardColumnsWithEntriesPolledQueryVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
}>;


export type GetContactBoardColumnsWithEntriesPolledQuery = { __typename?: 'query_root', board_contact_board_column: Array<{ __typename?: 'board_contact_board_column', id: string, board_id: string, name: string, position: number, type?: Board_Column_Type_Enum | null, contact_board_entries: Array<{ __typename?: 'board_contact_board_entry', id: string, score: number, column_id: string, board_id: string, position?: number | null, contact?: { __typename?: 'contact', id: string, first_name: string, last_name: string, phone_number: string, converted_at?: string | null, email_address: string, campaign_id: string, qa_source?: Qa_Source_Enum | null, cv_id?: string | null, routing_location_id?: number | null, utm_source?: Ad_Platform_Enum | null, answers: Array<{ __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, field_name: string, title: string, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }> } }>, origin_campaign?: { __typename?: 'campaign', id: string, name: string } | null } | null, forward_log?: { __typename?: 'rms_forwarded_logs', success: boolean } | null }>, contact_board_entries_aggregate: { __typename?: 'board_contact_board_entry_aggregate', aggregate?: { __typename?: 'board_contact_board_entry_aggregate_fields', count: number } | null } }> };

export type GetContactBoardColumnsWithEntriesSubscriptionVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
}>;


export type GetContactBoardColumnsWithEntriesSubscription = { __typename?: 'subscription_root', board_contact_board_column: Array<{ __typename?: 'board_contact_board_column', id: string, board_id: string, name: string, position: number, type?: Board_Column_Type_Enum | null, contact_board_entries: Array<{ __typename?: 'board_contact_board_entry', id: string, score: number, column_id: string, board_id: string, position?: number | null, contact?: { __typename?: 'contact', id: string, first_name: string, last_name: string, phone_number: string, converted_at?: string | null, email_address: string, campaign_id: string, qa_source?: Qa_Source_Enum | null, cv_id?: string | null, routing_location_id?: number | null, utm_source?: Ad_Platform_Enum | null, answers: Array<{ __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, field_name: string, title: string, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }> } }>, origin_campaign?: { __typename?: 'campaign', id: string, name: string } | null } | null, forward_log?: { __typename?: 'rms_forwarded_logs', success: boolean } | null }>, contact_board_entries_aggregate: { __typename?: 'board_contact_board_entry_aggregate', aggregate?: { __typename?: 'board_contact_board_entry_aggregate_fields', count: number } | null } }> };

export type ContactBoardColumnWithEntriesFragment = { __typename?: 'board_contact_board_column', id: string, board_id: string, name: string, position: number, type?: Board_Column_Type_Enum | null, contact_board_entries: Array<{ __typename?: 'board_contact_board_entry', id: string, score: number, column_id: string, board_id: string, position?: number | null, contact?: { __typename?: 'contact', id: string, first_name: string, last_name: string, phone_number: string, converted_at?: string | null, email_address: string, campaign_id: string, qa_source?: Qa_Source_Enum | null, cv_id?: string | null, routing_location_id?: number | null, utm_source?: Ad_Platform_Enum | null, answers: Array<{ __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, field_name: string, title: string, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }> } }>, origin_campaign?: { __typename?: 'campaign', id: string, name: string } | null } | null, forward_log?: { __typename?: 'rms_forwarded_logs', success: boolean } | null }>, contact_board_entries_aggregate: { __typename?: 'board_contact_board_entry_aggregate', aggregate?: { __typename?: 'board_contact_board_entry_aggregate_fields', count: number } | null } };

export type UpsertContactBoardColumnsMutationVariables = Exact<{
  columns: Array<Board_Contact_Board_Column_Insert_Input> | Board_Contact_Board_Column_Insert_Input;
}>;


export type UpsertContactBoardColumnsMutation = { __typename?: 'mutation_root', insert_board_contact_board_column?: { __typename?: 'board_contact_board_column_mutation_response', returning: Array<{ __typename?: 'board_contact_board_column', id: string, board_id: string, name: string, position: number, type?: Board_Column_Type_Enum | null }> } | null };

export type GetContactLogsQueryVariables = Exact<{
  contact_id: Scalars['uuid']['input'];
}>;


export type GetContactLogsQuery = { __typename?: 'query_root', contact_logs: Array<{ __typename?: 'contact_logs', id: number, contact_id?: string | null, campaign_id?: string | null, created_at: any, qualified_at?: any | null, bot_started_at?: any | null, bot_ended_at?: any | null, report_generated_at?: any | null, rms_forwarded_at?: any | null, error?: any | null, payload: any }> };

export type ContactBoardEntryFragment = { __typename?: 'board_contact_board_entry', id: string, score: number, column_id: string, board_id: string, position?: number | null, contact?: { __typename?: 'contact', id: string, first_name: string, last_name: string, phone_number: string, converted_at?: string | null, email_address: string, campaign_id: string, qa_source?: Qa_Source_Enum | null, cv_id?: string | null, routing_location_id?: number | null, utm_source?: Ad_Platform_Enum | null, answers: Array<{ __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, field_name: string, title: string, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }> } }>, origin_campaign?: { __typename?: 'campaign', id: string, name: string } | null } | null, forward_log?: { __typename?: 'rms_forwarded_logs', success: boolean } | null };

export type UpdateContactBoardEntryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  column_id: Scalars['uuid']['input'];
  position: Scalars['Int']['input'];
}>;


export type UpdateContactBoardEntryMutation = { __typename?: 'mutation_root', update_board_contact_board_entry_by_pk?: { __typename?: 'board_contact_board_entry', id: string, score: number, column_id: string, board_id: string, position?: number | null, contact?: { __typename?: 'contact', id: string, first_name: string, last_name: string, phone_number: string, converted_at?: string | null, email_address: string, campaign_id: string, qa_source?: Qa_Source_Enum | null, cv_id?: string | null, routing_location_id?: number | null, utm_source?: Ad_Platform_Enum | null, answers: Array<{ __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, field_name: string, title: string, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }> } }>, origin_campaign?: { __typename?: 'campaign', id: string, name: string } | null } | null, forward_log?: { __typename?: 'rms_forwarded_logs', success: boolean } | null } | null };

export type UpsertContactBoardEntriesMutationMutationVariables = Exact<{
  objects: Array<Board_Contact_Board_Entry_Insert_Input> | Board_Contact_Board_Entry_Insert_Input;
}>;


export type UpsertContactBoardEntriesMutationMutation = { __typename?: 'mutation_root', insert_board_contact_board_entry?: { __typename?: 'board_contact_board_entry_mutation_response', returning: Array<{ __typename?: 'board_contact_board_entry', id: string, score: number, column_id: string, board_id: string, position?: number | null, contact?: { __typename?: 'contact', id: string, first_name: string, last_name: string, phone_number: string, converted_at?: string | null, email_address: string, campaign_id: string, qa_source?: Qa_Source_Enum | null, cv_id?: string | null, routing_location_id?: number | null, utm_source?: Ad_Platform_Enum | null, answers: Array<{ __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, field_name: string, title: string, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }> } }>, origin_campaign?: { __typename?: 'campaign', id: string, name: string } | null } | null, forward_log?: { __typename?: 'rms_forwarded_logs', success: boolean } | null }> } | null };

export type GetApplicantExportDataQueryVariables = Exact<{
  campaign_id: Scalars['uuid']['input'];
}>;


export type GetApplicantExportDataQuery = { __typename?: 'query_root', contact: Array<{ __typename?: 'contact', id: string, first_name: string, last_name: string, qualified: boolean, converted_at?: string | null, email_address: string, phone_number: string, routing_location_id?: number | null, origin_campaign?: { __typename?: 'campaign', id: string, name: string } | null, answers: Array<{ __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, title: string } }> }>, campaign_by_pk?: { __typename?: 'campaign', id: string, organization: { __typename?: 'organization', id: string }, routing_info?: { __typename?: 'campaign_routing_info', location_id?: number | null } | null, questions: Array<{ __typename?: 'funnel_question', id: string, title: string }> } | null };

export type ApplicantExportQuestionFragment = { __typename?: 'funnel_question', id: string, title: string };

export type ApplicantExportDataFragment = { __typename?: 'contact', id: string, first_name: string, last_name: string, qualified: boolean, converted_at?: string | null, email_address: string, phone_number: string, routing_location_id?: number | null, origin_campaign?: { __typename?: 'campaign', id: string, name: string } | null, answers: Array<{ __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, title: string } }> };

export type DeleteNoteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteNoteMutation = { __typename?: 'mutation_root', delete_board_note_by_pk?: { __typename?: 'board_note', id: string } | null };

export type GetNotesQueryVariables = Exact<{
  contact_id: Scalars['uuid']['input'];
}>;


export type GetNotesQuery = { __typename?: 'query_root', board_note: Array<{ __typename?: 'board_note', created_at: string, author_id: string, content: string, id: string, contact_board_entry_id?: string | null }> };

export type InsertNoteMutationVariables = Exact<{
  input: Board_Note_Insert_Input;
}>;


export type InsertNoteMutation = { __typename?: 'mutation_root', insert_board_note_one?: { __typename?: 'board_note', created_at: string, author_id: string, content: string, id: string, contact_board_entry_id?: string | null } | null };

export type UpdateNoteContentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  content: Scalars['String']['input'];
}>;


export type UpdateNoteContentMutation = { __typename?: 'mutation_root', update_board_note_by_pk?: { __typename?: 'board_note', created_at: string, author_id: string, content: string, id: string, contact_board_entry_id?: string | null } | null };

export type GetAvgCtrQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvgCtrQuery = { __typename?: 'query_root', funnel_insights_aggregate: { __typename?: 'funnel_insights_aggregate', aggregate?: { __typename?: 'funnel_insights_aggregate_fields', avg?: { __typename?: 'funnel_insights_avg_fields', click_through_rate?: number | null } | null } | null } };

export type GetContactsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactsCountQuery = { __typename?: 'query_root', contact_aggregate: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null } };

export type SumBudgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type SumBudgetsQuery = { __typename?: 'query_root', campaign_budget_aggregate: { __typename?: 'campaign_budget_aggregate', aggregate?: { __typename?: 'campaign_budget_aggregate_fields', sum?: { __typename?: 'campaign_budget_sum_fields', amount?: any | null } | null } | null } };

export type GetLatestContactsQueryVariables = Exact<{
  results: Scalars['Int']['input'];
}>;


export type GetLatestContactsQuery = { __typename?: 'query_root', contact: Array<{ __typename?: 'contact', id: string, converted_at?: string | null, first_name: string, last_name: string, qualified: boolean, email_address: string, phone_number: string, routing_location_id?: number | null, campaign: { __typename?: 'campaign', id: string, name: string, location?: { __typename?: 'organization_location', slug: string, organization_id: string, name: string, region_slug: string } | null } }> };

export type ContactsPerDayFragment = { __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null };

export type GetOrganizationContactsBetweenDatesQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  previousStartDate: Scalars['String']['input'];
  previousEndDate: Scalars['String']['input'];
}>;


export type GetOrganizationContactsBetweenDatesQuery = { __typename?: 'query_root', lastWeekContacts: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null }>, lastWeekTotalContacts: { __typename?: 'new_contacts_per_day_aggregate', aggregate?: { __typename?: 'new_contacts_per_day_aggregate_fields', sum?: { __typename?: 'new_contacts_per_day_sum_fields', new_contacts?: any | null } | null } | null }, previousWeekTotalContacts: { __typename?: 'new_contacts_per_day_aggregate', aggregate?: { __typename?: 'new_contacts_per_day_aggregate_fields', sum?: { __typename?: 'new_contacts_per_day_sum_fields', new_contacts?: any | null } | null } | null }, qualifiedCount: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, unqualifiedCount: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null } };

export type CampaignMetaFragment = { __typename?: 'campaign', id: string, name: string, location?: { __typename?: 'organization_location', slug: string, organization_id: string, name: string, region_slug: string } | null, contacts_aggregate: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null } };

export type GetRankedNumberOfContactsPerCampaignQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRankedNumberOfContactsPerCampaignQuery = { __typename?: 'query_root', campaign: Array<{ __typename?: 'campaign', id: string, name: string, location?: { __typename?: 'organization_location', slug: string, organization_id: string, name: string, region_slug: string } | null, contacts_aggregate: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null } }> };

export type GetRankedPerformingLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRankedPerformingLocationsQuery = { __typename?: 'query_root', organization_location: Array<{ __typename?: 'organization_location', organization_id: string, slug: string, name: string, parent_region?: { __typename?: 'organization_region', name: string, slug: string, organization_id: string } | null, campaigns: Array<{ __typename?: 'campaign', id: string, name: string, contacts_aggregate: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null } }> }> };

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = { __typename?: 'query_root', organization_location: Array<{ __typename?: 'organization_location', slug: string, name: string, organization_id: string, campaign_count: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } }> };

export type GetAllRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRegionsQuery = { __typename?: 'query_root', organization_region: Array<{ __typename?: 'organization_region', name: string, slug: string, organization_id: string, locations: Array<{ __typename?: 'organization_location', slug: string, name: string, organization_id: string, campaign_count: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } }> }> };

export type AdCommentFragment = { __typename?: 'ad_comment', id: string, text: string, user_id: string, setting_reference?: Ad_Setting_Enum | null };

export type AnswerFragment = { __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, field_name: string, title: string, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }> } };

export type AnswerOptionFragment = { __typename?: 'funnel_question', options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }> };

export type CampaignFunnelFragment = { __typename?: 'funnel_funnels', id: string, enabled: boolean, campaign_id?: string | null, job_caption?: string | null, job_intro?: string | null, job_byline?: string | null, expectations_items: any, expectations_intro?: string | null, img_1_id?: string | null, img_1_2_id?: string | null, img_1_3_id?: string | null, img_1_4_id?: string | null, img_2_id?: string | null, img_2_2_id?: string | null, img_2_3_id?: string | null, img_2_4_id?: string | null, img_3_id?: string | null, img_3_2_id?: string | null, img_3_3_id?: string | null, img_3_4_id?: string | null, logo_id?: string | null, video_1_id?: string | null, video_2_id?: string | null, video_3_id?: string | null, benefit_icon_id?: string | null, expectation_icon_id?: string | null, company_privacy_policy_url?: string | null, company_privacy_policy_title?: string | null, bot_consent_enabled: boolean, chatbot_funnel_enabled: boolean, whatsapp_apply_label?: string | null, whatsapp_apply_message_template?: string | null, whatsapp_intro_message?: string | null, whatsapp_outro_message?: string | null, whatsapp_share_caption?: string | null, whatsapp_share_title?: string | null, whatsapp_share_label?: string | null, header_color?: string | null, we_are_intro?: string | null, we_are_byline?: string | null, we_are_copy?: string | null, we_are_call_to_action?: string | null, call_to_action?: string | null, sub_call_to_action?: string | null, formality_type: string, locale: string, theme_color?: string | null, benefits_intro?: string | null, template: string, next_steps: any, slug: string, highlights: string, cv_required?: boolean | null, location_question_country_enabled: boolean, location_question_city_enabled: boolean, location_question_street_enabled: boolean, location_question_postalcode_enabled: boolean, contact_question_birthdate_enabled: boolean, contact_question_form_of_address_enabled: boolean, cv_question_enabled: boolean, benefits: Array<{ __typename?: 'funnel_benefits', description: string, title: string, id: string }>, questions: Array<{ __typename?: 'funnel_question', title: string, question_type: string, position?: number | null, parent_question_id?: string | null, is_required: boolean, archived: boolean, uuid: string, options: Array<{ __typename?: 'funnel_question_option', icon?: string | null, id: string, title: string, value?: string | null, isKnockout: boolean, redirect_question_id?: string | null, redirect_behavior: string }>, child_questions: Array<{ __typename?: 'funnel_question', icon?: string | null, id: string, position?: number | null, title: string, is_required: boolean, question_type: string, parent_question_id?: string | null, archived: boolean, options: Array<{ __typename?: 'funnel_question_option', title: string }> }> }>, campaign?: { __typename?: 'campaign', status?: string | null, is_hidden: boolean, short_id: string } | null };

export type CampaignSettingsOverrideFragment = { __typename?: 'campaign_settings_override', campaign_id: string, logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum };

export type ContactFragment = { __typename?: 'contact', id: string, first_name: string, last_name: string, phone_number: string, converted_at?: string | null, email_address: string, campaign_id: string, qa_source?: Qa_Source_Enum | null, cv_id?: string | null, routing_location_id?: number | null, utm_source?: Ad_Platform_Enum | null, answers: Array<{ __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, field_name: string, title: string, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }> } }>, origin_campaign?: { __typename?: 'campaign', id: string, name: string } | null };

export type NoteFragment = { __typename?: 'board_note', created_at: string, author_id: string, content: string, id: string, contact_board_entry_id?: string | null };

export type GetFunnelChatbotMessagesQueryVariables = Exact<{
  contact_id: Scalars['uuid']['input'];
  campaign_id: Scalars['uuid']['input'];
}>;


export type GetFunnelChatbotMessagesQuery = { __typename?: 'query_root', funnel_chatbot_message: Array<{ __typename?: 'funnel_chatbot_message', id: string, direction: string, body: string, created_at: string }> };

export type GetCampaignLeadsInTimespanQueryVariables = Exact<{
  startDate: Scalars['timestamptz']['input'];
  endDate: Scalars['timestamptz']['input'];
  startDateString: Scalars['String']['input'];
  endDateString: Scalars['String']['input'];
}>;


export type GetCampaignLeadsInTimespanQuery = { __typename?: 'query_root', campaign: Array<{ __typename?: 'campaign', id: string, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }> }> };

export type DropdownCampaignInfoFragment = { __typename?: 'campaign', start?: string | null, end?: string | null, name: string, id: string, organization: { __typename?: 'organization', name: string } };

export type GetDropdownCampaignInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDropdownCampaignInfoQuery = { __typename?: 'query_root', campaign: Array<{ __typename?: 'campaign', start?: string | null, end?: string | null, name: string, id: string, organization: { __typename?: 'organization', name: string } }> };

export type GetInsightCampaignsInTimespanQueryVariables = Exact<{
  endDate: Scalars['timestamptz']['input'];
}>;


export type GetInsightCampaignsInTimespanQuery = { __typename?: 'query_root', newLeads: { __typename?: 'new_contacts_per_day_aggregate', aggregate?: { __typename?: 'new_contacts_per_day_aggregate_fields', sum?: { __typename?: 'new_contacts_per_day_sum_fields', new_contacts?: any | null } | null } | null }, completedCampaigns: Array<{ __typename?: 'campaign', id: string }>, campaign: Array<{ __typename?: 'campaign', id: string, start?: string | null, name: string, end?: string | null, organization: { __typename?: 'organization', name: string }, contacts_aggregate: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null }> }> };

export type GetSelectedCampaignsQueryVariables = Exact<{
  selectedCampaignIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  hasAdvancedAccessToCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  canSeeInternalInsights: Scalars['Boolean']['input'];
  canSeeDetails?: Scalars['Boolean']['input'];
  hasAdvancedAccessToCampaignsOrCanSeeInternalInsights?: Scalars['Boolean']['input'];
}>;


export type GetSelectedCampaignsQuery = { __typename?: 'query_root', selectedCampaigns: Array<{ __typename?: 'campaign', id: string, name: string, category?: string | null, start?: string | null, end?: string | null, customer_budget_initial?: any | null, customer_budget_total?: any | null, customer_budget_bonus?: any | null, remaining_customer_budget?: any | null, margin_in_percent?: any, media_budget?: any | null, work_location?: Campaign_Work_Location_Enum | null, status?: string | null, location_slug?: string | null, daily_budget: any, pdf_enabled?: boolean | null, monday_url?: string | null, meistertask_url?: string | null, organization_id?: string, perspective_campaign_id?: string | null, is_test: boolean, daily_media_budget?: any | null, applicants_email_list?: Array<string>, ads_email_list?: Array<string>, support_email?: string | null, is_hidden: boolean, chat_bot_is_ko: boolean, chat_bot_enabled: boolean, chat_bot_v2_enabled: boolean, job_posting_text?: string | null, phone_number_default_region: Campaign_Iso_2_Country_Codes_Enum, short_id: string, responsible_person?: string | null, applicant_board_enabled: boolean, forwarding?: { __typename?: 'chat_bot_forwarding', webhook_url?: string | null } | null, organization: { __typename?: 'organization', name: string, id: string }, qualified_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, total_lead_count: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, qualified_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, total_leads: Array<{ __typename?: 'contact', utm_source?: Ad_Platform_Enum | null }>, funnel_insights?: { __typename?: 'funnel_insights', click_through_rate?: any | null } | null, perspective_campaign?: { __typename?: 'perspective_campaign', id: string, url: string } | null, call_campaign: Array<{ __typename?: 'anna_ai_call_campaigns', id: string, enabled: boolean }>, c_location?: { __typename?: 'organization_location', organization_id: string, slug: string, name: string, parent_region?: { __typename?: 'organization_region', organization_id: string, slug: string, name: string } | null } | null, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null, utm_source?: string | null }>, ad_campaign_metrics: Array<{ __typename?: 'ad_campaign_metrics', platform_specific_id: string, clicks: number, impressions: number, spend?: any, reach?: number | null, cpc?: string | null, status: string, platform: Ad_Platform_Enum }>, routing_info?: { __typename?: 'campaign_routing_info', type: string, forwarding_webhook: string, location_id?: number | null, office_id?: string | null } | null, org_settings_override?: { __typename?: 'campaign_settings_override', logo_url?: string | null, short_name?: string | null, name_prefix: Organization_Name_Prefix_Enum } | null }> };

export type InsightCampaignFragment = { __typename?: 'campaign', id: string, start?: string | null, name: string, end?: string | null, organization: { __typename?: 'organization', name: string }, contacts_aggregate: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null }, contacts_per_day: Array<{ __typename?: 'new_contacts_per_day', date?: string | null, new_contacts?: any | null }> };

export type UpsertOrganizationMutationVariables = Exact<{
  org: Organization_Insert_Input;
  settings: Organization_Settings_Insert_Input;
}>;


export type UpsertOrganizationMutation = { __typename?: 'mutation_root', insert_organization_one?: { __typename?: 'organization', name: string, id: string, active: boolean, name_prefix?: Organization_Name_Prefix_Enum | null, is_partner: boolean, partner_organization_id?: string | null, short_name?: string | null, logo_url?: string | null, country?: string | null, campaigns_aggregate: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, settings?: { __typename?: 'organization_settings', address_formally: boolean, organization_id: string, notification_emails_enabled: boolean, welcome_emails_enabled: boolean, rejection_emails_enabled: boolean } | null } | null, insert_organization_settings_one?: { __typename?: 'organization_settings', organization_id: string, welcome_emails_enabled: boolean, rejection_emails_enabled: boolean, address_formally: boolean } | null };

export type UpsertOrganizationSettingMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  input?: InputMaybe<Organization_Settings_Set_Input>;
}>;


export type UpsertOrganizationSettingMutation = { __typename?: 'mutation_root', update_organization_settings_by_pk?: { __typename?: 'organization_settings', address_formally: boolean, organization_id: string } | null };

export type InsertCommentMutationVariables = Exact<{
  creative_id: Scalars['uuid']['input'];
  text: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
  setting_reference: Ad_Setting_Enum;
}>;


export type InsertCommentMutation = { __typename?: 'mutation_root', insert_ad_comment_one?: { __typename?: 'ad_comment', id: string, text: string, user_id: string, setting_reference?: Ad_Setting_Enum | null } | null };

export type UpsertCommentsMutationVariables = Exact<{
  objects: Array<Ad_Comment_Insert_Input> | Ad_Comment_Insert_Input;
}>;


export type UpsertCommentsMutation = { __typename?: 'mutation_root', insert_ad_comment?: { __typename?: 'ad_comment_mutation_response', affected_rows: number } | null };

export type PartnerOrganizationFragment = { __typename?: 'organization', id: string, name: string };

export type GetAllPartnerOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPartnerOrganizationsQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', id: string, name: string }> };

export type GetOrganizationByIdQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  canSeeInternalInsights?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrganizationByIdQuery = { __typename?: 'query_root', organization_by_pk?: { __typename?: 'organization', name: string, id: string, active: boolean, name_prefix?: Organization_Name_Prefix_Enum | null, is_partner: boolean, partner_organization_id?: string | null, short_name?: string | null, logo_url?: string | null, country?: string | null, budget_from_transactions?: { __typename?: 'organization_budget', spend?: any | null, bonus?: any | null, media_budget?: any | null, total_budget?: any | null } | null, campaigns_aggregate: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, settings?: { __typename?: 'organization_settings', address_formally: boolean, organization_id: string, notification_emails_enabled: boolean, welcome_emails_enabled: boolean, rejection_emails_enabled: boolean } | null } | null };

export type GetOrganizationIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationIdsQuery = { __typename?: 'query_root', ids: Array<{ __typename?: 'organization', id: string }> };

export type GetOrganizationWithLeadAndCampaignAggregateQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetOrganizationWithLeadAndCampaignAggregateQuery = { __typename?: 'query_root', organization_by_pk?: { __typename?: 'organization', name: string, id: string, active: boolean, name_prefix?: Organization_Name_Prefix_Enum | null, is_partner: boolean, partner_organization_id?: string | null, short_name?: string | null, logo_url?: string | null, country?: string | null, active_campaigns: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, leads: { __typename?: 'campaign_aggregate', nodes: Array<{ __typename?: 'campaign', contacts_aggregate: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null } }> }, campaigns_aggregate: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, settings?: { __typename?: 'organization_settings', address_formally: boolean, organization_id: string, notification_emails_enabled: boolean, welcome_emails_enabled: boolean, rejection_emails_enabled: boolean } | null } | null };

export type GetRecentNewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentNewsQuery = { __typename?: 'query_root', organization_news: Array<{ __typename?: 'organization_news', id: string, description?: string | null }> };

export type NewsFragment = { __typename?: 'organization_news', id: string, description?: string | null };

export type OrganizationDesignationFragment = { __typename?: 'organization', id: string, name_prefix?: Organization_Name_Prefix_Enum | null, short_name?: string | null, name: string };

export type OrganizationWithBudgetFragment = { __typename?: 'organization', name: string, id: string, active: boolean, name_prefix?: Organization_Name_Prefix_Enum | null, is_partner: boolean, partner_organization_id?: string | null, short_name?: string | null, logo_url?: string | null, country?: string | null, budget_from_transactions?: { __typename?: 'organization_budget', spend?: any | null, bonus?: any | null, media_budget?: any | null, total_budget?: any | null } | null, campaigns_aggregate: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, settings?: { __typename?: 'organization_settings', address_formally: boolean, organization_id: string, notification_emails_enabled: boolean, welcome_emails_enabled: boolean, rejection_emails_enabled: boolean } | null };

export type OrganizationWithLeadAndCampaignAggregateFragment = { __typename?: 'organization', name: string, id: string, active: boolean, name_prefix?: Organization_Name_Prefix_Enum | null, is_partner: boolean, partner_organization_id?: string | null, short_name?: string | null, logo_url?: string | null, country?: string | null, active_campaigns: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, leads: { __typename?: 'campaign_aggregate', nodes: Array<{ __typename?: 'campaign', contacts_aggregate: { __typename?: 'contact_aggregate', aggregate?: { __typename?: 'contact_aggregate_fields', count: number } | null } }> }, campaigns_aggregate: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null }, settings?: { __typename?: 'organization_settings', address_formally: boolean, organization_id: string, notification_emails_enabled: boolean, welcome_emails_enabled: boolean, rejection_emails_enabled: boolean } | null };

export type DeleteLocationMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'mutation_root', delete_organization_location_by_pk?: { __typename?: 'organization_location', organization_id: string, slug: string } | null };

export type DeleteRegionMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type DeleteRegionMutation = { __typename?: 'mutation_root', delete_organization_region_by_pk?: { __typename?: 'organization_region', slug: string, organization_id: string } | null };

export type GetRegionsQueryVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;


export type GetRegionsQuery = { __typename?: 'query_root', regions: Array<{ __typename?: 'organization_region', name: string, slug: string, organization_id: string, locations: Array<{ __typename?: 'organization_location', slug: string, name: string, organization_id: string, campaign_count: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } }> }> };

export type InsertLocationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  regionSlug: Scalars['String']['input'];
}>;


export type InsertLocationMutation = { __typename?: 'mutation_root', location?: { __typename?: 'organization_location', slug: string, name: string, organization_id: string, campaign_count: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } } | null };

export type InsertRegionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type InsertRegionMutation = { __typename?: 'mutation_root', region?: { __typename?: 'organization_region', organization_id: string, name: string, slug: string, locations: Array<{ __typename?: 'organization_location', slug: string, name: string, organization_id: string, campaign_count: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } }> } | null };

export type LocationFragment = { __typename?: 'organization_location', slug: string, name: string, organization_id: string, campaign_count: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } };

export type RegionFragment = { __typename?: 'organization_region', name: string, slug: string, organization_id: string, locations: Array<{ __typename?: 'organization_location', slug: string, name: string, organization_id: string, campaign_count: { __typename?: 'campaign_aggregate', aggregate?: { __typename?: 'campaign_aggregate_fields', count: number } | null } }> };

export type GetContactAvailabilityByIdQueryVariables = Exact<{
  contact_id: Scalars['uuid']['input'];
}>;


export type GetContactAvailabilityByIdQuery = { __typename?: 'query_root', chat_bot_v1_answer: Array<{ __typename?: 'chat_bot_messages', data: any }>, chat_bot_v2_answer: Array<{ __typename?: 'bot_conversation', messages: Array<{ __typename?: 'bot_message', text: string }> }>, funnel_answer?: { __typename?: 'contact', answers: Array<{ __typename?: 'answer', value?: string | null }> } | null };

export type GetContactByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetContactByIdQuery = { __typename?: 'query_root', contact_by_pk?: { __typename?: 'contact', id: string, first_name: string, last_name: string, phone_number: string, converted_at?: string | null, email_address: string, campaign_id: string, qa_source?: Qa_Source_Enum | null, cv_id?: string | null, routing_location_id?: number | null, utm_source?: Ad_Platform_Enum | null, answers: Array<{ __typename?: 'answer', id: string, value?: string | null, question: { __typename?: 'funnel_question', id: string, field_name: string, title: string, options: Array<{ __typename?: 'funnel_question_option', title: string, isKnockout: boolean }> } }>, origin_campaign?: { __typename?: 'campaign', id: string, name: string } | null } | null };

export type GetCommentsByCreativeIdQueryVariables = Exact<{
  creative_id: Scalars['uuid']['input'];
}>;


export type GetCommentsByCreativeIdQuery = { __typename?: 'query_root', ad_comment: Array<{ __typename?: 'ad_comment', id: string, text: string, user_id: string, setting_reference?: Ad_Setting_Enum | null }> };

export type GetCommentsByCreativeIdAndSettingsReferenceQueryVariables = Exact<{
  creative_id: Scalars['uuid']['input'];
  setting_reference: Ad_Setting_Enum;
}>;


export type GetCommentsByCreativeIdAndSettingsReferenceQuery = { __typename?: 'query_root', ad_comment: Array<{ __typename?: 'ad_comment', id: string, text: string, user_id: string, setting_reference?: Ad_Setting_Enum | null }> };

export type GetRmsConnectorQueryVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
}>;


export type GetRmsConnectorQuery = { __typename?: 'query_root', rms_connectors: Array<{ __typename?: 'rms_connectors', id: string, enabled: boolean, webhook?: string | null, job_id?: string | null, custom_mappings?: any | null }> };

export type GetRmsOrgSetupRmsTypeQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetRmsOrgSetupRmsTypeQuery = { __typename?: 'query_root', rms_org_setups: Array<{ __typename?: 'rms_org_setups', rms_type: string }> };

export type RmsConnectorFragment = { __typename?: 'rms_connectors', id: string, enabled: boolean, webhook?: string | null, job_id?: string | null, custom_mappings?: any | null };

export type UpsertRmsConnectorMutationVariables = Exact<{
  campaignId: Scalars['uuid']['input'];
  enabled: Scalars['Boolean']['input'];
  webhook?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  customMappings?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpsertRmsConnectorMutation = { __typename?: 'mutation_root', insert_rms_connectors_one?: { __typename?: 'rms_connectors', id: string, enabled: boolean, webhook?: string | null, job_id?: string | null, custom_mappings?: any | null } | null };

export const ContactMetaFragmentDoc = gql`
    fragment contactMeta on contact {
  id
  converted_at
  first_name
  last_name
  qualified
  email_address
  phone_number
  campaign {
    id
    name
    location: c_location {
      slug
      organization_id
      name
      region_slug
    }
  }
  routing_location_id
}
    `;
export const LocationFragmentDoc = gql`
    fragment Location on organization_location {
  slug
  name
  organization_id
  campaign_count: campaigns_aggregate {
    aggregate {
      count
    }
  }
}
    `;
export const RegionFragmentDoc = gql`
    fragment Region on organization_region {
  name
  slug
  organization_id
  locations {
    ...Location
  }
}
    `;
export const ImpersonationFragmentDoc = gql`
    fragment Impersonation on organization {
  id
  name
  regions {
    ...Region
  }
}
    `;
export const NewContactsPerDayFragmentDoc = gql`
    fragment NewContactsPerDay on new_contacts_per_day {
  date
  new_contacts
  utm_source
}
    `;
export const InsertCampaignFragmentDoc = gql`
    fragment InsertCampaign on campaign {
  id
  short_id
  name
  category
  start
  end
  location
  work_location
  pdf_enabled
  forwarding {
    webhook_url
  }
  organization {
    id
    name
  }
  qualified_lead_count: contacts_aggregate(where: {qualified: {_eq: true}}) {
    aggregate {
      count
    }
  }
  total_lead_count: contacts_aggregate {
    aggregate {
      count
    }
  }
  funnel_insights {
    click_through_rate
  }
  perspective_campaign {
    id
    url
  }
  contacts_per_day(order_by: {date: asc}) {
    ...NewContactsPerDay
  }
  ad_campaign_metrics {
    impressions
    spend @include(if: $isAdmin)
    reach
  }
  monday_url
  organization_id
  perspective_campaign_id
  is_test
  media_budget @include(if: $isAdmin)
  daily_media_budget @include(if: $isAdmin)
  applicants_email_list
  ads_email_list
  routing_info {
    campaign_id
    forwarding_webhook
    location_id
    office_id
    type
  }
}
    `;
export const AdCampaignFragmentDoc = gql`
    fragment AdCampaign on ad_campaign_metrics {
  id
  created_at
  platform
  platform_specific_id
  name
}
    `;
export const CampaignContactsPerDayFragmentDoc = gql`
    fragment CampaignContactsPerDay on campaign {
  total_leads: contacts(where: {utm_source: {_is_null: false}}) {
    utm_source
  }
  qualified_leads: contacts(
    where: {qualified: {_eq: true}, utm_source: {_is_null: false}}
  ) {
    utm_source
  }
}
    `;
export const CampaignEmailOverwriteFragmentDoc = gql`
    fragment CampaignEmailOverwrite on campaign_email_template_overwrite {
  campaign_id
  rejection
  welcome
}
    `;
export const CampaignFunnelAnalyticsFragmentDoc = gql`
    fragment CampaignFunnelAnalytics on campaign {
  funnel_insights {
    click_through_rate
    sessions
  }
  funnel_whatsapp_share_clicks_aggregate {
    aggregate {
      count
    }
  }
  funnel_page_insights {
    index
    visitors
    name
    question {
      title
    }
  }
}
    `;
export const CampaignKpisFragmentDoc = gql`
    fragment CampaignKpis on campaign {
  customer_budget_initial
  customer_budget_bonus
  customer_budget_total
  remaining_customer_budget
  margin_in_percent @include(if: $hasAdvancedAccessToCampaignsOrCanSeeInternalInsights)
  media_budget @include(if: $hasAdvancedAccessToCampaignsOrCanSeeInternalInsights)
  ad_campaign_metrics {
    platform_specific_id
    platform
    impressions
    reach
    clicks
    spend @include(if: $canSeeInternalInsights)
    cpc @include(if: $canSeeInternalInsights)
  }
}
    `;
export const MinifiedCampaignFragmentDoc = gql`
    fragment MinifiedCampaign on campaign {
  id
  name
  status
  is_test
  is_hidden
  organization {
    id
    name
    short_name
    name_prefix
    rms_org_setup {
      rms_type
    }
    settings {
      organization_id
      address_formally
      rejection_emails_enabled
      notification_emails_enabled
      welcome_emails_enabled
    }
  }
  org_settings_override {
    logo_url
    short_name
    name_prefix
  }
  applicant_board_enabled
  c_location {
    slug
    name
    organization_id
    parent_region {
      slug
      name
      organization_id
    }
  }
  start
  end
  daily_budget
  remaining_customer_budget
  customer_budget_total
  short_id
  responsible_person
  chat_bot_enabled
  chat_bot_v2_enabled
  work_location
  monday_url
  perspective_campaign {
    id
    url
  }
  funnel {
    campaign_id
    slug
    chatbot_funnel_enabled
  }
  call_campaign {
    id
    enabled
  }
  total_lead_count: origin_contacts_aggregate {
    aggregate {
      count
    }
  }
  qualified_lead_count: origin_contacts_aggregate(where: {qualified: {_eq: true}}) {
    aggregate {
      count
    }
  }
  ad_campaign_metrics {
    platform
  }
  contacts_per_day(order_by: {date: asc}) {
    ...NewContactsPerDay
  }
}
    `;
export const CreativeFeedbackFragmentDoc = gql`
    fragment CreativeFeedback on ad_creative_feedback {
  created_at
  id
  text
}
    `;
export const CreativesHistoryItemFragmentDoc = gql`
    fragment CreativesHistoryItem on ad_creative {
  id
  creative_upload_id
  created_at
  benefits
  mime_type
  funnel_url
  feedback(order_by: {created_at: asc}) {
    ...CreativeFeedback
  }
}
    `;
export const AdCreativeFragmentDoc = gql`
    fragment AdCreative on ad_creative {
  id
  benefits
  funnel_url
  call_to_action_text_color_hex
  call_to_action
  call_to_action_background_color_hex
  headline_text_color_hex
  headline
  headline_background_color_hex
  mime_type
  creative_upload_id
  feedback {
    ...CreativeFeedback
  }
}
    `;
export const AdFragmentDoc = gql`
    fragment Ad on campaign_ad {
  id
  campaign_id
  creative {
    ...AdCreative
  }
  status
  platform
}
    `;
export const PlatformTrafficMetricsFragmentDoc = gql`
    fragment PlatformTrafficMetrics on ad_platform {
  value
  campaign_metrics_aggregate {
    aggregate {
      sum {
        conversions
      }
    }
  }
}
    `;
export const CampaignBudgetTransactionFragmentDoc = gql`
    fragment CampaignBudgetTransaction on campaign_budget_transaction {
  amount
  created_at
  type
  id
  campaign {
    id
    margin_in_percent
  }
}
    `;
export const QuestionFragmentDoc = gql`
    fragment Question on funnel_question {
  id
  field_name
  title
  question_type
  options {
    title
    isKnockout
  }
  answers(where: {contact: {origin_campaign_id: {_eq: $campaign_id}}}) {
    value
  }
  answer_categories: answers(
    distinct_on: value
    where: {contact: {origin_campaign_id: {_eq: $campaign_id}}}
  ) {
    value
  }
  answers_aggregate(where: {contact: {origin_campaign_id: {_eq: $campaign_id}}}) {
    aggregate {
      count
    }
  }
}
    `;
export const InsightsQuestionFragmentDoc = gql`
    fragment InsightsQuestion on funnel_question {
  ...Question
  total_answer_count: answers_aggregate(
    distinct_on: [contact_id]
    where: {contact: {origin_campaign_id: {_eq: $campaign_id}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const OrganizationDesignationFragmentDoc = gql`
    fragment OrganizationDesignation on organization {
  id
  name_prefix
  short_name
  name
}
    `;
export const UnqualifiedContactsPerDayFragmentDoc = gql`
    fragment UnqualifiedContactsPerDay on new_unqualified_contacts_per_day {
  date
  new_unqualified_contacts
  utm_source
}
    `;
export const CampaignFragmentDoc = gql`
    fragment Campaign on campaign {
  id
  name
  category
  start
  end
  customer_budget_initial
  customer_budget_total
  customer_budget_bonus
  remaining_customer_budget
  margin_in_percent @include(if: $hasAdvancedAccessToCampaignsOrCanSeeInternalInsights)
  media_budget @include(if: $hasAdvancedAccessToCampaignsOrCanSeeInternalInsights)
  work_location
  status
  location_slug
  daily_budget
  pdf_enabled
  forwarding {
    webhook_url
  }
  organization {
    name
    id
  }
  qualified_lead_count: contacts_aggregate(where: {qualified: {_eq: true}}) {
    aggregate {
      count
    }
  }
  total_lead_count: contacts_aggregate {
    aggregate {
      count
    }
  }
  qualified_leads: contacts(
    where: {qualified: {_eq: true}, utm_source: {_is_null: false}}
  ) {
    utm_source
  }
  total_leads: contacts(where: {utm_source: {_is_null: false}}) {
    utm_source
  }
  funnel_insights {
    click_through_rate
  }
  perspective_campaign {
    id
    url
  }
  call_campaign {
    id
    enabled
  }
  c_location {
    organization_id
    slug
    name
    parent_region {
      organization_id
      slug
      name
    }
  }
  contacts_per_day(order_by: {date: asc}) {
    ...NewContactsPerDay
  }
  ad_campaign_metrics {
    platform_specific_id
    clicks
    impressions
    spend @include(if: $canSeeInternalInsights)
    reach
    cpc @include(if: $canSeeInternalInsights)
    status
    platform
  }
  monday_url @include(if: $hasAdvancedAccessToCampaigns)
  meistertask_url
  organization_id @include(if: $hasAdvancedAccessToCampaigns)
  perspective_campaign_id @include(if: $hasAdvancedAccessToCampaigns)
  is_test
  media_budget @include(if: $canSeeInternalInsights)
  daily_media_budget @include(if: $hasAdvancedAccessToCampaigns)
  applicants_email_list @include(if: $hasAdvancedAccessToCampaigns)
  ads_email_list @include(if: $hasAdvancedAccessToCampaigns)
  support_email
  routing_info @include(if: $hasAdvancedAccessToCampaigns) {
    type
    forwarding_webhook
    type
    location_id
    office_id
  }
  is_hidden
  chat_bot_is_ko
  chat_bot_enabled
  chat_bot_v2_enabled
  job_posting_text
  phone_number_default_region
  org_settings_override {
    logo_url
    short_name
    name_prefix
  }
  short_id
  responsible_person
  applicant_board_enabled
}
    `;
export const CampaignDetailsFragmentDoc = gql`
    fragment CampaignDetails on campaign {
  name
  funnel_insights {
    click_through_rate
    sessions
  }
  qualified_count: contacts_aggregate(where: {qualified: {_eq: true}}) {
    aggregate {
      count
    }
  }
  unqualified_count: contacts_aggregate(where: {qualified: {_eq: false}}) {
    aggregate {
      count
    }
  }
  funnel_page_insights {
    index
    visitors
    name
    question {
      title
    }
  }
  organization {
    settings {
      organization_id
      address_formally
      rejection_emails_enabled
      notification_emails_enabled
      welcome_emails_enabled
    }
    ...OrganizationDesignation
  }
  email_template_overwrite {
    campaign_id
    rejection
    welcome
  }
  unqualified_contacts_per_day(order_by: {date: asc}) {
    ...UnqualifiedContactsPerDay
  }
  ...Campaign
}
    `;
export const CampaignOrderFragmentDoc = gql`
    fragment CampaignOrder on campaign_order {
  id
  platform_job_id
  budget
  customer {
    id
    short_name
    name
    logo_url
  }
  source {
    id
    url
    source_type
  }
  title
  link
  description
  responsible_user
  completed
  created_campaign
  received_at
  additional_properties
  target_locations
}
    `;
export const DestinationCampaignFragmentDoc = gql`
    fragment DestinationCampaign on campaign {
  id
  name
  status
  start
  end
}
    `;
export const DestinationFragmentDoc = gql`
    fragment Destination on campaign_routing_destination {
  location_id
  location_name
  trello_board_id
  trello_qualified_column
  trello_unqualified_column
  meistertask_board_id
  meistertask_qualified_column
  meistertask_unqualified_column
  campaign {
    ...DestinationCampaign
  }
  type
  campaign_id
}
    `;
export const ChatMessageFragmentDoc = gql`
    fragment ChatMessage on chat_bot_messages {
  type
  data
  sender_type
  created_at
  id
}
    `;
export const LlmChatBotConversationFragmentDoc = gql`
    fragment LLMChatBotConversation on bot_conversation {
  id
  started_at
  contact_id
  messages(order_by: {sent_at: asc}) {
    id
    sent_at
    sent_by
    text
  }
}
    `;
export const AnnaFileFragmentFragmentDoc = gql`
    fragment AnnaFileFragment on anna_ai_outbound_calls {
  id
  has_recording
  file_id
  created_at: started_at
}
    `;
export const AnswerOptionFragmentDoc = gql`
    fragment AnswerOption on funnel_question {
  options {
    title
    isKnockout
  }
}
    `;
export const AnswerFragmentDoc = gql`
    fragment Answer on answer {
  id
  value
  question {
    id
    field_name
    title
    ...AnswerOption
  }
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on contact {
  id
  first_name
  last_name
  phone_number
  converted_at
  answers {
    ...Answer
  }
  email_address
  campaign_id
  qa_source
  cv_id
  origin_campaign {
    id
    name
  }
  routing_location_id
  utm_source
}
    `;
export const ContactBoardEntryFragmentDoc = gql`
    fragment ContactBoardEntry on board_contact_board_entry {
  id
  score
  column_id
  board_id
  position
  contact {
    ...Contact
  }
  forward_log {
    success
  }
}
    `;
export const ContactBoardColumnFragmentDoc = gql`
    fragment ContactBoardColumn on board_contact_board_column {
  id
  board_id
  name
  position
  type
}
    `;
export const ContactBoardColumnWithEntriesFragmentDoc = gql`
    fragment ContactBoardColumnWithEntries on board_contact_board_column {
  contact_board_entries(order_by: {column_id: asc, position: asc}) {
    ...ContactBoardEntry
  }
  contact_board_entries_aggregate {
    aggregate {
      count
    }
  }
  ...ContactBoardColumn
}
    `;
export const ApplicantExportQuestionFragmentDoc = gql`
    fragment ApplicantExportQuestion on funnel_question {
  id
  title
}
    `;
export const ApplicantExportDataFragmentDoc = gql`
    fragment ApplicantExportData on contact {
  id
  first_name
  last_name
  qualified
  converted_at
  email_address
  phone_number
  routing_location_id
  origin_campaign {
    id
    name
  }
  answers {
    id
    question {
      id
      title
    }
    value
  }
}
    `;
export const ContactsPerDayFragmentDoc = gql`
    fragment ContactsPerDay on new_contacts_per_day {
  date
  new_contacts
}
    `;
export const CampaignMetaFragmentDoc = gql`
    fragment campaignMeta on campaign {
  id
  location: c_location {
    slug
    organization_id
    name
    region_slug
  }
  name
  contacts_aggregate(where: {qualified: {_eq: true}}) {
    aggregate {
      count
    }
  }
}
    `;
export const AdCommentFragmentDoc = gql`
    fragment AdComment on ad_comment {
  id
  text
  user_id
  setting_reference
}
    `;
export const FunnelQuestionFragmentDoc = gql`
    fragment FunnelQuestion on funnel_question {
  title
  question_type
  uuid: id
  position
  parent_question_id
  is_required
  archived
  options {
    icon
    id
    title
    value
    isKnockout
    redirect_question_id
    redirect_behavior
  }
  child_questions(order_by: {position: asc}) {
    icon
    id
    position
    title
    is_required
    question_type
    parent_question_id
    archived
    options {
      title
    }
  }
}
    `;
export const CampaignFunnelFragmentDoc = gql`
    fragment CampaignFunnel on funnel_funnels {
  id
  enabled
  campaign_id
  job_caption
  job_intro
  job_byline
  expectations_items
  expectations_intro
  img_1_id
  img_1_2_id
  img_1_3_id
  img_1_4_id
  img_2_id
  img_2_2_id
  img_2_3_id
  img_2_4_id
  img_3_id
  img_3_2_id
  img_3_3_id
  img_3_4_id
  logo_id
  video_1_id
  video_2_id
  video_3_id
  benefit_icon_id
  expectation_icon_id
  company_privacy_policy_url
  company_privacy_policy_title
  bot_consent_enabled
  chatbot_funnel_enabled
  whatsapp_apply_label
  whatsapp_apply_message_template
  whatsapp_intro_message
  whatsapp_outro_message
  whatsapp_share_caption
  whatsapp_share_title
  whatsapp_share_label
  header_color
  we_are_intro
  we_are_byline
  we_are_copy
  we_are_call_to_action
  call_to_action
  sub_call_to_action
  formality_type
  locale
  theme_color
  benefits_intro
  benefits {
    description
    title
    id
  }
  template
  next_steps
  slug
  highlights
  cv_required
  location_question_country_enabled
  location_question_city_enabled
  location_question_street_enabled
  location_question_postalcode_enabled
  contact_question_birthdate_enabled
  contact_question_form_of_address_enabled
  cv_question_enabled
  questions(
    where: {archived: {_eq: false}, parent_question_id: {_is_null: true}}
    order_by: {position: asc}
  ) {
    ...FunnelQuestion
  }
  campaign {
    status
    is_hidden
    short_id
  }
}
    `;
export const CampaignSettingsOverrideFragmentDoc = gql`
    fragment CampaignSettingsOverride on campaign_settings_override {
  campaign_id
  logo_url
  short_name
  name_prefix
}
    `;
export const NoteFragmentDoc = gql`
    fragment Note on board_note {
  created_at
  author_id
  content
  id
  contact_board_entry_id
}
    `;
export const DropdownCampaignInfoFragmentDoc = gql`
    fragment DropdownCampaignInfo on campaign {
  start
  end
  name
  organization {
    name
  }
  id
}
    `;
export const InsightCampaignFragmentDoc = gql`
    fragment InsightCampaign on campaign {
  id
  start
  name
  end
  organization {
    name
  }
  contacts_aggregate {
    aggregate {
      count
    }
  }
  contacts_per_day(order_by: {date: asc}) {
    date
    new_contacts
  }
}
    `;
export const PartnerOrganizationFragmentDoc = gql`
    fragment PartnerOrganization on organization {
  id
  name
}
    `;
export const NewsFragmentDoc = gql`
    fragment News on organization_news {
  id
  description
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on organization {
  campaigns_aggregate {
    aggregate {
      count
    }
  }
  name
  id
  active
  country: country_code
  name_prefix
  is_partner
  partner_organization_id
  short_name
  logo_url
  settings {
    address_formally
    organization_id
    notification_emails_enabled
    welcome_emails_enabled
    rejection_emails_enabled
  }
}
    `;
export const OrganizationWithBudgetFragmentDoc = gql`
    fragment OrganizationWithBudget on organization {
  ...Organization
  budget_from_transactions: budget @include(if: $canSeeInternalInsights) {
    spend
    bonus
    media_budget
    total_budget
  }
}
    `;
export const OrganizationWithLeadAndCampaignAggregateFragmentDoc = gql`
    fragment OrganizationWithLeadAndCampaignAggregate on organization {
  ...Organization
  active_campaigns: campaigns_aggregate(
    where: {_and: {start: {_lte: "now()"}}, end: {_gte: "now()"}}
  ) {
    aggregate {
      count
    }
  }
  leads: campaigns_aggregate {
    nodes {
      contacts_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}
    `;
export const RmsConnectorFragmentDoc = gql`
    fragment RmsConnector on rms_connectors {
  id
  enabled
  webhook
  job_id
  custom_mappings
}
    `;
export const GetCampaignByIdDocument = gql`
    query GetCampaignById($id: uuid!, $hasAdvancedAccessToCampaigns: Boolean!, $canSeeInternalInsights: Boolean!, $hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: Boolean!) {
  campaign_by_pk(id: $id) {
    ...Campaign
  }
}
    ${CampaignFragmentDoc}
${NewContactsPerDayFragmentDoc}`;

/**
 * __useGetCampaignByIdQuery__
 *
 * To run a query within a React component, call `useGetCampaignByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      hasAdvancedAccessToCampaigns: // value for 'hasAdvancedAccessToCampaigns'
 *      canSeeInternalInsights: // value for 'canSeeInternalInsights'
 *      hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: // value for 'hasAdvancedAccessToCampaignsOrCanSeeInternalInsights'
 *   },
 * });
 */
export function useGetCampaignByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignByIdQuery, GetCampaignByIdQueryVariables> & ({ variables: GetCampaignByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>(GetCampaignByIdDocument, options);
      }
export function useGetCampaignByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>(GetCampaignByIdDocument, options);
        }
export function useGetCampaignByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>(GetCampaignByIdDocument, options);
        }
export type GetCampaignByIdQueryHookResult = ReturnType<typeof useGetCampaignByIdQuery>;
export type GetCampaignByIdLazyQueryHookResult = ReturnType<typeof useGetCampaignByIdLazyQuery>;
export type GetCampaignByIdSuspenseQueryHookResult = ReturnType<typeof useGetCampaignByIdSuspenseQuery>;
export type GetCampaignByIdQueryResult = Apollo.QueryResult<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>;
export const GetCampaignByIdForDuplicationDocument = gql`
    query GetCampaignByIdForDuplication($id: uuid!, $hasAdvancedAccessToCampaigns: Boolean!, $canSeeInternalInsights: Boolean!, $hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: Boolean!) {
  campaign_by_pk(id: $id) {
    ...Campaign
    funnel {
      ...CampaignFunnel
    }
    rms_connector {
      ...RmsConnector
    }
  }
}
    ${CampaignFragmentDoc}
${NewContactsPerDayFragmentDoc}
${CampaignFunnelFragmentDoc}
${FunnelQuestionFragmentDoc}
${RmsConnectorFragmentDoc}`;

/**
 * __useGetCampaignByIdForDuplicationQuery__
 *
 * To run a query within a React component, call `useGetCampaignByIdForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignByIdForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignByIdForDuplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      hasAdvancedAccessToCampaigns: // value for 'hasAdvancedAccessToCampaigns'
 *      canSeeInternalInsights: // value for 'canSeeInternalInsights'
 *      hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: // value for 'hasAdvancedAccessToCampaignsOrCanSeeInternalInsights'
 *   },
 * });
 */
export function useGetCampaignByIdForDuplicationQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignByIdForDuplicationQuery, GetCampaignByIdForDuplicationQueryVariables> & ({ variables: GetCampaignByIdForDuplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignByIdForDuplicationQuery, GetCampaignByIdForDuplicationQueryVariables>(GetCampaignByIdForDuplicationDocument, options);
      }
export function useGetCampaignByIdForDuplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignByIdForDuplicationQuery, GetCampaignByIdForDuplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignByIdForDuplicationQuery, GetCampaignByIdForDuplicationQueryVariables>(GetCampaignByIdForDuplicationDocument, options);
        }
export function useGetCampaignByIdForDuplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignByIdForDuplicationQuery, GetCampaignByIdForDuplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignByIdForDuplicationQuery, GetCampaignByIdForDuplicationQueryVariables>(GetCampaignByIdForDuplicationDocument, options);
        }
export type GetCampaignByIdForDuplicationQueryHookResult = ReturnType<typeof useGetCampaignByIdForDuplicationQuery>;
export type GetCampaignByIdForDuplicationLazyQueryHookResult = ReturnType<typeof useGetCampaignByIdForDuplicationLazyQuery>;
export type GetCampaignByIdForDuplicationSuspenseQueryHookResult = ReturnType<typeof useGetCampaignByIdForDuplicationSuspenseQuery>;
export type GetCampaignByIdForDuplicationQueryResult = Apollo.QueryResult<GetCampaignByIdForDuplicationQuery, GetCampaignByIdForDuplicationQueryVariables>;
export const GetCampaignsDocument = gql`
    query GetCampaigns($query: campaign_bool_exp, $order_by: [campaign_order_by!], $limit: Int!, $offset: Int!) {
  AllCampaigns: campaign(
    where: $query
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...MinifiedCampaign
  }
  campaign_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    ${MinifiedCampaignFragmentDoc}
${NewContactsPerDayFragmentDoc}`;

/**
 * __useGetCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      order_by: // value for 'order_by'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCampaignsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables> & ({ variables: GetCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
      }
export function useGetCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
export function useGetCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
export type GetCampaignsQueryHookResult = ReturnType<typeof useGetCampaignsQuery>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignsSuspenseQuery>;
export type GetCampaignsQueryResult = Apollo.QueryResult<GetCampaignsQuery, GetCampaignsQueryVariables>;
export const GetContactsDocument = gql`
    query GetContacts($query: contact_bool_exp, $limit: Int!, $offset: Int!) {
  AllContacts: contact(
    where: $query
    order_by: {converted_at: desc_nulls_last}
    limit: $limit
    offset: $offset
  ) {
    ...contactMeta
  }
  contact_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    ${ContactMetaFragmentDoc}`;

/**
 * __useGetContactsQuery__
 *
 * To run a query within a React component, call `useGetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetContactsQuery(baseOptions: Apollo.QueryHookOptions<GetContactsQuery, GetContactsQueryVariables> & ({ variables: GetContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
      }
export function useGetContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
export function useGetContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
export type GetContactsQueryHookResult = ReturnType<typeof useGetContactsQuery>;
export type GetContactsLazyQueryHookResult = ReturnType<typeof useGetContactsLazyQuery>;
export type GetContactsSuspenseQueryHookResult = ReturnType<typeof useGetContactsSuspenseQuery>;
export type GetContactsQueryResult = Apollo.QueryResult<GetContactsQuery, GetContactsQueryVariables>;
export const GetImpersonationOrganizationDocument = gql`
    query GetImpersonationOrganization($id: String!) {
  organization_by_pk(id: $id) {
    ...Impersonation
  }
}
    ${ImpersonationFragmentDoc}
${RegionFragmentDoc}
${LocationFragmentDoc}`;

/**
 * __useGetImpersonationOrganizationQuery__
 *
 * To run a query within a React component, call `useGetImpersonationOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImpersonationOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImpersonationOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImpersonationOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetImpersonationOrganizationQuery, GetImpersonationOrganizationQueryVariables> & ({ variables: GetImpersonationOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImpersonationOrganizationQuery, GetImpersonationOrganizationQueryVariables>(GetImpersonationOrganizationDocument, options);
      }
export function useGetImpersonationOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImpersonationOrganizationQuery, GetImpersonationOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImpersonationOrganizationQuery, GetImpersonationOrganizationQueryVariables>(GetImpersonationOrganizationDocument, options);
        }
export function useGetImpersonationOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetImpersonationOrganizationQuery, GetImpersonationOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImpersonationOrganizationQuery, GetImpersonationOrganizationQueryVariables>(GetImpersonationOrganizationDocument, options);
        }
export type GetImpersonationOrganizationQueryHookResult = ReturnType<typeof useGetImpersonationOrganizationQuery>;
export type GetImpersonationOrganizationLazyQueryHookResult = ReturnType<typeof useGetImpersonationOrganizationLazyQuery>;
export type GetImpersonationOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetImpersonationOrganizationSuspenseQuery>;
export type GetImpersonationOrganizationQueryResult = Apollo.QueryResult<GetImpersonationOrganizationQuery, GetImpersonationOrganizationQueryVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations($excludedOrganizations: [String!] = [], $canSeeInternalInsights: Boolean = false) {
  organization(where: {_not: {id: {_in: $excludedOrganizations}}}) {
    ...OrganizationWithBudget
  }
}
    ${OrganizationWithBudgetFragmentDoc}
${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      excludedOrganizations: // value for 'excludedOrganizations'
 *      canSeeInternalInsights: // value for 'canSeeInternalInsights'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetPaginatedOrganizationsDocument = gql`
    query GetPaginatedOrganizations($query: organization_bool_exp!, $excludedOrganizations: [String!] = [], $canSeeInternalInsights: Boolean = false, $limit: Int!, $offset: Int!) {
  organization(
    where: {_and: [{_not: {id: {_in: $excludedOrganizations}}}, $query]}
    limit: $limit
    offset: $offset
  ) {
    ...OrganizationWithBudget
  }
  organization_aggregate(
    where: {_and: [{_not: {id: {_in: $excludedOrganizations}}}, $query]}
  ) {
    aggregate {
      count
    }
  }
}
    ${OrganizationWithBudgetFragmentDoc}
${OrganizationFragmentDoc}`;

/**
 * __useGetPaginatedOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedOrganizationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      excludedOrganizations: // value for 'excludedOrganizations'
 *      canSeeInternalInsights: // value for 'canSeeInternalInsights'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPaginatedOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables> & ({ variables: GetPaginatedOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>(GetPaginatedOrganizationsDocument, options);
      }
export function useGetPaginatedOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>(GetPaginatedOrganizationsDocument, options);
        }
export function useGetPaginatedOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>(GetPaginatedOrganizationsDocument, options);
        }
export type GetPaginatedOrganizationsQueryHookResult = ReturnType<typeof useGetPaginatedOrganizationsQuery>;
export type GetPaginatedOrganizationsLazyQueryHookResult = ReturnType<typeof useGetPaginatedOrganizationsLazyQuery>;
export type GetPaginatedOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedOrganizationsSuspenseQuery>;
export type GetPaginatedOrganizationsQueryResult = Apollo.QueryResult<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>;
export const DeleteApplicantDocument = gql`
    mutation DeleteApplicant($applicant_id: uuid!) {
  update_contact_by_pk(
    _set: {deleted_at: "now()"}
    pk_columns: {id: $applicant_id}
  ) {
    id
  }
}
    `;
export type DeleteApplicantMutationFn = Apollo.MutationFunction<DeleteApplicantMutation, DeleteApplicantMutationVariables>;

/**
 * __useDeleteApplicantMutation__
 *
 * To run a mutation, you first call `useDeleteApplicantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApplicantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApplicantMutation, { data, loading, error }] = useDeleteApplicantMutation({
 *   variables: {
 *      applicant_id: // value for 'applicant_id'
 *   },
 * });
 */
export function useDeleteApplicantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApplicantMutation, DeleteApplicantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApplicantMutation, DeleteApplicantMutationVariables>(DeleteApplicantDocument, options);
      }
export type DeleteApplicantMutationHookResult = ReturnType<typeof useDeleteApplicantMutation>;
export type DeleteApplicantMutationResult = Apollo.MutationResult<DeleteApplicantMutation>;
export type DeleteApplicantMutationOptions = Apollo.BaseMutationOptions<DeleteApplicantMutation, DeleteApplicantMutationVariables>;
export const CountCampaignsByStatusDocument = gql`
    query CountCampaignsByStatus {
  active_campaigns: campaign_aggregate(where: {status: {_eq: "ACTIVE"}}) {
    aggregate {
      count
    }
  }
  paused_campaigns: campaign_aggregate(where: {status: {_eq: "PAUSED"}}) {
    aggregate {
      count
    }
  }
  draft_campaigns: campaign_aggregate(where: {status: {_eq: "DRAFT"}}) {
    aggregate {
      count
    }
  }
  finished_campaigns: campaign_aggregate(where: {status: {_eq: "FINISHED"}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCountCampaignsByStatusQuery__
 *
 * To run a query within a React component, call `useCountCampaignsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCampaignsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCampaignsByStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountCampaignsByStatusQuery(baseOptions?: Apollo.QueryHookOptions<CountCampaignsByStatusQuery, CountCampaignsByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountCampaignsByStatusQuery, CountCampaignsByStatusQueryVariables>(CountCampaignsByStatusDocument, options);
      }
export function useCountCampaignsByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountCampaignsByStatusQuery, CountCampaignsByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountCampaignsByStatusQuery, CountCampaignsByStatusQueryVariables>(CountCampaignsByStatusDocument, options);
        }
export function useCountCampaignsByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountCampaignsByStatusQuery, CountCampaignsByStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountCampaignsByStatusQuery, CountCampaignsByStatusQueryVariables>(CountCampaignsByStatusDocument, options);
        }
export type CountCampaignsByStatusQueryHookResult = ReturnType<typeof useCountCampaignsByStatusQuery>;
export type CountCampaignsByStatusLazyQueryHookResult = ReturnType<typeof useCountCampaignsByStatusLazyQuery>;
export type CountCampaignsByStatusSuspenseQueryHookResult = ReturnType<typeof useCountCampaignsByStatusSuspenseQuery>;
export type CountCampaignsByStatusQueryResult = Apollo.QueryResult<CountCampaignsByStatusQuery, CountCampaignsByStatusQueryVariables>;
export const DeleteForwardingDocument = gql`
    mutation DeleteForwarding($campaignId: uuid!) {
  delete_chat_bot_forwarding(where: {campaign_id: {_eq: $campaignId}}) {
    affected_rows
    returning {
      campaign_id
      webhook_url
    }
  }
}
    `;
export type DeleteForwardingMutationFn = Apollo.MutationFunction<DeleteForwardingMutation, DeleteForwardingMutationVariables>;

/**
 * __useDeleteForwardingMutation__
 *
 * To run a mutation, you first call `useDeleteForwardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForwardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteForwardingMutation, { data, loading, error }] = useDeleteForwardingMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDeleteForwardingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteForwardingMutation, DeleteForwardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteForwardingMutation, DeleteForwardingMutationVariables>(DeleteForwardingDocument, options);
      }
export type DeleteForwardingMutationHookResult = ReturnType<typeof useDeleteForwardingMutation>;
export type DeleteForwardingMutationResult = Apollo.MutationResult<DeleteForwardingMutation>;
export type DeleteForwardingMutationOptions = Apollo.BaseMutationOptions<DeleteForwardingMutation, DeleteForwardingMutationVariables>;
export const GetAdCampaignsDocument = gql`
    query GetAdCampaigns($filter: uuid_comparison_exp) {
  ad_campaign_metrics(
    where: {campaign_id: $filter, created_at: {_gte: "2023-01-01"}}
  ) {
    ...AdCampaign
  }
}
    ${AdCampaignFragmentDoc}`;

/**
 * __useGetAdCampaignsQuery__
 *
 * To run a query within a React component, call `useGetAdCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdCampaignsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAdCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdCampaignsQuery, GetAdCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdCampaignsQuery, GetAdCampaignsQueryVariables>(GetAdCampaignsDocument, options);
      }
export function useGetAdCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdCampaignsQuery, GetAdCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdCampaignsQuery, GetAdCampaignsQueryVariables>(GetAdCampaignsDocument, options);
        }
export function useGetAdCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdCampaignsQuery, GetAdCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdCampaignsQuery, GetAdCampaignsQueryVariables>(GetAdCampaignsDocument, options);
        }
export type GetAdCampaignsQueryHookResult = ReturnType<typeof useGetAdCampaignsQuery>;
export type GetAdCampaignsLazyQueryHookResult = ReturnType<typeof useGetAdCampaignsLazyQuery>;
export type GetAdCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetAdCampaignsSuspenseQuery>;
export type GetAdCampaignsQueryResult = Apollo.QueryResult<GetAdCampaignsQuery, GetAdCampaignsQueryVariables>;
export const GetCampaignContactsPerDayDocument = gql`
    query GetCampaignContactsPerDay($id: uuid!) {
  campaign_by_pk(id: $id) {
    ...CampaignContactsPerDay
  }
  new_unqualified_contacts_per_day(where: {campaign_id: {_eq: $id}}) {
    ...UnqualifiedContactsPerDay
  }
}
    ${CampaignContactsPerDayFragmentDoc}
${UnqualifiedContactsPerDayFragmentDoc}`;

/**
 * __useGetCampaignContactsPerDayQuery__
 *
 * To run a query within a React component, call `useGetCampaignContactsPerDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignContactsPerDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignContactsPerDayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignContactsPerDayQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignContactsPerDayQuery, GetCampaignContactsPerDayQueryVariables> & ({ variables: GetCampaignContactsPerDayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignContactsPerDayQuery, GetCampaignContactsPerDayQueryVariables>(GetCampaignContactsPerDayDocument, options);
      }
export function useGetCampaignContactsPerDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignContactsPerDayQuery, GetCampaignContactsPerDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignContactsPerDayQuery, GetCampaignContactsPerDayQueryVariables>(GetCampaignContactsPerDayDocument, options);
        }
export function useGetCampaignContactsPerDaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignContactsPerDayQuery, GetCampaignContactsPerDayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignContactsPerDayQuery, GetCampaignContactsPerDayQueryVariables>(GetCampaignContactsPerDayDocument, options);
        }
export type GetCampaignContactsPerDayQueryHookResult = ReturnType<typeof useGetCampaignContactsPerDayQuery>;
export type GetCampaignContactsPerDayLazyQueryHookResult = ReturnType<typeof useGetCampaignContactsPerDayLazyQuery>;
export type GetCampaignContactsPerDaySuspenseQueryHookResult = ReturnType<typeof useGetCampaignContactsPerDaySuspenseQuery>;
export type GetCampaignContactsPerDayQueryResult = Apollo.QueryResult<GetCampaignContactsPerDayQuery, GetCampaignContactsPerDayQueryVariables>;
export const GetCampaignEmailOverwriteDocument = gql`
    query GetCampaignEmailOverwrite($id: uuid!) {
  campaign_by_pk(id: $id) {
    support_email
    email_template_overwrite {
      ...CampaignEmailOverwrite
    }
  }
}
    ${CampaignEmailOverwriteFragmentDoc}`;

/**
 * __useGetCampaignEmailOverwriteQuery__
 *
 * To run a query within a React component, call `useGetCampaignEmailOverwriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignEmailOverwriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignEmailOverwriteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignEmailOverwriteQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignEmailOverwriteQuery, GetCampaignEmailOverwriteQueryVariables> & ({ variables: GetCampaignEmailOverwriteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignEmailOverwriteQuery, GetCampaignEmailOverwriteQueryVariables>(GetCampaignEmailOverwriteDocument, options);
      }
export function useGetCampaignEmailOverwriteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignEmailOverwriteQuery, GetCampaignEmailOverwriteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignEmailOverwriteQuery, GetCampaignEmailOverwriteQueryVariables>(GetCampaignEmailOverwriteDocument, options);
        }
export function useGetCampaignEmailOverwriteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignEmailOverwriteQuery, GetCampaignEmailOverwriteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignEmailOverwriteQuery, GetCampaignEmailOverwriteQueryVariables>(GetCampaignEmailOverwriteDocument, options);
        }
export type GetCampaignEmailOverwriteQueryHookResult = ReturnType<typeof useGetCampaignEmailOverwriteQuery>;
export type GetCampaignEmailOverwriteLazyQueryHookResult = ReturnType<typeof useGetCampaignEmailOverwriteLazyQuery>;
export type GetCampaignEmailOverwriteSuspenseQueryHookResult = ReturnType<typeof useGetCampaignEmailOverwriteSuspenseQuery>;
export type GetCampaignEmailOverwriteQueryResult = Apollo.QueryResult<GetCampaignEmailOverwriteQuery, GetCampaignEmailOverwriteQueryVariables>;
export const GetCampaignFunnelAnalyticsDocument = gql`
    query GetCampaignFunnelAnalytics($campaignId: uuid!) {
  campaign_by_pk(id: $campaignId) {
    ...CampaignFunnelAnalytics
  }
}
    ${CampaignFunnelAnalyticsFragmentDoc}`;

/**
 * __useGetCampaignFunnelAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetCampaignFunnelAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignFunnelAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignFunnelAnalyticsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignFunnelAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignFunnelAnalyticsQuery, GetCampaignFunnelAnalyticsQueryVariables> & ({ variables: GetCampaignFunnelAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignFunnelAnalyticsQuery, GetCampaignFunnelAnalyticsQueryVariables>(GetCampaignFunnelAnalyticsDocument, options);
      }
export function useGetCampaignFunnelAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignFunnelAnalyticsQuery, GetCampaignFunnelAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignFunnelAnalyticsQuery, GetCampaignFunnelAnalyticsQueryVariables>(GetCampaignFunnelAnalyticsDocument, options);
        }
export function useGetCampaignFunnelAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignFunnelAnalyticsQuery, GetCampaignFunnelAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignFunnelAnalyticsQuery, GetCampaignFunnelAnalyticsQueryVariables>(GetCampaignFunnelAnalyticsDocument, options);
        }
export type GetCampaignFunnelAnalyticsQueryHookResult = ReturnType<typeof useGetCampaignFunnelAnalyticsQuery>;
export type GetCampaignFunnelAnalyticsLazyQueryHookResult = ReturnType<typeof useGetCampaignFunnelAnalyticsLazyQuery>;
export type GetCampaignFunnelAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignFunnelAnalyticsSuspenseQuery>;
export type GetCampaignFunnelAnalyticsQueryResult = Apollo.QueryResult<GetCampaignFunnelAnalyticsQuery, GetCampaignFunnelAnalyticsQueryVariables>;
export const GetCampaignKpisDocument = gql`
    query GetCampaignKpis($campaignId: uuid!, $hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: Boolean!, $canSeeInternalInsights: Boolean!) {
  campaign_by_pk(id: $campaignId) {
    ...CampaignKpis
  }
}
    ${CampaignKpisFragmentDoc}`;

/**
 * __useGetCampaignKpisQuery__
 *
 * To run a query within a React component, call `useGetCampaignKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignKpisQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: // value for 'hasAdvancedAccessToCampaignsOrCanSeeInternalInsights'
 *      canSeeInternalInsights: // value for 'canSeeInternalInsights'
 *   },
 * });
 */
export function useGetCampaignKpisQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignKpisQuery, GetCampaignKpisQueryVariables> & ({ variables: GetCampaignKpisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignKpisQuery, GetCampaignKpisQueryVariables>(GetCampaignKpisDocument, options);
      }
export function useGetCampaignKpisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignKpisQuery, GetCampaignKpisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignKpisQuery, GetCampaignKpisQueryVariables>(GetCampaignKpisDocument, options);
        }
export function useGetCampaignKpisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignKpisQuery, GetCampaignKpisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignKpisQuery, GetCampaignKpisQueryVariables>(GetCampaignKpisDocument, options);
        }
export type GetCampaignKpisQueryHookResult = ReturnType<typeof useGetCampaignKpisQuery>;
export type GetCampaignKpisLazyQueryHookResult = ReturnType<typeof useGetCampaignKpisLazyQuery>;
export type GetCampaignKpisSuspenseQueryHookResult = ReturnType<typeof useGetCampaignKpisSuspenseQuery>;
export type GetCampaignKpisQueryResult = Apollo.QueryResult<GetCampaignKpisQuery, GetCampaignKpisQueryVariables>;
export const GetCampaignStatusesDocument = gql`
    query GetCampaignStatuses {
  campaign {
    status
  }
}
    `;

/**
 * __useGetCampaignStatusesQuery__
 *
 * To run a query within a React component, call `useGetCampaignStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCampaignStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignStatusesQuery, GetCampaignStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignStatusesQuery, GetCampaignStatusesQueryVariables>(GetCampaignStatusesDocument, options);
      }
export function useGetCampaignStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignStatusesQuery, GetCampaignStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignStatusesQuery, GetCampaignStatusesQueryVariables>(GetCampaignStatusesDocument, options);
        }
export function useGetCampaignStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignStatusesQuery, GetCampaignStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignStatusesQuery, GetCampaignStatusesQueryVariables>(GetCampaignStatusesDocument, options);
        }
export type GetCampaignStatusesQueryHookResult = ReturnType<typeof useGetCampaignStatusesQuery>;
export type GetCampaignStatusesLazyQueryHookResult = ReturnType<typeof useGetCampaignStatusesLazyQuery>;
export type GetCampaignStatusesSuspenseQueryHookResult = ReturnType<typeof useGetCampaignStatusesSuspenseQuery>;
export type GetCampaignStatusesQueryResult = Apollo.QueryResult<GetCampaignStatusesQuery, GetCampaignStatusesQueryVariables>;
export const GetLinkedAdCampaignsDocument = gql`
    query GetLinkedAdCampaigns($campaignId: uuid!) {
  ad_campaign_metrics(where: {campaign_id: {_eq: $campaignId}}) {
    ...AdCampaign
  }
}
    ${AdCampaignFragmentDoc}`;

/**
 * __useGetLinkedAdCampaignsQuery__
 *
 * To run a query within a React component, call `useGetLinkedAdCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedAdCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedAdCampaignsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetLinkedAdCampaignsQuery(baseOptions: Apollo.QueryHookOptions<GetLinkedAdCampaignsQuery, GetLinkedAdCampaignsQueryVariables> & ({ variables: GetLinkedAdCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedAdCampaignsQuery, GetLinkedAdCampaignsQueryVariables>(GetLinkedAdCampaignsDocument, options);
      }
export function useGetLinkedAdCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedAdCampaignsQuery, GetLinkedAdCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedAdCampaignsQuery, GetLinkedAdCampaignsQueryVariables>(GetLinkedAdCampaignsDocument, options);
        }
export function useGetLinkedAdCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkedAdCampaignsQuery, GetLinkedAdCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLinkedAdCampaignsQuery, GetLinkedAdCampaignsQueryVariables>(GetLinkedAdCampaignsDocument, options);
        }
export type GetLinkedAdCampaignsQueryHookResult = ReturnType<typeof useGetLinkedAdCampaignsQuery>;
export type GetLinkedAdCampaignsLazyQueryHookResult = ReturnType<typeof useGetLinkedAdCampaignsLazyQuery>;
export type GetLinkedAdCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetLinkedAdCampaignsSuspenseQuery>;
export type GetLinkedAdCampaignsQueryResult = Apollo.QueryResult<GetLinkedAdCampaignsQuery, GetLinkedAdCampaignsQueryVariables>;
export const GetMinifiedCampaignDocument = gql`
    query GetMinifiedCampaign($id: uuid!) {
  campaign_by_pk(id: $id) {
    ...MinifiedCampaign
  }
}
    ${MinifiedCampaignFragmentDoc}
${NewContactsPerDayFragmentDoc}`;

/**
 * __useGetMinifiedCampaignQuery__
 *
 * To run a query within a React component, call `useGetMinifiedCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMinifiedCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMinifiedCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMinifiedCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetMinifiedCampaignQuery, GetMinifiedCampaignQueryVariables> & ({ variables: GetMinifiedCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMinifiedCampaignQuery, GetMinifiedCampaignQueryVariables>(GetMinifiedCampaignDocument, options);
      }
export function useGetMinifiedCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMinifiedCampaignQuery, GetMinifiedCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMinifiedCampaignQuery, GetMinifiedCampaignQueryVariables>(GetMinifiedCampaignDocument, options);
        }
export function useGetMinifiedCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMinifiedCampaignQuery, GetMinifiedCampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMinifiedCampaignQuery, GetMinifiedCampaignQueryVariables>(GetMinifiedCampaignDocument, options);
        }
export type GetMinifiedCampaignQueryHookResult = ReturnType<typeof useGetMinifiedCampaignQuery>;
export type GetMinifiedCampaignLazyQueryHookResult = ReturnType<typeof useGetMinifiedCampaignLazyQuery>;
export type GetMinifiedCampaignSuspenseQueryHookResult = ReturnType<typeof useGetMinifiedCampaignSuspenseQuery>;
export type GetMinifiedCampaignQueryResult = Apollo.QueryResult<GetMinifiedCampaignQuery, GetMinifiedCampaignQueryVariables>;
export const InsertCampaignDocument = gql`
    mutation InsertCampaign($campaign: campaign_insert_input!, $isAdmin: Boolean!) {
  insert_campaign_one(object: $campaign) {
    ...InsertCampaign
  }
}
    ${InsertCampaignFragmentDoc}
${NewContactsPerDayFragmentDoc}`;
export type InsertCampaignMutationFn = Apollo.MutationFunction<InsertCampaignMutation, InsertCampaignMutationVariables>;

/**
 * __useInsertCampaignMutation__
 *
 * To run a mutation, you first call `useInsertCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCampaignMutation, { data, loading, error }] = useInsertCampaignMutation({
 *   variables: {
 *      campaign: // value for 'campaign'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useInsertCampaignMutation(baseOptions?: Apollo.MutationHookOptions<InsertCampaignMutation, InsertCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCampaignMutation, InsertCampaignMutationVariables>(InsertCampaignDocument, options);
      }
export type InsertCampaignMutationHookResult = ReturnType<typeof useInsertCampaignMutation>;
export type InsertCampaignMutationResult = Apollo.MutationResult<InsertCampaignMutation>;
export type InsertCampaignMutationOptions = Apollo.BaseMutationOptions<InsertCampaignMutation, InsertCampaignMutationVariables>;
export const PauseCampaignDocument = gql`
    mutation PauseCampaign($id: uuid!) {
  insert_campaign_status_log_one(object: {event: PAUSE, campaign_id: $id}) {
    created_at
  }
  update_campaign_by_pk(pk_columns: {id: $id}, _set: {status_override: PAUSED}) {
    id
    status_override
  }
}
    `;
export type PauseCampaignMutationFn = Apollo.MutationFunction<PauseCampaignMutation, PauseCampaignMutationVariables>;

/**
 * __usePauseCampaignMutation__
 *
 * To run a mutation, you first call `usePauseCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseCampaignMutation, { data, loading, error }] = usePauseCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePauseCampaignMutation(baseOptions?: Apollo.MutationHookOptions<PauseCampaignMutation, PauseCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseCampaignMutation, PauseCampaignMutationVariables>(PauseCampaignDocument, options);
      }
export type PauseCampaignMutationHookResult = ReturnType<typeof usePauseCampaignMutation>;
export type PauseCampaignMutationResult = Apollo.MutationResult<PauseCampaignMutation>;
export type PauseCampaignMutationOptions = Apollo.BaseMutationOptions<PauseCampaignMutation, PauseCampaignMutationVariables>;
export const ResumeCampaignDocument = gql`
    mutation ResumeCampaign($id: uuid!) {
  insert_campaign_status_log_one(object: {event: RESUME, campaign_id: $id}) {
    created_at
  }
  update_campaign_by_pk(pk_columns: {id: $id}, _set: {status_override: ON}) {
    id
    status_override
  }
}
    `;
export type ResumeCampaignMutationFn = Apollo.MutationFunction<ResumeCampaignMutation, ResumeCampaignMutationVariables>;

/**
 * __useResumeCampaignMutation__
 *
 * To run a mutation, you first call `useResumeCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeCampaignMutation, { data, loading, error }] = useResumeCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResumeCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ResumeCampaignMutation, ResumeCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeCampaignMutation, ResumeCampaignMutationVariables>(ResumeCampaignDocument, options);
      }
export type ResumeCampaignMutationHookResult = ReturnType<typeof useResumeCampaignMutation>;
export type ResumeCampaignMutationResult = Apollo.MutationResult<ResumeCampaignMutation>;
export type ResumeCampaignMutationOptions = Apollo.BaseMutationOptions<ResumeCampaignMutation, ResumeCampaignMutationVariables>;
export const StopCampaignDocument = gql`
    mutation StopCampaign($id: uuid!) {
  update_campaign_by_pk(pk_columns: {id: $id}, _set: {end: "now()"}) {
    id
    end
    status
  }
}
    `;
export type StopCampaignMutationFn = Apollo.MutationFunction<StopCampaignMutation, StopCampaignMutationVariables>;

/**
 * __useStopCampaignMutation__
 *
 * To run a mutation, you first call `useStopCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopCampaignMutation, { data, loading, error }] = useStopCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStopCampaignMutation(baseOptions?: Apollo.MutationHookOptions<StopCampaignMutation, StopCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopCampaignMutation, StopCampaignMutationVariables>(StopCampaignDocument, options);
      }
export type StopCampaignMutationHookResult = ReturnType<typeof useStopCampaignMutation>;
export type StopCampaignMutationResult = Apollo.MutationResult<StopCampaignMutation>;
export type StopCampaignMutationOptions = Apollo.BaseMutationOptions<StopCampaignMutation, StopCampaignMutationVariables>;
export const ToggleCampaignVisibilityDocument = gql`
    mutation ToggleCampaignVisibility($id: uuid!, $is_hidden: Boolean!) {
  update_campaign_by_pk(pk_columns: {id: $id}, _set: {is_hidden: $is_hidden}) {
    id
    is_hidden
  }
}
    `;
export type ToggleCampaignVisibilityMutationFn = Apollo.MutationFunction<ToggleCampaignVisibilityMutation, ToggleCampaignVisibilityMutationVariables>;

/**
 * __useToggleCampaignVisibilityMutation__
 *
 * To run a mutation, you first call `useToggleCampaignVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCampaignVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCampaignVisibilityMutation, { data, loading, error }] = useToggleCampaignVisibilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_hidden: // value for 'is_hidden'
 *   },
 * });
 */
export function useToggleCampaignVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCampaignVisibilityMutation, ToggleCampaignVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCampaignVisibilityMutation, ToggleCampaignVisibilityMutationVariables>(ToggleCampaignVisibilityDocument, options);
      }
export type ToggleCampaignVisibilityMutationHookResult = ReturnType<typeof useToggleCampaignVisibilityMutation>;
export type ToggleCampaignVisibilityMutationResult = Apollo.MutationResult<ToggleCampaignVisibilityMutation>;
export type ToggleCampaignVisibilityMutationOptions = Apollo.BaseMutationOptions<ToggleCampaignVisibilityMutation, ToggleCampaignVisibilityMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation UpdateCampaign($id: uuid!, $input: campaign_set_input!, $routingInfo: campaign_routing_info_insert_input!, $isAdmin: Boolean!) {
  update_campaign_by_pk(pk_columns: {id: $id}, _set: $input) {
    ...InsertCampaign
  }
  insert_campaign_routing_info_one(
    object: $routingInfo
    on_conflict: {constraint: campaign_info_pkey, update_columns: [location_id, office_id, type, forwarding_webhook]}
  ) {
    campaign_id
    type
    location_id
    office_id
  }
}
    ${InsertCampaignFragmentDoc}
${NewContactsPerDayFragmentDoc}`;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      routingInfo: // value for 'routingInfo'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const UpsertCampaignEmailTemplatesDocument = gql`
    mutation UpsertCampaignEmailTemplates($email_templates: campaign_email_template_overwrite_insert_input!) {
  insert_campaign_email_template_overwrite_one(
    object: $email_templates
    on_conflict: {constraint: email_template_overwrite_pkey, update_columns: [rejection, welcome]}
  ) {
    welcome
    rejection
    campaign_id
  }
}
    `;
export type UpsertCampaignEmailTemplatesMutationFn = Apollo.MutationFunction<UpsertCampaignEmailTemplatesMutation, UpsertCampaignEmailTemplatesMutationVariables>;

/**
 * __useUpsertCampaignEmailTemplatesMutation__
 *
 * To run a mutation, you first call `useUpsertCampaignEmailTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCampaignEmailTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCampaignEmailTemplatesMutation, { data, loading, error }] = useUpsertCampaignEmailTemplatesMutation({
 *   variables: {
 *      email_templates: // value for 'email_templates'
 *   },
 * });
 */
export function useUpsertCampaignEmailTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCampaignEmailTemplatesMutation, UpsertCampaignEmailTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCampaignEmailTemplatesMutation, UpsertCampaignEmailTemplatesMutationVariables>(UpsertCampaignEmailTemplatesDocument, options);
      }
export type UpsertCampaignEmailTemplatesMutationHookResult = ReturnType<typeof useUpsertCampaignEmailTemplatesMutation>;
export type UpsertCampaignEmailTemplatesMutationResult = Apollo.MutationResult<UpsertCampaignEmailTemplatesMutation>;
export type UpsertCampaignEmailTemplatesMutationOptions = Apollo.BaseMutationOptions<UpsertCampaignEmailTemplatesMutation, UpsertCampaignEmailTemplatesMutationVariables>;
export const UpsertCampaignSettingsOverrideDocument = gql`
    mutation UpsertCampaignSettingsOverride($cso: campaign_settings_override_insert_input!) {
  insert_campaign_settings_override_one(
    object: $cso
    on_conflict: {constraint: settings_override_pkey, update_columns: [campaign_id, logo_url, short_name, name_prefix]}
  ) {
    ...CampaignSettingsOverride
  }
}
    ${CampaignSettingsOverrideFragmentDoc}`;
export type UpsertCampaignSettingsOverrideMutationFn = Apollo.MutationFunction<UpsertCampaignSettingsOverrideMutation, UpsertCampaignSettingsOverrideMutationVariables>;

/**
 * __useUpsertCampaignSettingsOverrideMutation__
 *
 * To run a mutation, you first call `useUpsertCampaignSettingsOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCampaignSettingsOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCampaignSettingsOverrideMutation, { data, loading, error }] = useUpsertCampaignSettingsOverrideMutation({
 *   variables: {
 *      cso: // value for 'cso'
 *   },
 * });
 */
export function useUpsertCampaignSettingsOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCampaignSettingsOverrideMutation, UpsertCampaignSettingsOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCampaignSettingsOverrideMutation, UpsertCampaignSettingsOverrideMutationVariables>(UpsertCampaignSettingsOverrideDocument, options);
      }
export type UpsertCampaignSettingsOverrideMutationHookResult = ReturnType<typeof useUpsertCampaignSettingsOverrideMutation>;
export type UpsertCampaignSettingsOverrideMutationResult = Apollo.MutationResult<UpsertCampaignSettingsOverrideMutation>;
export type UpsertCampaignSettingsOverrideMutationOptions = Apollo.BaseMutationOptions<UpsertCampaignSettingsOverrideMutation, UpsertCampaignSettingsOverrideMutationVariables>;
export const UpsertChatBotForwardingDocument = gql`
    mutation UpsertChatBotForwarding($forwarding: chat_bot_forwarding_insert_input!) {
  insert_chat_bot_forwarding_one(
    object: $forwarding
    on_conflict: {constraint: forwarding_campaign_id_key, update_columns: [webhook_url]}
  ) {
    campaign_id
    webhook_url
  }
}
    `;
export type UpsertChatBotForwardingMutationFn = Apollo.MutationFunction<UpsertChatBotForwardingMutation, UpsertChatBotForwardingMutationVariables>;

/**
 * __useUpsertChatBotForwardingMutation__
 *
 * To run a mutation, you first call `useUpsertChatBotForwardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertChatBotForwardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertChatBotForwardingMutation, { data, loading, error }] = useUpsertChatBotForwardingMutation({
 *   variables: {
 *      forwarding: // value for 'forwarding'
 *   },
 * });
 */
export function useUpsertChatBotForwardingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertChatBotForwardingMutation, UpsertChatBotForwardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertChatBotForwardingMutation, UpsertChatBotForwardingMutationVariables>(UpsertChatBotForwardingDocument, options);
      }
export type UpsertChatBotForwardingMutationHookResult = ReturnType<typeof useUpsertChatBotForwardingMutation>;
export type UpsertChatBotForwardingMutationResult = Apollo.MutationResult<UpsertChatBotForwardingMutation>;
export type UpsertChatBotForwardingMutationOptions = Apollo.BaseMutationOptions<UpsertChatBotForwardingMutation, UpsertChatBotForwardingMutationVariables>;
export const ApproveAdDocument = gql`
    mutation ApproveAd($id: uuid!) {
  update_campaign_ad_by_pk(pk_columns: {id: $id}, _set: {status: APPROVED}) {
    id
    status
  }
}
    `;
export type ApproveAdMutationFn = Apollo.MutationFunction<ApproveAdMutation, ApproveAdMutationVariables>;

/**
 * __useApproveAdMutation__
 *
 * To run a mutation, you first call `useApproveAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAdMutation, { data, loading, error }] = useApproveAdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveAdMutation(baseOptions?: Apollo.MutationHookOptions<ApproveAdMutation, ApproveAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveAdMutation, ApproveAdMutationVariables>(ApproveAdDocument, options);
      }
export type ApproveAdMutationHookResult = ReturnType<typeof useApproveAdMutation>;
export type ApproveAdMutationResult = Apollo.MutationResult<ApproveAdMutation>;
export type ApproveAdMutationOptions = Apollo.BaseMutationOptions<ApproveAdMutation, ApproveAdMutationVariables>;
export const DeleteAdDocument = gql`
    mutation DeleteAd($id: uuid!) {
  delete_campaign_ad_by_pk(id: $id) {
    ...Ad
  }
}
    ${AdFragmentDoc}
${AdCreativeFragmentDoc}
${CreativeFeedbackFragmentDoc}`;
export type DeleteAdMutationFn = Apollo.MutationFunction<DeleteAdMutation, DeleteAdMutationVariables>;

/**
 * __useDeleteAdMutation__
 *
 * To run a mutation, you first call `useDeleteAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdMutation, { data, loading, error }] = useDeleteAdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdMutation, DeleteAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdMutation, DeleteAdMutationVariables>(DeleteAdDocument, options);
      }
export type DeleteAdMutationHookResult = ReturnType<typeof useDeleteAdMutation>;
export type DeleteAdMutationResult = Apollo.MutationResult<DeleteAdMutation>;
export type DeleteAdMutationOptions = Apollo.BaseMutationOptions<DeleteAdMutation, DeleteAdMutationVariables>;
export const GetActiveAdsDocument = gql`
    query GetActiveAds($limit: Int!, $offset: Int!) {
  campaign_ad(
    where: {campaign: {status: {_eq: "ACTIVE"}}}
    order_by: {created_at: desc}
    limit: $limit
    offset: $offset
  ) {
    campaign {
      name
      status
      is_hidden
    }
    ...Ad
  }
  campaign_ad_aggregate(where: {campaign: {status: {_eq: "ACTIVE"}}}) {
    aggregate {
      count
    }
  }
}
    ${AdFragmentDoc}
${AdCreativeFragmentDoc}
${CreativeFeedbackFragmentDoc}`;

/**
 * __useGetActiveAdsQuery__
 *
 * To run a query within a React component, call `useGetActiveAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveAdsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetActiveAdsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveAdsQuery, GetActiveAdsQueryVariables> & ({ variables: GetActiveAdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveAdsQuery, GetActiveAdsQueryVariables>(GetActiveAdsDocument, options);
      }
export function useGetActiveAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveAdsQuery, GetActiveAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveAdsQuery, GetActiveAdsQueryVariables>(GetActiveAdsDocument, options);
        }
export function useGetActiveAdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveAdsQuery, GetActiveAdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveAdsQuery, GetActiveAdsQueryVariables>(GetActiveAdsDocument, options);
        }
export type GetActiveAdsQueryHookResult = ReturnType<typeof useGetActiveAdsQuery>;
export type GetActiveAdsLazyQueryHookResult = ReturnType<typeof useGetActiveAdsLazyQuery>;
export type GetActiveAdsSuspenseQueryHookResult = ReturnType<typeof useGetActiveAdsSuspenseQuery>;
export type GetActiveAdsQueryResult = Apollo.QueryResult<GetActiveAdsQuery, GetActiveAdsQueryVariables>;
export const GetAdChangelogDocument = gql`
    query GetAdChangelog($ad_id: uuid!) {
  campaign_ad_by_pk(id: $ad_id) {
    id
    platform
    creatives_history(order_by: {created_at: asc}) {
      ...CreativesHistoryItem
    }
  }
}
    ${CreativesHistoryItemFragmentDoc}
${CreativeFeedbackFragmentDoc}`;

/**
 * __useGetAdChangelogQuery__
 *
 * To run a query within a React component, call `useGetAdChangelogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdChangelogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdChangelogQuery({
 *   variables: {
 *      ad_id: // value for 'ad_id'
 *   },
 * });
 */
export function useGetAdChangelogQuery(baseOptions: Apollo.QueryHookOptions<GetAdChangelogQuery, GetAdChangelogQueryVariables> & ({ variables: GetAdChangelogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdChangelogQuery, GetAdChangelogQueryVariables>(GetAdChangelogDocument, options);
      }
export function useGetAdChangelogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdChangelogQuery, GetAdChangelogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdChangelogQuery, GetAdChangelogQueryVariables>(GetAdChangelogDocument, options);
        }
export function useGetAdChangelogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdChangelogQuery, GetAdChangelogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdChangelogQuery, GetAdChangelogQueryVariables>(GetAdChangelogDocument, options);
        }
export type GetAdChangelogQueryHookResult = ReturnType<typeof useGetAdChangelogQuery>;
export type GetAdChangelogLazyQueryHookResult = ReturnType<typeof useGetAdChangelogLazyQuery>;
export type GetAdChangelogSuspenseQueryHookResult = ReturnType<typeof useGetAdChangelogSuspenseQuery>;
export type GetAdChangelogQueryResult = Apollo.QueryResult<GetAdChangelogQuery, GetAdChangelogQueryVariables>;
export const GetAdCreativeOriginalNameDocument = gql`
    query GetAdCreativeOriginalName($adId: uuid!) {
  campaign_ad_by_pk(id: $adId) {
    creative {
      creative_upload {
        original_filename
      }
    }
  }
}
    `;

/**
 * __useGetAdCreativeOriginalNameQuery__
 *
 * To run a query within a React component, call `useGetAdCreativeOriginalNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdCreativeOriginalNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdCreativeOriginalNameQuery({
 *   variables: {
 *      adId: // value for 'adId'
 *   },
 * });
 */
export function useGetAdCreativeOriginalNameQuery(baseOptions: Apollo.QueryHookOptions<GetAdCreativeOriginalNameQuery, GetAdCreativeOriginalNameQueryVariables> & ({ variables: GetAdCreativeOriginalNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdCreativeOriginalNameQuery, GetAdCreativeOriginalNameQueryVariables>(GetAdCreativeOriginalNameDocument, options);
      }
export function useGetAdCreativeOriginalNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdCreativeOriginalNameQuery, GetAdCreativeOriginalNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdCreativeOriginalNameQuery, GetAdCreativeOriginalNameQueryVariables>(GetAdCreativeOriginalNameDocument, options);
        }
export function useGetAdCreativeOriginalNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdCreativeOriginalNameQuery, GetAdCreativeOriginalNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdCreativeOriginalNameQuery, GetAdCreativeOriginalNameQueryVariables>(GetAdCreativeOriginalNameDocument, options);
        }
export type GetAdCreativeOriginalNameQueryHookResult = ReturnType<typeof useGetAdCreativeOriginalNameQuery>;
export type GetAdCreativeOriginalNameLazyQueryHookResult = ReturnType<typeof useGetAdCreativeOriginalNameLazyQuery>;
export type GetAdCreativeOriginalNameSuspenseQueryHookResult = ReturnType<typeof useGetAdCreativeOriginalNameSuspenseQuery>;
export type GetAdCreativeOriginalNameQueryResult = Apollo.QueryResult<GetAdCreativeOriginalNameQuery, GetAdCreativeOriginalNameQueryVariables>;
export const GetAdsDocument = gql`
    query GetAds($campaignId: uuid!) {
  campaign_ad(
    where: {campaign_id: {_eq: $campaignId}}
    order_by: {created_at: asc}
  ) {
    ...Ad
  }
}
    ${AdFragmentDoc}
${AdCreativeFragmentDoc}
${CreativeFeedbackFragmentDoc}`;

/**
 * __useGetAdsQuery__
 *
 * To run a query within a React component, call `useGetAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetAdsQuery(baseOptions: Apollo.QueryHookOptions<GetAdsQuery, GetAdsQueryVariables> & ({ variables: GetAdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdsQuery, GetAdsQueryVariables>(GetAdsDocument, options);
      }
export function useGetAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdsQuery, GetAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdsQuery, GetAdsQueryVariables>(GetAdsDocument, options);
        }
export function useGetAdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdsQuery, GetAdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdsQuery, GetAdsQueryVariables>(GetAdsDocument, options);
        }
export type GetAdsQueryHookResult = ReturnType<typeof useGetAdsQuery>;
export type GetAdsLazyQueryHookResult = ReturnType<typeof useGetAdsLazyQuery>;
export type GetAdsSuspenseQueryHookResult = ReturnType<typeof useGetAdsSuspenseQuery>;
export type GetAdsQueryResult = Apollo.QueryResult<GetAdsQuery, GetAdsQueryVariables>;
export const GetFirstAdCreativeDocument = gql`
    query GetFirstAdCreative($campaignId: uuid!) {
  campaign_ad(
    where: {campaign_id: {_eq: $campaignId}, _and: {platform: {_in: [INSTAGRAM, FACEBOOK]}}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    creative {
      ...AdCreative
    }
  }
}
    ${AdCreativeFragmentDoc}
${CreativeFeedbackFragmentDoc}`;

/**
 * __useGetFirstAdCreativeQuery__
 *
 * To run a query within a React component, call `useGetFirstAdCreativeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstAdCreativeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstAdCreativeQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetFirstAdCreativeQuery(baseOptions: Apollo.QueryHookOptions<GetFirstAdCreativeQuery, GetFirstAdCreativeQueryVariables> & ({ variables: GetFirstAdCreativeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirstAdCreativeQuery, GetFirstAdCreativeQueryVariables>(GetFirstAdCreativeDocument, options);
      }
export function useGetFirstAdCreativeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirstAdCreativeQuery, GetFirstAdCreativeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirstAdCreativeQuery, GetFirstAdCreativeQueryVariables>(GetFirstAdCreativeDocument, options);
        }
export function useGetFirstAdCreativeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFirstAdCreativeQuery, GetFirstAdCreativeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFirstAdCreativeQuery, GetFirstAdCreativeQueryVariables>(GetFirstAdCreativeDocument, options);
        }
export type GetFirstAdCreativeQueryHookResult = ReturnType<typeof useGetFirstAdCreativeQuery>;
export type GetFirstAdCreativeLazyQueryHookResult = ReturnType<typeof useGetFirstAdCreativeLazyQuery>;
export type GetFirstAdCreativeSuspenseQueryHookResult = ReturnType<typeof useGetFirstAdCreativeSuspenseQuery>;
export type GetFirstAdCreativeQueryResult = Apollo.QueryResult<GetFirstAdCreativeQuery, GetFirstAdCreativeQueryVariables>;
export const InsertAdDocument = gql`
    mutation InsertAd($input: campaign_ad_insert_input!) {
  insert_campaign_ad_one(object: $input) {
    ...Ad
  }
}
    ${AdFragmentDoc}
${AdCreativeFragmentDoc}
${CreativeFeedbackFragmentDoc}`;
export type InsertAdMutationFn = Apollo.MutationFunction<InsertAdMutation, InsertAdMutationVariables>;

/**
 * __useInsertAdMutation__
 *
 * To run a mutation, you first call `useInsertAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAdMutation, { data, loading, error }] = useInsertAdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertAdMutation(baseOptions?: Apollo.MutationHookOptions<InsertAdMutation, InsertAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAdMutation, InsertAdMutationVariables>(InsertAdDocument, options);
      }
export type InsertAdMutationHookResult = ReturnType<typeof useInsertAdMutation>;
export type InsertAdMutationResult = Apollo.MutationResult<InsertAdMutation>;
export type InsertAdMutationOptions = Apollo.BaseMutationOptions<InsertAdMutation, InsertAdMutationVariables>;
export const InsertCreativeDocument = gql`
    mutation InsertCreative($input: ad_creative_insert_input!) {
  insert_ad_creative_one(object: $input) {
    ...AdCreative
    created_at
  }
}
    ${AdCreativeFragmentDoc}
${CreativeFeedbackFragmentDoc}`;
export type InsertCreativeMutationFn = Apollo.MutationFunction<InsertCreativeMutation, InsertCreativeMutationVariables>;

/**
 * __useInsertCreativeMutation__
 *
 * To run a mutation, you first call `useInsertCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCreativeMutation, { data, loading, error }] = useInsertCreativeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertCreativeMutation(baseOptions?: Apollo.MutationHookOptions<InsertCreativeMutation, InsertCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCreativeMutation, InsertCreativeMutationVariables>(InsertCreativeDocument, options);
      }
export type InsertCreativeMutationHookResult = ReturnType<typeof useInsertCreativeMutation>;
export type InsertCreativeMutationResult = Apollo.MutationResult<InsertCreativeMutation>;
export type InsertCreativeMutationOptions = Apollo.BaseMutationOptions<InsertCreativeMutation, InsertCreativeMutationVariables>;
export const InsertCreativeFeedbackDocument = gql`
    mutation InsertCreativeFeedback($creative_id: uuid!, $feedback: String!) {
  insert_ad_creative_feedback_one(
    object: {creative_id: $creative_id, text: $feedback}
  ) {
    ...CreativeFeedback
  }
}
    ${CreativeFeedbackFragmentDoc}`;
export type InsertCreativeFeedbackMutationFn = Apollo.MutationFunction<InsertCreativeFeedbackMutation, InsertCreativeFeedbackMutationVariables>;

/**
 * __useInsertCreativeFeedbackMutation__
 *
 * To run a mutation, you first call `useInsertCreativeFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCreativeFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCreativeFeedbackMutation, { data, loading, error }] = useInsertCreativeFeedbackMutation({
 *   variables: {
 *      creative_id: // value for 'creative_id'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useInsertCreativeFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<InsertCreativeFeedbackMutation, InsertCreativeFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCreativeFeedbackMutation, InsertCreativeFeedbackMutationVariables>(InsertCreativeFeedbackDocument, options);
      }
export type InsertCreativeFeedbackMutationHookResult = ReturnType<typeof useInsertCreativeFeedbackMutation>;
export type InsertCreativeFeedbackMutationResult = Apollo.MutationResult<InsertCreativeFeedbackMutation>;
export type InsertCreativeFeedbackMutationOptions = Apollo.BaseMutationOptions<InsertCreativeFeedbackMutation, InsertCreativeFeedbackMutationVariables>;
export const LinkAdCampaignDocument = gql`
    mutation LinkAdCampaign($adCampaignId: uuid!, $campaignId: uuid!) {
  update_ad_campaign_metrics_by_pk(
    pk_columns: {id: $adCampaignId}
    _set: {campaign_id: $campaignId}
  ) {
    ...AdCampaign
  }
}
    ${AdCampaignFragmentDoc}`;
export type LinkAdCampaignMutationFn = Apollo.MutationFunction<LinkAdCampaignMutation, LinkAdCampaignMutationVariables>;

/**
 * __useLinkAdCampaignMutation__
 *
 * To run a mutation, you first call `useLinkAdCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAdCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAdCampaignMutation, { data, loading, error }] = useLinkAdCampaignMutation({
 *   variables: {
 *      adCampaignId: // value for 'adCampaignId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useLinkAdCampaignMutation(baseOptions?: Apollo.MutationHookOptions<LinkAdCampaignMutation, LinkAdCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkAdCampaignMutation, LinkAdCampaignMutationVariables>(LinkAdCampaignDocument, options);
      }
export type LinkAdCampaignMutationHookResult = ReturnType<typeof useLinkAdCampaignMutation>;
export type LinkAdCampaignMutationResult = Apollo.MutationResult<LinkAdCampaignMutation>;
export type LinkAdCampaignMutationOptions = Apollo.BaseMutationOptions<LinkAdCampaignMutation, LinkAdCampaignMutationVariables>;
export const GetTrafficByPlatformDocument = gql`
    query GetTrafficByPlatform {
  ad_platform {
    ...PlatformTrafficMetrics
  }
}
    ${PlatformTrafficMetricsFragmentDoc}`;

/**
 * __useGetTrafficByPlatformQuery__
 *
 * To run a query within a React component, call `useGetTrafficByPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrafficByPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrafficByPlatformQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrafficByPlatformQuery(baseOptions?: Apollo.QueryHookOptions<GetTrafficByPlatformQuery, GetTrafficByPlatformQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrafficByPlatformQuery, GetTrafficByPlatformQueryVariables>(GetTrafficByPlatformDocument, options);
      }
export function useGetTrafficByPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrafficByPlatformQuery, GetTrafficByPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrafficByPlatformQuery, GetTrafficByPlatformQueryVariables>(GetTrafficByPlatformDocument, options);
        }
export function useGetTrafficByPlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrafficByPlatformQuery, GetTrafficByPlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrafficByPlatformQuery, GetTrafficByPlatformQueryVariables>(GetTrafficByPlatformDocument, options);
        }
export type GetTrafficByPlatformQueryHookResult = ReturnType<typeof useGetTrafficByPlatformQuery>;
export type GetTrafficByPlatformLazyQueryHookResult = ReturnType<typeof useGetTrafficByPlatformLazyQuery>;
export type GetTrafficByPlatformSuspenseQueryHookResult = ReturnType<typeof useGetTrafficByPlatformSuspenseQuery>;
export type GetTrafficByPlatformQueryResult = Apollo.QueryResult<GetTrafficByPlatformQuery, GetTrafficByPlatformQueryVariables>;
export const UnlinkAdCampaignDocument = gql`
    mutation UnlinkAdCampaign($adCampaignId: uuid!) {
  update_ad_campaign_metrics_by_pk(
    pk_columns: {id: $adCampaignId}
    _set: {campaign_id: null}
  ) {
    ...AdCampaign
  }
}
    ${AdCampaignFragmentDoc}`;
export type UnlinkAdCampaignMutationFn = Apollo.MutationFunction<UnlinkAdCampaignMutation, UnlinkAdCampaignMutationVariables>;

/**
 * __useUnlinkAdCampaignMutation__
 *
 * To run a mutation, you first call `useUnlinkAdCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkAdCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkAdCampaignMutation, { data, loading, error }] = useUnlinkAdCampaignMutation({
 *   variables: {
 *      adCampaignId: // value for 'adCampaignId'
 *   },
 * });
 */
export function useUnlinkAdCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkAdCampaignMutation, UnlinkAdCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkAdCampaignMutation, UnlinkAdCampaignMutationVariables>(UnlinkAdCampaignDocument, options);
      }
export type UnlinkAdCampaignMutationHookResult = ReturnType<typeof useUnlinkAdCampaignMutation>;
export type UnlinkAdCampaignMutationResult = Apollo.MutationResult<UnlinkAdCampaignMutation>;
export type UnlinkAdCampaignMutationOptions = Apollo.BaseMutationOptions<UnlinkAdCampaignMutation, UnlinkAdCampaignMutationVariables>;
export const UpdateAdDocument = gql`
    mutation UpdateAd($id: uuid!, $input: campaign_ad_set_input!) {
  update_campaign_ad_by_pk(pk_columns: {id: $id}, _set: $input) {
    ...Ad
  }
}
    ${AdFragmentDoc}
${AdCreativeFragmentDoc}
${CreativeFeedbackFragmentDoc}`;
export type UpdateAdMutationFn = Apollo.MutationFunction<UpdateAdMutation, UpdateAdMutationVariables>;

/**
 * __useUpdateAdMutation__
 *
 * To run a mutation, you first call `useUpdateAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdMutation, { data, loading, error }] = useUpdateAdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdMutation, UpdateAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdMutation, UpdateAdMutationVariables>(UpdateAdDocument, options);
      }
export type UpdateAdMutationHookResult = ReturnType<typeof useUpdateAdMutation>;
export type UpdateAdMutationResult = Apollo.MutationResult<UpdateAdMutation>;
export type UpdateAdMutationOptions = Apollo.BaseMutationOptions<UpdateAdMutation, UpdateAdMutationVariables>;
export const UpdateCreativeDocument = gql`
    mutation UpdateCreative($ad_id: uuid!, $creative_id: uuid!, $input: ad_creative_set_input!) {
  update_ad_creative_by_pk(pk_columns: {id: $creative_id}, _set: $input) {
    ...AdCreative
  }
  update_campaign_ad_by_pk(
    pk_columns: {id: $ad_id}
    _set: {creative_id: $creative_id}
  ) {
    id
    creative {
      ...AdCreative
    }
  }
}
    ${AdCreativeFragmentDoc}
${CreativeFeedbackFragmentDoc}`;
export type UpdateCreativeMutationFn = Apollo.MutationFunction<UpdateCreativeMutation, UpdateCreativeMutationVariables>;

/**
 * __useUpdateCreativeMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeMutation, { data, loading, error }] = useUpdateCreativeMutation({
 *   variables: {
 *      ad_id: // value for 'ad_id'
 *      creative_id: // value for 'creative_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreativeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeMutation, UpdateCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeMutation, UpdateCreativeMutationVariables>(UpdateCreativeDocument, options);
      }
export type UpdateCreativeMutationHookResult = ReturnType<typeof useUpdateCreativeMutation>;
export type UpdateCreativeMutationResult = Apollo.MutationResult<UpdateCreativeMutation>;
export type UpdateCreativeMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeMutation, UpdateCreativeMutationVariables>;
export const WithdrawAdDocument = gql`
    mutation WithdrawAd($id: uuid!) {
  update_campaign_ad_by_pk(
    pk_columns: {id: $id}
    _set: {status: WAITING_FOR_APPROVAL}
  ) {
    id
    status
  }
}
    `;
export type WithdrawAdMutationFn = Apollo.MutationFunction<WithdrawAdMutation, WithdrawAdMutationVariables>;

/**
 * __useWithdrawAdMutation__
 *
 * To run a mutation, you first call `useWithdrawAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawAdMutation, { data, loading, error }] = useWithdrawAdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWithdrawAdMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawAdMutation, WithdrawAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawAdMutation, WithdrawAdMutationVariables>(WithdrawAdDocument, options);
      }
export type WithdrawAdMutationHookResult = ReturnType<typeof useWithdrawAdMutation>;
export type WithdrawAdMutationResult = Apollo.MutationResult<WithdrawAdMutation>;
export type WithdrawAdMutationOptions = Apollo.BaseMutationOptions<WithdrawAdMutation, WithdrawAdMutationVariables>;
export const GetCampaignAtsInsightsDocument = gql`
    query GetCampaignAtsInsights($campaignId: uuid!) {
  success_true: rms_forwarded_logs_aggregate(
    where: {campaign_id: {_eq: $campaignId}, success: {_eq: true}}
  ) {
    aggregate {
      count
    }
  }
  success_false: rms_forwarded_logs_aggregate(
    where: {campaign_id: {_eq: $campaignId}, success: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCampaignAtsInsightsQuery__
 *
 * To run a query within a React component, call `useGetCampaignAtsInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignAtsInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignAtsInsightsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignAtsInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignAtsInsightsQuery, GetCampaignAtsInsightsQueryVariables> & ({ variables: GetCampaignAtsInsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignAtsInsightsQuery, GetCampaignAtsInsightsQueryVariables>(GetCampaignAtsInsightsDocument, options);
      }
export function useGetCampaignAtsInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignAtsInsightsQuery, GetCampaignAtsInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignAtsInsightsQuery, GetCampaignAtsInsightsQueryVariables>(GetCampaignAtsInsightsDocument, options);
        }
export function useGetCampaignAtsInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignAtsInsightsQuery, GetCampaignAtsInsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignAtsInsightsQuery, GetCampaignAtsInsightsQueryVariables>(GetCampaignAtsInsightsDocument, options);
        }
export type GetCampaignAtsInsightsQueryHookResult = ReturnType<typeof useGetCampaignAtsInsightsQuery>;
export type GetCampaignAtsInsightsLazyQueryHookResult = ReturnType<typeof useGetCampaignAtsInsightsLazyQuery>;
export type GetCampaignAtsInsightsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignAtsInsightsSuspenseQuery>;
export type GetCampaignAtsInsightsQueryResult = Apollo.QueryResult<GetCampaignAtsInsightsQuery, GetCampaignAtsInsightsQueryVariables>;
export const IncreaseCampaignBudgetDocument = gql`
    mutation IncreaseCampaignBudget($campaign_id: uuid!, $amount: float8!, $new_end: timestamptz!, $new_daily_budget: numeric, $new_daily_media_budget: numeric) {
  insert_campaign_budget_transaction_one(
    object: {amount: $amount, campaign_id: $campaign_id, type: MANUAL}
  ) {
    ...CampaignBudgetTransaction
  }
  update_campaign_by_pk(
    pk_columns: {id: $campaign_id}
    _set: {end: $new_end, daily_budget: $new_daily_budget, daily_media_budget: $new_daily_media_budget}
  ) {
    id
  }
}
    ${CampaignBudgetTransactionFragmentDoc}`;
export type IncreaseCampaignBudgetMutationFn = Apollo.MutationFunction<IncreaseCampaignBudgetMutation, IncreaseCampaignBudgetMutationVariables>;

/**
 * __useIncreaseCampaignBudgetMutation__
 *
 * To run a mutation, you first call `useIncreaseCampaignBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncreaseCampaignBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [increaseCampaignBudgetMutation, { data, loading, error }] = useIncreaseCampaignBudgetMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *      amount: // value for 'amount'
 *      new_end: // value for 'new_end'
 *      new_daily_budget: // value for 'new_daily_budget'
 *      new_daily_media_budget: // value for 'new_daily_media_budget'
 *   },
 * });
 */
export function useIncreaseCampaignBudgetMutation(baseOptions?: Apollo.MutationHookOptions<IncreaseCampaignBudgetMutation, IncreaseCampaignBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IncreaseCampaignBudgetMutation, IncreaseCampaignBudgetMutationVariables>(IncreaseCampaignBudgetDocument, options);
      }
export type IncreaseCampaignBudgetMutationHookResult = ReturnType<typeof useIncreaseCampaignBudgetMutation>;
export type IncreaseCampaignBudgetMutationResult = Apollo.MutationResult<IncreaseCampaignBudgetMutation>;
export type IncreaseCampaignBudgetMutationOptions = Apollo.BaseMutationOptions<IncreaseCampaignBudgetMutation, IncreaseCampaignBudgetMutationVariables>;
export const InsertBudgetTransactionDocument = gql`
    mutation InsertBudgetTransaction($campaign_id: uuid!, $amount: float8!) {
  insert_campaign_budget_transaction_one(
    object: {campaign_id: $campaign_id, amount: $amount, type: MANUAL}
  ) {
    ...CampaignBudgetTransaction
  }
}
    ${CampaignBudgetTransactionFragmentDoc}`;
export type InsertBudgetTransactionMutationFn = Apollo.MutationFunction<InsertBudgetTransactionMutation, InsertBudgetTransactionMutationVariables>;

/**
 * __useInsertBudgetTransactionMutation__
 *
 * To run a mutation, you first call `useInsertBudgetTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertBudgetTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBudgetTransactionMutation, { data, loading, error }] = useInsertBudgetTransactionMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useInsertBudgetTransactionMutation(baseOptions?: Apollo.MutationHookOptions<InsertBudgetTransactionMutation, InsertBudgetTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertBudgetTransactionMutation, InsertBudgetTransactionMutationVariables>(InsertBudgetTransactionDocument, options);
      }
export type InsertBudgetTransactionMutationHookResult = ReturnType<typeof useInsertBudgetTransactionMutation>;
export type InsertBudgetTransactionMutationResult = Apollo.MutationResult<InsertBudgetTransactionMutation>;
export type InsertBudgetTransactionMutationOptions = Apollo.BaseMutationOptions<InsertBudgetTransactionMutation, InsertBudgetTransactionMutationVariables>;
export const InsertInitialBudgetDocument = gql`
    mutation InsertInitialBudget($budget: float8!, $campaignId: uuid!) {
  insert_campaign_budget_transaction_one(
    object: {campaign_id: $campaignId, type: INITIAL, amount: $budget}
  ) {
    id
  }
}
    `;
export type InsertInitialBudgetMutationFn = Apollo.MutationFunction<InsertInitialBudgetMutation, InsertInitialBudgetMutationVariables>;

/**
 * __useInsertInitialBudgetMutation__
 *
 * To run a mutation, you first call `useInsertInitialBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertInitialBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertInitialBudgetMutation, { data, loading, error }] = useInsertInitialBudgetMutation({
 *   variables: {
 *      budget: // value for 'budget'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useInsertInitialBudgetMutation(baseOptions?: Apollo.MutationHookOptions<InsertInitialBudgetMutation, InsertInitialBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertInitialBudgetMutation, InsertInitialBudgetMutationVariables>(InsertInitialBudgetDocument, options);
      }
export type InsertInitialBudgetMutationHookResult = ReturnType<typeof useInsertInitialBudgetMutation>;
export type InsertInitialBudgetMutationResult = Apollo.MutationResult<InsertInitialBudgetMutation>;
export type InsertInitialBudgetMutationOptions = Apollo.BaseMutationOptions<InsertInitialBudgetMutation, InsertInitialBudgetMutationVariables>;
export const ResetDailyTransactionsDocument = gql`
    mutation ResetDailyTransactions($campaign_id: uuid) {
  delete_campaign_budget_transaction(
    where: {type: {_eq: DAILY}, campaign_id: {_eq: $campaign_id}}
  ) {
    affected_rows
  }
}
    `;
export type ResetDailyTransactionsMutationFn = Apollo.MutationFunction<ResetDailyTransactionsMutation, ResetDailyTransactionsMutationVariables>;

/**
 * __useResetDailyTransactionsMutation__
 *
 * To run a mutation, you first call `useResetDailyTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetDailyTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetDailyTransactionsMutation, { data, loading, error }] = useResetDailyTransactionsMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useResetDailyTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<ResetDailyTransactionsMutation, ResetDailyTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetDailyTransactionsMutation, ResetDailyTransactionsMutationVariables>(ResetDailyTransactionsDocument, options);
      }
export type ResetDailyTransactionsMutationHookResult = ReturnType<typeof useResetDailyTransactionsMutation>;
export type ResetDailyTransactionsMutationResult = Apollo.MutationResult<ResetDailyTransactionsMutation>;
export type ResetDailyTransactionsMutationOptions = Apollo.BaseMutationOptions<ResetDailyTransactionsMutation, ResetDailyTransactionsMutationVariables>;
export const UpdateInitialTransactionDocument = gql`
    mutation UpdateInitialTransaction($campaign_id: uuid!, $amount: float8!) {
  update_campaign_budget_transaction(
    where: {type: {_eq: INITIAL}, campaign_id: {_eq: $campaign_id}}
    _set: {amount: $amount}
  ) {
    affected_rows
  }
}
    `;
export type UpdateInitialTransactionMutationFn = Apollo.MutationFunction<UpdateInitialTransactionMutation, UpdateInitialTransactionMutationVariables>;

/**
 * __useUpdateInitialTransactionMutation__
 *
 * To run a mutation, you first call `useUpdateInitialTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInitialTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInitialTransactionMutation, { data, loading, error }] = useUpdateInitialTransactionMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useUpdateInitialTransactionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInitialTransactionMutation, UpdateInitialTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInitialTransactionMutation, UpdateInitialTransactionMutationVariables>(UpdateInitialTransactionDocument, options);
      }
export type UpdateInitialTransactionMutationHookResult = ReturnType<typeof useUpdateInitialTransactionMutation>;
export type UpdateInitialTransactionMutationResult = Apollo.MutationResult<UpdateInitialTransactionMutation>;
export type UpdateInitialTransactionMutationOptions = Apollo.BaseMutationOptions<UpdateInitialTransactionMutation, UpdateInitialTransactionMutationVariables>;
export const GetCampaignBudgetDocument = gql`
    query GetCampaignBudget($id: uuid!, $limit: Int!, $offset: Int!, $createdAtSort: order_by) {
  campaign_budget(where: {campaign_id: {_eq: $id}}) {
    amount
  }
  campaign_budget_transaction(
    where: {campaign_id: {_eq: $id}}
    limit: $limit
    offset: $offset
    order_by: [{created_at: $createdAtSort}]
  ) {
    ...CampaignBudgetTransaction
  }
  campaign_budget_transaction_aggregate(where: {campaign_id: {_eq: $id}}) {
    aggregate {
      count
    }
  }
}
    ${CampaignBudgetTransactionFragmentDoc}`;

/**
 * __useGetCampaignBudgetQuery__
 *
 * To run a query within a React component, call `useGetCampaignBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignBudgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      createdAtSort: // value for 'createdAtSort'
 *   },
 * });
 */
export function useGetCampaignBudgetQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignBudgetQuery, GetCampaignBudgetQueryVariables> & ({ variables: GetCampaignBudgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignBudgetQuery, GetCampaignBudgetQueryVariables>(GetCampaignBudgetDocument, options);
      }
export function useGetCampaignBudgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignBudgetQuery, GetCampaignBudgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignBudgetQuery, GetCampaignBudgetQueryVariables>(GetCampaignBudgetDocument, options);
        }
export function useGetCampaignBudgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignBudgetQuery, GetCampaignBudgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignBudgetQuery, GetCampaignBudgetQueryVariables>(GetCampaignBudgetDocument, options);
        }
export type GetCampaignBudgetQueryHookResult = ReturnType<typeof useGetCampaignBudgetQuery>;
export type GetCampaignBudgetLazyQueryHookResult = ReturnType<typeof useGetCampaignBudgetLazyQuery>;
export type GetCampaignBudgetSuspenseQueryHookResult = ReturnType<typeof useGetCampaignBudgetSuspenseQuery>;
export type GetCampaignBudgetQueryResult = Apollo.QueryResult<GetCampaignBudgetQuery, GetCampaignBudgetQueryVariables>;
export const GetCampaignBudgetTransactionsDocument = gql`
    query GetCampaignBudgetTransactions($campaignId: uuid!) {
  campaign_budget_transaction(
    where: {campaign_id: {_eq: $campaignId}}
    order_by: [{created_at: asc}]
    limit: 50000
  ) {
    amount
    created_at
    type
  }
}
    `;

/**
 * __useGetCampaignBudgetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetCampaignBudgetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignBudgetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignBudgetTransactionsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignBudgetTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignBudgetTransactionsQuery, GetCampaignBudgetTransactionsQueryVariables> & ({ variables: GetCampaignBudgetTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignBudgetTransactionsQuery, GetCampaignBudgetTransactionsQueryVariables>(GetCampaignBudgetTransactionsDocument, options);
      }
export function useGetCampaignBudgetTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignBudgetTransactionsQuery, GetCampaignBudgetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignBudgetTransactionsQuery, GetCampaignBudgetTransactionsQueryVariables>(GetCampaignBudgetTransactionsDocument, options);
        }
export function useGetCampaignBudgetTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignBudgetTransactionsQuery, GetCampaignBudgetTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignBudgetTransactionsQuery, GetCampaignBudgetTransactionsQueryVariables>(GetCampaignBudgetTransactionsDocument, options);
        }
export type GetCampaignBudgetTransactionsQueryHookResult = ReturnType<typeof useGetCampaignBudgetTransactionsQuery>;
export type GetCampaignBudgetTransactionsLazyQueryHookResult = ReturnType<typeof useGetCampaignBudgetTransactionsLazyQuery>;
export type GetCampaignBudgetTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignBudgetTransactionsSuspenseQuery>;
export type GetCampaignBudgetTransactionsQueryResult = Apollo.QueryResult<GetCampaignBudgetTransactionsQuery, GetCampaignBudgetTransactionsQueryVariables>;
export const GetOrganizationCampaignBudgetDocument = gql`
    query GetOrganizationCampaignBudget($org_id: String) {
  campaign_budget_aggregate(where: {campaign: {organization_id: {_eq: $org_id}}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetOrganizationCampaignBudgetQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCampaignBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCampaignBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCampaignBudgetQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetOrganizationCampaignBudgetQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationCampaignBudgetQuery, GetOrganizationCampaignBudgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCampaignBudgetQuery, GetOrganizationCampaignBudgetQueryVariables>(GetOrganizationCampaignBudgetDocument, options);
      }
export function useGetOrganizationCampaignBudgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCampaignBudgetQuery, GetOrganizationCampaignBudgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCampaignBudgetQuery, GetOrganizationCampaignBudgetQueryVariables>(GetOrganizationCampaignBudgetDocument, options);
        }
export function useGetOrganizationCampaignBudgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCampaignBudgetQuery, GetOrganizationCampaignBudgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCampaignBudgetQuery, GetOrganizationCampaignBudgetQueryVariables>(GetOrganizationCampaignBudgetDocument, options);
        }
export type GetOrganizationCampaignBudgetQueryHookResult = ReturnType<typeof useGetOrganizationCampaignBudgetQuery>;
export type GetOrganizationCampaignBudgetLazyQueryHookResult = ReturnType<typeof useGetOrganizationCampaignBudgetLazyQuery>;
export type GetOrganizationCampaignBudgetSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCampaignBudgetSuspenseQuery>;
export type GetOrganizationCampaignBudgetQueryResult = Apollo.QueryResult<GetOrganizationCampaignBudgetQuery, GetOrganizationCampaignBudgetQueryVariables>;
export const DeleteFunnelQuestionDocument = gql`
    mutation DeleteFunnelQuestion($uuid: uuid!) {
  update_funnel_question(where: {id: {_eq: $uuid}}, _set: {archived: true}) {
    affected_rows
  }
}
    `;
export type DeleteFunnelQuestionMutationFn = Apollo.MutationFunction<DeleteFunnelQuestionMutation, DeleteFunnelQuestionMutationVariables>;

/**
 * __useDeleteFunnelQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteFunnelQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFunnelQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFunnelQuestionMutation, { data, loading, error }] = useDeleteFunnelQuestionMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteFunnelQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFunnelQuestionMutation, DeleteFunnelQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFunnelQuestionMutation, DeleteFunnelQuestionMutationVariables>(DeleteFunnelQuestionDocument, options);
      }
export type DeleteFunnelQuestionMutationHookResult = ReturnType<typeof useDeleteFunnelQuestionMutation>;
export type DeleteFunnelQuestionMutationResult = Apollo.MutationResult<DeleteFunnelQuestionMutation>;
export type DeleteFunnelQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteFunnelQuestionMutation, DeleteFunnelQuestionMutationVariables>;
export const GetFunnelForCampaignDocument = gql`
    query GetFunnelForCampaign($campaignId: uuid!) {
  funnel_funnels(where: {campaign_id: {_eq: $campaignId}}) {
    ...CampaignFunnel
  }
}
    ${CampaignFunnelFragmentDoc}
${FunnelQuestionFragmentDoc}`;

/**
 * __useGetFunnelForCampaignQuery__
 *
 * To run a query within a React component, call `useGetFunnelForCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunnelForCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunnelForCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetFunnelForCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetFunnelForCampaignQuery, GetFunnelForCampaignQueryVariables> & ({ variables: GetFunnelForCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunnelForCampaignQuery, GetFunnelForCampaignQueryVariables>(GetFunnelForCampaignDocument, options);
      }
export function useGetFunnelForCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunnelForCampaignQuery, GetFunnelForCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunnelForCampaignQuery, GetFunnelForCampaignQueryVariables>(GetFunnelForCampaignDocument, options);
        }
export function useGetFunnelForCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFunnelForCampaignQuery, GetFunnelForCampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFunnelForCampaignQuery, GetFunnelForCampaignQueryVariables>(GetFunnelForCampaignDocument, options);
        }
export type GetFunnelForCampaignQueryHookResult = ReturnType<typeof useGetFunnelForCampaignQuery>;
export type GetFunnelForCampaignLazyQueryHookResult = ReturnType<typeof useGetFunnelForCampaignLazyQuery>;
export type GetFunnelForCampaignSuspenseQueryHookResult = ReturnType<typeof useGetFunnelForCampaignSuspenseQuery>;
export type GetFunnelForCampaignQueryResult = Apollo.QueryResult<GetFunnelForCampaignQuery, GetFunnelForCampaignQueryVariables>;
export const GetFunnelQuestionDocument = gql`
    query GetFunnelQuestion($uuid: uuid!) {
  funnel_question(where: {id: {_eq: $uuid}}) {
    ...FunnelQuestion
  }
}
    ${FunnelQuestionFragmentDoc}`;

/**
 * __useGetFunnelQuestionQuery__
 *
 * To run a query within a React component, call `useGetFunnelQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunnelQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunnelQuestionQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetFunnelQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetFunnelQuestionQuery, GetFunnelQuestionQueryVariables> & ({ variables: GetFunnelQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunnelQuestionQuery, GetFunnelQuestionQueryVariables>(GetFunnelQuestionDocument, options);
      }
export function useGetFunnelQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunnelQuestionQuery, GetFunnelQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunnelQuestionQuery, GetFunnelQuestionQueryVariables>(GetFunnelQuestionDocument, options);
        }
export function useGetFunnelQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFunnelQuestionQuery, GetFunnelQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFunnelQuestionQuery, GetFunnelQuestionQueryVariables>(GetFunnelQuestionDocument, options);
        }
export type GetFunnelQuestionQueryHookResult = ReturnType<typeof useGetFunnelQuestionQuery>;
export type GetFunnelQuestionLazyQueryHookResult = ReturnType<typeof useGetFunnelQuestionLazyQuery>;
export type GetFunnelQuestionSuspenseQueryHookResult = ReturnType<typeof useGetFunnelQuestionSuspenseQuery>;
export type GetFunnelQuestionQueryResult = Apollo.QueryResult<GetFunnelQuestionQuery, GetFunnelQuestionQueryVariables>;
export const GetFunnelQuestionsDocument = gql`
    query GetFunnelQuestions($campaign_id: uuid!) {
  funnel_question(
    where: {campaign_id: {_eq: $campaign_id}, archived: {_eq: false}}
    order_by: {position: asc}
  ) {
    ...FunnelQuestion
  }
}
    ${FunnelQuestionFragmentDoc}`;

/**
 * __useGetFunnelQuestionsQuery__
 *
 * To run a query within a React component, call `useGetFunnelQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunnelQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunnelQuestionsQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetFunnelQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetFunnelQuestionsQuery, GetFunnelQuestionsQueryVariables> & ({ variables: GetFunnelQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunnelQuestionsQuery, GetFunnelQuestionsQueryVariables>(GetFunnelQuestionsDocument, options);
      }
export function useGetFunnelQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunnelQuestionsQuery, GetFunnelQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunnelQuestionsQuery, GetFunnelQuestionsQueryVariables>(GetFunnelQuestionsDocument, options);
        }
export function useGetFunnelQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFunnelQuestionsQuery, GetFunnelQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFunnelQuestionsQuery, GetFunnelQuestionsQueryVariables>(GetFunnelQuestionsDocument, options);
        }
export type GetFunnelQuestionsQueryHookResult = ReturnType<typeof useGetFunnelQuestionsQuery>;
export type GetFunnelQuestionsLazyQueryHookResult = ReturnType<typeof useGetFunnelQuestionsLazyQuery>;
export type GetFunnelQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetFunnelQuestionsSuspenseQuery>;
export type GetFunnelQuestionsQueryResult = Apollo.QueryResult<GetFunnelQuestionsQuery, GetFunnelQuestionsQueryVariables>;
export const InsertFunnelQuestionDocument = gql`
    mutation InsertFunnelQuestion($campaign_id: uuid!) {
  insert_funnel_question(
    objects: {campaign_id: $campaign_id, question_type: "SINGLE", title: ""}
  ) {
    affected_rows
  }
}
    `;
export type InsertFunnelQuestionMutationFn = Apollo.MutationFunction<InsertFunnelQuestionMutation, InsertFunnelQuestionMutationVariables>;

/**
 * __useInsertFunnelQuestionMutation__
 *
 * To run a mutation, you first call `useInsertFunnelQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertFunnelQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertFunnelQuestionMutation, { data, loading, error }] = useInsertFunnelQuestionMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useInsertFunnelQuestionMutation(baseOptions?: Apollo.MutationHookOptions<InsertFunnelQuestionMutation, InsertFunnelQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertFunnelQuestionMutation, InsertFunnelQuestionMutationVariables>(InsertFunnelQuestionDocument, options);
      }
export type InsertFunnelQuestionMutationHookResult = ReturnType<typeof useInsertFunnelQuestionMutation>;
export type InsertFunnelQuestionMutationResult = Apollo.MutationResult<InsertFunnelQuestionMutation>;
export type InsertFunnelQuestionMutationOptions = Apollo.BaseMutationOptions<InsertFunnelQuestionMutation, InsertFunnelQuestionMutationVariables>;
export const ToggleFunnelDocument = gql`
    mutation ToggleFunnel($campaignId: uuid!, $enabled: Boolean!) {
  update_funnel_funnels(
    where: {campaign_id: {_eq: $campaignId}}
    _set: {enabled: $enabled}
  ) {
    returning {
      campaign_id
      enabled
    }
  }
}
    `;
export type ToggleFunnelMutationFn = Apollo.MutationFunction<ToggleFunnelMutation, ToggleFunnelMutationVariables>;

/**
 * __useToggleFunnelMutation__
 *
 * To run a mutation, you first call `useToggleFunnelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFunnelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFunnelMutation, { data, loading, error }] = useToggleFunnelMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleFunnelMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFunnelMutation, ToggleFunnelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFunnelMutation, ToggleFunnelMutationVariables>(ToggleFunnelDocument, options);
      }
export type ToggleFunnelMutationHookResult = ReturnType<typeof useToggleFunnelMutation>;
export type ToggleFunnelMutationResult = Apollo.MutationResult<ToggleFunnelMutation>;
export type ToggleFunnelMutationOptions = Apollo.BaseMutationOptions<ToggleFunnelMutation, ToggleFunnelMutationVariables>;
export const UpdateFunnelQuestionDocument = gql`
    mutation UpdateFunnelQuestion($uuid: uuid = "", $question_type: String = "MULTIPLE", $title: String = "") {
  update_funnel_question(
    where: {id: {_eq: $uuid}}
    _set: {question_type: $question_type, title: $title}
  ) {
    affected_rows
  }
}
    `;
export type UpdateFunnelQuestionMutationFn = Apollo.MutationFunction<UpdateFunnelQuestionMutation, UpdateFunnelQuestionMutationVariables>;

/**
 * __useUpdateFunnelQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateFunnelQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFunnelQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFunnelQuestionMutation, { data, loading, error }] = useUpdateFunnelQuestionMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      question_type: // value for 'question_type'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateFunnelQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFunnelQuestionMutation, UpdateFunnelQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFunnelQuestionMutation, UpdateFunnelQuestionMutationVariables>(UpdateFunnelQuestionDocument, options);
      }
export type UpdateFunnelQuestionMutationHookResult = ReturnType<typeof useUpdateFunnelQuestionMutation>;
export type UpdateFunnelQuestionMutationResult = Apollo.MutationResult<UpdateFunnelQuestionMutation>;
export type UpdateFunnelQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateFunnelQuestionMutation, UpdateFunnelQuestionMutationVariables>;
export const UpsertFunnelDocument = gql`
    mutation UpsertFunnel($funnel: funnel_funnels_insert_input!) {
  insert_funnel_funnels_one(
    object: $funnel
    on_conflict: {constraint: funnel_campaign_id_key, update_columns: [slug, job_caption, job_intro, job_byline, highlights, expectations_intro, expectations_items, benefits_intro, we_are_intro, we_are_byline, we_are_copy, we_are_call_to_action, call_to_action, sub_call_to_action, next_steps, formality_type, locale, cv_required, location_question_country_enabled, location_question_city_enabled, location_question_street_enabled, location_question_postalcode_enabled, contact_question_birthdate_enabled, contact_question_form_of_address_enabled, cv_question_enabled, whatsapp_share_caption, whatsapp_share_title, whatsapp_share_label, theme_color, template, logo_id, img_1_id, img_1_2_id, img_1_3_id, img_1_4_id, img_2_id, img_2_2_id, img_2_3_id, img_2_4_id, img_3_id, img_3_2_id, img_3_3_id, img_3_4_id, video_1_id, video_2_id, video_3_id, benefit_icon_id, expectation_icon_id, company_privacy_policy_url, company_privacy_policy_title, bot_consent_enabled, header_color, application_webhook_url]}
  ) {
    campaign_id
  }
}
    `;
export type UpsertFunnelMutationFn = Apollo.MutationFunction<UpsertFunnelMutation, UpsertFunnelMutationVariables>;

/**
 * __useUpsertFunnelMutation__
 *
 * To run a mutation, you first call `useUpsertFunnelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFunnelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFunnelMutation, { data, loading, error }] = useUpsertFunnelMutation({
 *   variables: {
 *      funnel: // value for 'funnel'
 *   },
 * });
 */
export function useUpsertFunnelMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFunnelMutation, UpsertFunnelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFunnelMutation, UpsertFunnelMutationVariables>(UpsertFunnelDocument, options);
      }
export type UpsertFunnelMutationHookResult = ReturnType<typeof useUpsertFunnelMutation>;
export type UpsertFunnelMutationResult = Apollo.MutationResult<UpsertFunnelMutation>;
export type UpsertFunnelMutationOptions = Apollo.BaseMutationOptions<UpsertFunnelMutation, UpsertFunnelMutationVariables>;
export const UpsertFunnelQuestionDocument = gql`
    mutation UpsertFunnelQuestion($question: funnel_question_insert_input!) {
  insert_funnel_question(
    objects: [$question]
    on_conflict: {constraint: question_pkey, update_columns: [title, question_type, position, parent_question_id, is_required, icon]}
  ) {
    returning {
      id
      title
      question_type
      position
      parent_question_id
      is_required
      icon
    }
  }
}
    `;
export type UpsertFunnelQuestionMutationFn = Apollo.MutationFunction<UpsertFunnelQuestionMutation, UpsertFunnelQuestionMutationVariables>;

/**
 * __useUpsertFunnelQuestionMutation__
 *
 * To run a mutation, you first call `useUpsertFunnelQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFunnelQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFunnelQuestionMutation, { data, loading, error }] = useUpsertFunnelQuestionMutation({
 *   variables: {
 *      question: // value for 'question'
 *   },
 * });
 */
export function useUpsertFunnelQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFunnelQuestionMutation, UpsertFunnelQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFunnelQuestionMutation, UpsertFunnelQuestionMutationVariables>(UpsertFunnelQuestionDocument, options);
      }
export type UpsertFunnelQuestionMutationHookResult = ReturnType<typeof useUpsertFunnelQuestionMutation>;
export type UpsertFunnelQuestionMutationResult = Apollo.MutationResult<UpsertFunnelQuestionMutation>;
export type UpsertFunnelQuestionMutationOptions = Apollo.BaseMutationOptions<UpsertFunnelQuestionMutation, UpsertFunnelQuestionMutationVariables>;
export const UpsertFunnelV2Document = gql`
    mutation UpsertFunnelV2($campaign_id: uuid!, $funnel: funnel_funnels_insert_input!, $benefit_inserts: [funnel_benefits_insert_input!]!, $question_updates: [funnel_question_insert_input!]!, $question_inserts: [funnel_question_insert_input!]!, $question_ids_to_keep: [uuid!]!) {
  insert_funnel_funnels_one(
    object: $funnel
    on_conflict: {constraint: funnel_campaign_id_key, update_columns: [slug, job_caption, job_intro, job_byline, highlights, expectations_intro, expectations_items, benefits_intro, we_are_intro, we_are_byline, we_are_copy, we_are_call_to_action, call_to_action, sub_call_to_action, next_steps, formality_type, locale, cv_required, location_question_country_enabled, location_question_city_enabled, location_question_street_enabled, location_question_postalcode_enabled, contact_question_birthdate_enabled, contact_question_form_of_address_enabled, cv_question_enabled, whatsapp_share_caption, whatsapp_share_title, whatsapp_share_label, theme_color, template, logo_id, img_1_id, img_1_2_id, img_1_3_id, img_1_4_id, img_2_id, img_2_2_id, img_2_3_id, img_2_4_id, img_3_id, img_3_2_id, img_3_3_id, img_3_4_id, video_1_id, video_2_id, video_3_id, benefit_icon_id, expectation_icon_id, company_privacy_policy_url, company_privacy_policy_title, bot_consent_enabled, chatbot_funnel_enabled, whatsapp_apply_label, whatsapp_apply_message_template, whatsapp_intro_message, whatsapp_outro_message, header_color, application_webhook_url]}
  ) {
    campaign_id
  }
  delete_funnel_benefits(where: {funnel: {campaign_id: {_eq: $campaign_id}}}) {
    affected_rows
  }
  insert_funnel_benefits(objects: $benefit_inserts) {
    affected_rows
  }
  delete_funnel_question_option(
    where: {question: {campaign_id: {_eq: $campaign_id}}}
  ) {
    affected_rows
  }
  delete_funnel_question(
    where: {campaign_id: {_eq: $campaign_id}, id: {_nin: $question_ids_to_keep}}
  ) {
    affected_rows
  }
  update_questions: insert_funnel_question(
    objects: $question_updates
    on_conflict: {constraint: question_pkey, update_columns: [title, question_type, position, parent_question_id, is_required, icon]}
  ) {
    affected_rows
    returning {
      id
    }
  }
  insert_questions: insert_funnel_question(objects: $question_inserts) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type UpsertFunnelV2MutationFn = Apollo.MutationFunction<UpsertFunnelV2Mutation, UpsertFunnelV2MutationVariables>;

/**
 * __useUpsertFunnelV2Mutation__
 *
 * To run a mutation, you first call `useUpsertFunnelV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFunnelV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFunnelV2Mutation, { data, loading, error }] = useUpsertFunnelV2Mutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *      funnel: // value for 'funnel'
 *      benefit_inserts: // value for 'benefit_inserts'
 *      question_updates: // value for 'question_updates'
 *      question_inserts: // value for 'question_inserts'
 *      question_ids_to_keep: // value for 'question_ids_to_keep'
 *   },
 * });
 */
export function useUpsertFunnelV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpsertFunnelV2Mutation, UpsertFunnelV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFunnelV2Mutation, UpsertFunnelV2MutationVariables>(UpsertFunnelV2Document, options);
      }
export type UpsertFunnelV2MutationHookResult = ReturnType<typeof useUpsertFunnelV2Mutation>;
export type UpsertFunnelV2MutationResult = Apollo.MutationResult<UpsertFunnelV2Mutation>;
export type UpsertFunnelV2MutationOptions = Apollo.BaseMutationOptions<UpsertFunnelV2Mutation, UpsertFunnelV2MutationVariables>;
export const GetInsightCampaignDetailsDocument = gql`
    query GetInsightCampaignDetails($id: uuid!, $hasAdvancedAccessToCampaigns: Boolean = false, $canSeeInternalInsights: Boolean!, $hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: Boolean! = false, $isAdmin: Boolean = false) {
  campaign_by_pk(id: $id) {
    ...CampaignDetails
  }
}
    ${CampaignDetailsFragmentDoc}
${OrganizationDesignationFragmentDoc}
${UnqualifiedContactsPerDayFragmentDoc}
${CampaignFragmentDoc}
${NewContactsPerDayFragmentDoc}`;

/**
 * __useGetInsightCampaignDetailsQuery__
 *
 * To run a query within a React component, call `useGetInsightCampaignDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightCampaignDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightCampaignDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      hasAdvancedAccessToCampaigns: // value for 'hasAdvancedAccessToCampaigns'
 *      canSeeInternalInsights: // value for 'canSeeInternalInsights'
 *      hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: // value for 'hasAdvancedAccessToCampaignsOrCanSeeInternalInsights'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useGetInsightCampaignDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetInsightCampaignDetailsQuery, GetInsightCampaignDetailsQueryVariables> & ({ variables: GetInsightCampaignDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightCampaignDetailsQuery, GetInsightCampaignDetailsQueryVariables>(GetInsightCampaignDetailsDocument, options);
      }
export function useGetInsightCampaignDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightCampaignDetailsQuery, GetInsightCampaignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightCampaignDetailsQuery, GetInsightCampaignDetailsQueryVariables>(GetInsightCampaignDetailsDocument, options);
        }
export function useGetInsightCampaignDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightCampaignDetailsQuery, GetInsightCampaignDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsightCampaignDetailsQuery, GetInsightCampaignDetailsQueryVariables>(GetInsightCampaignDetailsDocument, options);
        }
export type GetInsightCampaignDetailsQueryHookResult = ReturnType<typeof useGetInsightCampaignDetailsQuery>;
export type GetInsightCampaignDetailsLazyQueryHookResult = ReturnType<typeof useGetInsightCampaignDetailsLazyQuery>;
export type GetInsightCampaignDetailsSuspenseQueryHookResult = ReturnType<typeof useGetInsightCampaignDetailsSuspenseQuery>;
export type GetInsightCampaignDetailsQueryResult = Apollo.QueryResult<GetInsightCampaignDetailsQuery, GetInsightCampaignDetailsQueryVariables>;
export const GetQuestionsDocument = gql`
    query GetQuestions($campaign_id: uuid!) {
  funnel_question(
    where: {campaign_id: {_eq: $campaign_id}, question_type: {_in: ["SINGLE", "MULTIPLE", "QUIZ", "SELECT"]}}
  ) {
    ...InsightsQuestion
  }
}
    ${InsightsQuestionFragmentDoc}
${QuestionFragmentDoc}`;

/**
 * __useGetQuestionsQuery__
 *
 * To run a query within a React component, call `useGetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables> & ({ variables: GetQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
      }
export function useGetQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
        }
export function useGetQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
        }
export type GetQuestionsQueryHookResult = ReturnType<typeof useGetQuestionsQuery>;
export type GetQuestionsLazyQueryHookResult = ReturnType<typeof useGetQuestionsLazyQuery>;
export type GetQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsSuspenseQuery>;
export type GetQuestionsQueryResult = Apollo.QueryResult<GetQuestionsQuery, GetQuestionsQueryVariables>;
export const GetUnqualifiedContactsByCampaignIdDocument = gql`
    query GetUnqualifiedContactsByCampaignId($campaign_id: uuid!) {
  new_unqualified_contacts_per_day(where: {campaign_id: {_eq: $campaign_id}}) {
    ...UnqualifiedContactsPerDay
  }
}
    ${UnqualifiedContactsPerDayFragmentDoc}`;

/**
 * __useGetUnqualifiedContactsByCampaignIdQuery__
 *
 * To run a query within a React component, call `useGetUnqualifiedContactsByCampaignIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnqualifiedContactsByCampaignIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnqualifiedContactsByCampaignIdQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetUnqualifiedContactsByCampaignIdQuery(baseOptions: Apollo.QueryHookOptions<GetUnqualifiedContactsByCampaignIdQuery, GetUnqualifiedContactsByCampaignIdQueryVariables> & ({ variables: GetUnqualifiedContactsByCampaignIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnqualifiedContactsByCampaignIdQuery, GetUnqualifiedContactsByCampaignIdQueryVariables>(GetUnqualifiedContactsByCampaignIdDocument, options);
      }
export function useGetUnqualifiedContactsByCampaignIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnqualifiedContactsByCampaignIdQuery, GetUnqualifiedContactsByCampaignIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnqualifiedContactsByCampaignIdQuery, GetUnqualifiedContactsByCampaignIdQueryVariables>(GetUnqualifiedContactsByCampaignIdDocument, options);
        }
export function useGetUnqualifiedContactsByCampaignIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnqualifiedContactsByCampaignIdQuery, GetUnqualifiedContactsByCampaignIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnqualifiedContactsByCampaignIdQuery, GetUnqualifiedContactsByCampaignIdQueryVariables>(GetUnqualifiedContactsByCampaignIdDocument, options);
        }
export type GetUnqualifiedContactsByCampaignIdQueryHookResult = ReturnType<typeof useGetUnqualifiedContactsByCampaignIdQuery>;
export type GetUnqualifiedContactsByCampaignIdLazyQueryHookResult = ReturnType<typeof useGetUnqualifiedContactsByCampaignIdLazyQuery>;
export type GetUnqualifiedContactsByCampaignIdSuspenseQueryHookResult = ReturnType<typeof useGetUnqualifiedContactsByCampaignIdSuspenseQuery>;
export type GetUnqualifiedContactsByCampaignIdQueryResult = Apollo.QueryResult<GetUnqualifiedContactsByCampaignIdQuery, GetUnqualifiedContactsByCampaignIdQueryVariables>;
export const AssignOrderDocument = gql`
    mutation AssignOrder($order_id: uuid!, $responsible_user_id: bpchar!) {
  update_campaign_order_by_pk(
    pk_columns: {id: $order_id}
    _set: {responsible_user: $responsible_user_id}
  ) {
    id
    responsible_user
  }
}
    `;
export type AssignOrderMutationFn = Apollo.MutationFunction<AssignOrderMutation, AssignOrderMutationVariables>;

/**
 * __useAssignOrderMutation__
 *
 * To run a mutation, you first call `useAssignOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignOrderMutation, { data, loading, error }] = useAssignOrderMutation({
 *   variables: {
 *      order_id: // value for 'order_id'
 *      responsible_user_id: // value for 'responsible_user_id'
 *   },
 * });
 */
export function useAssignOrderMutation(baseOptions?: Apollo.MutationHookOptions<AssignOrderMutation, AssignOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignOrderMutation, AssignOrderMutationVariables>(AssignOrderDocument, options);
      }
export type AssignOrderMutationHookResult = ReturnType<typeof useAssignOrderMutation>;
export type AssignOrderMutationResult = Apollo.MutationResult<AssignOrderMutation>;
export type AssignOrderMutationOptions = Apollo.BaseMutationOptions<AssignOrderMutation, AssignOrderMutationVariables>;
export const CompleteOrderDocument = gql`
    mutation CompleteOrder($order_id: uuid!) {
  update_campaign_order_by_pk(
    pk_columns: {id: $order_id}
    _set: {completed: true}
  ) {
    id
    completed
  }
}
    `;
export type CompleteOrderMutationFn = Apollo.MutationFunction<CompleteOrderMutation, CompleteOrderMutationVariables>;

/**
 * __useCompleteOrderMutation__
 *
 * To run a mutation, you first call `useCompleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOrderMutation, { data, loading, error }] = useCompleteOrderMutation({
 *   variables: {
 *      order_id: // value for 'order_id'
 *   },
 * });
 */
export function useCompleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<CompleteOrderMutation, CompleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteOrderMutation, CompleteOrderMutationVariables>(CompleteOrderDocument, options);
      }
export type CompleteOrderMutationHookResult = ReturnType<typeof useCompleteOrderMutation>;
export type CompleteOrderMutationResult = Apollo.MutationResult<CompleteOrderMutation>;
export type CompleteOrderMutationOptions = Apollo.BaseMutationOptions<CompleteOrderMutation, CompleteOrderMutationVariables>;
export const GetCampaignOrderByIdDocument = gql`
    query GetCampaignOrderById($id: uuid!) {
  campaign_order_by_pk(id: $id) {
    ...CampaignOrder
  }
}
    ${CampaignOrderFragmentDoc}`;

/**
 * __useGetCampaignOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetCampaignOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignOrderByIdQuery, GetCampaignOrderByIdQueryVariables> & ({ variables: GetCampaignOrderByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignOrderByIdQuery, GetCampaignOrderByIdQueryVariables>(GetCampaignOrderByIdDocument, options);
      }
export function useGetCampaignOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignOrderByIdQuery, GetCampaignOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignOrderByIdQuery, GetCampaignOrderByIdQueryVariables>(GetCampaignOrderByIdDocument, options);
        }
export function useGetCampaignOrderByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignOrderByIdQuery, GetCampaignOrderByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignOrderByIdQuery, GetCampaignOrderByIdQueryVariables>(GetCampaignOrderByIdDocument, options);
        }
export type GetCampaignOrderByIdQueryHookResult = ReturnType<typeof useGetCampaignOrderByIdQuery>;
export type GetCampaignOrderByIdLazyQueryHookResult = ReturnType<typeof useGetCampaignOrderByIdLazyQuery>;
export type GetCampaignOrderByIdSuspenseQueryHookResult = ReturnType<typeof useGetCampaignOrderByIdSuspenseQuery>;
export type GetCampaignOrderByIdQueryResult = Apollo.QueryResult<GetCampaignOrderByIdQuery, GetCampaignOrderByIdQueryVariables>;
export const GetCampaignOrdersDocument = gql`
    query GetCampaignOrders($query: campaign_order_bool_exp!, $limit: Int!, $offset: Int!) {
  campaign_order(
    where: $query
    order_by: {received_at: desc, platform_job_id: desc}
    limit: $limit
    offset: $offset
  ) {
    ...CampaignOrder
  }
  campaign_order_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    ${CampaignOrderFragmentDoc}`;

/**
 * __useGetCampaignOrdersQuery__
 *
 * To run a query within a React component, call `useGetCampaignOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignOrdersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCampaignOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignOrdersQuery, GetCampaignOrdersQueryVariables> & ({ variables: GetCampaignOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignOrdersQuery, GetCampaignOrdersQueryVariables>(GetCampaignOrdersDocument, options);
      }
export function useGetCampaignOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignOrdersQuery, GetCampaignOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignOrdersQuery, GetCampaignOrdersQueryVariables>(GetCampaignOrdersDocument, options);
        }
export function useGetCampaignOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignOrdersQuery, GetCampaignOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignOrdersQuery, GetCampaignOrdersQueryVariables>(GetCampaignOrdersDocument, options);
        }
export type GetCampaignOrdersQueryHookResult = ReturnType<typeof useGetCampaignOrdersQuery>;
export type GetCampaignOrdersLazyQueryHookResult = ReturnType<typeof useGetCampaignOrdersLazyQuery>;
export type GetCampaignOrdersSuspenseQueryHookResult = ReturnType<typeof useGetCampaignOrdersSuspenseQuery>;
export type GetCampaignOrdersQueryResult = Apollo.QueryResult<GetCampaignOrdersQuery, GetCampaignOrdersQueryVariables>;
export const SetCreatedCampaignForOrderDocument = gql`
    mutation SetCreatedCampaignForOrder($order_id: uuid!, $campaign_id: uuid!) {
  update_campaign_order_by_pk(
    pk_columns: {id: $order_id}
    _set: {created_campaign: $campaign_id}
  ) {
    id
    created_campaign
  }
}
    `;
export type SetCreatedCampaignForOrderMutationFn = Apollo.MutationFunction<SetCreatedCampaignForOrderMutation, SetCreatedCampaignForOrderMutationVariables>;

/**
 * __useSetCreatedCampaignForOrderMutation__
 *
 * To run a mutation, you first call `useSetCreatedCampaignForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreatedCampaignForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreatedCampaignForOrderMutation, { data, loading, error }] = useSetCreatedCampaignForOrderMutation({
 *   variables: {
 *      order_id: // value for 'order_id'
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useSetCreatedCampaignForOrderMutation(baseOptions?: Apollo.MutationHookOptions<SetCreatedCampaignForOrderMutation, SetCreatedCampaignForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCreatedCampaignForOrderMutation, SetCreatedCampaignForOrderMutationVariables>(SetCreatedCampaignForOrderDocument, options);
      }
export type SetCreatedCampaignForOrderMutationHookResult = ReturnType<typeof useSetCreatedCampaignForOrderMutation>;
export type SetCreatedCampaignForOrderMutationResult = Apollo.MutationResult<SetCreatedCampaignForOrderMutation>;
export type SetCreatedCampaignForOrderMutationOptions = Apollo.BaseMutationOptions<SetCreatedCampaignForOrderMutation, SetCreatedCampaignForOrderMutationVariables>;
export const UnassignOrderDocument = gql`
    mutation UnassignOrder($order_id: uuid!) {
  update_campaign_order_by_pk(
    pk_columns: {id: $order_id}
    _set: {responsible_user: null}
  ) {
    id
    responsible_user
  }
}
    `;
export type UnassignOrderMutationFn = Apollo.MutationFunction<UnassignOrderMutation, UnassignOrderMutationVariables>;

/**
 * __useUnassignOrderMutation__
 *
 * To run a mutation, you first call `useUnassignOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignOrderMutation, { data, loading, error }] = useUnassignOrderMutation({
 *   variables: {
 *      order_id: // value for 'order_id'
 *   },
 * });
 */
export function useUnassignOrderMutation(baseOptions?: Apollo.MutationHookOptions<UnassignOrderMutation, UnassignOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignOrderMutation, UnassignOrderMutationVariables>(UnassignOrderDocument, options);
      }
export type UnassignOrderMutationHookResult = ReturnType<typeof useUnassignOrderMutation>;
export type UnassignOrderMutationResult = Apollo.MutationResult<UnassignOrderMutation>;
export type UnassignOrderMutationOptions = Apollo.BaseMutationOptions<UnassignOrderMutation, UnassignOrderMutationVariables>;
export const GetDistinctResponsiblePersonsDocument = gql`
    query GetDistinctResponsiblePersons {
  distinct_persons: campaign(distinct_on: responsible_person) {
    responsible_person
  }
}
    `;

/**
 * __useGetDistinctResponsiblePersonsQuery__
 *
 * To run a query within a React component, call `useGetDistinctResponsiblePersonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistinctResponsiblePersonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistinctResponsiblePersonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDistinctResponsiblePersonsQuery(baseOptions?: Apollo.QueryHookOptions<GetDistinctResponsiblePersonsQuery, GetDistinctResponsiblePersonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistinctResponsiblePersonsQuery, GetDistinctResponsiblePersonsQueryVariables>(GetDistinctResponsiblePersonsDocument, options);
      }
export function useGetDistinctResponsiblePersonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistinctResponsiblePersonsQuery, GetDistinctResponsiblePersonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistinctResponsiblePersonsQuery, GetDistinctResponsiblePersonsQueryVariables>(GetDistinctResponsiblePersonsDocument, options);
        }
export function useGetDistinctResponsiblePersonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistinctResponsiblePersonsQuery, GetDistinctResponsiblePersonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDistinctResponsiblePersonsQuery, GetDistinctResponsiblePersonsQueryVariables>(GetDistinctResponsiblePersonsDocument, options);
        }
export type GetDistinctResponsiblePersonsQueryHookResult = ReturnType<typeof useGetDistinctResponsiblePersonsQuery>;
export type GetDistinctResponsiblePersonsLazyQueryHookResult = ReturnType<typeof useGetDistinctResponsiblePersonsLazyQuery>;
export type GetDistinctResponsiblePersonsSuspenseQueryHookResult = ReturnType<typeof useGetDistinctResponsiblePersonsSuspenseQuery>;
export type GetDistinctResponsiblePersonsQueryResult = Apollo.QueryResult<GetDistinctResponsiblePersonsQuery, GetDistinctResponsiblePersonsQueryVariables>;
export const GetDistinctResponsiblePersonsByOrgIdDocument = gql`
    query GetDistinctResponsiblePersonsByOrgId($organization_id: String!) {
  distinct_persons: campaign(
    distinct_on: responsible_person
    where: {organization_id: {_eq: $organization_id}}
  ) {
    responsible_person
  }
}
    `;

/**
 * __useGetDistinctResponsiblePersonsByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetDistinctResponsiblePersonsByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistinctResponsiblePersonsByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistinctResponsiblePersonsByOrgIdQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetDistinctResponsiblePersonsByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<GetDistinctResponsiblePersonsByOrgIdQuery, GetDistinctResponsiblePersonsByOrgIdQueryVariables> & ({ variables: GetDistinctResponsiblePersonsByOrgIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistinctResponsiblePersonsByOrgIdQuery, GetDistinctResponsiblePersonsByOrgIdQueryVariables>(GetDistinctResponsiblePersonsByOrgIdDocument, options);
      }
export function useGetDistinctResponsiblePersonsByOrgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistinctResponsiblePersonsByOrgIdQuery, GetDistinctResponsiblePersonsByOrgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistinctResponsiblePersonsByOrgIdQuery, GetDistinctResponsiblePersonsByOrgIdQueryVariables>(GetDistinctResponsiblePersonsByOrgIdDocument, options);
        }
export function useGetDistinctResponsiblePersonsByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistinctResponsiblePersonsByOrgIdQuery, GetDistinctResponsiblePersonsByOrgIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDistinctResponsiblePersonsByOrgIdQuery, GetDistinctResponsiblePersonsByOrgIdQueryVariables>(GetDistinctResponsiblePersonsByOrgIdDocument, options);
        }
export type GetDistinctResponsiblePersonsByOrgIdQueryHookResult = ReturnType<typeof useGetDistinctResponsiblePersonsByOrgIdQuery>;
export type GetDistinctResponsiblePersonsByOrgIdLazyQueryHookResult = ReturnType<typeof useGetDistinctResponsiblePersonsByOrgIdLazyQuery>;
export type GetDistinctResponsiblePersonsByOrgIdSuspenseQueryHookResult = ReturnType<typeof useGetDistinctResponsiblePersonsByOrgIdSuspenseQuery>;
export type GetDistinctResponsiblePersonsByOrgIdQueryResult = Apollo.QueryResult<GetDistinctResponsiblePersonsByOrgIdQuery, GetDistinctResponsiblePersonsByOrgIdQueryVariables>;
export const GetDestinationCampaignsDocument = gql`
    query GetDestinationCampaigns($orgId: String!) {
  campaign(where: {is_hidden: {_eq: false}, organization_id: {_eq: $orgId}}) {
    ...DestinationCampaign
  }
}
    ${DestinationCampaignFragmentDoc}`;

/**
 * __useGetDestinationCampaignsQuery__
 *
 * To run a query within a React component, call `useGetDestinationCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDestinationCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDestinationCampaignsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetDestinationCampaignsQuery(baseOptions: Apollo.QueryHookOptions<GetDestinationCampaignsQuery, GetDestinationCampaignsQueryVariables> & ({ variables: GetDestinationCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDestinationCampaignsQuery, GetDestinationCampaignsQueryVariables>(GetDestinationCampaignsDocument, options);
      }
export function useGetDestinationCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDestinationCampaignsQuery, GetDestinationCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDestinationCampaignsQuery, GetDestinationCampaignsQueryVariables>(GetDestinationCampaignsDocument, options);
        }
export function useGetDestinationCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDestinationCampaignsQuery, GetDestinationCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDestinationCampaignsQuery, GetDestinationCampaignsQueryVariables>(GetDestinationCampaignsDocument, options);
        }
export type GetDestinationCampaignsQueryHookResult = ReturnType<typeof useGetDestinationCampaignsQuery>;
export type GetDestinationCampaignsLazyQueryHookResult = ReturnType<typeof useGetDestinationCampaignsLazyQuery>;
export type GetDestinationCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetDestinationCampaignsSuspenseQuery>;
export type GetDestinationCampaignsQueryResult = Apollo.QueryResult<GetDestinationCampaignsQuery, GetDestinationCampaignsQueryVariables>;
export const GetDestinationIdsForTypeDocument = gql`
    query GetDestinationIdsForType($type: String!) {
  campaign_routing_destination(
    where: {type: {_eq: $type}}
    order_by: {location_id: asc}
  ) {
    type
    location_id
  }
}
    `;

/**
 * __useGetDestinationIdsForTypeQuery__
 *
 * To run a query within a React component, call `useGetDestinationIdsForTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDestinationIdsForTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDestinationIdsForTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDestinationIdsForTypeQuery(baseOptions: Apollo.QueryHookOptions<GetDestinationIdsForTypeQuery, GetDestinationIdsForTypeQueryVariables> & ({ variables: GetDestinationIdsForTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDestinationIdsForTypeQuery, GetDestinationIdsForTypeQueryVariables>(GetDestinationIdsForTypeDocument, options);
      }
export function useGetDestinationIdsForTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDestinationIdsForTypeQuery, GetDestinationIdsForTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDestinationIdsForTypeQuery, GetDestinationIdsForTypeQueryVariables>(GetDestinationIdsForTypeDocument, options);
        }
export function useGetDestinationIdsForTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDestinationIdsForTypeQuery, GetDestinationIdsForTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDestinationIdsForTypeQuery, GetDestinationIdsForTypeQueryVariables>(GetDestinationIdsForTypeDocument, options);
        }
export type GetDestinationIdsForTypeQueryHookResult = ReturnType<typeof useGetDestinationIdsForTypeQuery>;
export type GetDestinationIdsForTypeLazyQueryHookResult = ReturnType<typeof useGetDestinationIdsForTypeLazyQuery>;
export type GetDestinationIdsForTypeSuspenseQueryHookResult = ReturnType<typeof useGetDestinationIdsForTypeSuspenseQuery>;
export type GetDestinationIdsForTypeQueryResult = Apollo.QueryResult<GetDestinationIdsForTypeQuery, GetDestinationIdsForTypeQueryVariables>;
export const GetDestinationTypesDocument = gql`
    query GetDestinationTypes {
  types: campaign_routing_destination(distinct_on: type) {
    type
    location_id
    location_name
  }
}
    `;

/**
 * __useGetDestinationTypesQuery__
 *
 * To run a query within a React component, call `useGetDestinationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDestinationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDestinationTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDestinationTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetDestinationTypesQuery, GetDestinationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDestinationTypesQuery, GetDestinationTypesQueryVariables>(GetDestinationTypesDocument, options);
      }
export function useGetDestinationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDestinationTypesQuery, GetDestinationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDestinationTypesQuery, GetDestinationTypesQueryVariables>(GetDestinationTypesDocument, options);
        }
export function useGetDestinationTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDestinationTypesQuery, GetDestinationTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDestinationTypesQuery, GetDestinationTypesQueryVariables>(GetDestinationTypesDocument, options);
        }
export type GetDestinationTypesQueryHookResult = ReturnType<typeof useGetDestinationTypesQuery>;
export type GetDestinationTypesLazyQueryHookResult = ReturnType<typeof useGetDestinationTypesLazyQuery>;
export type GetDestinationTypesSuspenseQueryHookResult = ReturnType<typeof useGetDestinationTypesSuspenseQuery>;
export type GetDestinationTypesQueryResult = Apollo.QueryResult<GetDestinationTypesQuery, GetDestinationTypesQueryVariables>;
export const GetDestinationsForTypeDocument = gql`
    query GetDestinationsForType($type: String!) {
  destinations: campaign_routing_destination(
    where: {type: {_eq: $type}}
    order_by: {location_id: asc}
  ) {
    ...Destination
  }
}
    ${DestinationFragmentDoc}
${DestinationCampaignFragmentDoc}`;

/**
 * __useGetDestinationsForTypeQuery__
 *
 * To run a query within a React component, call `useGetDestinationsForTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDestinationsForTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDestinationsForTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDestinationsForTypeQuery(baseOptions: Apollo.QueryHookOptions<GetDestinationsForTypeQuery, GetDestinationsForTypeQueryVariables> & ({ variables: GetDestinationsForTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDestinationsForTypeQuery, GetDestinationsForTypeQueryVariables>(GetDestinationsForTypeDocument, options);
      }
export function useGetDestinationsForTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDestinationsForTypeQuery, GetDestinationsForTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDestinationsForTypeQuery, GetDestinationsForTypeQueryVariables>(GetDestinationsForTypeDocument, options);
        }
export function useGetDestinationsForTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDestinationsForTypeQuery, GetDestinationsForTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDestinationsForTypeQuery, GetDestinationsForTypeQueryVariables>(GetDestinationsForTypeDocument, options);
        }
export type GetDestinationsForTypeQueryHookResult = ReturnType<typeof useGetDestinationsForTypeQuery>;
export type GetDestinationsForTypeLazyQueryHookResult = ReturnType<typeof useGetDestinationsForTypeLazyQuery>;
export type GetDestinationsForTypeSuspenseQueryHookResult = ReturnType<typeof useGetDestinationsForTypeSuspenseQuery>;
export type GetDestinationsForTypeQueryResult = Apollo.QueryResult<GetDestinationsForTypeQuery, GetDestinationsForTypeQueryVariables>;
export const UpdateDestinationDocument = gql`
    mutation UpdateDestination($locationId: Int!, $type: String!, $dest: campaign_routing_destination_set_input!) {
  update_campaign_routing_destination_by_pk(
    pk_columns: {location_id: $locationId, type: $type}
    _set: $dest
  ) {
    ...Destination
  }
}
    ${DestinationFragmentDoc}
${DestinationCampaignFragmentDoc}`;
export type UpdateDestinationMutationFn = Apollo.MutationFunction<UpdateDestinationMutation, UpdateDestinationMutationVariables>;

/**
 * __useUpdateDestinationMutation__
 *
 * To run a mutation, you first call `useUpdateDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDestinationMutation, { data, loading, error }] = useUpdateDestinationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      type: // value for 'type'
 *      dest: // value for 'dest'
 *   },
 * });
 */
export function useUpdateDestinationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDestinationMutation, UpdateDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDestinationMutation, UpdateDestinationMutationVariables>(UpdateDestinationDocument, options);
      }
export type UpdateDestinationMutationHookResult = ReturnType<typeof useUpdateDestinationMutation>;
export type UpdateDestinationMutationResult = Apollo.MutationResult<UpdateDestinationMutation>;
export type UpdateDestinationMutationOptions = Apollo.BaseMutationOptions<UpdateDestinationMutation, UpdateDestinationMutationVariables>;
export const GetCampaignChatBotSettingsDocument = gql`
    query GetCampaignChatBotSettings($campaignId: uuid!) {
  campaign_by_pk(id: $campaignId) {
    id
    chat_bot_v2_enabled
    chat_bot_enabled
  }
}
    `;

/**
 * __useGetCampaignChatBotSettingsQuery__
 *
 * To run a query within a React component, call `useGetCampaignChatBotSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignChatBotSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignChatBotSettingsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignChatBotSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignChatBotSettingsQuery, GetCampaignChatBotSettingsQueryVariables> & ({ variables: GetCampaignChatBotSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignChatBotSettingsQuery, GetCampaignChatBotSettingsQueryVariables>(GetCampaignChatBotSettingsDocument, options);
      }
export function useGetCampaignChatBotSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignChatBotSettingsQuery, GetCampaignChatBotSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignChatBotSettingsQuery, GetCampaignChatBotSettingsQueryVariables>(GetCampaignChatBotSettingsDocument, options);
        }
export function useGetCampaignChatBotSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignChatBotSettingsQuery, GetCampaignChatBotSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignChatBotSettingsQuery, GetCampaignChatBotSettingsQueryVariables>(GetCampaignChatBotSettingsDocument, options);
        }
export type GetCampaignChatBotSettingsQueryHookResult = ReturnType<typeof useGetCampaignChatBotSettingsQuery>;
export type GetCampaignChatBotSettingsLazyQueryHookResult = ReturnType<typeof useGetCampaignChatBotSettingsLazyQuery>;
export type GetCampaignChatBotSettingsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignChatBotSettingsSuspenseQuery>;
export type GetCampaignChatBotSettingsQueryResult = Apollo.QueryResult<GetCampaignChatBotSettingsQuery, GetCampaignChatBotSettingsQueryVariables>;
export const GetChatContentDocument = gql`
    query GetChatContent($contact_id: uuid!) {
  chat_bot_messages(
    where: {contact_id: {_eq: $contact_id}}
    order_by: {created_at: asc}
  ) {
    ...ChatMessage
  }
}
    ${ChatMessageFragmentDoc}`;

/**
 * __useGetChatContentQuery__
 *
 * To run a query within a React component, call `useGetChatContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatContentQuery({
 *   variables: {
 *      contact_id: // value for 'contact_id'
 *   },
 * });
 */
export function useGetChatContentQuery(baseOptions: Apollo.QueryHookOptions<GetChatContentQuery, GetChatContentQueryVariables> & ({ variables: GetChatContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatContentQuery, GetChatContentQueryVariables>(GetChatContentDocument, options);
      }
export function useGetChatContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatContentQuery, GetChatContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatContentQuery, GetChatContentQueryVariables>(GetChatContentDocument, options);
        }
export function useGetChatContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatContentQuery, GetChatContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatContentQuery, GetChatContentQueryVariables>(GetChatContentDocument, options);
        }
export type GetChatContentQueryHookResult = ReturnType<typeof useGetChatContentQuery>;
export type GetChatContentLazyQueryHookResult = ReturnType<typeof useGetChatContentLazyQuery>;
export type GetChatContentSuspenseQueryHookResult = ReturnType<typeof useGetChatContentSuspenseQuery>;
export type GetChatContentQueryResult = Apollo.QueryResult<GetChatContentQuery, GetChatContentQueryVariables>;
export const GetLlmChatBotContentDocument = gql`
    subscription GetLLMChatBotContent($contactId: uuid!) {
  bot_conversation(
    order_by: {started_at: desc}
    where: {contact_id: {_eq: $contactId}}
    limit: 1
  ) {
    ...LLMChatBotConversation
  }
}
    ${LlmChatBotConversationFragmentDoc}`;

/**
 * __useGetLlmChatBotContentSubscription__
 *
 * To run a query within a React component, call `useGetLlmChatBotContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetLlmChatBotContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLlmChatBotContentSubscription({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetLlmChatBotContentSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetLlmChatBotContentSubscription, GetLlmChatBotContentSubscriptionVariables> & ({ variables: GetLlmChatBotContentSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetLlmChatBotContentSubscription, GetLlmChatBotContentSubscriptionVariables>(GetLlmChatBotContentDocument, options);
      }
export type GetLlmChatBotContentSubscriptionHookResult = ReturnType<typeof useGetLlmChatBotContentSubscription>;
export type GetLlmChatBotContentSubscriptionResult = Apollo.SubscriptionResult<GetLlmChatBotContentSubscription>;
export const PollLlmChatBotContentDocument = gql`
    query PollLLMChatBotContent($contactId: uuid!) {
  bot_conversation(
    order_by: {started_at: desc}
    where: {contact_id: {_eq: $contactId}}
    limit: 1
  ) {
    ...LLMChatBotConversation
  }
}
    ${LlmChatBotConversationFragmentDoc}`;

/**
 * __usePollLlmChatBotContentQuery__
 *
 * To run a query within a React component, call `usePollLlmChatBotContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollLlmChatBotContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollLlmChatBotContentQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function usePollLlmChatBotContentQuery(baseOptions: Apollo.QueryHookOptions<PollLlmChatBotContentQuery, PollLlmChatBotContentQueryVariables> & ({ variables: PollLlmChatBotContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollLlmChatBotContentQuery, PollLlmChatBotContentQueryVariables>(PollLlmChatBotContentDocument, options);
      }
export function usePollLlmChatBotContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollLlmChatBotContentQuery, PollLlmChatBotContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollLlmChatBotContentQuery, PollLlmChatBotContentQueryVariables>(PollLlmChatBotContentDocument, options);
        }
export function usePollLlmChatBotContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollLlmChatBotContentQuery, PollLlmChatBotContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PollLlmChatBotContentQuery, PollLlmChatBotContentQueryVariables>(PollLlmChatBotContentDocument, options);
        }
export type PollLlmChatBotContentQueryHookResult = ReturnType<typeof usePollLlmChatBotContentQuery>;
export type PollLlmChatBotContentLazyQueryHookResult = ReturnType<typeof usePollLlmChatBotContentLazyQuery>;
export type PollLlmChatBotContentSuspenseQueryHookResult = ReturnType<typeof usePollLlmChatBotContentSuspenseQuery>;
export type PollLlmChatBotContentQueryResult = Apollo.QueryResult<PollLlmChatBotContentQuery, PollLlmChatBotContentQueryVariables>;
export const CreateContactBoardWithColumnsDocument = gql`
    mutation CreateContactBoardWithColumns($campaign_id: uuid!) {
  insert_board_contact_board_one(
    object: {campaign_id: $campaign_id, columns: {data: [{name: "Neuer Bewerber", position: 0, type: NEW_APPLICANT}, {name: "Akzeptiert", position: 1, type: CUSTOM}, {name: "Abgelehnt", position: 2, type: DECLINED}]}}
  ) {
    id
    campaign_id
    columns {
      ...ContactBoardColumn
    }
  }
}
    ${ContactBoardColumnFragmentDoc}`;
export type CreateContactBoardWithColumnsMutationFn = Apollo.MutationFunction<CreateContactBoardWithColumnsMutation, CreateContactBoardWithColumnsMutationVariables>;

/**
 * __useCreateContactBoardWithColumnsMutation__
 *
 * To run a mutation, you first call `useCreateContactBoardWithColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactBoardWithColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactBoardWithColumnsMutation, { data, loading, error }] = useCreateContactBoardWithColumnsMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useCreateContactBoardWithColumnsMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactBoardWithColumnsMutation, CreateContactBoardWithColumnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactBoardWithColumnsMutation, CreateContactBoardWithColumnsMutationVariables>(CreateContactBoardWithColumnsDocument, options);
      }
export type CreateContactBoardWithColumnsMutationHookResult = ReturnType<typeof useCreateContactBoardWithColumnsMutation>;
export type CreateContactBoardWithColumnsMutationResult = Apollo.MutationResult<CreateContactBoardWithColumnsMutation>;
export type CreateContactBoardWithColumnsMutationOptions = Apollo.BaseMutationOptions<CreateContactBoardWithColumnsMutation, CreateContactBoardWithColumnsMutationVariables>;
export const GetBoardIdsDocument = gql`
    query GetBoardIds($campaignId: uuid!) {
  board_contact_board(where: {campaign_id: {_eq: $campaignId}}) {
    id
  }
}
    `;

/**
 * __useGetBoardIdsQuery__
 *
 * To run a query within a React component, call `useGetBoardIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardIdsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetBoardIdsQuery(baseOptions: Apollo.QueryHookOptions<GetBoardIdsQuery, GetBoardIdsQueryVariables> & ({ variables: GetBoardIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBoardIdsQuery, GetBoardIdsQueryVariables>(GetBoardIdsDocument, options);
      }
export function useGetBoardIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBoardIdsQuery, GetBoardIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBoardIdsQuery, GetBoardIdsQueryVariables>(GetBoardIdsDocument, options);
        }
export function useGetBoardIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBoardIdsQuery, GetBoardIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBoardIdsQuery, GetBoardIdsQueryVariables>(GetBoardIdsDocument, options);
        }
export type GetBoardIdsQueryHookResult = ReturnType<typeof useGetBoardIdsQuery>;
export type GetBoardIdsLazyQueryHookResult = ReturnType<typeof useGetBoardIdsLazyQuery>;
export type GetBoardIdsSuspenseQueryHookResult = ReturnType<typeof useGetBoardIdsSuspenseQuery>;
export type GetBoardIdsQueryResult = Apollo.QueryResult<GetBoardIdsQuery, GetBoardIdsQueryVariables>;
export const GetContactIdByDraggableIdDocument = gql`
    query GetContactIdByDraggableId($id: uuid!) {
  board_contact_board_entry_by_pk(id: $id) {
    contact_id
  }
}
    `;

/**
 * __useGetContactIdByDraggableIdQuery__
 *
 * To run a query within a React component, call `useGetContactIdByDraggableIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdByDraggableIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdByDraggableIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactIdByDraggableIdQuery(baseOptions: Apollo.QueryHookOptions<GetContactIdByDraggableIdQuery, GetContactIdByDraggableIdQueryVariables> & ({ variables: GetContactIdByDraggableIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactIdByDraggableIdQuery, GetContactIdByDraggableIdQueryVariables>(GetContactIdByDraggableIdDocument, options);
      }
export function useGetContactIdByDraggableIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactIdByDraggableIdQuery, GetContactIdByDraggableIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactIdByDraggableIdQuery, GetContactIdByDraggableIdQueryVariables>(GetContactIdByDraggableIdDocument, options);
        }
export function useGetContactIdByDraggableIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactIdByDraggableIdQuery, GetContactIdByDraggableIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactIdByDraggableIdQuery, GetContactIdByDraggableIdQueryVariables>(GetContactIdByDraggableIdDocument, options);
        }
export type GetContactIdByDraggableIdQueryHookResult = ReturnType<typeof useGetContactIdByDraggableIdQuery>;
export type GetContactIdByDraggableIdLazyQueryHookResult = ReturnType<typeof useGetContactIdByDraggableIdLazyQuery>;
export type GetContactIdByDraggableIdSuspenseQueryHookResult = ReturnType<typeof useGetContactIdByDraggableIdSuspenseQuery>;
export type GetContactIdByDraggableIdQueryResult = Apollo.QueryResult<GetContactIdByDraggableIdQuery, GetContactIdByDraggableIdQueryVariables>;
export const GetAnnaCallCampaignDocument = gql`
    query GetAnnaCallCampaign($campaignId: uuid!) {
  anna_ai_call_campaigns(where: {campaign_id: {_eq: $campaignId}}, limit: 1) {
    id
    enabled
    tier
    call_wait_time
    webhook
    pathway_id
    campaign_data
    inbound
    max_calls
    from
  }
}
    `;

/**
 * __useGetAnnaCallCampaignQuery__
 *
 * To run a query within a React component, call `useGetAnnaCallCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnaCallCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnaCallCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetAnnaCallCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetAnnaCallCampaignQuery, GetAnnaCallCampaignQueryVariables> & ({ variables: GetAnnaCallCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnaCallCampaignQuery, GetAnnaCallCampaignQueryVariables>(GetAnnaCallCampaignDocument, options);
      }
export function useGetAnnaCallCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnaCallCampaignQuery, GetAnnaCallCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnaCallCampaignQuery, GetAnnaCallCampaignQueryVariables>(GetAnnaCallCampaignDocument, options);
        }
export function useGetAnnaCallCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnaCallCampaignQuery, GetAnnaCallCampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnaCallCampaignQuery, GetAnnaCallCampaignQueryVariables>(GetAnnaCallCampaignDocument, options);
        }
export type GetAnnaCallCampaignQueryHookResult = ReturnType<typeof useGetAnnaCallCampaignQuery>;
export type GetAnnaCallCampaignLazyQueryHookResult = ReturnType<typeof useGetAnnaCallCampaignLazyQuery>;
export type GetAnnaCallCampaignSuspenseQueryHookResult = ReturnType<typeof useGetAnnaCallCampaignSuspenseQuery>;
export type GetAnnaCallCampaignQueryResult = Apollo.QueryResult<GetAnnaCallCampaignQuery, GetAnnaCallCampaignQueryVariables>;
export const GetAnnaContactByIdDocument = gql`
    query GetAnnaContactById($contact_id: uuid!) {
  latest_anna_ai_outbound_call: anna_ai_outbound_calls(
    where: {contact_id: {_eq: $contact_id}}
    limit: 1
    order_by: {planned_at: desc}
  ) {
    contact_id
    state
    started_at
    planned_at
    ended_at
    duration
    summary
    transcripts
    q_and_a
    lang_skill
    overall_impression
    has_recording
    end_call_result
    file_id
  }
  outbound_call_attempts_count: anna_ai_outbound_calls_aggregate(
    where: {contact_id: {_eq: $contact_id}, _and: [{state: {_neq: "PLANNED"}}, {state: {_neq: "STARTED_ERROR"}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAnnaContactByIdQuery__
 *
 * To run a query within a React component, call `useGetAnnaContactByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnaContactByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnaContactByIdQuery({
 *   variables: {
 *      contact_id: // value for 'contact_id'
 *   },
 * });
 */
export function useGetAnnaContactByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAnnaContactByIdQuery, GetAnnaContactByIdQueryVariables> & ({ variables: GetAnnaContactByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnaContactByIdQuery, GetAnnaContactByIdQueryVariables>(GetAnnaContactByIdDocument, options);
      }
export function useGetAnnaContactByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnaContactByIdQuery, GetAnnaContactByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnaContactByIdQuery, GetAnnaContactByIdQueryVariables>(GetAnnaContactByIdDocument, options);
        }
export function useGetAnnaContactByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnaContactByIdQuery, GetAnnaContactByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnaContactByIdQuery, GetAnnaContactByIdQueryVariables>(GetAnnaContactByIdDocument, options);
        }
export type GetAnnaContactByIdQueryHookResult = ReturnType<typeof useGetAnnaContactByIdQuery>;
export type GetAnnaContactByIdLazyQueryHookResult = ReturnType<typeof useGetAnnaContactByIdLazyQuery>;
export type GetAnnaContactByIdSuspenseQueryHookResult = ReturnType<typeof useGetAnnaContactByIdSuspenseQuery>;
export type GetAnnaContactByIdQueryResult = Apollo.QueryResult<GetAnnaContactByIdQuery, GetAnnaContactByIdQueryVariables>;
export const GetAnnaFileByIdDocument = gql`
    query GetAnnaFileById($contact_id: uuid!) {
  latest_anna_ai_outbound_call: anna_ai_outbound_calls(
    where: {contact_id: {_eq: $contact_id}, file_id: {_is_null: false}}
    limit: 1
    order_by: {planned_at: desc}
  ) {
    ...AnnaFileFragment
  }
}
    ${AnnaFileFragmentFragmentDoc}`;

/**
 * __useGetAnnaFileByIdQuery__
 *
 * To run a query within a React component, call `useGetAnnaFileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnaFileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnaFileByIdQuery({
 *   variables: {
 *      contact_id: // value for 'contact_id'
 *   },
 * });
 */
export function useGetAnnaFileByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAnnaFileByIdQuery, GetAnnaFileByIdQueryVariables> & ({ variables: GetAnnaFileByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnaFileByIdQuery, GetAnnaFileByIdQueryVariables>(GetAnnaFileByIdDocument, options);
      }
export function useGetAnnaFileByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnaFileByIdQuery, GetAnnaFileByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnaFileByIdQuery, GetAnnaFileByIdQueryVariables>(GetAnnaFileByIdDocument, options);
        }
export function useGetAnnaFileByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnaFileByIdQuery, GetAnnaFileByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnaFileByIdQuery, GetAnnaFileByIdQueryVariables>(GetAnnaFileByIdDocument, options);
        }
export type GetAnnaFileByIdQueryHookResult = ReturnType<typeof useGetAnnaFileByIdQuery>;
export type GetAnnaFileByIdLazyQueryHookResult = ReturnType<typeof useGetAnnaFileByIdLazyQuery>;
export type GetAnnaFileByIdSuspenseQueryHookResult = ReturnType<typeof useGetAnnaFileByIdSuspenseQuery>;
export type GetAnnaFileByIdQueryResult = Apollo.QueryResult<GetAnnaFileByIdQuery, GetAnnaFileByIdQueryVariables>;
export const UpsertAnnaCallCampaignDocument = gql`
    mutation UpsertAnnaCallCampaign($campaignId: uuid!, $enabled: Boolean!, $tier: String!, $callWaitTime: Int!, $webhook: String!, $pathwayId: uuid!, $campaignData: jsonb!, $inbound: Boolean!, $maxCalls: Int!, $from: String) {
  insert_anna_ai_call_campaigns_one(
    object: {campaign_id: $campaignId, enabled: $enabled, tier: $tier, call_wait_time: $callWaitTime, webhook: $webhook, pathway_id: $pathwayId, campaign_data: $campaignData, inbound: $inbound, max_calls: $maxCalls, from: $from}
    on_conflict: {constraint: call_campaigns_campaign_id_key, update_columns: [enabled, tier, call_wait_time, webhook, pathway_id, campaign_data, inbound, max_calls, from]}
  ) {
    id
    enabled
    tier
    call_wait_time
    webhook
    pathway_id
    campaign_data
    inbound
    max_calls
    from
  }
}
    `;
export type UpsertAnnaCallCampaignMutationFn = Apollo.MutationFunction<UpsertAnnaCallCampaignMutation, UpsertAnnaCallCampaignMutationVariables>;

/**
 * __useUpsertAnnaCallCampaignMutation__
 *
 * To run a mutation, you first call `useUpsertAnnaCallCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAnnaCallCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAnnaCallCampaignMutation, { data, loading, error }] = useUpsertAnnaCallCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      enabled: // value for 'enabled'
 *      tier: // value for 'tier'
 *      callWaitTime: // value for 'callWaitTime'
 *      webhook: // value for 'webhook'
 *      pathwayId: // value for 'pathwayId'
 *      campaignData: // value for 'campaignData'
 *      inbound: // value for 'inbound'
 *      maxCalls: // value for 'maxCalls'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useUpsertAnnaCallCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAnnaCallCampaignMutation, UpsertAnnaCallCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAnnaCallCampaignMutation, UpsertAnnaCallCampaignMutationVariables>(UpsertAnnaCallCampaignDocument, options);
      }
export type UpsertAnnaCallCampaignMutationHookResult = ReturnType<typeof useUpsertAnnaCallCampaignMutation>;
export type UpsertAnnaCallCampaignMutationResult = Apollo.MutationResult<UpsertAnnaCallCampaignMutation>;
export type UpsertAnnaCallCampaignMutationOptions = Apollo.BaseMutationOptions<UpsertAnnaCallCampaignMutation, UpsertAnnaCallCampaignMutationVariables>;
export const DeleteContactBoardColumnByIdDocument = gql`
    mutation DeleteContactBoardColumnById($id: uuid!) {
  delete_board_contact_board_column_by_pk(id: $id) {
    ...ContactBoardColumn
  }
}
    ${ContactBoardColumnFragmentDoc}`;
export type DeleteContactBoardColumnByIdMutationFn = Apollo.MutationFunction<DeleteContactBoardColumnByIdMutation, DeleteContactBoardColumnByIdMutationVariables>;

/**
 * __useDeleteContactBoardColumnByIdMutation__
 *
 * To run a mutation, you first call `useDeleteContactBoardColumnByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactBoardColumnByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactBoardColumnByIdMutation, { data, loading, error }] = useDeleteContactBoardColumnByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactBoardColumnByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactBoardColumnByIdMutation, DeleteContactBoardColumnByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactBoardColumnByIdMutation, DeleteContactBoardColumnByIdMutationVariables>(DeleteContactBoardColumnByIdDocument, options);
      }
export type DeleteContactBoardColumnByIdMutationHookResult = ReturnType<typeof useDeleteContactBoardColumnByIdMutation>;
export type DeleteContactBoardColumnByIdMutationResult = Apollo.MutationResult<DeleteContactBoardColumnByIdMutation>;
export type DeleteContactBoardColumnByIdMutationOptions = Apollo.BaseMutationOptions<DeleteContactBoardColumnByIdMutation, DeleteContactBoardColumnByIdMutationVariables>;
export const GetContactBoardColumnsWithEntriesPolledDocument = gql`
    query GetContactBoardColumnsWithEntriesPolled($campaign_id: uuid!) {
  board_contact_board_column(
    where: {contact_board: {campaign_id: {_eq: $campaign_id}}}
    order_by: {position: asc}
  ) {
    ...ContactBoardColumnWithEntries
  }
}
    ${ContactBoardColumnWithEntriesFragmentDoc}
${ContactBoardEntryFragmentDoc}
${ContactFragmentDoc}
${AnswerFragmentDoc}
${AnswerOptionFragmentDoc}
${ContactBoardColumnFragmentDoc}`;

/**
 * __useGetContactBoardColumnsWithEntriesPolledQuery__
 *
 * To run a query within a React component, call `useGetContactBoardColumnsWithEntriesPolledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactBoardColumnsWithEntriesPolledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactBoardColumnsWithEntriesPolledQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetContactBoardColumnsWithEntriesPolledQuery(baseOptions: Apollo.QueryHookOptions<GetContactBoardColumnsWithEntriesPolledQuery, GetContactBoardColumnsWithEntriesPolledQueryVariables> & ({ variables: GetContactBoardColumnsWithEntriesPolledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactBoardColumnsWithEntriesPolledQuery, GetContactBoardColumnsWithEntriesPolledQueryVariables>(GetContactBoardColumnsWithEntriesPolledDocument, options);
      }
export function useGetContactBoardColumnsWithEntriesPolledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactBoardColumnsWithEntriesPolledQuery, GetContactBoardColumnsWithEntriesPolledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactBoardColumnsWithEntriesPolledQuery, GetContactBoardColumnsWithEntriesPolledQueryVariables>(GetContactBoardColumnsWithEntriesPolledDocument, options);
        }
export function useGetContactBoardColumnsWithEntriesPolledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactBoardColumnsWithEntriesPolledQuery, GetContactBoardColumnsWithEntriesPolledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactBoardColumnsWithEntriesPolledQuery, GetContactBoardColumnsWithEntriesPolledQueryVariables>(GetContactBoardColumnsWithEntriesPolledDocument, options);
        }
export type GetContactBoardColumnsWithEntriesPolledQueryHookResult = ReturnType<typeof useGetContactBoardColumnsWithEntriesPolledQuery>;
export type GetContactBoardColumnsWithEntriesPolledLazyQueryHookResult = ReturnType<typeof useGetContactBoardColumnsWithEntriesPolledLazyQuery>;
export type GetContactBoardColumnsWithEntriesPolledSuspenseQueryHookResult = ReturnType<typeof useGetContactBoardColumnsWithEntriesPolledSuspenseQuery>;
export type GetContactBoardColumnsWithEntriesPolledQueryResult = Apollo.QueryResult<GetContactBoardColumnsWithEntriesPolledQuery, GetContactBoardColumnsWithEntriesPolledQueryVariables>;
export const GetContactBoardColumnsWithEntriesDocument = gql`
    subscription GetContactBoardColumnsWithEntries($campaign_id: uuid!) {
  board_contact_board_column(
    where: {contact_board: {campaign_id: {_eq: $campaign_id}}}
    order_by: {position: asc}
  ) {
    ...ContactBoardColumnWithEntries
  }
}
    ${ContactBoardColumnWithEntriesFragmentDoc}
${ContactBoardEntryFragmentDoc}
${ContactFragmentDoc}
${AnswerFragmentDoc}
${AnswerOptionFragmentDoc}
${ContactBoardColumnFragmentDoc}`;

/**
 * __useGetContactBoardColumnsWithEntriesSubscription__
 *
 * To run a query within a React component, call `useGetContactBoardColumnsWithEntriesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetContactBoardColumnsWithEntriesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactBoardColumnsWithEntriesSubscription({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetContactBoardColumnsWithEntriesSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetContactBoardColumnsWithEntriesSubscription, GetContactBoardColumnsWithEntriesSubscriptionVariables> & ({ variables: GetContactBoardColumnsWithEntriesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetContactBoardColumnsWithEntriesSubscription, GetContactBoardColumnsWithEntriesSubscriptionVariables>(GetContactBoardColumnsWithEntriesDocument, options);
      }
export type GetContactBoardColumnsWithEntriesSubscriptionHookResult = ReturnType<typeof useGetContactBoardColumnsWithEntriesSubscription>;
export type GetContactBoardColumnsWithEntriesSubscriptionResult = Apollo.SubscriptionResult<GetContactBoardColumnsWithEntriesSubscription>;
export const UpsertContactBoardColumnsDocument = gql`
    mutation UpsertContactBoardColumns($columns: [board_contact_board_column_insert_input!]!) {
  insert_board_contact_board_column(
    objects: $columns
    on_conflict: {constraint: contact_board_column_pkey, update_columns: [name, position]}
  ) {
    returning {
      ...ContactBoardColumn
    }
  }
}
    ${ContactBoardColumnFragmentDoc}`;
export type UpsertContactBoardColumnsMutationFn = Apollo.MutationFunction<UpsertContactBoardColumnsMutation, UpsertContactBoardColumnsMutationVariables>;

/**
 * __useUpsertContactBoardColumnsMutation__
 *
 * To run a mutation, you first call `useUpsertContactBoardColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContactBoardColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContactBoardColumnsMutation, { data, loading, error }] = useUpsertContactBoardColumnsMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *   },
 * });
 */
export function useUpsertContactBoardColumnsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertContactBoardColumnsMutation, UpsertContactBoardColumnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertContactBoardColumnsMutation, UpsertContactBoardColumnsMutationVariables>(UpsertContactBoardColumnsDocument, options);
      }
export type UpsertContactBoardColumnsMutationHookResult = ReturnType<typeof useUpsertContactBoardColumnsMutation>;
export type UpsertContactBoardColumnsMutationResult = Apollo.MutationResult<UpsertContactBoardColumnsMutation>;
export type UpsertContactBoardColumnsMutationOptions = Apollo.BaseMutationOptions<UpsertContactBoardColumnsMutation, UpsertContactBoardColumnsMutationVariables>;
export const GetContactLogsDocument = gql`
    query GetContactLogs($contact_id: uuid!) {
  contact_logs(
    where: {contact_id: {_eq: $contact_id}}
    order_by: {created_at: desc}
  ) {
    id
    contact_id
    campaign_id
    created_at
    qualified_at
    bot_started_at
    bot_ended_at
    report_generated_at
    rms_forwarded_at
    error
    payload
  }
}
    `;

/**
 * __useGetContactLogsQuery__
 *
 * To run a query within a React component, call `useGetContactLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactLogsQuery({
 *   variables: {
 *      contact_id: // value for 'contact_id'
 *   },
 * });
 */
export function useGetContactLogsQuery(baseOptions: Apollo.QueryHookOptions<GetContactLogsQuery, GetContactLogsQueryVariables> & ({ variables: GetContactLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactLogsQuery, GetContactLogsQueryVariables>(GetContactLogsDocument, options);
      }
export function useGetContactLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactLogsQuery, GetContactLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactLogsQuery, GetContactLogsQueryVariables>(GetContactLogsDocument, options);
        }
export function useGetContactLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactLogsQuery, GetContactLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactLogsQuery, GetContactLogsQueryVariables>(GetContactLogsDocument, options);
        }
export type GetContactLogsQueryHookResult = ReturnType<typeof useGetContactLogsQuery>;
export type GetContactLogsLazyQueryHookResult = ReturnType<typeof useGetContactLogsLazyQuery>;
export type GetContactLogsSuspenseQueryHookResult = ReturnType<typeof useGetContactLogsSuspenseQuery>;
export type GetContactLogsQueryResult = Apollo.QueryResult<GetContactLogsQuery, GetContactLogsQueryVariables>;
export const UpdateContactBoardEntryDocument = gql`
    mutation UpdateContactBoardEntry($id: uuid!, $column_id: uuid!, $position: Int!) {
  update_board_contact_board_entry_by_pk(
    pk_columns: {id: $id}
    _set: {column_id: $column_id, position: $position}
  ) {
    ...ContactBoardEntry
  }
}
    ${ContactBoardEntryFragmentDoc}
${ContactFragmentDoc}
${AnswerFragmentDoc}
${AnswerOptionFragmentDoc}`;
export type UpdateContactBoardEntryMutationFn = Apollo.MutationFunction<UpdateContactBoardEntryMutation, UpdateContactBoardEntryMutationVariables>;

/**
 * __useUpdateContactBoardEntryMutation__
 *
 * To run a mutation, you first call `useUpdateContactBoardEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactBoardEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactBoardEntryMutation, { data, loading, error }] = useUpdateContactBoardEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      column_id: // value for 'column_id'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useUpdateContactBoardEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactBoardEntryMutation, UpdateContactBoardEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactBoardEntryMutation, UpdateContactBoardEntryMutationVariables>(UpdateContactBoardEntryDocument, options);
      }
export type UpdateContactBoardEntryMutationHookResult = ReturnType<typeof useUpdateContactBoardEntryMutation>;
export type UpdateContactBoardEntryMutationResult = Apollo.MutationResult<UpdateContactBoardEntryMutation>;
export type UpdateContactBoardEntryMutationOptions = Apollo.BaseMutationOptions<UpdateContactBoardEntryMutation, UpdateContactBoardEntryMutationVariables>;
export const UpsertContactBoardEntriesMutationDocument = gql`
    mutation UpsertContactBoardEntriesMutation($objects: [board_contact_board_entry_insert_input!]!) {
  insert_board_contact_board_entry(
    objects: $objects
    on_conflict: {constraint: contact_board_entry_pkey, update_columns: [column_id, position]}
  ) {
    returning {
      ...ContactBoardEntry
    }
  }
}
    ${ContactBoardEntryFragmentDoc}
${ContactFragmentDoc}
${AnswerFragmentDoc}
${AnswerOptionFragmentDoc}`;
export type UpsertContactBoardEntriesMutationMutationFn = Apollo.MutationFunction<UpsertContactBoardEntriesMutationMutation, UpsertContactBoardEntriesMutationMutationVariables>;

/**
 * __useUpsertContactBoardEntriesMutationMutation__
 *
 * To run a mutation, you first call `useUpsertContactBoardEntriesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContactBoardEntriesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContactBoardEntriesMutationMutation, { data, loading, error }] = useUpsertContactBoardEntriesMutationMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertContactBoardEntriesMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertContactBoardEntriesMutationMutation, UpsertContactBoardEntriesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertContactBoardEntriesMutationMutation, UpsertContactBoardEntriesMutationMutationVariables>(UpsertContactBoardEntriesMutationDocument, options);
      }
export type UpsertContactBoardEntriesMutationMutationHookResult = ReturnType<typeof useUpsertContactBoardEntriesMutationMutation>;
export type UpsertContactBoardEntriesMutationMutationResult = Apollo.MutationResult<UpsertContactBoardEntriesMutationMutation>;
export type UpsertContactBoardEntriesMutationMutationOptions = Apollo.BaseMutationOptions<UpsertContactBoardEntriesMutationMutation, UpsertContactBoardEntriesMutationMutationVariables>;
export const GetApplicantExportDataDocument = gql`
    query GetApplicantExportData($campaign_id: uuid!) {
  contact(where: {origin_campaign_id: {_eq: $campaign_id}}) {
    ...ApplicantExportData
  }
  campaign_by_pk(id: $campaign_id) {
    id
    organization {
      id
    }
    routing_info {
      location_id
    }
    questions {
      ...ApplicantExportQuestion
    }
  }
}
    ${ApplicantExportDataFragmentDoc}
${ApplicantExportQuestionFragmentDoc}`;

/**
 * __useGetApplicantExportDataQuery__
 *
 * To run a query within a React component, call `useGetApplicantExportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicantExportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicantExportDataQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetApplicantExportDataQuery(baseOptions: Apollo.QueryHookOptions<GetApplicantExportDataQuery, GetApplicantExportDataQueryVariables> & ({ variables: GetApplicantExportDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicantExportDataQuery, GetApplicantExportDataQueryVariables>(GetApplicantExportDataDocument, options);
      }
export function useGetApplicantExportDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicantExportDataQuery, GetApplicantExportDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicantExportDataQuery, GetApplicantExportDataQueryVariables>(GetApplicantExportDataDocument, options);
        }
export function useGetApplicantExportDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicantExportDataQuery, GetApplicantExportDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicantExportDataQuery, GetApplicantExportDataQueryVariables>(GetApplicantExportDataDocument, options);
        }
export type GetApplicantExportDataQueryHookResult = ReturnType<typeof useGetApplicantExportDataQuery>;
export type GetApplicantExportDataLazyQueryHookResult = ReturnType<typeof useGetApplicantExportDataLazyQuery>;
export type GetApplicantExportDataSuspenseQueryHookResult = ReturnType<typeof useGetApplicantExportDataSuspenseQuery>;
export type GetApplicantExportDataQueryResult = Apollo.QueryResult<GetApplicantExportDataQuery, GetApplicantExportDataQueryVariables>;
export const DeleteNoteDocument = gql`
    mutation DeleteNote($id: uuid!) {
  delete_board_note_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const GetNotesDocument = gql`
    query GetNotes($contact_id: uuid!) {
  board_note(
    where: {contact_id: {_eq: $contact_id}}
    order_by: {created_at: desc}
  ) {
    ...Note
  }
}
    ${NoteFragmentDoc}`;

/**
 * __useGetNotesQuery__
 *
 * To run a query within a React component, call `useGetNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesQuery({
 *   variables: {
 *      contact_id: // value for 'contact_id'
 *   },
 * });
 */
export function useGetNotesQuery(baseOptions: Apollo.QueryHookOptions<GetNotesQuery, GetNotesQueryVariables> & ({ variables: GetNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
      }
export function useGetNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
        }
export function useGetNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
        }
export type GetNotesQueryHookResult = ReturnType<typeof useGetNotesQuery>;
export type GetNotesLazyQueryHookResult = ReturnType<typeof useGetNotesLazyQuery>;
export type GetNotesSuspenseQueryHookResult = ReturnType<typeof useGetNotesSuspenseQuery>;
export type GetNotesQueryResult = Apollo.QueryResult<GetNotesQuery, GetNotesQueryVariables>;
export const InsertNoteDocument = gql`
    mutation InsertNote($input: board_note_insert_input!) {
  insert_board_note_one(object: $input) {
    ...Note
  }
}
    ${NoteFragmentDoc}`;
export type InsertNoteMutationFn = Apollo.MutationFunction<InsertNoteMutation, InsertNoteMutationVariables>;

/**
 * __useInsertNoteMutation__
 *
 * To run a mutation, you first call `useInsertNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNoteMutation, { data, loading, error }] = useInsertNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertNoteMutation(baseOptions?: Apollo.MutationHookOptions<InsertNoteMutation, InsertNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertNoteMutation, InsertNoteMutationVariables>(InsertNoteDocument, options);
      }
export type InsertNoteMutationHookResult = ReturnType<typeof useInsertNoteMutation>;
export type InsertNoteMutationResult = Apollo.MutationResult<InsertNoteMutation>;
export type InsertNoteMutationOptions = Apollo.BaseMutationOptions<InsertNoteMutation, InsertNoteMutationVariables>;
export const UpdateNoteContentDocument = gql`
    mutation UpdateNoteContent($id: uuid!, $content: String!) {
  update_board_note_by_pk(pk_columns: {id: $id}, _set: {content: $content}) {
    ...Note
  }
}
    ${NoteFragmentDoc}`;
export type UpdateNoteContentMutationFn = Apollo.MutationFunction<UpdateNoteContentMutation, UpdateNoteContentMutationVariables>;

/**
 * __useUpdateNoteContentMutation__
 *
 * To run a mutation, you first call `useUpdateNoteContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteContentMutation, { data, loading, error }] = useUpdateNoteContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateNoteContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteContentMutation, UpdateNoteContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteContentMutation, UpdateNoteContentMutationVariables>(UpdateNoteContentDocument, options);
      }
export type UpdateNoteContentMutationHookResult = ReturnType<typeof useUpdateNoteContentMutation>;
export type UpdateNoteContentMutationResult = Apollo.MutationResult<UpdateNoteContentMutation>;
export type UpdateNoteContentMutationOptions = Apollo.BaseMutationOptions<UpdateNoteContentMutation, UpdateNoteContentMutationVariables>;
export const GetAvgCtrDocument = gql`
    query GetAvgCTR {
  funnel_insights_aggregate {
    aggregate {
      avg {
        click_through_rate
      }
    }
  }
}
    `;

/**
 * __useGetAvgCtrQuery__
 *
 * To run a query within a React component, call `useGetAvgCtrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvgCtrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvgCtrQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvgCtrQuery(baseOptions?: Apollo.QueryHookOptions<GetAvgCtrQuery, GetAvgCtrQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvgCtrQuery, GetAvgCtrQueryVariables>(GetAvgCtrDocument, options);
      }
export function useGetAvgCtrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvgCtrQuery, GetAvgCtrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvgCtrQuery, GetAvgCtrQueryVariables>(GetAvgCtrDocument, options);
        }
export function useGetAvgCtrSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvgCtrQuery, GetAvgCtrQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvgCtrQuery, GetAvgCtrQueryVariables>(GetAvgCtrDocument, options);
        }
export type GetAvgCtrQueryHookResult = ReturnType<typeof useGetAvgCtrQuery>;
export type GetAvgCtrLazyQueryHookResult = ReturnType<typeof useGetAvgCtrLazyQuery>;
export type GetAvgCtrSuspenseQueryHookResult = ReturnType<typeof useGetAvgCtrSuspenseQuery>;
export type GetAvgCtrQueryResult = Apollo.QueryResult<GetAvgCtrQuery, GetAvgCtrQueryVariables>;
export const GetContactsCountDocument = gql`
    query GetContactsCount {
  contact_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetContactsCountQuery__
 *
 * To run a query within a React component, call `useGetContactsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetContactsCountQuery, GetContactsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsCountQuery, GetContactsCountQueryVariables>(GetContactsCountDocument, options);
      }
export function useGetContactsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsCountQuery, GetContactsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsCountQuery, GetContactsCountQueryVariables>(GetContactsCountDocument, options);
        }
export function useGetContactsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactsCountQuery, GetContactsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactsCountQuery, GetContactsCountQueryVariables>(GetContactsCountDocument, options);
        }
export type GetContactsCountQueryHookResult = ReturnType<typeof useGetContactsCountQuery>;
export type GetContactsCountLazyQueryHookResult = ReturnType<typeof useGetContactsCountLazyQuery>;
export type GetContactsCountSuspenseQueryHookResult = ReturnType<typeof useGetContactsCountSuspenseQuery>;
export type GetContactsCountQueryResult = Apollo.QueryResult<GetContactsCountQuery, GetContactsCountQueryVariables>;
export const SumBudgetsDocument = gql`
    query SumBudgets {
  campaign_budget_aggregate {
    aggregate {
      sum {
        amount
      }
    }
  }
}
    `;

/**
 * __useSumBudgetsQuery__
 *
 * To run a query within a React component, call `useSumBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSumBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSumBudgetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSumBudgetsQuery(baseOptions?: Apollo.QueryHookOptions<SumBudgetsQuery, SumBudgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SumBudgetsQuery, SumBudgetsQueryVariables>(SumBudgetsDocument, options);
      }
export function useSumBudgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SumBudgetsQuery, SumBudgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SumBudgetsQuery, SumBudgetsQueryVariables>(SumBudgetsDocument, options);
        }
export function useSumBudgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SumBudgetsQuery, SumBudgetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SumBudgetsQuery, SumBudgetsQueryVariables>(SumBudgetsDocument, options);
        }
export type SumBudgetsQueryHookResult = ReturnType<typeof useSumBudgetsQuery>;
export type SumBudgetsLazyQueryHookResult = ReturnType<typeof useSumBudgetsLazyQuery>;
export type SumBudgetsSuspenseQueryHookResult = ReturnType<typeof useSumBudgetsSuspenseQuery>;
export type SumBudgetsQueryResult = Apollo.QueryResult<SumBudgetsQuery, SumBudgetsQueryVariables>;
export const GetLatestContactsDocument = gql`
    query GetLatestContacts($results: Int!) {
  contact(order_by: {converted_at: desc_nulls_last}, limit: $results) {
    ...contactMeta
  }
}
    ${ContactMetaFragmentDoc}`;

/**
 * __useGetLatestContactsQuery__
 *
 * To run a query within a React component, call `useGetLatestContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestContactsQuery({
 *   variables: {
 *      results: // value for 'results'
 *   },
 * });
 */
export function useGetLatestContactsQuery(baseOptions: Apollo.QueryHookOptions<GetLatestContactsQuery, GetLatestContactsQueryVariables> & ({ variables: GetLatestContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestContactsQuery, GetLatestContactsQueryVariables>(GetLatestContactsDocument, options);
      }
export function useGetLatestContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestContactsQuery, GetLatestContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestContactsQuery, GetLatestContactsQueryVariables>(GetLatestContactsDocument, options);
        }
export function useGetLatestContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestContactsQuery, GetLatestContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestContactsQuery, GetLatestContactsQueryVariables>(GetLatestContactsDocument, options);
        }
export type GetLatestContactsQueryHookResult = ReturnType<typeof useGetLatestContactsQuery>;
export type GetLatestContactsLazyQueryHookResult = ReturnType<typeof useGetLatestContactsLazyQuery>;
export type GetLatestContactsSuspenseQueryHookResult = ReturnType<typeof useGetLatestContactsSuspenseQuery>;
export type GetLatestContactsQueryResult = Apollo.QueryResult<GetLatestContactsQuery, GetLatestContactsQueryVariables>;
export const GetOrganizationContactsBetweenDatesDocument = gql`
    query GetOrganizationContactsBetweenDates($startDate: String!, $endDate: String!, $previousStartDate: String!, $previousEndDate: String!) {
  lastWeekContacts: new_contacts_per_day(
    where: {date: {_gte: $startDate, _lte: $endDate}}
    order_by: {date: desc}
  ) {
    ...ContactsPerDay
  }
  lastWeekTotalContacts: new_contacts_per_day_aggregate(
    where: {date: {_gte: $startDate, _lte: $endDate}}
  ) {
    aggregate {
      sum {
        new_contacts
      }
    }
  }
  previousWeekTotalContacts: new_contacts_per_day_aggregate(
    where: {date: {_gte: $previousStartDate, _lte: $previousEndDate}}
  ) {
    aggregate {
      sum {
        new_contacts
      }
    }
  }
  qualifiedCount: contact_aggregate(where: {qualified: {_eq: true}}) {
    aggregate {
      count
    }
  }
  unqualifiedCount: contact_aggregate(where: {qualified: {_eq: false}}) {
    aggregate {
      count
    }
  }
}
    ${ContactsPerDayFragmentDoc}`;

/**
 * __useGetOrganizationContactsBetweenDatesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationContactsBetweenDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationContactsBetweenDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationContactsBetweenDatesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      previousStartDate: // value for 'previousStartDate'
 *      previousEndDate: // value for 'previousEndDate'
 *   },
 * });
 */
export function useGetOrganizationContactsBetweenDatesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationContactsBetweenDatesQuery, GetOrganizationContactsBetweenDatesQueryVariables> & ({ variables: GetOrganizationContactsBetweenDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationContactsBetweenDatesQuery, GetOrganizationContactsBetweenDatesQueryVariables>(GetOrganizationContactsBetweenDatesDocument, options);
      }
export function useGetOrganizationContactsBetweenDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationContactsBetweenDatesQuery, GetOrganizationContactsBetweenDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationContactsBetweenDatesQuery, GetOrganizationContactsBetweenDatesQueryVariables>(GetOrganizationContactsBetweenDatesDocument, options);
        }
export function useGetOrganizationContactsBetweenDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationContactsBetweenDatesQuery, GetOrganizationContactsBetweenDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationContactsBetweenDatesQuery, GetOrganizationContactsBetweenDatesQueryVariables>(GetOrganizationContactsBetweenDatesDocument, options);
        }
export type GetOrganizationContactsBetweenDatesQueryHookResult = ReturnType<typeof useGetOrganizationContactsBetweenDatesQuery>;
export type GetOrganizationContactsBetweenDatesLazyQueryHookResult = ReturnType<typeof useGetOrganizationContactsBetweenDatesLazyQuery>;
export type GetOrganizationContactsBetweenDatesSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationContactsBetweenDatesSuspenseQuery>;
export type GetOrganizationContactsBetweenDatesQueryResult = Apollo.QueryResult<GetOrganizationContactsBetweenDatesQuery, GetOrganizationContactsBetweenDatesQueryVariables>;
export const GetRankedNumberOfContactsPerCampaignDocument = gql`
    query GetRankedNumberOfContactsPerCampaign {
  campaign(order_by: {contacts_aggregate: {count: desc}}, limit: 3) {
    ...campaignMeta
  }
}
    ${CampaignMetaFragmentDoc}`;

/**
 * __useGetRankedNumberOfContactsPerCampaignQuery__
 *
 * To run a query within a React component, call `useGetRankedNumberOfContactsPerCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRankedNumberOfContactsPerCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRankedNumberOfContactsPerCampaignQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRankedNumberOfContactsPerCampaignQuery(baseOptions?: Apollo.QueryHookOptions<GetRankedNumberOfContactsPerCampaignQuery, GetRankedNumberOfContactsPerCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRankedNumberOfContactsPerCampaignQuery, GetRankedNumberOfContactsPerCampaignQueryVariables>(GetRankedNumberOfContactsPerCampaignDocument, options);
      }
export function useGetRankedNumberOfContactsPerCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRankedNumberOfContactsPerCampaignQuery, GetRankedNumberOfContactsPerCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRankedNumberOfContactsPerCampaignQuery, GetRankedNumberOfContactsPerCampaignQueryVariables>(GetRankedNumberOfContactsPerCampaignDocument, options);
        }
export function useGetRankedNumberOfContactsPerCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRankedNumberOfContactsPerCampaignQuery, GetRankedNumberOfContactsPerCampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRankedNumberOfContactsPerCampaignQuery, GetRankedNumberOfContactsPerCampaignQueryVariables>(GetRankedNumberOfContactsPerCampaignDocument, options);
        }
export type GetRankedNumberOfContactsPerCampaignQueryHookResult = ReturnType<typeof useGetRankedNumberOfContactsPerCampaignQuery>;
export type GetRankedNumberOfContactsPerCampaignLazyQueryHookResult = ReturnType<typeof useGetRankedNumberOfContactsPerCampaignLazyQuery>;
export type GetRankedNumberOfContactsPerCampaignSuspenseQueryHookResult = ReturnType<typeof useGetRankedNumberOfContactsPerCampaignSuspenseQuery>;
export type GetRankedNumberOfContactsPerCampaignQueryResult = Apollo.QueryResult<GetRankedNumberOfContactsPerCampaignQuery, GetRankedNumberOfContactsPerCampaignQueryVariables>;
export const GetRankedPerformingLocationsDocument = gql`
    query GetRankedPerformingLocations {
  organization_location(
    distinct_on: [organization_id, slug]
    order_by: {parent_region: {name: asc_nulls_last}, organization_id: asc, slug: asc}
  ) {
    organization_id
    slug
    parent_region {
      name
      slug
      organization_id
    }
    name
    campaigns(order_by: {contacts_aggregate: {count: desc}}, limit: 1) {
      id
      name
      contacts_aggregate(where: {qualified: {_eq: true}}) {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetRankedPerformingLocationsQuery__
 *
 * To run a query within a React component, call `useGetRankedPerformingLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRankedPerformingLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRankedPerformingLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRankedPerformingLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRankedPerformingLocationsQuery, GetRankedPerformingLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRankedPerformingLocationsQuery, GetRankedPerformingLocationsQueryVariables>(GetRankedPerformingLocationsDocument, options);
      }
export function useGetRankedPerformingLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRankedPerformingLocationsQuery, GetRankedPerformingLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRankedPerformingLocationsQuery, GetRankedPerformingLocationsQueryVariables>(GetRankedPerformingLocationsDocument, options);
        }
export function useGetRankedPerformingLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRankedPerformingLocationsQuery, GetRankedPerformingLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRankedPerformingLocationsQuery, GetRankedPerformingLocationsQueryVariables>(GetRankedPerformingLocationsDocument, options);
        }
export type GetRankedPerformingLocationsQueryHookResult = ReturnType<typeof useGetRankedPerformingLocationsQuery>;
export type GetRankedPerformingLocationsLazyQueryHookResult = ReturnType<typeof useGetRankedPerformingLocationsLazyQuery>;
export type GetRankedPerformingLocationsSuspenseQueryHookResult = ReturnType<typeof useGetRankedPerformingLocationsSuspenseQuery>;
export type GetRankedPerformingLocationsQueryResult = Apollo.QueryResult<GetRankedPerformingLocationsQuery, GetRankedPerformingLocationsQueryVariables>;
export const GetLocationsDocument = gql`
    query GetLocations {
  organization_location(distinct_on: [name]) {
    ...Location
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export function useGetLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsSuspenseQueryHookResult = ReturnType<typeof useGetLocationsSuspenseQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export const GetAllRegionsDocument = gql`
    query GetAllRegions {
  organization_region(distinct_on: [name]) {
    ...Region
  }
}
    ${RegionFragmentDoc}
${LocationFragmentDoc}`;

/**
 * __useGetAllRegionsQuery__
 *
 * To run a query within a React component, call `useGetAllRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRegionsQuery, GetAllRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRegionsQuery, GetAllRegionsQueryVariables>(GetAllRegionsDocument, options);
      }
export function useGetAllRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRegionsQuery, GetAllRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRegionsQuery, GetAllRegionsQueryVariables>(GetAllRegionsDocument, options);
        }
export function useGetAllRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRegionsQuery, GetAllRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRegionsQuery, GetAllRegionsQueryVariables>(GetAllRegionsDocument, options);
        }
export type GetAllRegionsQueryHookResult = ReturnType<typeof useGetAllRegionsQuery>;
export type GetAllRegionsLazyQueryHookResult = ReturnType<typeof useGetAllRegionsLazyQuery>;
export type GetAllRegionsSuspenseQueryHookResult = ReturnType<typeof useGetAllRegionsSuspenseQuery>;
export type GetAllRegionsQueryResult = Apollo.QueryResult<GetAllRegionsQuery, GetAllRegionsQueryVariables>;
export const GetFunnelChatbotMessagesDocument = gql`
    query GetFunnelChatbotMessages($contact_id: uuid!, $campaign_id: uuid!) {
  funnel_chatbot_message(
    where: {contact_id: {_eq: $contact_id}, campaign_id: {_eq: $campaign_id}}
    order_by: {seq: asc}
  ) {
    id
    direction
    body
    created_at
  }
}
    `;

/**
 * __useGetFunnelChatbotMessagesQuery__
 *
 * To run a query within a React component, call `useGetFunnelChatbotMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunnelChatbotMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunnelChatbotMessagesQuery({
 *   variables: {
 *      contact_id: // value for 'contact_id'
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetFunnelChatbotMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetFunnelChatbotMessagesQuery, GetFunnelChatbotMessagesQueryVariables> & ({ variables: GetFunnelChatbotMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunnelChatbotMessagesQuery, GetFunnelChatbotMessagesQueryVariables>(GetFunnelChatbotMessagesDocument, options);
      }
export function useGetFunnelChatbotMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunnelChatbotMessagesQuery, GetFunnelChatbotMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunnelChatbotMessagesQuery, GetFunnelChatbotMessagesQueryVariables>(GetFunnelChatbotMessagesDocument, options);
        }
export function useGetFunnelChatbotMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFunnelChatbotMessagesQuery, GetFunnelChatbotMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFunnelChatbotMessagesQuery, GetFunnelChatbotMessagesQueryVariables>(GetFunnelChatbotMessagesDocument, options);
        }
export type GetFunnelChatbotMessagesQueryHookResult = ReturnType<typeof useGetFunnelChatbotMessagesQuery>;
export type GetFunnelChatbotMessagesLazyQueryHookResult = ReturnType<typeof useGetFunnelChatbotMessagesLazyQuery>;
export type GetFunnelChatbotMessagesSuspenseQueryHookResult = ReturnType<typeof useGetFunnelChatbotMessagesSuspenseQuery>;
export type GetFunnelChatbotMessagesQueryResult = Apollo.QueryResult<GetFunnelChatbotMessagesQuery, GetFunnelChatbotMessagesQueryVariables>;
export const GetCampaignLeadsInTimespanDocument = gql`
    query GetCampaignLeadsInTimespan($startDate: timestamptz!, $endDate: timestamptz!, $startDateString: String!, $endDateString: String!) {
  campaign(where: {end: {_gte: $startDate}, start: {_lte: $endDate}}) {
    id
    contacts_per_day(where: {date: {_gte: $startDateString, _lte: $endDateString}}) {
      ...NewContactsPerDay
    }
  }
}
    ${NewContactsPerDayFragmentDoc}`;

/**
 * __useGetCampaignLeadsInTimespanQuery__
 *
 * To run a query within a React component, call `useGetCampaignLeadsInTimespanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignLeadsInTimespanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignLeadsInTimespanQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      startDateString: // value for 'startDateString'
 *      endDateString: // value for 'endDateString'
 *   },
 * });
 */
export function useGetCampaignLeadsInTimespanQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignLeadsInTimespanQuery, GetCampaignLeadsInTimespanQueryVariables> & ({ variables: GetCampaignLeadsInTimespanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignLeadsInTimespanQuery, GetCampaignLeadsInTimespanQueryVariables>(GetCampaignLeadsInTimespanDocument, options);
      }
export function useGetCampaignLeadsInTimespanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignLeadsInTimespanQuery, GetCampaignLeadsInTimespanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignLeadsInTimespanQuery, GetCampaignLeadsInTimespanQueryVariables>(GetCampaignLeadsInTimespanDocument, options);
        }
export function useGetCampaignLeadsInTimespanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignLeadsInTimespanQuery, GetCampaignLeadsInTimespanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignLeadsInTimespanQuery, GetCampaignLeadsInTimespanQueryVariables>(GetCampaignLeadsInTimespanDocument, options);
        }
export type GetCampaignLeadsInTimespanQueryHookResult = ReturnType<typeof useGetCampaignLeadsInTimespanQuery>;
export type GetCampaignLeadsInTimespanLazyQueryHookResult = ReturnType<typeof useGetCampaignLeadsInTimespanLazyQuery>;
export type GetCampaignLeadsInTimespanSuspenseQueryHookResult = ReturnType<typeof useGetCampaignLeadsInTimespanSuspenseQuery>;
export type GetCampaignLeadsInTimespanQueryResult = Apollo.QueryResult<GetCampaignLeadsInTimespanQuery, GetCampaignLeadsInTimespanQueryVariables>;
export const GetDropdownCampaignInfoDocument = gql`
    query GetDropdownCampaignInfo {
  campaign {
    ...DropdownCampaignInfo
  }
}
    ${DropdownCampaignInfoFragmentDoc}`;

/**
 * __useGetDropdownCampaignInfoQuery__
 *
 * To run a query within a React component, call `useGetDropdownCampaignInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDropdownCampaignInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDropdownCampaignInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDropdownCampaignInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetDropdownCampaignInfoQuery, GetDropdownCampaignInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDropdownCampaignInfoQuery, GetDropdownCampaignInfoQueryVariables>(GetDropdownCampaignInfoDocument, options);
      }
export function useGetDropdownCampaignInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDropdownCampaignInfoQuery, GetDropdownCampaignInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDropdownCampaignInfoQuery, GetDropdownCampaignInfoQueryVariables>(GetDropdownCampaignInfoDocument, options);
        }
export function useGetDropdownCampaignInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDropdownCampaignInfoQuery, GetDropdownCampaignInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDropdownCampaignInfoQuery, GetDropdownCampaignInfoQueryVariables>(GetDropdownCampaignInfoDocument, options);
        }
export type GetDropdownCampaignInfoQueryHookResult = ReturnType<typeof useGetDropdownCampaignInfoQuery>;
export type GetDropdownCampaignInfoLazyQueryHookResult = ReturnType<typeof useGetDropdownCampaignInfoLazyQuery>;
export type GetDropdownCampaignInfoSuspenseQueryHookResult = ReturnType<typeof useGetDropdownCampaignInfoSuspenseQuery>;
export type GetDropdownCampaignInfoQueryResult = Apollo.QueryResult<GetDropdownCampaignInfoQuery, GetDropdownCampaignInfoQueryVariables>;
export const GetInsightCampaignsInTimespanDocument = gql`
    query GetInsightCampaignsInTimespan($endDate: timestamptz!) {
  newLeads: new_contacts_per_day_aggregate {
    aggregate {
      sum {
        new_contacts
      }
    }
  }
  completedCampaigns: campaign(
    where: {start: {_lte: $endDate}, end: {_lte: $endDate}}
  ) {
    id
  }
  campaign(
    where: {name: {_is_null: false}, start: {_lte: $endDate}}
    order_by: {end: desc_nulls_first}
  ) {
    ...InsightCampaign
  }
}
    ${InsightCampaignFragmentDoc}`;

/**
 * __useGetInsightCampaignsInTimespanQuery__
 *
 * To run a query within a React component, call `useGetInsightCampaignsInTimespanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightCampaignsInTimespanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightCampaignsInTimespanQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetInsightCampaignsInTimespanQuery(baseOptions: Apollo.QueryHookOptions<GetInsightCampaignsInTimespanQuery, GetInsightCampaignsInTimespanQueryVariables> & ({ variables: GetInsightCampaignsInTimespanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightCampaignsInTimespanQuery, GetInsightCampaignsInTimespanQueryVariables>(GetInsightCampaignsInTimespanDocument, options);
      }
export function useGetInsightCampaignsInTimespanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightCampaignsInTimespanQuery, GetInsightCampaignsInTimespanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightCampaignsInTimespanQuery, GetInsightCampaignsInTimespanQueryVariables>(GetInsightCampaignsInTimespanDocument, options);
        }
export function useGetInsightCampaignsInTimespanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightCampaignsInTimespanQuery, GetInsightCampaignsInTimespanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsightCampaignsInTimespanQuery, GetInsightCampaignsInTimespanQueryVariables>(GetInsightCampaignsInTimespanDocument, options);
        }
export type GetInsightCampaignsInTimespanQueryHookResult = ReturnType<typeof useGetInsightCampaignsInTimespanQuery>;
export type GetInsightCampaignsInTimespanLazyQueryHookResult = ReturnType<typeof useGetInsightCampaignsInTimespanLazyQuery>;
export type GetInsightCampaignsInTimespanSuspenseQueryHookResult = ReturnType<typeof useGetInsightCampaignsInTimespanSuspenseQuery>;
export type GetInsightCampaignsInTimespanQueryResult = Apollo.QueryResult<GetInsightCampaignsInTimespanQuery, GetInsightCampaignsInTimespanQueryVariables>;
export const GetSelectedCampaignsDocument = gql`
    query GetSelectedCampaigns($selectedCampaignIds: [uuid!] = [], $hasAdvancedAccessToCampaigns: Boolean = false, $canSeeInternalInsights: Boolean!, $canSeeDetails: Boolean! = false, $hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: Boolean! = false) {
  selectedCampaigns: campaign(where: {id: {_in: $selectedCampaignIds}}) {
    ...Campaign
  }
}
    ${CampaignFragmentDoc}
${NewContactsPerDayFragmentDoc}`;

/**
 * __useGetSelectedCampaignsQuery__
 *
 * To run a query within a React component, call `useGetSelectedCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedCampaignsQuery({
 *   variables: {
 *      selectedCampaignIds: // value for 'selectedCampaignIds'
 *      hasAdvancedAccessToCampaigns: // value for 'hasAdvancedAccessToCampaigns'
 *      canSeeInternalInsights: // value for 'canSeeInternalInsights'
 *      canSeeDetails: // value for 'canSeeDetails'
 *      hasAdvancedAccessToCampaignsOrCanSeeInternalInsights: // value for 'hasAdvancedAccessToCampaignsOrCanSeeInternalInsights'
 *   },
 * });
 */
export function useGetSelectedCampaignsQuery(baseOptions: Apollo.QueryHookOptions<GetSelectedCampaignsQuery, GetSelectedCampaignsQueryVariables> & ({ variables: GetSelectedCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectedCampaignsQuery, GetSelectedCampaignsQueryVariables>(GetSelectedCampaignsDocument, options);
      }
export function useGetSelectedCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectedCampaignsQuery, GetSelectedCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectedCampaignsQuery, GetSelectedCampaignsQueryVariables>(GetSelectedCampaignsDocument, options);
        }
export function useGetSelectedCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSelectedCampaignsQuery, GetSelectedCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSelectedCampaignsQuery, GetSelectedCampaignsQueryVariables>(GetSelectedCampaignsDocument, options);
        }
export type GetSelectedCampaignsQueryHookResult = ReturnType<typeof useGetSelectedCampaignsQuery>;
export type GetSelectedCampaignsLazyQueryHookResult = ReturnType<typeof useGetSelectedCampaignsLazyQuery>;
export type GetSelectedCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetSelectedCampaignsSuspenseQuery>;
export type GetSelectedCampaignsQueryResult = Apollo.QueryResult<GetSelectedCampaignsQuery, GetSelectedCampaignsQueryVariables>;
export const UpsertOrganizationDocument = gql`
    mutation UpsertOrganization($org: organization_insert_input!, $settings: organization_settings_insert_input!) {
  insert_organization_one(
    object: $org
    on_conflict: {constraint: organization_pkey, update_columns: [name, active, country_code, logo_url, short_name, name_prefix, is_partner, partner_organization_id]}
  ) {
    ...Organization
  }
  insert_organization_settings_one(
    object: $settings
    on_conflict: {constraint: settings_pkey, update_columns: [rejection_emails_enabled, welcome_emails_enabled, notification_emails_enabled, address_formally]}
  ) {
    organization_id
    welcome_emails_enabled
    rejection_emails_enabled
    welcome_emails_enabled
    address_formally
  }
}
    ${OrganizationFragmentDoc}`;
export type UpsertOrganizationMutationFn = Apollo.MutationFunction<UpsertOrganizationMutation, UpsertOrganizationMutationVariables>;

/**
 * __useUpsertOrganizationMutation__
 *
 * To run a mutation, you first call `useUpsertOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrganizationMutation, { data, loading, error }] = useUpsertOrganizationMutation({
 *   variables: {
 *      org: // value for 'org'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpsertOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrganizationMutation, UpsertOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrganizationMutation, UpsertOrganizationMutationVariables>(UpsertOrganizationDocument, options);
      }
export type UpsertOrganizationMutationHookResult = ReturnType<typeof useUpsertOrganizationMutation>;
export type UpsertOrganizationMutationResult = Apollo.MutationResult<UpsertOrganizationMutation>;
export type UpsertOrganizationMutationOptions = Apollo.BaseMutationOptions<UpsertOrganizationMutation, UpsertOrganizationMutationVariables>;
export const UpsertOrganizationSettingDocument = gql`
    mutation UpsertOrganizationSetting($organizationId: String!, $input: organization_settings_set_input) {
  update_organization_settings_by_pk(
    pk_columns: {organization_id: $organizationId}
    _set: $input
  ) {
    address_formally
    organization_id
  }
}
    `;
export type UpsertOrganizationSettingMutationFn = Apollo.MutationFunction<UpsertOrganizationSettingMutation, UpsertOrganizationSettingMutationVariables>;

/**
 * __useUpsertOrganizationSettingMutation__
 *
 * To run a mutation, you first call `useUpsertOrganizationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrganizationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrganizationSettingMutation, { data, loading, error }] = useUpsertOrganizationSettingMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOrganizationSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrganizationSettingMutation, UpsertOrganizationSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrganizationSettingMutation, UpsertOrganizationSettingMutationVariables>(UpsertOrganizationSettingDocument, options);
      }
export type UpsertOrganizationSettingMutationHookResult = ReturnType<typeof useUpsertOrganizationSettingMutation>;
export type UpsertOrganizationSettingMutationResult = Apollo.MutationResult<UpsertOrganizationSettingMutation>;
export type UpsertOrganizationSettingMutationOptions = Apollo.BaseMutationOptions<UpsertOrganizationSettingMutation, UpsertOrganizationSettingMutationVariables>;
export const InsertCommentDocument = gql`
    mutation InsertComment($creative_id: uuid!, $text: String!, $user_id: String!, $setting_reference: ad_setting_enum!) {
  insert_ad_comment_one(
    object: {creative_id: $creative_id, text: $text, user_id: $user_id, setting_reference: $setting_reference}
  ) {
    ...AdComment
  }
}
    ${AdCommentFragmentDoc}`;
export type InsertCommentMutationFn = Apollo.MutationFunction<InsertCommentMutation, InsertCommentMutationVariables>;

/**
 * __useInsertCommentMutation__
 *
 * To run a mutation, you first call `useInsertCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCommentMutation, { data, loading, error }] = useInsertCommentMutation({
 *   variables: {
 *      creative_id: // value for 'creative_id'
 *      text: // value for 'text'
 *      user_id: // value for 'user_id'
 *      setting_reference: // value for 'setting_reference'
 *   },
 * });
 */
export function useInsertCommentMutation(baseOptions?: Apollo.MutationHookOptions<InsertCommentMutation, InsertCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCommentMutation, InsertCommentMutationVariables>(InsertCommentDocument, options);
      }
export type InsertCommentMutationHookResult = ReturnType<typeof useInsertCommentMutation>;
export type InsertCommentMutationResult = Apollo.MutationResult<InsertCommentMutation>;
export type InsertCommentMutationOptions = Apollo.BaseMutationOptions<InsertCommentMutation, InsertCommentMutationVariables>;
export const UpsertCommentsDocument = gql`
    mutation UpsertComments($objects: [ad_comment_insert_input!]!) {
  insert_ad_comment(
    objects: $objects
    on_conflict: {constraint: comment_pkey, update_columns: [creative_id]}
  ) {
    affected_rows
  }
}
    `;
export type UpsertCommentsMutationFn = Apollo.MutationFunction<UpsertCommentsMutation, UpsertCommentsMutationVariables>;

/**
 * __useUpsertCommentsMutation__
 *
 * To run a mutation, you first call `useUpsertCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCommentsMutation, { data, loading, error }] = useUpsertCommentsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertCommentsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCommentsMutation, UpsertCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCommentsMutation, UpsertCommentsMutationVariables>(UpsertCommentsDocument, options);
      }
export type UpsertCommentsMutationHookResult = ReturnType<typeof useUpsertCommentsMutation>;
export type UpsertCommentsMutationResult = Apollo.MutationResult<UpsertCommentsMutation>;
export type UpsertCommentsMutationOptions = Apollo.BaseMutationOptions<UpsertCommentsMutation, UpsertCommentsMutationVariables>;
export const GetAllPartnerOrganizationsDocument = gql`
    query GetAllPartnerOrganizations {
  organization(where: {is_partner: {_eq: true}}) {
    ...PartnerOrganization
  }
}
    ${PartnerOrganizationFragmentDoc}`;

/**
 * __useGetAllPartnerOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetAllPartnerOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPartnerOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPartnerOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPartnerOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPartnerOrganizationsQuery, GetAllPartnerOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPartnerOrganizationsQuery, GetAllPartnerOrganizationsQueryVariables>(GetAllPartnerOrganizationsDocument, options);
      }
export function useGetAllPartnerOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPartnerOrganizationsQuery, GetAllPartnerOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPartnerOrganizationsQuery, GetAllPartnerOrganizationsQueryVariables>(GetAllPartnerOrganizationsDocument, options);
        }
export function useGetAllPartnerOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPartnerOrganizationsQuery, GetAllPartnerOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPartnerOrganizationsQuery, GetAllPartnerOrganizationsQueryVariables>(GetAllPartnerOrganizationsDocument, options);
        }
export type GetAllPartnerOrganizationsQueryHookResult = ReturnType<typeof useGetAllPartnerOrganizationsQuery>;
export type GetAllPartnerOrganizationsLazyQueryHookResult = ReturnType<typeof useGetAllPartnerOrganizationsLazyQuery>;
export type GetAllPartnerOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetAllPartnerOrganizationsSuspenseQuery>;
export type GetAllPartnerOrganizationsQueryResult = Apollo.QueryResult<GetAllPartnerOrganizationsQuery, GetAllPartnerOrganizationsQueryVariables>;
export const GetOrganizationByIdDocument = gql`
    query GetOrganizationById($organizationId: String!, $canSeeInternalInsights: Boolean = false) {
  organization_by_pk(id: $organizationId) {
    ...OrganizationWithBudget
  }
}
    ${OrganizationWithBudgetFragmentDoc}
${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationByIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationByIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      canSeeInternalInsights: // value for 'canSeeInternalInsights'
 *   },
 * });
 */
export function useGetOrganizationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables> & ({ variables: GetOrganizationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
      }
export function useGetOrganizationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
        }
export function useGetOrganizationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
        }
export type GetOrganizationByIdQueryHookResult = ReturnType<typeof useGetOrganizationByIdQuery>;
export type GetOrganizationByIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationByIdLazyQuery>;
export type GetOrganizationByIdSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationByIdSuspenseQuery>;
export type GetOrganizationByIdQueryResult = Apollo.QueryResult<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>;
export const GetOrganizationIdsDocument = gql`
    query GetOrganizationIds {
  ids: organization {
    id
  }
}
    `;

/**
 * __useGetOrganizationIdsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationIdsQuery, GetOrganizationIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationIdsQuery, GetOrganizationIdsQueryVariables>(GetOrganizationIdsDocument, options);
      }
export function useGetOrganizationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationIdsQuery, GetOrganizationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationIdsQuery, GetOrganizationIdsQueryVariables>(GetOrganizationIdsDocument, options);
        }
export function useGetOrganizationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationIdsQuery, GetOrganizationIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationIdsQuery, GetOrganizationIdsQueryVariables>(GetOrganizationIdsDocument, options);
        }
export type GetOrganizationIdsQueryHookResult = ReturnType<typeof useGetOrganizationIdsQuery>;
export type GetOrganizationIdsLazyQueryHookResult = ReturnType<typeof useGetOrganizationIdsLazyQuery>;
export type GetOrganizationIdsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationIdsSuspenseQuery>;
export type GetOrganizationIdsQueryResult = Apollo.QueryResult<GetOrganizationIdsQuery, GetOrganizationIdsQueryVariables>;
export const GetOrganizationWithLeadAndCampaignAggregateDocument = gql`
    query GetOrganizationWithLeadAndCampaignAggregate($slug: String!) {
  organization_by_pk(id: $slug) {
    ...OrganizationWithLeadAndCampaignAggregate
  }
}
    ${OrganizationWithLeadAndCampaignAggregateFragmentDoc}
${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationWithLeadAndCampaignAggregateQuery__
 *
 * To run a query within a React component, call `useGetOrganizationWithLeadAndCampaignAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationWithLeadAndCampaignAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationWithLeadAndCampaignAggregateQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetOrganizationWithLeadAndCampaignAggregateQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationWithLeadAndCampaignAggregateQuery, GetOrganizationWithLeadAndCampaignAggregateQueryVariables> & ({ variables: GetOrganizationWithLeadAndCampaignAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationWithLeadAndCampaignAggregateQuery, GetOrganizationWithLeadAndCampaignAggregateQueryVariables>(GetOrganizationWithLeadAndCampaignAggregateDocument, options);
      }
export function useGetOrganizationWithLeadAndCampaignAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationWithLeadAndCampaignAggregateQuery, GetOrganizationWithLeadAndCampaignAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationWithLeadAndCampaignAggregateQuery, GetOrganizationWithLeadAndCampaignAggregateQueryVariables>(GetOrganizationWithLeadAndCampaignAggregateDocument, options);
        }
export function useGetOrganizationWithLeadAndCampaignAggregateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationWithLeadAndCampaignAggregateQuery, GetOrganizationWithLeadAndCampaignAggregateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationWithLeadAndCampaignAggregateQuery, GetOrganizationWithLeadAndCampaignAggregateQueryVariables>(GetOrganizationWithLeadAndCampaignAggregateDocument, options);
        }
export type GetOrganizationWithLeadAndCampaignAggregateQueryHookResult = ReturnType<typeof useGetOrganizationWithLeadAndCampaignAggregateQuery>;
export type GetOrganizationWithLeadAndCampaignAggregateLazyQueryHookResult = ReturnType<typeof useGetOrganizationWithLeadAndCampaignAggregateLazyQuery>;
export type GetOrganizationWithLeadAndCampaignAggregateSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationWithLeadAndCampaignAggregateSuspenseQuery>;
export type GetOrganizationWithLeadAndCampaignAggregateQueryResult = Apollo.QueryResult<GetOrganizationWithLeadAndCampaignAggregateQuery, GetOrganizationWithLeadAndCampaignAggregateQueryVariables>;
export const GetRecentNewsDocument = gql`
    query GetRecentNews {
  organization_news(
    limit: 5
    order_by: {show_after: desc}
    where: {show_after: {_lt: "now()"}, show_until: {_gte: "now()"}}
  ) {
    ...News
  }
}
    ${NewsFragmentDoc}`;

/**
 * __useGetRecentNewsQuery__
 *
 * To run a query within a React component, call `useGetRecentNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecentNewsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentNewsQuery, GetRecentNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentNewsQuery, GetRecentNewsQueryVariables>(GetRecentNewsDocument, options);
      }
export function useGetRecentNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentNewsQuery, GetRecentNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentNewsQuery, GetRecentNewsQueryVariables>(GetRecentNewsDocument, options);
        }
export function useGetRecentNewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentNewsQuery, GetRecentNewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentNewsQuery, GetRecentNewsQueryVariables>(GetRecentNewsDocument, options);
        }
export type GetRecentNewsQueryHookResult = ReturnType<typeof useGetRecentNewsQuery>;
export type GetRecentNewsLazyQueryHookResult = ReturnType<typeof useGetRecentNewsLazyQuery>;
export type GetRecentNewsSuspenseQueryHookResult = ReturnType<typeof useGetRecentNewsSuspenseQuery>;
export type GetRecentNewsQueryResult = Apollo.QueryResult<GetRecentNewsQuery, GetRecentNewsQueryVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($slug: String!, $organizationId: String!) {
  delete_organization_location_by_pk(
    organization_id: $organizationId
    slug: $slug
  ) {
    organization_id
    slug
  }
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const DeleteRegionDocument = gql`
    mutation DeleteRegion($slug: String!, $organizationId: String!) {
  delete_organization_region_by_pk(organization_id: $organizationId, slug: $slug) {
    slug
    organization_id
  }
}
    `;
export type DeleteRegionMutationFn = Apollo.MutationFunction<DeleteRegionMutation, DeleteRegionMutationVariables>;

/**
 * __useDeleteRegionMutation__
 *
 * To run a mutation, you first call `useDeleteRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegionMutation, { data, loading, error }] = useDeleteRegionMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteRegionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegionMutation, DeleteRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegionMutation, DeleteRegionMutationVariables>(DeleteRegionDocument, options);
      }
export type DeleteRegionMutationHookResult = ReturnType<typeof useDeleteRegionMutation>;
export type DeleteRegionMutationResult = Apollo.MutationResult<DeleteRegionMutation>;
export type DeleteRegionMutationOptions = Apollo.BaseMutationOptions<DeleteRegionMutation, DeleteRegionMutationVariables>;
export const GetRegionsDocument = gql`
    query GetRegions($orgId: String!) {
  regions: organization_region(where: {organization_id: {_eq: $orgId}}) {
    ...Region
  }
}
    ${RegionFragmentDoc}
${LocationFragmentDoc}`;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables> & ({ variables: GetRegionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export function useGetRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsSuspenseQueryHookResult = ReturnType<typeof useGetRegionsSuspenseQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const InsertLocationDocument = gql`
    mutation InsertLocation($name: String!, $slug: String!, $organizationId: String!, $regionSlug: String!) {
  location: insert_organization_location_one(
    object: {organization_id: $organizationId, region_slug: $regionSlug, name: $name, slug: $slug}
  ) {
    ...Location
  }
}
    ${LocationFragmentDoc}`;
export type InsertLocationMutationFn = Apollo.MutationFunction<InsertLocationMutation, InsertLocationMutationVariables>;

/**
 * __useInsertLocationMutation__
 *
 * To run a mutation, you first call `useInsertLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLocationMutation, { data, loading, error }] = useInsertLocationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      slug: // value for 'slug'
 *      organizationId: // value for 'organizationId'
 *      regionSlug: // value for 'regionSlug'
 *   },
 * });
 */
export function useInsertLocationMutation(baseOptions?: Apollo.MutationHookOptions<InsertLocationMutation, InsertLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLocationMutation, InsertLocationMutationVariables>(InsertLocationDocument, options);
      }
export type InsertLocationMutationHookResult = ReturnType<typeof useInsertLocationMutation>;
export type InsertLocationMutationResult = Apollo.MutationResult<InsertLocationMutation>;
export type InsertLocationMutationOptions = Apollo.BaseMutationOptions<InsertLocationMutation, InsertLocationMutationVariables>;
export const InsertRegionDocument = gql`
    mutation InsertRegion($name: String!, $slug: String!, $organizationId: String!) {
  region: insert_organization_region_one(
    object: {name: $name, slug: $slug, organization_id: $organizationId}
  ) {
    organization_id
    ...Region
  }
}
    ${RegionFragmentDoc}
${LocationFragmentDoc}`;
export type InsertRegionMutationFn = Apollo.MutationFunction<InsertRegionMutation, InsertRegionMutationVariables>;

/**
 * __useInsertRegionMutation__
 *
 * To run a mutation, you first call `useInsertRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRegionMutation, { data, loading, error }] = useInsertRegionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      slug: // value for 'slug'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInsertRegionMutation(baseOptions?: Apollo.MutationHookOptions<InsertRegionMutation, InsertRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRegionMutation, InsertRegionMutationVariables>(InsertRegionDocument, options);
      }
export type InsertRegionMutationHookResult = ReturnType<typeof useInsertRegionMutation>;
export type InsertRegionMutationResult = Apollo.MutationResult<InsertRegionMutation>;
export type InsertRegionMutationOptions = Apollo.BaseMutationOptions<InsertRegionMutation, InsertRegionMutationVariables>;
export const GetContactAvailabilityByIdDocument = gql`
    query GetContactAvailabilityById($contact_id: uuid!) {
  chat_bot_v1_answer: chat_bot_messages(
    where: {contact_id: {_eq: $contact_id}, sender_type: {_eq: "customer"}, type: {_eq: BUTTON}, data: {_cast: {String: {_ilike: "%Uhr%"}}}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    data
  }
  chat_bot_v2_answer: bot_conversation(
    where: {contact_id: {_eq: $contact_id}}
    limit: 1
  ) {
    messages(
      where: {sent_by: {_eq: APPLICANT}, _and: {text: {_ilike: "%Uhr%"}}}
      order_by: {created_at: desc}
      limit: 1
    ) {
      text
    }
  }
  funnel_answer: contact_by_pk(id: $contact_id) {
    answers(where: {value: {_ilike: "%Uhr%"}}, limit: 1) {
      value
    }
  }
}
    `;

/**
 * __useGetContactAvailabilityByIdQuery__
 *
 * To run a query within a React component, call `useGetContactAvailabilityByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactAvailabilityByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactAvailabilityByIdQuery({
 *   variables: {
 *      contact_id: // value for 'contact_id'
 *   },
 * });
 */
export function useGetContactAvailabilityByIdQuery(baseOptions: Apollo.QueryHookOptions<GetContactAvailabilityByIdQuery, GetContactAvailabilityByIdQueryVariables> & ({ variables: GetContactAvailabilityByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactAvailabilityByIdQuery, GetContactAvailabilityByIdQueryVariables>(GetContactAvailabilityByIdDocument, options);
      }
export function useGetContactAvailabilityByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactAvailabilityByIdQuery, GetContactAvailabilityByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactAvailabilityByIdQuery, GetContactAvailabilityByIdQueryVariables>(GetContactAvailabilityByIdDocument, options);
        }
export function useGetContactAvailabilityByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactAvailabilityByIdQuery, GetContactAvailabilityByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactAvailabilityByIdQuery, GetContactAvailabilityByIdQueryVariables>(GetContactAvailabilityByIdDocument, options);
        }
export type GetContactAvailabilityByIdQueryHookResult = ReturnType<typeof useGetContactAvailabilityByIdQuery>;
export type GetContactAvailabilityByIdLazyQueryHookResult = ReturnType<typeof useGetContactAvailabilityByIdLazyQuery>;
export type GetContactAvailabilityByIdSuspenseQueryHookResult = ReturnType<typeof useGetContactAvailabilityByIdSuspenseQuery>;
export type GetContactAvailabilityByIdQueryResult = Apollo.QueryResult<GetContactAvailabilityByIdQuery, GetContactAvailabilityByIdQueryVariables>;
export const GetContactByIdDocument = gql`
    query GetContactById($id: uuid!) {
  contact_by_pk(id: $id) {
    ...Contact
  }
}
    ${ContactFragmentDoc}
${AnswerFragmentDoc}
${AnswerOptionFragmentDoc}`;

/**
 * __useGetContactByIdQuery__
 *
 * To run a query within a React component, call `useGetContactByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactByIdQuery(baseOptions: Apollo.QueryHookOptions<GetContactByIdQuery, GetContactByIdQueryVariables> & ({ variables: GetContactByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactByIdQuery, GetContactByIdQueryVariables>(GetContactByIdDocument, options);
      }
export function useGetContactByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactByIdQuery, GetContactByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactByIdQuery, GetContactByIdQueryVariables>(GetContactByIdDocument, options);
        }
export function useGetContactByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactByIdQuery, GetContactByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactByIdQuery, GetContactByIdQueryVariables>(GetContactByIdDocument, options);
        }
export type GetContactByIdQueryHookResult = ReturnType<typeof useGetContactByIdQuery>;
export type GetContactByIdLazyQueryHookResult = ReturnType<typeof useGetContactByIdLazyQuery>;
export type GetContactByIdSuspenseQueryHookResult = ReturnType<typeof useGetContactByIdSuspenseQuery>;
export type GetContactByIdQueryResult = Apollo.QueryResult<GetContactByIdQuery, GetContactByIdQueryVariables>;
export const GetCommentsByCreativeIdDocument = gql`
    query GetCommentsByCreativeId($creative_id: uuid!) {
  ad_comment(where: {creative_id: {_eq: $creative_id}}) {
    ...AdComment
  }
}
    ${AdCommentFragmentDoc}`;

/**
 * __useGetCommentsByCreativeIdQuery__
 *
 * To run a query within a React component, call `useGetCommentsByCreativeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsByCreativeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsByCreativeIdQuery({
 *   variables: {
 *      creative_id: // value for 'creative_id'
 *   },
 * });
 */
export function useGetCommentsByCreativeIdQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsByCreativeIdQuery, GetCommentsByCreativeIdQueryVariables> & ({ variables: GetCommentsByCreativeIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsByCreativeIdQuery, GetCommentsByCreativeIdQueryVariables>(GetCommentsByCreativeIdDocument, options);
      }
export function useGetCommentsByCreativeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsByCreativeIdQuery, GetCommentsByCreativeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsByCreativeIdQuery, GetCommentsByCreativeIdQueryVariables>(GetCommentsByCreativeIdDocument, options);
        }
export function useGetCommentsByCreativeIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommentsByCreativeIdQuery, GetCommentsByCreativeIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommentsByCreativeIdQuery, GetCommentsByCreativeIdQueryVariables>(GetCommentsByCreativeIdDocument, options);
        }
export type GetCommentsByCreativeIdQueryHookResult = ReturnType<typeof useGetCommentsByCreativeIdQuery>;
export type GetCommentsByCreativeIdLazyQueryHookResult = ReturnType<typeof useGetCommentsByCreativeIdLazyQuery>;
export type GetCommentsByCreativeIdSuspenseQueryHookResult = ReturnType<typeof useGetCommentsByCreativeIdSuspenseQuery>;
export type GetCommentsByCreativeIdQueryResult = Apollo.QueryResult<GetCommentsByCreativeIdQuery, GetCommentsByCreativeIdQueryVariables>;
export const GetCommentsByCreativeIdAndSettingsReferenceDocument = gql`
    query GetCommentsByCreativeIdAndSettingsReference($creative_id: uuid!, $setting_reference: ad_setting_enum!) {
  ad_comment(
    where: {_and: {creative_id: {_eq: $creative_id}, setting_reference: {_eq: $setting_reference}}}
    order_by: {created_at: desc}
  ) {
    ...AdComment
  }
}
    ${AdCommentFragmentDoc}`;

/**
 * __useGetCommentsByCreativeIdAndSettingsReferenceQuery__
 *
 * To run a query within a React component, call `useGetCommentsByCreativeIdAndSettingsReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsByCreativeIdAndSettingsReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsByCreativeIdAndSettingsReferenceQuery({
 *   variables: {
 *      creative_id: // value for 'creative_id'
 *      setting_reference: // value for 'setting_reference'
 *   },
 * });
 */
export function useGetCommentsByCreativeIdAndSettingsReferenceQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsByCreativeIdAndSettingsReferenceQuery, GetCommentsByCreativeIdAndSettingsReferenceQueryVariables> & ({ variables: GetCommentsByCreativeIdAndSettingsReferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsByCreativeIdAndSettingsReferenceQuery, GetCommentsByCreativeIdAndSettingsReferenceQueryVariables>(GetCommentsByCreativeIdAndSettingsReferenceDocument, options);
      }
export function useGetCommentsByCreativeIdAndSettingsReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsByCreativeIdAndSettingsReferenceQuery, GetCommentsByCreativeIdAndSettingsReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsByCreativeIdAndSettingsReferenceQuery, GetCommentsByCreativeIdAndSettingsReferenceQueryVariables>(GetCommentsByCreativeIdAndSettingsReferenceDocument, options);
        }
export function useGetCommentsByCreativeIdAndSettingsReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommentsByCreativeIdAndSettingsReferenceQuery, GetCommentsByCreativeIdAndSettingsReferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommentsByCreativeIdAndSettingsReferenceQuery, GetCommentsByCreativeIdAndSettingsReferenceQueryVariables>(GetCommentsByCreativeIdAndSettingsReferenceDocument, options);
        }
export type GetCommentsByCreativeIdAndSettingsReferenceQueryHookResult = ReturnType<typeof useGetCommentsByCreativeIdAndSettingsReferenceQuery>;
export type GetCommentsByCreativeIdAndSettingsReferenceLazyQueryHookResult = ReturnType<typeof useGetCommentsByCreativeIdAndSettingsReferenceLazyQuery>;
export type GetCommentsByCreativeIdAndSettingsReferenceSuspenseQueryHookResult = ReturnType<typeof useGetCommentsByCreativeIdAndSettingsReferenceSuspenseQuery>;
export type GetCommentsByCreativeIdAndSettingsReferenceQueryResult = Apollo.QueryResult<GetCommentsByCreativeIdAndSettingsReferenceQuery, GetCommentsByCreativeIdAndSettingsReferenceQueryVariables>;
export const GetRmsConnectorDocument = gql`
    query GetRmsConnector($campaignId: uuid!) {
  rms_connectors(where: {campaign_id: {_eq: $campaignId}}, limit: 1) {
    ...RmsConnector
  }
}
    ${RmsConnectorFragmentDoc}`;

/**
 * __useGetRmsConnectorQuery__
 *
 * To run a query within a React component, call `useGetRmsConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRmsConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRmsConnectorQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetRmsConnectorQuery(baseOptions: Apollo.QueryHookOptions<GetRmsConnectorQuery, GetRmsConnectorQueryVariables> & ({ variables: GetRmsConnectorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRmsConnectorQuery, GetRmsConnectorQueryVariables>(GetRmsConnectorDocument, options);
      }
export function useGetRmsConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRmsConnectorQuery, GetRmsConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRmsConnectorQuery, GetRmsConnectorQueryVariables>(GetRmsConnectorDocument, options);
        }
export function useGetRmsConnectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRmsConnectorQuery, GetRmsConnectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRmsConnectorQuery, GetRmsConnectorQueryVariables>(GetRmsConnectorDocument, options);
        }
export type GetRmsConnectorQueryHookResult = ReturnType<typeof useGetRmsConnectorQuery>;
export type GetRmsConnectorLazyQueryHookResult = ReturnType<typeof useGetRmsConnectorLazyQuery>;
export type GetRmsConnectorSuspenseQueryHookResult = ReturnType<typeof useGetRmsConnectorSuspenseQuery>;
export type GetRmsConnectorQueryResult = Apollo.QueryResult<GetRmsConnectorQuery, GetRmsConnectorQueryVariables>;
export const GetRmsOrgSetupRmsTypeDocument = gql`
    query GetRmsOrgSetupRmsType($organizationId: String!) {
  rms_org_setups(where: {organization_id: {_eq: $organizationId}}, limit: 1) {
    rms_type
  }
}
    `;

/**
 * __useGetRmsOrgSetupRmsTypeQuery__
 *
 * To run a query within a React component, call `useGetRmsOrgSetupRmsTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRmsOrgSetupRmsTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRmsOrgSetupRmsTypeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetRmsOrgSetupRmsTypeQuery(baseOptions: Apollo.QueryHookOptions<GetRmsOrgSetupRmsTypeQuery, GetRmsOrgSetupRmsTypeQueryVariables> & ({ variables: GetRmsOrgSetupRmsTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRmsOrgSetupRmsTypeQuery, GetRmsOrgSetupRmsTypeQueryVariables>(GetRmsOrgSetupRmsTypeDocument, options);
      }
export function useGetRmsOrgSetupRmsTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRmsOrgSetupRmsTypeQuery, GetRmsOrgSetupRmsTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRmsOrgSetupRmsTypeQuery, GetRmsOrgSetupRmsTypeQueryVariables>(GetRmsOrgSetupRmsTypeDocument, options);
        }
export function useGetRmsOrgSetupRmsTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRmsOrgSetupRmsTypeQuery, GetRmsOrgSetupRmsTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRmsOrgSetupRmsTypeQuery, GetRmsOrgSetupRmsTypeQueryVariables>(GetRmsOrgSetupRmsTypeDocument, options);
        }
export type GetRmsOrgSetupRmsTypeQueryHookResult = ReturnType<typeof useGetRmsOrgSetupRmsTypeQuery>;
export type GetRmsOrgSetupRmsTypeLazyQueryHookResult = ReturnType<typeof useGetRmsOrgSetupRmsTypeLazyQuery>;
export type GetRmsOrgSetupRmsTypeSuspenseQueryHookResult = ReturnType<typeof useGetRmsOrgSetupRmsTypeSuspenseQuery>;
export type GetRmsOrgSetupRmsTypeQueryResult = Apollo.QueryResult<GetRmsOrgSetupRmsTypeQuery, GetRmsOrgSetupRmsTypeQueryVariables>;
export const UpsertRmsConnectorDocument = gql`
    mutation UpsertRmsConnector($campaignId: uuid!, $enabled: Boolean!, $webhook: String, $jobId: String, $customMappings: jsonb) {
  insert_rms_connectors_one(
    object: {campaign_id: $campaignId, enabled: $enabled, webhook: $webhook, job_id: $jobId, custom_mappings: $customMappings}
    on_conflict: {constraint: connectors_campaign_id_key, update_columns: [enabled, webhook, job_id, custom_mappings]}
  ) {
    id
    enabled
    webhook
    job_id
    custom_mappings
  }
}
    `;
export type UpsertRmsConnectorMutationFn = Apollo.MutationFunction<UpsertRmsConnectorMutation, UpsertRmsConnectorMutationVariables>;

/**
 * __useUpsertRmsConnectorMutation__
 *
 * To run a mutation, you first call `useUpsertRmsConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRmsConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRmsConnectorMutation, { data, loading, error }] = useUpsertRmsConnectorMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      enabled: // value for 'enabled'
 *      webhook: // value for 'webhook'
 *      jobId: // value for 'jobId'
 *      customMappings: // value for 'customMappings'
 *   },
 * });
 */
export function useUpsertRmsConnectorMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRmsConnectorMutation, UpsertRmsConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertRmsConnectorMutation, UpsertRmsConnectorMutationVariables>(UpsertRmsConnectorDocument, options);
      }
export type UpsertRmsConnectorMutationHookResult = ReturnType<typeof useUpsertRmsConnectorMutation>;
export type UpsertRmsConnectorMutationResult = Apollo.MutationResult<UpsertRmsConnectorMutation>;
export type UpsertRmsConnectorMutationOptions = Apollo.BaseMutationOptions<UpsertRmsConnectorMutation, UpsertRmsConnectorMutationVariables>;
export type ad_campaign_metricsKeySpecifier = ('campaign' | 'campaign_id' | 'clicks' | 'conversions' | 'cpc' | 'created_at' | 'id' | 'impressions' | 'name' | 'platform' | 'platform_specific_id' | 'reach' | 'spend' | 'status' | 'updated_at' | ad_campaign_metricsKeySpecifier)[];
export type ad_campaign_metricsFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	cpc?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	platform?: FieldPolicy<any> | FieldReadFunction<any>,
	platform_specific_id?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_aggregateKeySpecifier = ('aggregate' | 'nodes' | ad_campaign_metrics_aggregateKeySpecifier)[];
export type ad_campaign_metrics_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | ad_campaign_metrics_aggregate_fieldsKeySpecifier)[];
export type ad_campaign_metrics_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_avg_fieldsKeySpecifier = ('clicks' | 'conversions' | 'impressions' | 'reach' | 'spend' | ad_campaign_metrics_avg_fieldsKeySpecifier)[];
export type ad_campaign_metrics_avg_fieldsFieldPolicy = {
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_max_fieldsKeySpecifier = ('campaign_id' | 'clicks' | 'conversions' | 'cpc' | 'created_at' | 'id' | 'impressions' | 'name' | 'platform_specific_id' | 'reach' | 'spend' | 'status' | 'updated_at' | ad_campaign_metrics_max_fieldsKeySpecifier)[];
export type ad_campaign_metrics_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	cpc?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	platform_specific_id?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_min_fieldsKeySpecifier = ('campaign_id' | 'clicks' | 'conversions' | 'cpc' | 'created_at' | 'id' | 'impressions' | 'name' | 'platform_specific_id' | 'reach' | 'spend' | 'status' | 'updated_at' | ad_campaign_metrics_min_fieldsKeySpecifier)[];
export type ad_campaign_metrics_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	cpc?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	platform_specific_id?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | ad_campaign_metrics_mutation_responseKeySpecifier)[];
export type ad_campaign_metrics_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_stddev_fieldsKeySpecifier = ('clicks' | 'conversions' | 'impressions' | 'reach' | 'spend' | ad_campaign_metrics_stddev_fieldsKeySpecifier)[];
export type ad_campaign_metrics_stddev_fieldsFieldPolicy = {
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_stddev_pop_fieldsKeySpecifier = ('clicks' | 'conversions' | 'impressions' | 'reach' | 'spend' | ad_campaign_metrics_stddev_pop_fieldsKeySpecifier)[];
export type ad_campaign_metrics_stddev_pop_fieldsFieldPolicy = {
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_stddev_samp_fieldsKeySpecifier = ('clicks' | 'conversions' | 'impressions' | 'reach' | 'spend' | ad_campaign_metrics_stddev_samp_fieldsKeySpecifier)[];
export type ad_campaign_metrics_stddev_samp_fieldsFieldPolicy = {
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_sum_fieldsKeySpecifier = ('clicks' | 'conversions' | 'impressions' | 'reach' | 'spend' | ad_campaign_metrics_sum_fieldsKeySpecifier)[];
export type ad_campaign_metrics_sum_fieldsFieldPolicy = {
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_var_pop_fieldsKeySpecifier = ('clicks' | 'conversions' | 'impressions' | 'reach' | 'spend' | ad_campaign_metrics_var_pop_fieldsKeySpecifier)[];
export type ad_campaign_metrics_var_pop_fieldsFieldPolicy = {
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_var_samp_fieldsKeySpecifier = ('clicks' | 'conversions' | 'impressions' | 'reach' | 'spend' | ad_campaign_metrics_var_samp_fieldsKeySpecifier)[];
export type ad_campaign_metrics_var_samp_fieldsFieldPolicy = {
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_campaign_metrics_variance_fieldsKeySpecifier = ('clicks' | 'conversions' | 'impressions' | 'reach' | 'spend' | ad_campaign_metrics_variance_fieldsKeySpecifier)[];
export type ad_campaign_metrics_variance_fieldsFieldPolicy = {
	clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	conversions?: FieldPolicy<any> | FieldReadFunction<any>,
	impressions?: FieldPolicy<any> | FieldReadFunction<any>,
	reach?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_commentKeySpecifier = ('created_at' | 'creative_id' | 'id' | 'setting_reference' | 'text' | 'user_id' | ad_commentKeySpecifier)[];
export type ad_commentFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_reference?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	user_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_comment_aggregateKeySpecifier = ('aggregate' | 'nodes' | ad_comment_aggregateKeySpecifier)[];
export type ad_comment_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_comment_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | ad_comment_aggregate_fieldsKeySpecifier)[];
export type ad_comment_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_comment_max_fieldsKeySpecifier = ('created_at' | 'creative_id' | 'id' | 'text' | 'user_id' | ad_comment_max_fieldsKeySpecifier)[];
export type ad_comment_max_fieldsFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	user_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_comment_min_fieldsKeySpecifier = ('created_at' | 'creative_id' | 'id' | 'text' | 'user_id' | ad_comment_min_fieldsKeySpecifier)[];
export type ad_comment_min_fieldsFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	user_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_comment_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | ad_comment_mutation_responseKeySpecifier)[];
export type ad_comment_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creativeKeySpecifier = ('ad' | 'ad_id' | 'background_upload' | 'background_upload_id' | 'benefits' | 'call_to_action' | 'call_to_action_background_color_hex' | 'call_to_action_text_color_hex' | 'comments' | 'comments_aggregate' | 'created_at' | 'creative_upload' | 'creative_upload_id' | 'external_id' | 'feedback' | 'feedback_aggregate' | 'funnel_url' | 'headline' | 'headline_background_color_hex' | 'headline_text_color_hex' | 'id' | 'logo_upload' | 'logo_upload_id' | 'mime_type' | ad_creativeKeySpecifier)[];
export type ad_creativeFieldPolicy = {
	ad?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_id?: FieldPolicy<any> | FieldReadFunction<any>,
	background_upload?: FieldPolicy<any> | FieldReadFunction<any>,
	background_upload_id?: FieldPolicy<any> | FieldReadFunction<any>,
	benefits?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action_background_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action_text_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	comments?: FieldPolicy<any> | FieldReadFunction<any>,
	comments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_upload?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_upload_id?: FieldPolicy<any> | FieldReadFunction<any>,
	external_id?: FieldPolicy<any> | FieldReadFunction<any>,
	feedback?: FieldPolicy<any> | FieldReadFunction<any>,
	feedback_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_url?: FieldPolicy<any> | FieldReadFunction<any>,
	headline?: FieldPolicy<any> | FieldReadFunction<any>,
	headline_background_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	headline_text_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_upload?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_upload_id?: FieldPolicy<any> | FieldReadFunction<any>,
	mime_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_aggregateKeySpecifier = ('aggregate' | 'nodes' | ad_creative_aggregateKeySpecifier)[];
export type ad_creative_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | ad_creative_aggregate_fieldsKeySpecifier)[];
export type ad_creative_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_feedbackKeySpecifier = ('created_at' | 'creative' | 'creative_id' | 'id' | 'text' | ad_creative_feedbackKeySpecifier)[];
export type ad_creative_feedbackFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_feedback_aggregateKeySpecifier = ('aggregate' | 'nodes' | ad_creative_feedback_aggregateKeySpecifier)[];
export type ad_creative_feedback_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_feedback_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | ad_creative_feedback_aggregate_fieldsKeySpecifier)[];
export type ad_creative_feedback_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_feedback_max_fieldsKeySpecifier = ('created_at' | 'creative_id' | 'id' | 'text' | ad_creative_feedback_max_fieldsKeySpecifier)[];
export type ad_creative_feedback_max_fieldsFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_feedback_min_fieldsKeySpecifier = ('created_at' | 'creative_id' | 'id' | 'text' | ad_creative_feedback_min_fieldsKeySpecifier)[];
export type ad_creative_feedback_min_fieldsFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_feedback_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | ad_creative_feedback_mutation_responseKeySpecifier)[];
export type ad_creative_feedback_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_max_fieldsKeySpecifier = ('ad_id' | 'background_upload_id' | 'benefits' | 'call_to_action' | 'call_to_action_background_color_hex' | 'call_to_action_text_color_hex' | 'created_at' | 'creative_upload_id' | 'external_id' | 'funnel_url' | 'headline' | 'headline_background_color_hex' | 'headline_text_color_hex' | 'id' | 'logo_upload_id' | 'mime_type' | ad_creative_max_fieldsKeySpecifier)[];
export type ad_creative_max_fieldsFieldPolicy = {
	ad_id?: FieldPolicy<any> | FieldReadFunction<any>,
	background_upload_id?: FieldPolicy<any> | FieldReadFunction<any>,
	benefits?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action_background_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action_text_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_upload_id?: FieldPolicy<any> | FieldReadFunction<any>,
	external_id?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_url?: FieldPolicy<any> | FieldReadFunction<any>,
	headline?: FieldPolicy<any> | FieldReadFunction<any>,
	headline_background_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	headline_text_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_upload_id?: FieldPolicy<any> | FieldReadFunction<any>,
	mime_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_min_fieldsKeySpecifier = ('ad_id' | 'background_upload_id' | 'benefits' | 'call_to_action' | 'call_to_action_background_color_hex' | 'call_to_action_text_color_hex' | 'created_at' | 'creative_upload_id' | 'external_id' | 'funnel_url' | 'headline' | 'headline_background_color_hex' | 'headline_text_color_hex' | 'id' | 'logo_upload_id' | 'mime_type' | ad_creative_min_fieldsKeySpecifier)[];
export type ad_creative_min_fieldsFieldPolicy = {
	ad_id?: FieldPolicy<any> | FieldReadFunction<any>,
	background_upload_id?: FieldPolicy<any> | FieldReadFunction<any>,
	benefits?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action_background_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action_text_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_upload_id?: FieldPolicy<any> | FieldReadFunction<any>,
	external_id?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_url?: FieldPolicy<any> | FieldReadFunction<any>,
	headline?: FieldPolicy<any> | FieldReadFunction<any>,
	headline_background_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	headline_text_color_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_upload_id?: FieldPolicy<any> | FieldReadFunction<any>,
	mime_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_creative_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | ad_creative_mutation_responseKeySpecifier)[];
export type ad_creative_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_platformKeySpecifier = ('campaign_metrics' | 'campaign_metrics_aggregate' | 'value' | ad_platformKeySpecifier)[];
export type ad_platformFieldPolicy = {
	campaign_metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_metrics_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_platform_aggregateKeySpecifier = ('aggregate' | 'nodes' | ad_platform_aggregateKeySpecifier)[];
export type ad_platform_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_platform_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | ad_platform_aggregate_fieldsKeySpecifier)[];
export type ad_platform_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_platform_max_fieldsKeySpecifier = ('value' | ad_platform_max_fieldsKeySpecifier)[];
export type ad_platform_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_platform_min_fieldsKeySpecifier = ('value' | ad_platform_min_fieldsKeySpecifier)[];
export type ad_platform_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_platform_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | ad_platform_mutation_responseKeySpecifier)[];
export type ad_platform_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_providersKeySpecifier = ('access_token' | 'account_id' | 'account_secret' | 'api_key' | 'created_at' | 'error_message' | 'expires_at' | 'id' | 'last_error_at' | 'last_sync_at' | 'name' | 'platform' | 'refresh_token' | 'updated_at' | ad_providersKeySpecifier)[];
export type ad_providersFieldPolicy = {
	access_token?: FieldPolicy<any> | FieldReadFunction<any>,
	account_id?: FieldPolicy<any> | FieldReadFunction<any>,
	account_secret?: FieldPolicy<any> | FieldReadFunction<any>,
	api_key?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	error_message?: FieldPolicy<any> | FieldReadFunction<any>,
	expires_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_error_at?: FieldPolicy<any> | FieldReadFunction<any>,
	last_sync_at?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	platform?: FieldPolicy<any> | FieldReadFunction<any>,
	refresh_token?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_providers_aggregateKeySpecifier = ('aggregate' | 'nodes' | ad_providers_aggregateKeySpecifier)[];
export type ad_providers_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_providers_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | ad_providers_aggregate_fieldsKeySpecifier)[];
export type ad_providers_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_providers_max_fieldsKeySpecifier = ('access_token' | 'account_id' | 'account_secret' | 'api_key' | 'created_at' | 'error_message' | 'expires_at' | 'id' | 'last_error_at' | 'last_sync_at' | 'name' | 'refresh_token' | 'updated_at' | ad_providers_max_fieldsKeySpecifier)[];
export type ad_providers_max_fieldsFieldPolicy = {
	access_token?: FieldPolicy<any> | FieldReadFunction<any>,
	account_id?: FieldPolicy<any> | FieldReadFunction<any>,
	account_secret?: FieldPolicy<any> | FieldReadFunction<any>,
	api_key?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	error_message?: FieldPolicy<any> | FieldReadFunction<any>,
	expires_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_error_at?: FieldPolicy<any> | FieldReadFunction<any>,
	last_sync_at?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	refresh_token?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_providers_min_fieldsKeySpecifier = ('access_token' | 'account_id' | 'account_secret' | 'api_key' | 'created_at' | 'error_message' | 'expires_at' | 'id' | 'last_error_at' | 'last_sync_at' | 'name' | 'refresh_token' | 'updated_at' | ad_providers_min_fieldsKeySpecifier)[];
export type ad_providers_min_fieldsFieldPolicy = {
	access_token?: FieldPolicy<any> | FieldReadFunction<any>,
	account_id?: FieldPolicy<any> | FieldReadFunction<any>,
	account_secret?: FieldPolicy<any> | FieldReadFunction<any>,
	api_key?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	error_message?: FieldPolicy<any> | FieldReadFunction<any>,
	expires_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_error_at?: FieldPolicy<any> | FieldReadFunction<any>,
	last_sync_at?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	refresh_token?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_providers_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | ad_providers_mutation_responseKeySpecifier)[];
export type ad_providers_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_settingKeySpecifier = ('value' | ad_settingKeySpecifier)[];
export type ad_settingFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_setting_aggregateKeySpecifier = ('aggregate' | 'nodes' | ad_setting_aggregateKeySpecifier)[];
export type ad_setting_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_setting_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | ad_setting_aggregate_fieldsKeySpecifier)[];
export type ad_setting_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_setting_max_fieldsKeySpecifier = ('value' | ad_setting_max_fieldsKeySpecifier)[];
export type ad_setting_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_setting_min_fieldsKeySpecifier = ('value' | ad_setting_min_fieldsKeySpecifier)[];
export type ad_setting_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_setting_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | ad_setting_mutation_responseKeySpecifier)[];
export type ad_setting_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_statusKeySpecifier = ('value' | ad_statusKeySpecifier)[];
export type ad_statusFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_status_aggregateKeySpecifier = ('aggregate' | 'nodes' | ad_status_aggregateKeySpecifier)[];
export type ad_status_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_status_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | ad_status_aggregate_fieldsKeySpecifier)[];
export type ad_status_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_status_max_fieldsKeySpecifier = ('value' | ad_status_max_fieldsKeySpecifier)[];
export type ad_status_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_status_min_fieldsKeySpecifier = ('value' | ad_status_min_fieldsKeySpecifier)[];
export type ad_status_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ad_status_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | ad_status_mutation_responseKeySpecifier)[];
export type ad_status_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaignsKeySpecifier = ('call_from' | 'call_till' | 'call_wait_time' | 'campaign' | 'campaign_data' | 'campaign_id' | 'created_at' | 'enabled' | 'from' | 'id' | 'inbound' | 'is_active' | 'make_id' | 'max_calls' | 'outbound_calls' | 'outbound_calls_aggregate' | 'pathway_id' | 'tier' | 'updated_at' | 'webhook' | anna_ai_call_campaignsKeySpecifier)[];
export type anna_ai_call_campaignsFieldPolicy = {
	call_from?: FieldPolicy<any> | FieldReadFunction<any>,
	call_till?: FieldPolicy<any> | FieldReadFunction<any>,
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_data?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	from?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inbound?: FieldPolicy<any> | FieldReadFunction<any>,
	is_active?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>,
	outbound_calls?: FieldPolicy<any> | FieldReadFunction<any>,
	outbound_calls_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pathway_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tier?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_aggregateKeySpecifier = ('aggregate' | 'nodes' | anna_ai_call_campaigns_aggregateKeySpecifier)[];
export type anna_ai_call_campaigns_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | anna_ai_call_campaigns_aggregate_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_avg_fieldsKeySpecifier = ('call_wait_time' | 'make_id' | 'max_calls' | anna_ai_call_campaigns_avg_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_avg_fieldsFieldPolicy = {
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_max_fieldsKeySpecifier = ('call_from' | 'call_till' | 'call_wait_time' | 'campaign_id' | 'created_at' | 'from' | 'id' | 'make_id' | 'max_calls' | 'pathway_id' | 'tier' | 'updated_at' | 'webhook' | anna_ai_call_campaigns_max_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_max_fieldsFieldPolicy = {
	call_from?: FieldPolicy<any> | FieldReadFunction<any>,
	call_till?: FieldPolicy<any> | FieldReadFunction<any>,
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	from?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>,
	pathway_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tier?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_min_fieldsKeySpecifier = ('call_from' | 'call_till' | 'call_wait_time' | 'campaign_id' | 'created_at' | 'from' | 'id' | 'make_id' | 'max_calls' | 'pathway_id' | 'tier' | 'updated_at' | 'webhook' | anna_ai_call_campaigns_min_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_min_fieldsFieldPolicy = {
	call_from?: FieldPolicy<any> | FieldReadFunction<any>,
	call_till?: FieldPolicy<any> | FieldReadFunction<any>,
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	from?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>,
	pathway_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tier?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | anna_ai_call_campaigns_mutation_responseKeySpecifier)[];
export type anna_ai_call_campaigns_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_stddev_fieldsKeySpecifier = ('call_wait_time' | 'make_id' | 'max_calls' | anna_ai_call_campaigns_stddev_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_stddev_fieldsFieldPolicy = {
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_stddev_pop_fieldsKeySpecifier = ('call_wait_time' | 'make_id' | 'max_calls' | anna_ai_call_campaigns_stddev_pop_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_stddev_pop_fieldsFieldPolicy = {
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_stddev_samp_fieldsKeySpecifier = ('call_wait_time' | 'make_id' | 'max_calls' | anna_ai_call_campaigns_stddev_samp_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_stddev_samp_fieldsFieldPolicy = {
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_sum_fieldsKeySpecifier = ('call_wait_time' | 'make_id' | 'max_calls' | anna_ai_call_campaigns_sum_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_sum_fieldsFieldPolicy = {
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_var_pop_fieldsKeySpecifier = ('call_wait_time' | 'make_id' | 'max_calls' | anna_ai_call_campaigns_var_pop_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_var_pop_fieldsFieldPolicy = {
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_var_samp_fieldsKeySpecifier = ('call_wait_time' | 'make_id' | 'max_calls' | anna_ai_call_campaigns_var_samp_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_var_samp_fieldsFieldPolicy = {
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_campaigns_variance_fieldsKeySpecifier = ('call_wait_time' | 'make_id' | 'max_calls' | anna_ai_call_campaigns_variance_fieldsKeySpecifier)[];
export type anna_ai_call_campaigns_variance_fieldsFieldPolicy = {
	call_wait_time?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	max_calls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_statesKeySpecifier = ('outbound_calls' | 'outbound_calls_aggregate' | 'value' | anna_ai_call_statesKeySpecifier)[];
export type anna_ai_call_statesFieldPolicy = {
	outbound_calls?: FieldPolicy<any> | FieldReadFunction<any>,
	outbound_calls_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_states_aggregateKeySpecifier = ('aggregate' | 'nodes' | anna_ai_call_states_aggregateKeySpecifier)[];
export type anna_ai_call_states_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_states_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | anna_ai_call_states_aggregate_fieldsKeySpecifier)[];
export type anna_ai_call_states_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_states_max_fieldsKeySpecifier = ('value' | anna_ai_call_states_max_fieldsKeySpecifier)[];
export type anna_ai_call_states_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_states_min_fieldsKeySpecifier = ('value' | anna_ai_call_states_min_fieldsKeySpecifier)[];
export type anna_ai_call_states_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_call_states_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | anna_ai_call_states_mutation_responseKeySpecifier)[];
export type anna_ai_call_states_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_outbound_callsKeySpecifier = ('call_campaign' | 'call_campaign_id' | 'call_ended_by' | 'call_id' | 'call_state' | 'consent_given' | 'contact' | 'contact_id' | 'created_at' | 'duration' | 'end_call_result' | 'ended_at' | 'file_id' | 'has_recording' | 'id' | 'lang_skill' | 'overall_impression' | 'pathway_tags' | 'planned_at' | 'q_and_a' | 'started_at' | 'state' | 'summary' | 'telli_contact_id' | 'to' | 'transcripts' | 'upload' | 'variables' | anna_ai_outbound_callsKeySpecifier)[];
export type anna_ai_outbound_callsFieldPolicy = {
	call_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	call_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	call_ended_by?: FieldPolicy<any> | FieldReadFunction<any>,
	call_id?: FieldPolicy<any> | FieldReadFunction<any>,
	call_state?: FieldPolicy<any> | FieldReadFunction<any>,
	consent_given?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	end_call_result?: FieldPolicy<any> | FieldReadFunction<any>,
	ended_at?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	has_recording?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lang_skill?: FieldPolicy<any> | FieldReadFunction<any>,
	overall_impression?: FieldPolicy<any> | FieldReadFunction<any>,
	pathway_tags?: FieldPolicy<any> | FieldReadFunction<any>,
	planned_at?: FieldPolicy<any> | FieldReadFunction<any>,
	q_and_a?: FieldPolicy<any> | FieldReadFunction<any>,
	started_at?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	telli_contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>,
	transcripts?: FieldPolicy<any> | FieldReadFunction<any>,
	upload?: FieldPolicy<any> | FieldReadFunction<any>,
	variables?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_outbound_calls_aggregateKeySpecifier = ('aggregate' | 'nodes' | anna_ai_outbound_calls_aggregateKeySpecifier)[];
export type anna_ai_outbound_calls_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_outbound_calls_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | anna_ai_outbound_calls_aggregate_fieldsKeySpecifier)[];
export type anna_ai_outbound_calls_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_outbound_calls_max_fieldsKeySpecifier = ('call_campaign_id' | 'call_ended_by' | 'call_id' | 'contact_id' | 'created_at' | 'duration' | 'end_call_result' | 'ended_at' | 'file_id' | 'id' | 'lang_skill' | 'overall_impression' | 'planned_at' | 'started_at' | 'state' | 'summary' | 'telli_contact_id' | 'to' | anna_ai_outbound_calls_max_fieldsKeySpecifier)[];
export type anna_ai_outbound_calls_max_fieldsFieldPolicy = {
	call_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	call_ended_by?: FieldPolicy<any> | FieldReadFunction<any>,
	call_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	end_call_result?: FieldPolicy<any> | FieldReadFunction<any>,
	ended_at?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lang_skill?: FieldPolicy<any> | FieldReadFunction<any>,
	overall_impression?: FieldPolicy<any> | FieldReadFunction<any>,
	planned_at?: FieldPolicy<any> | FieldReadFunction<any>,
	started_at?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	telli_contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_outbound_calls_min_fieldsKeySpecifier = ('call_campaign_id' | 'call_ended_by' | 'call_id' | 'contact_id' | 'created_at' | 'duration' | 'end_call_result' | 'ended_at' | 'file_id' | 'id' | 'lang_skill' | 'overall_impression' | 'planned_at' | 'started_at' | 'state' | 'summary' | 'telli_contact_id' | 'to' | anna_ai_outbound_calls_min_fieldsKeySpecifier)[];
export type anna_ai_outbound_calls_min_fieldsFieldPolicy = {
	call_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	call_ended_by?: FieldPolicy<any> | FieldReadFunction<any>,
	call_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	end_call_result?: FieldPolicy<any> | FieldReadFunction<any>,
	ended_at?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lang_skill?: FieldPolicy<any> | FieldReadFunction<any>,
	overall_impression?: FieldPolicy<any> | FieldReadFunction<any>,
	planned_at?: FieldPolicy<any> | FieldReadFunction<any>,
	started_at?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	telli_contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>
};
export type anna_ai_outbound_calls_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | anna_ai_outbound_calls_mutation_responseKeySpecifier)[];
export type anna_ai_outbound_calls_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type answerKeySpecifier = ('campaign' | 'campaign_id' | 'contact' | 'contact_id' | 'id' | 'question' | 'question_id' | 'value' | answerKeySpecifier)[];
export type answerFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type answer_aggregateKeySpecifier = ('aggregate' | 'nodes' | answer_aggregateKeySpecifier)[];
export type answer_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type answer_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | answer_aggregate_fieldsKeySpecifier)[];
export type answer_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type answer_max_fieldsKeySpecifier = ('campaign_id' | 'contact_id' | 'id' | 'question_id' | 'value' | answer_max_fieldsKeySpecifier)[];
export type answer_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type answer_min_fieldsKeySpecifier = ('campaign_id' | 'contact_id' | 'id' | 'question_id' | 'value' | answer_min_fieldsKeySpecifier)[];
export type answer_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type answer_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | answer_mutation_responseKeySpecifier)[];
export type answer_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_eventKeySpecifier = ('applicant_id' | 'created_at' | 'extra' | 'id' | 'name' | applicant_eventKeySpecifier)[];
export type applicant_eventFieldPolicy = {
	applicant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	extra?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_aggregateKeySpecifier = ('aggregate' | 'nodes' | applicant_event_aggregateKeySpecifier)[];
export type applicant_event_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | applicant_event_aggregate_fieldsKeySpecifier)[];
export type applicant_event_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_avg_fieldsKeySpecifier = ('id' | applicant_event_avg_fieldsKeySpecifier)[];
export type applicant_event_avg_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_max_fieldsKeySpecifier = ('applicant_id' | 'created_at' | 'id' | 'name' | applicant_event_max_fieldsKeySpecifier)[];
export type applicant_event_max_fieldsFieldPolicy = {
	applicant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_min_fieldsKeySpecifier = ('applicant_id' | 'created_at' | 'id' | 'name' | applicant_event_min_fieldsKeySpecifier)[];
export type applicant_event_min_fieldsFieldPolicy = {
	applicant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | applicant_event_mutation_responseKeySpecifier)[];
export type applicant_event_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_stddev_fieldsKeySpecifier = ('id' | applicant_event_stddev_fieldsKeySpecifier)[];
export type applicant_event_stddev_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_stddev_pop_fieldsKeySpecifier = ('id' | applicant_event_stddev_pop_fieldsKeySpecifier)[];
export type applicant_event_stddev_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_stddev_samp_fieldsKeySpecifier = ('id' | applicant_event_stddev_samp_fieldsKeySpecifier)[];
export type applicant_event_stddev_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_sum_fieldsKeySpecifier = ('id' | applicant_event_sum_fieldsKeySpecifier)[];
export type applicant_event_sum_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_var_pop_fieldsKeySpecifier = ('id' | applicant_event_var_pop_fieldsKeySpecifier)[];
export type applicant_event_var_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_var_samp_fieldsKeySpecifier = ('id' | applicant_event_var_samp_fieldsKeySpecifier)[];
export type applicant_event_var_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type applicant_event_variance_fieldsKeySpecifier = ('id' | applicant_event_variance_fieldsKeySpecifier)[];
export type applicant_event_variance_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_column_typeKeySpecifier = ('value' | board_column_typeKeySpecifier)[];
export type board_column_typeFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_column_type_aggregateKeySpecifier = ('aggregate' | 'nodes' | board_column_type_aggregateKeySpecifier)[];
export type board_column_type_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_column_type_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | board_column_type_aggregate_fieldsKeySpecifier)[];
export type board_column_type_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_column_type_max_fieldsKeySpecifier = ('value' | board_column_type_max_fieldsKeySpecifier)[];
export type board_column_type_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_column_type_min_fieldsKeySpecifier = ('value' | board_column_type_min_fieldsKeySpecifier)[];
export type board_column_type_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_column_type_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | board_column_type_mutation_responseKeySpecifier)[];
export type board_column_type_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_boardKeySpecifier = ('campaign' | 'campaign_id' | 'columns' | 'columns_aggregate' | 'id' | board_contact_boardKeySpecifier)[];
export type board_contact_boardFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	columns?: FieldPolicy<any> | FieldReadFunction<any>,
	columns_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_aggregateKeySpecifier = ('aggregate' | 'nodes' | board_contact_board_aggregateKeySpecifier)[];
export type board_contact_board_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | board_contact_board_aggregate_fieldsKeySpecifier)[];
export type board_contact_board_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_columnKeySpecifier = ('board_id' | 'column_type' | 'contact_board' | 'contact_board_entries' | 'contact_board_entries_aggregate' | 'id' | 'name' | 'position' | 'type' | board_contact_board_columnKeySpecifier)[];
export type board_contact_board_columnFieldPolicy = {
	board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	column_type?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_board?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_board_entries?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_board_entries_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_aggregateKeySpecifier = ('aggregate' | 'nodes' | board_contact_board_column_aggregateKeySpecifier)[];
export type board_contact_board_column_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | board_contact_board_column_aggregate_fieldsKeySpecifier)[];
export type board_contact_board_column_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_avg_fieldsKeySpecifier = ('position' | board_contact_board_column_avg_fieldsKeySpecifier)[];
export type board_contact_board_column_avg_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_max_fieldsKeySpecifier = ('board_id' | 'id' | 'name' | 'position' | board_contact_board_column_max_fieldsKeySpecifier)[];
export type board_contact_board_column_max_fieldsFieldPolicy = {
	board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_min_fieldsKeySpecifier = ('board_id' | 'id' | 'name' | 'position' | board_contact_board_column_min_fieldsKeySpecifier)[];
export type board_contact_board_column_min_fieldsFieldPolicy = {
	board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | board_contact_board_column_mutation_responseKeySpecifier)[];
export type board_contact_board_column_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_stddev_fieldsKeySpecifier = ('position' | board_contact_board_column_stddev_fieldsKeySpecifier)[];
export type board_contact_board_column_stddev_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_stddev_pop_fieldsKeySpecifier = ('position' | board_contact_board_column_stddev_pop_fieldsKeySpecifier)[];
export type board_contact_board_column_stddev_pop_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_stddev_samp_fieldsKeySpecifier = ('position' | board_contact_board_column_stddev_samp_fieldsKeySpecifier)[];
export type board_contact_board_column_stddev_samp_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_sum_fieldsKeySpecifier = ('position' | board_contact_board_column_sum_fieldsKeySpecifier)[];
export type board_contact_board_column_sum_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_var_pop_fieldsKeySpecifier = ('position' | board_contact_board_column_var_pop_fieldsKeySpecifier)[];
export type board_contact_board_column_var_pop_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_var_samp_fieldsKeySpecifier = ('position' | board_contact_board_column_var_samp_fieldsKeySpecifier)[];
export type board_contact_board_column_var_samp_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_column_variance_fieldsKeySpecifier = ('position' | board_contact_board_column_variance_fieldsKeySpecifier)[];
export type board_contact_board_column_variance_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entryKeySpecifier = ('board_id' | 'column_id' | 'contact' | 'contact_board' | 'contact_id' | 'forward_log' | 'id' | 'notes' | 'notes_aggregate' | 'position' | 'score' | 'updated_at' | board_contact_board_entryKeySpecifier)[];
export type board_contact_board_entryFieldPolicy = {
	board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	column_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_board?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	forward_log?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	notes_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_aggregateKeySpecifier = ('aggregate' | 'nodes' | board_contact_board_entry_aggregateKeySpecifier)[];
export type board_contact_board_entry_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | board_contact_board_entry_aggregate_fieldsKeySpecifier)[];
export type board_contact_board_entry_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_avg_fieldsKeySpecifier = ('position' | 'score' | board_contact_board_entry_avg_fieldsKeySpecifier)[];
export type board_contact_board_entry_avg_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_max_fieldsKeySpecifier = ('board_id' | 'column_id' | 'contact_id' | 'id' | 'position' | 'score' | 'updated_at' | board_contact_board_entry_max_fieldsKeySpecifier)[];
export type board_contact_board_entry_max_fieldsFieldPolicy = {
	board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	column_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_min_fieldsKeySpecifier = ('board_id' | 'column_id' | 'contact_id' | 'id' | 'position' | 'score' | 'updated_at' | board_contact_board_entry_min_fieldsKeySpecifier)[];
export type board_contact_board_entry_min_fieldsFieldPolicy = {
	board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	column_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | board_contact_board_entry_mutation_responseKeySpecifier)[];
export type board_contact_board_entry_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_stddev_fieldsKeySpecifier = ('position' | 'score' | board_contact_board_entry_stddev_fieldsKeySpecifier)[];
export type board_contact_board_entry_stddev_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_stddev_pop_fieldsKeySpecifier = ('position' | 'score' | board_contact_board_entry_stddev_pop_fieldsKeySpecifier)[];
export type board_contact_board_entry_stddev_pop_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_stddev_samp_fieldsKeySpecifier = ('position' | 'score' | board_contact_board_entry_stddev_samp_fieldsKeySpecifier)[];
export type board_contact_board_entry_stddev_samp_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_sum_fieldsKeySpecifier = ('position' | 'score' | board_contact_board_entry_sum_fieldsKeySpecifier)[];
export type board_contact_board_entry_sum_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_var_pop_fieldsKeySpecifier = ('position' | 'score' | board_contact_board_entry_var_pop_fieldsKeySpecifier)[];
export type board_contact_board_entry_var_pop_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_var_samp_fieldsKeySpecifier = ('position' | 'score' | board_contact_board_entry_var_samp_fieldsKeySpecifier)[];
export type board_contact_board_entry_var_samp_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_entry_variance_fieldsKeySpecifier = ('position' | 'score' | board_contact_board_entry_variance_fieldsKeySpecifier)[];
export type board_contact_board_entry_variance_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_max_fieldsKeySpecifier = ('campaign_id' | 'id' | board_contact_board_max_fieldsKeySpecifier)[];
export type board_contact_board_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_min_fieldsKeySpecifier = ('campaign_id' | 'id' | board_contact_board_min_fieldsKeySpecifier)[];
export type board_contact_board_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_contact_board_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | board_contact_board_mutation_responseKeySpecifier)[];
export type board_contact_board_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_noteKeySpecifier = ('author_id' | 'contact' | 'contact_board_entry' | 'contact_board_entry_id' | 'contact_id' | 'content' | 'created_at' | 'id' | 'updated_at' | board_noteKeySpecifier)[];
export type board_noteFieldPolicy = {
	author_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_board_entry?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_board_entry_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_note_aggregateKeySpecifier = ('aggregate' | 'nodes' | board_note_aggregateKeySpecifier)[];
export type board_note_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_note_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | board_note_aggregate_fieldsKeySpecifier)[];
export type board_note_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_note_max_fieldsKeySpecifier = ('author_id' | 'contact_board_entry_id' | 'contact_id' | 'content' | 'created_at' | 'id' | 'updated_at' | board_note_max_fieldsKeySpecifier)[];
export type board_note_max_fieldsFieldPolicy = {
	author_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_board_entry_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_note_min_fieldsKeySpecifier = ('author_id' | 'contact_board_entry_id' | 'contact_id' | 'content' | 'created_at' | 'id' | 'updated_at' | board_note_min_fieldsKeySpecifier)[];
export type board_note_min_fieldsFieldPolicy = {
	author_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_board_entry_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type board_note_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | board_note_mutation_responseKeySpecifier)[];
export type board_note_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_assigneeKeySpecifier = ('value' | bot_assigneeKeySpecifier)[];
export type bot_assigneeFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_assignee_aggregateKeySpecifier = ('aggregate' | 'nodes' | bot_assignee_aggregateKeySpecifier)[];
export type bot_assignee_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_assignee_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | bot_assignee_aggregate_fieldsKeySpecifier)[];
export type bot_assignee_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_assignee_max_fieldsKeySpecifier = ('value' | bot_assignee_max_fieldsKeySpecifier)[];
export type bot_assignee_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_assignee_min_fieldsKeySpecifier = ('value' | bot_assignee_min_fieldsKeySpecifier)[];
export type bot_assignee_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_assignee_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | bot_assignee_mutation_responseKeySpecifier)[];
export type bot_assignee_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_channelKeySpecifier = ('value' | bot_channelKeySpecifier)[];
export type bot_channelFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_channel_aggregateKeySpecifier = ('aggregate' | 'nodes' | bot_channel_aggregateKeySpecifier)[];
export type bot_channel_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_channel_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | bot_channel_aggregate_fieldsKeySpecifier)[];
export type bot_channel_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_channel_max_fieldsKeySpecifier = ('value' | bot_channel_max_fieldsKeySpecifier)[];
export type bot_channel_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_channel_min_fieldsKeySpecifier = ('value' | bot_channel_min_fieldsKeySpecifier)[];
export type bot_channel_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_channel_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | bot_channel_mutation_responseKeySpecifier)[];
export type bot_channel_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversationKeySpecifier = ('assigned' | 'assignee' | 'channel' | 'channel_specific_id' | 'closed_at' | 'contact' | 'contact_id' | 'id' | 'invalid_reason' | 'messages' | 'messages_aggregate' | 'start_attempts' | 'started_at' | 'state' | bot_conversationKeySpecifier)[];
export type bot_conversationFieldPolicy = {
	assigned?: FieldPolicy<any> | FieldReadFunction<any>,
	assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channel_specific_id?: FieldPolicy<any> | FieldReadFunction<any>,
	closed_at?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invalid_reason?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	messages_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>,
	started_at?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_aggregateKeySpecifier = ('aggregate' | 'nodes' | bot_conversation_aggregateKeySpecifier)[];
export type bot_conversation_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | bot_conversation_aggregate_fieldsKeySpecifier)[];
export type bot_conversation_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_avg_fieldsKeySpecifier = ('start_attempts' | bot_conversation_avg_fieldsKeySpecifier)[];
export type bot_conversation_avg_fieldsFieldPolicy = {
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_max_fieldsKeySpecifier = ('channel_specific_id' | 'closed_at' | 'contact_id' | 'id' | 'invalid_reason' | 'start_attempts' | 'started_at' | bot_conversation_max_fieldsKeySpecifier)[];
export type bot_conversation_max_fieldsFieldPolicy = {
	channel_specific_id?: FieldPolicy<any> | FieldReadFunction<any>,
	closed_at?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invalid_reason?: FieldPolicy<any> | FieldReadFunction<any>,
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>,
	started_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_min_fieldsKeySpecifier = ('channel_specific_id' | 'closed_at' | 'contact_id' | 'id' | 'invalid_reason' | 'start_attempts' | 'started_at' | bot_conversation_min_fieldsKeySpecifier)[];
export type bot_conversation_min_fieldsFieldPolicy = {
	channel_specific_id?: FieldPolicy<any> | FieldReadFunction<any>,
	closed_at?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invalid_reason?: FieldPolicy<any> | FieldReadFunction<any>,
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>,
	started_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | bot_conversation_mutation_responseKeySpecifier)[];
export type bot_conversation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_stateKeySpecifier = ('value' | bot_conversation_stateKeySpecifier)[];
export type bot_conversation_stateFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_state_aggregateKeySpecifier = ('aggregate' | 'nodes' | bot_conversation_state_aggregateKeySpecifier)[];
export type bot_conversation_state_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_state_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | bot_conversation_state_aggregate_fieldsKeySpecifier)[];
export type bot_conversation_state_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_state_max_fieldsKeySpecifier = ('value' | bot_conversation_state_max_fieldsKeySpecifier)[];
export type bot_conversation_state_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_state_min_fieldsKeySpecifier = ('value' | bot_conversation_state_min_fieldsKeySpecifier)[];
export type bot_conversation_state_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_state_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | bot_conversation_state_mutation_responseKeySpecifier)[];
export type bot_conversation_state_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_stddev_fieldsKeySpecifier = ('start_attempts' | bot_conversation_stddev_fieldsKeySpecifier)[];
export type bot_conversation_stddev_fieldsFieldPolicy = {
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_stddev_pop_fieldsKeySpecifier = ('start_attempts' | bot_conversation_stddev_pop_fieldsKeySpecifier)[];
export type bot_conversation_stddev_pop_fieldsFieldPolicy = {
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_stddev_samp_fieldsKeySpecifier = ('start_attempts' | bot_conversation_stddev_samp_fieldsKeySpecifier)[];
export type bot_conversation_stddev_samp_fieldsFieldPolicy = {
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_sum_fieldsKeySpecifier = ('start_attempts' | bot_conversation_sum_fieldsKeySpecifier)[];
export type bot_conversation_sum_fieldsFieldPolicy = {
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_var_pop_fieldsKeySpecifier = ('start_attempts' | bot_conversation_var_pop_fieldsKeySpecifier)[];
export type bot_conversation_var_pop_fieldsFieldPolicy = {
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_var_samp_fieldsKeySpecifier = ('start_attempts' | bot_conversation_var_samp_fieldsKeySpecifier)[];
export type bot_conversation_var_samp_fieldsFieldPolicy = {
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_conversation_variance_fieldsKeySpecifier = ('start_attempts' | bot_conversation_variance_fieldsKeySpecifier)[];
export type bot_conversation_variance_fieldsFieldPolicy = {
	start_attempts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_messageKeySpecifier = ('conversation' | 'conversation_id' | 'created_at' | 'external_id' | 'id' | 'sent_at' | 'sent_by' | 'status' | 'text' | bot_messageKeySpecifier)[];
export type bot_messageFieldPolicy = {
	conversation?: FieldPolicy<any> | FieldReadFunction<any>,
	conversation_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	external_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sent_at?: FieldPolicy<any> | FieldReadFunction<any>,
	sent_by?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_aggregateKeySpecifier = ('aggregate' | 'nodes' | bot_message_aggregateKeySpecifier)[];
export type bot_message_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | bot_message_aggregate_fieldsKeySpecifier)[];
export type bot_message_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_avg_fieldsKeySpecifier = ('id' | bot_message_avg_fieldsKeySpecifier)[];
export type bot_message_avg_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_max_fieldsKeySpecifier = ('conversation_id' | 'created_at' | 'external_id' | 'id' | 'sent_at' | 'text' | bot_message_max_fieldsKeySpecifier)[];
export type bot_message_max_fieldsFieldPolicy = {
	conversation_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	external_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sent_at?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_min_fieldsKeySpecifier = ('conversation_id' | 'created_at' | 'external_id' | 'id' | 'sent_at' | 'text' | bot_message_min_fieldsKeySpecifier)[];
export type bot_message_min_fieldsFieldPolicy = {
	conversation_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	external_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sent_at?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | bot_message_mutation_responseKeySpecifier)[];
export type bot_message_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_statusKeySpecifier = ('value' | bot_message_statusKeySpecifier)[];
export type bot_message_statusFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_status_aggregateKeySpecifier = ('aggregate' | 'nodes' | bot_message_status_aggregateKeySpecifier)[];
export type bot_message_status_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_status_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | bot_message_status_aggregate_fieldsKeySpecifier)[];
export type bot_message_status_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_status_max_fieldsKeySpecifier = ('value' | bot_message_status_max_fieldsKeySpecifier)[];
export type bot_message_status_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_status_min_fieldsKeySpecifier = ('value' | bot_message_status_min_fieldsKeySpecifier)[];
export type bot_message_status_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_status_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | bot_message_status_mutation_responseKeySpecifier)[];
export type bot_message_status_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_stddev_fieldsKeySpecifier = ('id' | bot_message_stddev_fieldsKeySpecifier)[];
export type bot_message_stddev_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_stddev_pop_fieldsKeySpecifier = ('id' | bot_message_stddev_pop_fieldsKeySpecifier)[];
export type bot_message_stddev_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_stddev_samp_fieldsKeySpecifier = ('id' | bot_message_stddev_samp_fieldsKeySpecifier)[];
export type bot_message_stddev_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_sum_fieldsKeySpecifier = ('id' | bot_message_sum_fieldsKeySpecifier)[];
export type bot_message_sum_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_var_pop_fieldsKeySpecifier = ('id' | bot_message_var_pop_fieldsKeySpecifier)[];
export type bot_message_var_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_var_samp_fieldsKeySpecifier = ('id' | bot_message_var_samp_fieldsKeySpecifier)[];
export type bot_message_var_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_message_variance_fieldsKeySpecifier = ('id' | bot_message_variance_fieldsKeySpecifier)[];
export type bot_message_variance_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_senderKeySpecifier = ('value' | bot_senderKeySpecifier)[];
export type bot_senderFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_sender_aggregateKeySpecifier = ('aggregate' | 'nodes' | bot_sender_aggregateKeySpecifier)[];
export type bot_sender_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_sender_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | bot_sender_aggregate_fieldsKeySpecifier)[];
export type bot_sender_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_sender_max_fieldsKeySpecifier = ('value' | bot_sender_max_fieldsKeySpecifier)[];
export type bot_sender_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_sender_min_fieldsKeySpecifier = ('value' | bot_sender_min_fieldsKeySpecifier)[];
export type bot_sender_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bot_sender_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | bot_sender_mutation_responseKeySpecifier)[];
export type bot_sender_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaignKeySpecifier = ('ad_campaign_metrics' | 'ad_campaign_metrics_aggregate' | 'ads' | 'ads_aggregate' | 'ads_email_list' | 'applicant_board_enabled' | 'applicants_email_list' | 'bot_consent' | 'c_location' | 'call_campaign' | 'call_campaign_aggregate' | 'campaign_events' | 'campaign_events_aggregate' | 'campaign_status' | 'campaign_work_location' | 'category' | 'chat_bot_enabled' | 'chat_bot_is_ko' | 'chat_bot_v2_enabled' | 'contacts' | 'contacts_aggregate' | 'contacts_per_day' | 'contacts_per_day_aggregate' | 'cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'email_template_overwrite' | 'end' | 'forwarding' | 'funnel' | 'funnel_insights' | 'funnel_page_insights' | 'funnel_page_insights_aggregate' | 'funnel_whatsapp_share_clicks' | 'funnel_whatsapp_share_clicks_aggregate' | 'id' | 'is_hidden' | 'is_test' | 'job_posting_text' | 'location' | 'location_slug' | 'margin_in_percent' | 'media_budget' | 'meistertask_url' | 'monday_url' | 'name' | 'org_settings_override' | 'organization' | 'organization_id' | 'origin_contacts' | 'origin_contacts_aggregate' | 'pdf_enabled' | 'perspective_campaign' | 'perspective_campaign_id' | 'phone_number_default_region' | 'profit' | 'questions' | 'questions_aggregate' | 'remaining_customer_budget' | 'responsible_person' | 'rms_connector' | 'routing_info' | 'short_id' | 'start' | 'status' | 'status_log' | 'status_log_aggregate' | 'status_override' | 'support_email' | 'transactions' | 'transactions_aggregate' | 'unqualified_contacts_per_day' | 'unqualified_contacts_per_day_aggregate' | 'updated_at' | 'work_location' | campaignKeySpecifier)[];
export type campaignFieldPolicy = {
	ad_campaign_metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_campaign_metrics_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ads?: FieldPolicy<any> | FieldReadFunction<any>,
	ads_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ads_email_list?: FieldPolicy<any> | FieldReadFunction<any>,
	applicant_board_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	applicants_email_list?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_consent?: FieldPolicy<any> | FieldReadFunction<any>,
	c_location?: FieldPolicy<any> | FieldReadFunction<any>,
	call_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	call_campaign_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_events?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_events_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_work_location?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_is_ko?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_v2_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts_per_day?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts_per_day_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	email_template_overwrite?: FieldPolicy<any> | FieldReadFunction<any>,
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	forwarding?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_page_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_page_insights_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_whatsapp_share_clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_whatsapp_share_clicks_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_hidden?: FieldPolicy<any> | FieldReadFunction<any>,
	is_test?: FieldPolicy<any> | FieldReadFunction<any>,
	job_posting_text?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	location_slug?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_url?: FieldPolicy<any> | FieldReadFunction<any>,
	monday_url?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	org_settings_override?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_contacts_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pdf_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	phone_number_default_region?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	questions?: FieldPolicy<any> | FieldReadFunction<any>,
	questions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	responsible_person?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_connector?: FieldPolicy<any> | FieldReadFunction<any>,
	routing_info?: FieldPolicy<any> | FieldReadFunction<any>,
	short_id?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	status_log?: FieldPolicy<any> | FieldReadFunction<any>,
	status_log_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	status_override?: FieldPolicy<any> | FieldReadFunction<any>,
	support_email?: FieldPolicy<any> | FieldReadFunction<any>,
	transactions?: FieldPolicy<any> | FieldReadFunction<any>,
	transactions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	unqualified_contacts_per_day?: FieldPolicy<any> | FieldReadFunction<any>,
	unqualified_contacts_per_day_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	work_location?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_adKeySpecifier = ('campaign' | 'campaign_id' | 'created_at' | 'creative' | 'creative_id' | 'creatives_history' | 'creatives_history_aggregate' | 'id' | 'platform' | 'status' | 'updated_at' | campaign_adKeySpecifier)[];
export type campaign_adFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_id?: FieldPolicy<any> | FieldReadFunction<any>,
	creatives_history?: FieldPolicy<any> | FieldReadFunction<any>,
	creatives_history_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	platform?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_ad_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_ad_aggregateKeySpecifier)[];
export type campaign_ad_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_ad_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_ad_aggregate_fieldsKeySpecifier)[];
export type campaign_ad_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_ad_max_fieldsKeySpecifier = ('campaign_id' | 'created_at' | 'creative_id' | 'id' | 'updated_at' | campaign_ad_max_fieldsKeySpecifier)[];
export type campaign_ad_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_ad_min_fieldsKeySpecifier = ('campaign_id' | 'created_at' | 'creative_id' | 'id' | 'updated_at' | campaign_ad_min_fieldsKeySpecifier)[];
export type campaign_ad_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	creative_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_ad_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_ad_mutation_responseKeySpecifier)[];
export type campaign_ad_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_aggregateKeySpecifier)[];
export type campaign_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | campaign_aggregate_fieldsKeySpecifier)[];
export type campaign_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_avg_fieldsKeySpecifier = ('cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'margin_in_percent' | 'media_budget' | 'profit' | 'remaining_customer_budget' | campaign_avg_fieldsKeySpecifier)[];
export type campaign_avg_fieldsFieldPolicy = {
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budgetKeySpecifier = ('amount' | 'bonus' | 'campaign' | 'campaign_id' | 'organization_id' | 'without_bonus' | campaign_budgetKeySpecifier)[];
export type campaign_budgetFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_budget_aggregateKeySpecifier)[];
export type campaign_budget_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | campaign_budget_aggregate_fieldsKeySpecifier)[];
export type campaign_budget_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_avg_fieldsKeySpecifier = ('amount' | 'bonus' | 'without_bonus' | campaign_budget_avg_fieldsKeySpecifier)[];
export type campaign_budget_avg_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_max_fieldsKeySpecifier = ('amount' | 'bonus' | 'campaign_id' | 'organization_id' | 'without_bonus' | campaign_budget_max_fieldsKeySpecifier)[];
export type campaign_budget_max_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_min_fieldsKeySpecifier = ('amount' | 'bonus' | 'campaign_id' | 'organization_id' | 'without_bonus' | campaign_budget_min_fieldsKeySpecifier)[];
export type campaign_budget_min_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_budget_mutation_responseKeySpecifier)[];
export type campaign_budget_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_stddev_fieldsKeySpecifier = ('amount' | 'bonus' | 'without_bonus' | campaign_budget_stddev_fieldsKeySpecifier)[];
export type campaign_budget_stddev_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_stddev_pop_fieldsKeySpecifier = ('amount' | 'bonus' | 'without_bonus' | campaign_budget_stddev_pop_fieldsKeySpecifier)[];
export type campaign_budget_stddev_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_stddev_samp_fieldsKeySpecifier = ('amount' | 'bonus' | 'without_bonus' | campaign_budget_stddev_samp_fieldsKeySpecifier)[];
export type campaign_budget_stddev_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_sum_fieldsKeySpecifier = ('amount' | 'bonus' | 'without_bonus' | campaign_budget_sum_fieldsKeySpecifier)[];
export type campaign_budget_sum_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transactionKeySpecifier = ('amount' | 'campaign' | 'campaign_id' | 'created_at' | 'full_amount' | 'id' | 'type' | campaign_budget_transactionKeySpecifier)[];
export type campaign_budget_transactionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_budget_transaction_aggregateKeySpecifier)[];
export type campaign_budget_transaction_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | campaign_budget_transaction_aggregate_fieldsKeySpecifier)[];
export type campaign_budget_transaction_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_avg_fieldsKeySpecifier = ('amount' | 'full_amount' | campaign_budget_transaction_avg_fieldsKeySpecifier)[];
export type campaign_budget_transaction_avg_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_max_fieldsKeySpecifier = ('amount' | 'campaign_id' | 'created_at' | 'full_amount' | 'id' | campaign_budget_transaction_max_fieldsKeySpecifier)[];
export type campaign_budget_transaction_max_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_min_fieldsKeySpecifier = ('amount' | 'campaign_id' | 'created_at' | 'full_amount' | 'id' | campaign_budget_transaction_min_fieldsKeySpecifier)[];
export type campaign_budget_transaction_min_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_budget_transaction_mutation_responseKeySpecifier)[];
export type campaign_budget_transaction_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_stddev_fieldsKeySpecifier = ('amount' | 'full_amount' | campaign_budget_transaction_stddev_fieldsKeySpecifier)[];
export type campaign_budget_transaction_stddev_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_stddev_pop_fieldsKeySpecifier = ('amount' | 'full_amount' | campaign_budget_transaction_stddev_pop_fieldsKeySpecifier)[];
export type campaign_budget_transaction_stddev_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_stddev_samp_fieldsKeySpecifier = ('amount' | 'full_amount' | campaign_budget_transaction_stddev_samp_fieldsKeySpecifier)[];
export type campaign_budget_transaction_stddev_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_sum_fieldsKeySpecifier = ('amount' | 'full_amount' | campaign_budget_transaction_sum_fieldsKeySpecifier)[];
export type campaign_budget_transaction_sum_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_var_pop_fieldsKeySpecifier = ('amount' | 'full_amount' | campaign_budget_transaction_var_pop_fieldsKeySpecifier)[];
export type campaign_budget_transaction_var_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_var_samp_fieldsKeySpecifier = ('amount' | 'full_amount' | campaign_budget_transaction_var_samp_fieldsKeySpecifier)[];
export type campaign_budget_transaction_var_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_transaction_variance_fieldsKeySpecifier = ('amount' | 'full_amount' | campaign_budget_transaction_variance_fieldsKeySpecifier)[];
export type campaign_budget_transaction_variance_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	full_amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_var_pop_fieldsKeySpecifier = ('amount' | 'bonus' | 'without_bonus' | campaign_budget_var_pop_fieldsKeySpecifier)[];
export type campaign_budget_var_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_var_samp_fieldsKeySpecifier = ('amount' | 'bonus' | 'without_bonus' | campaign_budget_var_samp_fieldsKeySpecifier)[];
export type campaign_budget_var_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_budget_variance_fieldsKeySpecifier = ('amount' | 'bonus' | 'without_bonus' | campaign_budget_variance_fieldsKeySpecifier)[];
export type campaign_budget_variance_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	without_bonus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_email_template_overwriteKeySpecifier = ('campaign' | 'campaign_id' | 'rejection' | 'welcome' | campaign_email_template_overwriteKeySpecifier)[];
export type campaign_email_template_overwriteFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	rejection?: FieldPolicy<any> | FieldReadFunction<any>,
	welcome?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_email_template_overwrite_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_email_template_overwrite_aggregateKeySpecifier)[];
export type campaign_email_template_overwrite_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_email_template_overwrite_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_email_template_overwrite_aggregate_fieldsKeySpecifier)[];
export type campaign_email_template_overwrite_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_email_template_overwrite_max_fieldsKeySpecifier = ('campaign_id' | 'rejection' | 'welcome' | campaign_email_template_overwrite_max_fieldsKeySpecifier)[];
export type campaign_email_template_overwrite_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	rejection?: FieldPolicy<any> | FieldReadFunction<any>,
	welcome?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_email_template_overwrite_min_fieldsKeySpecifier = ('campaign_id' | 'rejection' | 'welcome' | campaign_email_template_overwrite_min_fieldsKeySpecifier)[];
export type campaign_email_template_overwrite_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	rejection?: FieldPolicy<any> | FieldReadFunction<any>,
	welcome?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_email_template_overwrite_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_email_template_overwrite_mutation_responseKeySpecifier)[];
export type campaign_email_template_overwrite_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_logKeySpecifier = ('campaign_id' | 'contact' | 'contact_id' | 'created_at' | 'event_type' | 'id' | 'metadata' | 'user_id' | campaign_event_logKeySpecifier)[];
export type campaign_event_logFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	event_type?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	user_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_event_log_aggregateKeySpecifier)[];
export type campaign_event_log_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | campaign_event_log_aggregate_fieldsKeySpecifier)[];
export type campaign_event_log_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_avg_fieldsKeySpecifier = ('id' | campaign_event_log_avg_fieldsKeySpecifier)[];
export type campaign_event_log_avg_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_max_fieldsKeySpecifier = ('campaign_id' | 'contact_id' | 'created_at' | 'event_type' | 'id' | 'user_id' | campaign_event_log_max_fieldsKeySpecifier)[];
export type campaign_event_log_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	event_type?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	user_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_min_fieldsKeySpecifier = ('campaign_id' | 'contact_id' | 'created_at' | 'event_type' | 'id' | 'user_id' | campaign_event_log_min_fieldsKeySpecifier)[];
export type campaign_event_log_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	event_type?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	user_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_event_log_mutation_responseKeySpecifier)[];
export type campaign_event_log_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_stddev_fieldsKeySpecifier = ('id' | campaign_event_log_stddev_fieldsKeySpecifier)[];
export type campaign_event_log_stddev_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_stddev_pop_fieldsKeySpecifier = ('id' | campaign_event_log_stddev_pop_fieldsKeySpecifier)[];
export type campaign_event_log_stddev_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_stddev_samp_fieldsKeySpecifier = ('id' | campaign_event_log_stddev_samp_fieldsKeySpecifier)[];
export type campaign_event_log_stddev_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_sum_fieldsKeySpecifier = ('id' | campaign_event_log_sum_fieldsKeySpecifier)[];
export type campaign_event_log_sum_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_var_pop_fieldsKeySpecifier = ('id' | campaign_event_log_var_pop_fieldsKeySpecifier)[];
export type campaign_event_log_var_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_var_samp_fieldsKeySpecifier = ('id' | campaign_event_log_var_samp_fieldsKeySpecifier)[];
export type campaign_event_log_var_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_event_log_variance_fieldsKeySpecifier = ('id' | campaign_event_log_variance_fieldsKeySpecifier)[];
export type campaign_event_log_variance_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_iso_2_country_codesKeySpecifier = ('value' | campaign_iso_2_country_codesKeySpecifier)[];
export type campaign_iso_2_country_codesFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_iso_2_country_codes_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_iso_2_country_codes_aggregateKeySpecifier)[];
export type campaign_iso_2_country_codes_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_iso_2_country_codes_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_iso_2_country_codes_aggregate_fieldsKeySpecifier)[];
export type campaign_iso_2_country_codes_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_iso_2_country_codes_max_fieldsKeySpecifier = ('value' | campaign_iso_2_country_codes_max_fieldsKeySpecifier)[];
export type campaign_iso_2_country_codes_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_iso_2_country_codes_min_fieldsKeySpecifier = ('value' | campaign_iso_2_country_codes_min_fieldsKeySpecifier)[];
export type campaign_iso_2_country_codes_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_iso_2_country_codes_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_iso_2_country_codes_mutation_responseKeySpecifier)[];
export type campaign_iso_2_country_codes_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_job_descriptionKeySpecifier = ('campaign' | 'campaign_id' | 'job_title' | 'pay' | 'working_hours' | campaign_job_descriptionKeySpecifier)[];
export type campaign_job_descriptionFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	job_title?: FieldPolicy<any> | FieldReadFunction<any>,
	pay?: FieldPolicy<any> | FieldReadFunction<any>,
	working_hours?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_job_description_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_job_description_aggregateKeySpecifier)[];
export type campaign_job_description_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_job_description_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_job_description_aggregate_fieldsKeySpecifier)[];
export type campaign_job_description_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_job_description_max_fieldsKeySpecifier = ('campaign_id' | 'job_title' | 'pay' | 'working_hours' | campaign_job_description_max_fieldsKeySpecifier)[];
export type campaign_job_description_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	job_title?: FieldPolicy<any> | FieldReadFunction<any>,
	pay?: FieldPolicy<any> | FieldReadFunction<any>,
	working_hours?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_job_description_min_fieldsKeySpecifier = ('campaign_id' | 'job_title' | 'pay' | 'working_hours' | campaign_job_description_min_fieldsKeySpecifier)[];
export type campaign_job_description_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	job_title?: FieldPolicy<any> | FieldReadFunction<any>,
	pay?: FieldPolicy<any> | FieldReadFunction<any>,
	working_hours?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_job_description_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_job_description_mutation_responseKeySpecifier)[];
export type campaign_job_description_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_max_fieldsKeySpecifier = ('ads_email_list' | 'applicants_email_list' | 'category' | 'cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'end' | 'id' | 'job_posting_text' | 'location' | 'location_slug' | 'margin_in_percent' | 'media_budget' | 'meistertask_url' | 'monday_url' | 'name' | 'organization_id' | 'perspective_campaign_id' | 'profit' | 'remaining_customer_budget' | 'responsible_person' | 'short_id' | 'start' | 'status' | 'support_email' | 'updated_at' | campaign_max_fieldsKeySpecifier)[];
export type campaign_max_fieldsFieldPolicy = {
	ads_email_list?: FieldPolicy<any> | FieldReadFunction<any>,
	applicants_email_list?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	job_posting_text?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	location_slug?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_url?: FieldPolicy<any> | FieldReadFunction<any>,
	monday_url?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	responsible_person?: FieldPolicy<any> | FieldReadFunction<any>,
	short_id?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	support_email?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_min_fieldsKeySpecifier = ('ads_email_list' | 'applicants_email_list' | 'category' | 'cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'end' | 'id' | 'job_posting_text' | 'location' | 'location_slug' | 'margin_in_percent' | 'media_budget' | 'meistertask_url' | 'monday_url' | 'name' | 'organization_id' | 'perspective_campaign_id' | 'profit' | 'remaining_customer_budget' | 'responsible_person' | 'short_id' | 'start' | 'status' | 'support_email' | 'updated_at' | campaign_min_fieldsKeySpecifier)[];
export type campaign_min_fieldsFieldPolicy = {
	ads_email_list?: FieldPolicy<any> | FieldReadFunction<any>,
	applicants_email_list?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	job_posting_text?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	location_slug?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_url?: FieldPolicy<any> | FieldReadFunction<any>,
	monday_url?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	responsible_person?: FieldPolicy<any> | FieldReadFunction<any>,
	short_id?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	support_email?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_mutation_responseKeySpecifier)[];
export type campaign_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_orderKeySpecifier = ('additional_properties' | 'budget' | 'completed' | 'created_campaign' | 'customer' | 'customer_org_id' | 'description' | 'id' | 'imported_from' | 'link' | 'platform_job_id' | 'posted_at' | 'received_at' | 'responsible_user' | 'source' | 'target_locations' | 'title' | campaign_orderKeySpecifier)[];
export type campaign_orderFieldPolicy = {
	additional_properties?: FieldPolicy<any> | FieldReadFunction<any>,
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	completed?: FieldPolicy<any> | FieldReadFunction<any>,
	created_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imported_from?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	platform_job_id?: FieldPolicy<any> | FieldReadFunction<any>,
	posted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	received_at?: FieldPolicy<any> | FieldReadFunction<any>,
	responsible_user?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	target_locations?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_order_aggregateKeySpecifier)[];
export type campaign_order_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | campaign_order_aggregate_fieldsKeySpecifier)[];
export type campaign_order_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_avg_fieldsKeySpecifier = ('budget' | campaign_order_avg_fieldsKeySpecifier)[];
export type campaign_order_avg_fieldsFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_max_fieldsKeySpecifier = ('budget' | 'created_campaign' | 'customer_org_id' | 'description' | 'id' | 'imported_from' | 'link' | 'platform_job_id' | 'posted_at' | 'received_at' | 'responsible_user' | 'title' | campaign_order_max_fieldsKeySpecifier)[];
export type campaign_order_max_fieldsFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	created_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imported_from?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	platform_job_id?: FieldPolicy<any> | FieldReadFunction<any>,
	posted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	received_at?: FieldPolicy<any> | FieldReadFunction<any>,
	responsible_user?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_min_fieldsKeySpecifier = ('budget' | 'created_campaign' | 'customer_org_id' | 'description' | 'id' | 'imported_from' | 'link' | 'platform_job_id' | 'posted_at' | 'received_at' | 'responsible_user' | 'title' | campaign_order_min_fieldsKeySpecifier)[];
export type campaign_order_min_fieldsFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	created_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imported_from?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	platform_job_id?: FieldPolicy<any> | FieldReadFunction<any>,
	posted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	received_at?: FieldPolicy<any> | FieldReadFunction<any>,
	responsible_user?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_order_mutation_responseKeySpecifier)[];
export type campaign_order_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_sourceKeySpecifier = ('campaign_budget' | 'id' | 'organization_id' | 'source_type' | 'url' | campaign_order_sourceKeySpecifier)[];
export type campaign_order_sourceFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	source_type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_order_source_aggregateKeySpecifier)[];
export type campaign_order_source_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | campaign_order_source_aggregate_fieldsKeySpecifier)[];
export type campaign_order_source_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_avg_fieldsKeySpecifier = ('campaign_budget' | campaign_order_source_avg_fieldsKeySpecifier)[];
export type campaign_order_source_avg_fieldsFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_max_fieldsKeySpecifier = ('campaign_budget' | 'id' | 'organization_id' | 'url' | campaign_order_source_max_fieldsKeySpecifier)[];
export type campaign_order_source_max_fieldsFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_min_fieldsKeySpecifier = ('campaign_budget' | 'id' | 'organization_id' | 'url' | campaign_order_source_min_fieldsKeySpecifier)[];
export type campaign_order_source_min_fieldsFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_order_source_mutation_responseKeySpecifier)[];
export type campaign_order_source_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_stddev_fieldsKeySpecifier = ('campaign_budget' | campaign_order_source_stddev_fieldsKeySpecifier)[];
export type campaign_order_source_stddev_fieldsFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_stddev_pop_fieldsKeySpecifier = ('campaign_budget' | campaign_order_source_stddev_pop_fieldsKeySpecifier)[];
export type campaign_order_source_stddev_pop_fieldsFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_stddev_samp_fieldsKeySpecifier = ('campaign_budget' | campaign_order_source_stddev_samp_fieldsKeySpecifier)[];
export type campaign_order_source_stddev_samp_fieldsFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_sum_fieldsKeySpecifier = ('campaign_budget' | campaign_order_source_sum_fieldsKeySpecifier)[];
export type campaign_order_source_sum_fieldsFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_typeKeySpecifier = ('value' | campaign_order_source_typeKeySpecifier)[];
export type campaign_order_source_typeFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_type_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_order_source_type_aggregateKeySpecifier)[];
export type campaign_order_source_type_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_type_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_order_source_type_aggregate_fieldsKeySpecifier)[];
export type campaign_order_source_type_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_type_max_fieldsKeySpecifier = ('value' | campaign_order_source_type_max_fieldsKeySpecifier)[];
export type campaign_order_source_type_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_type_min_fieldsKeySpecifier = ('value' | campaign_order_source_type_min_fieldsKeySpecifier)[];
export type campaign_order_source_type_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_type_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_order_source_type_mutation_responseKeySpecifier)[];
export type campaign_order_source_type_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_var_pop_fieldsKeySpecifier = ('campaign_budget' | campaign_order_source_var_pop_fieldsKeySpecifier)[];
export type campaign_order_source_var_pop_fieldsFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_var_samp_fieldsKeySpecifier = ('campaign_budget' | campaign_order_source_var_samp_fieldsKeySpecifier)[];
export type campaign_order_source_var_samp_fieldsFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_source_variance_fieldsKeySpecifier = ('campaign_budget' | campaign_order_source_variance_fieldsKeySpecifier)[];
export type campaign_order_source_variance_fieldsFieldPolicy = {
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_stddev_fieldsKeySpecifier = ('budget' | campaign_order_stddev_fieldsKeySpecifier)[];
export type campaign_order_stddev_fieldsFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_stddev_pop_fieldsKeySpecifier = ('budget' | campaign_order_stddev_pop_fieldsKeySpecifier)[];
export type campaign_order_stddev_pop_fieldsFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_stddev_samp_fieldsKeySpecifier = ('budget' | campaign_order_stddev_samp_fieldsKeySpecifier)[];
export type campaign_order_stddev_samp_fieldsFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_sum_fieldsKeySpecifier = ('budget' | campaign_order_sum_fieldsKeySpecifier)[];
export type campaign_order_sum_fieldsFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_var_pop_fieldsKeySpecifier = ('budget' | campaign_order_var_pop_fieldsKeySpecifier)[];
export type campaign_order_var_pop_fieldsFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_var_samp_fieldsKeySpecifier = ('budget' | campaign_order_var_samp_fieldsKeySpecifier)[];
export type campaign_order_var_samp_fieldsFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_order_variance_fieldsKeySpecifier = ('budget' | campaign_order_variance_fieldsKeySpecifier)[];
export type campaign_order_variance_fieldsFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destinationKeySpecifier = ('campaign' | 'campaign_id' | 'location_id' | 'location_name' | 'meistertask_board_id' | 'meistertask_qualified_column' | 'meistertask_unqualified_column' | 'trello_board_id' | 'trello_qualified_column' | 'trello_unqualified_column' | 'type' | campaign_routing_destinationKeySpecifier)[];
export type campaign_routing_destinationFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	location_name?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_qualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_unqualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	trello_board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	trello_qualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	trello_unqualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_routing_destination_aggregateKeySpecifier)[];
export type campaign_routing_destination_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | campaign_routing_destination_aggregate_fieldsKeySpecifier)[];
export type campaign_routing_destination_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_avg_fieldsKeySpecifier = ('location_id' | campaign_routing_destination_avg_fieldsKeySpecifier)[];
export type campaign_routing_destination_avg_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_max_fieldsKeySpecifier = ('campaign_id' | 'location_id' | 'location_name' | 'meistertask_board_id' | 'meistertask_qualified_column' | 'meistertask_unqualified_column' | 'trello_board_id' | 'trello_qualified_column' | 'trello_unqualified_column' | 'type' | campaign_routing_destination_max_fieldsKeySpecifier)[];
export type campaign_routing_destination_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	location_name?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_qualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_unqualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	trello_board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	trello_qualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	trello_unqualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_min_fieldsKeySpecifier = ('campaign_id' | 'location_id' | 'location_name' | 'meistertask_board_id' | 'meistertask_qualified_column' | 'meistertask_unqualified_column' | 'trello_board_id' | 'trello_qualified_column' | 'trello_unqualified_column' | 'type' | campaign_routing_destination_min_fieldsKeySpecifier)[];
export type campaign_routing_destination_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	location_name?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_qualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	meistertask_unqualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	trello_board_id?: FieldPolicy<any> | FieldReadFunction<any>,
	trello_qualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	trello_unqualified_column?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_routing_destination_mutation_responseKeySpecifier)[];
export type campaign_routing_destination_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_stddev_fieldsKeySpecifier = ('location_id' | campaign_routing_destination_stddev_fieldsKeySpecifier)[];
export type campaign_routing_destination_stddev_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_stddev_pop_fieldsKeySpecifier = ('location_id' | campaign_routing_destination_stddev_pop_fieldsKeySpecifier)[];
export type campaign_routing_destination_stddev_pop_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_stddev_samp_fieldsKeySpecifier = ('location_id' | campaign_routing_destination_stddev_samp_fieldsKeySpecifier)[];
export type campaign_routing_destination_stddev_samp_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_sum_fieldsKeySpecifier = ('location_id' | campaign_routing_destination_sum_fieldsKeySpecifier)[];
export type campaign_routing_destination_sum_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_var_pop_fieldsKeySpecifier = ('location_id' | campaign_routing_destination_var_pop_fieldsKeySpecifier)[];
export type campaign_routing_destination_var_pop_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_var_samp_fieldsKeySpecifier = ('location_id' | campaign_routing_destination_var_samp_fieldsKeySpecifier)[];
export type campaign_routing_destination_var_samp_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_destination_variance_fieldsKeySpecifier = ('location_id' | campaign_routing_destination_variance_fieldsKeySpecifier)[];
export type campaign_routing_destination_variance_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_infoKeySpecifier = ('campaign' | 'campaign_id' | 'forwarding_webhook' | 'is_active' | 'location_id' | 'make_id' | 'office_id' | 'type' | campaign_routing_infoKeySpecifier)[];
export type campaign_routing_infoFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	forwarding_webhook?: FieldPolicy<any> | FieldReadFunction<any>,
	is_active?: FieldPolicy<any> | FieldReadFunction<any>,
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	office_id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_routing_info_aggregateKeySpecifier)[];
export type campaign_routing_info_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | campaign_routing_info_aggregate_fieldsKeySpecifier)[];
export type campaign_routing_info_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_avg_fieldsKeySpecifier = ('location_id' | 'make_id' | campaign_routing_info_avg_fieldsKeySpecifier)[];
export type campaign_routing_info_avg_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_max_fieldsKeySpecifier = ('campaign_id' | 'forwarding_webhook' | 'location_id' | 'make_id' | 'office_id' | 'type' | campaign_routing_info_max_fieldsKeySpecifier)[];
export type campaign_routing_info_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	forwarding_webhook?: FieldPolicy<any> | FieldReadFunction<any>,
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	office_id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_min_fieldsKeySpecifier = ('campaign_id' | 'forwarding_webhook' | 'location_id' | 'make_id' | 'office_id' | 'type' | campaign_routing_info_min_fieldsKeySpecifier)[];
export type campaign_routing_info_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	forwarding_webhook?: FieldPolicy<any> | FieldReadFunction<any>,
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	office_id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_routing_info_mutation_responseKeySpecifier)[];
export type campaign_routing_info_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_stddev_fieldsKeySpecifier = ('location_id' | 'make_id' | campaign_routing_info_stddev_fieldsKeySpecifier)[];
export type campaign_routing_info_stddev_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_stddev_pop_fieldsKeySpecifier = ('location_id' | 'make_id' | campaign_routing_info_stddev_pop_fieldsKeySpecifier)[];
export type campaign_routing_info_stddev_pop_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_stddev_samp_fieldsKeySpecifier = ('location_id' | 'make_id' | campaign_routing_info_stddev_samp_fieldsKeySpecifier)[];
export type campaign_routing_info_stddev_samp_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_sum_fieldsKeySpecifier = ('location_id' | 'make_id' | campaign_routing_info_sum_fieldsKeySpecifier)[];
export type campaign_routing_info_sum_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_var_pop_fieldsKeySpecifier = ('location_id' | 'make_id' | campaign_routing_info_var_pop_fieldsKeySpecifier)[];
export type campaign_routing_info_var_pop_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_var_samp_fieldsKeySpecifier = ('location_id' | 'make_id' | campaign_routing_info_var_samp_fieldsKeySpecifier)[];
export type campaign_routing_info_var_samp_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_info_variance_fieldsKeySpecifier = ('location_id' | 'make_id' | campaign_routing_info_variance_fieldsKeySpecifier)[];
export type campaign_routing_info_variance_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcodeKeySpecifier = ('destinations' | 'destinations_aggregate' | 'kdb_office_id' | 'location_id' | 'organization_id' | 'vmb_office_id' | 'zipcode' | campaign_routing_zipcodeKeySpecifier)[];
export type campaign_routing_zipcodeFieldPolicy = {
	destinations?: FieldPolicy<any> | FieldReadFunction<any>,
	destinations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	kdb_office_id?: FieldPolicy<any> | FieldReadFunction<any>,
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	vmb_office_id?: FieldPolicy<any> | FieldReadFunction<any>,
	zipcode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_routing_zipcode_aggregateKeySpecifier)[];
export type campaign_routing_zipcode_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | campaign_routing_zipcode_aggregate_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_avg_fieldsKeySpecifier = ('location_id' | campaign_routing_zipcode_avg_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_avg_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_max_fieldsKeySpecifier = ('kdb_office_id' | 'location_id' | 'organization_id' | 'vmb_office_id' | 'zipcode' | campaign_routing_zipcode_max_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_max_fieldsFieldPolicy = {
	kdb_office_id?: FieldPolicy<any> | FieldReadFunction<any>,
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	vmb_office_id?: FieldPolicy<any> | FieldReadFunction<any>,
	zipcode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_min_fieldsKeySpecifier = ('kdb_office_id' | 'location_id' | 'organization_id' | 'vmb_office_id' | 'zipcode' | campaign_routing_zipcode_min_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_min_fieldsFieldPolicy = {
	kdb_office_id?: FieldPolicy<any> | FieldReadFunction<any>,
	location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	vmb_office_id?: FieldPolicy<any> | FieldReadFunction<any>,
	zipcode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_routing_zipcode_mutation_responseKeySpecifier)[];
export type campaign_routing_zipcode_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_stddev_fieldsKeySpecifier = ('location_id' | campaign_routing_zipcode_stddev_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_stddev_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_stddev_pop_fieldsKeySpecifier = ('location_id' | campaign_routing_zipcode_stddev_pop_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_stddev_pop_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_stddev_samp_fieldsKeySpecifier = ('location_id' | campaign_routing_zipcode_stddev_samp_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_stddev_samp_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_sum_fieldsKeySpecifier = ('location_id' | campaign_routing_zipcode_sum_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_sum_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_var_pop_fieldsKeySpecifier = ('location_id' | campaign_routing_zipcode_var_pop_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_var_pop_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_var_samp_fieldsKeySpecifier = ('location_id' | campaign_routing_zipcode_var_samp_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_var_samp_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_routing_zipcode_variance_fieldsKeySpecifier = ('location_id' | campaign_routing_zipcode_variance_fieldsKeySpecifier)[];
export type campaign_routing_zipcode_variance_fieldsFieldPolicy = {
	location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_settings_overrideKeySpecifier = ('campaign' | 'campaign_id' | 'color' | 'logo_url' | 'name_prefix' | 'short_name' | campaign_settings_overrideKeySpecifier)[];
export type campaign_settings_overrideFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_url?: FieldPolicy<any> | FieldReadFunction<any>,
	name_prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	short_name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_settings_override_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_settings_override_aggregateKeySpecifier)[];
export type campaign_settings_override_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_settings_override_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_settings_override_aggregate_fieldsKeySpecifier)[];
export type campaign_settings_override_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_settings_override_max_fieldsKeySpecifier = ('campaign_id' | 'color' | 'logo_url' | 'short_name' | campaign_settings_override_max_fieldsKeySpecifier)[];
export type campaign_settings_override_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_url?: FieldPolicy<any> | FieldReadFunction<any>,
	short_name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_settings_override_min_fieldsKeySpecifier = ('campaign_id' | 'color' | 'logo_url' | 'short_name' | campaign_settings_override_min_fieldsKeySpecifier)[];
export type campaign_settings_override_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_url?: FieldPolicy<any> | FieldReadFunction<any>,
	short_name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_settings_override_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_settings_override_mutation_responseKeySpecifier)[];
export type campaign_settings_override_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_statusKeySpecifier = ('value' | campaign_statusKeySpecifier)[];
export type campaign_statusFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_status_aggregateKeySpecifier)[];
export type campaign_status_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_status_aggregate_fieldsKeySpecifier)[];
export type campaign_status_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_eventKeySpecifier = ('value' | campaign_status_eventKeySpecifier)[];
export type campaign_status_eventFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_event_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_status_event_aggregateKeySpecifier)[];
export type campaign_status_event_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_event_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_status_event_aggregate_fieldsKeySpecifier)[];
export type campaign_status_event_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_event_max_fieldsKeySpecifier = ('value' | campaign_status_event_max_fieldsKeySpecifier)[];
export type campaign_status_event_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_event_min_fieldsKeySpecifier = ('value' | campaign_status_event_min_fieldsKeySpecifier)[];
export type campaign_status_event_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_event_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_status_event_mutation_responseKeySpecifier)[];
export type campaign_status_event_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_logKeySpecifier = ('campaign' | 'campaign_id' | 'created_at' | 'event' | campaign_status_logKeySpecifier)[];
export type campaign_status_logFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_log_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_status_log_aggregateKeySpecifier)[];
export type campaign_status_log_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_log_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_status_log_aggregate_fieldsKeySpecifier)[];
export type campaign_status_log_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_log_max_fieldsKeySpecifier = ('campaign_id' | 'created_at' | campaign_status_log_max_fieldsKeySpecifier)[];
export type campaign_status_log_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_log_min_fieldsKeySpecifier = ('campaign_id' | 'created_at' | campaign_status_log_min_fieldsKeySpecifier)[];
export type campaign_status_log_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_log_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_status_log_mutation_responseKeySpecifier)[];
export type campaign_status_log_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_max_fieldsKeySpecifier = ('value' | campaign_status_max_fieldsKeySpecifier)[];
export type campaign_status_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_min_fieldsKeySpecifier = ('value' | campaign_status_min_fieldsKeySpecifier)[];
export type campaign_status_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_status_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_status_mutation_responseKeySpecifier)[];
export type campaign_status_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_stddev_fieldsKeySpecifier = ('cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'margin_in_percent' | 'media_budget' | 'profit' | 'remaining_customer_budget' | campaign_stddev_fieldsKeySpecifier)[];
export type campaign_stddev_fieldsFieldPolicy = {
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_stddev_pop_fieldsKeySpecifier = ('cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'margin_in_percent' | 'media_budget' | 'profit' | 'remaining_customer_budget' | campaign_stddev_pop_fieldsKeySpecifier)[];
export type campaign_stddev_pop_fieldsFieldPolicy = {
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_stddev_samp_fieldsKeySpecifier = ('cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'margin_in_percent' | 'media_budget' | 'profit' | 'remaining_customer_budget' | campaign_stddev_samp_fieldsKeySpecifier)[];
export type campaign_stddev_samp_fieldsFieldPolicy = {
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_sum_fieldsKeySpecifier = ('cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'margin_in_percent' | 'media_budget' | 'profit' | 'remaining_customer_budget' | campaign_sum_fieldsKeySpecifier)[];
export type campaign_sum_fieldsFieldPolicy = {
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_transaction_typeKeySpecifier = ('value' | campaign_transaction_typeKeySpecifier)[];
export type campaign_transaction_typeFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_transaction_type_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_transaction_type_aggregateKeySpecifier)[];
export type campaign_transaction_type_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_transaction_type_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_transaction_type_aggregate_fieldsKeySpecifier)[];
export type campaign_transaction_type_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_transaction_type_max_fieldsKeySpecifier = ('value' | campaign_transaction_type_max_fieldsKeySpecifier)[];
export type campaign_transaction_type_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_transaction_type_min_fieldsKeySpecifier = ('value' | campaign_transaction_type_min_fieldsKeySpecifier)[];
export type campaign_transaction_type_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_transaction_type_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_transaction_type_mutation_responseKeySpecifier)[];
export type campaign_transaction_type_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_var_pop_fieldsKeySpecifier = ('cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'margin_in_percent' | 'media_budget' | 'profit' | 'remaining_customer_budget' | campaign_var_pop_fieldsKeySpecifier)[];
export type campaign_var_pop_fieldsFieldPolicy = {
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_var_samp_fieldsKeySpecifier = ('cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'margin_in_percent' | 'media_budget' | 'profit' | 'remaining_customer_budget' | campaign_var_samp_fieldsKeySpecifier)[];
export type campaign_var_samp_fieldsFieldPolicy = {
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_variance_fieldsKeySpecifier = ('cost_per_lead' | 'cost_per_lead_customer' | 'customer_budget_bonus' | 'customer_budget_initial' | 'customer_budget_total' | 'daily_budget' | 'daily_media_budget' | 'margin_in_percent' | 'media_budget' | 'profit' | 'remaining_customer_budget' | campaign_variance_fieldsKeySpecifier)[];
export type campaign_variance_fieldsFieldPolicy = {
	cost_per_lead?: FieldPolicy<any> | FieldReadFunction<any>,
	cost_per_lead_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_initial?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_budget_total?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	daily_media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	margin_in_percent?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	profit?: FieldPolicy<any> | FieldReadFunction<any>,
	remaining_customer_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_work_locationKeySpecifier = ('value' | campaign_work_locationKeySpecifier)[];
export type campaign_work_locationFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_work_location_aggregateKeySpecifier = ('aggregate' | 'nodes' | campaign_work_location_aggregateKeySpecifier)[];
export type campaign_work_location_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_work_location_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | campaign_work_location_aggregate_fieldsKeySpecifier)[];
export type campaign_work_location_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_work_location_max_fieldsKeySpecifier = ('value' | campaign_work_location_max_fieldsKeySpecifier)[];
export type campaign_work_location_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_work_location_min_fieldsKeySpecifier = ('value' | campaign_work_location_min_fieldsKeySpecifier)[];
export type campaign_work_location_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type campaign_work_location_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | campaign_work_location_mutation_responseKeySpecifier)[];
export type campaign_work_location_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customersKeySpecifier = ('campaign' | 'campaign_id' | 'contact' | 'contact_id' | 'contact_payload' | 'created_at' | 'has_completed_conversation' | 'id' | 'messages' | 'messages_aggregate' | 'remainder_count' | 'retry_count' | 'sent_initial_message_at' | 'updated_at' | chat_bot_customersKeySpecifier)[];
export type chat_bot_customersFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_payload?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	has_completed_conversation?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	messages_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>,
	sent_initial_message_at?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_aggregateKeySpecifier = ('aggregate' | 'nodes' | chat_bot_customers_aggregateKeySpecifier)[];
export type chat_bot_customers_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | chat_bot_customers_aggregate_fieldsKeySpecifier)[];
export type chat_bot_customers_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_avg_fieldsKeySpecifier = ('id' | 'remainder_count' | 'retry_count' | chat_bot_customers_avg_fieldsKeySpecifier)[];
export type chat_bot_customers_avg_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_max_fieldsKeySpecifier = ('campaign_id' | 'contact_id' | 'created_at' | 'id' | 'remainder_count' | 'retry_count' | 'sent_initial_message_at' | 'updated_at' | chat_bot_customers_max_fieldsKeySpecifier)[];
export type chat_bot_customers_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>,
	sent_initial_message_at?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_min_fieldsKeySpecifier = ('campaign_id' | 'contact_id' | 'created_at' | 'id' | 'remainder_count' | 'retry_count' | 'sent_initial_message_at' | 'updated_at' | chat_bot_customers_min_fieldsKeySpecifier)[];
export type chat_bot_customers_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>,
	sent_initial_message_at?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | chat_bot_customers_mutation_responseKeySpecifier)[];
export type chat_bot_customers_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_stddev_fieldsKeySpecifier = ('id' | 'remainder_count' | 'retry_count' | chat_bot_customers_stddev_fieldsKeySpecifier)[];
export type chat_bot_customers_stddev_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_stddev_pop_fieldsKeySpecifier = ('id' | 'remainder_count' | 'retry_count' | chat_bot_customers_stddev_pop_fieldsKeySpecifier)[];
export type chat_bot_customers_stddev_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_stddev_samp_fieldsKeySpecifier = ('id' | 'remainder_count' | 'retry_count' | chat_bot_customers_stddev_samp_fieldsKeySpecifier)[];
export type chat_bot_customers_stddev_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_sum_fieldsKeySpecifier = ('id' | 'remainder_count' | 'retry_count' | chat_bot_customers_sum_fieldsKeySpecifier)[];
export type chat_bot_customers_sum_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_var_pop_fieldsKeySpecifier = ('id' | 'remainder_count' | 'retry_count' | chat_bot_customers_var_pop_fieldsKeySpecifier)[];
export type chat_bot_customers_var_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_var_samp_fieldsKeySpecifier = ('id' | 'remainder_count' | 'retry_count' | chat_bot_customers_var_samp_fieldsKeySpecifier)[];
export type chat_bot_customers_var_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_customers_variance_fieldsKeySpecifier = ('id' | 'remainder_count' | 'retry_count' | chat_bot_customers_variance_fieldsKeySpecifier)[];
export type chat_bot_customers_variance_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remainder_count?: FieldPolicy<any> | FieldReadFunction<any>,
	retry_count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwardingKeySpecifier = ('campaign' | 'campaign_id' | 'is_active' | 'make_id' | 'webhook_url' | chat_bot_forwardingKeySpecifier)[];
export type chat_bot_forwardingFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_active?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook_url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_aggregateKeySpecifier = ('aggregate' | 'nodes' | chat_bot_forwarding_aggregateKeySpecifier)[];
export type chat_bot_forwarding_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | chat_bot_forwarding_aggregate_fieldsKeySpecifier)[];
export type chat_bot_forwarding_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_avg_fieldsKeySpecifier = ('make_id' | chat_bot_forwarding_avg_fieldsKeySpecifier)[];
export type chat_bot_forwarding_avg_fieldsFieldPolicy = {
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_max_fieldsKeySpecifier = ('campaign_id' | 'make_id' | 'webhook_url' | chat_bot_forwarding_max_fieldsKeySpecifier)[];
export type chat_bot_forwarding_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook_url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_min_fieldsKeySpecifier = ('campaign_id' | 'make_id' | 'webhook_url' | chat_bot_forwarding_min_fieldsKeySpecifier)[];
export type chat_bot_forwarding_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	make_id?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook_url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | chat_bot_forwarding_mutation_responseKeySpecifier)[];
export type chat_bot_forwarding_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_stddev_fieldsKeySpecifier = ('make_id' | chat_bot_forwarding_stddev_fieldsKeySpecifier)[];
export type chat_bot_forwarding_stddev_fieldsFieldPolicy = {
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_stddev_pop_fieldsKeySpecifier = ('make_id' | chat_bot_forwarding_stddev_pop_fieldsKeySpecifier)[];
export type chat_bot_forwarding_stddev_pop_fieldsFieldPolicy = {
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_stddev_samp_fieldsKeySpecifier = ('make_id' | chat_bot_forwarding_stddev_samp_fieldsKeySpecifier)[];
export type chat_bot_forwarding_stddev_samp_fieldsFieldPolicy = {
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_sum_fieldsKeySpecifier = ('make_id' | chat_bot_forwarding_sum_fieldsKeySpecifier)[];
export type chat_bot_forwarding_sum_fieldsFieldPolicy = {
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_var_pop_fieldsKeySpecifier = ('make_id' | chat_bot_forwarding_var_pop_fieldsKeySpecifier)[];
export type chat_bot_forwarding_var_pop_fieldsFieldPolicy = {
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_var_samp_fieldsKeySpecifier = ('make_id' | chat_bot_forwarding_var_samp_fieldsKeySpecifier)[];
export type chat_bot_forwarding_var_samp_fieldsFieldPolicy = {
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_forwarding_variance_fieldsKeySpecifier = ('make_id' | chat_bot_forwarding_variance_fieldsKeySpecifier)[];
export type chat_bot_forwarding_variance_fieldsFieldPolicy = {
	make_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_message_typeKeySpecifier = ('value' | chat_bot_message_typeKeySpecifier)[];
export type chat_bot_message_typeFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_message_type_aggregateKeySpecifier = ('aggregate' | 'nodes' | chat_bot_message_type_aggregateKeySpecifier)[];
export type chat_bot_message_type_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_message_type_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | chat_bot_message_type_aggregate_fieldsKeySpecifier)[];
export type chat_bot_message_type_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_message_type_max_fieldsKeySpecifier = ('value' | chat_bot_message_type_max_fieldsKeySpecifier)[];
export type chat_bot_message_type_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_message_type_min_fieldsKeySpecifier = ('value' | chat_bot_message_type_min_fieldsKeySpecifier)[];
export type chat_bot_message_type_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_message_type_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | chat_bot_message_type_mutation_responseKeySpecifier)[];
export type chat_bot_message_type_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messagesKeySpecifier = ('_raw' | 'applicant' | 'channel_id' | 'contact' | 'contact_id' | 'created_at' | 'customer_id' | 'data' | 'id' | 'sender_type' | 'type' | chat_bot_messagesKeySpecifier)[];
export type chat_bot_messagesFieldPolicy = {
	_raw?: FieldPolicy<any> | FieldReadFunction<any>,
	applicant?: FieldPolicy<any> | FieldReadFunction<any>,
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sender_type?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_aggregateKeySpecifier = ('aggregate' | 'nodes' | chat_bot_messages_aggregateKeySpecifier)[];
export type chat_bot_messages_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | chat_bot_messages_aggregate_fieldsKeySpecifier)[];
export type chat_bot_messages_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_avg_fieldsKeySpecifier = ('channel_id' | 'customer_id' | 'id' | chat_bot_messages_avg_fieldsKeySpecifier)[];
export type chat_bot_messages_avg_fieldsFieldPolicy = {
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_max_fieldsKeySpecifier = ('channel_id' | 'contact_id' | 'created_at' | 'customer_id' | 'id' | 'sender_type' | chat_bot_messages_max_fieldsKeySpecifier)[];
export type chat_bot_messages_max_fieldsFieldPolicy = {
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sender_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_min_fieldsKeySpecifier = ('channel_id' | 'contact_id' | 'created_at' | 'customer_id' | 'id' | 'sender_type' | chat_bot_messages_min_fieldsKeySpecifier)[];
export type chat_bot_messages_min_fieldsFieldPolicy = {
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sender_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | chat_bot_messages_mutation_responseKeySpecifier)[];
export type chat_bot_messages_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_stddev_fieldsKeySpecifier = ('channel_id' | 'customer_id' | 'id' | chat_bot_messages_stddev_fieldsKeySpecifier)[];
export type chat_bot_messages_stddev_fieldsFieldPolicy = {
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_stddev_pop_fieldsKeySpecifier = ('channel_id' | 'customer_id' | 'id' | chat_bot_messages_stddev_pop_fieldsKeySpecifier)[];
export type chat_bot_messages_stddev_pop_fieldsFieldPolicy = {
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_stddev_samp_fieldsKeySpecifier = ('channel_id' | 'customer_id' | 'id' | chat_bot_messages_stddev_samp_fieldsKeySpecifier)[];
export type chat_bot_messages_stddev_samp_fieldsFieldPolicy = {
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_sum_fieldsKeySpecifier = ('channel_id' | 'customer_id' | 'id' | chat_bot_messages_sum_fieldsKeySpecifier)[];
export type chat_bot_messages_sum_fieldsFieldPolicy = {
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_var_pop_fieldsKeySpecifier = ('channel_id' | 'customer_id' | 'id' | chat_bot_messages_var_pop_fieldsKeySpecifier)[];
export type chat_bot_messages_var_pop_fieldsFieldPolicy = {
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_var_samp_fieldsKeySpecifier = ('channel_id' | 'customer_id' | 'id' | chat_bot_messages_var_samp_fieldsKeySpecifier)[];
export type chat_bot_messages_var_samp_fieldsFieldPolicy = {
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type chat_bot_messages_variance_fieldsKeySpecifier = ('channel_id' | 'customer_id' | 'id' | chat_bot_messages_variance_fieldsKeySpecifier)[];
export type chat_bot_messages_variance_fieldsFieldPolicy = {
	channel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	customer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contactKeySpecifier = ('accepted_data_privacy_agreement' | 'answers' | 'answers_aggregate' | 'birthdate' | 'bot_consent' | 'campaign' | 'campaign_id' | 'chat_bot_contact' | 'city' | 'contact_board_entries' | 'contact_board_entries_aggregate' | 'contacts' | 'contacts_aggregate' | 'converted_at' | 'country' | 'created_at' | 'cv' | 'cv_id' | 'deleted_at' | 'email_address' | 'first_name' | 'form_of_address' | 'funnel_file_id' | 'has_completed_chatbot' | 'id' | 'last_name' | 'origin_campaign' | 'origin_campaign_id' | 'perspective_id' | 'phone_number' | 'qa_source' | 'qa_source_enum' | 'qualified' | 'routing_location_id' | 'street' | 'updated_at' | 'utm_source' | 'zip_code' | contactKeySpecifier)[];
export type contactFieldPolicy = {
	accepted_data_privacy_agreement?: FieldPolicy<any> | FieldReadFunction<any>,
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	answers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	birthdate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_consent?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_contact?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_board_entries?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_board_entries_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	converted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	cv?: FieldPolicy<any> | FieldReadFunction<any>,
	cv_id?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	email_address?: FieldPolicy<any> | FieldReadFunction<any>,
	first_name?: FieldPolicy<any> | FieldReadFunction<any>,
	form_of_address?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	has_completed_chatbot?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_name?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_id?: FieldPolicy<any> | FieldReadFunction<any>,
	phone_number?: FieldPolicy<any> | FieldReadFunction<any>,
	qa_source?: FieldPolicy<any> | FieldReadFunction<any>,
	qa_source_enum?: FieldPolicy<any> | FieldReadFunction<any>,
	qualified?: FieldPolicy<any> | FieldReadFunction<any>,
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	utm_source?: FieldPolicy<any> | FieldReadFunction<any>,
	zip_code?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_aggregateKeySpecifier = ('aggregate' | 'nodes' | contact_aggregateKeySpecifier)[];
export type contact_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | contact_aggregate_fieldsKeySpecifier)[];
export type contact_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_avg_fieldsKeySpecifier = ('routing_location_id' | contact_avg_fieldsKeySpecifier)[];
export type contact_avg_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logsKeySpecifier = ('bot_ended_at' | 'bot_started_at' | 'campaign_id' | 'contact_id' | 'created_at' | 'error' | 'id' | 'payload' | 'qualified_at' | 'report_generated_at' | 'rms_forwarded_at' | contact_logsKeySpecifier)[];
export type contact_logsFieldPolicy = {
	bot_ended_at?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_started_at?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	payload?: FieldPolicy<any> | FieldReadFunction<any>,
	qualified_at?: FieldPolicy<any> | FieldReadFunction<any>,
	report_generated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_forwarded_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_aggregateKeySpecifier = ('aggregate' | 'nodes' | contact_logs_aggregateKeySpecifier)[];
export type contact_logs_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | contact_logs_aggregate_fieldsKeySpecifier)[];
export type contact_logs_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_avg_fieldsKeySpecifier = ('id' | contact_logs_avg_fieldsKeySpecifier)[];
export type contact_logs_avg_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_max_fieldsKeySpecifier = ('bot_ended_at' | 'bot_started_at' | 'campaign_id' | 'contact_id' | 'created_at' | 'id' | 'qualified_at' | 'report_generated_at' | 'rms_forwarded_at' | contact_logs_max_fieldsKeySpecifier)[];
export type contact_logs_max_fieldsFieldPolicy = {
	bot_ended_at?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_started_at?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	qualified_at?: FieldPolicy<any> | FieldReadFunction<any>,
	report_generated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_forwarded_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_min_fieldsKeySpecifier = ('bot_ended_at' | 'bot_started_at' | 'campaign_id' | 'contact_id' | 'created_at' | 'id' | 'qualified_at' | 'report_generated_at' | 'rms_forwarded_at' | contact_logs_min_fieldsKeySpecifier)[];
export type contact_logs_min_fieldsFieldPolicy = {
	bot_ended_at?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_started_at?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	qualified_at?: FieldPolicy<any> | FieldReadFunction<any>,
	report_generated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_forwarded_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | contact_logs_mutation_responseKeySpecifier)[];
export type contact_logs_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_stddev_fieldsKeySpecifier = ('id' | contact_logs_stddev_fieldsKeySpecifier)[];
export type contact_logs_stddev_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_stddev_pop_fieldsKeySpecifier = ('id' | contact_logs_stddev_pop_fieldsKeySpecifier)[];
export type contact_logs_stddev_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_stddev_samp_fieldsKeySpecifier = ('id' | contact_logs_stddev_samp_fieldsKeySpecifier)[];
export type contact_logs_stddev_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_sum_fieldsKeySpecifier = ('id' | contact_logs_sum_fieldsKeySpecifier)[];
export type contact_logs_sum_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_var_pop_fieldsKeySpecifier = ('id' | contact_logs_var_pop_fieldsKeySpecifier)[];
export type contact_logs_var_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_var_samp_fieldsKeySpecifier = ('id' | contact_logs_var_samp_fieldsKeySpecifier)[];
export type contact_logs_var_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_logs_variance_fieldsKeySpecifier = ('id' | contact_logs_variance_fieldsKeySpecifier)[];
export type contact_logs_variance_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_max_fieldsKeySpecifier = ('birthdate' | 'campaign_id' | 'city' | 'converted_at' | 'country' | 'created_at' | 'cv_id' | 'deleted_at' | 'email_address' | 'first_name' | 'form_of_address' | 'funnel_file_id' | 'id' | 'last_name' | 'origin_campaign_id' | 'perspective_id' | 'phone_number' | 'routing_location_id' | 'street' | 'updated_at' | 'zip_code' | contact_max_fieldsKeySpecifier)[];
export type contact_max_fieldsFieldPolicy = {
	birthdate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	converted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	cv_id?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	email_address?: FieldPolicy<any> | FieldReadFunction<any>,
	first_name?: FieldPolicy<any> | FieldReadFunction<any>,
	form_of_address?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_name?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_id?: FieldPolicy<any> | FieldReadFunction<any>,
	phone_number?: FieldPolicy<any> | FieldReadFunction<any>,
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	zip_code?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_min_fieldsKeySpecifier = ('birthdate' | 'campaign_id' | 'city' | 'converted_at' | 'country' | 'created_at' | 'cv_id' | 'deleted_at' | 'email_address' | 'first_name' | 'form_of_address' | 'funnel_file_id' | 'id' | 'last_name' | 'origin_campaign_id' | 'perspective_id' | 'phone_number' | 'routing_location_id' | 'street' | 'updated_at' | 'zip_code' | contact_min_fieldsKeySpecifier)[];
export type contact_min_fieldsFieldPolicy = {
	birthdate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	converted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	cv_id?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	email_address?: FieldPolicy<any> | FieldReadFunction<any>,
	first_name?: FieldPolicy<any> | FieldReadFunction<any>,
	form_of_address?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_name?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_id?: FieldPolicy<any> | FieldReadFunction<any>,
	phone_number?: FieldPolicy<any> | FieldReadFunction<any>,
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	zip_code?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | contact_mutation_responseKeySpecifier)[];
export type contact_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_stddev_fieldsKeySpecifier = ('routing_location_id' | contact_stddev_fieldsKeySpecifier)[];
export type contact_stddev_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_stddev_pop_fieldsKeySpecifier = ('routing_location_id' | contact_stddev_pop_fieldsKeySpecifier)[];
export type contact_stddev_pop_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_stddev_samp_fieldsKeySpecifier = ('routing_location_id' | contact_stddev_samp_fieldsKeySpecifier)[];
export type contact_stddev_samp_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_sum_fieldsKeySpecifier = ('routing_location_id' | contact_sum_fieldsKeySpecifier)[];
export type contact_sum_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_var_pop_fieldsKeySpecifier = ('routing_location_id' | contact_var_pop_fieldsKeySpecifier)[];
export type contact_var_pop_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_var_samp_fieldsKeySpecifier = ('routing_location_id' | contact_var_samp_fieldsKeySpecifier)[];
export type contact_var_samp_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type contact_variance_fieldsKeySpecifier = ('routing_location_id' | contact_variance_fieldsKeySpecifier)[];
export type contact_variance_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_pdf_templatesKeySpecifier = ('created_at' | 'id' | 'template' | 'type' | 'updated_at' | file_pdf_templatesKeySpecifier)[];
export type file_pdf_templatesFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_pdf_templates_aggregateKeySpecifier = ('aggregate' | 'nodes' | file_pdf_templates_aggregateKeySpecifier)[];
export type file_pdf_templates_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_pdf_templates_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | file_pdf_templates_aggregate_fieldsKeySpecifier)[];
export type file_pdf_templates_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_pdf_templates_max_fieldsKeySpecifier = ('created_at' | 'id' | 'template' | 'type' | 'updated_at' | file_pdf_templates_max_fieldsKeySpecifier)[];
export type file_pdf_templates_max_fieldsFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_pdf_templates_min_fieldsKeySpecifier = ('created_at' | 'id' | 'template' | 'type' | 'updated_at' | file_pdf_templates_min_fieldsKeySpecifier)[];
export type file_pdf_templates_min_fieldsFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_pdf_templates_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | file_pdf_templates_mutation_responseKeySpecifier)[];
export type file_pdf_templates_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_uploadKeySpecifier = ('bucket' | 'created_at' | 'filename' | 'id' | 'original_filename' | 'path' | file_uploadKeySpecifier)[];
export type file_uploadFieldPolicy = {
	bucket?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	original_filename?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_upload_aggregateKeySpecifier = ('aggregate' | 'nodes' | file_upload_aggregateKeySpecifier)[];
export type file_upload_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_upload_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | file_upload_aggregate_fieldsKeySpecifier)[];
export type file_upload_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_upload_max_fieldsKeySpecifier = ('bucket' | 'created_at' | 'filename' | 'id' | 'original_filename' | 'path' | file_upload_max_fieldsKeySpecifier)[];
export type file_upload_max_fieldsFieldPolicy = {
	bucket?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	original_filename?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_upload_min_fieldsKeySpecifier = ('bucket' | 'created_at' | 'filename' | 'id' | 'original_filename' | 'path' | file_upload_min_fieldsKeySpecifier)[];
export type file_upload_min_fieldsFieldPolicy = {
	bucket?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	original_filename?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_upload_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | file_upload_mutation_responseKeySpecifier)[];
export type file_upload_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_benefitsKeySpecifier = ('description' | 'funnel' | 'funnel_id' | 'id' | 'title' | funnel_benefitsKeySpecifier)[];
export type funnel_benefitsFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_benefits_aggregateKeySpecifier = ('aggregate' | 'nodes' | funnel_benefits_aggregateKeySpecifier)[];
export type funnel_benefits_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_benefits_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | funnel_benefits_aggregate_fieldsKeySpecifier)[];
export type funnel_benefits_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_benefits_max_fieldsKeySpecifier = ('description' | 'funnel_id' | 'id' | 'title' | funnel_benefits_max_fieldsKeySpecifier)[];
export type funnel_benefits_max_fieldsFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_benefits_min_fieldsKeySpecifier = ('description' | 'funnel_id' | 'id' | 'title' | funnel_benefits_min_fieldsKeySpecifier)[];
export type funnel_benefits_min_fieldsFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_benefits_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | funnel_benefits_mutation_responseKeySpecifier)[];
export type funnel_benefits_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_messageKeySpecifier = ('body' | 'campaign' | 'campaign_id' | 'contact' | 'contact_id' | 'created_at' | 'direction' | 'id' | 'seq' | 'wa_id' | 'whatsapp_message_id' | funnel_chatbot_messageKeySpecifier)[];
export type funnel_chatbot_messageFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	seq?: FieldPolicy<any> | FieldReadFunction<any>,
	wa_id?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_message_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_aggregateKeySpecifier = ('aggregate' | 'nodes' | funnel_chatbot_message_aggregateKeySpecifier)[];
export type funnel_chatbot_message_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | funnel_chatbot_message_aggregate_fieldsKeySpecifier)[];
export type funnel_chatbot_message_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_avg_fieldsKeySpecifier = ('seq' | funnel_chatbot_message_avg_fieldsKeySpecifier)[];
export type funnel_chatbot_message_avg_fieldsFieldPolicy = {
	seq?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_max_fieldsKeySpecifier = ('body' | 'campaign_id' | 'contact_id' | 'created_at' | 'direction' | 'id' | 'seq' | 'wa_id' | 'whatsapp_message_id' | funnel_chatbot_message_max_fieldsKeySpecifier)[];
export type funnel_chatbot_message_max_fieldsFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	seq?: FieldPolicy<any> | FieldReadFunction<any>,
	wa_id?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_message_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_min_fieldsKeySpecifier = ('body' | 'campaign_id' | 'contact_id' | 'created_at' | 'direction' | 'id' | 'seq' | 'wa_id' | 'whatsapp_message_id' | funnel_chatbot_message_min_fieldsKeySpecifier)[];
export type funnel_chatbot_message_min_fieldsFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	seq?: FieldPolicy<any> | FieldReadFunction<any>,
	wa_id?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_message_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | funnel_chatbot_message_mutation_responseKeySpecifier)[];
export type funnel_chatbot_message_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_stddev_fieldsKeySpecifier = ('seq' | funnel_chatbot_message_stddev_fieldsKeySpecifier)[];
export type funnel_chatbot_message_stddev_fieldsFieldPolicy = {
	seq?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_stddev_pop_fieldsKeySpecifier = ('seq' | funnel_chatbot_message_stddev_pop_fieldsKeySpecifier)[];
export type funnel_chatbot_message_stddev_pop_fieldsFieldPolicy = {
	seq?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_stddev_samp_fieldsKeySpecifier = ('seq' | funnel_chatbot_message_stddev_samp_fieldsKeySpecifier)[];
export type funnel_chatbot_message_stddev_samp_fieldsFieldPolicy = {
	seq?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_sum_fieldsKeySpecifier = ('seq' | funnel_chatbot_message_sum_fieldsKeySpecifier)[];
export type funnel_chatbot_message_sum_fieldsFieldPolicy = {
	seq?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_var_pop_fieldsKeySpecifier = ('seq' | funnel_chatbot_message_var_pop_fieldsKeySpecifier)[];
export type funnel_chatbot_message_var_pop_fieldsFieldPolicy = {
	seq?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_var_samp_fieldsKeySpecifier = ('seq' | funnel_chatbot_message_var_samp_fieldsKeySpecifier)[];
export type funnel_chatbot_message_var_samp_fieldsFieldPolicy = {
	seq?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_message_variance_fieldsKeySpecifier = ('seq' | funnel_chatbot_message_variance_fieldsKeySpecifier)[];
export type funnel_chatbot_message_variance_fieldsFieldPolicy = {
	seq?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_sessionKeySpecifier = ('answers' | 'campaign' | 'campaign_id' | 'contact' | 'contact_fields' | 'contact_id' | 'created_at' | 'funnel' | 'funnel_id' | 'id' | 'state' | 'step_index' | 'updated_at' | 'wa_id' | funnel_chatbot_sessionKeySpecifier)[];
export type funnel_chatbot_sessionFieldPolicy = {
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_fields?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	step_index?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	wa_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_aggregateKeySpecifier = ('aggregate' | 'nodes' | funnel_chatbot_session_aggregateKeySpecifier)[];
export type funnel_chatbot_session_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | funnel_chatbot_session_aggregate_fieldsKeySpecifier)[];
export type funnel_chatbot_session_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_avg_fieldsKeySpecifier = ('step_index' | funnel_chatbot_session_avg_fieldsKeySpecifier)[];
export type funnel_chatbot_session_avg_fieldsFieldPolicy = {
	step_index?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_max_fieldsKeySpecifier = ('campaign_id' | 'contact_id' | 'created_at' | 'funnel_id' | 'id' | 'state' | 'step_index' | 'updated_at' | 'wa_id' | funnel_chatbot_session_max_fieldsKeySpecifier)[];
export type funnel_chatbot_session_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	step_index?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	wa_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_min_fieldsKeySpecifier = ('campaign_id' | 'contact_id' | 'created_at' | 'funnel_id' | 'id' | 'state' | 'step_index' | 'updated_at' | 'wa_id' | funnel_chatbot_session_min_fieldsKeySpecifier)[];
export type funnel_chatbot_session_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	step_index?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	wa_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | funnel_chatbot_session_mutation_responseKeySpecifier)[];
export type funnel_chatbot_session_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_stddev_fieldsKeySpecifier = ('step_index' | funnel_chatbot_session_stddev_fieldsKeySpecifier)[];
export type funnel_chatbot_session_stddev_fieldsFieldPolicy = {
	step_index?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_stddev_pop_fieldsKeySpecifier = ('step_index' | funnel_chatbot_session_stddev_pop_fieldsKeySpecifier)[];
export type funnel_chatbot_session_stddev_pop_fieldsFieldPolicy = {
	step_index?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_stddev_samp_fieldsKeySpecifier = ('step_index' | funnel_chatbot_session_stddev_samp_fieldsKeySpecifier)[];
export type funnel_chatbot_session_stddev_samp_fieldsFieldPolicy = {
	step_index?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_sum_fieldsKeySpecifier = ('step_index' | funnel_chatbot_session_sum_fieldsKeySpecifier)[];
export type funnel_chatbot_session_sum_fieldsFieldPolicy = {
	step_index?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_var_pop_fieldsKeySpecifier = ('step_index' | funnel_chatbot_session_var_pop_fieldsKeySpecifier)[];
export type funnel_chatbot_session_var_pop_fieldsFieldPolicy = {
	step_index?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_var_samp_fieldsKeySpecifier = ('step_index' | funnel_chatbot_session_var_samp_fieldsKeySpecifier)[];
export type funnel_chatbot_session_var_samp_fieldsFieldPolicy = {
	step_index?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_chatbot_session_variance_fieldsKeySpecifier = ('step_index' | funnel_chatbot_session_variance_fieldsKeySpecifier)[];
export type funnel_chatbot_session_variance_fieldsFieldPolicy = {
	step_index?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_funnelsKeySpecifier = ('application_webhook_url' | 'benefit_icon' | 'benefit_icon_id' | 'benefits' | 'benefits_aggregate' | 'benefits_intro' | 'bot_consent_enabled' | 'call_to_action' | 'campaign' | 'campaign_id' | 'chatbot_funnel_enabled' | 'company_privacy_policy_title' | 'company_privacy_policy_url' | 'contact_question_birthdate_enabled' | 'contact_question_form_of_address_enabled' | 'created_at' | 'cv_question_enabled' | 'cv_required' | 'enabled' | 'expectation_icon' | 'expectation_icon_id' | 'expectations_intro' | 'expectations_items' | 'formality_type' | 'header_color' | 'highlights' | 'id' | 'img_1' | 'img_1_2' | 'img_1_2_id' | 'img_1_3' | 'img_1_3_id' | 'img_1_4' | 'img_1_4_id' | 'img_1_id' | 'img_2' | 'img_2_2' | 'img_2_2_id' | 'img_2_3' | 'img_2_3_id' | 'img_2_4' | 'img_2_4_id' | 'img_2_id' | 'img_3' | 'img_3_2' | 'img_3_2_id' | 'img_3_3' | 'img_3_3_id' | 'img_3_4' | 'img_3_4_id' | 'img_3_id' | 'insight' | 'job_byline' | 'job_caption' | 'job_intro' | 'locale' | 'location_question_city_enabled' | 'location_question_country_enabled' | 'location_question_postalcode_enabled' | 'location_question_street_enabled' | 'logo' | 'logo_id' | 'next_steps' | 'page_insights' | 'page_insights_aggregate' | 'questions' | 'questions_aggregate' | 'slug' | 'sub_call_to_action' | 'template' | 'theme_color' | 'updated_at' | 'video_1_id' | 'video_2_id' | 'video_3_id' | 'we_are_byline' | 'we_are_call_to_action' | 'we_are_copy' | 'we_are_intro' | 'whatsapp_apply_label' | 'whatsapp_apply_message_template' | 'whatsapp_intro_message' | 'whatsapp_outro_message' | 'whatsapp_share_caption' | 'whatsapp_share_clicks' | 'whatsapp_share_clicks_aggregate' | 'whatsapp_share_label' | 'whatsapp_share_title' | funnel_funnelsKeySpecifier)[];
export type funnel_funnelsFieldPolicy = {
	application_webhook_url?: FieldPolicy<any> | FieldReadFunction<any>,
	benefit_icon?: FieldPolicy<any> | FieldReadFunction<any>,
	benefit_icon_id?: FieldPolicy<any> | FieldReadFunction<any>,
	benefits?: FieldPolicy<any> | FieldReadFunction<any>,
	benefits_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	benefits_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_consent_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	chatbot_funnel_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	company_privacy_policy_title?: FieldPolicy<any> | FieldReadFunction<any>,
	company_privacy_policy_url?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_question_birthdate_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_question_form_of_address_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	cv_question_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	cv_required?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	expectation_icon?: FieldPolicy<any> | FieldReadFunction<any>,
	expectation_icon_id?: FieldPolicy<any> | FieldReadFunction<any>,
	expectations_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	expectations_items?: FieldPolicy<any> | FieldReadFunction<any>,
	formality_type?: FieldPolicy<any> | FieldReadFunction<any>,
	header_color?: FieldPolicy<any> | FieldReadFunction<any>,
	highlights?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_2?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_3?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_4?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_4_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_2?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_3?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_4?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_4_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_2?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_3?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_4?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_4_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	insight?: FieldPolicy<any> | FieldReadFunction<any>,
	job_byline?: FieldPolicy<any> | FieldReadFunction<any>,
	job_caption?: FieldPolicy<any> | FieldReadFunction<any>,
	job_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	location_question_city_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	location_question_country_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	location_question_postalcode_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	location_question_street_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_id?: FieldPolicy<any> | FieldReadFunction<any>,
	next_steps?: FieldPolicy<any> | FieldReadFunction<any>,
	page_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	page_insights_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	questions?: FieldPolicy<any> | FieldReadFunction<any>,
	questions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>,
	theme_color?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	video_1_id?: FieldPolicy<any> | FieldReadFunction<any>,
	video_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	video_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_byline?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_copy?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_apply_label?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_apply_message_template?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_intro_message?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_outro_message?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_caption?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_clicks_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_label?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_funnels_aggregateKeySpecifier = ('aggregate' | 'nodes' | funnel_funnels_aggregateKeySpecifier)[];
export type funnel_funnels_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_funnels_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | funnel_funnels_aggregate_fieldsKeySpecifier)[];
export type funnel_funnels_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_funnels_max_fieldsKeySpecifier = ('application_webhook_url' | 'benefit_icon_id' | 'benefits_intro' | 'call_to_action' | 'campaign_id' | 'company_privacy_policy_title' | 'company_privacy_policy_url' | 'created_at' | 'expectation_icon_id' | 'expectations_intro' | 'formality_type' | 'header_color' | 'highlights' | 'id' | 'img_1_2_id' | 'img_1_3_id' | 'img_1_4_id' | 'img_1_id' | 'img_2_2_id' | 'img_2_3_id' | 'img_2_4_id' | 'img_2_id' | 'img_3_2_id' | 'img_3_3_id' | 'img_3_4_id' | 'img_3_id' | 'job_byline' | 'job_caption' | 'job_intro' | 'locale' | 'logo_id' | 'slug' | 'sub_call_to_action' | 'template' | 'theme_color' | 'updated_at' | 'video_1_id' | 'video_2_id' | 'video_3_id' | 'we_are_byline' | 'we_are_call_to_action' | 'we_are_copy' | 'we_are_intro' | 'whatsapp_apply_label' | 'whatsapp_apply_message_template' | 'whatsapp_intro_message' | 'whatsapp_outro_message' | 'whatsapp_share_caption' | 'whatsapp_share_label' | 'whatsapp_share_title' | funnel_funnels_max_fieldsKeySpecifier)[];
export type funnel_funnels_max_fieldsFieldPolicy = {
	application_webhook_url?: FieldPolicy<any> | FieldReadFunction<any>,
	benefit_icon_id?: FieldPolicy<any> | FieldReadFunction<any>,
	benefits_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	company_privacy_policy_title?: FieldPolicy<any> | FieldReadFunction<any>,
	company_privacy_policy_url?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	expectation_icon_id?: FieldPolicy<any> | FieldReadFunction<any>,
	expectations_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	formality_type?: FieldPolicy<any> | FieldReadFunction<any>,
	header_color?: FieldPolicy<any> | FieldReadFunction<any>,
	highlights?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_4_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_4_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_4_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	job_byline?: FieldPolicy<any> | FieldReadFunction<any>,
	job_caption?: FieldPolicy<any> | FieldReadFunction<any>,
	job_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_id?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>,
	theme_color?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	video_1_id?: FieldPolicy<any> | FieldReadFunction<any>,
	video_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	video_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_byline?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_copy?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_apply_label?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_apply_message_template?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_intro_message?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_outro_message?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_caption?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_label?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_funnels_min_fieldsKeySpecifier = ('application_webhook_url' | 'benefit_icon_id' | 'benefits_intro' | 'call_to_action' | 'campaign_id' | 'company_privacy_policy_title' | 'company_privacy_policy_url' | 'created_at' | 'expectation_icon_id' | 'expectations_intro' | 'formality_type' | 'header_color' | 'highlights' | 'id' | 'img_1_2_id' | 'img_1_3_id' | 'img_1_4_id' | 'img_1_id' | 'img_2_2_id' | 'img_2_3_id' | 'img_2_4_id' | 'img_2_id' | 'img_3_2_id' | 'img_3_3_id' | 'img_3_4_id' | 'img_3_id' | 'job_byline' | 'job_caption' | 'job_intro' | 'locale' | 'logo_id' | 'slug' | 'sub_call_to_action' | 'template' | 'theme_color' | 'updated_at' | 'video_1_id' | 'video_2_id' | 'video_3_id' | 'we_are_byline' | 'we_are_call_to_action' | 'we_are_copy' | 'we_are_intro' | 'whatsapp_apply_label' | 'whatsapp_apply_message_template' | 'whatsapp_intro_message' | 'whatsapp_outro_message' | 'whatsapp_share_caption' | 'whatsapp_share_label' | 'whatsapp_share_title' | funnel_funnels_min_fieldsKeySpecifier)[];
export type funnel_funnels_min_fieldsFieldPolicy = {
	application_webhook_url?: FieldPolicy<any> | FieldReadFunction<any>,
	benefit_icon_id?: FieldPolicy<any> | FieldReadFunction<any>,
	benefits_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	company_privacy_policy_title?: FieldPolicy<any> | FieldReadFunction<any>,
	company_privacy_policy_url?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	expectation_icon_id?: FieldPolicy<any> | FieldReadFunction<any>,
	expectations_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	formality_type?: FieldPolicy<any> | FieldReadFunction<any>,
	header_color?: FieldPolicy<any> | FieldReadFunction<any>,
	highlights?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_4_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_1_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_4_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_4_id?: FieldPolicy<any> | FieldReadFunction<any>,
	img_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	job_byline?: FieldPolicy<any> | FieldReadFunction<any>,
	job_caption?: FieldPolicy<any> | FieldReadFunction<any>,
	job_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_id?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>,
	theme_color?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	video_1_id?: FieldPolicy<any> | FieldReadFunction<any>,
	video_2_id?: FieldPolicy<any> | FieldReadFunction<any>,
	video_3_id?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_byline?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_call_to_action?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_copy?: FieldPolicy<any> | FieldReadFunction<any>,
	we_are_intro?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_apply_label?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_apply_message_template?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_intro_message?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_outro_message?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_caption?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_label?: FieldPolicy<any> | FieldReadFunction<any>,
	whatsapp_share_title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_funnels_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | funnel_funnels_mutation_responseKeySpecifier)[];
export type funnel_funnels_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insightsKeySpecifier = ('campaign' | 'campaign_id' | 'click_through_rate' | 'click_throughs' | 'funnel' | 'funnel_id' | 'sessions' | funnel_insightsKeySpecifier)[];
export type funnel_insightsFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_aggregateKeySpecifier = ('aggregate' | 'nodes' | funnel_insights_aggregateKeySpecifier)[];
export type funnel_insights_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | funnel_insights_aggregate_fieldsKeySpecifier)[];
export type funnel_insights_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_avg_fieldsKeySpecifier = ('click_through_rate' | 'click_throughs' | 'sessions' | funnel_insights_avg_fieldsKeySpecifier)[];
export type funnel_insights_avg_fieldsFieldPolicy = {
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_max_fieldsKeySpecifier = ('campaign_id' | 'click_through_rate' | 'click_throughs' | 'funnel_id' | 'sessions' | funnel_insights_max_fieldsKeySpecifier)[];
export type funnel_insights_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_min_fieldsKeySpecifier = ('campaign_id' | 'click_through_rate' | 'click_throughs' | 'funnel_id' | 'sessions' | funnel_insights_min_fieldsKeySpecifier)[];
export type funnel_insights_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | funnel_insights_mutation_responseKeySpecifier)[];
export type funnel_insights_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_stddev_fieldsKeySpecifier = ('click_through_rate' | 'click_throughs' | 'sessions' | funnel_insights_stddev_fieldsKeySpecifier)[];
export type funnel_insights_stddev_fieldsFieldPolicy = {
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_stddev_pop_fieldsKeySpecifier = ('click_through_rate' | 'click_throughs' | 'sessions' | funnel_insights_stddev_pop_fieldsKeySpecifier)[];
export type funnel_insights_stddev_pop_fieldsFieldPolicy = {
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_stddev_samp_fieldsKeySpecifier = ('click_through_rate' | 'click_throughs' | 'sessions' | funnel_insights_stddev_samp_fieldsKeySpecifier)[];
export type funnel_insights_stddev_samp_fieldsFieldPolicy = {
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_sum_fieldsKeySpecifier = ('click_through_rate' | 'click_throughs' | 'sessions' | funnel_insights_sum_fieldsKeySpecifier)[];
export type funnel_insights_sum_fieldsFieldPolicy = {
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_var_pop_fieldsKeySpecifier = ('click_through_rate' | 'click_throughs' | 'sessions' | funnel_insights_var_pop_fieldsKeySpecifier)[];
export type funnel_insights_var_pop_fieldsFieldPolicy = {
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_var_samp_fieldsKeySpecifier = ('click_through_rate' | 'click_throughs' | 'sessions' | funnel_insights_var_samp_fieldsKeySpecifier)[];
export type funnel_insights_var_samp_fieldsFieldPolicy = {
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_insights_variance_fieldsKeySpecifier = ('click_through_rate' | 'click_throughs' | 'sessions' | funnel_insights_variance_fieldsKeySpecifier)[];
export type funnel_insights_variance_fieldsFieldPolicy = {
	click_through_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	click_throughs?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insightsKeySpecifier = ('campaign' | 'campaign_id' | 'funnel' | 'funnel_id' | 'id' | 'index' | 'name' | 'question' | 'question_id' | 'visitors' | funnel_page_insightsKeySpecifier)[];
export type funnel_page_insightsFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_aggregateKeySpecifier = ('aggregate' | 'nodes' | funnel_page_insights_aggregateKeySpecifier)[];
export type funnel_page_insights_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | funnel_page_insights_aggregate_fieldsKeySpecifier)[];
export type funnel_page_insights_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_avg_fieldsKeySpecifier = ('index' | 'visitors' | funnel_page_insights_avg_fieldsKeySpecifier)[];
export type funnel_page_insights_avg_fieldsFieldPolicy = {
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_max_fieldsKeySpecifier = ('campaign_id' | 'funnel_id' | 'id' | 'index' | 'name' | 'question_id' | 'visitors' | funnel_page_insights_max_fieldsKeySpecifier)[];
export type funnel_page_insights_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_min_fieldsKeySpecifier = ('campaign_id' | 'funnel_id' | 'id' | 'index' | 'name' | 'question_id' | 'visitors' | funnel_page_insights_min_fieldsKeySpecifier)[];
export type funnel_page_insights_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | funnel_page_insights_mutation_responseKeySpecifier)[];
export type funnel_page_insights_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_stddev_fieldsKeySpecifier = ('index' | 'visitors' | funnel_page_insights_stddev_fieldsKeySpecifier)[];
export type funnel_page_insights_stddev_fieldsFieldPolicy = {
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_stddev_pop_fieldsKeySpecifier = ('index' | 'visitors' | funnel_page_insights_stddev_pop_fieldsKeySpecifier)[];
export type funnel_page_insights_stddev_pop_fieldsFieldPolicy = {
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_stddev_samp_fieldsKeySpecifier = ('index' | 'visitors' | funnel_page_insights_stddev_samp_fieldsKeySpecifier)[];
export type funnel_page_insights_stddev_samp_fieldsFieldPolicy = {
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_sum_fieldsKeySpecifier = ('index' | 'visitors' | funnel_page_insights_sum_fieldsKeySpecifier)[];
export type funnel_page_insights_sum_fieldsFieldPolicy = {
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_var_pop_fieldsKeySpecifier = ('index' | 'visitors' | funnel_page_insights_var_pop_fieldsKeySpecifier)[];
export type funnel_page_insights_var_pop_fieldsFieldPolicy = {
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_var_samp_fieldsKeySpecifier = ('index' | 'visitors' | funnel_page_insights_var_samp_fieldsKeySpecifier)[];
export type funnel_page_insights_var_samp_fieldsFieldPolicy = {
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_page_insights_variance_fieldsKeySpecifier = ('index' | 'visitors' | funnel_page_insights_variance_fieldsKeySpecifier)[];
export type funnel_page_insights_variance_fieldsFieldPolicy = {
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	visitors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_questionKeySpecifier = ('answers' | 'answers_aggregate' | 'archived' | 'campaign' | 'campaign_id' | 'child_questions' | 'child_questions_aggregate' | 'field_name' | 'funnel' | 'funnel_id' | 'icon' | 'id' | 'is_required' | 'options' | 'options_aggregate' | 'page_insights' | 'page_insights_aggregate' | 'parent_question' | 'parent_question_id' | 'position' | 'question_type' | 'title' | funnel_questionKeySpecifier)[];
export type funnel_questionFieldPolicy = {
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	answers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	archived?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	child_questions?: FieldPolicy<any> | FieldReadFunction<any>,
	child_questions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	field_name?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_required?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	options_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	page_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	page_insights_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_question?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	question_type?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_aggregateKeySpecifier = ('aggregate' | 'nodes' | funnel_question_aggregateKeySpecifier)[];
export type funnel_question_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | funnel_question_aggregate_fieldsKeySpecifier)[];
export type funnel_question_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_avg_fieldsKeySpecifier = ('position' | funnel_question_avg_fieldsKeySpecifier)[];
export type funnel_question_avg_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_max_fieldsKeySpecifier = ('campaign_id' | 'field_name' | 'funnel_id' | 'icon' | 'id' | 'parent_question_id' | 'position' | 'question_type' | 'title' | funnel_question_max_fieldsKeySpecifier)[];
export type funnel_question_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	field_name?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	question_type?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_min_fieldsKeySpecifier = ('campaign_id' | 'field_name' | 'funnel_id' | 'icon' | 'id' | 'parent_question_id' | 'position' | 'question_type' | 'title' | funnel_question_min_fieldsKeySpecifier)[];
export type funnel_question_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	field_name?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	question_type?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | funnel_question_mutation_responseKeySpecifier)[];
export type funnel_question_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_optionKeySpecifier = ('icon' | 'id' | 'isKnockout' | 'question' | 'question_id' | 'redirect_behavior' | 'redirect_question' | 'redirect_question_id' | 'title' | 'value' | funnel_question_optionKeySpecifier)[];
export type funnel_question_optionFieldPolicy = {
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isKnockout?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	redirect_behavior?: FieldPolicy<any> | FieldReadFunction<any>,
	redirect_question?: FieldPolicy<any> | FieldReadFunction<any>,
	redirect_question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_option_aggregateKeySpecifier = ('aggregate' | 'nodes' | funnel_question_option_aggregateKeySpecifier)[];
export type funnel_question_option_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_option_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | funnel_question_option_aggregate_fieldsKeySpecifier)[];
export type funnel_question_option_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_option_max_fieldsKeySpecifier = ('icon' | 'id' | 'question_id' | 'redirect_behavior' | 'redirect_question_id' | 'title' | 'value' | funnel_question_option_max_fieldsKeySpecifier)[];
export type funnel_question_option_max_fieldsFieldPolicy = {
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	redirect_behavior?: FieldPolicy<any> | FieldReadFunction<any>,
	redirect_question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_option_min_fieldsKeySpecifier = ('icon' | 'id' | 'question_id' | 'redirect_behavior' | 'redirect_question_id' | 'title' | 'value' | funnel_question_option_min_fieldsKeySpecifier)[];
export type funnel_question_option_min_fieldsFieldPolicy = {
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	redirect_behavior?: FieldPolicy<any> | FieldReadFunction<any>,
	redirect_question_id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_option_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | funnel_question_option_mutation_responseKeySpecifier)[];
export type funnel_question_option_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_stddev_fieldsKeySpecifier = ('position' | funnel_question_stddev_fieldsKeySpecifier)[];
export type funnel_question_stddev_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_stddev_pop_fieldsKeySpecifier = ('position' | funnel_question_stddev_pop_fieldsKeySpecifier)[];
export type funnel_question_stddev_pop_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_stddev_samp_fieldsKeySpecifier = ('position' | funnel_question_stddev_samp_fieldsKeySpecifier)[];
export type funnel_question_stddev_samp_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_sum_fieldsKeySpecifier = ('position' | funnel_question_sum_fieldsKeySpecifier)[];
export type funnel_question_sum_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_var_pop_fieldsKeySpecifier = ('position' | funnel_question_var_pop_fieldsKeySpecifier)[];
export type funnel_question_var_pop_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_var_samp_fieldsKeySpecifier = ('position' | funnel_question_var_samp_fieldsKeySpecifier)[];
export type funnel_question_var_samp_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_question_variance_fieldsKeySpecifier = ('position' | funnel_question_variance_fieldsKeySpecifier)[];
export type funnel_question_variance_fieldsFieldPolicy = {
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_whatsapp_share_clicksKeySpecifier = ('campaign' | 'campaign_id' | 'created_at' | 'funnel' | 'funnel_id' | 'id' | 'source' | funnel_whatsapp_share_clicksKeySpecifier)[];
export type funnel_whatsapp_share_clicksFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_whatsapp_share_clicks_aggregateKeySpecifier = ('aggregate' | 'nodes' | funnel_whatsapp_share_clicks_aggregateKeySpecifier)[];
export type funnel_whatsapp_share_clicks_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_whatsapp_share_clicks_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | funnel_whatsapp_share_clicks_aggregate_fieldsKeySpecifier)[];
export type funnel_whatsapp_share_clicks_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_whatsapp_share_clicks_max_fieldsKeySpecifier = ('campaign_id' | 'created_at' | 'funnel_id' | 'id' | 'source' | funnel_whatsapp_share_clicks_max_fieldsKeySpecifier)[];
export type funnel_whatsapp_share_clicks_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_whatsapp_share_clicks_min_fieldsKeySpecifier = ('campaign_id' | 'created_at' | 'funnel_id' | 'id' | 'source' | funnel_whatsapp_share_clicks_min_fieldsKeySpecifier)[];
export type funnel_whatsapp_share_clicks_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type funnel_whatsapp_share_clicks_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | funnel_whatsapp_share_clicks_mutation_responseKeySpecifier)[];
export type funnel_whatsapp_share_clicks_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contactsKeySpecifier = ('accepted_data_privacy_agreement' | 'birthdate' | 'bot_consent' | 'camp_id' | 'campaign_id' | 'campaign_name' | 'category' | 'city' | 'converted_at' | 'country' | 'created_at' | 'cv_id' | 'deleted_at' | 'email_address' | 'end' | 'first_name' | 'form_of_address' | 'funnel_file_id' | 'has_completed_chatbot' | 'id' | 'last_name' | 'origin_campaign_id' | 'perspective_id' | 'phone_number' | 'qualified' | 'routing_location_id' | 'start' | 'street' | 'updated_at' | 'utm_source' | 'zip_code' | huk_contactsKeySpecifier)[];
export type huk_contactsFieldPolicy = {
	accepted_data_privacy_agreement?: FieldPolicy<any> | FieldReadFunction<any>,
	birthdate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_consent?: FieldPolicy<any> | FieldReadFunction<any>,
	camp_id?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_name?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	converted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	cv_id?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	email_address?: FieldPolicy<any> | FieldReadFunction<any>,
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	first_name?: FieldPolicy<any> | FieldReadFunction<any>,
	form_of_address?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	has_completed_chatbot?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_name?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_id?: FieldPolicy<any> | FieldReadFunction<any>,
	phone_number?: FieldPolicy<any> | FieldReadFunction<any>,
	qualified?: FieldPolicy<any> | FieldReadFunction<any>,
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	utm_source?: FieldPolicy<any> | FieldReadFunction<any>,
	zip_code?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_aggregateKeySpecifier = ('aggregate' | 'nodes' | huk_contacts_aggregateKeySpecifier)[];
export type huk_contacts_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | huk_contacts_aggregate_fieldsKeySpecifier)[];
export type huk_contacts_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_avg_fieldsKeySpecifier = ('routing_location_id' | huk_contacts_avg_fieldsKeySpecifier)[];
export type huk_contacts_avg_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_max_fieldsKeySpecifier = ('birthdate' | 'camp_id' | 'campaign_id' | 'campaign_name' | 'category' | 'city' | 'converted_at' | 'country' | 'created_at' | 'cv_id' | 'deleted_at' | 'email_address' | 'end' | 'first_name' | 'form_of_address' | 'funnel_file_id' | 'id' | 'last_name' | 'origin_campaign_id' | 'perspective_id' | 'phone_number' | 'routing_location_id' | 'start' | 'street' | 'updated_at' | 'utm_source' | 'zip_code' | huk_contacts_max_fieldsKeySpecifier)[];
export type huk_contacts_max_fieldsFieldPolicy = {
	birthdate?: FieldPolicy<any> | FieldReadFunction<any>,
	camp_id?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_name?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	converted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	cv_id?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	email_address?: FieldPolicy<any> | FieldReadFunction<any>,
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	first_name?: FieldPolicy<any> | FieldReadFunction<any>,
	form_of_address?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_name?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_id?: FieldPolicy<any> | FieldReadFunction<any>,
	phone_number?: FieldPolicy<any> | FieldReadFunction<any>,
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	utm_source?: FieldPolicy<any> | FieldReadFunction<any>,
	zip_code?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_min_fieldsKeySpecifier = ('birthdate' | 'camp_id' | 'campaign_id' | 'campaign_name' | 'category' | 'city' | 'converted_at' | 'country' | 'created_at' | 'cv_id' | 'deleted_at' | 'email_address' | 'end' | 'first_name' | 'form_of_address' | 'funnel_file_id' | 'id' | 'last_name' | 'origin_campaign_id' | 'perspective_id' | 'phone_number' | 'routing_location_id' | 'start' | 'street' | 'updated_at' | 'utm_source' | 'zip_code' | huk_contacts_min_fieldsKeySpecifier)[];
export type huk_contacts_min_fieldsFieldPolicy = {
	birthdate?: FieldPolicy<any> | FieldReadFunction<any>,
	camp_id?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_name?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	converted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	cv_id?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	email_address?: FieldPolicy<any> | FieldReadFunction<any>,
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	first_name?: FieldPolicy<any> | FieldReadFunction<any>,
	form_of_address?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_name?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_id?: FieldPolicy<any> | FieldReadFunction<any>,
	phone_number?: FieldPolicy<any> | FieldReadFunction<any>,
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	utm_source?: FieldPolicy<any> | FieldReadFunction<any>,
	zip_code?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_stddev_fieldsKeySpecifier = ('routing_location_id' | huk_contacts_stddev_fieldsKeySpecifier)[];
export type huk_contacts_stddev_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_stddev_pop_fieldsKeySpecifier = ('routing_location_id' | huk_contacts_stddev_pop_fieldsKeySpecifier)[];
export type huk_contacts_stddev_pop_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_stddev_samp_fieldsKeySpecifier = ('routing_location_id' | huk_contacts_stddev_samp_fieldsKeySpecifier)[];
export type huk_contacts_stddev_samp_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_sum_fieldsKeySpecifier = ('routing_location_id' | huk_contacts_sum_fieldsKeySpecifier)[];
export type huk_contacts_sum_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_var_pop_fieldsKeySpecifier = ('routing_location_id' | huk_contacts_var_pop_fieldsKeySpecifier)[];
export type huk_contacts_var_pop_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_var_samp_fieldsKeySpecifier = ('routing_location_id' | huk_contacts_var_samp_fieldsKeySpecifier)[];
export type huk_contacts_var_samp_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type huk_contacts_variance_fieldsKeySpecifier = ('routing_location_id' | huk_contacts_variance_fieldsKeySpecifier)[];
export type huk_contacts_variance_fieldsFieldPolicy = {
	routing_location_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type mutation_rootKeySpecifier = ('delete_ad_campaign_metrics' | 'delete_ad_campaign_metrics_by_pk' | 'delete_ad_comment' | 'delete_ad_comment_by_pk' | 'delete_ad_creative' | 'delete_ad_creative_by_pk' | 'delete_ad_creative_feedback' | 'delete_ad_creative_feedback_by_pk' | 'delete_ad_platform' | 'delete_ad_platform_by_pk' | 'delete_ad_providers' | 'delete_ad_providers_by_pk' | 'delete_ad_setting' | 'delete_ad_setting_by_pk' | 'delete_ad_status' | 'delete_ad_status_by_pk' | 'delete_anna_ai_call_campaigns' | 'delete_anna_ai_call_campaigns_by_pk' | 'delete_anna_ai_call_states' | 'delete_anna_ai_call_states_by_pk' | 'delete_anna_ai_outbound_calls' | 'delete_anna_ai_outbound_calls_by_pk' | 'delete_answer' | 'delete_answer_by_pk' | 'delete_applicant_event' | 'delete_applicant_event_by_pk' | 'delete_board_column_type' | 'delete_board_column_type_by_pk' | 'delete_board_contact_board' | 'delete_board_contact_board_by_pk' | 'delete_board_contact_board_column' | 'delete_board_contact_board_column_by_pk' | 'delete_board_contact_board_entry' | 'delete_board_contact_board_entry_by_pk' | 'delete_board_note' | 'delete_board_note_by_pk' | 'delete_bot_assignee' | 'delete_bot_assignee_by_pk' | 'delete_bot_channel' | 'delete_bot_channel_by_pk' | 'delete_bot_conversation' | 'delete_bot_conversation_by_pk' | 'delete_bot_conversation_state' | 'delete_bot_conversation_state_by_pk' | 'delete_bot_message' | 'delete_bot_message_by_pk' | 'delete_bot_message_status' | 'delete_bot_message_status_by_pk' | 'delete_bot_sender' | 'delete_bot_sender_by_pk' | 'delete_campaign' | 'delete_campaign_ad' | 'delete_campaign_ad_by_pk' | 'delete_campaign_budget' | 'delete_campaign_budget_transaction' | 'delete_campaign_budget_transaction_by_pk' | 'delete_campaign_by_pk' | 'delete_campaign_email_template_overwrite' | 'delete_campaign_email_template_overwrite_by_pk' | 'delete_campaign_event_log' | 'delete_campaign_event_log_by_pk' | 'delete_campaign_iso_2_country_codes' | 'delete_campaign_iso_2_country_codes_by_pk' | 'delete_campaign_job_description' | 'delete_campaign_job_description_by_pk' | 'delete_campaign_order' | 'delete_campaign_order_by_pk' | 'delete_campaign_order_source' | 'delete_campaign_order_source_by_pk' | 'delete_campaign_order_source_type' | 'delete_campaign_order_source_type_by_pk' | 'delete_campaign_routing_destination' | 'delete_campaign_routing_destination_by_pk' | 'delete_campaign_routing_info' | 'delete_campaign_routing_info_by_pk' | 'delete_campaign_routing_zipcode' | 'delete_campaign_routing_zipcode_by_pk' | 'delete_campaign_settings_override' | 'delete_campaign_settings_override_by_pk' | 'delete_campaign_status' | 'delete_campaign_status_by_pk' | 'delete_campaign_status_event' | 'delete_campaign_status_event_by_pk' | 'delete_campaign_status_log' | 'delete_campaign_status_log_by_pk' | 'delete_campaign_transaction_type' | 'delete_campaign_transaction_type_by_pk' | 'delete_campaign_work_location' | 'delete_campaign_work_location_by_pk' | 'delete_chat_bot_customers' | 'delete_chat_bot_customers_by_pk' | 'delete_chat_bot_forwarding' | 'delete_chat_bot_forwarding_by_pk' | 'delete_chat_bot_message_type' | 'delete_chat_bot_message_type_by_pk' | 'delete_chat_bot_messages' | 'delete_chat_bot_messages_by_pk' | 'delete_contact' | 'delete_contact_by_pk' | 'delete_contact_logs' | 'delete_contact_logs_by_pk' | 'delete_file_pdf_templates' | 'delete_file_pdf_templates_by_pk' | 'delete_file_upload' | 'delete_file_upload_by_pk' | 'delete_funnel_benefits' | 'delete_funnel_benefits_by_pk' | 'delete_funnel_chatbot_message' | 'delete_funnel_chatbot_message_by_pk' | 'delete_funnel_chatbot_session' | 'delete_funnel_chatbot_session_by_pk' | 'delete_funnel_funnels' | 'delete_funnel_funnels_by_pk' | 'delete_funnel_insights' | 'delete_funnel_page_insights' | 'delete_funnel_page_insights_by_pk' | 'delete_funnel_question' | 'delete_funnel_question_by_pk' | 'delete_funnel_question_option' | 'delete_funnel_question_option_by_pk' | 'delete_funnel_whatsapp_share_clicks' | 'delete_funnel_whatsapp_share_clicks_by_pk' | 'delete_organization' | 'delete_organization_by_pk' | 'delete_organization_location' | 'delete_organization_location_by_pk' | 'delete_organization_name_prefix' | 'delete_organization_name_prefix_by_pk' | 'delete_organization_news' | 'delete_organization_news_by_pk' | 'delete_organization_region' | 'delete_organization_region_by_pk' | 'delete_organization_settings' | 'delete_organization_settings_by_pk' | 'delete_perspective_campaign' | 'delete_perspective_campaign_by_pk' | 'delete_qa_source' | 'delete_qa_source_by_pk' | 'delete_rms_connectors' | 'delete_rms_connectors_by_pk' | 'delete_rms_forwarded_logs' | 'delete_rms_forwarded_logs_by_pk' | 'delete_rms_org_setups' | 'delete_rms_org_setups_by_pk' | 'delete_system_api_keys' | 'delete_system_api_keys_by_pk' | 'delete_system_call_daily_stats' | 'delete_system_call_daily_stats_by_pk' | 'delete_system_email_daily_stats' | 'delete_system_email_daily_stats_by_pk' | 'delete_system_running_release' | 'delete_system_running_release_by_pk' | 'delete_system_sms_daily_stats' | 'delete_system_sms_daily_stats_by_pk' | 'insert_ad_campaign_metrics' | 'insert_ad_campaign_metrics_one' | 'insert_ad_comment' | 'insert_ad_comment_one' | 'insert_ad_creative' | 'insert_ad_creative_feedback' | 'insert_ad_creative_feedback_one' | 'insert_ad_creative_one' | 'insert_ad_platform' | 'insert_ad_platform_one' | 'insert_ad_providers' | 'insert_ad_providers_one' | 'insert_ad_setting' | 'insert_ad_setting_one' | 'insert_ad_status' | 'insert_ad_status_one' | 'insert_anna_ai_call_campaigns' | 'insert_anna_ai_call_campaigns_one' | 'insert_anna_ai_call_states' | 'insert_anna_ai_call_states_one' | 'insert_anna_ai_outbound_calls' | 'insert_anna_ai_outbound_calls_one' | 'insert_answer' | 'insert_answer_one' | 'insert_applicant_event' | 'insert_applicant_event_one' | 'insert_board_column_type' | 'insert_board_column_type_one' | 'insert_board_contact_board' | 'insert_board_contact_board_column' | 'insert_board_contact_board_column_one' | 'insert_board_contact_board_entry' | 'insert_board_contact_board_entry_one' | 'insert_board_contact_board_one' | 'insert_board_note' | 'insert_board_note_one' | 'insert_bot_assignee' | 'insert_bot_assignee_one' | 'insert_bot_channel' | 'insert_bot_channel_one' | 'insert_bot_conversation' | 'insert_bot_conversation_one' | 'insert_bot_conversation_state' | 'insert_bot_conversation_state_one' | 'insert_bot_message' | 'insert_bot_message_one' | 'insert_bot_message_status' | 'insert_bot_message_status_one' | 'insert_bot_sender' | 'insert_bot_sender_one' | 'insert_campaign' | 'insert_campaign_ad' | 'insert_campaign_ad_one' | 'insert_campaign_budget' | 'insert_campaign_budget_one' | 'insert_campaign_budget_transaction' | 'insert_campaign_budget_transaction_one' | 'insert_campaign_email_template_overwrite' | 'insert_campaign_email_template_overwrite_one' | 'insert_campaign_event_log' | 'insert_campaign_event_log_one' | 'insert_campaign_iso_2_country_codes' | 'insert_campaign_iso_2_country_codes_one' | 'insert_campaign_job_description' | 'insert_campaign_job_description_one' | 'insert_campaign_one' | 'insert_campaign_order' | 'insert_campaign_order_one' | 'insert_campaign_order_source' | 'insert_campaign_order_source_one' | 'insert_campaign_order_source_type' | 'insert_campaign_order_source_type_one' | 'insert_campaign_routing_destination' | 'insert_campaign_routing_destination_one' | 'insert_campaign_routing_info' | 'insert_campaign_routing_info_one' | 'insert_campaign_routing_zipcode' | 'insert_campaign_routing_zipcode_one' | 'insert_campaign_settings_override' | 'insert_campaign_settings_override_one' | 'insert_campaign_status' | 'insert_campaign_status_event' | 'insert_campaign_status_event_one' | 'insert_campaign_status_log' | 'insert_campaign_status_log_one' | 'insert_campaign_status_one' | 'insert_campaign_transaction_type' | 'insert_campaign_transaction_type_one' | 'insert_campaign_work_location' | 'insert_campaign_work_location_one' | 'insert_chat_bot_customers' | 'insert_chat_bot_customers_one' | 'insert_chat_bot_forwarding' | 'insert_chat_bot_forwarding_one' | 'insert_chat_bot_message_type' | 'insert_chat_bot_message_type_one' | 'insert_chat_bot_messages' | 'insert_chat_bot_messages_one' | 'insert_contact' | 'insert_contact_logs' | 'insert_contact_logs_one' | 'insert_contact_one' | 'insert_file_pdf_templates' | 'insert_file_pdf_templates_one' | 'insert_file_upload' | 'insert_file_upload_one' | 'insert_funnel_benefits' | 'insert_funnel_benefits_one' | 'insert_funnel_chatbot_message' | 'insert_funnel_chatbot_message_one' | 'insert_funnel_chatbot_session' | 'insert_funnel_chatbot_session_one' | 'insert_funnel_funnels' | 'insert_funnel_funnels_one' | 'insert_funnel_insights' | 'insert_funnel_insights_one' | 'insert_funnel_page_insights' | 'insert_funnel_page_insights_one' | 'insert_funnel_question' | 'insert_funnel_question_one' | 'insert_funnel_question_option' | 'insert_funnel_question_option_one' | 'insert_funnel_whatsapp_share_clicks' | 'insert_funnel_whatsapp_share_clicks_one' | 'insert_organization' | 'insert_organization_location' | 'insert_organization_location_one' | 'insert_organization_name_prefix' | 'insert_organization_name_prefix_one' | 'insert_organization_news' | 'insert_organization_news_one' | 'insert_organization_one' | 'insert_organization_region' | 'insert_organization_region_one' | 'insert_organization_settings' | 'insert_organization_settings_one' | 'insert_perspective_campaign' | 'insert_perspective_campaign_one' | 'insert_qa_source' | 'insert_qa_source_one' | 'insert_rms_connectors' | 'insert_rms_connectors_one' | 'insert_rms_forwarded_logs' | 'insert_rms_forwarded_logs_one' | 'insert_rms_org_setups' | 'insert_rms_org_setups_one' | 'insert_system_api_keys' | 'insert_system_api_keys_one' | 'insert_system_call_daily_stats' | 'insert_system_call_daily_stats_one' | 'insert_system_email_daily_stats' | 'insert_system_email_daily_stats_one' | 'insert_system_running_release' | 'insert_system_running_release_one' | 'insert_system_sms_daily_stats' | 'insert_system_sms_daily_stats_one' | 'update_ad_campaign_metrics' | 'update_ad_campaign_metrics_by_pk' | 'update_ad_campaign_metrics_many' | 'update_ad_comment' | 'update_ad_comment_by_pk' | 'update_ad_comment_many' | 'update_ad_creative' | 'update_ad_creative_by_pk' | 'update_ad_creative_feedback' | 'update_ad_creative_feedback_by_pk' | 'update_ad_creative_feedback_many' | 'update_ad_creative_many' | 'update_ad_platform' | 'update_ad_platform_by_pk' | 'update_ad_platform_many' | 'update_ad_providers' | 'update_ad_providers_by_pk' | 'update_ad_providers_many' | 'update_ad_setting' | 'update_ad_setting_by_pk' | 'update_ad_setting_many' | 'update_ad_status' | 'update_ad_status_by_pk' | 'update_ad_status_many' | 'update_anna_ai_call_campaigns' | 'update_anna_ai_call_campaigns_by_pk' | 'update_anna_ai_call_campaigns_many' | 'update_anna_ai_call_states' | 'update_anna_ai_call_states_by_pk' | 'update_anna_ai_call_states_many' | 'update_anna_ai_outbound_calls' | 'update_anna_ai_outbound_calls_by_pk' | 'update_anna_ai_outbound_calls_many' | 'update_answer' | 'update_answer_by_pk' | 'update_answer_many' | 'update_applicant_event' | 'update_applicant_event_by_pk' | 'update_applicant_event_many' | 'update_board_column_type' | 'update_board_column_type_by_pk' | 'update_board_column_type_many' | 'update_board_contact_board' | 'update_board_contact_board_by_pk' | 'update_board_contact_board_column' | 'update_board_contact_board_column_by_pk' | 'update_board_contact_board_column_many' | 'update_board_contact_board_entry' | 'update_board_contact_board_entry_by_pk' | 'update_board_contact_board_entry_many' | 'update_board_contact_board_many' | 'update_board_note' | 'update_board_note_by_pk' | 'update_board_note_many' | 'update_bot_assignee' | 'update_bot_assignee_by_pk' | 'update_bot_assignee_many' | 'update_bot_channel' | 'update_bot_channel_by_pk' | 'update_bot_channel_many' | 'update_bot_conversation' | 'update_bot_conversation_by_pk' | 'update_bot_conversation_many' | 'update_bot_conversation_state' | 'update_bot_conversation_state_by_pk' | 'update_bot_conversation_state_many' | 'update_bot_message' | 'update_bot_message_by_pk' | 'update_bot_message_many' | 'update_bot_message_status' | 'update_bot_message_status_by_pk' | 'update_bot_message_status_many' | 'update_bot_sender' | 'update_bot_sender_by_pk' | 'update_bot_sender_many' | 'update_campaign' | 'update_campaign_ad' | 'update_campaign_ad_by_pk' | 'update_campaign_ad_many' | 'update_campaign_budget' | 'update_campaign_budget_many' | 'update_campaign_budget_transaction' | 'update_campaign_budget_transaction_by_pk' | 'update_campaign_budget_transaction_many' | 'update_campaign_by_pk' | 'update_campaign_email_template_overwrite' | 'update_campaign_email_template_overwrite_by_pk' | 'update_campaign_email_template_overwrite_many' | 'update_campaign_event_log' | 'update_campaign_event_log_by_pk' | 'update_campaign_event_log_many' | 'update_campaign_iso_2_country_codes' | 'update_campaign_iso_2_country_codes_by_pk' | 'update_campaign_iso_2_country_codes_many' | 'update_campaign_job_description' | 'update_campaign_job_description_by_pk' | 'update_campaign_job_description_many' | 'update_campaign_many' | 'update_campaign_order' | 'update_campaign_order_by_pk' | 'update_campaign_order_many' | 'update_campaign_order_source' | 'update_campaign_order_source_by_pk' | 'update_campaign_order_source_many' | 'update_campaign_order_source_type' | 'update_campaign_order_source_type_by_pk' | 'update_campaign_order_source_type_many' | 'update_campaign_routing_destination' | 'update_campaign_routing_destination_by_pk' | 'update_campaign_routing_destination_many' | 'update_campaign_routing_info' | 'update_campaign_routing_info_by_pk' | 'update_campaign_routing_info_many' | 'update_campaign_routing_zipcode' | 'update_campaign_routing_zipcode_by_pk' | 'update_campaign_routing_zipcode_many' | 'update_campaign_settings_override' | 'update_campaign_settings_override_by_pk' | 'update_campaign_settings_override_many' | 'update_campaign_status' | 'update_campaign_status_by_pk' | 'update_campaign_status_event' | 'update_campaign_status_event_by_pk' | 'update_campaign_status_event_many' | 'update_campaign_status_log' | 'update_campaign_status_log_by_pk' | 'update_campaign_status_log_many' | 'update_campaign_status_many' | 'update_campaign_transaction_type' | 'update_campaign_transaction_type_by_pk' | 'update_campaign_transaction_type_many' | 'update_campaign_work_location' | 'update_campaign_work_location_by_pk' | 'update_campaign_work_location_many' | 'update_chat_bot_customers' | 'update_chat_bot_customers_by_pk' | 'update_chat_bot_customers_many' | 'update_chat_bot_forwarding' | 'update_chat_bot_forwarding_by_pk' | 'update_chat_bot_forwarding_many' | 'update_chat_bot_message_type' | 'update_chat_bot_message_type_by_pk' | 'update_chat_bot_message_type_many' | 'update_chat_bot_messages' | 'update_chat_bot_messages_by_pk' | 'update_chat_bot_messages_many' | 'update_contact' | 'update_contact_by_pk' | 'update_contact_logs' | 'update_contact_logs_by_pk' | 'update_contact_logs_many' | 'update_contact_many' | 'update_file_pdf_templates' | 'update_file_pdf_templates_by_pk' | 'update_file_pdf_templates_many' | 'update_file_upload' | 'update_file_upload_by_pk' | 'update_file_upload_many' | 'update_funnel_benefits' | 'update_funnel_benefits_by_pk' | 'update_funnel_benefits_many' | 'update_funnel_chatbot_message' | 'update_funnel_chatbot_message_by_pk' | 'update_funnel_chatbot_message_many' | 'update_funnel_chatbot_session' | 'update_funnel_chatbot_session_by_pk' | 'update_funnel_chatbot_session_many' | 'update_funnel_funnels' | 'update_funnel_funnels_by_pk' | 'update_funnel_funnels_many' | 'update_funnel_insights' | 'update_funnel_insights_many' | 'update_funnel_page_insights' | 'update_funnel_page_insights_by_pk' | 'update_funnel_page_insights_many' | 'update_funnel_question' | 'update_funnel_question_by_pk' | 'update_funnel_question_many' | 'update_funnel_question_option' | 'update_funnel_question_option_by_pk' | 'update_funnel_question_option_many' | 'update_funnel_whatsapp_share_clicks' | 'update_funnel_whatsapp_share_clicks_by_pk' | 'update_funnel_whatsapp_share_clicks_many' | 'update_organization' | 'update_organization_by_pk' | 'update_organization_location' | 'update_organization_location_by_pk' | 'update_organization_location_many' | 'update_organization_many' | 'update_organization_name_prefix' | 'update_organization_name_prefix_by_pk' | 'update_organization_name_prefix_many' | 'update_organization_news' | 'update_organization_news_by_pk' | 'update_organization_news_many' | 'update_organization_region' | 'update_organization_region_by_pk' | 'update_organization_region_many' | 'update_organization_settings' | 'update_organization_settings_by_pk' | 'update_organization_settings_many' | 'update_perspective_campaign' | 'update_perspective_campaign_by_pk' | 'update_perspective_campaign_many' | 'update_qa_source' | 'update_qa_source_by_pk' | 'update_qa_source_many' | 'update_rms_connectors' | 'update_rms_connectors_by_pk' | 'update_rms_connectors_many' | 'update_rms_forwarded_logs' | 'update_rms_forwarded_logs_by_pk' | 'update_rms_forwarded_logs_many' | 'update_rms_org_setups' | 'update_rms_org_setups_by_pk' | 'update_rms_org_setups_many' | 'update_system_api_keys' | 'update_system_api_keys_by_pk' | 'update_system_api_keys_many' | 'update_system_call_daily_stats' | 'update_system_call_daily_stats_by_pk' | 'update_system_call_daily_stats_many' | 'update_system_email_daily_stats' | 'update_system_email_daily_stats_by_pk' | 'update_system_email_daily_stats_many' | 'update_system_running_release' | 'update_system_running_release_by_pk' | 'update_system_running_release_many' | 'update_system_sms_daily_stats' | 'update_system_sms_daily_stats_by_pk' | 'update_system_sms_daily_stats_many' | mutation_rootKeySpecifier)[];
export type mutation_rootFieldPolicy = {
	delete_ad_campaign_metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_campaign_metrics_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_comment?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_comment_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_creative?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_creative_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_creative_feedback?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_creative_feedback_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_platform?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_platform_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_providers?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_providers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_setting?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_setting_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_status?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_ad_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_anna_ai_call_campaigns?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_anna_ai_call_campaigns_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_anna_ai_call_states?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_anna_ai_call_states_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_anna_ai_outbound_calls?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_anna_ai_outbound_calls_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_answer?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_answer_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_applicant_event?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_applicant_event_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_board_column_type?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_board_column_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_board_contact_board?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_board_contact_board_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_board_contact_board_column?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_board_contact_board_column_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_board_contact_board_entry?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_board_contact_board_entry_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_board_note?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_board_note_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_assignee_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_channel?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_channel_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_conversation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_conversation_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_conversation_state?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_conversation_state_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_message?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_message_status?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_message_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_sender?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bot_sender_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_ad?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_ad_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_budget_transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_budget_transaction_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_email_template_overwrite?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_email_template_overwrite_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_event_log?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_event_log_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_iso_2_country_codes?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_iso_2_country_codes_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_job_description?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_job_description_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_order?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_order_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_order_source?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_order_source_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_order_source_type?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_order_source_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_routing_destination?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_routing_destination_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_routing_info?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_routing_info_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_routing_zipcode?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_routing_zipcode_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_settings_override?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_settings_override_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_status?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_status_event?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_status_event_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_status_log?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_status_log_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_transaction_type?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_transaction_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_work_location?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_campaign_work_location_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_chat_bot_customers?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_chat_bot_customers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_chat_bot_forwarding?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_chat_bot_forwarding_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_chat_bot_message_type?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_chat_bot_message_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_chat_bot_messages?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_chat_bot_messages_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_contact?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_contact_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_contact_logs?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_contact_logs_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_file_pdf_templates?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_file_pdf_templates_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_file_upload?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_file_upload_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_benefits?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_benefits_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_chatbot_message?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_chatbot_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_chatbot_session?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_chatbot_session_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_funnels?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_funnels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_page_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_page_insights_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_question?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_question_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_question_option?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_question_option_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_whatsapp_share_clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_funnel_whatsapp_share_clicks_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_location?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_location_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_name_prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_name_prefix_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_news?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_news_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_region?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_region_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_organization_settings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_perspective_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_perspective_campaign_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_qa_source?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_qa_source_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_rms_connectors?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_rms_connectors_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_rms_forwarded_logs?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_rms_forwarded_logs_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_rms_org_setups?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_rms_org_setups_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_system_api_keys?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_system_api_keys_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_system_call_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_system_call_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_system_email_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_system_email_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_system_running_release?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_system_running_release_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_system_sms_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_system_sms_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_campaign_metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_campaign_metrics_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_comment?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_comment_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_creative?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_creative_feedback?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_creative_feedback_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_creative_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_platform?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_platform_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_providers?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_providers_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_setting?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_setting_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_status?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_ad_status_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_anna_ai_call_campaigns?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_anna_ai_call_campaigns_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_anna_ai_call_states?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_anna_ai_call_states_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_anna_ai_outbound_calls?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_anna_ai_outbound_calls_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_answer?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_answer_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_applicant_event?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_applicant_event_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_board_column_type?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_board_column_type_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_board_contact_board?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_board_contact_board_column?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_board_contact_board_column_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_board_contact_board_entry?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_board_contact_board_entry_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_board_contact_board_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_board_note?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_board_note_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_assignee_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_channel?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_channel_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_conversation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_conversation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_conversation_state?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_conversation_state_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_message?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_message_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_message_status?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_message_status_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_sender?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bot_sender_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_ad?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_ad_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_budget_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_budget_transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_budget_transaction_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_email_template_overwrite?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_email_template_overwrite_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_event_log?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_event_log_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_iso_2_country_codes?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_iso_2_country_codes_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_job_description?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_job_description_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_order?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_order_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_order_source?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_order_source_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_order_source_type?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_order_source_type_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_routing_destination?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_routing_destination_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_routing_info?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_routing_info_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_routing_zipcode?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_routing_zipcode_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_settings_override?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_settings_override_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_status?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_status_event?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_status_event_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_status_log?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_status_log_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_status_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_transaction_type?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_transaction_type_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_work_location?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_campaign_work_location_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_chat_bot_customers?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_chat_bot_customers_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_chat_bot_forwarding?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_chat_bot_forwarding_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_chat_bot_message_type?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_chat_bot_message_type_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_chat_bot_messages?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_chat_bot_messages_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_contact?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_contact_logs?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_contact_logs_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_contact_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_file_pdf_templates?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_file_pdf_templates_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_file_upload?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_file_upload_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_benefits?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_benefits_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_chatbot_message?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_chatbot_message_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_chatbot_session?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_chatbot_session_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_funnels?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_funnels_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_insights_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_page_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_page_insights_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_question?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_question_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_question_option?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_question_option_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_whatsapp_share_clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_funnel_whatsapp_share_clicks_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_location?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_location_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_name_prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_name_prefix_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_news?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_news_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_region?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_region_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_organization_settings_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_perspective_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_perspective_campaign_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_qa_source?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_qa_source_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_rms_connectors?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_rms_connectors_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_rms_forwarded_logs?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_rms_forwarded_logs_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_rms_org_setups?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_rms_org_setups_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_system_api_keys?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_system_api_keys_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_system_call_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_system_call_daily_stats_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_system_email_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_system_email_daily_stats_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_system_running_release?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_system_running_release_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_system_sms_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_system_sms_daily_stats_one?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_campaign_metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_campaign_metrics_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_campaign_metrics_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_comment?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_comment_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_comment_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_creative?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_creative_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_creative_feedback?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_creative_feedback_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_creative_feedback_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_creative_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_platform?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_platform_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_platform_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_providers?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_providers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_providers_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_setting?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_setting_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_setting_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_status?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_ad_status_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_anna_ai_call_campaigns?: FieldPolicy<any> | FieldReadFunction<any>,
	update_anna_ai_call_campaigns_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_anna_ai_call_campaigns_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_anna_ai_call_states?: FieldPolicy<any> | FieldReadFunction<any>,
	update_anna_ai_call_states_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_anna_ai_call_states_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_anna_ai_outbound_calls?: FieldPolicy<any> | FieldReadFunction<any>,
	update_anna_ai_outbound_calls_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_anna_ai_outbound_calls_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_answer?: FieldPolicy<any> | FieldReadFunction<any>,
	update_answer_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_answer_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_applicant_event?: FieldPolicy<any> | FieldReadFunction<any>,
	update_applicant_event_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_applicant_event_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_column_type?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_column_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_column_type_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_contact_board?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_contact_board_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_contact_board_column?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_contact_board_column_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_contact_board_column_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_contact_board_entry?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_contact_board_entry_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_contact_board_entry_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_contact_board_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_note?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_note_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_board_note_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_assignee_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_assignee_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_channel?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_channel_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_channel_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_conversation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_conversation_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_conversation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_conversation_state?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_conversation_state_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_conversation_state_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_message?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_message_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_message_status?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_message_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_message_status_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_sender?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_sender_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bot_sender_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_ad?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_ad_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_ad_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_budget_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_budget_transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_budget_transaction_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_budget_transaction_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_email_template_overwrite?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_email_template_overwrite_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_email_template_overwrite_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_event_log?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_event_log_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_event_log_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_iso_2_country_codes?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_iso_2_country_codes_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_iso_2_country_codes_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_job_description?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_job_description_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_job_description_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_order?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_order_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_order_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_order_source?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_order_source_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_order_source_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_order_source_type?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_order_source_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_order_source_type_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_routing_destination?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_routing_destination_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_routing_destination_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_routing_info?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_routing_info_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_routing_info_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_routing_zipcode?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_routing_zipcode_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_routing_zipcode_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_settings_override?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_settings_override_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_settings_override_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_status?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_status_event?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_status_event_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_status_event_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_status_log?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_status_log_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_status_log_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_status_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_transaction_type?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_transaction_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_transaction_type_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_work_location?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_work_location_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_campaign_work_location_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_customers?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_customers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_customers_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_forwarding?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_forwarding_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_forwarding_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_message_type?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_message_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_message_type_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_messages?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_messages_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_chat_bot_messages_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_contact?: FieldPolicy<any> | FieldReadFunction<any>,
	update_contact_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_contact_logs?: FieldPolicy<any> | FieldReadFunction<any>,
	update_contact_logs_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_contact_logs_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_contact_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_file_pdf_templates?: FieldPolicy<any> | FieldReadFunction<any>,
	update_file_pdf_templates_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_file_pdf_templates_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_file_upload?: FieldPolicy<any> | FieldReadFunction<any>,
	update_file_upload_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_file_upload_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_benefits?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_benefits_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_benefits_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_chatbot_message?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_chatbot_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_chatbot_message_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_chatbot_session?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_chatbot_session_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_chatbot_session_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_funnels?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_funnels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_funnels_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_insights_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_page_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_page_insights_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_page_insights_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_question?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_question_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_question_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_question_option?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_question_option_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_question_option_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_whatsapp_share_clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_whatsapp_share_clicks_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_funnel_whatsapp_share_clicks_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_location?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_location_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_location_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_name_prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_name_prefix_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_name_prefix_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_news?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_news_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_news_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_region?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_region_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_region_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_settings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_organization_settings_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_perspective_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	update_perspective_campaign_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_perspective_campaign_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_qa_source?: FieldPolicy<any> | FieldReadFunction<any>,
	update_qa_source_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_qa_source_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_rms_connectors?: FieldPolicy<any> | FieldReadFunction<any>,
	update_rms_connectors_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_rms_connectors_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_rms_forwarded_logs?: FieldPolicy<any> | FieldReadFunction<any>,
	update_rms_forwarded_logs_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_rms_forwarded_logs_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_rms_org_setups?: FieldPolicy<any> | FieldReadFunction<any>,
	update_rms_org_setups_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_rms_org_setups_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_api_keys?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_api_keys_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_api_keys_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_call_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_call_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_call_daily_stats_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_email_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_email_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_email_daily_stats_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_running_release?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_running_release_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_running_release_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_sms_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_sms_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_system_sms_daily_stats_many?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_dayKeySpecifier = ('campaign' | 'campaign_id' | 'date' | 'new_contacts' | 'utm_source' | new_contacts_per_dayKeySpecifier)[];
export type new_contacts_per_dayFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	utm_source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_aggregateKeySpecifier = ('aggregate' | 'nodes' | new_contacts_per_day_aggregateKeySpecifier)[];
export type new_contacts_per_day_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | new_contacts_per_day_aggregate_fieldsKeySpecifier)[];
export type new_contacts_per_day_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_avg_fieldsKeySpecifier = ('new_contacts' | new_contacts_per_day_avg_fieldsKeySpecifier)[];
export type new_contacts_per_day_avg_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_max_fieldsKeySpecifier = ('campaign_id' | 'date' | 'new_contacts' | 'utm_source' | new_contacts_per_day_max_fieldsKeySpecifier)[];
export type new_contacts_per_day_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	utm_source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_min_fieldsKeySpecifier = ('campaign_id' | 'date' | 'new_contacts' | 'utm_source' | new_contacts_per_day_min_fieldsKeySpecifier)[];
export type new_contacts_per_day_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	utm_source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_stddev_fieldsKeySpecifier = ('new_contacts' | new_contacts_per_day_stddev_fieldsKeySpecifier)[];
export type new_contacts_per_day_stddev_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_stddev_pop_fieldsKeySpecifier = ('new_contacts' | new_contacts_per_day_stddev_pop_fieldsKeySpecifier)[];
export type new_contacts_per_day_stddev_pop_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_stddev_samp_fieldsKeySpecifier = ('new_contacts' | new_contacts_per_day_stddev_samp_fieldsKeySpecifier)[];
export type new_contacts_per_day_stddev_samp_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_sum_fieldsKeySpecifier = ('new_contacts' | new_contacts_per_day_sum_fieldsKeySpecifier)[];
export type new_contacts_per_day_sum_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_var_pop_fieldsKeySpecifier = ('new_contacts' | new_contacts_per_day_var_pop_fieldsKeySpecifier)[];
export type new_contacts_per_day_var_pop_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_var_samp_fieldsKeySpecifier = ('new_contacts' | new_contacts_per_day_var_samp_fieldsKeySpecifier)[];
export type new_contacts_per_day_var_samp_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_contacts_per_day_variance_fieldsKeySpecifier = ('new_contacts' | new_contacts_per_day_variance_fieldsKeySpecifier)[];
export type new_contacts_per_day_variance_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_dayKeySpecifier = ('campaign' | 'campaign_id' | 'date' | 'new_unqualified_contacts' | 'utm_source' | new_unqualified_contacts_per_dayKeySpecifier)[];
export type new_unqualified_contacts_per_dayFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	utm_source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_aggregateKeySpecifier = ('aggregate' | 'nodes' | new_unqualified_contacts_per_day_aggregateKeySpecifier)[];
export type new_unqualified_contacts_per_day_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | new_unqualified_contacts_per_day_aggregate_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_avg_fieldsKeySpecifier = ('new_unqualified_contacts' | new_unqualified_contacts_per_day_avg_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_avg_fieldsFieldPolicy = {
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_max_fieldsKeySpecifier = ('campaign_id' | 'date' | 'new_unqualified_contacts' | 'utm_source' | new_unqualified_contacts_per_day_max_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	utm_source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_min_fieldsKeySpecifier = ('campaign_id' | 'date' | 'new_unqualified_contacts' | 'utm_source' | new_unqualified_contacts_per_day_min_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	utm_source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_stddev_fieldsKeySpecifier = ('new_unqualified_contacts' | new_unqualified_contacts_per_day_stddev_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_stddev_fieldsFieldPolicy = {
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_stddev_pop_fieldsKeySpecifier = ('new_unqualified_contacts' | new_unqualified_contacts_per_day_stddev_pop_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_stddev_pop_fieldsFieldPolicy = {
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_stddev_samp_fieldsKeySpecifier = ('new_unqualified_contacts' | new_unqualified_contacts_per_day_stddev_samp_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_stddev_samp_fieldsFieldPolicy = {
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_sum_fieldsKeySpecifier = ('new_unqualified_contacts' | new_unqualified_contacts_per_day_sum_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_sum_fieldsFieldPolicy = {
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_var_pop_fieldsKeySpecifier = ('new_unqualified_contacts' | new_unqualified_contacts_per_day_var_pop_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_var_pop_fieldsFieldPolicy = {
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_var_samp_fieldsKeySpecifier = ('new_unqualified_contacts' | new_unqualified_contacts_per_day_var_samp_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_var_samp_fieldsFieldPolicy = {
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type new_unqualified_contacts_per_day_variance_fieldsKeySpecifier = ('new_unqualified_contacts' | new_unqualified_contacts_per_day_variance_fieldsKeySpecifier)[];
export type new_unqualified_contacts_per_day_variance_fieldsFieldPolicy = {
	new_unqualified_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organizationKeySpecifier = ('active' | 'budget' | 'campaigns' | 'campaigns_aggregate' | 'color' | 'country_code' | 'id' | 'is_partner' | 'is_test' | 'logo_url' | 'name' | 'name_prefix' | 'partner_organization' | 'partner_organization_id' | 'regions' | 'regions_aggregate' | 'rms_org_setup' | 'settings' | 'short_name' | 'sub_organizations' | 'sub_organizations_aggregate' | organizationKeySpecifier)[];
export type organizationFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	campaigns?: FieldPolicy<any> | FieldReadFunction<any>,
	campaigns_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	country_code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_partner?: FieldPolicy<any> | FieldReadFunction<any>,
	is_test?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_url?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	name_prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	partner_organization?: FieldPolicy<any> | FieldReadFunction<any>,
	partner_organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	regions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_org_setup?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	short_name?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_organizations?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_organizations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_aggregateKeySpecifier = ('aggregate' | 'nodes' | organization_aggregateKeySpecifier)[];
export type organization_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | organization_aggregate_fieldsKeySpecifier)[];
export type organization_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budgetKeySpecifier = ('bonus' | 'media_budget' | 'organization_id' | 'spend' | 'total_budget' | organization_budgetKeySpecifier)[];
export type organization_budgetFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_aggregateKeySpecifier = ('aggregate' | 'nodes' | organization_budget_aggregateKeySpecifier)[];
export type organization_budget_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | organization_budget_aggregate_fieldsKeySpecifier)[];
export type organization_budget_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_avg_fieldsKeySpecifier = ('bonus' | 'media_budget' | 'spend' | 'total_budget' | organization_budget_avg_fieldsKeySpecifier)[];
export type organization_budget_avg_fieldsFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_max_fieldsKeySpecifier = ('bonus' | 'media_budget' | 'organization_id' | 'spend' | 'total_budget' | organization_budget_max_fieldsKeySpecifier)[];
export type organization_budget_max_fieldsFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_min_fieldsKeySpecifier = ('bonus' | 'media_budget' | 'organization_id' | 'spend' | 'total_budget' | organization_budget_min_fieldsKeySpecifier)[];
export type organization_budget_min_fieldsFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_stddev_fieldsKeySpecifier = ('bonus' | 'media_budget' | 'spend' | 'total_budget' | organization_budget_stddev_fieldsKeySpecifier)[];
export type organization_budget_stddev_fieldsFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_stddev_pop_fieldsKeySpecifier = ('bonus' | 'media_budget' | 'spend' | 'total_budget' | organization_budget_stddev_pop_fieldsKeySpecifier)[];
export type organization_budget_stddev_pop_fieldsFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_stddev_samp_fieldsKeySpecifier = ('bonus' | 'media_budget' | 'spend' | 'total_budget' | organization_budget_stddev_samp_fieldsKeySpecifier)[];
export type organization_budget_stddev_samp_fieldsFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_sum_fieldsKeySpecifier = ('bonus' | 'media_budget' | 'spend' | 'total_budget' | organization_budget_sum_fieldsKeySpecifier)[];
export type organization_budget_sum_fieldsFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_var_pop_fieldsKeySpecifier = ('bonus' | 'media_budget' | 'spend' | 'total_budget' | organization_budget_var_pop_fieldsKeySpecifier)[];
export type organization_budget_var_pop_fieldsFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_var_samp_fieldsKeySpecifier = ('bonus' | 'media_budget' | 'spend' | 'total_budget' | organization_budget_var_samp_fieldsKeySpecifier)[];
export type organization_budget_var_samp_fieldsFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_budget_variance_fieldsKeySpecifier = ('bonus' | 'media_budget' | 'spend' | 'total_budget' | organization_budget_variance_fieldsKeySpecifier)[];
export type organization_budget_variance_fieldsFieldPolicy = {
	bonus?: FieldPolicy<any> | FieldReadFunction<any>,
	media_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	total_budget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_dayKeySpecifier = ('date' | 'new_contacts' | 'organization' | 'organization_id' | organization_contacts_per_dayKeySpecifier)[];
export type organization_contacts_per_dayFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_aggregateKeySpecifier = ('aggregate' | 'nodes' | organization_contacts_per_day_aggregateKeySpecifier)[];
export type organization_contacts_per_day_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | organization_contacts_per_day_aggregate_fieldsKeySpecifier)[];
export type organization_contacts_per_day_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_avg_fieldsKeySpecifier = ('new_contacts' | organization_contacts_per_day_avg_fieldsKeySpecifier)[];
export type organization_contacts_per_day_avg_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_max_fieldsKeySpecifier = ('date' | 'new_contacts' | 'organization_id' | organization_contacts_per_day_max_fieldsKeySpecifier)[];
export type organization_contacts_per_day_max_fieldsFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_min_fieldsKeySpecifier = ('date' | 'new_contacts' | 'organization_id' | organization_contacts_per_day_min_fieldsKeySpecifier)[];
export type organization_contacts_per_day_min_fieldsFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_stddev_fieldsKeySpecifier = ('new_contacts' | organization_contacts_per_day_stddev_fieldsKeySpecifier)[];
export type organization_contacts_per_day_stddev_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_stddev_pop_fieldsKeySpecifier = ('new_contacts' | organization_contacts_per_day_stddev_pop_fieldsKeySpecifier)[];
export type organization_contacts_per_day_stddev_pop_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_stddev_samp_fieldsKeySpecifier = ('new_contacts' | organization_contacts_per_day_stddev_samp_fieldsKeySpecifier)[];
export type organization_contacts_per_day_stddev_samp_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_sum_fieldsKeySpecifier = ('new_contacts' | organization_contacts_per_day_sum_fieldsKeySpecifier)[];
export type organization_contacts_per_day_sum_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_var_pop_fieldsKeySpecifier = ('new_contacts' | organization_contacts_per_day_var_pop_fieldsKeySpecifier)[];
export type organization_contacts_per_day_var_pop_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_var_samp_fieldsKeySpecifier = ('new_contacts' | organization_contacts_per_day_var_samp_fieldsKeySpecifier)[];
export type organization_contacts_per_day_var_samp_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_contacts_per_day_variance_fieldsKeySpecifier = ('new_contacts' | organization_contacts_per_day_variance_fieldsKeySpecifier)[];
export type organization_contacts_per_day_variance_fieldsFieldPolicy = {
	new_contacts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_locationKeySpecifier = ('campaigns' | 'campaigns_aggregate' | 'name' | 'organization' | 'organization_id' | 'parent_region' | 'region_slug' | 'slug' | organization_locationKeySpecifier)[];
export type organization_locationFieldPolicy = {
	campaigns?: FieldPolicy<any> | FieldReadFunction<any>,
	campaigns_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_region?: FieldPolicy<any> | FieldReadFunction<any>,
	region_slug?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_location_aggregateKeySpecifier = ('aggregate' | 'nodes' | organization_location_aggregateKeySpecifier)[];
export type organization_location_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_location_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | organization_location_aggregate_fieldsKeySpecifier)[];
export type organization_location_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_location_max_fieldsKeySpecifier = ('name' | 'organization_id' | 'region_slug' | 'slug' | organization_location_max_fieldsKeySpecifier)[];
export type organization_location_max_fieldsFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	region_slug?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_location_min_fieldsKeySpecifier = ('name' | 'organization_id' | 'region_slug' | 'slug' | organization_location_min_fieldsKeySpecifier)[];
export type organization_location_min_fieldsFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	region_slug?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_location_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | organization_location_mutation_responseKeySpecifier)[];
export type organization_location_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_max_fieldsKeySpecifier = ('color' | 'country_code' | 'id' | 'logo_url' | 'name' | 'partner_organization_id' | 'short_name' | organization_max_fieldsKeySpecifier)[];
export type organization_max_fieldsFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	country_code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_url?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	partner_organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	short_name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_min_fieldsKeySpecifier = ('color' | 'country_code' | 'id' | 'logo_url' | 'name' | 'partner_organization_id' | 'short_name' | organization_min_fieldsKeySpecifier)[];
export type organization_min_fieldsFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	country_code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_url?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	partner_organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	short_name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | organization_mutation_responseKeySpecifier)[];
export type organization_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_name_prefixKeySpecifier = ('value' | organization_name_prefixKeySpecifier)[];
export type organization_name_prefixFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_name_prefix_aggregateKeySpecifier = ('aggregate' | 'nodes' | organization_name_prefix_aggregateKeySpecifier)[];
export type organization_name_prefix_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_name_prefix_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | organization_name_prefix_aggregate_fieldsKeySpecifier)[];
export type organization_name_prefix_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_name_prefix_max_fieldsKeySpecifier = ('value' | organization_name_prefix_max_fieldsKeySpecifier)[];
export type organization_name_prefix_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_name_prefix_min_fieldsKeySpecifier = ('value' | organization_name_prefix_min_fieldsKeySpecifier)[];
export type organization_name_prefix_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_name_prefix_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | organization_name_prefix_mutation_responseKeySpecifier)[];
export type organization_name_prefix_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_newsKeySpecifier = ('description' | 'id' | 'organization' | 'organization_id' | 'show_after' | 'show_until' | organization_newsKeySpecifier)[];
export type organization_newsFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	show_after?: FieldPolicy<any> | FieldReadFunction<any>,
	show_until?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_news_aggregateKeySpecifier = ('aggregate' | 'nodes' | organization_news_aggregateKeySpecifier)[];
export type organization_news_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_news_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | organization_news_aggregate_fieldsKeySpecifier)[];
export type organization_news_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_news_max_fieldsKeySpecifier = ('description' | 'id' | 'organization_id' | 'show_after' | 'show_until' | organization_news_max_fieldsKeySpecifier)[];
export type organization_news_max_fieldsFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	show_after?: FieldPolicy<any> | FieldReadFunction<any>,
	show_until?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_news_min_fieldsKeySpecifier = ('description' | 'id' | 'organization_id' | 'show_after' | 'show_until' | organization_news_min_fieldsKeySpecifier)[];
export type organization_news_min_fieldsFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	show_after?: FieldPolicy<any> | FieldReadFunction<any>,
	show_until?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_news_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | organization_news_mutation_responseKeySpecifier)[];
export type organization_news_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_regionKeySpecifier = ('locations' | 'locations_aggregate' | 'name' | 'organization' | 'organization_id' | 'slug' | organization_regionKeySpecifier)[];
export type organization_regionFieldPolicy = {
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_region_aggregateKeySpecifier = ('aggregate' | 'nodes' | organization_region_aggregateKeySpecifier)[];
export type organization_region_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_region_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | organization_region_aggregate_fieldsKeySpecifier)[];
export type organization_region_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_region_max_fieldsKeySpecifier = ('name' | 'organization_id' | 'slug' | organization_region_max_fieldsKeySpecifier)[];
export type organization_region_max_fieldsFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_region_min_fieldsKeySpecifier = ('name' | 'organization_id' | 'slug' | organization_region_min_fieldsKeySpecifier)[];
export type organization_region_min_fieldsFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_region_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | organization_region_mutation_responseKeySpecifier)[];
export type organization_region_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_settingsKeySpecifier = ('address_formally' | 'notification_emails_enabled' | 'organization' | 'organization_id' | 'rejection_emails_enabled' | 'welcome_emails_enabled' | organization_settingsKeySpecifier)[];
export type organization_settingsFieldPolicy = {
	address_formally?: FieldPolicy<any> | FieldReadFunction<any>,
	notification_emails_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	rejection_emails_enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	welcome_emails_enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_settings_aggregateKeySpecifier = ('aggregate' | 'nodes' | organization_settings_aggregateKeySpecifier)[];
export type organization_settings_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_settings_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | organization_settings_aggregate_fieldsKeySpecifier)[];
export type organization_settings_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_settings_max_fieldsKeySpecifier = ('organization_id' | organization_settings_max_fieldsKeySpecifier)[];
export type organization_settings_max_fieldsFieldPolicy = {
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_settings_min_fieldsKeySpecifier = ('organization_id' | organization_settings_min_fieldsKeySpecifier)[];
export type organization_settings_min_fieldsFieldPolicy = {
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type organization_settings_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | organization_settings_mutation_responseKeySpecifier)[];
export type organization_settings_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type perspective_campaignKeySpecifier = ('campaign' | 'id' | 'name' | 'url' | perspective_campaignKeySpecifier)[];
export type perspective_campaignFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type perspective_campaign_aggregateKeySpecifier = ('aggregate' | 'nodes' | perspective_campaign_aggregateKeySpecifier)[];
export type perspective_campaign_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type perspective_campaign_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | perspective_campaign_aggregate_fieldsKeySpecifier)[];
export type perspective_campaign_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type perspective_campaign_max_fieldsKeySpecifier = ('id' | 'name' | 'url' | perspective_campaign_max_fieldsKeySpecifier)[];
export type perspective_campaign_max_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type perspective_campaign_min_fieldsKeySpecifier = ('id' | 'name' | 'url' | perspective_campaign_min_fieldsKeySpecifier)[];
export type perspective_campaign_min_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type perspective_campaign_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | perspective_campaign_mutation_responseKeySpecifier)[];
export type perspective_campaign_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type qa_sourceKeySpecifier = ('comment' | 'value' | qa_sourceKeySpecifier)[];
export type qa_sourceFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type qa_source_aggregateKeySpecifier = ('aggregate' | 'nodes' | qa_source_aggregateKeySpecifier)[];
export type qa_source_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type qa_source_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | qa_source_aggregate_fieldsKeySpecifier)[];
export type qa_source_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type qa_source_max_fieldsKeySpecifier = ('comment' | 'value' | qa_source_max_fieldsKeySpecifier)[];
export type qa_source_max_fieldsFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type qa_source_min_fieldsKeySpecifier = ('comment' | 'value' | qa_source_min_fieldsKeySpecifier)[];
export type qa_source_min_fieldsFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type qa_source_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | qa_source_mutation_responseKeySpecifier)[];
export type qa_source_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type query_rootKeySpecifier = ('ad_campaign_metrics' | 'ad_campaign_metrics_aggregate' | 'ad_campaign_metrics_by_pk' | 'ad_comment' | 'ad_comment_aggregate' | 'ad_comment_by_pk' | 'ad_creative' | 'ad_creative_aggregate' | 'ad_creative_by_pk' | 'ad_creative_feedback' | 'ad_creative_feedback_aggregate' | 'ad_creative_feedback_by_pk' | 'ad_platform' | 'ad_platform_aggregate' | 'ad_platform_by_pk' | 'ad_providers' | 'ad_providers_aggregate' | 'ad_providers_by_pk' | 'ad_setting' | 'ad_setting_aggregate' | 'ad_setting_by_pk' | 'ad_status' | 'ad_status_aggregate' | 'ad_status_by_pk' | 'anna_ai_call_campaigns' | 'anna_ai_call_campaigns_aggregate' | 'anna_ai_call_campaigns_by_pk' | 'anna_ai_call_states' | 'anna_ai_call_states_aggregate' | 'anna_ai_call_states_by_pk' | 'anna_ai_outbound_calls' | 'anna_ai_outbound_calls_aggregate' | 'anna_ai_outbound_calls_by_pk' | 'answer' | 'answer_aggregate' | 'answer_by_pk' | 'applicant_event' | 'applicant_event_aggregate' | 'applicant_event_by_pk' | 'board_column_type' | 'board_column_type_aggregate' | 'board_column_type_by_pk' | 'board_contact_board' | 'board_contact_board_aggregate' | 'board_contact_board_by_pk' | 'board_contact_board_column' | 'board_contact_board_column_aggregate' | 'board_contact_board_column_by_pk' | 'board_contact_board_entry' | 'board_contact_board_entry_aggregate' | 'board_contact_board_entry_by_pk' | 'board_note' | 'board_note_aggregate' | 'board_note_by_pk' | 'bot_assignee' | 'bot_assignee_aggregate' | 'bot_assignee_by_pk' | 'bot_channel' | 'bot_channel_aggregate' | 'bot_channel_by_pk' | 'bot_conversation' | 'bot_conversation_aggregate' | 'bot_conversation_by_pk' | 'bot_conversation_state' | 'bot_conversation_state_aggregate' | 'bot_conversation_state_by_pk' | 'bot_message' | 'bot_message_aggregate' | 'bot_message_by_pk' | 'bot_message_status' | 'bot_message_status_aggregate' | 'bot_message_status_by_pk' | 'bot_sender' | 'bot_sender_aggregate' | 'bot_sender_by_pk' | 'campaign' | 'campaign_ad' | 'campaign_ad_aggregate' | 'campaign_ad_by_pk' | 'campaign_aggregate' | 'campaign_budget' | 'campaign_budget_aggregate' | 'campaign_budget_transaction' | 'campaign_budget_transaction_aggregate' | 'campaign_budget_transaction_by_pk' | 'campaign_by_pk' | 'campaign_email_template_overwrite' | 'campaign_email_template_overwrite_aggregate' | 'campaign_email_template_overwrite_by_pk' | 'campaign_event_log' | 'campaign_event_log_aggregate' | 'campaign_event_log_by_pk' | 'campaign_get_daily_budget' | 'campaign_get_daily_budget_aggregate' | 'campaign_iso_2_country_codes' | 'campaign_iso_2_country_codes_aggregate' | 'campaign_iso_2_country_codes_by_pk' | 'campaign_job_description' | 'campaign_job_description_aggregate' | 'campaign_job_description_by_pk' | 'campaign_order' | 'campaign_order_aggregate' | 'campaign_order_by_pk' | 'campaign_order_source' | 'campaign_order_source_aggregate' | 'campaign_order_source_by_pk' | 'campaign_order_source_type' | 'campaign_order_source_type_aggregate' | 'campaign_order_source_type_by_pk' | 'campaign_routing_destination' | 'campaign_routing_destination_aggregate' | 'campaign_routing_destination_by_pk' | 'campaign_routing_info' | 'campaign_routing_info_aggregate' | 'campaign_routing_info_by_pk' | 'campaign_routing_zipcode' | 'campaign_routing_zipcode_aggregate' | 'campaign_routing_zipcode_by_pk' | 'campaign_settings_override' | 'campaign_settings_override_aggregate' | 'campaign_settings_override_by_pk' | 'campaign_status' | 'campaign_status_aggregate' | 'campaign_status_by_pk' | 'campaign_status_event' | 'campaign_status_event_aggregate' | 'campaign_status_event_by_pk' | 'campaign_status_log' | 'campaign_status_log_aggregate' | 'campaign_status_log_by_pk' | 'campaign_transaction_type' | 'campaign_transaction_type_aggregate' | 'campaign_transaction_type_by_pk' | 'campaign_work_location' | 'campaign_work_location_aggregate' | 'campaign_work_location_by_pk' | 'chat_bot_customers' | 'chat_bot_customers_aggregate' | 'chat_bot_customers_by_pk' | 'chat_bot_forwarding' | 'chat_bot_forwarding_aggregate' | 'chat_bot_forwarding_by_pk' | 'chat_bot_message_type' | 'chat_bot_message_type_aggregate' | 'chat_bot_message_type_by_pk' | 'chat_bot_messages' | 'chat_bot_messages_aggregate' | 'chat_bot_messages_by_pk' | 'contact' | 'contact_aggregate' | 'contact_by_pk' | 'contact_logs' | 'contact_logs_aggregate' | 'contact_logs_by_pk' | 'file_pdf_templates' | 'file_pdf_templates_aggregate' | 'file_pdf_templates_by_pk' | 'file_upload' | 'file_upload_aggregate' | 'file_upload_by_pk' | 'funnel_benefits' | 'funnel_benefits_aggregate' | 'funnel_benefits_by_pk' | 'funnel_chatbot_message' | 'funnel_chatbot_message_aggregate' | 'funnel_chatbot_message_by_pk' | 'funnel_chatbot_session' | 'funnel_chatbot_session_aggregate' | 'funnel_chatbot_session_by_pk' | 'funnel_funnels' | 'funnel_funnels_aggregate' | 'funnel_funnels_by_pk' | 'funnel_insights' | 'funnel_insights_aggregate' | 'funnel_page_insights' | 'funnel_page_insights_aggregate' | 'funnel_page_insights_by_pk' | 'funnel_question' | 'funnel_question_aggregate' | 'funnel_question_by_pk' | 'funnel_question_option' | 'funnel_question_option_aggregate' | 'funnel_question_option_by_pk' | 'funnel_whatsapp_share_clicks' | 'funnel_whatsapp_share_clicks_aggregate' | 'funnel_whatsapp_share_clicks_by_pk' | 'huk_contacts' | 'huk_contacts_aggregate' | 'new_contacts_per_day' | 'new_contacts_per_day_aggregate' | 'new_unqualified_contacts_per_day' | 'new_unqualified_contacts_per_day_aggregate' | 'organization' | 'organization_aggregate' | 'organization_budget' | 'organization_budget_aggregate' | 'organization_by_pk' | 'organization_contacts_per_day' | 'organization_contacts_per_day_aggregate' | 'organization_location' | 'organization_location_aggregate' | 'organization_location_by_pk' | 'organization_name_prefix' | 'organization_name_prefix_aggregate' | 'organization_name_prefix_by_pk' | 'organization_news' | 'organization_news_aggregate' | 'organization_news_by_pk' | 'organization_region' | 'organization_region_aggregate' | 'organization_region_by_pk' | 'organization_settings' | 'organization_settings_aggregate' | 'organization_settings_by_pk' | 'perspective_campaign' | 'perspective_campaign_aggregate' | 'perspective_campaign_by_pk' | 'qa_source' | 'qa_source_aggregate' | 'qa_source_by_pk' | 'rms_connectors' | 'rms_connectors_aggregate' | 'rms_connectors_by_pk' | 'rms_forwarded_logs' | 'rms_forwarded_logs_aggregate' | 'rms_forwarded_logs_by_pk' | 'rms_org_setups' | 'rms_org_setups_aggregate' | 'rms_org_setups_by_pk' | 'system_api_keys' | 'system_api_keys_aggregate' | 'system_api_keys_by_pk' | 'system_call_daily_stats' | 'system_call_daily_stats_aggregate' | 'system_call_daily_stats_by_pk' | 'system_email_daily_stats' | 'system_email_daily_stats_aggregate' | 'system_email_daily_stats_by_pk' | 'system_running_release' | 'system_running_release_aggregate' | 'system_running_release_by_pk' | 'system_sms_daily_stats' | 'system_sms_daily_stats_aggregate' | 'system_sms_daily_stats_by_pk' | query_rootKeySpecifier)[];
export type query_rootFieldPolicy = {
	ad_campaign_metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_campaign_metrics_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_campaign_metrics_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_comment?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_comment_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_comment_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_feedback?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_feedback_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_feedback_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_platform?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_platform_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_platform_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_providers?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_providers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_providers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_setting?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_setting_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_setting_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_status?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_status_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_campaigns?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_campaigns_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_campaigns_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_states?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_states_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_states_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_outbound_calls?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_outbound_calls_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_outbound_calls_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	answer_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	answer_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	applicant_event?: FieldPolicy<any> | FieldReadFunction<any>,
	applicant_event_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	applicant_event_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	board_column_type?: FieldPolicy<any> | FieldReadFunction<any>,
	board_column_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	board_column_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_column?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_column_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_column_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_entry?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_entry_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_entry_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	board_note?: FieldPolicy<any> | FieldReadFunction<any>,
	board_note_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	board_note_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_assignee_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_assignee_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_channel?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_channel_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_channel_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_state?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_state_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_state_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_status?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_status_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_sender?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_sender_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_sender_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_ad?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_ad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_ad_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget_transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget_transaction_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget_transaction_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_email_template_overwrite?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_email_template_overwrite_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_email_template_overwrite_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_event_log?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_event_log_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_event_log_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_get_daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_get_daily_budget_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_iso_2_country_codes?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_iso_2_country_codes_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_iso_2_country_codes_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_job_description?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_job_description_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_job_description_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_type?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_destination?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_destination_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_destination_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_info?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_info_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_info_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_zipcode?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_zipcode_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_zipcode_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_settings_override?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_settings_override_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_settings_override_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_event?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_event_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_event_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_log?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_log_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_log_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_transaction_type?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_transaction_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_transaction_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_work_location?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_work_location_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_work_location_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_customers?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_customers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_customers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_forwarding?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_forwarding_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_forwarding_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_message_type?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_message_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_message_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_messages?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_messages_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_messages_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_logs?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_logs_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_logs_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	file_pdf_templates?: FieldPolicy<any> | FieldReadFunction<any>,
	file_pdf_templates_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file_pdf_templates_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	file_upload?: FieldPolicy<any> | FieldReadFunction<any>,
	file_upload_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file_upload_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_benefits?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_benefits_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_benefits_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_message?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_message_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_session?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_session_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_session_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_funnels?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_funnels_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_funnels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_insights_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_page_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_page_insights_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_page_insights_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_option?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_option_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_option_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_whatsapp_share_clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_whatsapp_share_clicks_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_whatsapp_share_clicks_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	huk_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	huk_contacts_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts_per_day?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts_per_day_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	new_unqualified_contacts_per_day?: FieldPolicy<any> | FieldReadFunction<any>,
	new_unqualified_contacts_per_day_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_budget_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_contacts_per_day?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_contacts_per_day_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_location?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_location_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_location_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_name_prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_name_prefix_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_name_prefix_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_news?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_news_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_news_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_region?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_region_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_settings_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_settings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	qa_source?: FieldPolicy<any> | FieldReadFunction<any>,
	qa_source_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	qa_source_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_connectors?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_connectors_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_connectors_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_forwarded_logs?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_forwarded_logs_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_forwarded_logs_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_org_setups?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_org_setups_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_org_setups_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	system_api_keys?: FieldPolicy<any> | FieldReadFunction<any>,
	system_api_keys_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	system_api_keys_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	system_call_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	system_call_daily_stats_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	system_call_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	system_email_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	system_email_daily_stats_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	system_email_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	system_running_release?: FieldPolicy<any> | FieldReadFunction<any>,
	system_running_release_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	system_running_release_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	system_sms_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	system_sms_daily_stats_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	system_sms_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_connectorsKeySpecifier = ('campaign' | 'campaign_id' | 'custom_mappings' | 'enabled' | 'id' | 'job_id' | 'webhook' | rms_connectorsKeySpecifier)[];
export type rms_connectorsFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	custom_mappings?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	job_id?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_connectors_aggregateKeySpecifier = ('aggregate' | 'nodes' | rms_connectors_aggregateKeySpecifier)[];
export type rms_connectors_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_connectors_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | rms_connectors_aggregate_fieldsKeySpecifier)[];
export type rms_connectors_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_connectors_max_fieldsKeySpecifier = ('campaign_id' | 'id' | 'job_id' | 'webhook' | rms_connectors_max_fieldsKeySpecifier)[];
export type rms_connectors_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	job_id?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_connectors_min_fieldsKeySpecifier = ('campaign_id' | 'id' | 'job_id' | 'webhook' | rms_connectors_min_fieldsKeySpecifier)[];
export type rms_connectors_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	job_id?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_connectors_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | rms_connectors_mutation_responseKeySpecifier)[];
export type rms_connectors_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_forwarded_logsKeySpecifier = ('campaign' | 'campaign_id' | 'connector' | 'connector_id' | 'contact' | 'contact_id' | 'created_at' | 'id' | 'result_json' | 'rms_type' | 'success' | rms_forwarded_logsKeySpecifier)[];
export type rms_forwarded_logsFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	connector?: FieldPolicy<any> | FieldReadFunction<any>,
	connector_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	result_json?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_type?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_forwarded_logs_aggregateKeySpecifier = ('aggregate' | 'nodes' | rms_forwarded_logs_aggregateKeySpecifier)[];
export type rms_forwarded_logs_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_forwarded_logs_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | rms_forwarded_logs_aggregate_fieldsKeySpecifier)[];
export type rms_forwarded_logs_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_forwarded_logs_max_fieldsKeySpecifier = ('campaign_id' | 'connector_id' | 'contact_id' | 'created_at' | 'id' | 'rms_type' | rms_forwarded_logs_max_fieldsKeySpecifier)[];
export type rms_forwarded_logs_max_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	connector_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_forwarded_logs_min_fieldsKeySpecifier = ('campaign_id' | 'connector_id' | 'contact_id' | 'created_at' | 'id' | 'rms_type' | rms_forwarded_logs_min_fieldsKeySpecifier)[];
export type rms_forwarded_logs_min_fieldsFieldPolicy = {
	campaign_id?: FieldPolicy<any> | FieldReadFunction<any>,
	connector_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_forwarded_logs_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | rms_forwarded_logs_mutation_responseKeySpecifier)[];
export type rms_forwarded_logs_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_org_setupsKeySpecifier = ('credentials' | 'endpoint' | 'id' | 'organization' | 'organization_id' | 'rms_type' | rms_org_setupsKeySpecifier)[];
export type rms_org_setupsFieldPolicy = {
	credentials?: FieldPolicy<any> | FieldReadFunction<any>,
	endpoint?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_org_setups_aggregateKeySpecifier = ('aggregate' | 'nodes' | rms_org_setups_aggregateKeySpecifier)[];
export type rms_org_setups_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_org_setups_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | rms_org_setups_aggregate_fieldsKeySpecifier)[];
export type rms_org_setups_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_org_setups_max_fieldsKeySpecifier = ('endpoint' | 'id' | 'organization_id' | 'rms_type' | rms_org_setups_max_fieldsKeySpecifier)[];
export type rms_org_setups_max_fieldsFieldPolicy = {
	endpoint?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_org_setups_min_fieldsKeySpecifier = ('endpoint' | 'id' | 'organization_id' | 'rms_type' | rms_org_setups_min_fieldsKeySpecifier)[];
export type rms_org_setups_min_fieldsFieldPolicy = {
	endpoint?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_id?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type rms_org_setups_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | rms_org_setups_mutation_responseKeySpecifier)[];
export type rms_org_setups_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type subscription_rootKeySpecifier = ('ad_campaign_metrics' | 'ad_campaign_metrics_aggregate' | 'ad_campaign_metrics_by_pk' | 'ad_campaign_metrics_stream' | 'ad_comment' | 'ad_comment_aggregate' | 'ad_comment_by_pk' | 'ad_comment_stream' | 'ad_creative' | 'ad_creative_aggregate' | 'ad_creative_by_pk' | 'ad_creative_feedback' | 'ad_creative_feedback_aggregate' | 'ad_creative_feedback_by_pk' | 'ad_creative_feedback_stream' | 'ad_creative_stream' | 'ad_platform' | 'ad_platform_aggregate' | 'ad_platform_by_pk' | 'ad_platform_stream' | 'ad_providers' | 'ad_providers_aggregate' | 'ad_providers_by_pk' | 'ad_providers_stream' | 'ad_setting' | 'ad_setting_aggregate' | 'ad_setting_by_pk' | 'ad_setting_stream' | 'ad_status' | 'ad_status_aggregate' | 'ad_status_by_pk' | 'ad_status_stream' | 'anna_ai_call_campaigns' | 'anna_ai_call_campaigns_aggregate' | 'anna_ai_call_campaigns_by_pk' | 'anna_ai_call_campaigns_stream' | 'anna_ai_call_states' | 'anna_ai_call_states_aggregate' | 'anna_ai_call_states_by_pk' | 'anna_ai_call_states_stream' | 'anna_ai_outbound_calls' | 'anna_ai_outbound_calls_aggregate' | 'anna_ai_outbound_calls_by_pk' | 'anna_ai_outbound_calls_stream' | 'answer' | 'answer_aggregate' | 'answer_by_pk' | 'answer_stream' | 'applicant_event' | 'applicant_event_aggregate' | 'applicant_event_by_pk' | 'applicant_event_stream' | 'board_column_type' | 'board_column_type_aggregate' | 'board_column_type_by_pk' | 'board_column_type_stream' | 'board_contact_board' | 'board_contact_board_aggregate' | 'board_contact_board_by_pk' | 'board_contact_board_column' | 'board_contact_board_column_aggregate' | 'board_contact_board_column_by_pk' | 'board_contact_board_column_stream' | 'board_contact_board_entry' | 'board_contact_board_entry_aggregate' | 'board_contact_board_entry_by_pk' | 'board_contact_board_entry_stream' | 'board_contact_board_stream' | 'board_note' | 'board_note_aggregate' | 'board_note_by_pk' | 'board_note_stream' | 'bot_assignee' | 'bot_assignee_aggregate' | 'bot_assignee_by_pk' | 'bot_assignee_stream' | 'bot_channel' | 'bot_channel_aggregate' | 'bot_channel_by_pk' | 'bot_channel_stream' | 'bot_conversation' | 'bot_conversation_aggregate' | 'bot_conversation_by_pk' | 'bot_conversation_state' | 'bot_conversation_state_aggregate' | 'bot_conversation_state_by_pk' | 'bot_conversation_state_stream' | 'bot_conversation_stream' | 'bot_message' | 'bot_message_aggregate' | 'bot_message_by_pk' | 'bot_message_status' | 'bot_message_status_aggregate' | 'bot_message_status_by_pk' | 'bot_message_status_stream' | 'bot_message_stream' | 'bot_sender' | 'bot_sender_aggregate' | 'bot_sender_by_pk' | 'bot_sender_stream' | 'campaign' | 'campaign_ad' | 'campaign_ad_aggregate' | 'campaign_ad_by_pk' | 'campaign_ad_stream' | 'campaign_aggregate' | 'campaign_budget' | 'campaign_budget_aggregate' | 'campaign_budget_stream' | 'campaign_budget_transaction' | 'campaign_budget_transaction_aggregate' | 'campaign_budget_transaction_by_pk' | 'campaign_budget_transaction_stream' | 'campaign_by_pk' | 'campaign_email_template_overwrite' | 'campaign_email_template_overwrite_aggregate' | 'campaign_email_template_overwrite_by_pk' | 'campaign_email_template_overwrite_stream' | 'campaign_event_log' | 'campaign_event_log_aggregate' | 'campaign_event_log_by_pk' | 'campaign_event_log_stream' | 'campaign_get_daily_budget' | 'campaign_get_daily_budget_aggregate' | 'campaign_iso_2_country_codes' | 'campaign_iso_2_country_codes_aggregate' | 'campaign_iso_2_country_codes_by_pk' | 'campaign_iso_2_country_codes_stream' | 'campaign_job_description' | 'campaign_job_description_aggregate' | 'campaign_job_description_by_pk' | 'campaign_job_description_stream' | 'campaign_order' | 'campaign_order_aggregate' | 'campaign_order_by_pk' | 'campaign_order_source' | 'campaign_order_source_aggregate' | 'campaign_order_source_by_pk' | 'campaign_order_source_stream' | 'campaign_order_source_type' | 'campaign_order_source_type_aggregate' | 'campaign_order_source_type_by_pk' | 'campaign_order_source_type_stream' | 'campaign_order_stream' | 'campaign_routing_destination' | 'campaign_routing_destination_aggregate' | 'campaign_routing_destination_by_pk' | 'campaign_routing_destination_stream' | 'campaign_routing_info' | 'campaign_routing_info_aggregate' | 'campaign_routing_info_by_pk' | 'campaign_routing_info_stream' | 'campaign_routing_zipcode' | 'campaign_routing_zipcode_aggregate' | 'campaign_routing_zipcode_by_pk' | 'campaign_routing_zipcode_stream' | 'campaign_settings_override' | 'campaign_settings_override_aggregate' | 'campaign_settings_override_by_pk' | 'campaign_settings_override_stream' | 'campaign_status' | 'campaign_status_aggregate' | 'campaign_status_by_pk' | 'campaign_status_event' | 'campaign_status_event_aggregate' | 'campaign_status_event_by_pk' | 'campaign_status_event_stream' | 'campaign_status_log' | 'campaign_status_log_aggregate' | 'campaign_status_log_by_pk' | 'campaign_status_log_stream' | 'campaign_status_stream' | 'campaign_stream' | 'campaign_transaction_type' | 'campaign_transaction_type_aggregate' | 'campaign_transaction_type_by_pk' | 'campaign_transaction_type_stream' | 'campaign_work_location' | 'campaign_work_location_aggregate' | 'campaign_work_location_by_pk' | 'campaign_work_location_stream' | 'chat_bot_customers' | 'chat_bot_customers_aggregate' | 'chat_bot_customers_by_pk' | 'chat_bot_customers_stream' | 'chat_bot_forwarding' | 'chat_bot_forwarding_aggregate' | 'chat_bot_forwarding_by_pk' | 'chat_bot_forwarding_stream' | 'chat_bot_message_type' | 'chat_bot_message_type_aggregate' | 'chat_bot_message_type_by_pk' | 'chat_bot_message_type_stream' | 'chat_bot_messages' | 'chat_bot_messages_aggregate' | 'chat_bot_messages_by_pk' | 'chat_bot_messages_stream' | 'contact' | 'contact_aggregate' | 'contact_by_pk' | 'contact_logs' | 'contact_logs_aggregate' | 'contact_logs_by_pk' | 'contact_logs_stream' | 'contact_stream' | 'file_pdf_templates' | 'file_pdf_templates_aggregate' | 'file_pdf_templates_by_pk' | 'file_pdf_templates_stream' | 'file_upload' | 'file_upload_aggregate' | 'file_upload_by_pk' | 'file_upload_stream' | 'funnel_benefits' | 'funnel_benefits_aggregate' | 'funnel_benefits_by_pk' | 'funnel_benefits_stream' | 'funnel_chatbot_message' | 'funnel_chatbot_message_aggregate' | 'funnel_chatbot_message_by_pk' | 'funnel_chatbot_message_stream' | 'funnel_chatbot_session' | 'funnel_chatbot_session_aggregate' | 'funnel_chatbot_session_by_pk' | 'funnel_chatbot_session_stream' | 'funnel_funnels' | 'funnel_funnels_aggregate' | 'funnel_funnels_by_pk' | 'funnel_funnels_stream' | 'funnel_insights' | 'funnel_insights_aggregate' | 'funnel_insights_stream' | 'funnel_page_insights' | 'funnel_page_insights_aggregate' | 'funnel_page_insights_by_pk' | 'funnel_page_insights_stream' | 'funnel_question' | 'funnel_question_aggregate' | 'funnel_question_by_pk' | 'funnel_question_option' | 'funnel_question_option_aggregate' | 'funnel_question_option_by_pk' | 'funnel_question_option_stream' | 'funnel_question_stream' | 'funnel_whatsapp_share_clicks' | 'funnel_whatsapp_share_clicks_aggregate' | 'funnel_whatsapp_share_clicks_by_pk' | 'funnel_whatsapp_share_clicks_stream' | 'huk_contacts' | 'huk_contacts_aggregate' | 'huk_contacts_stream' | 'new_contacts_per_day' | 'new_contacts_per_day_aggregate' | 'new_contacts_per_day_stream' | 'new_unqualified_contacts_per_day' | 'new_unqualified_contacts_per_day_aggregate' | 'new_unqualified_contacts_per_day_stream' | 'organization' | 'organization_aggregate' | 'organization_budget' | 'organization_budget_aggregate' | 'organization_budget_stream' | 'organization_by_pk' | 'organization_contacts_per_day' | 'organization_contacts_per_day_aggregate' | 'organization_contacts_per_day_stream' | 'organization_location' | 'organization_location_aggregate' | 'organization_location_by_pk' | 'organization_location_stream' | 'organization_name_prefix' | 'organization_name_prefix_aggregate' | 'organization_name_prefix_by_pk' | 'organization_name_prefix_stream' | 'organization_news' | 'organization_news_aggregate' | 'organization_news_by_pk' | 'organization_news_stream' | 'organization_region' | 'organization_region_aggregate' | 'organization_region_by_pk' | 'organization_region_stream' | 'organization_settings' | 'organization_settings_aggregate' | 'organization_settings_by_pk' | 'organization_settings_stream' | 'organization_stream' | 'perspective_campaign' | 'perspective_campaign_aggregate' | 'perspective_campaign_by_pk' | 'perspective_campaign_stream' | 'qa_source' | 'qa_source_aggregate' | 'qa_source_by_pk' | 'qa_source_stream' | 'rms_connectors' | 'rms_connectors_aggregate' | 'rms_connectors_by_pk' | 'rms_connectors_stream' | 'rms_forwarded_logs' | 'rms_forwarded_logs_aggregate' | 'rms_forwarded_logs_by_pk' | 'rms_forwarded_logs_stream' | 'rms_org_setups' | 'rms_org_setups_aggregate' | 'rms_org_setups_by_pk' | 'rms_org_setups_stream' | 'system_api_keys' | 'system_api_keys_aggregate' | 'system_api_keys_by_pk' | 'system_api_keys_stream' | 'system_call_daily_stats' | 'system_call_daily_stats_aggregate' | 'system_call_daily_stats_by_pk' | 'system_call_daily_stats_stream' | 'system_email_daily_stats' | 'system_email_daily_stats_aggregate' | 'system_email_daily_stats_by_pk' | 'system_email_daily_stats_stream' | 'system_running_release' | 'system_running_release_aggregate' | 'system_running_release_by_pk' | 'system_running_release_stream' | 'system_sms_daily_stats' | 'system_sms_daily_stats_aggregate' | 'system_sms_daily_stats_by_pk' | 'system_sms_daily_stats_stream' | subscription_rootKeySpecifier)[];
export type subscription_rootFieldPolicy = {
	ad_campaign_metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_campaign_metrics_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_campaign_metrics_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_campaign_metrics_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_comment?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_comment_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_comment_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_comment_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_feedback?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_feedback_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_feedback_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_feedback_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_creative_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_platform?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_platform_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_platform_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_platform_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_providers?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_providers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_providers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_providers_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_setting?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_setting_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_setting_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_setting_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_status?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_status_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	ad_status_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_campaigns?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_campaigns_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_campaigns_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_campaigns_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_states?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_states_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_states_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_call_states_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_outbound_calls?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_outbound_calls_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_outbound_calls_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	anna_ai_outbound_calls_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	answer_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	answer_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	answer_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	applicant_event?: FieldPolicy<any> | FieldReadFunction<any>,
	applicant_event_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	applicant_event_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	applicant_event_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	board_column_type?: FieldPolicy<any> | FieldReadFunction<any>,
	board_column_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	board_column_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	board_column_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_column?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_column_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_column_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_column_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_entry?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_entry_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_entry_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_entry_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	board_contact_board_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	board_note?: FieldPolicy<any> | FieldReadFunction<any>,
	board_note_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	board_note_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	board_note_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_assignee_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_assignee_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_assignee_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_channel?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_channel_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_channel_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_channel_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_state?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_state_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_state_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_state_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_conversation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_status?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_status_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_status_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_message_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_sender?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_sender_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_sender_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bot_sender_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_ad?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_ad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_ad_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_ad_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget_transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget_transaction_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget_transaction_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_budget_transaction_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_email_template_overwrite?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_email_template_overwrite_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_email_template_overwrite_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_email_template_overwrite_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_event_log?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_event_log_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_event_log_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_event_log_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_get_daily_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_get_daily_budget_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_iso_2_country_codes?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_iso_2_country_codes_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_iso_2_country_codes_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_iso_2_country_codes_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_job_description?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_job_description_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_job_description_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_job_description_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_type?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_source_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_order_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_destination?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_destination_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_destination_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_destination_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_info?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_info_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_info_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_info_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_zipcode?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_zipcode_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_zipcode_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_routing_zipcode_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_settings_override?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_settings_override_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_settings_override_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_settings_override_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_event?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_event_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_event_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_event_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_log?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_log_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_log_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_log_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_status_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_transaction_type?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_transaction_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_transaction_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_transaction_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_work_location?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_work_location_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_work_location_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign_work_location_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_customers?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_customers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_customers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_customers_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_forwarding?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_forwarding_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_forwarding_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_forwarding_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_message_type?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_message_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_message_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_message_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_messages?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_messages_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_messages_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	chat_bot_messages_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_logs?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_logs_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_logs_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_logs_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	file_pdf_templates?: FieldPolicy<any> | FieldReadFunction<any>,
	file_pdf_templates_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file_pdf_templates_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	file_pdf_templates_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	file_upload?: FieldPolicy<any> | FieldReadFunction<any>,
	file_upload_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file_upload_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	file_upload_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_benefits?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_benefits_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_benefits_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_benefits_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_message?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_message_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_message_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_session?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_session_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_session_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_chatbot_session_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_funnels?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_funnels_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_funnels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_funnels_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_insights_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_insights_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_page_insights?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_page_insights_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_page_insights_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_page_insights_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_option?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_option_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_option_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_option_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_question_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_whatsapp_share_clicks?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_whatsapp_share_clicks_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_whatsapp_share_clicks_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	funnel_whatsapp_share_clicks_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	huk_contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	huk_contacts_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	huk_contacts_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts_per_day?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts_per_day_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	new_contacts_per_day_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	new_unqualified_contacts_per_day?: FieldPolicy<any> | FieldReadFunction<any>,
	new_unqualified_contacts_per_day_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	new_unqualified_contacts_per_day_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_budget?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_budget_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_budget_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_contacts_per_day?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_contacts_per_day_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_contacts_per_day_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_location?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_location_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_location_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_location_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_name_prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_name_prefix_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_name_prefix_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_name_prefix_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_news?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_news_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_news_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_news_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_region?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_region_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_region_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_settings_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_settings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_settings_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	organization_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	perspective_campaign_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	qa_source?: FieldPolicy<any> | FieldReadFunction<any>,
	qa_source_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	qa_source_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	qa_source_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_connectors?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_connectors_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_connectors_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_connectors_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_forwarded_logs?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_forwarded_logs_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_forwarded_logs_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_forwarded_logs_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_org_setups?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_org_setups_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_org_setups_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	rms_org_setups_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	system_api_keys?: FieldPolicy<any> | FieldReadFunction<any>,
	system_api_keys_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	system_api_keys_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	system_api_keys_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	system_call_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	system_call_daily_stats_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	system_call_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	system_call_daily_stats_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	system_email_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	system_email_daily_stats_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	system_email_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	system_email_daily_stats_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	system_running_release?: FieldPolicy<any> | FieldReadFunction<any>,
	system_running_release_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	system_running_release_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	system_running_release_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	system_sms_daily_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	system_sms_daily_stats_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	system_sms_daily_stats_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	system_sms_daily_stats_stream?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_api_keysKeySpecifier = ('created_at' | 'expired_at' | 'name' | 'value' | system_api_keysKeySpecifier)[];
export type system_api_keysFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	expired_at?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_api_keys_aggregateKeySpecifier = ('aggregate' | 'nodes' | system_api_keys_aggregateKeySpecifier)[];
export type system_api_keys_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_api_keys_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | system_api_keys_aggregate_fieldsKeySpecifier)[];
export type system_api_keys_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_api_keys_max_fieldsKeySpecifier = ('created_at' | 'expired_at' | 'name' | 'value' | system_api_keys_max_fieldsKeySpecifier)[];
export type system_api_keys_max_fieldsFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	expired_at?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_api_keys_min_fieldsKeySpecifier = ('created_at' | 'expired_at' | 'name' | 'value' | system_api_keys_min_fieldsKeySpecifier)[];
export type system_api_keys_min_fieldsFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	expired_at?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_api_keys_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | system_api_keys_mutation_responseKeySpecifier)[];
export type system_api_keys_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_statsKeySpecifier = ('cost' | 'date' | 'tag' | 'usage' | system_call_daily_statsKeySpecifier)[];
export type system_call_daily_statsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_aggregateKeySpecifier = ('aggregate' | 'nodes' | system_call_daily_stats_aggregateKeySpecifier)[];
export type system_call_daily_stats_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | system_call_daily_stats_aggregate_fieldsKeySpecifier)[];
export type system_call_daily_stats_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_avg_fieldsKeySpecifier = ('cost' | 'usage' | system_call_daily_stats_avg_fieldsKeySpecifier)[];
export type system_call_daily_stats_avg_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_max_fieldsKeySpecifier = ('cost' | 'date' | 'tag' | 'usage' | system_call_daily_stats_max_fieldsKeySpecifier)[];
export type system_call_daily_stats_max_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_min_fieldsKeySpecifier = ('cost' | 'date' | 'tag' | 'usage' | system_call_daily_stats_min_fieldsKeySpecifier)[];
export type system_call_daily_stats_min_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | system_call_daily_stats_mutation_responseKeySpecifier)[];
export type system_call_daily_stats_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_stddev_fieldsKeySpecifier = ('cost' | 'usage' | system_call_daily_stats_stddev_fieldsKeySpecifier)[];
export type system_call_daily_stats_stddev_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_stddev_pop_fieldsKeySpecifier = ('cost' | 'usage' | system_call_daily_stats_stddev_pop_fieldsKeySpecifier)[];
export type system_call_daily_stats_stddev_pop_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_stddev_samp_fieldsKeySpecifier = ('cost' | 'usage' | system_call_daily_stats_stddev_samp_fieldsKeySpecifier)[];
export type system_call_daily_stats_stddev_samp_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_sum_fieldsKeySpecifier = ('cost' | 'usage' | system_call_daily_stats_sum_fieldsKeySpecifier)[];
export type system_call_daily_stats_sum_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_var_pop_fieldsKeySpecifier = ('cost' | 'usage' | system_call_daily_stats_var_pop_fieldsKeySpecifier)[];
export type system_call_daily_stats_var_pop_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_var_samp_fieldsKeySpecifier = ('cost' | 'usage' | system_call_daily_stats_var_samp_fieldsKeySpecifier)[];
export type system_call_daily_stats_var_samp_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_call_daily_stats_variance_fieldsKeySpecifier = ('cost' | 'usage' | system_call_daily_stats_variance_fieldsKeySpecifier)[];
export type system_call_daily_stats_variance_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_statsKeySpecifier = ('cost' | 'date' | 'tag' | 'usage' | system_email_daily_statsKeySpecifier)[];
export type system_email_daily_statsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_aggregateKeySpecifier = ('aggregate' | 'nodes' | system_email_daily_stats_aggregateKeySpecifier)[];
export type system_email_daily_stats_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | system_email_daily_stats_aggregate_fieldsKeySpecifier)[];
export type system_email_daily_stats_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_avg_fieldsKeySpecifier = ('cost' | 'usage' | system_email_daily_stats_avg_fieldsKeySpecifier)[];
export type system_email_daily_stats_avg_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_max_fieldsKeySpecifier = ('cost' | 'date' | 'tag' | 'usage' | system_email_daily_stats_max_fieldsKeySpecifier)[];
export type system_email_daily_stats_max_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_min_fieldsKeySpecifier = ('cost' | 'date' | 'tag' | 'usage' | system_email_daily_stats_min_fieldsKeySpecifier)[];
export type system_email_daily_stats_min_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | system_email_daily_stats_mutation_responseKeySpecifier)[];
export type system_email_daily_stats_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_stddev_fieldsKeySpecifier = ('cost' | 'usage' | system_email_daily_stats_stddev_fieldsKeySpecifier)[];
export type system_email_daily_stats_stddev_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_stddev_pop_fieldsKeySpecifier = ('cost' | 'usage' | system_email_daily_stats_stddev_pop_fieldsKeySpecifier)[];
export type system_email_daily_stats_stddev_pop_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_stddev_samp_fieldsKeySpecifier = ('cost' | 'usage' | system_email_daily_stats_stddev_samp_fieldsKeySpecifier)[];
export type system_email_daily_stats_stddev_samp_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_sum_fieldsKeySpecifier = ('cost' | 'usage' | system_email_daily_stats_sum_fieldsKeySpecifier)[];
export type system_email_daily_stats_sum_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_var_pop_fieldsKeySpecifier = ('cost' | 'usage' | system_email_daily_stats_var_pop_fieldsKeySpecifier)[];
export type system_email_daily_stats_var_pop_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_var_samp_fieldsKeySpecifier = ('cost' | 'usage' | system_email_daily_stats_var_samp_fieldsKeySpecifier)[];
export type system_email_daily_stats_var_samp_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_email_daily_stats_variance_fieldsKeySpecifier = ('cost' | 'usage' | system_email_daily_stats_variance_fieldsKeySpecifier)[];
export type system_email_daily_stats_variance_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_running_releaseKeySpecifier = ('announced_at' | 'dist' | 'release' | 'service' | system_running_releaseKeySpecifier)[];
export type system_running_releaseFieldPolicy = {
	announced_at?: FieldPolicy<any> | FieldReadFunction<any>,
	dist?: FieldPolicy<any> | FieldReadFunction<any>,
	release?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_running_release_aggregateKeySpecifier = ('aggregate' | 'nodes' | system_running_release_aggregateKeySpecifier)[];
export type system_running_release_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_running_release_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | system_running_release_aggregate_fieldsKeySpecifier)[];
export type system_running_release_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_running_release_max_fieldsKeySpecifier = ('announced_at' | 'dist' | 'release' | 'service' | system_running_release_max_fieldsKeySpecifier)[];
export type system_running_release_max_fieldsFieldPolicy = {
	announced_at?: FieldPolicy<any> | FieldReadFunction<any>,
	dist?: FieldPolicy<any> | FieldReadFunction<any>,
	release?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_running_release_min_fieldsKeySpecifier = ('announced_at' | 'dist' | 'release' | 'service' | system_running_release_min_fieldsKeySpecifier)[];
export type system_running_release_min_fieldsFieldPolicy = {
	announced_at?: FieldPolicy<any> | FieldReadFunction<any>,
	dist?: FieldPolicy<any> | FieldReadFunction<any>,
	release?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_running_release_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | system_running_release_mutation_responseKeySpecifier)[];
export type system_running_release_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_statsKeySpecifier = ('cost' | 'date' | 'tag' | 'usage' | system_sms_daily_statsKeySpecifier)[];
export type system_sms_daily_statsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_aggregateKeySpecifier = ('aggregate' | 'nodes' | system_sms_daily_stats_aggregateKeySpecifier)[];
export type system_sms_daily_stats_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | system_sms_daily_stats_aggregate_fieldsKeySpecifier)[];
export type system_sms_daily_stats_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_avg_fieldsKeySpecifier = ('cost' | 'usage' | system_sms_daily_stats_avg_fieldsKeySpecifier)[];
export type system_sms_daily_stats_avg_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_max_fieldsKeySpecifier = ('cost' | 'date' | 'tag' | 'usage' | system_sms_daily_stats_max_fieldsKeySpecifier)[];
export type system_sms_daily_stats_max_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_min_fieldsKeySpecifier = ('cost' | 'date' | 'tag' | 'usage' | system_sms_daily_stats_min_fieldsKeySpecifier)[];
export type system_sms_daily_stats_min_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | system_sms_daily_stats_mutation_responseKeySpecifier)[];
export type system_sms_daily_stats_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_stddev_fieldsKeySpecifier = ('cost' | 'usage' | system_sms_daily_stats_stddev_fieldsKeySpecifier)[];
export type system_sms_daily_stats_stddev_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_stddev_pop_fieldsKeySpecifier = ('cost' | 'usage' | system_sms_daily_stats_stddev_pop_fieldsKeySpecifier)[];
export type system_sms_daily_stats_stddev_pop_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_stddev_samp_fieldsKeySpecifier = ('cost' | 'usage' | system_sms_daily_stats_stddev_samp_fieldsKeySpecifier)[];
export type system_sms_daily_stats_stddev_samp_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_sum_fieldsKeySpecifier = ('cost' | 'usage' | system_sms_daily_stats_sum_fieldsKeySpecifier)[];
export type system_sms_daily_stats_sum_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_var_pop_fieldsKeySpecifier = ('cost' | 'usage' | system_sms_daily_stats_var_pop_fieldsKeySpecifier)[];
export type system_sms_daily_stats_var_pop_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_var_samp_fieldsKeySpecifier = ('cost' | 'usage' | system_sms_daily_stats_var_samp_fieldsKeySpecifier)[];
export type system_sms_daily_stats_var_samp_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type system_sms_daily_stats_variance_fieldsKeySpecifier = ('cost' | 'usage' | system_sms_daily_stats_variance_fieldsKeySpecifier)[];
export type system_sms_daily_stats_variance_fieldsFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	ad_campaign_metrics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metricsKeySpecifier | (() => undefined | ad_campaign_metricsKeySpecifier),
		fields?: ad_campaign_metricsFieldPolicy,
	},
	ad_campaign_metrics_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_aggregateKeySpecifier | (() => undefined | ad_campaign_metrics_aggregateKeySpecifier),
		fields?: ad_campaign_metrics_aggregateFieldPolicy,
	},
	ad_campaign_metrics_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_aggregate_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_aggregate_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_aggregate_fieldsFieldPolicy,
	},
	ad_campaign_metrics_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_avg_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_avg_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_avg_fieldsFieldPolicy,
	},
	ad_campaign_metrics_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_max_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_max_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_max_fieldsFieldPolicy,
	},
	ad_campaign_metrics_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_min_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_min_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_min_fieldsFieldPolicy,
	},
	ad_campaign_metrics_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_mutation_responseKeySpecifier | (() => undefined | ad_campaign_metrics_mutation_responseKeySpecifier),
		fields?: ad_campaign_metrics_mutation_responseFieldPolicy,
	},
	ad_campaign_metrics_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_stddev_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_stddev_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_stddev_fieldsFieldPolicy,
	},
	ad_campaign_metrics_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_stddev_pop_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_stddev_pop_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_stddev_pop_fieldsFieldPolicy,
	},
	ad_campaign_metrics_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_stddev_samp_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_stddev_samp_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_stddev_samp_fieldsFieldPolicy,
	},
	ad_campaign_metrics_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_sum_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_sum_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_sum_fieldsFieldPolicy,
	},
	ad_campaign_metrics_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_var_pop_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_var_pop_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_var_pop_fieldsFieldPolicy,
	},
	ad_campaign_metrics_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_var_samp_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_var_samp_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_var_samp_fieldsFieldPolicy,
	},
	ad_campaign_metrics_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_campaign_metrics_variance_fieldsKeySpecifier | (() => undefined | ad_campaign_metrics_variance_fieldsKeySpecifier),
		fields?: ad_campaign_metrics_variance_fieldsFieldPolicy,
	},
	ad_comment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_commentKeySpecifier | (() => undefined | ad_commentKeySpecifier),
		fields?: ad_commentFieldPolicy,
	},
	ad_comment_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_comment_aggregateKeySpecifier | (() => undefined | ad_comment_aggregateKeySpecifier),
		fields?: ad_comment_aggregateFieldPolicy,
	},
	ad_comment_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_comment_aggregate_fieldsKeySpecifier | (() => undefined | ad_comment_aggregate_fieldsKeySpecifier),
		fields?: ad_comment_aggregate_fieldsFieldPolicy,
	},
	ad_comment_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_comment_max_fieldsKeySpecifier | (() => undefined | ad_comment_max_fieldsKeySpecifier),
		fields?: ad_comment_max_fieldsFieldPolicy,
	},
	ad_comment_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_comment_min_fieldsKeySpecifier | (() => undefined | ad_comment_min_fieldsKeySpecifier),
		fields?: ad_comment_min_fieldsFieldPolicy,
	},
	ad_comment_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_comment_mutation_responseKeySpecifier | (() => undefined | ad_comment_mutation_responseKeySpecifier),
		fields?: ad_comment_mutation_responseFieldPolicy,
	},
	ad_creative?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creativeKeySpecifier | (() => undefined | ad_creativeKeySpecifier),
		fields?: ad_creativeFieldPolicy,
	},
	ad_creative_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_aggregateKeySpecifier | (() => undefined | ad_creative_aggregateKeySpecifier),
		fields?: ad_creative_aggregateFieldPolicy,
	},
	ad_creative_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_aggregate_fieldsKeySpecifier | (() => undefined | ad_creative_aggregate_fieldsKeySpecifier),
		fields?: ad_creative_aggregate_fieldsFieldPolicy,
	},
	ad_creative_feedback?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_feedbackKeySpecifier | (() => undefined | ad_creative_feedbackKeySpecifier),
		fields?: ad_creative_feedbackFieldPolicy,
	},
	ad_creative_feedback_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_feedback_aggregateKeySpecifier | (() => undefined | ad_creative_feedback_aggregateKeySpecifier),
		fields?: ad_creative_feedback_aggregateFieldPolicy,
	},
	ad_creative_feedback_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_feedback_aggregate_fieldsKeySpecifier | (() => undefined | ad_creative_feedback_aggregate_fieldsKeySpecifier),
		fields?: ad_creative_feedback_aggregate_fieldsFieldPolicy,
	},
	ad_creative_feedback_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_feedback_max_fieldsKeySpecifier | (() => undefined | ad_creative_feedback_max_fieldsKeySpecifier),
		fields?: ad_creative_feedback_max_fieldsFieldPolicy,
	},
	ad_creative_feedback_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_feedback_min_fieldsKeySpecifier | (() => undefined | ad_creative_feedback_min_fieldsKeySpecifier),
		fields?: ad_creative_feedback_min_fieldsFieldPolicy,
	},
	ad_creative_feedback_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_feedback_mutation_responseKeySpecifier | (() => undefined | ad_creative_feedback_mutation_responseKeySpecifier),
		fields?: ad_creative_feedback_mutation_responseFieldPolicy,
	},
	ad_creative_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_max_fieldsKeySpecifier | (() => undefined | ad_creative_max_fieldsKeySpecifier),
		fields?: ad_creative_max_fieldsFieldPolicy,
	},
	ad_creative_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_min_fieldsKeySpecifier | (() => undefined | ad_creative_min_fieldsKeySpecifier),
		fields?: ad_creative_min_fieldsFieldPolicy,
	},
	ad_creative_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_creative_mutation_responseKeySpecifier | (() => undefined | ad_creative_mutation_responseKeySpecifier),
		fields?: ad_creative_mutation_responseFieldPolicy,
	},
	ad_platform?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_platformKeySpecifier | (() => undefined | ad_platformKeySpecifier),
		fields?: ad_platformFieldPolicy,
	},
	ad_platform_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_platform_aggregateKeySpecifier | (() => undefined | ad_platform_aggregateKeySpecifier),
		fields?: ad_platform_aggregateFieldPolicy,
	},
	ad_platform_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_platform_aggregate_fieldsKeySpecifier | (() => undefined | ad_platform_aggregate_fieldsKeySpecifier),
		fields?: ad_platform_aggregate_fieldsFieldPolicy,
	},
	ad_platform_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_platform_max_fieldsKeySpecifier | (() => undefined | ad_platform_max_fieldsKeySpecifier),
		fields?: ad_platform_max_fieldsFieldPolicy,
	},
	ad_platform_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_platform_min_fieldsKeySpecifier | (() => undefined | ad_platform_min_fieldsKeySpecifier),
		fields?: ad_platform_min_fieldsFieldPolicy,
	},
	ad_platform_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_platform_mutation_responseKeySpecifier | (() => undefined | ad_platform_mutation_responseKeySpecifier),
		fields?: ad_platform_mutation_responseFieldPolicy,
	},
	ad_providers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_providersKeySpecifier | (() => undefined | ad_providersKeySpecifier),
		fields?: ad_providersFieldPolicy,
	},
	ad_providers_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_providers_aggregateKeySpecifier | (() => undefined | ad_providers_aggregateKeySpecifier),
		fields?: ad_providers_aggregateFieldPolicy,
	},
	ad_providers_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_providers_aggregate_fieldsKeySpecifier | (() => undefined | ad_providers_aggregate_fieldsKeySpecifier),
		fields?: ad_providers_aggregate_fieldsFieldPolicy,
	},
	ad_providers_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_providers_max_fieldsKeySpecifier | (() => undefined | ad_providers_max_fieldsKeySpecifier),
		fields?: ad_providers_max_fieldsFieldPolicy,
	},
	ad_providers_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_providers_min_fieldsKeySpecifier | (() => undefined | ad_providers_min_fieldsKeySpecifier),
		fields?: ad_providers_min_fieldsFieldPolicy,
	},
	ad_providers_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_providers_mutation_responseKeySpecifier | (() => undefined | ad_providers_mutation_responseKeySpecifier),
		fields?: ad_providers_mutation_responseFieldPolicy,
	},
	ad_setting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_settingKeySpecifier | (() => undefined | ad_settingKeySpecifier),
		fields?: ad_settingFieldPolicy,
	},
	ad_setting_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_setting_aggregateKeySpecifier | (() => undefined | ad_setting_aggregateKeySpecifier),
		fields?: ad_setting_aggregateFieldPolicy,
	},
	ad_setting_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_setting_aggregate_fieldsKeySpecifier | (() => undefined | ad_setting_aggregate_fieldsKeySpecifier),
		fields?: ad_setting_aggregate_fieldsFieldPolicy,
	},
	ad_setting_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_setting_max_fieldsKeySpecifier | (() => undefined | ad_setting_max_fieldsKeySpecifier),
		fields?: ad_setting_max_fieldsFieldPolicy,
	},
	ad_setting_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_setting_min_fieldsKeySpecifier | (() => undefined | ad_setting_min_fieldsKeySpecifier),
		fields?: ad_setting_min_fieldsFieldPolicy,
	},
	ad_setting_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_setting_mutation_responseKeySpecifier | (() => undefined | ad_setting_mutation_responseKeySpecifier),
		fields?: ad_setting_mutation_responseFieldPolicy,
	},
	ad_status?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_statusKeySpecifier | (() => undefined | ad_statusKeySpecifier),
		fields?: ad_statusFieldPolicy,
	},
	ad_status_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_status_aggregateKeySpecifier | (() => undefined | ad_status_aggregateKeySpecifier),
		fields?: ad_status_aggregateFieldPolicy,
	},
	ad_status_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_status_aggregate_fieldsKeySpecifier | (() => undefined | ad_status_aggregate_fieldsKeySpecifier),
		fields?: ad_status_aggregate_fieldsFieldPolicy,
	},
	ad_status_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_status_max_fieldsKeySpecifier | (() => undefined | ad_status_max_fieldsKeySpecifier),
		fields?: ad_status_max_fieldsFieldPolicy,
	},
	ad_status_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_status_min_fieldsKeySpecifier | (() => undefined | ad_status_min_fieldsKeySpecifier),
		fields?: ad_status_min_fieldsFieldPolicy,
	},
	ad_status_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ad_status_mutation_responseKeySpecifier | (() => undefined | ad_status_mutation_responseKeySpecifier),
		fields?: ad_status_mutation_responseFieldPolicy,
	},
	anna_ai_call_campaigns?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaignsKeySpecifier | (() => undefined | anna_ai_call_campaignsKeySpecifier),
		fields?: anna_ai_call_campaignsFieldPolicy,
	},
	anna_ai_call_campaigns_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_aggregateKeySpecifier | (() => undefined | anna_ai_call_campaigns_aggregateKeySpecifier),
		fields?: anna_ai_call_campaigns_aggregateFieldPolicy,
	},
	anna_ai_call_campaigns_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_aggregate_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_aggregate_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_aggregate_fieldsFieldPolicy,
	},
	anna_ai_call_campaigns_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_avg_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_avg_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_avg_fieldsFieldPolicy,
	},
	anna_ai_call_campaigns_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_max_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_max_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_max_fieldsFieldPolicy,
	},
	anna_ai_call_campaigns_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_min_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_min_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_min_fieldsFieldPolicy,
	},
	anna_ai_call_campaigns_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_mutation_responseKeySpecifier | (() => undefined | anna_ai_call_campaigns_mutation_responseKeySpecifier),
		fields?: anna_ai_call_campaigns_mutation_responseFieldPolicy,
	},
	anna_ai_call_campaigns_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_stddev_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_stddev_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_stddev_fieldsFieldPolicy,
	},
	anna_ai_call_campaigns_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_stddev_pop_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_stddev_pop_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_stddev_pop_fieldsFieldPolicy,
	},
	anna_ai_call_campaigns_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_stddev_samp_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_stddev_samp_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_stddev_samp_fieldsFieldPolicy,
	},
	anna_ai_call_campaigns_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_sum_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_sum_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_sum_fieldsFieldPolicy,
	},
	anna_ai_call_campaigns_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_var_pop_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_var_pop_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_var_pop_fieldsFieldPolicy,
	},
	anna_ai_call_campaigns_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_var_samp_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_var_samp_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_var_samp_fieldsFieldPolicy,
	},
	anna_ai_call_campaigns_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_campaigns_variance_fieldsKeySpecifier | (() => undefined | anna_ai_call_campaigns_variance_fieldsKeySpecifier),
		fields?: anna_ai_call_campaigns_variance_fieldsFieldPolicy,
	},
	anna_ai_call_states?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_statesKeySpecifier | (() => undefined | anna_ai_call_statesKeySpecifier),
		fields?: anna_ai_call_statesFieldPolicy,
	},
	anna_ai_call_states_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_states_aggregateKeySpecifier | (() => undefined | anna_ai_call_states_aggregateKeySpecifier),
		fields?: anna_ai_call_states_aggregateFieldPolicy,
	},
	anna_ai_call_states_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_states_aggregate_fieldsKeySpecifier | (() => undefined | anna_ai_call_states_aggregate_fieldsKeySpecifier),
		fields?: anna_ai_call_states_aggregate_fieldsFieldPolicy,
	},
	anna_ai_call_states_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_states_max_fieldsKeySpecifier | (() => undefined | anna_ai_call_states_max_fieldsKeySpecifier),
		fields?: anna_ai_call_states_max_fieldsFieldPolicy,
	},
	anna_ai_call_states_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_states_min_fieldsKeySpecifier | (() => undefined | anna_ai_call_states_min_fieldsKeySpecifier),
		fields?: anna_ai_call_states_min_fieldsFieldPolicy,
	},
	anna_ai_call_states_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_call_states_mutation_responseKeySpecifier | (() => undefined | anna_ai_call_states_mutation_responseKeySpecifier),
		fields?: anna_ai_call_states_mutation_responseFieldPolicy,
	},
	anna_ai_outbound_calls?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_outbound_callsKeySpecifier | (() => undefined | anna_ai_outbound_callsKeySpecifier),
		fields?: anna_ai_outbound_callsFieldPolicy,
	},
	anna_ai_outbound_calls_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_outbound_calls_aggregateKeySpecifier | (() => undefined | anna_ai_outbound_calls_aggregateKeySpecifier),
		fields?: anna_ai_outbound_calls_aggregateFieldPolicy,
	},
	anna_ai_outbound_calls_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_outbound_calls_aggregate_fieldsKeySpecifier | (() => undefined | anna_ai_outbound_calls_aggregate_fieldsKeySpecifier),
		fields?: anna_ai_outbound_calls_aggregate_fieldsFieldPolicy,
	},
	anna_ai_outbound_calls_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_outbound_calls_max_fieldsKeySpecifier | (() => undefined | anna_ai_outbound_calls_max_fieldsKeySpecifier),
		fields?: anna_ai_outbound_calls_max_fieldsFieldPolicy,
	},
	anna_ai_outbound_calls_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_outbound_calls_min_fieldsKeySpecifier | (() => undefined | anna_ai_outbound_calls_min_fieldsKeySpecifier),
		fields?: anna_ai_outbound_calls_min_fieldsFieldPolicy,
	},
	anna_ai_outbound_calls_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | anna_ai_outbound_calls_mutation_responseKeySpecifier | (() => undefined | anna_ai_outbound_calls_mutation_responseKeySpecifier),
		fields?: anna_ai_outbound_calls_mutation_responseFieldPolicy,
	},
	answer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | answerKeySpecifier | (() => undefined | answerKeySpecifier),
		fields?: answerFieldPolicy,
	},
	answer_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | answer_aggregateKeySpecifier | (() => undefined | answer_aggregateKeySpecifier),
		fields?: answer_aggregateFieldPolicy,
	},
	answer_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | answer_aggregate_fieldsKeySpecifier | (() => undefined | answer_aggregate_fieldsKeySpecifier),
		fields?: answer_aggregate_fieldsFieldPolicy,
	},
	answer_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | answer_max_fieldsKeySpecifier | (() => undefined | answer_max_fieldsKeySpecifier),
		fields?: answer_max_fieldsFieldPolicy,
	},
	answer_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | answer_min_fieldsKeySpecifier | (() => undefined | answer_min_fieldsKeySpecifier),
		fields?: answer_min_fieldsFieldPolicy,
	},
	answer_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | answer_mutation_responseKeySpecifier | (() => undefined | answer_mutation_responseKeySpecifier),
		fields?: answer_mutation_responseFieldPolicy,
	},
	applicant_event?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_eventKeySpecifier | (() => undefined | applicant_eventKeySpecifier),
		fields?: applicant_eventFieldPolicy,
	},
	applicant_event_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_aggregateKeySpecifier | (() => undefined | applicant_event_aggregateKeySpecifier),
		fields?: applicant_event_aggregateFieldPolicy,
	},
	applicant_event_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_aggregate_fieldsKeySpecifier | (() => undefined | applicant_event_aggregate_fieldsKeySpecifier),
		fields?: applicant_event_aggregate_fieldsFieldPolicy,
	},
	applicant_event_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_avg_fieldsKeySpecifier | (() => undefined | applicant_event_avg_fieldsKeySpecifier),
		fields?: applicant_event_avg_fieldsFieldPolicy,
	},
	applicant_event_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_max_fieldsKeySpecifier | (() => undefined | applicant_event_max_fieldsKeySpecifier),
		fields?: applicant_event_max_fieldsFieldPolicy,
	},
	applicant_event_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_min_fieldsKeySpecifier | (() => undefined | applicant_event_min_fieldsKeySpecifier),
		fields?: applicant_event_min_fieldsFieldPolicy,
	},
	applicant_event_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_mutation_responseKeySpecifier | (() => undefined | applicant_event_mutation_responseKeySpecifier),
		fields?: applicant_event_mutation_responseFieldPolicy,
	},
	applicant_event_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_stddev_fieldsKeySpecifier | (() => undefined | applicant_event_stddev_fieldsKeySpecifier),
		fields?: applicant_event_stddev_fieldsFieldPolicy,
	},
	applicant_event_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_stddev_pop_fieldsKeySpecifier | (() => undefined | applicant_event_stddev_pop_fieldsKeySpecifier),
		fields?: applicant_event_stddev_pop_fieldsFieldPolicy,
	},
	applicant_event_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_stddev_samp_fieldsKeySpecifier | (() => undefined | applicant_event_stddev_samp_fieldsKeySpecifier),
		fields?: applicant_event_stddev_samp_fieldsFieldPolicy,
	},
	applicant_event_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_sum_fieldsKeySpecifier | (() => undefined | applicant_event_sum_fieldsKeySpecifier),
		fields?: applicant_event_sum_fieldsFieldPolicy,
	},
	applicant_event_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_var_pop_fieldsKeySpecifier | (() => undefined | applicant_event_var_pop_fieldsKeySpecifier),
		fields?: applicant_event_var_pop_fieldsFieldPolicy,
	},
	applicant_event_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_var_samp_fieldsKeySpecifier | (() => undefined | applicant_event_var_samp_fieldsKeySpecifier),
		fields?: applicant_event_var_samp_fieldsFieldPolicy,
	},
	applicant_event_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | applicant_event_variance_fieldsKeySpecifier | (() => undefined | applicant_event_variance_fieldsKeySpecifier),
		fields?: applicant_event_variance_fieldsFieldPolicy,
	},
	board_column_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_column_typeKeySpecifier | (() => undefined | board_column_typeKeySpecifier),
		fields?: board_column_typeFieldPolicy,
	},
	board_column_type_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_column_type_aggregateKeySpecifier | (() => undefined | board_column_type_aggregateKeySpecifier),
		fields?: board_column_type_aggregateFieldPolicy,
	},
	board_column_type_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_column_type_aggregate_fieldsKeySpecifier | (() => undefined | board_column_type_aggregate_fieldsKeySpecifier),
		fields?: board_column_type_aggregate_fieldsFieldPolicy,
	},
	board_column_type_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_column_type_max_fieldsKeySpecifier | (() => undefined | board_column_type_max_fieldsKeySpecifier),
		fields?: board_column_type_max_fieldsFieldPolicy,
	},
	board_column_type_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_column_type_min_fieldsKeySpecifier | (() => undefined | board_column_type_min_fieldsKeySpecifier),
		fields?: board_column_type_min_fieldsFieldPolicy,
	},
	board_column_type_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_column_type_mutation_responseKeySpecifier | (() => undefined | board_column_type_mutation_responseKeySpecifier),
		fields?: board_column_type_mutation_responseFieldPolicy,
	},
	board_contact_board?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_boardKeySpecifier | (() => undefined | board_contact_boardKeySpecifier),
		fields?: board_contact_boardFieldPolicy,
	},
	board_contact_board_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_aggregateKeySpecifier | (() => undefined | board_contact_board_aggregateKeySpecifier),
		fields?: board_contact_board_aggregateFieldPolicy,
	},
	board_contact_board_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_aggregate_fieldsKeySpecifier | (() => undefined | board_contact_board_aggregate_fieldsKeySpecifier),
		fields?: board_contact_board_aggregate_fieldsFieldPolicy,
	},
	board_contact_board_column?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_columnKeySpecifier | (() => undefined | board_contact_board_columnKeySpecifier),
		fields?: board_contact_board_columnFieldPolicy,
	},
	board_contact_board_column_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_aggregateKeySpecifier | (() => undefined | board_contact_board_column_aggregateKeySpecifier),
		fields?: board_contact_board_column_aggregateFieldPolicy,
	},
	board_contact_board_column_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_aggregate_fieldsKeySpecifier | (() => undefined | board_contact_board_column_aggregate_fieldsKeySpecifier),
		fields?: board_contact_board_column_aggregate_fieldsFieldPolicy,
	},
	board_contact_board_column_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_avg_fieldsKeySpecifier | (() => undefined | board_contact_board_column_avg_fieldsKeySpecifier),
		fields?: board_contact_board_column_avg_fieldsFieldPolicy,
	},
	board_contact_board_column_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_max_fieldsKeySpecifier | (() => undefined | board_contact_board_column_max_fieldsKeySpecifier),
		fields?: board_contact_board_column_max_fieldsFieldPolicy,
	},
	board_contact_board_column_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_min_fieldsKeySpecifier | (() => undefined | board_contact_board_column_min_fieldsKeySpecifier),
		fields?: board_contact_board_column_min_fieldsFieldPolicy,
	},
	board_contact_board_column_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_mutation_responseKeySpecifier | (() => undefined | board_contact_board_column_mutation_responseKeySpecifier),
		fields?: board_contact_board_column_mutation_responseFieldPolicy,
	},
	board_contact_board_column_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_stddev_fieldsKeySpecifier | (() => undefined | board_contact_board_column_stddev_fieldsKeySpecifier),
		fields?: board_contact_board_column_stddev_fieldsFieldPolicy,
	},
	board_contact_board_column_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_stddev_pop_fieldsKeySpecifier | (() => undefined | board_contact_board_column_stddev_pop_fieldsKeySpecifier),
		fields?: board_contact_board_column_stddev_pop_fieldsFieldPolicy,
	},
	board_contact_board_column_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_stddev_samp_fieldsKeySpecifier | (() => undefined | board_contact_board_column_stddev_samp_fieldsKeySpecifier),
		fields?: board_contact_board_column_stddev_samp_fieldsFieldPolicy,
	},
	board_contact_board_column_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_sum_fieldsKeySpecifier | (() => undefined | board_contact_board_column_sum_fieldsKeySpecifier),
		fields?: board_contact_board_column_sum_fieldsFieldPolicy,
	},
	board_contact_board_column_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_var_pop_fieldsKeySpecifier | (() => undefined | board_contact_board_column_var_pop_fieldsKeySpecifier),
		fields?: board_contact_board_column_var_pop_fieldsFieldPolicy,
	},
	board_contact_board_column_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_var_samp_fieldsKeySpecifier | (() => undefined | board_contact_board_column_var_samp_fieldsKeySpecifier),
		fields?: board_contact_board_column_var_samp_fieldsFieldPolicy,
	},
	board_contact_board_column_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_column_variance_fieldsKeySpecifier | (() => undefined | board_contact_board_column_variance_fieldsKeySpecifier),
		fields?: board_contact_board_column_variance_fieldsFieldPolicy,
	},
	board_contact_board_entry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entryKeySpecifier | (() => undefined | board_contact_board_entryKeySpecifier),
		fields?: board_contact_board_entryFieldPolicy,
	},
	board_contact_board_entry_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_aggregateKeySpecifier | (() => undefined | board_contact_board_entry_aggregateKeySpecifier),
		fields?: board_contact_board_entry_aggregateFieldPolicy,
	},
	board_contact_board_entry_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_aggregate_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_aggregate_fieldsKeySpecifier),
		fields?: board_contact_board_entry_aggregate_fieldsFieldPolicy,
	},
	board_contact_board_entry_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_avg_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_avg_fieldsKeySpecifier),
		fields?: board_contact_board_entry_avg_fieldsFieldPolicy,
	},
	board_contact_board_entry_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_max_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_max_fieldsKeySpecifier),
		fields?: board_contact_board_entry_max_fieldsFieldPolicy,
	},
	board_contact_board_entry_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_min_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_min_fieldsKeySpecifier),
		fields?: board_contact_board_entry_min_fieldsFieldPolicy,
	},
	board_contact_board_entry_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_mutation_responseKeySpecifier | (() => undefined | board_contact_board_entry_mutation_responseKeySpecifier),
		fields?: board_contact_board_entry_mutation_responseFieldPolicy,
	},
	board_contact_board_entry_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_stddev_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_stddev_fieldsKeySpecifier),
		fields?: board_contact_board_entry_stddev_fieldsFieldPolicy,
	},
	board_contact_board_entry_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_stddev_pop_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_stddev_pop_fieldsKeySpecifier),
		fields?: board_contact_board_entry_stddev_pop_fieldsFieldPolicy,
	},
	board_contact_board_entry_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_stddev_samp_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_stddev_samp_fieldsKeySpecifier),
		fields?: board_contact_board_entry_stddev_samp_fieldsFieldPolicy,
	},
	board_contact_board_entry_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_sum_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_sum_fieldsKeySpecifier),
		fields?: board_contact_board_entry_sum_fieldsFieldPolicy,
	},
	board_contact_board_entry_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_var_pop_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_var_pop_fieldsKeySpecifier),
		fields?: board_contact_board_entry_var_pop_fieldsFieldPolicy,
	},
	board_contact_board_entry_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_var_samp_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_var_samp_fieldsKeySpecifier),
		fields?: board_contact_board_entry_var_samp_fieldsFieldPolicy,
	},
	board_contact_board_entry_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_entry_variance_fieldsKeySpecifier | (() => undefined | board_contact_board_entry_variance_fieldsKeySpecifier),
		fields?: board_contact_board_entry_variance_fieldsFieldPolicy,
	},
	board_contact_board_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_max_fieldsKeySpecifier | (() => undefined | board_contact_board_max_fieldsKeySpecifier),
		fields?: board_contact_board_max_fieldsFieldPolicy,
	},
	board_contact_board_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_min_fieldsKeySpecifier | (() => undefined | board_contact_board_min_fieldsKeySpecifier),
		fields?: board_contact_board_min_fieldsFieldPolicy,
	},
	board_contact_board_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_contact_board_mutation_responseKeySpecifier | (() => undefined | board_contact_board_mutation_responseKeySpecifier),
		fields?: board_contact_board_mutation_responseFieldPolicy,
	},
	board_note?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_noteKeySpecifier | (() => undefined | board_noteKeySpecifier),
		fields?: board_noteFieldPolicy,
	},
	board_note_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_note_aggregateKeySpecifier | (() => undefined | board_note_aggregateKeySpecifier),
		fields?: board_note_aggregateFieldPolicy,
	},
	board_note_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_note_aggregate_fieldsKeySpecifier | (() => undefined | board_note_aggregate_fieldsKeySpecifier),
		fields?: board_note_aggregate_fieldsFieldPolicy,
	},
	board_note_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_note_max_fieldsKeySpecifier | (() => undefined | board_note_max_fieldsKeySpecifier),
		fields?: board_note_max_fieldsFieldPolicy,
	},
	board_note_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_note_min_fieldsKeySpecifier | (() => undefined | board_note_min_fieldsKeySpecifier),
		fields?: board_note_min_fieldsFieldPolicy,
	},
	board_note_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | board_note_mutation_responseKeySpecifier | (() => undefined | board_note_mutation_responseKeySpecifier),
		fields?: board_note_mutation_responseFieldPolicy,
	},
	bot_assignee?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_assigneeKeySpecifier | (() => undefined | bot_assigneeKeySpecifier),
		fields?: bot_assigneeFieldPolicy,
	},
	bot_assignee_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_assignee_aggregateKeySpecifier | (() => undefined | bot_assignee_aggregateKeySpecifier),
		fields?: bot_assignee_aggregateFieldPolicy,
	},
	bot_assignee_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_assignee_aggregate_fieldsKeySpecifier | (() => undefined | bot_assignee_aggregate_fieldsKeySpecifier),
		fields?: bot_assignee_aggregate_fieldsFieldPolicy,
	},
	bot_assignee_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_assignee_max_fieldsKeySpecifier | (() => undefined | bot_assignee_max_fieldsKeySpecifier),
		fields?: bot_assignee_max_fieldsFieldPolicy,
	},
	bot_assignee_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_assignee_min_fieldsKeySpecifier | (() => undefined | bot_assignee_min_fieldsKeySpecifier),
		fields?: bot_assignee_min_fieldsFieldPolicy,
	},
	bot_assignee_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_assignee_mutation_responseKeySpecifier | (() => undefined | bot_assignee_mutation_responseKeySpecifier),
		fields?: bot_assignee_mutation_responseFieldPolicy,
	},
	bot_channel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_channelKeySpecifier | (() => undefined | bot_channelKeySpecifier),
		fields?: bot_channelFieldPolicy,
	},
	bot_channel_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_channel_aggregateKeySpecifier | (() => undefined | bot_channel_aggregateKeySpecifier),
		fields?: bot_channel_aggregateFieldPolicy,
	},
	bot_channel_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_channel_aggregate_fieldsKeySpecifier | (() => undefined | bot_channel_aggregate_fieldsKeySpecifier),
		fields?: bot_channel_aggregate_fieldsFieldPolicy,
	},
	bot_channel_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_channel_max_fieldsKeySpecifier | (() => undefined | bot_channel_max_fieldsKeySpecifier),
		fields?: bot_channel_max_fieldsFieldPolicy,
	},
	bot_channel_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_channel_min_fieldsKeySpecifier | (() => undefined | bot_channel_min_fieldsKeySpecifier),
		fields?: bot_channel_min_fieldsFieldPolicy,
	},
	bot_channel_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_channel_mutation_responseKeySpecifier | (() => undefined | bot_channel_mutation_responseKeySpecifier),
		fields?: bot_channel_mutation_responseFieldPolicy,
	},
	bot_conversation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversationKeySpecifier | (() => undefined | bot_conversationKeySpecifier),
		fields?: bot_conversationFieldPolicy,
	},
	bot_conversation_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_aggregateKeySpecifier | (() => undefined | bot_conversation_aggregateKeySpecifier),
		fields?: bot_conversation_aggregateFieldPolicy,
	},
	bot_conversation_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_aggregate_fieldsKeySpecifier | (() => undefined | bot_conversation_aggregate_fieldsKeySpecifier),
		fields?: bot_conversation_aggregate_fieldsFieldPolicy,
	},
	bot_conversation_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_avg_fieldsKeySpecifier | (() => undefined | bot_conversation_avg_fieldsKeySpecifier),
		fields?: bot_conversation_avg_fieldsFieldPolicy,
	},
	bot_conversation_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_max_fieldsKeySpecifier | (() => undefined | bot_conversation_max_fieldsKeySpecifier),
		fields?: bot_conversation_max_fieldsFieldPolicy,
	},
	bot_conversation_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_min_fieldsKeySpecifier | (() => undefined | bot_conversation_min_fieldsKeySpecifier),
		fields?: bot_conversation_min_fieldsFieldPolicy,
	},
	bot_conversation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_mutation_responseKeySpecifier | (() => undefined | bot_conversation_mutation_responseKeySpecifier),
		fields?: bot_conversation_mutation_responseFieldPolicy,
	},
	bot_conversation_state?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_stateKeySpecifier | (() => undefined | bot_conversation_stateKeySpecifier),
		fields?: bot_conversation_stateFieldPolicy,
	},
	bot_conversation_state_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_state_aggregateKeySpecifier | (() => undefined | bot_conversation_state_aggregateKeySpecifier),
		fields?: bot_conversation_state_aggregateFieldPolicy,
	},
	bot_conversation_state_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_state_aggregate_fieldsKeySpecifier | (() => undefined | bot_conversation_state_aggregate_fieldsKeySpecifier),
		fields?: bot_conversation_state_aggregate_fieldsFieldPolicy,
	},
	bot_conversation_state_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_state_max_fieldsKeySpecifier | (() => undefined | bot_conversation_state_max_fieldsKeySpecifier),
		fields?: bot_conversation_state_max_fieldsFieldPolicy,
	},
	bot_conversation_state_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_state_min_fieldsKeySpecifier | (() => undefined | bot_conversation_state_min_fieldsKeySpecifier),
		fields?: bot_conversation_state_min_fieldsFieldPolicy,
	},
	bot_conversation_state_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_state_mutation_responseKeySpecifier | (() => undefined | bot_conversation_state_mutation_responseKeySpecifier),
		fields?: bot_conversation_state_mutation_responseFieldPolicy,
	},
	bot_conversation_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_stddev_fieldsKeySpecifier | (() => undefined | bot_conversation_stddev_fieldsKeySpecifier),
		fields?: bot_conversation_stddev_fieldsFieldPolicy,
	},
	bot_conversation_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_stddev_pop_fieldsKeySpecifier | (() => undefined | bot_conversation_stddev_pop_fieldsKeySpecifier),
		fields?: bot_conversation_stddev_pop_fieldsFieldPolicy,
	},
	bot_conversation_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_stddev_samp_fieldsKeySpecifier | (() => undefined | bot_conversation_stddev_samp_fieldsKeySpecifier),
		fields?: bot_conversation_stddev_samp_fieldsFieldPolicy,
	},
	bot_conversation_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_sum_fieldsKeySpecifier | (() => undefined | bot_conversation_sum_fieldsKeySpecifier),
		fields?: bot_conversation_sum_fieldsFieldPolicy,
	},
	bot_conversation_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_var_pop_fieldsKeySpecifier | (() => undefined | bot_conversation_var_pop_fieldsKeySpecifier),
		fields?: bot_conversation_var_pop_fieldsFieldPolicy,
	},
	bot_conversation_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_var_samp_fieldsKeySpecifier | (() => undefined | bot_conversation_var_samp_fieldsKeySpecifier),
		fields?: bot_conversation_var_samp_fieldsFieldPolicy,
	},
	bot_conversation_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_conversation_variance_fieldsKeySpecifier | (() => undefined | bot_conversation_variance_fieldsKeySpecifier),
		fields?: bot_conversation_variance_fieldsFieldPolicy,
	},
	bot_message?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_messageKeySpecifier | (() => undefined | bot_messageKeySpecifier),
		fields?: bot_messageFieldPolicy,
	},
	bot_message_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_aggregateKeySpecifier | (() => undefined | bot_message_aggregateKeySpecifier),
		fields?: bot_message_aggregateFieldPolicy,
	},
	bot_message_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_aggregate_fieldsKeySpecifier | (() => undefined | bot_message_aggregate_fieldsKeySpecifier),
		fields?: bot_message_aggregate_fieldsFieldPolicy,
	},
	bot_message_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_avg_fieldsKeySpecifier | (() => undefined | bot_message_avg_fieldsKeySpecifier),
		fields?: bot_message_avg_fieldsFieldPolicy,
	},
	bot_message_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_max_fieldsKeySpecifier | (() => undefined | bot_message_max_fieldsKeySpecifier),
		fields?: bot_message_max_fieldsFieldPolicy,
	},
	bot_message_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_min_fieldsKeySpecifier | (() => undefined | bot_message_min_fieldsKeySpecifier),
		fields?: bot_message_min_fieldsFieldPolicy,
	},
	bot_message_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_mutation_responseKeySpecifier | (() => undefined | bot_message_mutation_responseKeySpecifier),
		fields?: bot_message_mutation_responseFieldPolicy,
	},
	bot_message_status?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_statusKeySpecifier | (() => undefined | bot_message_statusKeySpecifier),
		fields?: bot_message_statusFieldPolicy,
	},
	bot_message_status_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_status_aggregateKeySpecifier | (() => undefined | bot_message_status_aggregateKeySpecifier),
		fields?: bot_message_status_aggregateFieldPolicy,
	},
	bot_message_status_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_status_aggregate_fieldsKeySpecifier | (() => undefined | bot_message_status_aggregate_fieldsKeySpecifier),
		fields?: bot_message_status_aggregate_fieldsFieldPolicy,
	},
	bot_message_status_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_status_max_fieldsKeySpecifier | (() => undefined | bot_message_status_max_fieldsKeySpecifier),
		fields?: bot_message_status_max_fieldsFieldPolicy,
	},
	bot_message_status_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_status_min_fieldsKeySpecifier | (() => undefined | bot_message_status_min_fieldsKeySpecifier),
		fields?: bot_message_status_min_fieldsFieldPolicy,
	},
	bot_message_status_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_status_mutation_responseKeySpecifier | (() => undefined | bot_message_status_mutation_responseKeySpecifier),
		fields?: bot_message_status_mutation_responseFieldPolicy,
	},
	bot_message_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_stddev_fieldsKeySpecifier | (() => undefined | bot_message_stddev_fieldsKeySpecifier),
		fields?: bot_message_stddev_fieldsFieldPolicy,
	},
	bot_message_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_stddev_pop_fieldsKeySpecifier | (() => undefined | bot_message_stddev_pop_fieldsKeySpecifier),
		fields?: bot_message_stddev_pop_fieldsFieldPolicy,
	},
	bot_message_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_stddev_samp_fieldsKeySpecifier | (() => undefined | bot_message_stddev_samp_fieldsKeySpecifier),
		fields?: bot_message_stddev_samp_fieldsFieldPolicy,
	},
	bot_message_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_sum_fieldsKeySpecifier | (() => undefined | bot_message_sum_fieldsKeySpecifier),
		fields?: bot_message_sum_fieldsFieldPolicy,
	},
	bot_message_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_var_pop_fieldsKeySpecifier | (() => undefined | bot_message_var_pop_fieldsKeySpecifier),
		fields?: bot_message_var_pop_fieldsFieldPolicy,
	},
	bot_message_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_var_samp_fieldsKeySpecifier | (() => undefined | bot_message_var_samp_fieldsKeySpecifier),
		fields?: bot_message_var_samp_fieldsFieldPolicy,
	},
	bot_message_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_message_variance_fieldsKeySpecifier | (() => undefined | bot_message_variance_fieldsKeySpecifier),
		fields?: bot_message_variance_fieldsFieldPolicy,
	},
	bot_sender?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_senderKeySpecifier | (() => undefined | bot_senderKeySpecifier),
		fields?: bot_senderFieldPolicy,
	},
	bot_sender_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_sender_aggregateKeySpecifier | (() => undefined | bot_sender_aggregateKeySpecifier),
		fields?: bot_sender_aggregateFieldPolicy,
	},
	bot_sender_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_sender_aggregate_fieldsKeySpecifier | (() => undefined | bot_sender_aggregate_fieldsKeySpecifier),
		fields?: bot_sender_aggregate_fieldsFieldPolicy,
	},
	bot_sender_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_sender_max_fieldsKeySpecifier | (() => undefined | bot_sender_max_fieldsKeySpecifier),
		fields?: bot_sender_max_fieldsFieldPolicy,
	},
	bot_sender_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_sender_min_fieldsKeySpecifier | (() => undefined | bot_sender_min_fieldsKeySpecifier),
		fields?: bot_sender_min_fieldsFieldPolicy,
	},
	bot_sender_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bot_sender_mutation_responseKeySpecifier | (() => undefined | bot_sender_mutation_responseKeySpecifier),
		fields?: bot_sender_mutation_responseFieldPolicy,
	},
	campaign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaignKeySpecifier | (() => undefined | campaignKeySpecifier),
		fields?: campaignFieldPolicy,
	},
	campaign_ad?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_adKeySpecifier | (() => undefined | campaign_adKeySpecifier),
		fields?: campaign_adFieldPolicy,
	},
	campaign_ad_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_ad_aggregateKeySpecifier | (() => undefined | campaign_ad_aggregateKeySpecifier),
		fields?: campaign_ad_aggregateFieldPolicy,
	},
	campaign_ad_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_ad_aggregate_fieldsKeySpecifier | (() => undefined | campaign_ad_aggregate_fieldsKeySpecifier),
		fields?: campaign_ad_aggregate_fieldsFieldPolicy,
	},
	campaign_ad_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_ad_max_fieldsKeySpecifier | (() => undefined | campaign_ad_max_fieldsKeySpecifier),
		fields?: campaign_ad_max_fieldsFieldPolicy,
	},
	campaign_ad_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_ad_min_fieldsKeySpecifier | (() => undefined | campaign_ad_min_fieldsKeySpecifier),
		fields?: campaign_ad_min_fieldsFieldPolicy,
	},
	campaign_ad_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_ad_mutation_responseKeySpecifier | (() => undefined | campaign_ad_mutation_responseKeySpecifier),
		fields?: campaign_ad_mutation_responseFieldPolicy,
	},
	campaign_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_aggregateKeySpecifier | (() => undefined | campaign_aggregateKeySpecifier),
		fields?: campaign_aggregateFieldPolicy,
	},
	campaign_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_aggregate_fieldsKeySpecifier | (() => undefined | campaign_aggregate_fieldsKeySpecifier),
		fields?: campaign_aggregate_fieldsFieldPolicy,
	},
	campaign_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_avg_fieldsKeySpecifier | (() => undefined | campaign_avg_fieldsKeySpecifier),
		fields?: campaign_avg_fieldsFieldPolicy,
	},
	campaign_budget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budgetKeySpecifier | (() => undefined | campaign_budgetKeySpecifier),
		fields?: campaign_budgetFieldPolicy,
	},
	campaign_budget_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_aggregateKeySpecifier | (() => undefined | campaign_budget_aggregateKeySpecifier),
		fields?: campaign_budget_aggregateFieldPolicy,
	},
	campaign_budget_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_aggregate_fieldsKeySpecifier | (() => undefined | campaign_budget_aggregate_fieldsKeySpecifier),
		fields?: campaign_budget_aggregate_fieldsFieldPolicy,
	},
	campaign_budget_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_avg_fieldsKeySpecifier | (() => undefined | campaign_budget_avg_fieldsKeySpecifier),
		fields?: campaign_budget_avg_fieldsFieldPolicy,
	},
	campaign_budget_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_max_fieldsKeySpecifier | (() => undefined | campaign_budget_max_fieldsKeySpecifier),
		fields?: campaign_budget_max_fieldsFieldPolicy,
	},
	campaign_budget_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_min_fieldsKeySpecifier | (() => undefined | campaign_budget_min_fieldsKeySpecifier),
		fields?: campaign_budget_min_fieldsFieldPolicy,
	},
	campaign_budget_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_mutation_responseKeySpecifier | (() => undefined | campaign_budget_mutation_responseKeySpecifier),
		fields?: campaign_budget_mutation_responseFieldPolicy,
	},
	campaign_budget_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_stddev_fieldsKeySpecifier | (() => undefined | campaign_budget_stddev_fieldsKeySpecifier),
		fields?: campaign_budget_stddev_fieldsFieldPolicy,
	},
	campaign_budget_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_stddev_pop_fieldsKeySpecifier | (() => undefined | campaign_budget_stddev_pop_fieldsKeySpecifier),
		fields?: campaign_budget_stddev_pop_fieldsFieldPolicy,
	},
	campaign_budget_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_stddev_samp_fieldsKeySpecifier | (() => undefined | campaign_budget_stddev_samp_fieldsKeySpecifier),
		fields?: campaign_budget_stddev_samp_fieldsFieldPolicy,
	},
	campaign_budget_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_sum_fieldsKeySpecifier | (() => undefined | campaign_budget_sum_fieldsKeySpecifier),
		fields?: campaign_budget_sum_fieldsFieldPolicy,
	},
	campaign_budget_transaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transactionKeySpecifier | (() => undefined | campaign_budget_transactionKeySpecifier),
		fields?: campaign_budget_transactionFieldPolicy,
	},
	campaign_budget_transaction_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_aggregateKeySpecifier | (() => undefined | campaign_budget_transaction_aggregateKeySpecifier),
		fields?: campaign_budget_transaction_aggregateFieldPolicy,
	},
	campaign_budget_transaction_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_aggregate_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_aggregate_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_aggregate_fieldsFieldPolicy,
	},
	campaign_budget_transaction_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_avg_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_avg_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_avg_fieldsFieldPolicy,
	},
	campaign_budget_transaction_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_max_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_max_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_max_fieldsFieldPolicy,
	},
	campaign_budget_transaction_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_min_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_min_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_min_fieldsFieldPolicy,
	},
	campaign_budget_transaction_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_mutation_responseKeySpecifier | (() => undefined | campaign_budget_transaction_mutation_responseKeySpecifier),
		fields?: campaign_budget_transaction_mutation_responseFieldPolicy,
	},
	campaign_budget_transaction_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_stddev_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_stddev_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_stddev_fieldsFieldPolicy,
	},
	campaign_budget_transaction_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_stddev_pop_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_stddev_pop_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_stddev_pop_fieldsFieldPolicy,
	},
	campaign_budget_transaction_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_stddev_samp_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_stddev_samp_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_stddev_samp_fieldsFieldPolicy,
	},
	campaign_budget_transaction_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_sum_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_sum_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_sum_fieldsFieldPolicy,
	},
	campaign_budget_transaction_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_var_pop_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_var_pop_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_var_pop_fieldsFieldPolicy,
	},
	campaign_budget_transaction_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_var_samp_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_var_samp_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_var_samp_fieldsFieldPolicy,
	},
	campaign_budget_transaction_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_transaction_variance_fieldsKeySpecifier | (() => undefined | campaign_budget_transaction_variance_fieldsKeySpecifier),
		fields?: campaign_budget_transaction_variance_fieldsFieldPolicy,
	},
	campaign_budget_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_var_pop_fieldsKeySpecifier | (() => undefined | campaign_budget_var_pop_fieldsKeySpecifier),
		fields?: campaign_budget_var_pop_fieldsFieldPolicy,
	},
	campaign_budget_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_var_samp_fieldsKeySpecifier | (() => undefined | campaign_budget_var_samp_fieldsKeySpecifier),
		fields?: campaign_budget_var_samp_fieldsFieldPolicy,
	},
	campaign_budget_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_budget_variance_fieldsKeySpecifier | (() => undefined | campaign_budget_variance_fieldsKeySpecifier),
		fields?: campaign_budget_variance_fieldsFieldPolicy,
	},
	campaign_email_template_overwrite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_email_template_overwriteKeySpecifier | (() => undefined | campaign_email_template_overwriteKeySpecifier),
		fields?: campaign_email_template_overwriteFieldPolicy,
	},
	campaign_email_template_overwrite_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_email_template_overwrite_aggregateKeySpecifier | (() => undefined | campaign_email_template_overwrite_aggregateKeySpecifier),
		fields?: campaign_email_template_overwrite_aggregateFieldPolicy,
	},
	campaign_email_template_overwrite_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_email_template_overwrite_aggregate_fieldsKeySpecifier | (() => undefined | campaign_email_template_overwrite_aggregate_fieldsKeySpecifier),
		fields?: campaign_email_template_overwrite_aggregate_fieldsFieldPolicy,
	},
	campaign_email_template_overwrite_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_email_template_overwrite_max_fieldsKeySpecifier | (() => undefined | campaign_email_template_overwrite_max_fieldsKeySpecifier),
		fields?: campaign_email_template_overwrite_max_fieldsFieldPolicy,
	},
	campaign_email_template_overwrite_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_email_template_overwrite_min_fieldsKeySpecifier | (() => undefined | campaign_email_template_overwrite_min_fieldsKeySpecifier),
		fields?: campaign_email_template_overwrite_min_fieldsFieldPolicy,
	},
	campaign_email_template_overwrite_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_email_template_overwrite_mutation_responseKeySpecifier | (() => undefined | campaign_email_template_overwrite_mutation_responseKeySpecifier),
		fields?: campaign_email_template_overwrite_mutation_responseFieldPolicy,
	},
	campaign_event_log?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_logKeySpecifier | (() => undefined | campaign_event_logKeySpecifier),
		fields?: campaign_event_logFieldPolicy,
	},
	campaign_event_log_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_aggregateKeySpecifier | (() => undefined | campaign_event_log_aggregateKeySpecifier),
		fields?: campaign_event_log_aggregateFieldPolicy,
	},
	campaign_event_log_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_aggregate_fieldsKeySpecifier | (() => undefined | campaign_event_log_aggregate_fieldsKeySpecifier),
		fields?: campaign_event_log_aggregate_fieldsFieldPolicy,
	},
	campaign_event_log_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_avg_fieldsKeySpecifier | (() => undefined | campaign_event_log_avg_fieldsKeySpecifier),
		fields?: campaign_event_log_avg_fieldsFieldPolicy,
	},
	campaign_event_log_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_max_fieldsKeySpecifier | (() => undefined | campaign_event_log_max_fieldsKeySpecifier),
		fields?: campaign_event_log_max_fieldsFieldPolicy,
	},
	campaign_event_log_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_min_fieldsKeySpecifier | (() => undefined | campaign_event_log_min_fieldsKeySpecifier),
		fields?: campaign_event_log_min_fieldsFieldPolicy,
	},
	campaign_event_log_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_mutation_responseKeySpecifier | (() => undefined | campaign_event_log_mutation_responseKeySpecifier),
		fields?: campaign_event_log_mutation_responseFieldPolicy,
	},
	campaign_event_log_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_stddev_fieldsKeySpecifier | (() => undefined | campaign_event_log_stddev_fieldsKeySpecifier),
		fields?: campaign_event_log_stddev_fieldsFieldPolicy,
	},
	campaign_event_log_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_stddev_pop_fieldsKeySpecifier | (() => undefined | campaign_event_log_stddev_pop_fieldsKeySpecifier),
		fields?: campaign_event_log_stddev_pop_fieldsFieldPolicy,
	},
	campaign_event_log_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_stddev_samp_fieldsKeySpecifier | (() => undefined | campaign_event_log_stddev_samp_fieldsKeySpecifier),
		fields?: campaign_event_log_stddev_samp_fieldsFieldPolicy,
	},
	campaign_event_log_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_sum_fieldsKeySpecifier | (() => undefined | campaign_event_log_sum_fieldsKeySpecifier),
		fields?: campaign_event_log_sum_fieldsFieldPolicy,
	},
	campaign_event_log_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_var_pop_fieldsKeySpecifier | (() => undefined | campaign_event_log_var_pop_fieldsKeySpecifier),
		fields?: campaign_event_log_var_pop_fieldsFieldPolicy,
	},
	campaign_event_log_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_var_samp_fieldsKeySpecifier | (() => undefined | campaign_event_log_var_samp_fieldsKeySpecifier),
		fields?: campaign_event_log_var_samp_fieldsFieldPolicy,
	},
	campaign_event_log_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_event_log_variance_fieldsKeySpecifier | (() => undefined | campaign_event_log_variance_fieldsKeySpecifier),
		fields?: campaign_event_log_variance_fieldsFieldPolicy,
	},
	campaign_iso_2_country_codes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_iso_2_country_codesKeySpecifier | (() => undefined | campaign_iso_2_country_codesKeySpecifier),
		fields?: campaign_iso_2_country_codesFieldPolicy,
	},
	campaign_iso_2_country_codes_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_iso_2_country_codes_aggregateKeySpecifier | (() => undefined | campaign_iso_2_country_codes_aggregateKeySpecifier),
		fields?: campaign_iso_2_country_codes_aggregateFieldPolicy,
	},
	campaign_iso_2_country_codes_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_iso_2_country_codes_aggregate_fieldsKeySpecifier | (() => undefined | campaign_iso_2_country_codes_aggregate_fieldsKeySpecifier),
		fields?: campaign_iso_2_country_codes_aggregate_fieldsFieldPolicy,
	},
	campaign_iso_2_country_codes_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_iso_2_country_codes_max_fieldsKeySpecifier | (() => undefined | campaign_iso_2_country_codes_max_fieldsKeySpecifier),
		fields?: campaign_iso_2_country_codes_max_fieldsFieldPolicy,
	},
	campaign_iso_2_country_codes_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_iso_2_country_codes_min_fieldsKeySpecifier | (() => undefined | campaign_iso_2_country_codes_min_fieldsKeySpecifier),
		fields?: campaign_iso_2_country_codes_min_fieldsFieldPolicy,
	},
	campaign_iso_2_country_codes_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_iso_2_country_codes_mutation_responseKeySpecifier | (() => undefined | campaign_iso_2_country_codes_mutation_responseKeySpecifier),
		fields?: campaign_iso_2_country_codes_mutation_responseFieldPolicy,
	},
	campaign_job_description?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_job_descriptionKeySpecifier | (() => undefined | campaign_job_descriptionKeySpecifier),
		fields?: campaign_job_descriptionFieldPolicy,
	},
	campaign_job_description_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_job_description_aggregateKeySpecifier | (() => undefined | campaign_job_description_aggregateKeySpecifier),
		fields?: campaign_job_description_aggregateFieldPolicy,
	},
	campaign_job_description_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_job_description_aggregate_fieldsKeySpecifier | (() => undefined | campaign_job_description_aggregate_fieldsKeySpecifier),
		fields?: campaign_job_description_aggregate_fieldsFieldPolicy,
	},
	campaign_job_description_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_job_description_max_fieldsKeySpecifier | (() => undefined | campaign_job_description_max_fieldsKeySpecifier),
		fields?: campaign_job_description_max_fieldsFieldPolicy,
	},
	campaign_job_description_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_job_description_min_fieldsKeySpecifier | (() => undefined | campaign_job_description_min_fieldsKeySpecifier),
		fields?: campaign_job_description_min_fieldsFieldPolicy,
	},
	campaign_job_description_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_job_description_mutation_responseKeySpecifier | (() => undefined | campaign_job_description_mutation_responseKeySpecifier),
		fields?: campaign_job_description_mutation_responseFieldPolicy,
	},
	campaign_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_max_fieldsKeySpecifier | (() => undefined | campaign_max_fieldsKeySpecifier),
		fields?: campaign_max_fieldsFieldPolicy,
	},
	campaign_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_min_fieldsKeySpecifier | (() => undefined | campaign_min_fieldsKeySpecifier),
		fields?: campaign_min_fieldsFieldPolicy,
	},
	campaign_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_mutation_responseKeySpecifier | (() => undefined | campaign_mutation_responseKeySpecifier),
		fields?: campaign_mutation_responseFieldPolicy,
	},
	campaign_order?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_orderKeySpecifier | (() => undefined | campaign_orderKeySpecifier),
		fields?: campaign_orderFieldPolicy,
	},
	campaign_order_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_aggregateKeySpecifier | (() => undefined | campaign_order_aggregateKeySpecifier),
		fields?: campaign_order_aggregateFieldPolicy,
	},
	campaign_order_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_aggregate_fieldsKeySpecifier | (() => undefined | campaign_order_aggregate_fieldsKeySpecifier),
		fields?: campaign_order_aggregate_fieldsFieldPolicy,
	},
	campaign_order_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_avg_fieldsKeySpecifier | (() => undefined | campaign_order_avg_fieldsKeySpecifier),
		fields?: campaign_order_avg_fieldsFieldPolicy,
	},
	campaign_order_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_max_fieldsKeySpecifier | (() => undefined | campaign_order_max_fieldsKeySpecifier),
		fields?: campaign_order_max_fieldsFieldPolicy,
	},
	campaign_order_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_min_fieldsKeySpecifier | (() => undefined | campaign_order_min_fieldsKeySpecifier),
		fields?: campaign_order_min_fieldsFieldPolicy,
	},
	campaign_order_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_mutation_responseKeySpecifier | (() => undefined | campaign_order_mutation_responseKeySpecifier),
		fields?: campaign_order_mutation_responseFieldPolicy,
	},
	campaign_order_source?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_sourceKeySpecifier | (() => undefined | campaign_order_sourceKeySpecifier),
		fields?: campaign_order_sourceFieldPolicy,
	},
	campaign_order_source_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_aggregateKeySpecifier | (() => undefined | campaign_order_source_aggregateKeySpecifier),
		fields?: campaign_order_source_aggregateFieldPolicy,
	},
	campaign_order_source_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_aggregate_fieldsKeySpecifier | (() => undefined | campaign_order_source_aggregate_fieldsKeySpecifier),
		fields?: campaign_order_source_aggregate_fieldsFieldPolicy,
	},
	campaign_order_source_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_avg_fieldsKeySpecifier | (() => undefined | campaign_order_source_avg_fieldsKeySpecifier),
		fields?: campaign_order_source_avg_fieldsFieldPolicy,
	},
	campaign_order_source_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_max_fieldsKeySpecifier | (() => undefined | campaign_order_source_max_fieldsKeySpecifier),
		fields?: campaign_order_source_max_fieldsFieldPolicy,
	},
	campaign_order_source_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_min_fieldsKeySpecifier | (() => undefined | campaign_order_source_min_fieldsKeySpecifier),
		fields?: campaign_order_source_min_fieldsFieldPolicy,
	},
	campaign_order_source_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_mutation_responseKeySpecifier | (() => undefined | campaign_order_source_mutation_responseKeySpecifier),
		fields?: campaign_order_source_mutation_responseFieldPolicy,
	},
	campaign_order_source_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_stddev_fieldsKeySpecifier | (() => undefined | campaign_order_source_stddev_fieldsKeySpecifier),
		fields?: campaign_order_source_stddev_fieldsFieldPolicy,
	},
	campaign_order_source_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_stddev_pop_fieldsKeySpecifier | (() => undefined | campaign_order_source_stddev_pop_fieldsKeySpecifier),
		fields?: campaign_order_source_stddev_pop_fieldsFieldPolicy,
	},
	campaign_order_source_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_stddev_samp_fieldsKeySpecifier | (() => undefined | campaign_order_source_stddev_samp_fieldsKeySpecifier),
		fields?: campaign_order_source_stddev_samp_fieldsFieldPolicy,
	},
	campaign_order_source_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_sum_fieldsKeySpecifier | (() => undefined | campaign_order_source_sum_fieldsKeySpecifier),
		fields?: campaign_order_source_sum_fieldsFieldPolicy,
	},
	campaign_order_source_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_typeKeySpecifier | (() => undefined | campaign_order_source_typeKeySpecifier),
		fields?: campaign_order_source_typeFieldPolicy,
	},
	campaign_order_source_type_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_type_aggregateKeySpecifier | (() => undefined | campaign_order_source_type_aggregateKeySpecifier),
		fields?: campaign_order_source_type_aggregateFieldPolicy,
	},
	campaign_order_source_type_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_type_aggregate_fieldsKeySpecifier | (() => undefined | campaign_order_source_type_aggregate_fieldsKeySpecifier),
		fields?: campaign_order_source_type_aggregate_fieldsFieldPolicy,
	},
	campaign_order_source_type_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_type_max_fieldsKeySpecifier | (() => undefined | campaign_order_source_type_max_fieldsKeySpecifier),
		fields?: campaign_order_source_type_max_fieldsFieldPolicy,
	},
	campaign_order_source_type_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_type_min_fieldsKeySpecifier | (() => undefined | campaign_order_source_type_min_fieldsKeySpecifier),
		fields?: campaign_order_source_type_min_fieldsFieldPolicy,
	},
	campaign_order_source_type_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_type_mutation_responseKeySpecifier | (() => undefined | campaign_order_source_type_mutation_responseKeySpecifier),
		fields?: campaign_order_source_type_mutation_responseFieldPolicy,
	},
	campaign_order_source_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_var_pop_fieldsKeySpecifier | (() => undefined | campaign_order_source_var_pop_fieldsKeySpecifier),
		fields?: campaign_order_source_var_pop_fieldsFieldPolicy,
	},
	campaign_order_source_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_var_samp_fieldsKeySpecifier | (() => undefined | campaign_order_source_var_samp_fieldsKeySpecifier),
		fields?: campaign_order_source_var_samp_fieldsFieldPolicy,
	},
	campaign_order_source_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_source_variance_fieldsKeySpecifier | (() => undefined | campaign_order_source_variance_fieldsKeySpecifier),
		fields?: campaign_order_source_variance_fieldsFieldPolicy,
	},
	campaign_order_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_stddev_fieldsKeySpecifier | (() => undefined | campaign_order_stddev_fieldsKeySpecifier),
		fields?: campaign_order_stddev_fieldsFieldPolicy,
	},
	campaign_order_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_stddev_pop_fieldsKeySpecifier | (() => undefined | campaign_order_stddev_pop_fieldsKeySpecifier),
		fields?: campaign_order_stddev_pop_fieldsFieldPolicy,
	},
	campaign_order_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_stddev_samp_fieldsKeySpecifier | (() => undefined | campaign_order_stddev_samp_fieldsKeySpecifier),
		fields?: campaign_order_stddev_samp_fieldsFieldPolicy,
	},
	campaign_order_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_sum_fieldsKeySpecifier | (() => undefined | campaign_order_sum_fieldsKeySpecifier),
		fields?: campaign_order_sum_fieldsFieldPolicy,
	},
	campaign_order_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_var_pop_fieldsKeySpecifier | (() => undefined | campaign_order_var_pop_fieldsKeySpecifier),
		fields?: campaign_order_var_pop_fieldsFieldPolicy,
	},
	campaign_order_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_var_samp_fieldsKeySpecifier | (() => undefined | campaign_order_var_samp_fieldsKeySpecifier),
		fields?: campaign_order_var_samp_fieldsFieldPolicy,
	},
	campaign_order_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_order_variance_fieldsKeySpecifier | (() => undefined | campaign_order_variance_fieldsKeySpecifier),
		fields?: campaign_order_variance_fieldsFieldPolicy,
	},
	campaign_routing_destination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destinationKeySpecifier | (() => undefined | campaign_routing_destinationKeySpecifier),
		fields?: campaign_routing_destinationFieldPolicy,
	},
	campaign_routing_destination_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_aggregateKeySpecifier | (() => undefined | campaign_routing_destination_aggregateKeySpecifier),
		fields?: campaign_routing_destination_aggregateFieldPolicy,
	},
	campaign_routing_destination_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_aggregate_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_aggregate_fieldsKeySpecifier),
		fields?: campaign_routing_destination_aggregate_fieldsFieldPolicy,
	},
	campaign_routing_destination_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_avg_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_avg_fieldsKeySpecifier),
		fields?: campaign_routing_destination_avg_fieldsFieldPolicy,
	},
	campaign_routing_destination_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_max_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_max_fieldsKeySpecifier),
		fields?: campaign_routing_destination_max_fieldsFieldPolicy,
	},
	campaign_routing_destination_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_min_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_min_fieldsKeySpecifier),
		fields?: campaign_routing_destination_min_fieldsFieldPolicy,
	},
	campaign_routing_destination_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_mutation_responseKeySpecifier | (() => undefined | campaign_routing_destination_mutation_responseKeySpecifier),
		fields?: campaign_routing_destination_mutation_responseFieldPolicy,
	},
	campaign_routing_destination_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_stddev_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_stddev_fieldsKeySpecifier),
		fields?: campaign_routing_destination_stddev_fieldsFieldPolicy,
	},
	campaign_routing_destination_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_stddev_pop_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_stddev_pop_fieldsKeySpecifier),
		fields?: campaign_routing_destination_stddev_pop_fieldsFieldPolicy,
	},
	campaign_routing_destination_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_stddev_samp_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_stddev_samp_fieldsKeySpecifier),
		fields?: campaign_routing_destination_stddev_samp_fieldsFieldPolicy,
	},
	campaign_routing_destination_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_sum_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_sum_fieldsKeySpecifier),
		fields?: campaign_routing_destination_sum_fieldsFieldPolicy,
	},
	campaign_routing_destination_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_var_pop_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_var_pop_fieldsKeySpecifier),
		fields?: campaign_routing_destination_var_pop_fieldsFieldPolicy,
	},
	campaign_routing_destination_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_var_samp_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_var_samp_fieldsKeySpecifier),
		fields?: campaign_routing_destination_var_samp_fieldsFieldPolicy,
	},
	campaign_routing_destination_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_destination_variance_fieldsKeySpecifier | (() => undefined | campaign_routing_destination_variance_fieldsKeySpecifier),
		fields?: campaign_routing_destination_variance_fieldsFieldPolicy,
	},
	campaign_routing_info?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_infoKeySpecifier | (() => undefined | campaign_routing_infoKeySpecifier),
		fields?: campaign_routing_infoFieldPolicy,
	},
	campaign_routing_info_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_aggregateKeySpecifier | (() => undefined | campaign_routing_info_aggregateKeySpecifier),
		fields?: campaign_routing_info_aggregateFieldPolicy,
	},
	campaign_routing_info_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_aggregate_fieldsKeySpecifier | (() => undefined | campaign_routing_info_aggregate_fieldsKeySpecifier),
		fields?: campaign_routing_info_aggregate_fieldsFieldPolicy,
	},
	campaign_routing_info_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_avg_fieldsKeySpecifier | (() => undefined | campaign_routing_info_avg_fieldsKeySpecifier),
		fields?: campaign_routing_info_avg_fieldsFieldPolicy,
	},
	campaign_routing_info_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_max_fieldsKeySpecifier | (() => undefined | campaign_routing_info_max_fieldsKeySpecifier),
		fields?: campaign_routing_info_max_fieldsFieldPolicy,
	},
	campaign_routing_info_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_min_fieldsKeySpecifier | (() => undefined | campaign_routing_info_min_fieldsKeySpecifier),
		fields?: campaign_routing_info_min_fieldsFieldPolicy,
	},
	campaign_routing_info_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_mutation_responseKeySpecifier | (() => undefined | campaign_routing_info_mutation_responseKeySpecifier),
		fields?: campaign_routing_info_mutation_responseFieldPolicy,
	},
	campaign_routing_info_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_stddev_fieldsKeySpecifier | (() => undefined | campaign_routing_info_stddev_fieldsKeySpecifier),
		fields?: campaign_routing_info_stddev_fieldsFieldPolicy,
	},
	campaign_routing_info_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_stddev_pop_fieldsKeySpecifier | (() => undefined | campaign_routing_info_stddev_pop_fieldsKeySpecifier),
		fields?: campaign_routing_info_stddev_pop_fieldsFieldPolicy,
	},
	campaign_routing_info_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_stddev_samp_fieldsKeySpecifier | (() => undefined | campaign_routing_info_stddev_samp_fieldsKeySpecifier),
		fields?: campaign_routing_info_stddev_samp_fieldsFieldPolicy,
	},
	campaign_routing_info_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_sum_fieldsKeySpecifier | (() => undefined | campaign_routing_info_sum_fieldsKeySpecifier),
		fields?: campaign_routing_info_sum_fieldsFieldPolicy,
	},
	campaign_routing_info_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_var_pop_fieldsKeySpecifier | (() => undefined | campaign_routing_info_var_pop_fieldsKeySpecifier),
		fields?: campaign_routing_info_var_pop_fieldsFieldPolicy,
	},
	campaign_routing_info_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_var_samp_fieldsKeySpecifier | (() => undefined | campaign_routing_info_var_samp_fieldsKeySpecifier),
		fields?: campaign_routing_info_var_samp_fieldsFieldPolicy,
	},
	campaign_routing_info_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_info_variance_fieldsKeySpecifier | (() => undefined | campaign_routing_info_variance_fieldsKeySpecifier),
		fields?: campaign_routing_info_variance_fieldsFieldPolicy,
	},
	campaign_routing_zipcode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcodeKeySpecifier | (() => undefined | campaign_routing_zipcodeKeySpecifier),
		fields?: campaign_routing_zipcodeFieldPolicy,
	},
	campaign_routing_zipcode_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_aggregateKeySpecifier | (() => undefined | campaign_routing_zipcode_aggregateKeySpecifier),
		fields?: campaign_routing_zipcode_aggregateFieldPolicy,
	},
	campaign_routing_zipcode_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_aggregate_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_aggregate_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_aggregate_fieldsFieldPolicy,
	},
	campaign_routing_zipcode_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_avg_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_avg_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_avg_fieldsFieldPolicy,
	},
	campaign_routing_zipcode_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_max_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_max_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_max_fieldsFieldPolicy,
	},
	campaign_routing_zipcode_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_min_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_min_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_min_fieldsFieldPolicy,
	},
	campaign_routing_zipcode_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_mutation_responseKeySpecifier | (() => undefined | campaign_routing_zipcode_mutation_responseKeySpecifier),
		fields?: campaign_routing_zipcode_mutation_responseFieldPolicy,
	},
	campaign_routing_zipcode_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_stddev_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_stddev_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_stddev_fieldsFieldPolicy,
	},
	campaign_routing_zipcode_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_stddev_pop_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_stddev_pop_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_stddev_pop_fieldsFieldPolicy,
	},
	campaign_routing_zipcode_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_stddev_samp_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_stddev_samp_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_stddev_samp_fieldsFieldPolicy,
	},
	campaign_routing_zipcode_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_sum_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_sum_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_sum_fieldsFieldPolicy,
	},
	campaign_routing_zipcode_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_var_pop_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_var_pop_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_var_pop_fieldsFieldPolicy,
	},
	campaign_routing_zipcode_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_var_samp_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_var_samp_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_var_samp_fieldsFieldPolicy,
	},
	campaign_routing_zipcode_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_routing_zipcode_variance_fieldsKeySpecifier | (() => undefined | campaign_routing_zipcode_variance_fieldsKeySpecifier),
		fields?: campaign_routing_zipcode_variance_fieldsFieldPolicy,
	},
	campaign_settings_override?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_settings_overrideKeySpecifier | (() => undefined | campaign_settings_overrideKeySpecifier),
		fields?: campaign_settings_overrideFieldPolicy,
	},
	campaign_settings_override_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_settings_override_aggregateKeySpecifier | (() => undefined | campaign_settings_override_aggregateKeySpecifier),
		fields?: campaign_settings_override_aggregateFieldPolicy,
	},
	campaign_settings_override_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_settings_override_aggregate_fieldsKeySpecifier | (() => undefined | campaign_settings_override_aggregate_fieldsKeySpecifier),
		fields?: campaign_settings_override_aggregate_fieldsFieldPolicy,
	},
	campaign_settings_override_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_settings_override_max_fieldsKeySpecifier | (() => undefined | campaign_settings_override_max_fieldsKeySpecifier),
		fields?: campaign_settings_override_max_fieldsFieldPolicy,
	},
	campaign_settings_override_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_settings_override_min_fieldsKeySpecifier | (() => undefined | campaign_settings_override_min_fieldsKeySpecifier),
		fields?: campaign_settings_override_min_fieldsFieldPolicy,
	},
	campaign_settings_override_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_settings_override_mutation_responseKeySpecifier | (() => undefined | campaign_settings_override_mutation_responseKeySpecifier),
		fields?: campaign_settings_override_mutation_responseFieldPolicy,
	},
	campaign_status?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_statusKeySpecifier | (() => undefined | campaign_statusKeySpecifier),
		fields?: campaign_statusFieldPolicy,
	},
	campaign_status_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_aggregateKeySpecifier | (() => undefined | campaign_status_aggregateKeySpecifier),
		fields?: campaign_status_aggregateFieldPolicy,
	},
	campaign_status_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_aggregate_fieldsKeySpecifier | (() => undefined | campaign_status_aggregate_fieldsKeySpecifier),
		fields?: campaign_status_aggregate_fieldsFieldPolicy,
	},
	campaign_status_event?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_eventKeySpecifier | (() => undefined | campaign_status_eventKeySpecifier),
		fields?: campaign_status_eventFieldPolicy,
	},
	campaign_status_event_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_event_aggregateKeySpecifier | (() => undefined | campaign_status_event_aggregateKeySpecifier),
		fields?: campaign_status_event_aggregateFieldPolicy,
	},
	campaign_status_event_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_event_aggregate_fieldsKeySpecifier | (() => undefined | campaign_status_event_aggregate_fieldsKeySpecifier),
		fields?: campaign_status_event_aggregate_fieldsFieldPolicy,
	},
	campaign_status_event_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_event_max_fieldsKeySpecifier | (() => undefined | campaign_status_event_max_fieldsKeySpecifier),
		fields?: campaign_status_event_max_fieldsFieldPolicy,
	},
	campaign_status_event_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_event_min_fieldsKeySpecifier | (() => undefined | campaign_status_event_min_fieldsKeySpecifier),
		fields?: campaign_status_event_min_fieldsFieldPolicy,
	},
	campaign_status_event_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_event_mutation_responseKeySpecifier | (() => undefined | campaign_status_event_mutation_responseKeySpecifier),
		fields?: campaign_status_event_mutation_responseFieldPolicy,
	},
	campaign_status_log?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_logKeySpecifier | (() => undefined | campaign_status_logKeySpecifier),
		fields?: campaign_status_logFieldPolicy,
	},
	campaign_status_log_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_log_aggregateKeySpecifier | (() => undefined | campaign_status_log_aggregateKeySpecifier),
		fields?: campaign_status_log_aggregateFieldPolicy,
	},
	campaign_status_log_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_log_aggregate_fieldsKeySpecifier | (() => undefined | campaign_status_log_aggregate_fieldsKeySpecifier),
		fields?: campaign_status_log_aggregate_fieldsFieldPolicy,
	},
	campaign_status_log_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_log_max_fieldsKeySpecifier | (() => undefined | campaign_status_log_max_fieldsKeySpecifier),
		fields?: campaign_status_log_max_fieldsFieldPolicy,
	},
	campaign_status_log_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_log_min_fieldsKeySpecifier | (() => undefined | campaign_status_log_min_fieldsKeySpecifier),
		fields?: campaign_status_log_min_fieldsFieldPolicy,
	},
	campaign_status_log_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_log_mutation_responseKeySpecifier | (() => undefined | campaign_status_log_mutation_responseKeySpecifier),
		fields?: campaign_status_log_mutation_responseFieldPolicy,
	},
	campaign_status_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_max_fieldsKeySpecifier | (() => undefined | campaign_status_max_fieldsKeySpecifier),
		fields?: campaign_status_max_fieldsFieldPolicy,
	},
	campaign_status_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_min_fieldsKeySpecifier | (() => undefined | campaign_status_min_fieldsKeySpecifier),
		fields?: campaign_status_min_fieldsFieldPolicy,
	},
	campaign_status_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_status_mutation_responseKeySpecifier | (() => undefined | campaign_status_mutation_responseKeySpecifier),
		fields?: campaign_status_mutation_responseFieldPolicy,
	},
	campaign_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_stddev_fieldsKeySpecifier | (() => undefined | campaign_stddev_fieldsKeySpecifier),
		fields?: campaign_stddev_fieldsFieldPolicy,
	},
	campaign_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_stddev_pop_fieldsKeySpecifier | (() => undefined | campaign_stddev_pop_fieldsKeySpecifier),
		fields?: campaign_stddev_pop_fieldsFieldPolicy,
	},
	campaign_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_stddev_samp_fieldsKeySpecifier | (() => undefined | campaign_stddev_samp_fieldsKeySpecifier),
		fields?: campaign_stddev_samp_fieldsFieldPolicy,
	},
	campaign_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_sum_fieldsKeySpecifier | (() => undefined | campaign_sum_fieldsKeySpecifier),
		fields?: campaign_sum_fieldsFieldPolicy,
	},
	campaign_transaction_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_transaction_typeKeySpecifier | (() => undefined | campaign_transaction_typeKeySpecifier),
		fields?: campaign_transaction_typeFieldPolicy,
	},
	campaign_transaction_type_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_transaction_type_aggregateKeySpecifier | (() => undefined | campaign_transaction_type_aggregateKeySpecifier),
		fields?: campaign_transaction_type_aggregateFieldPolicy,
	},
	campaign_transaction_type_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_transaction_type_aggregate_fieldsKeySpecifier | (() => undefined | campaign_transaction_type_aggregate_fieldsKeySpecifier),
		fields?: campaign_transaction_type_aggregate_fieldsFieldPolicy,
	},
	campaign_transaction_type_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_transaction_type_max_fieldsKeySpecifier | (() => undefined | campaign_transaction_type_max_fieldsKeySpecifier),
		fields?: campaign_transaction_type_max_fieldsFieldPolicy,
	},
	campaign_transaction_type_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_transaction_type_min_fieldsKeySpecifier | (() => undefined | campaign_transaction_type_min_fieldsKeySpecifier),
		fields?: campaign_transaction_type_min_fieldsFieldPolicy,
	},
	campaign_transaction_type_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_transaction_type_mutation_responseKeySpecifier | (() => undefined | campaign_transaction_type_mutation_responseKeySpecifier),
		fields?: campaign_transaction_type_mutation_responseFieldPolicy,
	},
	campaign_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_var_pop_fieldsKeySpecifier | (() => undefined | campaign_var_pop_fieldsKeySpecifier),
		fields?: campaign_var_pop_fieldsFieldPolicy,
	},
	campaign_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_var_samp_fieldsKeySpecifier | (() => undefined | campaign_var_samp_fieldsKeySpecifier),
		fields?: campaign_var_samp_fieldsFieldPolicy,
	},
	campaign_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_variance_fieldsKeySpecifier | (() => undefined | campaign_variance_fieldsKeySpecifier),
		fields?: campaign_variance_fieldsFieldPolicy,
	},
	campaign_work_location?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_work_locationKeySpecifier | (() => undefined | campaign_work_locationKeySpecifier),
		fields?: campaign_work_locationFieldPolicy,
	},
	campaign_work_location_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_work_location_aggregateKeySpecifier | (() => undefined | campaign_work_location_aggregateKeySpecifier),
		fields?: campaign_work_location_aggregateFieldPolicy,
	},
	campaign_work_location_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_work_location_aggregate_fieldsKeySpecifier | (() => undefined | campaign_work_location_aggregate_fieldsKeySpecifier),
		fields?: campaign_work_location_aggregate_fieldsFieldPolicy,
	},
	campaign_work_location_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_work_location_max_fieldsKeySpecifier | (() => undefined | campaign_work_location_max_fieldsKeySpecifier),
		fields?: campaign_work_location_max_fieldsFieldPolicy,
	},
	campaign_work_location_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_work_location_min_fieldsKeySpecifier | (() => undefined | campaign_work_location_min_fieldsKeySpecifier),
		fields?: campaign_work_location_min_fieldsFieldPolicy,
	},
	campaign_work_location_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | campaign_work_location_mutation_responseKeySpecifier | (() => undefined | campaign_work_location_mutation_responseKeySpecifier),
		fields?: campaign_work_location_mutation_responseFieldPolicy,
	},
	chat_bot_customers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customersKeySpecifier | (() => undefined | chat_bot_customersKeySpecifier),
		fields?: chat_bot_customersFieldPolicy,
	},
	chat_bot_customers_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_aggregateKeySpecifier | (() => undefined | chat_bot_customers_aggregateKeySpecifier),
		fields?: chat_bot_customers_aggregateFieldPolicy,
	},
	chat_bot_customers_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_aggregate_fieldsKeySpecifier | (() => undefined | chat_bot_customers_aggregate_fieldsKeySpecifier),
		fields?: chat_bot_customers_aggregate_fieldsFieldPolicy,
	},
	chat_bot_customers_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_avg_fieldsKeySpecifier | (() => undefined | chat_bot_customers_avg_fieldsKeySpecifier),
		fields?: chat_bot_customers_avg_fieldsFieldPolicy,
	},
	chat_bot_customers_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_max_fieldsKeySpecifier | (() => undefined | chat_bot_customers_max_fieldsKeySpecifier),
		fields?: chat_bot_customers_max_fieldsFieldPolicy,
	},
	chat_bot_customers_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_min_fieldsKeySpecifier | (() => undefined | chat_bot_customers_min_fieldsKeySpecifier),
		fields?: chat_bot_customers_min_fieldsFieldPolicy,
	},
	chat_bot_customers_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_mutation_responseKeySpecifier | (() => undefined | chat_bot_customers_mutation_responseKeySpecifier),
		fields?: chat_bot_customers_mutation_responseFieldPolicy,
	},
	chat_bot_customers_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_stddev_fieldsKeySpecifier | (() => undefined | chat_bot_customers_stddev_fieldsKeySpecifier),
		fields?: chat_bot_customers_stddev_fieldsFieldPolicy,
	},
	chat_bot_customers_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_stddev_pop_fieldsKeySpecifier | (() => undefined | chat_bot_customers_stddev_pop_fieldsKeySpecifier),
		fields?: chat_bot_customers_stddev_pop_fieldsFieldPolicy,
	},
	chat_bot_customers_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_stddev_samp_fieldsKeySpecifier | (() => undefined | chat_bot_customers_stddev_samp_fieldsKeySpecifier),
		fields?: chat_bot_customers_stddev_samp_fieldsFieldPolicy,
	},
	chat_bot_customers_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_sum_fieldsKeySpecifier | (() => undefined | chat_bot_customers_sum_fieldsKeySpecifier),
		fields?: chat_bot_customers_sum_fieldsFieldPolicy,
	},
	chat_bot_customers_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_var_pop_fieldsKeySpecifier | (() => undefined | chat_bot_customers_var_pop_fieldsKeySpecifier),
		fields?: chat_bot_customers_var_pop_fieldsFieldPolicy,
	},
	chat_bot_customers_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_var_samp_fieldsKeySpecifier | (() => undefined | chat_bot_customers_var_samp_fieldsKeySpecifier),
		fields?: chat_bot_customers_var_samp_fieldsFieldPolicy,
	},
	chat_bot_customers_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_customers_variance_fieldsKeySpecifier | (() => undefined | chat_bot_customers_variance_fieldsKeySpecifier),
		fields?: chat_bot_customers_variance_fieldsFieldPolicy,
	},
	chat_bot_forwarding?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwardingKeySpecifier | (() => undefined | chat_bot_forwardingKeySpecifier),
		fields?: chat_bot_forwardingFieldPolicy,
	},
	chat_bot_forwarding_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_aggregateKeySpecifier | (() => undefined | chat_bot_forwarding_aggregateKeySpecifier),
		fields?: chat_bot_forwarding_aggregateFieldPolicy,
	},
	chat_bot_forwarding_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_aggregate_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_aggregate_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_aggregate_fieldsFieldPolicy,
	},
	chat_bot_forwarding_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_avg_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_avg_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_avg_fieldsFieldPolicy,
	},
	chat_bot_forwarding_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_max_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_max_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_max_fieldsFieldPolicy,
	},
	chat_bot_forwarding_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_min_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_min_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_min_fieldsFieldPolicy,
	},
	chat_bot_forwarding_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_mutation_responseKeySpecifier | (() => undefined | chat_bot_forwarding_mutation_responseKeySpecifier),
		fields?: chat_bot_forwarding_mutation_responseFieldPolicy,
	},
	chat_bot_forwarding_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_stddev_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_stddev_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_stddev_fieldsFieldPolicy,
	},
	chat_bot_forwarding_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_stddev_pop_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_stddev_pop_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_stddev_pop_fieldsFieldPolicy,
	},
	chat_bot_forwarding_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_stddev_samp_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_stddev_samp_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_stddev_samp_fieldsFieldPolicy,
	},
	chat_bot_forwarding_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_sum_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_sum_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_sum_fieldsFieldPolicy,
	},
	chat_bot_forwarding_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_var_pop_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_var_pop_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_var_pop_fieldsFieldPolicy,
	},
	chat_bot_forwarding_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_var_samp_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_var_samp_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_var_samp_fieldsFieldPolicy,
	},
	chat_bot_forwarding_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_forwarding_variance_fieldsKeySpecifier | (() => undefined | chat_bot_forwarding_variance_fieldsKeySpecifier),
		fields?: chat_bot_forwarding_variance_fieldsFieldPolicy,
	},
	chat_bot_message_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_message_typeKeySpecifier | (() => undefined | chat_bot_message_typeKeySpecifier),
		fields?: chat_bot_message_typeFieldPolicy,
	},
	chat_bot_message_type_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_message_type_aggregateKeySpecifier | (() => undefined | chat_bot_message_type_aggregateKeySpecifier),
		fields?: chat_bot_message_type_aggregateFieldPolicy,
	},
	chat_bot_message_type_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_message_type_aggregate_fieldsKeySpecifier | (() => undefined | chat_bot_message_type_aggregate_fieldsKeySpecifier),
		fields?: chat_bot_message_type_aggregate_fieldsFieldPolicy,
	},
	chat_bot_message_type_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_message_type_max_fieldsKeySpecifier | (() => undefined | chat_bot_message_type_max_fieldsKeySpecifier),
		fields?: chat_bot_message_type_max_fieldsFieldPolicy,
	},
	chat_bot_message_type_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_message_type_min_fieldsKeySpecifier | (() => undefined | chat_bot_message_type_min_fieldsKeySpecifier),
		fields?: chat_bot_message_type_min_fieldsFieldPolicy,
	},
	chat_bot_message_type_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_message_type_mutation_responseKeySpecifier | (() => undefined | chat_bot_message_type_mutation_responseKeySpecifier),
		fields?: chat_bot_message_type_mutation_responseFieldPolicy,
	},
	chat_bot_messages?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messagesKeySpecifier | (() => undefined | chat_bot_messagesKeySpecifier),
		fields?: chat_bot_messagesFieldPolicy,
	},
	chat_bot_messages_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_aggregateKeySpecifier | (() => undefined | chat_bot_messages_aggregateKeySpecifier),
		fields?: chat_bot_messages_aggregateFieldPolicy,
	},
	chat_bot_messages_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_aggregate_fieldsKeySpecifier | (() => undefined | chat_bot_messages_aggregate_fieldsKeySpecifier),
		fields?: chat_bot_messages_aggregate_fieldsFieldPolicy,
	},
	chat_bot_messages_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_avg_fieldsKeySpecifier | (() => undefined | chat_bot_messages_avg_fieldsKeySpecifier),
		fields?: chat_bot_messages_avg_fieldsFieldPolicy,
	},
	chat_bot_messages_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_max_fieldsKeySpecifier | (() => undefined | chat_bot_messages_max_fieldsKeySpecifier),
		fields?: chat_bot_messages_max_fieldsFieldPolicy,
	},
	chat_bot_messages_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_min_fieldsKeySpecifier | (() => undefined | chat_bot_messages_min_fieldsKeySpecifier),
		fields?: chat_bot_messages_min_fieldsFieldPolicy,
	},
	chat_bot_messages_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_mutation_responseKeySpecifier | (() => undefined | chat_bot_messages_mutation_responseKeySpecifier),
		fields?: chat_bot_messages_mutation_responseFieldPolicy,
	},
	chat_bot_messages_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_stddev_fieldsKeySpecifier | (() => undefined | chat_bot_messages_stddev_fieldsKeySpecifier),
		fields?: chat_bot_messages_stddev_fieldsFieldPolicy,
	},
	chat_bot_messages_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_stddev_pop_fieldsKeySpecifier | (() => undefined | chat_bot_messages_stddev_pop_fieldsKeySpecifier),
		fields?: chat_bot_messages_stddev_pop_fieldsFieldPolicy,
	},
	chat_bot_messages_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_stddev_samp_fieldsKeySpecifier | (() => undefined | chat_bot_messages_stddev_samp_fieldsKeySpecifier),
		fields?: chat_bot_messages_stddev_samp_fieldsFieldPolicy,
	},
	chat_bot_messages_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_sum_fieldsKeySpecifier | (() => undefined | chat_bot_messages_sum_fieldsKeySpecifier),
		fields?: chat_bot_messages_sum_fieldsFieldPolicy,
	},
	chat_bot_messages_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_var_pop_fieldsKeySpecifier | (() => undefined | chat_bot_messages_var_pop_fieldsKeySpecifier),
		fields?: chat_bot_messages_var_pop_fieldsFieldPolicy,
	},
	chat_bot_messages_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_var_samp_fieldsKeySpecifier | (() => undefined | chat_bot_messages_var_samp_fieldsKeySpecifier),
		fields?: chat_bot_messages_var_samp_fieldsFieldPolicy,
	},
	chat_bot_messages_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | chat_bot_messages_variance_fieldsKeySpecifier | (() => undefined | chat_bot_messages_variance_fieldsKeySpecifier),
		fields?: chat_bot_messages_variance_fieldsFieldPolicy,
	},
	contact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contactKeySpecifier | (() => undefined | contactKeySpecifier),
		fields?: contactFieldPolicy,
	},
	contact_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_aggregateKeySpecifier | (() => undefined | contact_aggregateKeySpecifier),
		fields?: contact_aggregateFieldPolicy,
	},
	contact_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_aggregate_fieldsKeySpecifier | (() => undefined | contact_aggregate_fieldsKeySpecifier),
		fields?: contact_aggregate_fieldsFieldPolicy,
	},
	contact_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_avg_fieldsKeySpecifier | (() => undefined | contact_avg_fieldsKeySpecifier),
		fields?: contact_avg_fieldsFieldPolicy,
	},
	contact_logs?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logsKeySpecifier | (() => undefined | contact_logsKeySpecifier),
		fields?: contact_logsFieldPolicy,
	},
	contact_logs_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_aggregateKeySpecifier | (() => undefined | contact_logs_aggregateKeySpecifier),
		fields?: contact_logs_aggregateFieldPolicy,
	},
	contact_logs_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_aggregate_fieldsKeySpecifier | (() => undefined | contact_logs_aggregate_fieldsKeySpecifier),
		fields?: contact_logs_aggregate_fieldsFieldPolicy,
	},
	contact_logs_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_avg_fieldsKeySpecifier | (() => undefined | contact_logs_avg_fieldsKeySpecifier),
		fields?: contact_logs_avg_fieldsFieldPolicy,
	},
	contact_logs_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_max_fieldsKeySpecifier | (() => undefined | contact_logs_max_fieldsKeySpecifier),
		fields?: contact_logs_max_fieldsFieldPolicy,
	},
	contact_logs_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_min_fieldsKeySpecifier | (() => undefined | contact_logs_min_fieldsKeySpecifier),
		fields?: contact_logs_min_fieldsFieldPolicy,
	},
	contact_logs_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_mutation_responseKeySpecifier | (() => undefined | contact_logs_mutation_responseKeySpecifier),
		fields?: contact_logs_mutation_responseFieldPolicy,
	},
	contact_logs_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_stddev_fieldsKeySpecifier | (() => undefined | contact_logs_stddev_fieldsKeySpecifier),
		fields?: contact_logs_stddev_fieldsFieldPolicy,
	},
	contact_logs_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_stddev_pop_fieldsKeySpecifier | (() => undefined | contact_logs_stddev_pop_fieldsKeySpecifier),
		fields?: contact_logs_stddev_pop_fieldsFieldPolicy,
	},
	contact_logs_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_stddev_samp_fieldsKeySpecifier | (() => undefined | contact_logs_stddev_samp_fieldsKeySpecifier),
		fields?: contact_logs_stddev_samp_fieldsFieldPolicy,
	},
	contact_logs_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_sum_fieldsKeySpecifier | (() => undefined | contact_logs_sum_fieldsKeySpecifier),
		fields?: contact_logs_sum_fieldsFieldPolicy,
	},
	contact_logs_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_var_pop_fieldsKeySpecifier | (() => undefined | contact_logs_var_pop_fieldsKeySpecifier),
		fields?: contact_logs_var_pop_fieldsFieldPolicy,
	},
	contact_logs_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_var_samp_fieldsKeySpecifier | (() => undefined | contact_logs_var_samp_fieldsKeySpecifier),
		fields?: contact_logs_var_samp_fieldsFieldPolicy,
	},
	contact_logs_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_logs_variance_fieldsKeySpecifier | (() => undefined | contact_logs_variance_fieldsKeySpecifier),
		fields?: contact_logs_variance_fieldsFieldPolicy,
	},
	contact_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_max_fieldsKeySpecifier | (() => undefined | contact_max_fieldsKeySpecifier),
		fields?: contact_max_fieldsFieldPolicy,
	},
	contact_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_min_fieldsKeySpecifier | (() => undefined | contact_min_fieldsKeySpecifier),
		fields?: contact_min_fieldsFieldPolicy,
	},
	contact_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_mutation_responseKeySpecifier | (() => undefined | contact_mutation_responseKeySpecifier),
		fields?: contact_mutation_responseFieldPolicy,
	},
	contact_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_stddev_fieldsKeySpecifier | (() => undefined | contact_stddev_fieldsKeySpecifier),
		fields?: contact_stddev_fieldsFieldPolicy,
	},
	contact_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_stddev_pop_fieldsKeySpecifier | (() => undefined | contact_stddev_pop_fieldsKeySpecifier),
		fields?: contact_stddev_pop_fieldsFieldPolicy,
	},
	contact_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_stddev_samp_fieldsKeySpecifier | (() => undefined | contact_stddev_samp_fieldsKeySpecifier),
		fields?: contact_stddev_samp_fieldsFieldPolicy,
	},
	contact_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_sum_fieldsKeySpecifier | (() => undefined | contact_sum_fieldsKeySpecifier),
		fields?: contact_sum_fieldsFieldPolicy,
	},
	contact_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_var_pop_fieldsKeySpecifier | (() => undefined | contact_var_pop_fieldsKeySpecifier),
		fields?: contact_var_pop_fieldsFieldPolicy,
	},
	contact_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_var_samp_fieldsKeySpecifier | (() => undefined | contact_var_samp_fieldsKeySpecifier),
		fields?: contact_var_samp_fieldsFieldPolicy,
	},
	contact_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | contact_variance_fieldsKeySpecifier | (() => undefined | contact_variance_fieldsKeySpecifier),
		fields?: contact_variance_fieldsFieldPolicy,
	},
	file_pdf_templates?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_pdf_templatesKeySpecifier | (() => undefined | file_pdf_templatesKeySpecifier),
		fields?: file_pdf_templatesFieldPolicy,
	},
	file_pdf_templates_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_pdf_templates_aggregateKeySpecifier | (() => undefined | file_pdf_templates_aggregateKeySpecifier),
		fields?: file_pdf_templates_aggregateFieldPolicy,
	},
	file_pdf_templates_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_pdf_templates_aggregate_fieldsKeySpecifier | (() => undefined | file_pdf_templates_aggregate_fieldsKeySpecifier),
		fields?: file_pdf_templates_aggregate_fieldsFieldPolicy,
	},
	file_pdf_templates_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_pdf_templates_max_fieldsKeySpecifier | (() => undefined | file_pdf_templates_max_fieldsKeySpecifier),
		fields?: file_pdf_templates_max_fieldsFieldPolicy,
	},
	file_pdf_templates_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_pdf_templates_min_fieldsKeySpecifier | (() => undefined | file_pdf_templates_min_fieldsKeySpecifier),
		fields?: file_pdf_templates_min_fieldsFieldPolicy,
	},
	file_pdf_templates_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_pdf_templates_mutation_responseKeySpecifier | (() => undefined | file_pdf_templates_mutation_responseKeySpecifier),
		fields?: file_pdf_templates_mutation_responseFieldPolicy,
	},
	file_upload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_uploadKeySpecifier | (() => undefined | file_uploadKeySpecifier),
		fields?: file_uploadFieldPolicy,
	},
	file_upload_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_upload_aggregateKeySpecifier | (() => undefined | file_upload_aggregateKeySpecifier),
		fields?: file_upload_aggregateFieldPolicy,
	},
	file_upload_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_upload_aggregate_fieldsKeySpecifier | (() => undefined | file_upload_aggregate_fieldsKeySpecifier),
		fields?: file_upload_aggregate_fieldsFieldPolicy,
	},
	file_upload_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_upload_max_fieldsKeySpecifier | (() => undefined | file_upload_max_fieldsKeySpecifier),
		fields?: file_upload_max_fieldsFieldPolicy,
	},
	file_upload_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_upload_min_fieldsKeySpecifier | (() => undefined | file_upload_min_fieldsKeySpecifier),
		fields?: file_upload_min_fieldsFieldPolicy,
	},
	file_upload_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_upload_mutation_responseKeySpecifier | (() => undefined | file_upload_mutation_responseKeySpecifier),
		fields?: file_upload_mutation_responseFieldPolicy,
	},
	funnel_benefits?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_benefitsKeySpecifier | (() => undefined | funnel_benefitsKeySpecifier),
		fields?: funnel_benefitsFieldPolicy,
	},
	funnel_benefits_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_benefits_aggregateKeySpecifier | (() => undefined | funnel_benefits_aggregateKeySpecifier),
		fields?: funnel_benefits_aggregateFieldPolicy,
	},
	funnel_benefits_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_benefits_aggregate_fieldsKeySpecifier | (() => undefined | funnel_benefits_aggregate_fieldsKeySpecifier),
		fields?: funnel_benefits_aggregate_fieldsFieldPolicy,
	},
	funnel_benefits_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_benefits_max_fieldsKeySpecifier | (() => undefined | funnel_benefits_max_fieldsKeySpecifier),
		fields?: funnel_benefits_max_fieldsFieldPolicy,
	},
	funnel_benefits_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_benefits_min_fieldsKeySpecifier | (() => undefined | funnel_benefits_min_fieldsKeySpecifier),
		fields?: funnel_benefits_min_fieldsFieldPolicy,
	},
	funnel_benefits_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_benefits_mutation_responseKeySpecifier | (() => undefined | funnel_benefits_mutation_responseKeySpecifier),
		fields?: funnel_benefits_mutation_responseFieldPolicy,
	},
	funnel_chatbot_message?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_messageKeySpecifier | (() => undefined | funnel_chatbot_messageKeySpecifier),
		fields?: funnel_chatbot_messageFieldPolicy,
	},
	funnel_chatbot_message_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_aggregateKeySpecifier | (() => undefined | funnel_chatbot_message_aggregateKeySpecifier),
		fields?: funnel_chatbot_message_aggregateFieldPolicy,
	},
	funnel_chatbot_message_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_aggregate_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_aggregate_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_aggregate_fieldsFieldPolicy,
	},
	funnel_chatbot_message_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_avg_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_avg_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_avg_fieldsFieldPolicy,
	},
	funnel_chatbot_message_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_max_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_max_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_max_fieldsFieldPolicy,
	},
	funnel_chatbot_message_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_min_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_min_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_min_fieldsFieldPolicy,
	},
	funnel_chatbot_message_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_mutation_responseKeySpecifier | (() => undefined | funnel_chatbot_message_mutation_responseKeySpecifier),
		fields?: funnel_chatbot_message_mutation_responseFieldPolicy,
	},
	funnel_chatbot_message_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_stddev_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_stddev_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_stddev_fieldsFieldPolicy,
	},
	funnel_chatbot_message_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_stddev_pop_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_stddev_pop_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_stddev_pop_fieldsFieldPolicy,
	},
	funnel_chatbot_message_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_stddev_samp_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_stddev_samp_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_stddev_samp_fieldsFieldPolicy,
	},
	funnel_chatbot_message_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_sum_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_sum_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_sum_fieldsFieldPolicy,
	},
	funnel_chatbot_message_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_var_pop_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_var_pop_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_var_pop_fieldsFieldPolicy,
	},
	funnel_chatbot_message_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_var_samp_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_var_samp_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_var_samp_fieldsFieldPolicy,
	},
	funnel_chatbot_message_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_message_variance_fieldsKeySpecifier | (() => undefined | funnel_chatbot_message_variance_fieldsKeySpecifier),
		fields?: funnel_chatbot_message_variance_fieldsFieldPolicy,
	},
	funnel_chatbot_session?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_sessionKeySpecifier | (() => undefined | funnel_chatbot_sessionKeySpecifier),
		fields?: funnel_chatbot_sessionFieldPolicy,
	},
	funnel_chatbot_session_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_aggregateKeySpecifier | (() => undefined | funnel_chatbot_session_aggregateKeySpecifier),
		fields?: funnel_chatbot_session_aggregateFieldPolicy,
	},
	funnel_chatbot_session_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_aggregate_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_aggregate_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_aggregate_fieldsFieldPolicy,
	},
	funnel_chatbot_session_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_avg_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_avg_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_avg_fieldsFieldPolicy,
	},
	funnel_chatbot_session_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_max_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_max_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_max_fieldsFieldPolicy,
	},
	funnel_chatbot_session_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_min_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_min_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_min_fieldsFieldPolicy,
	},
	funnel_chatbot_session_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_mutation_responseKeySpecifier | (() => undefined | funnel_chatbot_session_mutation_responseKeySpecifier),
		fields?: funnel_chatbot_session_mutation_responseFieldPolicy,
	},
	funnel_chatbot_session_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_stddev_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_stddev_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_stddev_fieldsFieldPolicy,
	},
	funnel_chatbot_session_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_stddev_pop_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_stddev_pop_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_stddev_pop_fieldsFieldPolicy,
	},
	funnel_chatbot_session_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_stddev_samp_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_stddev_samp_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_stddev_samp_fieldsFieldPolicy,
	},
	funnel_chatbot_session_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_sum_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_sum_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_sum_fieldsFieldPolicy,
	},
	funnel_chatbot_session_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_var_pop_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_var_pop_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_var_pop_fieldsFieldPolicy,
	},
	funnel_chatbot_session_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_var_samp_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_var_samp_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_var_samp_fieldsFieldPolicy,
	},
	funnel_chatbot_session_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_chatbot_session_variance_fieldsKeySpecifier | (() => undefined | funnel_chatbot_session_variance_fieldsKeySpecifier),
		fields?: funnel_chatbot_session_variance_fieldsFieldPolicy,
	},
	funnel_funnels?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_funnelsKeySpecifier | (() => undefined | funnel_funnelsKeySpecifier),
		fields?: funnel_funnelsFieldPolicy,
	},
	funnel_funnels_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_funnels_aggregateKeySpecifier | (() => undefined | funnel_funnels_aggregateKeySpecifier),
		fields?: funnel_funnels_aggregateFieldPolicy,
	},
	funnel_funnels_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_funnels_aggregate_fieldsKeySpecifier | (() => undefined | funnel_funnels_aggregate_fieldsKeySpecifier),
		fields?: funnel_funnels_aggregate_fieldsFieldPolicy,
	},
	funnel_funnels_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_funnels_max_fieldsKeySpecifier | (() => undefined | funnel_funnels_max_fieldsKeySpecifier),
		fields?: funnel_funnels_max_fieldsFieldPolicy,
	},
	funnel_funnels_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_funnels_min_fieldsKeySpecifier | (() => undefined | funnel_funnels_min_fieldsKeySpecifier),
		fields?: funnel_funnels_min_fieldsFieldPolicy,
	},
	funnel_funnels_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_funnels_mutation_responseKeySpecifier | (() => undefined | funnel_funnels_mutation_responseKeySpecifier),
		fields?: funnel_funnels_mutation_responseFieldPolicy,
	},
	funnel_insights?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insightsKeySpecifier | (() => undefined | funnel_insightsKeySpecifier),
		fields?: funnel_insightsFieldPolicy,
	},
	funnel_insights_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_aggregateKeySpecifier | (() => undefined | funnel_insights_aggregateKeySpecifier),
		fields?: funnel_insights_aggregateFieldPolicy,
	},
	funnel_insights_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_aggregate_fieldsKeySpecifier | (() => undefined | funnel_insights_aggregate_fieldsKeySpecifier),
		fields?: funnel_insights_aggregate_fieldsFieldPolicy,
	},
	funnel_insights_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_avg_fieldsKeySpecifier | (() => undefined | funnel_insights_avg_fieldsKeySpecifier),
		fields?: funnel_insights_avg_fieldsFieldPolicy,
	},
	funnel_insights_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_max_fieldsKeySpecifier | (() => undefined | funnel_insights_max_fieldsKeySpecifier),
		fields?: funnel_insights_max_fieldsFieldPolicy,
	},
	funnel_insights_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_min_fieldsKeySpecifier | (() => undefined | funnel_insights_min_fieldsKeySpecifier),
		fields?: funnel_insights_min_fieldsFieldPolicy,
	},
	funnel_insights_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_mutation_responseKeySpecifier | (() => undefined | funnel_insights_mutation_responseKeySpecifier),
		fields?: funnel_insights_mutation_responseFieldPolicy,
	},
	funnel_insights_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_stddev_fieldsKeySpecifier | (() => undefined | funnel_insights_stddev_fieldsKeySpecifier),
		fields?: funnel_insights_stddev_fieldsFieldPolicy,
	},
	funnel_insights_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_stddev_pop_fieldsKeySpecifier | (() => undefined | funnel_insights_stddev_pop_fieldsKeySpecifier),
		fields?: funnel_insights_stddev_pop_fieldsFieldPolicy,
	},
	funnel_insights_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_stddev_samp_fieldsKeySpecifier | (() => undefined | funnel_insights_stddev_samp_fieldsKeySpecifier),
		fields?: funnel_insights_stddev_samp_fieldsFieldPolicy,
	},
	funnel_insights_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_sum_fieldsKeySpecifier | (() => undefined | funnel_insights_sum_fieldsKeySpecifier),
		fields?: funnel_insights_sum_fieldsFieldPolicy,
	},
	funnel_insights_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_var_pop_fieldsKeySpecifier | (() => undefined | funnel_insights_var_pop_fieldsKeySpecifier),
		fields?: funnel_insights_var_pop_fieldsFieldPolicy,
	},
	funnel_insights_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_var_samp_fieldsKeySpecifier | (() => undefined | funnel_insights_var_samp_fieldsKeySpecifier),
		fields?: funnel_insights_var_samp_fieldsFieldPolicy,
	},
	funnel_insights_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_insights_variance_fieldsKeySpecifier | (() => undefined | funnel_insights_variance_fieldsKeySpecifier),
		fields?: funnel_insights_variance_fieldsFieldPolicy,
	},
	funnel_page_insights?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insightsKeySpecifier | (() => undefined | funnel_page_insightsKeySpecifier),
		fields?: funnel_page_insightsFieldPolicy,
	},
	funnel_page_insights_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_aggregateKeySpecifier | (() => undefined | funnel_page_insights_aggregateKeySpecifier),
		fields?: funnel_page_insights_aggregateFieldPolicy,
	},
	funnel_page_insights_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_aggregate_fieldsKeySpecifier | (() => undefined | funnel_page_insights_aggregate_fieldsKeySpecifier),
		fields?: funnel_page_insights_aggregate_fieldsFieldPolicy,
	},
	funnel_page_insights_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_avg_fieldsKeySpecifier | (() => undefined | funnel_page_insights_avg_fieldsKeySpecifier),
		fields?: funnel_page_insights_avg_fieldsFieldPolicy,
	},
	funnel_page_insights_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_max_fieldsKeySpecifier | (() => undefined | funnel_page_insights_max_fieldsKeySpecifier),
		fields?: funnel_page_insights_max_fieldsFieldPolicy,
	},
	funnel_page_insights_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_min_fieldsKeySpecifier | (() => undefined | funnel_page_insights_min_fieldsKeySpecifier),
		fields?: funnel_page_insights_min_fieldsFieldPolicy,
	},
	funnel_page_insights_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_mutation_responseKeySpecifier | (() => undefined | funnel_page_insights_mutation_responseKeySpecifier),
		fields?: funnel_page_insights_mutation_responseFieldPolicy,
	},
	funnel_page_insights_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_stddev_fieldsKeySpecifier | (() => undefined | funnel_page_insights_stddev_fieldsKeySpecifier),
		fields?: funnel_page_insights_stddev_fieldsFieldPolicy,
	},
	funnel_page_insights_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_stddev_pop_fieldsKeySpecifier | (() => undefined | funnel_page_insights_stddev_pop_fieldsKeySpecifier),
		fields?: funnel_page_insights_stddev_pop_fieldsFieldPolicy,
	},
	funnel_page_insights_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_stddev_samp_fieldsKeySpecifier | (() => undefined | funnel_page_insights_stddev_samp_fieldsKeySpecifier),
		fields?: funnel_page_insights_stddev_samp_fieldsFieldPolicy,
	},
	funnel_page_insights_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_sum_fieldsKeySpecifier | (() => undefined | funnel_page_insights_sum_fieldsKeySpecifier),
		fields?: funnel_page_insights_sum_fieldsFieldPolicy,
	},
	funnel_page_insights_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_var_pop_fieldsKeySpecifier | (() => undefined | funnel_page_insights_var_pop_fieldsKeySpecifier),
		fields?: funnel_page_insights_var_pop_fieldsFieldPolicy,
	},
	funnel_page_insights_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_var_samp_fieldsKeySpecifier | (() => undefined | funnel_page_insights_var_samp_fieldsKeySpecifier),
		fields?: funnel_page_insights_var_samp_fieldsFieldPolicy,
	},
	funnel_page_insights_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_page_insights_variance_fieldsKeySpecifier | (() => undefined | funnel_page_insights_variance_fieldsKeySpecifier),
		fields?: funnel_page_insights_variance_fieldsFieldPolicy,
	},
	funnel_question?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_questionKeySpecifier | (() => undefined | funnel_questionKeySpecifier),
		fields?: funnel_questionFieldPolicy,
	},
	funnel_question_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_aggregateKeySpecifier | (() => undefined | funnel_question_aggregateKeySpecifier),
		fields?: funnel_question_aggregateFieldPolicy,
	},
	funnel_question_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_aggregate_fieldsKeySpecifier | (() => undefined | funnel_question_aggregate_fieldsKeySpecifier),
		fields?: funnel_question_aggregate_fieldsFieldPolicy,
	},
	funnel_question_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_avg_fieldsKeySpecifier | (() => undefined | funnel_question_avg_fieldsKeySpecifier),
		fields?: funnel_question_avg_fieldsFieldPolicy,
	},
	funnel_question_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_max_fieldsKeySpecifier | (() => undefined | funnel_question_max_fieldsKeySpecifier),
		fields?: funnel_question_max_fieldsFieldPolicy,
	},
	funnel_question_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_min_fieldsKeySpecifier | (() => undefined | funnel_question_min_fieldsKeySpecifier),
		fields?: funnel_question_min_fieldsFieldPolicy,
	},
	funnel_question_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_mutation_responseKeySpecifier | (() => undefined | funnel_question_mutation_responseKeySpecifier),
		fields?: funnel_question_mutation_responseFieldPolicy,
	},
	funnel_question_option?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_optionKeySpecifier | (() => undefined | funnel_question_optionKeySpecifier),
		fields?: funnel_question_optionFieldPolicy,
	},
	funnel_question_option_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_option_aggregateKeySpecifier | (() => undefined | funnel_question_option_aggregateKeySpecifier),
		fields?: funnel_question_option_aggregateFieldPolicy,
	},
	funnel_question_option_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_option_aggregate_fieldsKeySpecifier | (() => undefined | funnel_question_option_aggregate_fieldsKeySpecifier),
		fields?: funnel_question_option_aggregate_fieldsFieldPolicy,
	},
	funnel_question_option_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_option_max_fieldsKeySpecifier | (() => undefined | funnel_question_option_max_fieldsKeySpecifier),
		fields?: funnel_question_option_max_fieldsFieldPolicy,
	},
	funnel_question_option_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_option_min_fieldsKeySpecifier | (() => undefined | funnel_question_option_min_fieldsKeySpecifier),
		fields?: funnel_question_option_min_fieldsFieldPolicy,
	},
	funnel_question_option_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_option_mutation_responseKeySpecifier | (() => undefined | funnel_question_option_mutation_responseKeySpecifier),
		fields?: funnel_question_option_mutation_responseFieldPolicy,
	},
	funnel_question_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_stddev_fieldsKeySpecifier | (() => undefined | funnel_question_stddev_fieldsKeySpecifier),
		fields?: funnel_question_stddev_fieldsFieldPolicy,
	},
	funnel_question_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_stddev_pop_fieldsKeySpecifier | (() => undefined | funnel_question_stddev_pop_fieldsKeySpecifier),
		fields?: funnel_question_stddev_pop_fieldsFieldPolicy,
	},
	funnel_question_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_stddev_samp_fieldsKeySpecifier | (() => undefined | funnel_question_stddev_samp_fieldsKeySpecifier),
		fields?: funnel_question_stddev_samp_fieldsFieldPolicy,
	},
	funnel_question_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_sum_fieldsKeySpecifier | (() => undefined | funnel_question_sum_fieldsKeySpecifier),
		fields?: funnel_question_sum_fieldsFieldPolicy,
	},
	funnel_question_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_var_pop_fieldsKeySpecifier | (() => undefined | funnel_question_var_pop_fieldsKeySpecifier),
		fields?: funnel_question_var_pop_fieldsFieldPolicy,
	},
	funnel_question_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_var_samp_fieldsKeySpecifier | (() => undefined | funnel_question_var_samp_fieldsKeySpecifier),
		fields?: funnel_question_var_samp_fieldsFieldPolicy,
	},
	funnel_question_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_question_variance_fieldsKeySpecifier | (() => undefined | funnel_question_variance_fieldsKeySpecifier),
		fields?: funnel_question_variance_fieldsFieldPolicy,
	},
	funnel_whatsapp_share_clicks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_whatsapp_share_clicksKeySpecifier | (() => undefined | funnel_whatsapp_share_clicksKeySpecifier),
		fields?: funnel_whatsapp_share_clicksFieldPolicy,
	},
	funnel_whatsapp_share_clicks_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_whatsapp_share_clicks_aggregateKeySpecifier | (() => undefined | funnel_whatsapp_share_clicks_aggregateKeySpecifier),
		fields?: funnel_whatsapp_share_clicks_aggregateFieldPolicy,
	},
	funnel_whatsapp_share_clicks_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_whatsapp_share_clicks_aggregate_fieldsKeySpecifier | (() => undefined | funnel_whatsapp_share_clicks_aggregate_fieldsKeySpecifier),
		fields?: funnel_whatsapp_share_clicks_aggregate_fieldsFieldPolicy,
	},
	funnel_whatsapp_share_clicks_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_whatsapp_share_clicks_max_fieldsKeySpecifier | (() => undefined | funnel_whatsapp_share_clicks_max_fieldsKeySpecifier),
		fields?: funnel_whatsapp_share_clicks_max_fieldsFieldPolicy,
	},
	funnel_whatsapp_share_clicks_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_whatsapp_share_clicks_min_fieldsKeySpecifier | (() => undefined | funnel_whatsapp_share_clicks_min_fieldsKeySpecifier),
		fields?: funnel_whatsapp_share_clicks_min_fieldsFieldPolicy,
	},
	funnel_whatsapp_share_clicks_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | funnel_whatsapp_share_clicks_mutation_responseKeySpecifier | (() => undefined | funnel_whatsapp_share_clicks_mutation_responseKeySpecifier),
		fields?: funnel_whatsapp_share_clicks_mutation_responseFieldPolicy,
	},
	huk_contacts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contactsKeySpecifier | (() => undefined | huk_contactsKeySpecifier),
		fields?: huk_contactsFieldPolicy,
	},
	huk_contacts_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_aggregateKeySpecifier | (() => undefined | huk_contacts_aggregateKeySpecifier),
		fields?: huk_contacts_aggregateFieldPolicy,
	},
	huk_contacts_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_aggregate_fieldsKeySpecifier | (() => undefined | huk_contacts_aggregate_fieldsKeySpecifier),
		fields?: huk_contacts_aggregate_fieldsFieldPolicy,
	},
	huk_contacts_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_avg_fieldsKeySpecifier | (() => undefined | huk_contacts_avg_fieldsKeySpecifier),
		fields?: huk_contacts_avg_fieldsFieldPolicy,
	},
	huk_contacts_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_max_fieldsKeySpecifier | (() => undefined | huk_contacts_max_fieldsKeySpecifier),
		fields?: huk_contacts_max_fieldsFieldPolicy,
	},
	huk_contacts_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_min_fieldsKeySpecifier | (() => undefined | huk_contacts_min_fieldsKeySpecifier),
		fields?: huk_contacts_min_fieldsFieldPolicy,
	},
	huk_contacts_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_stddev_fieldsKeySpecifier | (() => undefined | huk_contacts_stddev_fieldsKeySpecifier),
		fields?: huk_contacts_stddev_fieldsFieldPolicy,
	},
	huk_contacts_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_stddev_pop_fieldsKeySpecifier | (() => undefined | huk_contacts_stddev_pop_fieldsKeySpecifier),
		fields?: huk_contacts_stddev_pop_fieldsFieldPolicy,
	},
	huk_contacts_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_stddev_samp_fieldsKeySpecifier | (() => undefined | huk_contacts_stddev_samp_fieldsKeySpecifier),
		fields?: huk_contacts_stddev_samp_fieldsFieldPolicy,
	},
	huk_contacts_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_sum_fieldsKeySpecifier | (() => undefined | huk_contacts_sum_fieldsKeySpecifier),
		fields?: huk_contacts_sum_fieldsFieldPolicy,
	},
	huk_contacts_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_var_pop_fieldsKeySpecifier | (() => undefined | huk_contacts_var_pop_fieldsKeySpecifier),
		fields?: huk_contacts_var_pop_fieldsFieldPolicy,
	},
	huk_contacts_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_var_samp_fieldsKeySpecifier | (() => undefined | huk_contacts_var_samp_fieldsKeySpecifier),
		fields?: huk_contacts_var_samp_fieldsFieldPolicy,
	},
	huk_contacts_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | huk_contacts_variance_fieldsKeySpecifier | (() => undefined | huk_contacts_variance_fieldsKeySpecifier),
		fields?: huk_contacts_variance_fieldsFieldPolicy,
	},
	mutation_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | mutation_rootKeySpecifier | (() => undefined | mutation_rootKeySpecifier),
		fields?: mutation_rootFieldPolicy,
	},
	new_contacts_per_day?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_dayKeySpecifier | (() => undefined | new_contacts_per_dayKeySpecifier),
		fields?: new_contacts_per_dayFieldPolicy,
	},
	new_contacts_per_day_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_aggregateKeySpecifier | (() => undefined | new_contacts_per_day_aggregateKeySpecifier),
		fields?: new_contacts_per_day_aggregateFieldPolicy,
	},
	new_contacts_per_day_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_aggregate_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_aggregate_fieldsKeySpecifier),
		fields?: new_contacts_per_day_aggregate_fieldsFieldPolicy,
	},
	new_contacts_per_day_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_avg_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_avg_fieldsKeySpecifier),
		fields?: new_contacts_per_day_avg_fieldsFieldPolicy,
	},
	new_contacts_per_day_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_max_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_max_fieldsKeySpecifier),
		fields?: new_contacts_per_day_max_fieldsFieldPolicy,
	},
	new_contacts_per_day_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_min_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_min_fieldsKeySpecifier),
		fields?: new_contacts_per_day_min_fieldsFieldPolicy,
	},
	new_contacts_per_day_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_stddev_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_stddev_fieldsKeySpecifier),
		fields?: new_contacts_per_day_stddev_fieldsFieldPolicy,
	},
	new_contacts_per_day_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_stddev_pop_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_stddev_pop_fieldsKeySpecifier),
		fields?: new_contacts_per_day_stddev_pop_fieldsFieldPolicy,
	},
	new_contacts_per_day_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_stddev_samp_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_stddev_samp_fieldsKeySpecifier),
		fields?: new_contacts_per_day_stddev_samp_fieldsFieldPolicy,
	},
	new_contacts_per_day_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_sum_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_sum_fieldsKeySpecifier),
		fields?: new_contacts_per_day_sum_fieldsFieldPolicy,
	},
	new_contacts_per_day_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_var_pop_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_var_pop_fieldsKeySpecifier),
		fields?: new_contacts_per_day_var_pop_fieldsFieldPolicy,
	},
	new_contacts_per_day_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_var_samp_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_var_samp_fieldsKeySpecifier),
		fields?: new_contacts_per_day_var_samp_fieldsFieldPolicy,
	},
	new_contacts_per_day_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_contacts_per_day_variance_fieldsKeySpecifier | (() => undefined | new_contacts_per_day_variance_fieldsKeySpecifier),
		fields?: new_contacts_per_day_variance_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_dayKeySpecifier | (() => undefined | new_unqualified_contacts_per_dayKeySpecifier),
		fields?: new_unqualified_contacts_per_dayFieldPolicy,
	},
	new_unqualified_contacts_per_day_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_aggregateKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_aggregateKeySpecifier),
		fields?: new_unqualified_contacts_per_day_aggregateFieldPolicy,
	},
	new_unqualified_contacts_per_day_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_aggregate_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_aggregate_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_aggregate_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_avg_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_avg_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_avg_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_max_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_max_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_max_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_min_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_min_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_min_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_stddev_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_stddev_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_stddev_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_stddev_pop_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_stddev_pop_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_stddev_pop_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_stddev_samp_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_stddev_samp_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_stddev_samp_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_sum_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_sum_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_sum_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_var_pop_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_var_pop_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_var_pop_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_var_samp_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_var_samp_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_var_samp_fieldsFieldPolicy,
	},
	new_unqualified_contacts_per_day_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | new_unqualified_contacts_per_day_variance_fieldsKeySpecifier | (() => undefined | new_unqualified_contacts_per_day_variance_fieldsKeySpecifier),
		fields?: new_unqualified_contacts_per_day_variance_fieldsFieldPolicy,
	},
	organization?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organizationKeySpecifier | (() => undefined | organizationKeySpecifier),
		fields?: organizationFieldPolicy,
	},
	organization_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_aggregateKeySpecifier | (() => undefined | organization_aggregateKeySpecifier),
		fields?: organization_aggregateFieldPolicy,
	},
	organization_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_aggregate_fieldsKeySpecifier | (() => undefined | organization_aggregate_fieldsKeySpecifier),
		fields?: organization_aggregate_fieldsFieldPolicy,
	},
	organization_budget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budgetKeySpecifier | (() => undefined | organization_budgetKeySpecifier),
		fields?: organization_budgetFieldPolicy,
	},
	organization_budget_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_aggregateKeySpecifier | (() => undefined | organization_budget_aggregateKeySpecifier),
		fields?: organization_budget_aggregateFieldPolicy,
	},
	organization_budget_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_aggregate_fieldsKeySpecifier | (() => undefined | organization_budget_aggregate_fieldsKeySpecifier),
		fields?: organization_budget_aggregate_fieldsFieldPolicy,
	},
	organization_budget_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_avg_fieldsKeySpecifier | (() => undefined | organization_budget_avg_fieldsKeySpecifier),
		fields?: organization_budget_avg_fieldsFieldPolicy,
	},
	organization_budget_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_max_fieldsKeySpecifier | (() => undefined | organization_budget_max_fieldsKeySpecifier),
		fields?: organization_budget_max_fieldsFieldPolicy,
	},
	organization_budget_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_min_fieldsKeySpecifier | (() => undefined | organization_budget_min_fieldsKeySpecifier),
		fields?: organization_budget_min_fieldsFieldPolicy,
	},
	organization_budget_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_stddev_fieldsKeySpecifier | (() => undefined | organization_budget_stddev_fieldsKeySpecifier),
		fields?: organization_budget_stddev_fieldsFieldPolicy,
	},
	organization_budget_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_stddev_pop_fieldsKeySpecifier | (() => undefined | organization_budget_stddev_pop_fieldsKeySpecifier),
		fields?: organization_budget_stddev_pop_fieldsFieldPolicy,
	},
	organization_budget_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_stddev_samp_fieldsKeySpecifier | (() => undefined | organization_budget_stddev_samp_fieldsKeySpecifier),
		fields?: organization_budget_stddev_samp_fieldsFieldPolicy,
	},
	organization_budget_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_sum_fieldsKeySpecifier | (() => undefined | organization_budget_sum_fieldsKeySpecifier),
		fields?: organization_budget_sum_fieldsFieldPolicy,
	},
	organization_budget_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_var_pop_fieldsKeySpecifier | (() => undefined | organization_budget_var_pop_fieldsKeySpecifier),
		fields?: organization_budget_var_pop_fieldsFieldPolicy,
	},
	organization_budget_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_var_samp_fieldsKeySpecifier | (() => undefined | organization_budget_var_samp_fieldsKeySpecifier),
		fields?: organization_budget_var_samp_fieldsFieldPolicy,
	},
	organization_budget_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_budget_variance_fieldsKeySpecifier | (() => undefined | organization_budget_variance_fieldsKeySpecifier),
		fields?: organization_budget_variance_fieldsFieldPolicy,
	},
	organization_contacts_per_day?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_dayKeySpecifier | (() => undefined | organization_contacts_per_dayKeySpecifier),
		fields?: organization_contacts_per_dayFieldPolicy,
	},
	organization_contacts_per_day_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_aggregateKeySpecifier | (() => undefined | organization_contacts_per_day_aggregateKeySpecifier),
		fields?: organization_contacts_per_day_aggregateFieldPolicy,
	},
	organization_contacts_per_day_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_aggregate_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_aggregate_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_aggregate_fieldsFieldPolicy,
	},
	organization_contacts_per_day_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_avg_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_avg_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_avg_fieldsFieldPolicy,
	},
	organization_contacts_per_day_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_max_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_max_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_max_fieldsFieldPolicy,
	},
	organization_contacts_per_day_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_min_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_min_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_min_fieldsFieldPolicy,
	},
	organization_contacts_per_day_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_stddev_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_stddev_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_stddev_fieldsFieldPolicy,
	},
	organization_contacts_per_day_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_stddev_pop_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_stddev_pop_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_stddev_pop_fieldsFieldPolicy,
	},
	organization_contacts_per_day_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_stddev_samp_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_stddev_samp_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_stddev_samp_fieldsFieldPolicy,
	},
	organization_contacts_per_day_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_sum_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_sum_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_sum_fieldsFieldPolicy,
	},
	organization_contacts_per_day_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_var_pop_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_var_pop_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_var_pop_fieldsFieldPolicy,
	},
	organization_contacts_per_day_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_var_samp_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_var_samp_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_var_samp_fieldsFieldPolicy,
	},
	organization_contacts_per_day_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_contacts_per_day_variance_fieldsKeySpecifier | (() => undefined | organization_contacts_per_day_variance_fieldsKeySpecifier),
		fields?: organization_contacts_per_day_variance_fieldsFieldPolicy,
	},
	organization_location?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_locationKeySpecifier | (() => undefined | organization_locationKeySpecifier),
		fields?: organization_locationFieldPolicy,
	},
	organization_location_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_location_aggregateKeySpecifier | (() => undefined | organization_location_aggregateKeySpecifier),
		fields?: organization_location_aggregateFieldPolicy,
	},
	organization_location_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_location_aggregate_fieldsKeySpecifier | (() => undefined | organization_location_aggregate_fieldsKeySpecifier),
		fields?: organization_location_aggregate_fieldsFieldPolicy,
	},
	organization_location_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_location_max_fieldsKeySpecifier | (() => undefined | organization_location_max_fieldsKeySpecifier),
		fields?: organization_location_max_fieldsFieldPolicy,
	},
	organization_location_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_location_min_fieldsKeySpecifier | (() => undefined | organization_location_min_fieldsKeySpecifier),
		fields?: organization_location_min_fieldsFieldPolicy,
	},
	organization_location_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_location_mutation_responseKeySpecifier | (() => undefined | organization_location_mutation_responseKeySpecifier),
		fields?: organization_location_mutation_responseFieldPolicy,
	},
	organization_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_max_fieldsKeySpecifier | (() => undefined | organization_max_fieldsKeySpecifier),
		fields?: organization_max_fieldsFieldPolicy,
	},
	organization_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_min_fieldsKeySpecifier | (() => undefined | organization_min_fieldsKeySpecifier),
		fields?: organization_min_fieldsFieldPolicy,
	},
	organization_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_mutation_responseKeySpecifier | (() => undefined | organization_mutation_responseKeySpecifier),
		fields?: organization_mutation_responseFieldPolicy,
	},
	organization_name_prefix?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_name_prefixKeySpecifier | (() => undefined | organization_name_prefixKeySpecifier),
		fields?: organization_name_prefixFieldPolicy,
	},
	organization_name_prefix_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_name_prefix_aggregateKeySpecifier | (() => undefined | organization_name_prefix_aggregateKeySpecifier),
		fields?: organization_name_prefix_aggregateFieldPolicy,
	},
	organization_name_prefix_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_name_prefix_aggregate_fieldsKeySpecifier | (() => undefined | organization_name_prefix_aggregate_fieldsKeySpecifier),
		fields?: organization_name_prefix_aggregate_fieldsFieldPolicy,
	},
	organization_name_prefix_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_name_prefix_max_fieldsKeySpecifier | (() => undefined | organization_name_prefix_max_fieldsKeySpecifier),
		fields?: organization_name_prefix_max_fieldsFieldPolicy,
	},
	organization_name_prefix_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_name_prefix_min_fieldsKeySpecifier | (() => undefined | organization_name_prefix_min_fieldsKeySpecifier),
		fields?: organization_name_prefix_min_fieldsFieldPolicy,
	},
	organization_name_prefix_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_name_prefix_mutation_responseKeySpecifier | (() => undefined | organization_name_prefix_mutation_responseKeySpecifier),
		fields?: organization_name_prefix_mutation_responseFieldPolicy,
	},
	organization_news?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_newsKeySpecifier | (() => undefined | organization_newsKeySpecifier),
		fields?: organization_newsFieldPolicy,
	},
	organization_news_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_news_aggregateKeySpecifier | (() => undefined | organization_news_aggregateKeySpecifier),
		fields?: organization_news_aggregateFieldPolicy,
	},
	organization_news_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_news_aggregate_fieldsKeySpecifier | (() => undefined | organization_news_aggregate_fieldsKeySpecifier),
		fields?: organization_news_aggregate_fieldsFieldPolicy,
	},
	organization_news_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_news_max_fieldsKeySpecifier | (() => undefined | organization_news_max_fieldsKeySpecifier),
		fields?: organization_news_max_fieldsFieldPolicy,
	},
	organization_news_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_news_min_fieldsKeySpecifier | (() => undefined | organization_news_min_fieldsKeySpecifier),
		fields?: organization_news_min_fieldsFieldPolicy,
	},
	organization_news_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_news_mutation_responseKeySpecifier | (() => undefined | organization_news_mutation_responseKeySpecifier),
		fields?: organization_news_mutation_responseFieldPolicy,
	},
	organization_region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_regionKeySpecifier | (() => undefined | organization_regionKeySpecifier),
		fields?: organization_regionFieldPolicy,
	},
	organization_region_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_region_aggregateKeySpecifier | (() => undefined | organization_region_aggregateKeySpecifier),
		fields?: organization_region_aggregateFieldPolicy,
	},
	organization_region_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_region_aggregate_fieldsKeySpecifier | (() => undefined | organization_region_aggregate_fieldsKeySpecifier),
		fields?: organization_region_aggregate_fieldsFieldPolicy,
	},
	organization_region_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_region_max_fieldsKeySpecifier | (() => undefined | organization_region_max_fieldsKeySpecifier),
		fields?: organization_region_max_fieldsFieldPolicy,
	},
	organization_region_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_region_min_fieldsKeySpecifier | (() => undefined | organization_region_min_fieldsKeySpecifier),
		fields?: organization_region_min_fieldsFieldPolicy,
	},
	organization_region_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_region_mutation_responseKeySpecifier | (() => undefined | organization_region_mutation_responseKeySpecifier),
		fields?: organization_region_mutation_responseFieldPolicy,
	},
	organization_settings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_settingsKeySpecifier | (() => undefined | organization_settingsKeySpecifier),
		fields?: organization_settingsFieldPolicy,
	},
	organization_settings_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_settings_aggregateKeySpecifier | (() => undefined | organization_settings_aggregateKeySpecifier),
		fields?: organization_settings_aggregateFieldPolicy,
	},
	organization_settings_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_settings_aggregate_fieldsKeySpecifier | (() => undefined | organization_settings_aggregate_fieldsKeySpecifier),
		fields?: organization_settings_aggregate_fieldsFieldPolicy,
	},
	organization_settings_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_settings_max_fieldsKeySpecifier | (() => undefined | organization_settings_max_fieldsKeySpecifier),
		fields?: organization_settings_max_fieldsFieldPolicy,
	},
	organization_settings_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_settings_min_fieldsKeySpecifier | (() => undefined | organization_settings_min_fieldsKeySpecifier),
		fields?: organization_settings_min_fieldsFieldPolicy,
	},
	organization_settings_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | organization_settings_mutation_responseKeySpecifier | (() => undefined | organization_settings_mutation_responseKeySpecifier),
		fields?: organization_settings_mutation_responseFieldPolicy,
	},
	perspective_campaign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | perspective_campaignKeySpecifier | (() => undefined | perspective_campaignKeySpecifier),
		fields?: perspective_campaignFieldPolicy,
	},
	perspective_campaign_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | perspective_campaign_aggregateKeySpecifier | (() => undefined | perspective_campaign_aggregateKeySpecifier),
		fields?: perspective_campaign_aggregateFieldPolicy,
	},
	perspective_campaign_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | perspective_campaign_aggregate_fieldsKeySpecifier | (() => undefined | perspective_campaign_aggregate_fieldsKeySpecifier),
		fields?: perspective_campaign_aggregate_fieldsFieldPolicy,
	},
	perspective_campaign_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | perspective_campaign_max_fieldsKeySpecifier | (() => undefined | perspective_campaign_max_fieldsKeySpecifier),
		fields?: perspective_campaign_max_fieldsFieldPolicy,
	},
	perspective_campaign_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | perspective_campaign_min_fieldsKeySpecifier | (() => undefined | perspective_campaign_min_fieldsKeySpecifier),
		fields?: perspective_campaign_min_fieldsFieldPolicy,
	},
	perspective_campaign_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | perspective_campaign_mutation_responseKeySpecifier | (() => undefined | perspective_campaign_mutation_responseKeySpecifier),
		fields?: perspective_campaign_mutation_responseFieldPolicy,
	},
	qa_source?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | qa_sourceKeySpecifier | (() => undefined | qa_sourceKeySpecifier),
		fields?: qa_sourceFieldPolicy,
	},
	qa_source_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | qa_source_aggregateKeySpecifier | (() => undefined | qa_source_aggregateKeySpecifier),
		fields?: qa_source_aggregateFieldPolicy,
	},
	qa_source_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | qa_source_aggregate_fieldsKeySpecifier | (() => undefined | qa_source_aggregate_fieldsKeySpecifier),
		fields?: qa_source_aggregate_fieldsFieldPolicy,
	},
	qa_source_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | qa_source_max_fieldsKeySpecifier | (() => undefined | qa_source_max_fieldsKeySpecifier),
		fields?: qa_source_max_fieldsFieldPolicy,
	},
	qa_source_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | qa_source_min_fieldsKeySpecifier | (() => undefined | qa_source_min_fieldsKeySpecifier),
		fields?: qa_source_min_fieldsFieldPolicy,
	},
	qa_source_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | qa_source_mutation_responseKeySpecifier | (() => undefined | qa_source_mutation_responseKeySpecifier),
		fields?: qa_source_mutation_responseFieldPolicy,
	},
	query_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | query_rootKeySpecifier | (() => undefined | query_rootKeySpecifier),
		fields?: query_rootFieldPolicy,
	},
	rms_connectors?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_connectorsKeySpecifier | (() => undefined | rms_connectorsKeySpecifier),
		fields?: rms_connectorsFieldPolicy,
	},
	rms_connectors_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_connectors_aggregateKeySpecifier | (() => undefined | rms_connectors_aggregateKeySpecifier),
		fields?: rms_connectors_aggregateFieldPolicy,
	},
	rms_connectors_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_connectors_aggregate_fieldsKeySpecifier | (() => undefined | rms_connectors_aggregate_fieldsKeySpecifier),
		fields?: rms_connectors_aggregate_fieldsFieldPolicy,
	},
	rms_connectors_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_connectors_max_fieldsKeySpecifier | (() => undefined | rms_connectors_max_fieldsKeySpecifier),
		fields?: rms_connectors_max_fieldsFieldPolicy,
	},
	rms_connectors_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_connectors_min_fieldsKeySpecifier | (() => undefined | rms_connectors_min_fieldsKeySpecifier),
		fields?: rms_connectors_min_fieldsFieldPolicy,
	},
	rms_connectors_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_connectors_mutation_responseKeySpecifier | (() => undefined | rms_connectors_mutation_responseKeySpecifier),
		fields?: rms_connectors_mutation_responseFieldPolicy,
	},
	rms_forwarded_logs?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_forwarded_logsKeySpecifier | (() => undefined | rms_forwarded_logsKeySpecifier),
		fields?: rms_forwarded_logsFieldPolicy,
	},
	rms_forwarded_logs_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_forwarded_logs_aggregateKeySpecifier | (() => undefined | rms_forwarded_logs_aggregateKeySpecifier),
		fields?: rms_forwarded_logs_aggregateFieldPolicy,
	},
	rms_forwarded_logs_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_forwarded_logs_aggregate_fieldsKeySpecifier | (() => undefined | rms_forwarded_logs_aggregate_fieldsKeySpecifier),
		fields?: rms_forwarded_logs_aggregate_fieldsFieldPolicy,
	},
	rms_forwarded_logs_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_forwarded_logs_max_fieldsKeySpecifier | (() => undefined | rms_forwarded_logs_max_fieldsKeySpecifier),
		fields?: rms_forwarded_logs_max_fieldsFieldPolicy,
	},
	rms_forwarded_logs_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_forwarded_logs_min_fieldsKeySpecifier | (() => undefined | rms_forwarded_logs_min_fieldsKeySpecifier),
		fields?: rms_forwarded_logs_min_fieldsFieldPolicy,
	},
	rms_forwarded_logs_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_forwarded_logs_mutation_responseKeySpecifier | (() => undefined | rms_forwarded_logs_mutation_responseKeySpecifier),
		fields?: rms_forwarded_logs_mutation_responseFieldPolicy,
	},
	rms_org_setups?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_org_setupsKeySpecifier | (() => undefined | rms_org_setupsKeySpecifier),
		fields?: rms_org_setupsFieldPolicy,
	},
	rms_org_setups_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_org_setups_aggregateKeySpecifier | (() => undefined | rms_org_setups_aggregateKeySpecifier),
		fields?: rms_org_setups_aggregateFieldPolicy,
	},
	rms_org_setups_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_org_setups_aggregate_fieldsKeySpecifier | (() => undefined | rms_org_setups_aggregate_fieldsKeySpecifier),
		fields?: rms_org_setups_aggregate_fieldsFieldPolicy,
	},
	rms_org_setups_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_org_setups_max_fieldsKeySpecifier | (() => undefined | rms_org_setups_max_fieldsKeySpecifier),
		fields?: rms_org_setups_max_fieldsFieldPolicy,
	},
	rms_org_setups_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_org_setups_min_fieldsKeySpecifier | (() => undefined | rms_org_setups_min_fieldsKeySpecifier),
		fields?: rms_org_setups_min_fieldsFieldPolicy,
	},
	rms_org_setups_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | rms_org_setups_mutation_responseKeySpecifier | (() => undefined | rms_org_setups_mutation_responseKeySpecifier),
		fields?: rms_org_setups_mutation_responseFieldPolicy,
	},
	subscription_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | subscription_rootKeySpecifier | (() => undefined | subscription_rootKeySpecifier),
		fields?: subscription_rootFieldPolicy,
	},
	system_api_keys?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_api_keysKeySpecifier | (() => undefined | system_api_keysKeySpecifier),
		fields?: system_api_keysFieldPolicy,
	},
	system_api_keys_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_api_keys_aggregateKeySpecifier | (() => undefined | system_api_keys_aggregateKeySpecifier),
		fields?: system_api_keys_aggregateFieldPolicy,
	},
	system_api_keys_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_api_keys_aggregate_fieldsKeySpecifier | (() => undefined | system_api_keys_aggregate_fieldsKeySpecifier),
		fields?: system_api_keys_aggregate_fieldsFieldPolicy,
	},
	system_api_keys_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_api_keys_max_fieldsKeySpecifier | (() => undefined | system_api_keys_max_fieldsKeySpecifier),
		fields?: system_api_keys_max_fieldsFieldPolicy,
	},
	system_api_keys_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_api_keys_min_fieldsKeySpecifier | (() => undefined | system_api_keys_min_fieldsKeySpecifier),
		fields?: system_api_keys_min_fieldsFieldPolicy,
	},
	system_api_keys_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_api_keys_mutation_responseKeySpecifier | (() => undefined | system_api_keys_mutation_responseKeySpecifier),
		fields?: system_api_keys_mutation_responseFieldPolicy,
	},
	system_call_daily_stats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_statsKeySpecifier | (() => undefined | system_call_daily_statsKeySpecifier),
		fields?: system_call_daily_statsFieldPolicy,
	},
	system_call_daily_stats_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_aggregateKeySpecifier | (() => undefined | system_call_daily_stats_aggregateKeySpecifier),
		fields?: system_call_daily_stats_aggregateFieldPolicy,
	},
	system_call_daily_stats_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_aggregate_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_aggregate_fieldsKeySpecifier),
		fields?: system_call_daily_stats_aggregate_fieldsFieldPolicy,
	},
	system_call_daily_stats_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_avg_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_avg_fieldsKeySpecifier),
		fields?: system_call_daily_stats_avg_fieldsFieldPolicy,
	},
	system_call_daily_stats_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_max_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_max_fieldsKeySpecifier),
		fields?: system_call_daily_stats_max_fieldsFieldPolicy,
	},
	system_call_daily_stats_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_min_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_min_fieldsKeySpecifier),
		fields?: system_call_daily_stats_min_fieldsFieldPolicy,
	},
	system_call_daily_stats_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_mutation_responseKeySpecifier | (() => undefined | system_call_daily_stats_mutation_responseKeySpecifier),
		fields?: system_call_daily_stats_mutation_responseFieldPolicy,
	},
	system_call_daily_stats_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_stddev_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_stddev_fieldsKeySpecifier),
		fields?: system_call_daily_stats_stddev_fieldsFieldPolicy,
	},
	system_call_daily_stats_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_stddev_pop_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_stddev_pop_fieldsKeySpecifier),
		fields?: system_call_daily_stats_stddev_pop_fieldsFieldPolicy,
	},
	system_call_daily_stats_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_stddev_samp_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_stddev_samp_fieldsKeySpecifier),
		fields?: system_call_daily_stats_stddev_samp_fieldsFieldPolicy,
	},
	system_call_daily_stats_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_sum_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_sum_fieldsKeySpecifier),
		fields?: system_call_daily_stats_sum_fieldsFieldPolicy,
	},
	system_call_daily_stats_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_var_pop_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_var_pop_fieldsKeySpecifier),
		fields?: system_call_daily_stats_var_pop_fieldsFieldPolicy,
	},
	system_call_daily_stats_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_var_samp_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_var_samp_fieldsKeySpecifier),
		fields?: system_call_daily_stats_var_samp_fieldsFieldPolicy,
	},
	system_call_daily_stats_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_call_daily_stats_variance_fieldsKeySpecifier | (() => undefined | system_call_daily_stats_variance_fieldsKeySpecifier),
		fields?: system_call_daily_stats_variance_fieldsFieldPolicy,
	},
	system_email_daily_stats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_statsKeySpecifier | (() => undefined | system_email_daily_statsKeySpecifier),
		fields?: system_email_daily_statsFieldPolicy,
	},
	system_email_daily_stats_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_aggregateKeySpecifier | (() => undefined | system_email_daily_stats_aggregateKeySpecifier),
		fields?: system_email_daily_stats_aggregateFieldPolicy,
	},
	system_email_daily_stats_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_aggregate_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_aggregate_fieldsKeySpecifier),
		fields?: system_email_daily_stats_aggregate_fieldsFieldPolicy,
	},
	system_email_daily_stats_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_avg_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_avg_fieldsKeySpecifier),
		fields?: system_email_daily_stats_avg_fieldsFieldPolicy,
	},
	system_email_daily_stats_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_max_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_max_fieldsKeySpecifier),
		fields?: system_email_daily_stats_max_fieldsFieldPolicy,
	},
	system_email_daily_stats_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_min_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_min_fieldsKeySpecifier),
		fields?: system_email_daily_stats_min_fieldsFieldPolicy,
	},
	system_email_daily_stats_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_mutation_responseKeySpecifier | (() => undefined | system_email_daily_stats_mutation_responseKeySpecifier),
		fields?: system_email_daily_stats_mutation_responseFieldPolicy,
	},
	system_email_daily_stats_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_stddev_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_stddev_fieldsKeySpecifier),
		fields?: system_email_daily_stats_stddev_fieldsFieldPolicy,
	},
	system_email_daily_stats_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_stddev_pop_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_stddev_pop_fieldsKeySpecifier),
		fields?: system_email_daily_stats_stddev_pop_fieldsFieldPolicy,
	},
	system_email_daily_stats_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_stddev_samp_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_stddev_samp_fieldsKeySpecifier),
		fields?: system_email_daily_stats_stddev_samp_fieldsFieldPolicy,
	},
	system_email_daily_stats_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_sum_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_sum_fieldsKeySpecifier),
		fields?: system_email_daily_stats_sum_fieldsFieldPolicy,
	},
	system_email_daily_stats_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_var_pop_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_var_pop_fieldsKeySpecifier),
		fields?: system_email_daily_stats_var_pop_fieldsFieldPolicy,
	},
	system_email_daily_stats_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_var_samp_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_var_samp_fieldsKeySpecifier),
		fields?: system_email_daily_stats_var_samp_fieldsFieldPolicy,
	},
	system_email_daily_stats_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_email_daily_stats_variance_fieldsKeySpecifier | (() => undefined | system_email_daily_stats_variance_fieldsKeySpecifier),
		fields?: system_email_daily_stats_variance_fieldsFieldPolicy,
	},
	system_running_release?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_running_releaseKeySpecifier | (() => undefined | system_running_releaseKeySpecifier),
		fields?: system_running_releaseFieldPolicy,
	},
	system_running_release_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_running_release_aggregateKeySpecifier | (() => undefined | system_running_release_aggregateKeySpecifier),
		fields?: system_running_release_aggregateFieldPolicy,
	},
	system_running_release_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_running_release_aggregate_fieldsKeySpecifier | (() => undefined | system_running_release_aggregate_fieldsKeySpecifier),
		fields?: system_running_release_aggregate_fieldsFieldPolicy,
	},
	system_running_release_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_running_release_max_fieldsKeySpecifier | (() => undefined | system_running_release_max_fieldsKeySpecifier),
		fields?: system_running_release_max_fieldsFieldPolicy,
	},
	system_running_release_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_running_release_min_fieldsKeySpecifier | (() => undefined | system_running_release_min_fieldsKeySpecifier),
		fields?: system_running_release_min_fieldsFieldPolicy,
	},
	system_running_release_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_running_release_mutation_responseKeySpecifier | (() => undefined | system_running_release_mutation_responseKeySpecifier),
		fields?: system_running_release_mutation_responseFieldPolicy,
	},
	system_sms_daily_stats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_statsKeySpecifier | (() => undefined | system_sms_daily_statsKeySpecifier),
		fields?: system_sms_daily_statsFieldPolicy,
	},
	system_sms_daily_stats_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_aggregateKeySpecifier | (() => undefined | system_sms_daily_stats_aggregateKeySpecifier),
		fields?: system_sms_daily_stats_aggregateFieldPolicy,
	},
	system_sms_daily_stats_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_aggregate_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_aggregate_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_aggregate_fieldsFieldPolicy,
	},
	system_sms_daily_stats_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_avg_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_avg_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_avg_fieldsFieldPolicy,
	},
	system_sms_daily_stats_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_max_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_max_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_max_fieldsFieldPolicy,
	},
	system_sms_daily_stats_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_min_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_min_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_min_fieldsFieldPolicy,
	},
	system_sms_daily_stats_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_mutation_responseKeySpecifier | (() => undefined | system_sms_daily_stats_mutation_responseKeySpecifier),
		fields?: system_sms_daily_stats_mutation_responseFieldPolicy,
	},
	system_sms_daily_stats_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_stddev_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_stddev_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_stddev_fieldsFieldPolicy,
	},
	system_sms_daily_stats_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_stddev_pop_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_stddev_pop_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_stddev_pop_fieldsFieldPolicy,
	},
	system_sms_daily_stats_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_stddev_samp_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_stddev_samp_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_stddev_samp_fieldsFieldPolicy,
	},
	system_sms_daily_stats_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_sum_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_sum_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_sum_fieldsFieldPolicy,
	},
	system_sms_daily_stats_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_var_pop_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_var_pop_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_var_pop_fieldsFieldPolicy,
	},
	system_sms_daily_stats_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_var_samp_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_var_samp_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_var_samp_fieldsFieldPolicy,
	},
	system_sms_daily_stats_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | system_sms_daily_stats_variance_fieldsKeySpecifier | (() => undefined | system_sms_daily_stats_variance_fieldsKeySpecifier),
		fields?: system_sms_daily_stats_variance_fieldsFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;